import StocksType from './StocksType';

const latestStocks: StocksType[] = [
    { name: "AAPL - Apple Inc.", ticker: "AAPL" },
    { name: "MSFT - MICROSOFT CORP", ticker: "MSFT" },
    { name: "AMZN - AMAZON COM INC", ticker: "AMZN" },
    { name: "GOOG - Alphabet Inc.", ticker: "GOOG" },
    { name: "BABA - Alibaba Group Holding Ltd", ticker: "BABA" },
    { name: "TCEHY - Tencent Holdings Ltd", ticker: "TCEHY" },
    { name: "BRK-A - BERKSHIRE HATHAWAY INC", ticker: "BRK-A" },
    { name: "V - VISA INC.", ticker: "V" },
    { name: "WMT - Walmart Inc.", ticker: "WMT" },
    { name: "TSM - TAIWAN SEMICONDUCTOR MANUFACTURING CO LTD", ticker: "TSM" },
    { name: "TSLA - Tesla, Inc.", ticker: "TSLA" },
    { name: "JNJ - JOHNSON & JOHNSON", ticker: "JNJ" },
    { name: "PG - PROCTER & GAMBLE Co", ticker: "PG" },
    { name: "NVDA - NVIDIA CORP", ticker: "NVDA" },
    { name: "MA - Mastercard Inc", ticker: "MA" },
    { name: "HD - HOME DEPOT, INC.", ticker: "HD" },
    { name: "UNH - UNITEDHEALTH GROUP INC", ticker: "UNH" },
    { name: "JPM - JPMORGAN CHASE & CO", ticker: "JPM" },
    { name: "LVMUY - LVMH MOET HENNESSY LOUIS VUITTON", ticker: "LVMUY" },
    { name: "IDCBY - Industrial & Commercial Bank of China", ticker: "IDCBY" },
    { name: "ADBE - ADOBE INC.", ticker: "ADBE" },
    { name: "PYPL - PayPal Holdings, Inc.", ticker: "PYPL" },
    { name: "VZ - VERIZON COMMUNICATIONS INC", ticker: "VZ" },
    { name: "CRM - SALESFORCE.COM, INC.", ticker: "CRM" },
    { name: "NFLX - NETFLIX INC", ticker: "NFLX" },
    { name: "INTC - INTEL CORP", ticker: "INTC" },
    { name: "DIS - Walt Disney Co", ticker: "DIS" },
    { name: "KO - COCA COLA CO", ticker: "KO" },
    { name: "BAC - BANK OF AMERICA CORP /DE/", ticker: "BAC" },
    { name: "PFE - PFIZER INC", ticker: "PFE" },
    { name: "CMCSA - COMCAST CORP", ticker: "CMCSA" },
    { name: "NKE - NIKE, Inc.", ticker: "NKE" },
    { name: "ORCL - ORACLE CORP", ticker: "ORCL" },
    { name: "MRK - Merck & Co., Inc.", ticker: "MRK" },
    { name: "NVS - NOVARTIS AG", ticker: "NVS" },
    { name: "PEP - PEPSICO INC", ticker: "PEP" },
    { name: "ABT - ABBOTT LABORATORIES", ticker: "ABT" },
    { name: "T - AT&T INC.", ticker: "T" },
    { name: "TM - TOYOTA MOTOR CORP/", ticker: "TM" },
    { name: "CICHY - China Construction Bank Corp", ticker: "CICHY" },
    { name: "TMO - THERMO FISHER SCIENTIFIC INC.", ticker: "TMO" },
    { name: "SAP - SAP SE", ticker: "SAP" },
    { name: "MCD - MCDONALDS CORP", ticker: "MCD" },
    { name: "COST - COSTCO WHOLESALE CORP /NEW", ticker: "COST" },
    { name: "CSCO - CISCO SYSTEMS, INC.", ticker: "CSCO" },
    { name: "NVO - NOVO NORDISK A S", ticker: "NVO" },
    { name: "UL - UNILEVER PLC", ticker: "UL" },
    { name: "ACGBY - Agricultural Bank of China Limited/ADR", ticker: "ACGBY" },
    { name: "DHR - DANAHER CORP /DE/", ticker: "DHR" },
    { name: "ASML - ASML HOLDING NV", ticker: "ASML" },
    { name: "ZM - Zoom Video Communications, Inc.", ticker: "ZM" },
    { name: "AVGO - Broadcom Inc.", ticker: "AVGO" },
    { name: "UPS - UNITED PARCEL SERVICE INC", ticker: "UPS" },
    { name: "ABBV - AbbVie Inc.", ticker: "ABBV" },
    { name: "CIHKY - China Merchants Bank Co., Ltd./ADR/", ticker: "CIHKY" },
    { name: "NEE - NEXTERA ENERGY INC", ticker: "NEE" },
    { name: "MDT - Medtronic plc", ticker: "MDT" },
    { name: "ACN - Accenture plc", ticker: "ACN" },
    { name: "QCOM - QUALCOMM INC/DE", ticker: "QCOM" },
    { name: "XOM - EXXON MOBIL CORP", ticker: "XOM" },
    { name: "TMUS - T-Mobile US, Inc.", ticker: "TMUS" },
    { name: "UNP - UNION PACIFIC CORP", ticker: "UNP" },
    { name: "TXN - TEXAS INSTRUMENTS INC", ticker: "TXN" },
    { name: "CVX - CHEVRON CORP", ticker: "CVX" },
    { name: "LLY - ELI LILLY & Co", ticker: "LLY" },
    { name: "AZN - ASTRAZENECA PLC", ticker: "AZN" },
    { name: "BMY - BRISTOL MYERS SQUIBB CO", ticker: "BMY" },
    { name: "AMGN - AMGEN INC", ticker: "AMGN" },
    { name: "LOW - LOWES COMPANIES INC", ticker: "LOW" },
    { name: "SHOP - SHOPIFY INC.", ticker: "SHOP" },
    { name: "BHP - BHP Group Ltd", ticker: "BHP" },
    { name: "BACHY - BANK OF CHINA LTD", ticker: "BACHY" },
    { name: "JD - JD.com, Inc.", ticker: "JD" },
    { name: "SFTBY - SOFTBANK GROUP CORP", ticker: "SFTBY" },
    { name: "SNY - Sanofi", ticker: "SNY" },
    { name: "CHTR - CHARTER COMMUNICATIONS, INC. /MO/", ticker: "CHTR" },
    { name: "LIN - LINDE PLC", ticker: "LIN" },
    { name: "AAGIY - AIA Group Ltd/ADR", ticker: "AAGIY" },
    { name: "HON - HONEYWELL INTERNATIONAL INC", ticker: "HON" },
    { name: "PM - Philip Morris International Inc.", ticker: "PM" },
    { name: "BUD - Anheuser-Busch InBev SA/NV", ticker: "BUD" },
    { name: "AMT - AMERICAN TOWER CORP /MA/", ticker: "AMT" },
    { name: "RTNTF - RIO TINTO LTD", ticker: "RTNTF" },
    { name: "PDD - Pinduoduo Inc.", ticker: "PDD" },
    { name: "PTR - PETROCHINA CO LTD", ticker: "PTR" },
    { name: "IBM - INTERNATIONAL BUSINESS MACHINES CORP", ticker: "IBM" },
    { name: "LMT - LOCKHEED MARTIN CORP", ticker: "LMT" },
    { name: "SBUX - STARBUCKS CORP", ticker: "SBUX" },
    { name: "RY - ROYAL BANK OF CANADA", ticker: "RY" },
    { name: "NOW - ServiceNow, Inc.", ticker: "NOW" },
    { name: "HESAY - HERMES INTERNATIONAL S.C.A.", ticker: "HESAY" },
    { name: "MMM - 3M CO", ticker: "MMM" },
    { name: "BLK - BlackRock Inc.", ticker: "BLK" },
    { name: "RDS-A - Royal Dutch Shell plc", ticker: "RDS-A" },
    { name: "AMD - ADVANCED MICRO DEVICES INC", ticker: "AMD" },
    { name: "BA - BOEING CO", ticker: "BA" },
    { name: "WFC - WELLS FARGO & COMPANY/MN", ticker: "WFC" },
    { name: "RTX - RAYTHEON TECHNOLOGIES CORP", ticker: "RTX" },
    { name: "HDB - HDFC BANK LTD", ticker: "HDB" },
    { name: "SNE - SONY CORP", ticker: "SNE" },
    { name: "CAT - CATERPILLAR INC", ticker: "CAT" },
    { name: "C - CITIGROUP INC", ticker: "C" },
    { name: "GSK - GLAXOSMITHKLINE PLC", ticker: "GSK" },
    { name: "MS - MORGAN STANLEY", ticker: "MS" },
    { name: "INTU - INTUIT INC", ticker: "INTU" },
    { name: "TOT - TOTAL SE", ticker: "TOT" },
    { name: "FIS - Fidelity National Information Services, Inc.", ticker: "FIS" },
    { name: "PPRUY - Kering", ticker: "PPRUY" },
    { name: "ISRG - INTUITIVE SURGICAL INC", ticker: "ISRG" },
    { name: "CHDRY - Christian Dior SE/ADR", ticker: "CHDRY" },
    { name: "AXP - AMERICAN EXPRESS CO", ticker: "AXP" },
    { name: "SYK - STRYKER CORP", ticker: "SYK" },
    { name: "TGT - TARGET CORP", ticker: "TGT" },
    { name: "SQ - Block, Inc.", ticker: "SQ" },
    { name: "XYZ - Block, Inc.", ticker: "XYZ" },
    { name: "SPGI - S&P Global Inc.", ticker: "SPGI" },
    { name: "HSBC - HSBC HOLDINGS PLC", ticker: "HSBC" },
    { name: "EL - ESTEE LAUDER COMPANIES INC", ticker: "EL" },
    { name: "SE - Sea Ltd", ticker: "SE" },
    { name: "MDLZ - Mondelez International, Inc.", ticker: "MDLZ" },
    { name: "TD - TORONTO DOMINION BANK", ticker: "TD" },
    { name: "DEO - DIAGEO PLC", ticker: "DEO" },
    { name: "CNI - CANADIAN NATIONAL RAILWAY CO", ticker: "CNI" },
    { name: "BEKE - KE Holdings Inc.", ticker: "BEKE" },
    { name: "CVS - CVS HEALTH Corp", ticker: "CVS" },
    { name: "BTI - British American Tobacco p.l.c.", ticker: "BTI" },
    { name: "PLD - Prologis, Inc.", ticker: "PLD" },
    { name: "GILD - GILEAD SCIENCES INC", ticker: "GILD" },
    { name: "ZTS - Zoetis Inc.", ticker: "ZTS" },
    { name: "FDX - FEDEX CORP", ticker: "FDX" },
    { name: "DE - DEERE & CO", ticker: "DE" },
    { name: "RIO - RIO TINTO PLC", ticker: "RIO" },
    { name: "CTA-PA - DUPONT E I DE NEMOURS & CO", ticker: "CTA-PA" },
    { name: "SCHW - SCHWAB CHARLES CORP", ticker: "SCHW" },
    { name: "ANTM - Anthem, Inc.", ticker: "ANTM" },
    { name: "AIQUY - L AIR LIQUIDE SA /FI", ticker: "AIQUY" },
    { name: "MO - ALTRIA GROUP, INC.", ticker: "MO" },
    { name: "GS - GOLDMAN SACHS GROUP INC", ticker: "GS" },
    { name: "EQIX - EQUINIX INC", ticker: "EQIX" },
    { name: "FRCOY - Fast Retailing Co Ltd", ticker: "FRCOY" },
    { name: "SNOW - Snowflake Inc.", ticker: "SNOW" },
    { name: "CCI - CROWN CASTLE INTERNATIONAL CORP", ticker: "CCI" },
    { name: "BDX - BECTON DICKINSON & CO", ticker: "BDX" },
    { name: "BKNG - Booking Holdings Inc.", ticker: "BKNG" },
    { name: "CL - COLGATE PALMOLIVE CO", ticker: "CL" },
    { name: "D - DOMINION ENERGY, INC", ticker: "D" },
    { name: "SBGSY - SCHNEIDER ELECTRIC SA", ticker: "SBGSY" },
    { name: "RBGLY - RECKITT BENCKISER GROUP PLC", ticker: "RBGLY" },
    { name: "DUK - Duke Energy CORP", ticker: "DUK" },
    { name: "CHGCY - Chugai Pharmaceutical Co., Ltd. / ADR", ticker: "CHGCY" },
    { name: "DNNGY - Orsted A/S / ADR", ticker: "DNNGY" },
    { name: "FISV - FISERV INC", ticker: "FISV" },
    { name: "MELI - MERCADOLIBRE INC", ticker: "MELI" },
    { name: "INFY - Infosys Ltd", ticker: "INFY" },
    { name: "TJX - TJX COMPANIES INC /DE/", ticker: "TJX" },
    { name: "APD - AIR PRODUCTS & CHEMICALS INC /DE/", ticker: "APD" },
    { name: "SNP - CHINA PETROLEUM & CHEMICAL CORP", ticker: "SNP" },
    { name: "ITW - ILLINOIS TOOL WORKS INC", ticker: "ITW" },
    { name: "GE - G.E Aerospace", ticker: "GE" },
    { name: "UBER - Uber Technologies, Inc", ticker: "UBER" },
    { name: "ADP - AUTOMATIC DATA PROCESSING INC", ticker: "ADP" },
    { name: "VMW - VMWARE, INC.", ticker: "VMW" },
    { name: "CI - Cigna Corp", ticker: "CI" },
    { name: "SO - SOUTHERN CO", ticker: "SO" },
    { name: "EADSY - Airbus SE/ADR", ticker: "EADSY" },
    { name: "SHW - SHERWIN WILLIAMS CO", ticker: "SHW" },
    { name: "REGN - REGENERON PHARMACEUTICALS, INC.", ticker: "REGN" },
    { name: "CSX - CSX CORP", ticker: "CSX" },
    { name: "DMLRY - DAIMLER AG", ticker: "DMLRY" },
    { name: "NTES - NetEase, Inc.", ticker: "NTES" },
    { name: "HKXCY - Hong Kong Exchanges & Clearing Ltd", ticker: "HKXCY" },
    { name: "ESLOY - ESSILOR INTERNATIONAL /FI", ticker: "ESLOY" },
    { name: "MU - MICRON TECHNOLOGY INC", ticker: "MU" },
    { name: "USB - US BANCORP \\DE\\", ticker: "USB" },
    { name: "ENB - ENBRIDGE INC", ticker: "ENB" },
    { name: "CME - CME GROUP INC.", ticker: "CME" },
    { name: "KDDIY - KDDI CORP", ticker: "KDDIY" },
    { name: "ECL - ECOLAB INC.", ticker: "ECL" },
    { name: "HUM - HUMANA INC", ticker: "HUM" },
    { name: "NJDCY - NIDEC CORP", ticker: "NJDCY" },
    { name: "MMC - MARSH & MCLENNAN COMPANIES, INC.", ticker: "MMC" },
    { name: "VALE - Vale S.A.", ticker: "VALE" },
    { name: "AMAT - APPLIED MATERIALS INC /DE", ticker: "AMAT" },
    { name: "TFC - TRUIST FINANCIAL CORP", ticker: "TFC" },
    { name: "SHECY - Shin-Etsu Chemical Co., Ltd.", ticker: "SHECY" },
    { name: "ADSK - Autodesk, Inc.", ticker: "ADSK" },
    { name: "ICE - Intercontinental Exchange, Inc.", ticker: "ICE" },
    { name: "PSTVY - Postal Savings Bank of China Co Ltd/ADR", ticker: "PSTVY" },
    { name: "VRTX - VERTEX PHARMACEUTICALS INC / MA", ticker: "VRTX" },
    { name: "PGR - PROGRESSIVE CORP/OH/", ticker: "PGR" },
    { name: "NSC - NORFOLK SOUTHERN CORP", ticker: "NSC" },
    { name: "DKILY - Daikin Industries Ltd", ticker: "DKILY" },
    { name: "BYDDY - BYD CO LTD", ticker: "BYDDY" },
    { name: "DG - DOLLAR GENERAL CORP", ticker: "DG" },
    { name: "BP - BP PLC", ticker: "BP" },
    { name: "CB - Chubb Ltd", ticker: "CB" },
    { name: "BSX - BOSTON SCIENTIFIC CORP", ticker: "BSX" },
    { name: "MCO - MOODYS CORP /DE/", ticker: "MCO" },
    { name: "WDAY - Workday, Inc.", ticker: "WDAY" },
    { name: "LRCX - LAM RESEARCH CORP", ticker: "LRCX" },
    { name: "EW - Edwards Lifesciences Corp", ticker: "EW" },
    { name: "TAK - TAKEDA PHARMACEUTICAL CO LTD", ticker: "TAK" },
    { name: "TEAM - Atlassian Corp Plc", ticker: "TEAM" },
    { name: "GPN - GLOBAL PAYMENTS INC", ticker: "GPN" },
    { name: "DELL - Dell Technologies Inc.", ticker: "DELL" },
    { name: "NOC - NORTHROP GRUMMAN CORP /DE/", ticker: "NOC" },
    { name: "MUFG - MITSUBISHI UFJ FINANCIAL GROUP INC", ticker: "MUFG" },
    { name: "BNS - BANK OF NOVA SCOTIA", ticker: "BNS" },
    { name: "GM - General Motors Co", ticker: "GM" },
    { name: "KMB - KIMBERLY CLARK CORP", ticker: "KMB" },
    { name: "NEM - NEWMONT Corp /DE/", ticker: "NEM" },
    { name: "VCISY - VINCI /FI", ticker: "VCISY" },
    { name: "SPOT - Spotify Technology S.A.", ticker: "SPOT" },
    { name: "BNPQY - BNP PARIBAS", ticker: "BNPQY" },
    { name: "WM - WASTE MANAGEMENT INC", ticker: "WM" },
    { name: "TAL - TAL Education Group", ticker: "TAL" },
    { name: "AON - Aon plc", ticker: "AON" },
    { name: "GOLD - BARRICK GOLD CORP", ticker: "GOLD" },
    { name: "SAFRY - SAFRAN S.A.", ticker: "SAFRY" },
    { name: "RACE - Ferrari N.V.", ticker: "RACE" },
    { name: "PNC - PNC FINANCIAL SERVICES GROUP, INC.", ticker: "PNC" },
    { name: "LZAGY - Lonza Group AG", ticker: "LZAGY" },
    { name: "CSUAY - China Shenhua Energy Co Ltd", ticker: "CSUAY" },
    { name: "PBR - PETROBRAS - PETROLEO BRASILEIRO SA", ticker: "PBR" },
    { name: "OLCLY - Oriental Land Co., Ltd./ADR", ticker: "OLCLY" },
    { name: "ILMN - ILLUMINA, INC.", ticker: "ILMN" },
    { name: "GLD - SPDR GOLD TRUST", ticker: "GLD" },
    { name: "PHG - KONINKLIJKE PHILIPS NV", ticker: "PHG" },
    { name: "HCA - HCA Healthcare, Inc.", ticker: "HCA" },
    { name: "EQNR - EQUINOR ASA", ticker: "EQNR" },
    { name: "JMHLY - JARDINE MATHESON HOLDINGS LTD \\ /FI", ticker: "JMHLY" },
    { name: "TWLO - TWILIO INC", ticker: "TWLO" },
    { name: "VEEV - VEEVA SYSTEMS INC", ticker: "VEEV" },
    { name: "KNYJY - Kone OYJ", ticker: "KNYJY" },
    { name: "ADI - ANALOG DEVICES INC", ticker: "ADI" },
    { name: "AEP - AMERICAN ELECTRIC POWER CO INC", ticker: "AEP" },
    { name: "BCMXY - Bank of Communications Co Ltd", ticker: "BCMXY" },
    { name: "MRAAY - Murata Manufacturing Co., Ltd./ADR", ticker: "MRAAY" },
    { name: "BIDU - Baidu, Inc.", ticker: "BIDU" },
    { name: "AMX - AMERICA MOVIL SAB DE CV/", ticker: "AMX" },
    { name: "ROP - ROPER TECHNOLOGIES INC", ticker: "ROP" },
    { name: "UBS - UBS Group AG", ticker: "UBS" },
    { name: "PDRDY - PERNOD RICARD S A /FI", ticker: "PDRDY" },
    { name: "NTOIY - Neste OYJ", ticker: "NTOIY" },
    { name: "DD - DuPont de Nemours, Inc.", ticker: "DD" },
    { name: "ETN - Eaton Corp plc", ticker: "ETN" },
    { name: "CHPXY - China Pacific Insurance (Group) Co., Ltd./ADR", ticker: "CHPXY" },
    { name: "CP - CANADIAN PACIFIC RAILWAY LTD/CN", ticker: "CP" },
    { name: "DLR - DIGITAL REALTY TRUST, INC.", ticker: "DLR" },
    { name: "TOELY - Tokyo Electron LTD", ticker: "TOELY" },
    { name: "LULU - lululemon athletica inc.", ticker: "LULU" },
    { name: "VNJA - VANJIA CORP", ticker: "VNJA" },
    { name: "NGG - NATIONAL GRID PLC", ticker: "NGG" },
    { name: "HMC - HONDA MOTOR CO LTD", ticker: "HMC" },
    { name: "VLVLY - AKTIEBOLAGET VOLVO \\PUBL\\", ticker: "VLVLY" },
    { name: "MNST - Monster Beverage Corp", ticker: "MNST" },
    { name: "BIIB - BIOGEN INC.", ticker: "BIIB" },
    { name: "DOCU - DOCUSIGN, INC.", ticker: "DOCU" },
    { name: "RELX - RELX PLC", ticker: "RELX" },
    { name: "EMR - EMERSON ELECTRIC CO", ticker: "EMR" },
    { name: "SNAP - Snap Inc", ticker: "SNAP" },
    { name: "EXC - EXELON CORP", ticker: "EXC" },
    { name: "AHCHY - Anhui Conch Cement Co Ltd\\ADR", ticker: "AHCHY" },
    { name: "KDP - Keurig Dr Pepper Inc.", ticker: "KDP" },
    { name: "RKT - Rocket Companies, Inc.", ticker: "RKT" },
    { name: "BAX - BAXTER INTERNATIONAL INC", ticker: "BAX" },
    { name: "ITUB - Itau Unibanco Holding S.A.", ticker: "ITUB" },
    { name: "PSA - Public Storage", ticker: "PSA" },
    { name: "TRI - THOMSON REUTERS CORP /CAN/", ticker: "TRI" },
    { name: "TRP - TC ENERGY CORP", ticker: "TRP" },
    { name: "LNSTY - London Stock Exchange Group", ticker: "LNSTY" },
    { name: "CTSH - COGNIZANT TECHNOLOGY SOLUTIONS CORP", ticker: "CTSH" },
    { name: "GD - GENERAL DYNAMICS CORP", ticker: "GD" },
    { name: "GVDNY - GIVAUDAN SA /FI", ticker: "GVDNY" },
    { name: "NXPI - NXP Semiconductors N.V.", ticker: "NXPI" },
    { name: "IBN - ICICI BANK LTD", ticker: "IBN" },
    { name: "CFRUY - COMPAGNIE FINANCIERE RICHEMONT AG /FI", ticker: "CFRUY" },
    { name: "BMO - BANK OF MONTREAL /CAN/", ticker: "BMO" },
    { name: "KHC - Kraft Heinz Co", ticker: "KHC" },
    { name: "VONOY - Vonovia SE/ADR", ticker: "VONOY" },
    { name: "JSHLY - JARDINE STRATEGIC HOLDINGS LTD /FI", ticker: "JSHLY" },
    { name: "ECIFY - ELECTRICITE DE FRANCE S.A.", ticker: "ECIFY" },
    { name: "VOD - VODAFONE GROUP PUBLIC LTD CO", ticker: "VOD" },
    { name: "WFAFY - WESFARMERS LTD", ticker: "WFAFY" },
    { name: "SMFG - SUMITOMO MITSUI FINANCIAL GROUP, INC.", ticker: "SMFG" },
    { name: "PTON - PELOTON INTERACTIVE, INC.", ticker: "PTON" },
    { name: "BCE - BCE INC", ticker: "BCE" },
    { name: "SCCO - SOUTHERN COPPER CORP/", ticker: "SCCO" },
    { name: "CNC - CENTENE CORP", ticker: "CNC" },
    { name: "EBAY - EBAY INC", ticker: "EBAY" },
    { name: "BX - Blackstone Group Inc", ticker: "BX" },
    { name: "CMG - CHIPOTLE MEXICAN GRILL INC", ticker: "CMG" },
    { name: "ABEV - AMBEV S.A.", ticker: "ABEV" },
    { name: "XEL - XCEL ENERGY INC", ticker: "XEL" },
    { name: "DXCM - DEXCOM INC", ticker: "DXCM" },
    { name: "SRE - SEMPRA ENERGY", ticker: "SRE" },
    { name: "EPD - ENTERPRISE PRODUCTS PARTNERS L.P.", ticker: "EPD" },
    { name: "FANUY - Fanuc Ltd", ticker: "FANUY" },
    { name: "GIS - GENERAL MILLS INC", ticker: "GIS" },
    { name: "ERIC - ERICSSON LM TELEPHONE CO", ticker: "ERIC" },
    { name: "LHX - L3HARRIS TECHNOLOGIES, INC. /DE/", ticker: "LHX" },
    { name: "ITOCY - ITOCHU CORP", ticker: "ITOCY" },
    { name: "PUK - PRUDENTIAL PLC", ticker: "PUK" },
    { name: "EA - ELECTRONIC ARTS INC.", ticker: "EA" },
    { name: "DOW - DOW INC.", ticker: "DOW" },
    { name: "CTAS - CINTAS CORP", ticker: "CTAS" },
    { name: "DNZOY - Denso Corp", ticker: "DNZOY" },
    { name: "SXYAY - Sika AG/ADR", ticker: "SXYAY" },
    { name: "IDXX - IDEXX LABORATORIES INC /DE", ticker: "IDXX" },
    { name: "MET - METLIFE INC", ticker: "MET" },
    { name: "LVS - LAS VEGAS SANDS CORP", ticker: "LVS" },
    { name: "COF - CAPITAL ONE FINANCIAL CORP", ticker: "COF" },
    { name: "STZ - CONSTELLATION BRANDS, INC.", ticker: "STZ" },
    { name: "TEL - TE Connectivity Ltd.", ticker: "TEL" },
    { name: "YAHOY - Yahoo! Japan Corp", ticker: "YAHOY" },
    { name: "COP - CONOCOPHILLIPS", ticker: "COP" },
    { name: "ORLY - O REILLY AUTOMOTIVE INC", ticker: "ORLY" },
    { name: "VWDRY - VESTAS WIND SYSTEMS A/S", ticker: "VWDRY" },
    { name: "SNPS - SYNOPSYS INC", ticker: "SNPS" },
    { name: "SBAC - SBA COMMUNICATIONS CORP", ticker: "SBAC" },
    { name: "NIO - NIO Inc.", ticker: "NIO" },
    { name: "APH - AMPHENOL CORP /DE/", ticker: "APH" },
    { name: "CVNA - CARVANA CO.", ticker: "CVNA" },
    { name: "CM - CANADIAN IMPERIAL BANK OF COMMERCE /CAN/", ticker: "CM" },
    { name: "SPLK - SPLUNK INC", ticker: "SPLK" },
    { name: "TROW - PRICE T ROWE GROUP INC", ticker: "TROW" },
    { name: "SAN - Banco Santander, S.A.", ticker: "SAN" },
    { name: "IQV - IQVIA HOLDINGS INC.", ticker: "IQV" },
    { name: "HNNMY - H&M HENNES & MAURITZ AB", ticker: "HNNMY" },
    { name: "CHCJY - China CITIC Bank Corp Limited/ADR/", ticker: "CHCJY" },
    { name: "DDOG - Datadog, Inc.", ticker: "DDOG" },
    { name: "CLPBY - COLOPLAST A/S", ticker: "CLPBY" },
    { name: "CSGP - COSTAR GROUP, INC.", ticker: "CSGP" },
    { name: "VIVHY - VIVENDI", ticker: "VIVHY" },
    { name: "SYY - SYSCO CORP", ticker: "SYY" },
    { name: "BK - Bank of New York Mellon Corp", ticker: "BK" },
    { name: "CMAKY - China Minsheng Banking Corp., Ltd.", ticker: "CMAKY" },
    { name: "CMI - CUMMINS INC", ticker: "CMI" },
    { name: "ROST - ROSS STORES, INC.", ticker: "ROST" },
    { name: "CRBJY - China Resources Land Ltd / ADR", ticker: "CRBJY" },
    { name: "LGFRY - Longfor Group Holdings Limited/ADR", ticker: "LGFRY" },
    { name: "A - AGILENT TECHNOLOGIES, INC.", ticker: "A" },
    { name: "WBA - Walgreens Boots Alliance, Inc.", ticker: "WBA" },
    { name: "BBD - BANK BRADESCO", ticker: "BBD" },
    { name: "JCI - Johnson Controls International plc", ticker: "JCI" },
    { name: "KLAC - KLA CORP", ticker: "KLAC" },
    { name: "PPG - PPG INDUSTRIES INC", ticker: "PPG" },
    { name: "ES - EVERSOURCE ENERGY", ticker: "ES" },
    { name: "WEC - WEC ENERGY GROUP, INC.", ticker: "WEC" },
    { name: "KKR - KKR & Co. Inc.", ticker: "KKR" },
    { name: "CDNS - CADENCE DESIGN SYSTEMS INC", ticker: "CDNS" },
    { name: "CRWD - CrowdStrike Holdings, Inc.", ticker: "CRWD" },
    { name: "BBY - BEST BUY CO INC", ticker: "BBY" },
    { name: "PCAR - PACCAR INC", ticker: "PCAR" },
    { name: "MAR - MARRIOTT INTERNATIONAL INC /MD/", ticker: "MAR" },
    { name: "MTCPY - MTR CORP LTD", ticker: "MTCPY" },
    { name: "MFG - MIZUHO FINANCIAL GROUP INC", ticker: "MFG" },
    { name: "VRSK - Verisk Analytics, Inc.", ticker: "VRSK" },
    { name: "TT - Trane Technologies plc", ticker: "TT" },
    { name: "F - FORD MOTOR CO", ticker: "F" },
    { name: "DBOEY - Deutsche Boerse", ticker: "DBOEY" },
    { name: "STM - STMicroelectronics N.V.", ticker: "STM" },
    { name: "HSY - HERSHEY CO", ticker: "HSY" },
    { name: "PEG - PUBLIC SERVICE ENTERPRISE GROUP INC", ticker: "PEG" },
    { name: "MSCI - MSCI Inc.", ticker: "MSCI" },
    { name: "TRV - TRAVELERS COMPANIES, INC.", ticker: "TRV" },
    { name: "MTCH - Match Group, Inc.", ticker: "MTCH" },
    { name: "BLL - BALL Corp", ticker: "BLL" },
    { name: "CRH - CRH PUBLIC LTD CO", ticker: "CRH" },
    { name: "OKTA - Okta, Inc.", ticker: "OKTA" },
    { name: "ALC - ALCON INC", ticker: "ALC" },
    { name: "SVNDY - SEVEN & I HOLDINGS CO LTD", ticker: "SVNDY" },
    { name: "ORAN - ORANGE", ticker: "ORAN" },
    { name: "ING - ING GROEP NV", ticker: "ING" },
    { name: "PAYX - PAYCHEX INC", ticker: "PAYX" },
    { name: "RSG - REPUBLIC SERVICES, INC.", ticker: "RSG" },
    { name: "ZBH - ZIMMER BIOMET HOLDINGS, INC.", ticker: "ZBH" },
    { name: "YUM - YUM BRANDS INC", ticker: "YUM" },
    { name: "HCMLY - LafargeHolcim Ltd/ADR", ticker: "HCMLY" },
    { name: "SCHYY - Sands China Ltd. /ADR", ticker: "SCHYY" },
    { name: "UNICY - Unicharm Corp", ticker: "UNICY" },
    { name: "GLNCY - Glencore plc/ADR", ticker: "GLNCY" },
    { name: "RDSMY - Royal DSM N.V.", ticker: "RDSMY" },
    { name: "TRUMY - Terumo Corp", ticker: "TRUMY" },
    { name: "PH - PARKER HANNIFIN CORP", ticker: "PH" },
    { name: "CARR - Carrier Global Corp", ticker: "CARR" },
    { name: "KMI - KINDER MORGAN, INC.", ticker: "KMI" },
    { name: "CHT - CHUNGHWA TELECOM CO LTD", ticker: "CHT" },
    { name: "MSI - Motorola Solutions, Inc.", ticker: "MSI" },
    { name: "TTD - Trade Desk, Inc.", ticker: "TTD" },
    { name: "ANSS - ANSYS INC", ticker: "ANSS" },
    { name: "ALL - ALLSTATE CORP", ticker: "ALL" },
    { name: "GWLLY - Great Wall Motor Co Limited/ADR", ticker: "GWLLY" },
    { name: "BGNE - BeiGene, Ltd.", ticker: "BGNE" },
    { name: "ADM - Archer-Daniels-Midland Co", ticker: "ADM" },
    { name: "VFC - V F CORP", ticker: "VFC" },
    { name: "MRNA - Moderna, Inc.", ticker: "MRNA" },
    { name: "OVCHY - Oversea-Chinese Banking Corp / ADR", ticker: "OVCHY" },
    { name: "W - Wayfair Inc.", ticker: "W" },
    { name: "CHWY - Chewy, Inc.", ticker: "CHWY" },
    { name: "MCHP - MICROCHIP TECHNOLOGY INC", ticker: "MCHP" },
    { name: "SWK - STANLEY BLACK & DECKER, INC.", ticker: "SWK" },
    { name: "ROK - ROCKWELL AUTOMATION, INC", ticker: "ROK" },
    { name: "MRVL - MARVELL TECHNOLOGY GROUP LTD", ticker: "MRVL" },
    { name: "OTIS - Otis Worldwide Corp", ticker: "OTIS" },
    { name: "DHI - HORTON D R INC /DE/", ticker: "DHI" },
    { name: "EDU - New Oriental Education & Technology Group Inc.", ticker: "EDU" },
    { name: "AWK - American Water Works Company, Inc.", ticker: "AWK" },
    { name: "AZO - AUTOZONE INC", ticker: "AZO" },
    { name: "PINS - PINTEREST, INC.", ticker: "PINS" },
    { name: "E - ENI SPA", ticker: "E" },
    { name: "ROKU - ROKU, INC", ticker: "ROKU" },
    { name: "ASAZY - ASSA ABLOY AB", ticker: "ASAZY" },
    { name: "CPRT - COPART INC", ticker: "CPRT" },
    { name: "MFC - MANULIFE FINANCIAL CORP", ticker: "MFC" },
    { name: "APTV - Aptiv PLC", ticker: "APTV" },
    { name: "WCN - Waste Connections, Inc.", ticker: "WCN" },
    { name: "WLTW - WILLIS TOWERS WATSON PLC", ticker: "WLTW" },
    { name: "ED - CONSOLIDATED EDISON INC", ticker: "ED" },
    { name: "CTRYY - Country Garden Holdings Co Ltd /ADR", ticker: "CTRYY" },
    { name: "WIT - WIPRO LTD", ticker: "WIT" },
    { name: "PDYPY - Paddy Power plc/ADR", ticker: "PDYPY" },
    { name: "TSCDY - TESCO PLC /FI", ticker: "TSCDY" },
    { name: "TDG - TransDigm Group INC", ticker: "TDG" },
    { name: "BFA - BROWN FORMAN CORP", ticker: "BFA" },
    { name: "HPQ - HP INC", ticker: "HPQ" },
    { name: "CLX - CLOROX CO /DE/", ticker: "CLX" },
    { name: "GLW - CORNING INC /NY", ticker: "GLW" },
    { name: "FNV - FRANCO NEVADA Corp", ticker: "FNV" },
    { name: "ALPMY - Astellas Pharma Inc", ticker: "ALPMY" },
    { name: "EGRNY - China Evergrande Group/ADR", ticker: "EGRNY" },
    { name: "AIG - AMERICAN INTERNATIONAL GROUP INC", ticker: "AIG" },
    { name: "LYB - LyondellBasell Industries N.V.", ticker: "LYB" },
    { name: "ALGN - ALIGN TECHNOLOGY INC", ticker: "ALGN" },
    { name: "AFL - AFLAC INC", ticker: "AFL" },
    { name: "HRL - HORMEL FOODS CORP /DE/", ticker: "HRL" },
    { name: "RNG - RingCentral, Inc.", ticker: "RNG" },
    { name: "PRU - PRUDENTIAL FINANCIAL INC", ticker: "PRU" },
    { name: "MKC - MCCORMICK & CO INC", ticker: "MKC" },
    { name: "CJPRY - CENTRAL JAPAN RAILWAY CO", ticker: "CJPRY" },
    { name: "RMD - RESMED INC", ticker: "RMD" },
    { name: "FAST - FASTENAL CO", ticker: "FAST" },
    { name: "KR - KROGER CO", ticker: "KR" },
    { name: "LBRDA - Liberty Broadband Corp", ticker: "LBRDA" },
    { name: "FCAU - Fiat Chrysler Automobiles N.V.", ticker: "FCAU" },
    { name: "FCX - FREEPORT-MCMORAN INC", ticker: "FCX" },
    { name: "SWKS - SKYWORKS SOLUTIONS, INC.", ticker: "SWKS" },
    { name: "LEN - LENNAR CORP /NEW/", ticker: "LEN" },
    { name: "CRARY - CREDIT AGRICOLE S A", ticker: "CRARY" },
    { name: "AMADY - Amadeus IT Group, S.A./ADR", ticker: "AMADY" },
    { name: "SIRI - SIRIUS XM HOLDINGS INC.", ticker: "SIRI" },
    { name: "AME - AMETEK INC/", ticker: "AME" },
    { name: "ZLNDY - Zalando SE/ADR", ticker: "ZLNDY" },
    { name: "HLT - Hilton Worldwide Holdings Inc.", ticker: "HLT" },
    { name: "LYG - Lloyds Banking Group plc", ticker: "LYG" },
    { name: "MCK - MCKESSON CORP", ticker: "MCK" },
    { name: "CTVA - Corteva, Inc.", ticker: "CTVA" },
    { name: "KHNGY - Kuehne & Nagel International AG / ADR", ticker: "KHNGY" },
    { name: "MTD - METTLER TOLEDO INTERNATIONAL INC/", ticker: "MTD" },
    { name: "GSX - GSX Techedu Inc.", ticker: "GSX" },
    { name: "XP - XP Inc.", ticker: "XP" },
    { name: "RPRX - Royalty Pharma plc", ticker: "RPRX" },
    { name: "FMS - Fresenius Medical Care AG & Co. KGaA", ticker: "FMS" },
    { name: "HAITY - Haitong Securities Co., LTD/ADR", ticker: "HAITY" },
    { name: "SLF - SUN LIFE FINANCIAL INC", ticker: "SLF" },
    { name: "ZIJMY - Zijin Mining Group Co., Ltd./ADR", ticker: "ZIJMY" },
    { name: "WMB - WILLIAMS COMPANIES, INC.", ticker: "WMB" },
    { name: "LUV - SOUTHWEST AIRLINES CO", ticker: "LUV" },
    { name: "NOK - NOKIA CORP", ticker: "NOK" },
    { name: "BCS - BARCLAYS PLC", ticker: "BCS" },
    { name: "TME - Tencent Music Entertainment Group", ticker: "TME" },
    { name: "SAXPY - Sampo OYJ", ticker: "SAXPY" },
    { name: "VRSN - VERISIGN INC/CA", ticker: "VRSN" },
    { name: "GMAB - GENMAB A/S", ticker: "GMAB" },
    { name: "DTE - DTE ENERGY CO", ticker: "DTE" },
    { name: "ODFL - OLD DOMINION FREIGHT LINE, INC.", ticker: "ODFL" },
    { name: "TU - TELUS CORP", ticker: "TU" },
    { name: "PANW - Palo Alto Networks Inc", ticker: "PANW" },
    { name: "U - Unity Software Inc.", ticker: "U" },
    { name: "NTR - Nutrien Ltd.", ticker: "NTR" },
    { name: "CKHUY - CK Hutchison Holdings Limited/ADR", ticker: "CKHUY" },
    { name: "AONNY - AEON CO., LTD.", ticker: "AONNY" },
    { name: "CHD - CHURCH & DWIGHT CO INC /DE/", ticker: "CHD" },
    { name: "STT - STATE STREET CORP", ticker: "STT" },
    { name: "K - KELLOGG CO", ticker: "K" },
    { name: "DLTR - DOLLAR TREE, INC.", ticker: "DLTR" },
    { name: "ARZGY - Assicurazioni Generali S.p.A.", ticker: "ARZGY" },
    { name: "EIX - EDISON INTERNATIONAL", ticker: "EIX" },
    { name: "WELL - WELLTOWER INC.", ticker: "WELL" },
    { name: "FTV - Fortive Corp", ticker: "FTV" },
    { name: "YUMC - Yum China Holdings, Inc.", ticker: "YUMC" },
    { name: "PAYC - Paycom Software, Inc.", ticker: "PAYC" },
    { name: "ETP-PC - Energy Transfer Operating, L.P.", ticker: "ETP-PC" },
    { name: "BNTX - BioNTech SE", ticker: "BNTX" },
    { name: "WY - WEYERHAEUSER CO", ticker: "WY" },
    { name: "ZG - ZILLOW GROUP, INC.", ticker: "ZG" },
    { name: "ZTCOY - ZTE CORP", ticker: "ZTCOY" },
    { name: "FRC - FIRST REPUBLIC BANK", ticker: "FRC" },
    { name: "CODYY - COMPAGNIE DE SAINT GOBAIN", ticker: "CODYY" },
    { name: "KBCSY - KBC Group NV", ticker: "KBCSY" },
    { name: "WPM - Wheaton Precious Metals Corp.", ticker: "WPM" },
    { name: "ETR - ENTERGY CORP /DE/", ticker: "ETR" },
    { name: "PCG - PG&E Corp", ticker: "PCG" },
    { name: "PSX - Phillips 66", ticker: "PSX" },
    { name: "PPL - PPL Corp", ticker: "PPL" },
    { name: "SLB - SCHLUMBERGER LIMITED/NV", ticker: "SLB" },
    { name: "GBERY - GEBERIT AG", ticker: "GBERY" },
    { name: "FTNT - Fortinet, Inc.", ticker: "FTNT" },
    { name: "SZKMY - SUZUKI MOTOR CORP", ticker: "SZKMY" },
    { name: "EJPRY - EAST JAPAN RAILWAY CO /FI", ticker: "EJPRY" },
    { name: "OTSKY - Otsuka Holdings Co., Ltd./ADR", ticker: "OTSKY" },
    { name: "WST - WEST PHARMACEUTICAL SERVICES INC", ticker: "WST" },
    { name: "NDAQ - NASDAQ, INC.", ticker: "NDAQ" },
    { name: "EOG - EOG RESOURCES INC", ticker: "EOG" },
    { name: "TSN - TYSON FOODS, INC.", ticker: "TSN" },
    { name: "CGEMY - CAP GEMINI SA", ticker: "CGEMY" },
    { name: "GELYY - Geely Automobile Holdings Limited/ADR", ticker: "GELYY" },
    { name: "BSBR - Banco Santander (Brasil) S.A.", ticker: "BSBR" },
    { name: "MKTX - MARKETAXESS HOLDINGS INC", ticker: "MKTX" },
    { name: "IBKR - Interactive Brokers Group, Inc.", ticker: "IBKR" },
    { name: "COUP - Coupa Software Inc", ticker: "COUP" },
    { name: "GCTAY - GAMESA S A /FI", ticker: "GCTAY" },
    { name: "AJG - Arthur J. Gallagher & Co.", ticker: "AJG" },
    { name: "CNQ - CANADIAN NATURAL RESOURCES LTD", ticker: "CNQ" },
    { name: "GASNY - GAS NATURAL SDG SA", ticker: "GASNY" },
    { name: "UCBJY - UCB S.A.", ticker: "UCBJY" },
    { name: "AVB - AVALONBAY COMMUNITIES INC", ticker: "AVB" },
    { name: "FLT - FLEETCOR TECHNOLOGIES INC", ticker: "FLT" },
    { name: "DAL - DELTA AIR LINES, INC.", ticker: "DAL" },
    { name: "PLTR - Palantir Technologies Inc.", ticker: "PLTR" },
    { name: "O - REALTY INCOME CORP", ticker: "O" },
    { name: "CABHF - Carlsberg AS", ticker: "CABHF" },
    { name: "AEE - AMEREN CORP", ticker: "AEE" },
    { name: "RCI - ROGERS COMMUNICATIONS INC", ticker: "RCI" },
    { name: "SSMXY - Sysmex Corporation/ADR", ticker: "SSMXY" },
    { name: "AMP - AMERIPRISE FINANCIAL INC", ticker: "AMP" },
    { name: "ARE - ALEXANDRIA REAL ESTATE EQUITIES, INC.", ticker: "ARE" },
    { name: "GWW - W.W. GRAINGER, INC.", ticker: "GWW" },
    { name: "EC - ECOPETROL S.A.", ticker: "EC" },
    { name: "BAESY - BAE SYSTEMS PLC /FI/", ticker: "BAESY" },
    { name: "ZS - Zscaler, Inc.", ticker: "ZS" },
    { name: "AKZOY - AKZO NOBEL NV", ticker: "AKZOY" },
    { name: "ABC - AMERISOURCEBERGEN CORP", ticker: "ABC" },
    { name: "MGDDY - MICHELIN COMPAGNIE GENERALE DES ETABLISSEMENTS MICHELIN /FI", ticker: "MGDDY" },
    { name: "LH - LABORATORY CORP OF AMERICA HOLDINGS", ticker: "LH" },
    { name: "FMX - MEXICAN ECONOMIC DEVELOPMENT INC", ticker: "FMX" },
    { name: "YNDX - Yandex N.V.", ticker: "YNDX" },
    { name: "SGSOY - SGS SOCIETE GENERALE DE SURVEILLANCE HOLDING SA /FI", ticker: "SGSOY" },
    { name: "KEYS - Keysight Technologies, Inc.", ticker: "KEYS" },
    { name: "DB - DEUTSCHE BANK AKTIENGESELLSCHAFT", ticker: "DB" },
    { name: "TYIDY - TOYOTA INDUSTRIES CORP /FI", ticker: "TYIDY" },
    { name: "SPG - SIMON PROPERTY GROUP INC /DE/", ticker: "SPG" },
    { name: "ROL - ROLLINS INC", ticker: "ROL" },
    { name: "INCY - INCYTE CORP", ticker: "INCY" },
    { name: "SBHMY - Sino Biopharmaceutical Limited/ADR", ticker: "SBHMY" },
    { name: "MXIM - MAXIM INTEGRATED PRODUCTS INC", ticker: "MXIM" },
    { name: "EFX - EQUIFAX INC", ticker: "EFX" },
    { name: "ZI - ZoomInfo Technologies Inc.", ticker: "ZI" },
    { name: "EPAM - EPAM Systems, Inc.", ticker: "EPAM" },
    { name: "DFS - Discover Financial Services", ticker: "DFS" },
    { name: "GWLIF - GREAT-WEST LIFECO INC.", ticker: "GWLIF" },
    { name: "VMC - Vulcan Materials CO", ticker: "VMC" },
    { name: "AEM - AGNICO EAGLE MINES LTD", ticker: "AEM" },
    { name: "BBVA - BANCO BILBAO VIZCAYA ARGENTARIA, S.A.", ticker: "BBVA" },
    { name: "GDRX - GoodRx Holdings, Inc.", ticker: "GDRX" },
    { name: "MPC - Marathon Petroleum Corp", ticker: "MPC" },
    { name: "CCC - CLARIVATE Plc", ticker: "CCC" },
    { name: "EQR - EQUITY RESIDENTIAL", ticker: "EQR" },
    { name: "GRMN - GARMIN LTD", ticker: "GRMN" },
    { name: "FTS - Fortis Inc.", ticker: "FTS" },
    { name: "TTWO - TAKE TWO INTERACTIVE SOFTWARE INC", ticker: "TTWO" },
    { name: "FOJCY - Fortum OYJ", ticker: "FOJCY" },
    { name: "TEF - TELEFONICA S A", ticker: "TEF" },
    { name: "CMS - CMS ENERGY CORP", ticker: "CMS" },
    { name: "TLPFY - Teleperformance SA / ADR", ticker: "TLPFY" },
    { name: "COO - COOPER COMPANIES, INC.", ticker: "COO" },
    { name: "GRFS - Grifols SA", ticker: "GRFS" },
    { name: "CDW - CDW Corp", ticker: "CDW" },
    { name: "TDOC - Teladoc Health, Inc.", ticker: "TDOC" },
    { name: "SYIEY - Symrise AG", ticker: "SYIEY" },
    { name: "ETSY - ETSY INC", ticker: "ETSY" },
    { name: "WEICY - Weichai Power Co., Ltd. / ADR", ticker: "WEICY" },
    { name: "NVZMY - NOVOZYMES AS/FI", ticker: "NVZMY" },
    { name: "STNE - StoneCo Ltd.", ticker: "STNE" },
    { name: "FRRVY - CINTRA Concesiones de Infraestructuras", ticker: "FRRVY" },
    { name: "IP - INTERNATIONAL PAPER CO /NEW/", ticker: "IP" },
    { name: "SMNNY - Shimano Inc./ADR", ticker: "SMNNY" },
    { name: "CAG - CONAGRA BRANDS INC.", ticker: "CAG" },
    { name: "SU - SUNCOR ENERGY INC", ticker: "SU" },
    { name: "NWG - NatWest Group plc", ticker: "NWG" },
    { name: "POAHY - Porsche Automobil Holding SE / ADR", ticker: "POAHY" },
    { name: "SVNLY - Svenska Handelsbanken AB", ticker: "SVNLY" },
    { name: "TLK - PERUSAHAAN PERSEROAN PERSERO PT TELEKOMUNIKASI INDONESIA TBK", ticker: "TLK" },
    { name: "PPERY - PT Bank Mandiri (Persero) Tbk / ADR", ticker: "PPERY" },
    { name: "NTRS - NORTHERN TRUST CORP", ticker: "NTRS" },
    { name: "TCOM - Trip.com Group Ltd", ticker: "TCOM" },
    { name: "ANET - Arista Networks, Inc.", ticker: "ANET" },
    { name: "AKAM - AKAMAI TECHNOLOGIES INC", ticker: "AKAM" },
    { name: "NRILY - NOMURA RESEARCH INSTITUTE LTD", ticker: "NRILY" },
    { name: "TLSNY - TELIA Co AB", ticker: "TLSNY" },
    { name: "CCEP - COCA-COLA EUROPEAN PARTNERS plc", ticker: "CCEP" },
    { name: "MPLX - MPLX LP", ticker: "MPLX" },
    { name: "AMCR - Amcor plc", ticker: "AMCR" },
    { name: "CQP - Cheniere Energy Partners, L.P.", ticker: "CQP" },
    { name: "MTSFY - Mitsui Fudosan Co Ltd", ticker: "MTSFY" },
    { name: "GIB - CGI INC", ticker: "GIB" },
    { name: "NET - Cloudflare, Inc.", ticker: "NET" },
    { name: "TSCO - TRACTOR SUPPLY CO /DE/", ticker: "TSCO" },
    { name: "ASHTY - Ashtead Group plc/ADR", ticker: "ASHTY" },
    { name: "CHKP - CHECK POINT SOFTWARE TECHNOLOGIES LTD", ticker: "CHKP" },
    { name: "FE - FIRSTENERGY CORP", ticker: "FE" },
    { name: "ZBRA - ZEBRA TECHNOLOGIES CORP", ticker: "ZBRA" },
    { name: "HOLX - HOLOGIC INC", ticker: "HOLX" },
    { name: "LI - Li Auto Inc.", ticker: "LI" },
    { name: "QSR - Restaurant Brands International Inc.", ticker: "QSR" },
    { name: "SNMRY - Snam Rete Gas SpA", ticker: "SNMRY" },
    { name: "VIAC - ViacomCBS Inc.", ticker: "VIAC" },
    { name: "PUGOY - PEUGEOT S A /FI", ticker: "PUGOY" },
    { name: "FITB - FIFTH THIRD BANCORP", ticker: "FITB" },
    { name: "SNN - SMITH & NEPHEW PLC", ticker: "SNN" },
    { name: "TFX - TELEFLEX INC", ticker: "TFX" },
    { name: "SONVY - Sonova Holding AG / ADR", ticker: "SONVY" },
    { name: "AGR - Avangrid, Inc.", ticker: "AGR" },
    { name: "IX - ORIX CORP", ticker: "IX" },
    { name: "VLO - VALERO ENERGY CORP/TX", ticker: "VLO" },
    { name: "BR - BROADRIDGE FINANCIAL SOLUTIONS, INC.", ticker: "BR" },
    { name: "BIO - BIO-RAD LABORATORIES, INC.", ticker: "BIO" },
    { name: "SSNC - SS&C Technologies Holdings Inc", ticker: "SSNC" },
    { name: "DGX - QUEST DIAGNOSTICS INC", ticker: "DGX" },
    { name: "BEPC - Brookfield Renewable Corp", ticker: "BEPC" },
    { name: "IQ - iQIYI, Inc.", ticker: "IQ" },
    { name: "XYL - Xylem Inc.", ticker: "XYL" },
    { name: "DOV - DOVER Corp", ticker: "DOV" },
    { name: "RYAAY - RYANAIR HOLDINGS PLC", ticker: "RYAAY" },
    { name: "ALNY - ALNYLAM PHARMACEUTICALS, INC.", ticker: "ALNY" },
    { name: "TXG - 10x Genomics, Inc.", ticker: "TXG" },
    { name: "CAJ - CANON INC", ticker: "CAJ" },
    { name: "NVR - NVR INC", ticker: "NVR" },
    { name: "MGA - MAGNA INTERNATIONAL INC", ticker: "MGA" },
    { name: "THLLY - Thales S.A./ADR", ticker: "THLLY" },
    { name: "IMBBY - IMPERIAL TOBACCO GROUP PLC", ticker: "IMBBY" },
    { name: "ATUS - Altice USA, Inc.", ticker: "ATUS" },
    { name: "WHLKF - Wheelock & Co Ltd", ticker: "WHLKF" },
    { name: "TRU - TransUnion", ticker: "TRU" },
    { name: "CGHLY - China Gas Holdings LTD/ADR", ticker: "CGHLY" },
    { name: "PODD - INSULET CORP", ticker: "PODD" },
    { name: "SYF - Synchrony Financial", ticker: "SYF" },
    { name: "CBRE - CBRE GROUP, INC.", ticker: "CBRE" },
    { name: "JHX - James Hardie Industries plc", ticker: "JHX" },
    { name: "MLM - MARTIN MARIETTA MATERIALS INC", ticker: "MLM" },
    { name: "ET - Energy Transfer LP", ticker: "ET" },
    { name: "TYL - TYLER TECHNOLOGIES INC", ticker: "TYL" },
    { name: "STE - STERIS plc", ticker: "STE" },
    { name: "PPCCY - PICC Property & Casualty Co Ltd", ticker: "PPCCY" },
    { name: "CWYCY - CHINA RAILWAY CONSTRUCTION CORP LTD", ticker: "CWYCY" },
    { name: "LOGI - LOGITECH INTERNATIONAL S.A.", ticker: "LOGI" },
    { name: "MT - ArcelorMittal", ticker: "MT" },
    { name: "EXPD - EXPEDITORS INTERNATIONAL OF WASHINGTON INC", ticker: "EXPD" },
    { name: "INVH - Invitation Homes Inc.", ticker: "INVH" },
    { name: "BILI - Bilibili Inc.", ticker: "BILI" },
    { name: "OPHLY - ONO PHARMACEUTICAL CO LTD", ticker: "OPHLY" },
    { name: "FOXA - Fox Corp", ticker: "FOXA" },
    { name: "VTR - Ventas, Inc.", ticker: "VTR" },
    { name: "DPZ - DOMINOS PIZZA INC", ticker: "DPZ" },
    { name: "IR - Ingersoll Rand Inc.", ticker: "IR" },
    { name: "SEDG - SOLAREDGE TECHNOLOGIES, INC.", ticker: "SEDG" },
    { name: "CCCGY - China Communications Construction Co", ticker: "CCCGY" },
    { name: "WIX - Wix.com Ltd.", ticker: "WIX" },
    { name: "QRVO - Qorvo, Inc.", ticker: "QRVO" },
    { name: "EXAS - EXACT SCIENCES CORP", ticker: "EXAS" },
    { name: "CTLT - Catalent, Inc.", ticker: "CTLT" },
    { name: "POOL - POOL CORP", ticker: "POOL" },
    { name: "DKNG - DraftKings Inc.", ticker: "DKNG" },
    { name: "MDB - MongoDB, Inc.", ticker: "MDB" },
    { name: "NIPNF - NEC CORP", ticker: "NIPNF" },
    { name: "RNECY - NEC ELECTRONICS CORP", ticker: "RNECY" },
    { name: "SKM - SK TELECOM CO LTD", ticker: "SKM" },
    { name: "KMX - CARMAX INC", ticker: "KMX" },
    { name: "NICE - NICE Ltd.", ticker: "NICE" },
    { name: "SGIOY - SHIONOGI & CO LTD", ticker: "SGIOY" },
    { name: "FUJHY - FUJI HEAVY INDUSTRIES LTD /FI", ticker: "FUJHY" },
    { name: "BKI - Black Knight, Inc.", ticker: "BKI" },
    { name: "WMG - Warner Music Group Corp.", ticker: "WMG" },
    { name: "EXR - Extra Space Storage Inc.", ticker: "EXR" },
    { name: "ELAN - Elanco Animal Health Inc", ticker: "ELAN" },
    { name: "GPC - GENUINE PARTS CO", ticker: "GPC" },
    { name: "NUE - NUCOR CORP", ticker: "NUE" },
    { name: "ENPH - Enphase Energy, Inc.", ticker: "ENPH" },
    { name: "MAS - MASCO CORP /DE/", ticker: "MAS" },
    { name: "TER - TERADYNE, INC", ticker: "TER" },
    { name: "PEAK - HEALTHPEAK PROPERTIES, INC.", ticker: "PEAK" },
    { name: "RKUNY - Rakuten, Inc.", ticker: "RKUNY" },
    { name: "PKX - POSCO", ticker: "PKX" },
    { name: "XPEV - XPENG INC.", ticker: "XPEV" },
    { name: "DQJCY - Don Quijote Holdings Co Ltd", ticker: "DQJCY" },
    { name: "IEX - IDEX CORP /DE/", ticker: "IEX" },
    { name: "CPB - CAMPBELL SOUP CO", ticker: "CPB" },
    { name: "AVTR - Avantor, Inc.", ticker: "AVTR" },
    { name: "SUI - SUN COMMUNITIES INC", ticker: "SUI" },
    { name: "NMR - NOMURA HOLDINGS INC", ticker: "NMR" },
    { name: "ATASY - Atlantia SpA", ticker: "ATASY" },
    { name: "MPWR - MONOLITHIC POWER SYSTEMS INC", ticker: "MPWR" },
    { name: "BMRN - BIOMARIN PHARMACEUTICAL INC", ticker: "BMRN" },
    { name: "HUBS - HUBSPOT INC", ticker: "HUBS" },
    { name: "BKR - Baker Hughes Co", ticker: "BKR" },
    { name: "KB - KB Financial Group Inc.", ticker: "KB" },
    { name: "CAH - CARDINAL HEALTH INC", ticker: "CAH" },
    { name: "MONOY - MonotaRO Co., Ltd./ADR", ticker: "MONOY" },
    { name: "FMC - FMC CORP", ticker: "FMC" },
    { name: "CE - Celanese Corp", ticker: "CE" },
    { name: "HEI - HEICO CORP", ticker: "HEI" },
    { name: "PKI - PERKINELMER INC", ticker: "PKI" },
    { name: "RCL - ROYAL CARIBBEAN CRUISES LTD", ticker: "RCL" },
    { name: "LNT - ALLIANT ENERGY CORP", ticker: "LNT" },
    { name: "HIG - HARTFORD FINANCIAL SERVICES GROUP, INC.", ticker: "HIG" },
    { name: "PXD - PIONEER NATURAL RESOURCES CO", ticker: "PXD" },
    { name: "SHMAY - Shimao Group Holdings Limited/ADR", ticker: "SHMAY" },
    { name: "URI - UNITED RENTALS, INC.", ticker: "URI" },
    { name: "BIP - Brookfield Infrastructure Partners L.P.", ticker: "BIP" },
    { name: "CHRW - C. H. ROBINSON WORLDWIDE, INC.", ticker: "CHRW" },
    { name: "LSXMA - Liberty Media Corp", ticker: "LSXMA" },
    { name: "MAA - MID AMERICA APARTMENT COMMUNITIES INC.", ticker: "MAA" },
    { name: "TW - Tradeweb Markets Inc.", ticker: "TW" },
    { name: "PPD - PPD, Inc.", ticker: "PPD" },
    { name: "NVCR - NovoCure Ltd", ticker: "NVCR" },
    { name: "STX - Seagate Technology plc", ticker: "STX" },
    { name: "GNRC - GENERAC HOLDINGS INC.", ticker: "GNRC" },
    { name: "AES - AES CORP", ticker: "AES" },
    { name: "BURL - Burlington Stores, Inc.", ticker: "BURL" },
    { name: "MKL - MARKEL CORP", ticker: "MKL" },
    { name: "CCL - CARNIVAL CORP", ticker: "CCL" },
    { name: "WAT - WATERS CORP /DE/", ticker: "WAT" },
    { name: "CJEWY - Chow Tai Fook Jewellery Group Limited/ADR", ticker: "CJEWY" },
    { name: "EXPE - Expedia Group, Inc.", ticker: "EXPE" },
    { name: "UMC - UNITED MICROELECTRONICS CORP", ticker: "UMC" },
    { name: "BRO - BROWN & BROWN, INC.", ticker: "BRO" },
    { name: "ULTA - Ulta Beauty, Inc.", ticker: "ULTA" },
    { name: "GDDY - GoDaddy Inc.", ticker: "GDDY" },
    { name: "ESS - ESSEX PROPERTY TRUST, INC.", ticker: "ESS" },
    { name: "SJM - J M SMUCKER Co", ticker: "SJM" },
    { name: "CDAY - Ceridian HCM Holding Inc.", ticker: "CDAY" },
    { name: "JBHT - HUNT J B TRANSPORT SERVICES INC", ticker: "JBHT" },
    { name: "TRMB - TRIMBLE INC.", ticker: "TRMB" },
    { name: "MASI - MASIMO CORP", ticker: "MASI" },
    { name: "FANDY - FirstRand Ltd / ADR", ticker: "FANDY" },
    { name: "GDS - GDS Holdings Ltd", ticker: "GDS" },
    { name: "PAGS - PagSeguro Digital Ltd.", ticker: "PAGS" },
    { name: "OKE - ONEOK INC /NEW/", ticker: "OKE" },
    { name: "CINF - CINCINNATI FINANCIAL CORP", ticker: "CINF" },
    { name: "VIPS - Vipshop Holdings Ltd", ticker: "VIPS" },
    { name: "IKTSY - Intertek Group plc", ticker: "IKTSY" },
    { name: "DRI - DARDEN RESTAURANTS INC", ticker: "DRI" },
    { name: "KEY - KEYCORP /NEW/", ticker: "KEY" },
    { name: "HDELY - HeidelbergCement AG", ticker: "HDELY" },
    { name: "J - JACOBS ENGINEERING GROUP INC /DE/", ticker: "J" },
    { name: "MTB - M&T BANK CORP", ticker: "MTB" },
    { name: "XNGSY - ENN Energy Holdings Ltd / ADR", ticker: "XNGSY" },
    { name: "FDS - FACTSET RESEARCH SYSTEMS INC", ticker: "FDS" },
    { name: "FICO - FAIR ISAAC CORP", ticker: "FICO" },
    { name: "UI - Ubiquiti Inc.", ticker: "UI" },
    { name: "PHM - PULTEGROUP INC/MI/", ticker: "PHM" },
    { name: "WDC - WESTERN DIGITAL CORP", ticker: "WDC" },
    { name: "EVRG - Evergy, Inc.", ticker: "EVRG" },
    { name: "LNG - Cheniere Energy, Inc.", ticker: "LNG" },
    { name: "NDVLY - NEW WORLD DEVELOPMENT CO LTD /FI", ticker: "NDVLY" },
    { name: "DVCMY - DAVIDE CAMPARI MILANO SPA", ticker: "DVCMY" },
    { name: "LBTYA - Liberty Global plc", ticker: "LBTYA" },
    { name: "CKISY - CK Infrastructure Holdings Limited/ADR", ticker: "CKISY" },
    { name: "TDY - TELEDYNE TECHNOLOGIES INC", ticker: "TDY" },
    { name: "WHR - WHIRLPOOL CORP /DE/", ticker: "WHR" },
    { name: "RF - REGIONS FINANCIAL CORP", ticker: "RF" },
    { name: "VICI - VICI PROPERTIES INC.", ticker: "VICI" },
    { name: "NNGRY - NN Group NV/ADR", ticker: "NNGRY" },
    { name: "ARGX - ARGENX SE", ticker: "ARGX" },
    { name: "ACGL - ARCH CAPITAL GROUP LTD.", ticker: "ACGL" },
    { name: "RUN - Sunrun Inc.", ticker: "RUN" },
    { name: "SHG - SHINHAN FINANCIAL GROUP CO LTD", ticker: "SHG" },
    { name: "MOH - MOLINA HEALTHCARE, INC.", ticker: "MOH" },
    { name: "LDOS - Leidos Holdings, Inc.", ticker: "LDOS" },
    { name: "NLOK - NortonLifeLock Inc.", ticker: "NLOK" },
    { name: "PBA - PEMBINA PIPELINE CORP", ticker: "PBA" },
    { name: "JKHY - HENRY JACK & ASSOCIATES INC", ticker: "JKHY" },
    { name: "IFF - INTERNATIONAL FLAVORS & FRAGRANCES INC", ticker: "IFF" },
    { name: "EDNMY - Edenred/ADR", ticker: "EDNMY" },
    { name: "DT - Dynatrace, Inc.", ticker: "DT" },
    { name: "NDSN - NORDSON CORP", ticker: "NDSN" },
    { name: "FBHS - Fortune Brands Home & Security, Inc.", ticker: "FBHS" },
    { name: "LYV - Live Nation Entertainment, Inc.", ticker: "LYV" },
    { name: "WAB - WESTINGHOUSE AIR BRAKE TECHNOLOGIES CORP", ticker: "WAB" },
    { name: "HPE - Hewlett Packard Enterprise Co", ticker: "HPE" },
    { name: "SUZ - Suzano S.A.", ticker: "SUZ" },
    { name: "CAIXY - CaixaBank/ADR", ticker: "CAIXY" },
    { name: "KEP - KOREA ELECTRIC POWER CORP", ticker: "KEP" },
    { name: "NTCO - Natura &Co Holding S.A.", ticker: "NTCO" },
    { name: "QGEN - QIAGEN N.V.", ticker: "QGEN" },
    { name: "HAS - HASBRO, INC.", ticker: "HAS" },
    { name: "ATHM - Autohome Inc.", ticker: "ATHM" },
    { name: "BXP - BOSTON PROPERTIES INC", ticker: "BXP" },
    { name: "CGNX - COGNEX CORP", ticker: "CGNX" },
    { name: "CFG - CITIZENS FINANCIAL GROUP INC/RI", ticker: "CFG" },
    { name: "SWGAY - Swatch Group AG\\ADR", ticker: "SWGAY" },
    { name: "UBSFY - Ubisoft Entertainment SA", ticker: "UBSFY" },
    { name: "ERIE - ERIE INDEMNITY CO", ticker: "ERIE" },
    { name: "EMN - EASTMAN CHEMICAL CO", ticker: "EMN" },
    { name: "CCK - CROWN HOLDINGS INC", ticker: "CCK" },
    { name: "SZSAY - SUEZ ENVIRONNEMENT CO S.A.", ticker: "SZSAY" },
    { name: "KKPNY - KONINKLIJKE KPN N V", ticker: "KKPNY" },
    { name: "ATO - ATMOS ENERGY CORP", ticker: "ATO" },
    { name: "CNP - CENTERPOINT ENERGY INC", ticker: "CNP" },
    { name: "HES - HESS CORP", ticker: "HES" },
    { name: "WPC - W. P. Carey Inc.", ticker: "WPC" },
    { name: "CNHI - CNH Industrial N.V.", ticker: "CNHI" },
    { name: "CRL - CHARLES RIVER LABORATORIES INTERNATIONAL, INC.", ticker: "CRL" },
    { name: "RPM - RPM INTERNATIONAL INC/DE/", ticker: "RPM" },
    { name: "ILIAY - Iliad S.A./ADR", ticker: "ILIAY" },
    { name: "RDY - DR REDDYS LABORATORIES LTD", ticker: "RDY" },
    { name: "ELS - EQUITY LIFESTYLE PROPERTIES INC", ticker: "ELS" },
    { name: "BEN - FRANKLIN RESOURCES INC", ticker: "BEN" },
    { name: "SZLMY - Swiss Life Holding", ticker: "SZLMY" },
    { name: "JXHLY - ENEOS Holdings, Inc./ADR", ticker: "JXHLY" },
    { name: "PFG - PRINCIPAL FINANCIAL GROUP INC", ticker: "PFG" },
    { name: "IEP - ICAHN ENTERPRISES L.P.", ticker: "IEP" },
    { name: "STBFY - Suntory Beverage & Food Limited/ADR", ticker: "STBFY" },
    { name: "WRB - BERKLEY W R CORP", ticker: "WRB" },
    { name: "OTEX - OPEN TEXT CORP", ticker: "OTEX" },
    { name: "KGC - KINROSS GOLD CORP", ticker: "KGC" },
    { name: "AVY - Avery Dennison Corp", ticker: "AVY" },
    { name: "IT - GARTNER INC", ticker: "IT" },
    { name: "HAL - HALLIBURTON CO", ticker: "HAL" },
    { name: "CHGG - CHEGG, INC", ticker: "CHGG" },
    { name: "SAM - BOSTON BEER CO INC", ticker: "SAM" },
    { name: "CZR - Caesars Entertainment, Inc.", ticker: "CZR" },
    { name: "CUK - CARNIVAL PLC", ticker: "CUK" },
    { name: "FYRTY - FamilyMart Co., Ltd. / ADR", ticker: "FYRTY" },
    { name: "PKG - PACKAGING CORP OF AMERICA", ticker: "PKG" },
    { name: "BYND - BEYOND MEAT, INC.", ticker: "BYND" },
    { name: "OMC - OMNICOM GROUP INC.", ticker: "OMC" },
    { name: "AU - ANGLOGOLD ASHANTI LTD", ticker: "AU" },
    { name: "BAH - Booz Allen Hamilton Holding Corp", ticker: "BAH" },
    { name: "DVA - DAVITA INC.", ticker: "DVA" },
    { name: "HRELY - Haier Electronics Group Co., Ltd./ADR", ticker: "HRELY" },
    { name: "ENTG - ENTEGRIS INC", ticker: "ENTG" },
    { name: "GGG - GRACO INC", ticker: "GGG" },
    { name: "LII - LENNOX INTERNATIONAL INC", ticker: "LII" },
    { name: "CABO - Cable One, Inc.", ticker: "CABO" },
    { name: "RJF - RAYMOND JAMES FINANCIAL INC", ticker: "RJF" },
    { name: "SURRY - Sun Art Retail Group Limited/ADR", ticker: "SURRY" },
    { name: "SRPT - Sarepta Therapeutics, Inc.", ticker: "SRPT" },
    { name: "GFI - GOLD FIELDS LTD", ticker: "GFI" },
    { name: "COIHY - Croda International Plc/ADR", ticker: "COIHY" },
    { name: "SNYFY - SONY FINANCIAL HOLDINGS INC", ticker: "SNYFY" },
    { name: "ON - ON SEMICONDUCTOR CORP", ticker: "ON" },
    { name: "ICLR - ICON PLC", ticker: "ICLR" },
    { name: "ALSMY - ALSTOM", ticker: "ALSMY" },
    { name: "PTC - PTC INC.", ticker: "PTC" },
    { name: "CGASY - China Resources Gas Group Limited/ADR", ticker: "CGASY" },
    { name: "ALLY - Ally Financial Inc.", ticker: "ALLY" },
    { name: "AAP - ADVANCE AUTO PARTS INC", ticker: "AAP" },
    { name: "WPP - WPP plc", ticker: "WPP" },
    { name: "MGM - MGM Resorts International", ticker: "MGM" },
    { name: "LUMN - CENTURYLINK, INC", ticker: "LUMN" },
    { name: "JBAXY - Julius Baer Group Ltd.", ticker: "JBAXY" },
    { name: "ENIA - ENEL AMERICAS S.A.", ticker: "ENIA" },
    { name: "GJNSY - Gjensidige Forsikring ASA/ADR", ticker: "GJNSY" },
    { name: "LW - Lamb Weston Holdings, Inc.", ticker: "LW" },
    { name: "UAL - United Airlines Holdings, Inc.", ticker: "UAL" },
    { name: "NTAP - NetApp, Inc.", ticker: "NTAP" },
    { name: "RMYHY - Ramsay Health Care Limited/ADR", ticker: "RMYHY" },
    { name: "QDEL - QUIDEL CORP /DE/", ticker: "QDEL" },
    { name: "AMIGY - Admiral Group", ticker: "AMIGY" },
    { name: "IAC - IAC/InterActiveCorp", ticker: "IAC" },
    { name: "WRK - WestRock Co", ticker: "WRK" },
    { name: "IHG - INTERCONTINENTAL HOTELS GROUP PLC /NEW/", ticker: "IHG" },
    { name: "EMRAF - EMERA INC", ticker: "EMRAF" },
    { name: "CEA - CHINA EASTERN AIRLINES CORP LTD", ticker: "CEA" },
    { name: "PEGA - PEGASYSTEMS INC", ticker: "PEGA" },
    { name: "GGDVY - GUANGDONG INVESTMENT LTD /FI", ticker: "GGDVY" },
    { name: "AEOXF - Aeroports de Paris SA / ADR", ticker: "AEOXF" },
    { name: "PSMMY - Persimmon", ticker: "PSMMY" },
    { name: "NDEKY - NITTO DENKO CORP / ADR/", ticker: "NDEKY" },
    { name: "SIELY - Shanghai Electric Group Co Ltd / ADR", ticker: "SIELY" },
    { name: "WTRG - Essential Utilities, Inc.", ticker: "WTRG" },
    { name: "PRDSY - Prada S.p.A./ADR", ticker: "PRDSY" },
    { name: "TEVA - TEVA PHARMACEUTICAL INDUSTRIES LTD", ticker: "TEVA" },
    { name: "IPGP - IPG PHOTONICS CORP", ticker: "IPGP" },
    { name: "PCTY - Paylocity Holding Corp", ticker: "PCTY" },
    { name: "RDEIY - Red Electrica Corporacion SA/ADR", ticker: "RDEIY" },
    { name: "YASKY - Yaskawa Electric Corp/ADR", ticker: "YASKY" },
    { name: "TECH - BIO-TECHNE Corp", ticker: "TECH" },
    { name: "CHEOY - Cochlear Ltd / ADR", ticker: "CHEOY" },
    { name: "GH - Guardant Health, Inc.", ticker: "GH" },
    { name: "FOSUY - Fosun International Ltd / ADR", ticker: "FOSUY" },
    { name: "ESTC - Elastic N.V.", ticker: "ESTC" },
    { name: "MTUAY - MTU AERO ENGINES HOLDING AG", ticker: "MTUAY" },
    { name: "NLY - ANNALY CAPITAL MANAGEMENT INC", ticker: "NLY" },
    { name: "SGPYY - SAGE GROUP PLC", ticker: "SGPYY" },
    { name: "PENN - PENN NATIONAL GAMING INC", ticker: "PENN" },
    { name: "RANJY - RANDSTAD HOLDING NV /FI", ticker: "RANJY" },
    { name: "HBAN - HUNTINGTON BANCSHARES INC/MD", ticker: "HBAN" },
    { name: "CICOY - COSCO SHIPPING Holdings Co., Ltd./ADR", ticker: "CICOY" },
    { name: "BSY - BENTLEY SYSTEMS INC", ticker: "BSY" },
    { name: "BNTGY - Brenntag AG/ADR", ticker: "BNTGY" },
    { name: "ALB - ALBEMARLE CORP", ticker: "ALB" },
    { name: "AYX - Alteryx, Inc.", ticker: "AYX" },
    { name: "BFAM - BRIGHT HORIZONS FAMILY SOLUTIONS INC.", ticker: "BFAM" },
    { name: "UMICY - Umicore/ADR", ticker: "UMICY" },
    { name: "SMFKY - Smurfit Kappa Group PLC/ADR", ticker: "SMFKY" },
    { name: "MARUY - MARUBENI CORP /FI", ticker: "MARUY" },
    { name: "ZLIOY - Zoomlion Heavy Industry Science & Technology Co., Ltd./ADR", ticker: "ZLIOY" },
    { name: "BEP - Brookfield Renewable Partners L.P.", ticker: "BEP" },
    { name: "XRAY - DENTSPLY SIRONA Inc.", ticker: "XRAY" },
    { name: "LKQ - LKQ CORP", ticker: "LKQ" },
    { name: "INGIY - INGENICO GROUP", ticker: "INGIY" },
    { name: "L - LOEWS CORP", ticker: "L" },
    { name: "ALLE - Allegion plc", ticker: "ALLE" },
    { name: "DISCA - Discovery, Inc.", ticker: "DISCA" },
    { name: "CG - Carlyle Group Inc.", ticker: "CG" },
    { name: "BWA - BORGWARNER INC", ticker: "BWA" },
    { name: "UHS - UNIVERSAL HEALTH SERVICES INC", ticker: "UHS" },
    { name: "UELMO - UNION ELECTRIC CO", ticker: "UELMO" },
    { name: "BAP - CREDICORP LTD", ticker: "BAP" },
    { name: "KIKOY - Kikkoman Corp", ticker: "KIKOY" },
    { name: "UDR - UDR, Inc.", ticker: "UDR" },
    { name: "IMO - IMPERIAL OIL LTD", ticker: "IMO" },
    { name: "FNF - Fidelity National Financial, Inc.", ticker: "FNF" },
    { name: "MPW - MEDICAL PROPERTIES TRUST INC", ticker: "MPW" },
    { name: "ALFVY - ALFA LAVAL AB /FI", ticker: "ALFVY" },
    { name: "FIVN - Five9, Inc.", ticker: "FIVN" },
    { name: "MHGVY - Marine Harvest ASA", ticker: "MHGVY" },
    { name: "CVAC - CureVac N.V.", ticker: "CVAC" },
    { name: "CCHGY - Coca-Cola HBC AG", ticker: "CCHGY" },
    { name: "OXY - OCCIDENTAL PETROLEUM CORP /DE/", ticker: "OXY" },
    { name: "FSLY - Fastly, Inc.", ticker: "FSLY" },
    { name: "AMH - American Homes 4 Rent", ticker: "AMH" },
    { name: "PNW - PINNACLE WEST CAPITAL CORP", ticker: "PNW" },
    { name: "VST - Vistra Corp.", ticker: "VST" },
    { name: "CMS-PB - CONSUMERS ENERGY CO", ticker: "CMS-PB" },
    { name: "SHWGY - Shandong Weigao Group Medical Polymer Co Limited/ADR", ticker: "SHWGY" },
    { name: "MTN - VAIL RESORTS INC", ticker: "MTN" },
    { name: "NBIX - NEUROCRINE BIOSCIENCES INC", ticker: "NBIX" },
    { name: "CONE - CyrusOne Inc.", ticker: "CONE" },
    { name: "APO - Apollo Global Management, Inc.", ticker: "APO" },
    { name: "SQM - CHEMICAL & MINING CO OF CHILE INC", ticker: "SQM" },
    { name: "FTCH - Farfetch Ltd", ticker: "FTCH" },
    { name: "TTC - TORO CO", ticker: "TTC" },
    { name: "LB - L Brands, Inc.", ticker: "LB" },
    { name: "AQN - ALGONQUIN POWER & UTILITIES CORP.", ticker: "AQN" },
    { name: "ASX - ASE Technology Holding Co., Ltd.", ticker: "ASX" },
    { name: "BILL - Bill.com Holdings, Inc.", ticker: "BILL" },
    { name: "AHEXY - Adecco Group AG/ADR", ticker: "AHEXY" },
    { name: "RGEN - REPLIGEN CORP", ticker: "RGEN" },
    { name: "NI - NISOURCE INC.", ticker: "NI" },
    { name: "SMG - SCOTTS MIRACLE-GRO CO", ticker: "SMG" },
    { name: "WLK - WESTLAKE CHEMICAL CORP", ticker: "WLK" },
    { name: "PUBGY - PUBLICIS GROUPE SA", ticker: "PUBGY" },
    { name: "SJR - SHAW COMMUNICATIONS INC", ticker: "SJR" },
    { name: "EBR - BRAZILIAN ELECTRIC POWER CO", ticker: "EBR" },
    { name: "EQH - Equitable Holdings, Inc.", ticker: "EQH" },
    { name: "XPO - XPO Logistics, Inc.", ticker: "XPO" },
    { name: "FSLR - FIRST SOLAR, INC.", ticker: "FSLR" },
    { name: "NFE - New Fortress Energy Inc.", ticker: "NFE" },
    { name: "AZPN - ASPEN TECHNOLOGY INC /DE/", ticker: "AZPN" },
    { name: "ASEKY - Aisin Seiki Co., Ltd./ADR", ticker: "ASEKY" },
    { name: "HSIC - HENRY SCHEIN INC", ticker: "HSIC" },
    { name: "OLED - UNIVERSAL DISPLAY CORP \\PA\\", ticker: "OLED" },
    { name: "WU - Western Union CO", ticker: "WU" },
    { name: "AOS - SMITH A O CORP", ticker: "AOS" },
    { name: "CPT - CAMDEN PROPERTY TRUST", ticker: "CPT" },
    { name: "GL - GLOBE LIFE INC.", ticker: "GL" },
    { name: "WSO - WATSCO INC", ticker: "WSO" },
    { name: "CBOE - Cboe Global Markets, Inc.", ticker: "CBOE" },
    { name: "RNR - RENAISSANCERE HOLDINGS LTD", ticker: "RNR" },
    { name: "TREX - TREX CO INC", ticker: "TREX" },
    { name: "WB - WEIBO Corp", ticker: "WB" },
    { name: "CNPAY - CNP Assurances SA / ADR", ticker: "CNPAY" },
    { name: "PWR - QUANTA SERVICES, INC.", ticker: "PWR" },
    { name: "HRGLY - Hargreaves Lansdown PLC/ADR", ticker: "HRGLY" },
    { name: "KOF - COCA COLA FEMSA SAB DE CV", ticker: "KOF" },
    { name: "SMMYY - Sumitomo Metal Mining Co., LTD./ADR", ticker: "SMMYY" },
    { name: "GWRE - Guidewire Software, Inc.", ticker: "GWRE" },
    { name: "GLPG - GALAPAGOS NV", ticker: "GLPG" },
    { name: "SMTOY - SUMITOMO ELECTRIC INDUSTRIES LTD/ADR/", ticker: "SMTOY" },
    { name: "PNR - PENTAIR plc", ticker: "PNR" },
    { name: "FND - Floor & Decor Holdings, Inc.", ticker: "FND" },
    { name: "HEGIY - Hengan International Group Co. Ltd.", ticker: "HEGIY" },
    { name: "SNA - Snap-on Inc", ticker: "SNA" },
    { name: "NVTA - Invitae Corp", ticker: "NVTA" },
    { name: "MRTX - Mirati Therapeutics, Inc.", ticker: "MRTX" },
    { name: "JAZZ - Jazz Pharmaceuticals plc", ticker: "JAZZ" },
    { name: "ASND - Ascendis Pharma A/S", ticker: "ASND" },
    { name: "SEIC - SEI INVESTMENTS CO", ticker: "SEIC" },
    { name: "RNLSY - Renault SA Unsponsored ADR Facility", ticker: "RNLSY" },
    { name: "FRFHF - FAIRFAX FINANCIAL HOLDINGS LTD/ CAN", ticker: "FRFHF" },
    { name: "XYIGY - Xinyi Glass Holdings Limited/ADR", ticker: "XYIGY" },
    { name: "GRPTY - Groupe Eurotunnel SA", ticker: "GRPTY" },
    { name: "DBX - DROPBOX, INC.", ticker: "DBX" },
    { name: "NWSA - NEWS CORP", ticker: "NWSA" },
    { name: "WILYY - Demant AS/ADR", ticker: "WILYY" },
    { name: "GLPI - Gaming & Leisure Properties, Inc.", ticker: "GLPI" },
    { name: "EFGSY - Eiffage SA", ticker: "EFGSY" },
    { name: "MGP - MGM Growth Properties LLC", ticker: "MGP" },
    { name: "NRG - NRG ENERGY, INC.", ticker: "NRG" },
    { name: "CNA - CNA FINANCIAL CORP", ticker: "CNA" },
    { name: "CREE - CREE, INC.", ticker: "CREE" },
    { name: "AMED - AMEDISYS INC", ticker: "AMED" },
    { name: "SBSW - Sibanye Stillwater Ltd", ticker: "SBSW" },
    { name: "HUBB - HUBBELL INC", ticker: "HUBB" },
    { name: "WSM - WILLIAMS SONOMA INC", ticker: "WSM" },
    { name: "RE - EVEREST RE GROUP LTD", ticker: "RE" },
    { name: "IAUGY - INSURANCE AUSTRALIA GROUP LTD", ticker: "IAUGY" },
    { name: "TXT - TEXTRON INC", ticker: "TXT" },
    { name: "RGLD - ROYAL GOLD INC", ticker: "RGLD" },
    { name: "HWM - Howmet Aerospace Inc.", ticker: "HWM" },
    { name: "SNPHY - Santen Pharmaceutical Co Ltd/ADR", ticker: "SNPHY" },
    { name: "IRM - IRON MOUNTAIN INC", ticker: "IRM" },
    { name: "OC - Owens Corning", ticker: "OC" },
    { name: "FFIV - F5 NETWORKS, INC.", ticker: "FFIV" },
    { name: "KSRYY - Kose Corporation/ADR", ticker: "KSRYY" },
    { name: "LEA - LEAR CORP", ticker: "LEA" },
    { name: "MORN - Morningstar, Inc.", ticker: "MORN" },
    { name: "KOTMY - Koito Manufacturing Co., Ltd./ADR", ticker: "KOTMY" },
    { name: "DADA - Dada Nexus Ltd", ticker: "DADA" },
    { name: "SLV - iShares Silver Trust", ticker: "SLV" },
    { name: "NKLA - Nikola Corp", ticker: "NKLA" },
    { name: "LYFT - Lyft, Inc.", ticker: "LYFT" },
    { name: "PRYMY - Prysmian S.p.A.", ticker: "PRYMY" },
    { name: "ACSAY - ACS Actividades de Construccion y Servicios SA", ticker: "ACSAY" },
    { name: "WYNN - WYNN RESORTS LTD", ticker: "WYNN" },
    { name: "AGNC - AGNC Investment Corp.", ticker: "AGNC" },
    { name: "SCI - SERVICE CORP INTERNATIONAL", ticker: "SCI" },
    { name: "CHE - CHEMED CORP", ticker: "CHE" },
    { name: "BCH - BANK OF CHILE", ticker: "BCH" },
    { name: "GLOB - Globant S.A.", ticker: "GLOB" },
    { name: "GRUB - GrubHub Inc.", ticker: "GRUB" },
    { name: "OCFT - ONECONNECT FINANCIAL TECHNOLOGY CO., LTD.", ticker: "OCFT" },
    { name: "BG - BUNGELTD", ticker: "BG" },
    { name: "COG - CABOT OIL & GAS CORP", ticker: "COG" },
    { name: "PEN - Penumbra Inc", ticker: "PEN" },
    { name: "CRCBY - Chongqing Rural Commercial Bank Co., Ltd./ADR", ticker: "CRCBY" },
    { name: "IAA - IAA, Inc.", ticker: "IAA" },
    { name: "WYNMY - Wynn Macau Limited/ADR", ticker: "WYNMY" },
    { name: "HST - HOST HOTELS & RESORTS, INC.", ticker: "HST" },
    { name: "SNX - SYNNEX CORP", ticker: "SNX" },
    { name: "DOX - AMDOCS LTD", ticker: "DOX" },
    { name: "RTMVY - Rightmove PLC/ADR", ticker: "RTMVY" },
    { name: "TAP - MOLSON COORS BEVERAGE CO", ticker: "TAP" },
    { name: "AMWL - American Well Corp", ticker: "AMWL" },
    { name: "ATR - APTARGROUP INC", ticker: "ATR" },
    { name: "FIVE - FIVE BELOW, INC", ticker: "FIVE" },
    { name: "COLD - AMERICOLD REALTY TRUST", ticker: "COLD" },
    { name: "NWL - NEWELL BRANDS INC.", ticker: "NWL" },
    { name: "ST - Sensata Technologies Holding plc", ticker: "ST" },
    { name: "SHPMY - Shanghai Pharmaceuticals Holding Co., Ltd./ADR", ticker: "SHPMY" },
    { name: "CRSP - CRISPR Therapeutics AG", ticker: "CRSP" },
    { name: "ROHCY - ROHM Co., Ltd.", ticker: "ROHCY" },
    { name: "NCNO - NCINO, INC.", ticker: "NCNO" },
    { name: "ATDRY - Auto Trader Group plc/ADR", ticker: "ATDRY" },
    { name: "HTCMY - Hitachi Construction Machinery Co Ltd", ticker: "HTCMY" },
    { name: "ACM - AECOM", ticker: "ACM" },
    { name: "TECK - TECK RESOURCES LTD", ticker: "TECK" },
    { name: "MHK - MOHAWK INDUSTRIES INC", ticker: "MHK" },
    { name: "AIZ - ASSURANT, INC.", ticker: "AIZ" },
    { name: "ARMK - Aramark", ticker: "ARMK" },
    { name: "JNPR - JUNIPER NETWORKS INC", ticker: "JNPR" },
    { name: "FLEX - FLEX LTD.", ticker: "FLEX" },
    { name: "FROG - JFrog Ltd", ticker: "FROG" },
    { name: "IPXHY - INPEX HOLDINGS INC", ticker: "IPXHY" },
    { name: "ALV - AUTOLIV INC", ticker: "ALV" },
    { name: "DAR - DARLING INGREDIENTS INC.", ticker: "DAR" },
    { name: "ACI - Albertsons Companies, Inc.", ticker: "ACI" },
    { name: "NYT - NEW YORK TIMES CO", ticker: "NYT" },
    { name: "GFL - GFL Environmental Inc.", ticker: "GFL" },
    { name: "UGI - UGI CORP /PA/", ticker: "UGI" },
    { name: "RS - RELIANCE STEEL & ALUMINUM CO", ticker: "RS" },
    { name: "RH - RH", ticker: "RH" },
    { name: "MOS - MOSAIC CO", ticker: "MOS" },
    { name: "G - Genpact LTD", ticker: "G" },
    { name: "MLCO - Melco Resorts & Entertainment LTD", ticker: "MLCO" },
    { name: "TNDM - TANDEM DIABETES CARE INC", ticker: "TNDM" },
    { name: "GPS - GAP INC", ticker: "GPS" },
    { name: "UHAL - AMERCO /NV/", ticker: "UHAL" },
    { name: "RGA - REINSURANCE GROUP OF AMERICA INC", ticker: "RGA" },
    { name: "TOKUY - TOKYU CORP", ticker: "TOKUY" },
    { name: "VOPKY - Koninklijke Vopak N.V. / ADR", ticker: "VOPKY" },
    { name: "BTG - B2GOLD CORP", ticker: "BTG" },
    { name: "SLFPY - STANDARD LIFE PLC", ticker: "SLFPY" },
    { name: "CSL - CARLISLE COMPANIES INC", ticker: "CSL" },
    { name: "ASGLY - AGC Inc./ADR", ticker: "ASGLY" },
    { name: "IPG - INTERPUBLIC GROUP OF COMPANIES, INC.", ticker: "IPG" },
    { name: "MAGOY - Man AG", ticker: "MAGOY" },
    { name: "DECK - DECKERS OUTDOOR CORP", ticker: "DECK" },
    { name: "CGC - Canopy Growth Corp", ticker: "CGC" },
    { name: "AACAY - AAC Acoustic Technologies Holdings Inc.", ticker: "AACAY" },
    { name: "CHDN - CHURCHILL DOWNS Inc", ticker: "CHDN" },
    { name: "ABMRF - ABN AMRO Bank N.V./ADR", ticker: "ABMRF" },
    { name: "PAAS - PAN AMERICAN SILVER CORP", ticker: "PAAS" },
    { name: "SMAR - SMARTSHEET INC", ticker: "SMAR" },
    { name: "LAD - LITHIA MOTORS INC", ticker: "LAD" },
    { name: "EXEL - EXELIXIS, INC.", ticker: "EXEL" },
    { name: "DLB - Dolby Laboratories, Inc.", ticker: "DLB" },
    { name: "OHI - OMEGA HEALTHCARE INVESTORS INC", ticker: "OHI" },
    { name: "GNTX - GENTEX CORP", ticker: "GNTX" },
    { name: "CBSH - COMMERCE BANCSHARES INC /MO/", ticker: "CBSH" },
    { name: "NGLS-PA - Targa Resources Partners LP", ticker: "NGLS-PA" },
    { name: "RBA - RITCHIE BROS AUCTIONEERS INC", ticker: "RBA" },
    { name: "TISCY - TAISEI CORP LTD /ADR/", ticker: "TISCY" },
    { name: "SWI - SolarWinds Corp", ticker: "SWI" },
    { name: "KNX - Knight-Swift Transportation Holdings Inc.", ticker: "KNX" },
    { name: "MDIBY - Mediobanca - Banca di Credito Finanziario SpA", ticker: "MDIBY" },
    { name: "AAXN - AXON ENTERPRISE, INC.", ticker: "AAXN" },
    { name: "CASY - CASEYS GENERAL STORES INC", ticker: "CASY" },
    { name: "ACH - ALUMINUM CORP OF CHINA LTD", ticker: "ACH" },
    { name: "STLD - STEEL DYNAMICS INC", ticker: "STLD" },
    { name: "KC - Kingsoft Cloud Holdings Ltd", ticker: "KC" },
    { name: "ELUXY - AKTIEBOLAGET ELECTROLUX", ticker: "ELUXY" },
    { name: "LAMR - LAMAR ADVERTISING CO/NEW", ticker: "LAMR" },
    { name: "LNC - LINCOLN NATIONAL CORP", ticker: "LNC" },
    { name: "IONS - IONIS PHARMACEUTICALS INC", ticker: "IONS" },
    { name: "BERY - BERRY GLOBAL GROUP, INC.", ticker: "BERY" },
    { name: "EHC - Encompass Health Corp", ticker: "EHC" },
    { name: "CCOZY - CHINA COAL ENERGY CO LTD", ticker: "CCOZY" },
    { name: "CUBE - CubeSmart", ticker: "CUBE" },
    { name: "BSAC - BANCO SANTANDER CHILE", ticker: "BSAC" },
    { name: "LPLA - LPL Financial Holdings Inc.", ticker: "LPLA" },
    { name: "ADPT - Adaptive Biotechnologies Corp", ticker: "ADPT" },
    { name: "ACAD - ACADIA PHARMACEUTICALS INC", ticker: "ACAD" },
    { name: "PLUG - PLUG POWER INC", ticker: "PLUG" },
    { name: "GGB - GERDAU S.A.", ticker: "GGB" },
    { name: "OUKPY - Outotec OYJ", ticker: "OUKPY" },
    { name: "HMTLY - HITACHI METALS LTD /ADR/", ticker: "HMTLY" },
    { name: "YY - JOYY Inc.", ticker: "YY" },
    { name: "ARW - ARROW ELECTRONICS INC", ticker: "ARW" },
    { name: "LEVI - LEVI STRAUSS & CO", ticker: "LEVI" },
    { name: "DCI - DONALDSON CO INC", ticker: "DCI" },
    { name: "DSEEY - Daiwa Securities Group Inc.", ticker: "DSEEY" },
    { name: "IVZ - Invesco Ltd.", ticker: "IVZ" },
    { name: "BMRRY - B&M European Value Retail S.A./ADR", ticker: "BMRRY" },
    { name: "RHI - ROBERT HALF INTERNATIONAL INC.", ticker: "RHI" },
    { name: "OGE - OGE ENERGY CORP.", ticker: "OGE" },
    { name: "AAL - American Airlines Group Inc.", ticker: "AAL" },
    { name: "IRTC - iRhythm Technologies, Inc.", ticker: "IRTC" },
    { name: "VOYA - Voya Financial, Inc.", ticker: "VOYA" },
    { name: "WEX - WEX Inc.", ticker: "WEX" },
    { name: "JAPSY - JAPAN AIRLINES CO LTD /ADR/", ticker: "JAPSY" },
    { name: "REYN - Reynolds Consumer Products Inc.", ticker: "REYN" },
    { name: "SHCAY - SHARP CORP /FI", ticker: "SHCAY" },
    { name: "SEE - SEALED AIR CORP/DE", ticker: "SEE" },
    { name: "AFG - AMERICAN FINANCIAL GROUP INC", ticker: "AFG" },
    { name: "LITE - Lumentum Holdings Inc.", ticker: "LITE" },
    { name: "REG - REGENCY CENTERS CORP", ticker: "REG" },
    { name: "ARES - Ares Management Corp", ticker: "ARES" },
    { name: "BRKR - BRUKER CORP", ticker: "BRKR" },
    { name: "CLZNY - CLARIANT AG", ticker: "CLZNY" },
    { name: "CX - CEMEX SAB DE CV", ticker: "CX" },
    { name: "ISUZY - ISUZU MOTORS LTD/ADR/", ticker: "ISUZY" },
    { name: "HLF - HERBALIFE NUTRITION LTD.", ticker: "HLF" },
    { name: "PRGO - PERRIGO Co plc", ticker: "PRGO" },
    { name: "ADT - ADT Inc.", ticker: "ADT" },
    { name: "CIEN - CIENA CORP", ticker: "CIEN" },
    { name: "VNO - VORNADO REALTY TRUST", ticker: "VNO" },
    { name: "CAKFY - McKesson Europe AG/ADR", ticker: "CAKFY" },
    { name: "MKSI - MKS INSTRUMENTS INC", ticker: "MKSI" },
    { name: "CIB - BANCOLOMBIA SA", ticker: "CIB" },
    { name: "TS - TENARIS SA", ticker: "TS" },
    { name: "FVRR - Fiverr International Ltd.", ticker: "FVRR" },
    { name: "SHTDY - Sinopharm Group Co/ADR", ticker: "SHTDY" },
    { name: "MANH - MANHATTAN ASSOCIATES INC", ticker: "MANH" },
    { name: "TOL - Toll Brothers, Inc.", ticker: "TOL" },
    { name: "POST - Post Holdings, Inc.", ticker: "POST" },
    { name: "BIGC - BigCommerce Holdings, Inc.", ticker: "BIGC" },
    { name: "WARFY - WHARF HOLDINGS LTD /FI", ticker: "WARFY" },
    { name: "ASOMY - ASOS plc", ticker: "ASOMY" },
    { name: "BGAOY - Proximus", ticker: "BGAOY" },
    { name: "COLM - COLUMBIA SPORTSWEAR CO", ticker: "COLM" },
    { name: "SRCL - STERICYCLE INC", ticker: "SRCL" },
    { name: "OLLI - Ollie's Bargain Outlet Holdings, Inc.", ticker: "OLLI" },
    { name: "MNSO - MINISO Group Holding Ltd", ticker: "MNSO" },
    { name: "VRT - Vertiv Holdings Co", ticker: "VRT" },
    { name: "AGCO - AGCO CORP /DE", ticker: "AGCO" },
    { name: "UVRBY - Universal Robina Corporation/ADR", ticker: "UVRBY" },
    { name: "LECO - LINCOLN ELECTRIC HOLDINGS INC", ticker: "LECO" },
    { name: "BHC - Bausch Health Companies Inc.", ticker: "BHC" },
    { name: "TDHOY - T&D HOLDINGS INC", ticker: "TDHOY" },
    { name: "SJMHY - SJM Holdings Limited/ADR", ticker: "SJMHY" },
    { name: "NVAX - NOVAVAX INC", ticker: "NVAX" },
    { name: "REXR - Rexford Industrial Realty, Inc.", ticker: "REXR" },
    { name: "AXTA - Axalta Coating Systems Ltd.", ticker: "AXTA" },
    { name: "BLD - TopBuild Corp", ticker: "BLD" },
    { name: "APPN - APPIAN CORP", ticker: "APPN" },
    { name: "JSGRY - JS Group CORP", ticker: "JSGRY" },
    { name: "ENGGY - Enagas, S.A.", ticker: "ENGGY" },
    { name: "CMA - COMERICA INC /NEW/", ticker: "CMA" },
    { name: "CF - CF Industries Holdings, Inc.", ticker: "CF" },
    { name: "CACC - CREDIT ACCEPTANCE CORP", ticker: "CACC" },
    { name: "FHN - FIRST HORIZON NATIONAL CORP", ticker: "FHN" },
    { name: "DNFGY - Dongfeng Motor Group Co Ltd / ADR", ticker: "DNFGY" },
    { name: "HII - HUNTINGTON INGALLS INDUSTRIES, INC.", ticker: "HII" },
    { name: "SITE - SiteOne Landscape Supply, Inc.", ticker: "SITE" },
    { name: "HBI - Hanesbrands Inc.", ticker: "HBI" },
    { name: "VRM - Vroom, Inc.", ticker: "VRM" },
    { name: "LNEGY - Lundin Petroleum AB", ticker: "LNEGY" },
    { name: "AEG - AEGON NV", ticker: "AEG" },
    { name: "NTRA - Natera, Inc.", ticker: "NTRA" },
    { name: "AZEK - AZEK Co Inc.", ticker: "AZEK" },
    { name: "NNN - NATIONAL RETAIL PROPERTIES, INC.", ticker: "NNN" },
    { name: "FAF - First American Financial Corp", ticker: "FAF" },
    { name: "ARCC - ARES CAPITAL CORP", ticker: "ARCC" },
    { name: "FSV - FirstService Corp", ticker: "FSV" },
    { name: "HNP - HUANENG POWER INTERNATIONAL INC", ticker: "HNP" },
    { name: "LEG - LEGGETT & PLATT INC", ticker: "LEG" },
    { name: "PII - Polaris Inc.", ticker: "PII" },
    { name: "KLYCY - KunLun Energy Co Ltd", ticker: "KLYCY" },
    { name: "CLPXY - China Longyuan Power Group Corp Limited/ADR/", ticker: "CLPXY" },
    { name: "PHI - PLDT Inc.", ticker: "PHI" },
    { name: "HOCFF - HOCHTIEF AG / ADR", ticker: "HOCFF" },
    { name: "CWEN-A - Clearway Energy, Inc.", ticker: "CWEN-A" },
    { name: "UA - Under Armour, Inc.", ticker: "UA" },
    { name: "BL - BLACKLINE, INC.", ticker: "BL" },
    { name: "DCT - DUCK CREEK TECHNOLOGIES, INC.", ticker: "DCT" },
    { name: "MIDD - MIDDLEBY CORP", ticker: "MIDD" },
    { name: "BJ - BJ's Wholesale Club Holdings, Inc.", ticker: "BJ" },
    { name: "TTEK - TETRA TECH INC", ticker: "TTEK" },
    { name: "JLL - JONES LANG LASALLE INC", ticker: "JLL" },
    { name: "KRC - KILROY REALTY CORP", ticker: "KRC" },
    { name: "JBL - JABIL INC", ticker: "JBL" },
    { name: "TPR - TAPESTRY, INC.", ticker: "TPR" },
    { name: "KAJMY - Kajima Corp", ticker: "KAJMY" },
    { name: "OGFGY - ORIGIN ENERGY LTD", ticker: "OGFGY" },
    { name: "BPMC - Blueprint Medicines Corp", ticker: "BPMC" },
    { name: "ITT - ITT Inc.", ticker: "ITT" },
    { name: "OSAGY - OSRAM Licht AG/ADR", ticker: "OSAGY" },
    { name: "FRT - FEDERAL REALTY INVESTMENT TRUST", ticker: "FRT" },
    { name: "MPLN - MultiPlan Corp", ticker: "MPLN" },
    { name: "ARWR - ARROWHEAD PHARMACEUTICALS, INC.", ticker: "ARWR" },
    { name: "MSA - MSA Safety Inc", ticker: "MSA" },
    { name: "PLNT - Planet Fitness, Inc.", ticker: "PLNT" },
    { name: "SOMMY - Sumitomo Chemical Co., Ltd.", ticker: "SOMMY" },
    { name: "BNCDY - Banca Mediolanum S.p.A./ADR", ticker: "BNCDY" },
    { name: "RYKKY - Ryohin Keikaku Co/ADR", ticker: "RYKKY" },
    { name: "AUY - YAMANA GOLD INC.", ticker: "AUY" },
    { name: "IOVA - IOVANCE BIOTHERAPEUTICS, INC.", ticker: "IOVA" },
    { name: "TIMB - TIM S.A.", ticker: "TIMB" },
    { name: "HLLGY - Hella KGaA Hueck & Co./ADR", ticker: "HLLGY" },
    { name: "SON - SONOCO PRODUCTS CO", ticker: "SON" },
    { name: "SBS - COMPANHIA DE SANEAMENTO BASICO DO ESTADO DE SAO PAULO-SABESP", ticker: "SBS" },
    { name: "USFD - US Foods Holding Corp.", ticker: "USFD" },
    { name: "ANGI - ANGI Homeservices Inc.", ticker: "ANGI" },
    { name: "HTA - HEALTHCARE TRUST OF AMERICA, INC.", ticker: "HTA" },
    { name: "AN - AUTONATION, INC.", ticker: "AN" },
    { name: "ESLT - ELBIT SYSTEMS LTD", ticker: "ESLT" },
    { name: "H - Hyatt Hotels Corp", ticker: "H" },
    { name: "MRWSY - WM Morrison Supermarkets plc", ticker: "MRWSY" },
    { name: "RARE - Ultragenyx Pharmaceutical Inc.", ticker: "RARE" },
    { name: "OSK - OSHKOSH CORP", ticker: "OSK" },
    { name: "APPF - APPFOLIO INC", ticker: "APPF" },
    { name: "WWD - Woodward, Inc.", ticker: "WWD" },
    { name: "WF - WOORI FINANCIAL GROUP INC.", ticker: "WF" },
    { name: "EGP - EASTGROUP PROPERTIES INC", ticker: "EGP" },
    { name: "HUN - Huntsman CORP", ticker: "HUN" },
    { name: "SKX - SKECHERS USA INC", ticker: "SKX" },
    { name: "DKS - DICK'S SPORTING GOODS, INC.", ticker: "DKS" },
    { name: "SHMUY - Shimizu Corporation/ADR", ticker: "SHMUY" },
    { name: "LSI - LIFE STORAGE, INC.", ticker: "LSI" },
    { name: "RL - RALPH LAUREN CORP", ticker: "RL" },
    { name: "WEN - Wendy's Co", ticker: "WEN" },
    { name: "BWXT - BWX Technologies, Inc.", ticker: "BWXT" },
    { name: "EWBC - EAST WEST BANCORP INC", ticker: "EWBC" },
    { name: "CACI - CACI INTERNATIONAL INC /DE/", ticker: "CACI" },
    { name: "THO - THOR INDUSTRIES INC", ticker: "THO" },
    { name: "FR - FIRST INDUSTRIAL REALTY TRUST INC", ticker: "FR" },
    { name: "UTHR - UNITED THERAPEUTICS Corp", ticker: "UTHR" },
    { name: "GMED - GLOBUS MEDICAL INC", ticker: "GMED" },
    { name: "VLPNY - VOESTALPINE AG", ticker: "VLPNY" },
    { name: "PSO - PEARSON PLC", ticker: "PSO" },
    { name: "PB - PROSPERITY BANCSHARES INC", ticker: "PB" },
    { name: "AVAL - Grupo Aval Acciones Y Valores S.A.", ticker: "AVAL" },
    { name: "TSUKY - TOYO SUISAN KAISHA LTD/ADR/", ticker: "TSUKY" },
    { name: "WRTBY - Wartsila OYJ", ticker: "WRTBY" },
    { name: "NVRO - NEVRO CORP", ticker: "NVRO" },
    { name: "BC - BRUNSWICK CORP", ticker: "BC" },
    { name: "INGR - Ingredion Inc", ticker: "INGR" },
    { name: "TXRH - Texas Roadhouse, Inc.", ticker: "TXRH" },
    { name: "PAC - Pacific Airport Group", ticker: "PAC" },
    { name: "FLO - FLOWERS FOODS INC", ticker: "FLO" },
    { name: "QTWO - Q2 Holdings, Inc.", ticker: "QTWO" },
    { name: "CURLF - Curaleaf Holdings, Inc.", ticker: "CURLF" },
    { name: "EBS - Emergent BioSolutions Inc.", ticker: "EBS" },
    { name: "DXC - DXC Technology Co", ticker: "DXC" },
    { name: "HWDJY - Howden Joinery Group Plc/ADR", ticker: "HWDJY" },
    { name: "JEF - Jefferies Financial Group Inc.", ticker: "JEF" },
    { name: "SID - NATIONAL STEEL CO", ticker: "SID" },
    { name: "JHG - JANUS HENDERSON GROUP PLC", ticker: "JHG" },
    { name: "DOOO - BRP Inc.", ticker: "DOOO" },
    { name: "HELE - HELEN OF TROY LTD", ticker: "HELE" },
    { name: "AIV - APARTMENT INVESTMENT & MANAGEMENT CO", ticker: "AIV" },
    { name: "NEO - NEOGENOMICS INC", ticker: "NEO" },
    { name: "EKTAY - Elekta AB / ADR", ticker: "EKTAY" },
    { name: "BLI - Berkeley Lights, Inc.", ticker: "BLI" },
    { name: "ZION - ZIONS BANCORPORATION, NATIONAL ASSOCIATION /UT/", ticker: "ZION" },
    { name: "ALLO - Allogene Therapeutics, Inc.", ticker: "ALLO" },
    { name: "FUTU - Futu Holdings Ltd", ticker: "FUTU" },
    { name: "NOMD - Nomad Foods Ltd", ticker: "NOMD" },
    { name: "KT - KT CORP", ticker: "KT" },
    { name: "LPL - LG Display Co., Ltd.", ticker: "LPL" },
    { name: "EEFT - EURONET WORLDWIDE, INC.", ticker: "EEFT" },
    { name: "DNLI - Denali Therapeutics Inc.", ticker: "DNLI" },
    { name: "PFGC - Performance Food Group Co", ticker: "PFGC" },
    { name: "ENIC - Enel Chile S.A.", ticker: "ENIC" },
    { name: "OMF - OneMain Holdings, Inc.", ticker: "OMF" },
    { name: "ALK - ALASKA AIR GROUP, INC.", ticker: "ALK" },
    { name: "LSTR - LANDSTAR SYSTEM INC", ticker: "LSTR" },
    { name: "DIISY - Direct Line Insurance Group plc/ADR", ticker: "DIISY" },
    { name: "CHH - CHOICE HOTELS INTERNATIONAL INC /DE", ticker: "CHH" },
    { name: "PSTG - Pure Storage, Inc.", ticker: "PSTG" },
    { name: "CLR - CONTINENTAL RESOURCES, INC", ticker: "CLR" },
    { name: "DOYU - DouYu International Holdings Ltd", ticker: "DOYU" },
    { name: "HUYA - HUYA Inc.", ticker: "HUYA" },
    { name: "WMS - ADVANCED DRAINAGE SYSTEMS, INC.", ticker: "WMS" },
    { name: "ICL - ICL Group Ltd.", ticker: "ICL" },
    { name: "SPCE - Virgin Galactic Holdings, Inc", ticker: "SPCE" },
    { name: "LANC - LANCASTER COLONY CORP", ticker: "LANC" },
    { name: "FRPT - Freshpet, Inc.", ticker: "FRPT" },
    { name: "NTNX - Nutanix, Inc.", ticker: "NTNX" },
    { name: "STAG - STAG Industrial, Inc.", ticker: "STAG" },
    { name: "BBIO - BridgeBio Pharma, Inc.", ticker: "BBIO" },
    { name: "PAA - PLAINS ALL AMERICAN PIPELINE LP", ticker: "PAA" },
    { name: "KIM - KIMCO REALTY CORP", ticker: "KIM" },
    { name: "VNT - Vontier Corp", ticker: "VNT" },
    { name: "HAE - HAEMONETICS CORP", ticker: "HAE" },
    { name: "ESNT - Essent Group Ltd.", ticker: "ESNT" },
    { name: "CNVVY - ConvaTec Group PLC/ADR", ticker: "CNVVY" },
    { name: "DSGX - DESCARTES SYSTEMS GROUP INC", ticker: "DSGX" },
    { name: "IIVI - II-VI INC", ticker: "IIVI" },
    { name: "MPFRY - MAPFRE S.A.", ticker: "MPFRY" },
    { name: "FOUR - Shift4 Payments, Inc.", ticker: "FOUR" },
    { name: "TNET - TRINET GROUP, INC.", ticker: "TNET" },
    { name: "TPX - TEMPUR SEALY INTERNATIONAL, INC.", ticker: "TPX" },
    { name: "ORI - OLD REPUBLIC INTERNATIONAL CORP", ticker: "ORI" },
    { name: "MDU - MDU RESOURCES GROUP INC", ticker: "MDU" },
    { name: "NCLH - Norwegian Cruise Line Holdings Ltd.", ticker: "NCLH" },
    { name: "WH - WYNDHAM HOTELS & RESORTS, INC.", ticker: "WH" },
    { name: "RDFN - Redfin Corp", ticker: "RDFN" },
    { name: "TKC - TURKCELL ILETISIM HIZMETLERI A S", ticker: "TKC" },
    { name: "LFUS - LITTELFUSE INC /DE", ticker: "LFUS" },
    { name: "BZZUY - BUZZI UNICEM S.p.A.", ticker: "BZZUY" },
    { name: "PRI - Primerica, Inc.", ticker: "PRI" },
    { name: "LSCC - LATTICE SEMICONDUCTOR CORP", ticker: "LSCC" },
    { name: "BCAUY - BRILLIANCE CHINA AUTOMOTIVE HOLDINGS LTD", ticker: "BCAUY" },
    { name: "BHVN - Biohaven Pharmaceutical Holding Co Ltd.", ticker: "BHVN" },
    { name: "TFII - TFI International Inc.", ticker: "TFII" },
    { name: "SAIC - Science Applications International Corp", ticker: "SAIC" },
    { name: "ASMVY - ASM Pacific Technology Ltd.", ticker: "ASMVY" },
    { name: "SLAB - SILICON LABORATORIES INC.", ticker: "SLAB" },
    { name: "CVE - CENOVUS ENERGY INC.", ticker: "CVE" },
    { name: "TKR - TIMKEN CO", ticker: "TKR" },
    { name: "TREE - LendingTree, Inc.", ticker: "TREE" },
    { name: "PAG - PENSKE AUTOMOTIVE GROUP, INC.", ticker: "PAG" },
    { name: "VIR - Vir Biotechnology, Inc.", ticker: "VIR" },
    { name: "PHYS - Sprott Physical Gold Trust", ticker: "PHYS" },
    { name: "KNSL - Kinsale Capital Group, Inc.", ticker: "KNSL" },
    { name: "CAE - CAE INC", ticker: "CAE" },
    { name: "FANG - Diamondback Energy, Inc.", ticker: "FANG" },
    { name: "ORCC - Owl Rock Capital Corp", ticker: "ORCC" },
    { name: "PFSI - PennyMac Financial Services, Inc.", ticker: "PFSI" },
    { name: "ASH - ASHLAND GLOBAL HOLDINGS INC", ticker: "ASH" },
    { name: "ALSN - Allison Transmission Holdings Inc", ticker: "ALSN" },
    { name: "ENV - ENVESTNET, INC.", ticker: "ENV" },
    { name: "YETI - YETI Holdings, Inc.", ticker: "YETI" },
    { name: "SBNY - Signature Bank Corp", ticker: "SBNY" },
    { name: "TFSL - TFS Financial CORP", ticker: "TFSL" },
    { name: "HOG - HARLEY-DAVIDSON, INC.", ticker: "HOG" },
    { name: "FELTY - Fuji Electric Holdings Ltd", ticker: "FELTY" },
    { name: "HLI - HOULIHAN LOKEY, INC.", ticker: "HLI" },
    { name: "HCM - Hutchison China MediTech Ltd", ticker: "HCM" },
    { name: "CNCN - Chun Can Capital Group", ticker: "CNCN" },
    { name: "FOLD - AMICUS THERAPEUTICS, INC.", ticker: "FOLD" },
    { name: "SUOPY - SUMCO CORP", ticker: "SUOPY" },
    { name: "SDC - SmileDirectClub, Inc.", ticker: "SDC" },
    { name: "PVH - PVH CORP. /DE/", ticker: "PVH" },
    { name: "EVBG - EVERBRIDGE, INC.", ticker: "EVBG" },
    { name: "BLDP - Ballard Power Systems Inc.", ticker: "BLDP" },
    { name: "GIL - Gildan Activewear Inc.", ticker: "GIL" },
    { name: "MAT - MATTEL INC /DE/", ticker: "MAT" },
    { name: "VIV - TELEFONICA BRASIL S.A.", ticker: "VIV" },
    { name: "IDA - IDACORP INC", ticker: "IDA" },
    { name: "VIRT - Virtu Financial, Inc.", ticker: "VIRT" },
    { name: "API - Agora, Inc.", ticker: "API" },
    { name: "CYBR - CyberArk Software Ltd.", ticker: "CYBR" },
    { name: "DEI - Douglas Emmett Inc", ticker: "DEI" },
    { name: "SLGN - SILGAN HOLDINGS INC", ticker: "SLGN" },
    { name: "STWD - STARWOOD PROPERTY TRUST, INC.", ticker: "STWD" },
    { name: "MRCY - MERCURY SYSTEMS INC", ticker: "MRCY" },
    { name: "XRX - Xerox Holdings Corp", ticker: "XRX" },
    { name: "CFR - CULLEN/FROST BANKERS, INC.", ticker: "CFR" },
    { name: "NEP - NextEra Energy Partners, LP", ticker: "NEP" },
    { name: "MEDP - Medpace Holdings, Inc.", ticker: "MEDP" },
    { name: "TPDKY - Topdanmark AS", ticker: "TPDKY" },
    { name: "AEMMY - A2A SpA", ticker: "AEMMY" },
    { name: "FFIN - FIRST FINANCIAL BANKSHARES INC", ticker: "FFIN" },
    { name: "SNDR - Schneider National, Inc.", ticker: "SNDR" },
    { name: "NKRKY - Nokian Tyres OYJ", ticker: "NKRKY" },
    { name: "KMPR - KEMPER Corp", ticker: "KMPR" },
    { name: "FATE - FATE THERAPEUTICS INC", ticker: "FATE" },
    { name: "NVST - Envista Holdings Corp", ticker: "NVST" },
    { name: "GFSZY - G4S", ticker: "GFSZY" },
    { name: "MLLUY - Metallurgical Corp of China Ltd./ADR/", ticker: "MLLUY" },
    { name: "SSRM - SSR MINING INC.", ticker: "SSRM" },
    { name: "MAURY - MARUI CO LTD /ADR/", ticker: "MAURY" },
    { name: "BAND - Bandwidth Inc.", ticker: "BAND" },
    { name: "HALO - HALOZYME THERAPEUTICS, INC.", ticker: "HALO" },
    { name: "TRNO - Terreno Realty Corp", ticker: "TRNO" },
    { name: "SSD - Simpson Manufacturing Co., Inc.", ticker: "SSD" },
    { name: "SF - STIFEL FINANCIAL CORP", ticker: "SF" },
    { name: "FGEN - FIBROGEN INC", ticker: "FGEN" },
    { name: "NPSKY - NSK LTD /ADR/", ticker: "NPSKY" },
    { name: "PINC - Premier, Inc.", ticker: "PINC" },
    { name: "MAN - ManpowerGroup Inc.", ticker: "MAN" },
    { name: "QTS - QTS Realty Trust, Inc.", ticker: "QTS" },
    { name: "FIZZ - NATIONAL BEVERAGE CORP", ticker: "FIZZ" },
    { name: "MTH - Meritage Homes CORP", ticker: "MTH" },
    { name: "MMS - MAXIMUS, INC.", ticker: "MMS" },
    { name: "FCN - FTI CONSULTING, INC", ticker: "FCN" },
    { name: "FCNCA - FIRST CITIZENS BANCSHARES INC /DE/", ticker: "FCNCA" },
    { name: "TX - Ternium S.A.", ticker: "TX" },
    { name: "RBC - REGAL BELOIT CORP", ticker: "RBC" },
    { name: "SSB - SOUTH STATE Corp", ticker: "SSB" },
    { name: "CRUS - CIRRUS LOGIC, INC.", ticker: "CRUS" },
    { name: "GULRY - Guoco Group Ltd", ticker: "GULRY" },
    { name: "HQY - HEALTHEQUITY, INC.", ticker: "HQY" },
    { name: "IART - INTEGRA LIFESCIENCES HOLDINGS CORP", ticker: "IART" },
    { name: "CUZ - COUSINS PROPERTIES INC", ticker: "CUZ" },
    { name: "FL - FOOT LOCKER, INC.", ticker: "FL" },
    { name: "DAVA - Endava plc", ticker: "DAVA" },
    { name: "BOKF - BOK FINANCIAL CORP", ticker: "BOKF" },
    { name: "ICUI - ICU MEDICAL INC/DE", ticker: "ICUI" },
    { name: "RYN - RAYONIER INC", ticker: "RYN" },
    { name: "TV - GRUPO TELEVISA, S.A.B.", ticker: "TV" },
    { name: "NOVT - NOVANTA INC", ticker: "NOVT" },
    { name: "TWST - Twist Bioscience Corp", ticker: "TWST" },
    { name: "VAC - MARRIOTT VACATIONS WORLDWIDE Corp", ticker: "VAC" },
    { name: "KBH - KB HOME", ticker: "KBH" },
    { name: "JAMF - Jamf Holding Corp.", ticker: "JAMF" },
    { name: "ALLK - Allakos Inc.", ticker: "ALLK" },
    { name: "PPC - PILGRIMS PRIDE CORP", ticker: "PPC" },
    { name: "SEPJY - Spectris PLC/ADR", ticker: "SEPJY" },
    { name: "NXST - NEXSTAR MEDIA GROUP, INC.", ticker: "NXST" },
    { name: "GOOS - Canada Goose Holdings Inc.", ticker: "GOOS" },
    { name: "BLDR - Builders FirstSource, Inc.", ticker: "BLDR" },
    { name: "AAN - Aaron's Holdings Company, Inc.", ticker: "AAN" },
    { name: "LPSN - LIVEPERSON INC", ticker: "LPSN" },
    { name: "EME - EMCOR Group, Inc.", ticker: "EME" },
    { name: "CW - CURTISS WRIGHT CORP", ticker: "CW" },
    { name: "RAMP - LiveRamp Holdings, Inc.", ticker: "RAMP" },
    { name: "IMVT - Immunovant, Inc.", ticker: "IMVT" },
    { name: "VRNS - VARONIS SYSTEMS INC", ticker: "VRNS" },
    { name: "BRTHY - BROTHER INDUSTRIES LTD/ADR/", ticker: "BRTHY" },
    { name: "TRGP - Targa Resources Corp.", ticker: "TRGP" },
    { name: "NEU - NEWMARKET CORP", ticker: "NEU" },
    { name: "INSM - INSMED Inc", ticker: "INSM" },
    { name: "UPCHY - Uni-President China Holdings Ltd.", ticker: "UPCHY" },
    { name: "JKS - JinkoSolar Holding Co., Ltd.", ticker: "JKS" },
    { name: "LOPE - Grand Canyon Education, Inc.", ticker: "LOPE" },
    { name: "WSC - WillScot Mobile Mini Holdings Corp.", ticker: "WSC" },
    { name: "QLYS - QUALYS, INC.", ticker: "QLYS" },
    { name: "WYGPY - Worleyparsons Ltd/ADR", ticker: "WYGPY" },
    { name: "ZHUZY - Zhuzhou CRRC Times Electric Co., Ltd./ADR", ticker: "ZHUZY" },
    { name: "ITVPY - ITV PLC", ticker: "ITVPY" },
    { name: "WAL - WESTERN ALLIANCE BANCORPORATION", ticker: "WAL" },
    { name: "ESGR - Enstar Group LTD", ticker: "ESGR" },
    { name: "LAZ - Lazard Ltd", ticker: "LAZ" },
    { name: "SDGR - Schrodinger, Inc.", ticker: "SDGR" },
    { name: "EQT - EQT Corp", ticker: "EQT" },
    { name: "SEB - SEABOARD CORP /DE/", ticker: "SEB" },
    { name: "CMHHY - China Merchants Holdings International Co Ltd", ticker: "CMHHY" },
    { name: "GPK - GRAPHIC PACKAGING HOLDING CO", ticker: "GPK" },
    { name: "NYCB - NEW YORK COMMUNITY BANCORP INC", ticker: "NYCB" },
    { name: "GSHD - Goosehead Insurance, Inc.", ticker: "GSHD" },
    { name: "OGS - ONE Gas, Inc.", ticker: "OGS" },
    { name: "CSXXY - carsales.com Limited/ADR", ticker: "CSXXY" },
    { name: "RXN - Rexnord Corp", ticker: "RXN" },
    { name: "VERX - Vertex, Inc.", ticker: "VERX" },
    { name: "NFG - NATIONAL FUEL GAS CO", ticker: "NFG" },
    { name: "HKIB - AMTD International Inc.", ticker: "HKIB" },
    { name: "UNM - Unum Group", ticker: "UNM" },
    { name: "CCJ - CAMECO CORP", ticker: "CCJ" },
    { name: "EXPO - EXPONENT INC", ticker: "EXPO" },
    { name: "RNMBY - RHEINMETALL / ADR", ticker: "RNMBY" },
    { name: "FLS - FLOWSERVE CORP", ticker: "FLS" },
    { name: "WTS - WATTS WATER TECHNOLOGIES INC", ticker: "WTS" },
    { name: "EXPI - EXP World Holdings, Inc.", ticker: "EXPI" },
    { name: "AXS - AXIS CAPITAL HOLDINGS LTD", ticker: "AXS" },
    { name: "CNNE - Cannae Holdings, Inc.", ticker: "CNNE" },
    { name: "WIMHY - William Hill plc / ADR", ticker: "WIMHY" },
    { name: "IRDM - Iridium Communications Inc.", ticker: "IRDM" },
    { name: "BYD - BOYD GAMING CORP", ticker: "BYD" },
    { name: "RLI - RLI CORP", ticker: "RLI" },
    { name: "EXP - EAGLE MATERIALS INC", ticker: "EXP" },
    { name: "GO - Grocery Outlet Holding Corp.", ticker: "GO" },
    { name: "AER - AerCap Holdings N.V.", ticker: "AER" },
    { name: "TENB - Tenable Holdings, Inc.", ticker: "TENB" },
    { name: "CFX - Colfax CORP", ticker: "CFX" },
    { name: "SWX - Southwest Gas Holdings, Inc.", ticker: "SWX" },
    { name: "MSM - MSC INDUSTRIAL DIRECT CO INC", ticker: "MSM" },
    { name: "SSL - SASOL LTD", ticker: "SSL" },
    { name: "NEOG - NEOGEN CORP", ticker: "NEOG" },
    { name: "AUOTY - AU OPTRONICS CORP", ticker: "AUOTY" },
    { name: "THG - HANOVER INSURANCE GROUP, INC.", ticker: "THG" },
    { name: "SAIA - SAIA INC", ticker: "SAIA" },
    { name: "HE - HAWAIIAN ELECTRIC INDUSTRIES INC", ticker: "HE" },
    { name: "UNF - UNIFIRST CORP", ticker: "UNF" },
    { name: "ORA - ORMAT TECHNOLOGIES, INC.", ticker: "ORA" },
    { name: "ASAN - Asana, Inc.", ticker: "ASAN" },
    { name: "NEWR - NEW RELIC, INC.", ticker: "NEWR" },
    { name: "CC - Chemours Co", ticker: "CC" },
    { name: "AYI - ACUITY BRANDS INC", ticker: "AYI" },
    { name: "CEF - Sprott Physical Gold & Silver Trust", ticker: "CEF" },
    { name: "GOCO - GoHealth, Inc.", ticker: "GOCO" },
    { name: "LSPD - Lightspeed POS Inc.", ticker: "LSPD" },
    { name: "WING - Wingstop Inc.", ticker: "WING" },
    { name: "SFIX - Stitch Fix, Inc.", ticker: "SFIX" },
    { name: "UGP - ULTRAPAR HOLDINGS INC", ticker: "UGP" },
    { name: "AMG - AFFILIATED MANAGERS GROUP, INC.", ticker: "AMG" },
    { name: "SMTC - SEMTECH CORP", ticker: "SMTC" },
    { name: "PRLB - Proto Labs Inc", ticker: "PRLB" },
    { name: "DOC - Physicians Realty Trust", ticker: "DOC" },
    { name: "MZDAY - Mazda Motor Corp", ticker: "MZDAY" },
    { name: "MUSA - Murphy USA Inc.", ticker: "MUSA" },
    { name: "SNV - SYNOVUS FINANCIAL CORP", ticker: "SNV" },
    { name: "TPL - TEXAS PACIFIC LAND TRUST", ticker: "TPL" },
    { name: "PNM - PNM RESOURCES INC", ticker: "PNM" },
    { name: "ASGN - ASGN Inc", ticker: "ASGN" },
    { name: "BLUE - bluebird bio, Inc.", ticker: "BLUE" },
    { name: "SAGE - Sage Therapeutics, Inc.", ticker: "SAGE" },
    { name: "CRI - CARTERS INC", ticker: "CRI" },
    { name: "MXCHY - Orbia Advance Corporation, S.A.B. de C.V./ADR", ticker: "MXCHY" },
    { name: "WES - Western Midstream Partners, LP", ticker: "WES" },
    { name: "HLNE - Hamilton Lane INC", ticker: "HLNE" },
    { name: "DAO - Youdao, Inc.", ticker: "DAO" },
    { name: "TGTX - TG THERAPEUTICS, INC.", ticker: "TGTX" },
    { name: "BRKS - Brooks Automation, Inc.", ticker: "BRKS" },
    { name: "APA - APACHE CORP", ticker: "APA" },
    { name: "VVV - VALVOLINE INC", ticker: "VVV" },
    { name: "WWE - WORLD WRESTLING ENTERTAINMENTINC", ticker: "WWE" },
    { name: "AFFS - Amtrust Financial Services, Inc.", ticker: "AFFS" },
    { name: "VICR - VICOR CORP", ticker: "VICR" },
    { name: "MTZ - MASTEC INC", ticker: "MTZ" },
    { name: "ACIW - ACI WORLDWIDE, INC.", ticker: "ACIW" },
    { name: "NG - NOVAGOLD RESOURCES INC", ticker: "NG" },
    { name: "BKH - BLACK HILLS CORP /SD/", ticker: "BKH" },
    { name: "POWI - POWER INTEGRATIONS INC", ticker: "POWI" },
    { name: "APAM - Artisan Partners Asset Management Inc.", ticker: "APAM" },
    { name: "ETRN - Equitrans Midstream Corp", ticker: "ETRN" },
    { name: "HYLN - Hyliion Holdings Corp.", ticker: "HYLN" },
    { name: "ASR - SOUTHEAST AIRPORT GROUP", ticker: "ASR" },
    { name: "NOV - NATIONAL OILWELL VARCO INC", ticker: "NOV" },
    { name: "HAIN - HAIN CELESTIAL GROUP INC", ticker: "HAIN" },
    { name: "SLM - SLM Corp", ticker: "SLM" },
    { name: "MOR - MorphoSys AG", ticker: "MOR" },
    { name: "FTDR - frontdoor, inc.", ticker: "FTDR" },
    { name: "AL - AIR LEASE CORP", ticker: "AL" },
    { name: "MSGS - Madison Square Garden Sports Corp.", ticker: "MSGS" },
    { name: "LPX - LOUISIANA-PACIFIC CORP", ticker: "LPX" },
    { name: "CHFFY - China Everbright International Limited/ADR", ticker: "CHFFY" },
    { name: "KZMYY - Kaz Minerals Plc", ticker: "KZMYY" },
    { name: "CROX - Crocs, Inc.", ticker: "CROX" },
    { name: "LEGN - Legend Biotech Corp", ticker: "LEGN" },
    { name: "EBRPY - Ebro Puleva SA / ADR", ticker: "EBRPY" },
    { name: "RLAY - Relay Therapeutics, Inc.", ticker: "RLAY" },
    { name: "GTES - Gates Industrial Corp plc", ticker: "GTES" },
    { name: "NRZ - New Residential Investment Corp.", ticker: "NRZ" },
    { name: "ADC - AGREE REALTY CORP", ticker: "ADC" },
    { name: "UFPI - UFP INDUSTRIES INC", ticker: "UFPI" },
    { name: "KOD - Kodiak Sciences Inc.", ticker: "KOD" },
    { name: "PTCT - PTC THERAPEUTICS, INC.", ticker: "PTCT" },
    { name: "FOXF - FOX FACTORY HOLDING CORP", ticker: "FOXF" },
    { name: "KBR - KBR, INC.", ticker: "KBR" },
    { name: "ADRZY - Andritz AG", ticker: "ADRZY" },
    { name: "HRB - H&R BLOCK INC", ticker: "HRB" },
    { name: "USO - United States Oil Fund, LP", ticker: "USO" },
    { name: "MTG - MGIC INVESTMENT CORP", ticker: "MTG" },
    { name: "OMCL - OMNICELL, Inc", ticker: "OMCL" },
    { name: "KWR - QUAKER CHEMICAL CORP", ticker: "KWR" },
    { name: "STN - STANTEC INC", ticker: "STN" },
    { name: "TMHC - Taylor Morrison Home Corp", ticker: "TMHC" },
    { name: "DVN - DEVON ENERGY CORP/DE", ticker: "DVN" },
    { name: "HYPMY - Hypermarcas S.A.", ticker: "HYPMY" },
    { name: "HHC - Howard Hughes Corp", ticker: "HHC" },
    { name: "HMY - HARMONY GOLD MINING CO LTD", ticker: "HMY" },
    { name: "VRNT - VERINT SYSTEMS INC", ticker: "VRNT" },
    { name: "SEKEY - SEIKO EPSON CORP", ticker: "SEKEY" },
    { name: "SLG - SL GREEN REALTY CORP", ticker: "SLG" },
    { name: "ALTR - Altair Engineering Inc.", ticker: "ALTR" },
    { name: "VVNT - Vivint Smart Home, Inc.", ticker: "VVNT" },
    { name: "GTBIF - Green Thumb Industries Inc.", ticker: "GTBIF" },
    { name: "KURRY - Kuraray Co Ltd", ticker: "KURRY" },
    { name: "RDN - RADIAN GROUP INC", ticker: "RDN" },
    { name: "BCPC - BALCHEM CORP", ticker: "BCPC" },
    { name: "POR - PORTLAND GENERAL ELECTRIC CO /OR/", ticker: "POR" },
    { name: "RXT - Rackspace Technology, Inc.", ticker: "RXT" },
    { name: "HIW - HIGHWOODS PROPERTIES, INC.", ticker: "HIW" },
    { name: "EYE - National Vision Holdings, Inc.", ticker: "EYE" },
    { name: "JBGS - JBG SMITH Properties", ticker: "JBGS" },
    { name: "DQ - DAQO NEW ENERGY CORP.", ticker: "DQ" },
    { name: "SRC - SPIRIT REALTY CAPITAL, INC.", ticker: "SRC" },
    { name: "SAFE - Safehold Inc.", ticker: "SAFE" },
    { name: "JBLU - JETBLUE AIRWAYS CORP", ticker: "JBLU" },
    { name: "BRX - Brixmor Property Group Inc.", ticker: "BRX" },
    { name: "DCPH - Deciphera Pharmaceuticals, Inc.", ticker: "DCPH" },
    { name: "HASI - Hannon Armstrong Sustainable Infrastructure Capital, Inc.", ticker: "HASI" },
    { name: "NARI - Inari Medical, Inc.", ticker: "NARI" },
    { name: "GRP-UN - GRANITE REAL ESTATE INVESTMENT TRUST", ticker: "GRP-UN" },
    { name: "MALRY - Mineral Resources Limited/ADR", ticker: "MALRY" },
    { name: "IRDEY - Iren S.p.A./ADR", ticker: "IRDEY" },
    { name: "GBCI - GLACIER BANCORP, INC.", ticker: "GBCI" },
    { name: "LMND - Lemonade, Inc.", ticker: "LMND" },
    { name: "NVT - nVent Electric plc", ticker: "NVT" },
    { name: "PSN - PARSONS CORP", ticker: "PSN" },
    { name: "BPOP - POPULAR INC", ticker: "BPOP" },
    { name: "TEO - TELECOM ARGENTINA SA", ticker: "TEO" },
    { name: "FTI - TechnipFMC plc", ticker: "FTI" },
    { name: "CCOHY - China State Construction International Holdings Limited/ADR", ticker: "CCOHY" },
    { name: "JCOM - J2 GLOBAL, INC.", ticker: "JCOM" },
    { name: "CPRI - Capri Holdings Ltd", ticker: "CPRI" },
    { name: "INSP - Inspire Medical Systems, Inc.", ticker: "INSP" },
    { name: "RPD - Rapid7, Inc.", ticker: "RPD" },
    { name: "SVMK - SVMK Inc.", ticker: "SVMK" },
    { name: "MRO - MARATHON OIL CORP", ticker: "MRO" },
    { name: "STAA - STAAR SURGICAL CO", ticker: "STAA" },
    { name: "VNET - 21Vianet Group, Inc.", ticker: "VNET" },
    { name: "TIGO - MILLICOM INTERNATIONAL CELLULAR SA", ticker: "TIGO" },
    { name: "BXMT - BLACKSTONE MORTGAGE TRUST, INC.", ticker: "BXMT" },
    { name: "KSS - KOHLS Corp", ticker: "KSS" },
    { name: "AGI - ALAMOS GOLD INC", ticker: "AGI" },
    { name: "DIOD - DIODES INC /DEL/", ticker: "DIOD" },
    { name: "CLH - CLEAN HARBORS INC", ticker: "CLH" },
    { name: "AWI - ARMSTRONG WORLD INDUSTRIES INC", ticker: "AWI" },
    { name: "SGMS - SCIENTIFIC GAMES CORP", ticker: "SGMS" },
    { name: "GDOT - GREEN DOT CORP", ticker: "GDOT" },
    { name: "CBD - BRAZILIAN DISTRIBUTION CO COMPANHIA BRASILEIRA DE DISTR CBD", ticker: "CBD" },
    { name: "BAK - BRASKEM SA", ticker: "BAK" },
    { name: "BVN - BUENAVENTURA MINING CO INC", ticker: "BVN" },
    { name: "CR - CRANE CO /DE/", ticker: "CR" },
    { name: "IBP - Installed Building Products, Inc.", ticker: "IBP" },
    { name: "AAON - AAON, INC.", ticker: "AAON" },
    { name: "EQC - Equity Commonwealth", ticker: "EQC" },
    { name: "ZTO - ZTO Express (Cayman) Inc.", ticker: "ZTO" },
    { name: "THKLY - THK Co., Ltd.", ticker: "THKLY" },
    { name: "UBSI - UNITED BANKSHARES INC/WV", ticker: "UBSI" },
    { name: "LGIH - LGI Homes, Inc.", ticker: "LGIH" },
    { name: "HPP - Hudson Pacific Properties, Inc.", ticker: "HPP" },
    { name: "HFC - HollyFrontier Corp", ticker: "HFC" },
    { name: "AB - ALLIANCEBERNSTEIN HOLDING L.P.", ticker: "AB" },
    { name: "AMKR - AMKOR TECHNOLOGY, INC.", ticker: "AMKR" },
    { name: "APPS - Digital Turbine, Inc.", ticker: "APPS" },
    { name: "ENS - EnerSys", ticker: "ENS" },
    { name: "FEYE - FireEye, Inc.", ticker: "FEYE" },
    { name: "EVR - Evercore Inc.", ticker: "EVR" },
    { name: "ROLL - RBC Bearings INC", ticker: "ROLL" },
    { name: "BBBY - BED BATH & BEYOND INC", ticker: "BBBY" },
    { name: "LPRO - Open Lending Corp", ticker: "LPRO" },
    { name: "MDC - M.D.C. HOLDINGS, INC.", ticker: "MDC" },
    { name: "PCH - POTLATCHDELTIC CORP", ticker: "PCH" },
    { name: "AMN - AMN HEALTHCARE SERVICES INC", ticker: "AMN" },
    { name: "ENSG - ENSIGN GROUP, INC", ticker: "ENSG" },
    { name: "CLF - CLEVELAND-CLIFFS INC.", ticker: "CLF" },
    { name: "AM - Antero Midstream Corp", ticker: "AM" },
    { name: "ROYMY - Royal Mail plc/ADR", ticker: "ROYMY" },
    { name: "WNS - WNS (HOLDINGS) LTD", ticker: "WNS" },
    { name: "UNVR - Univar Solutions Inc.", ticker: "UNVR" },
    { name: "SIGI - SELECTIVE INSURANCE GROUP INC", ticker: "SIGI" },
    { name: "CIG - ENERGY CO OF MINAS GERAIS", ticker: "CIG" },
    { name: "VLY - VALLEY NATIONAL BANCORP", ticker: "VLY" },
    { name: "GRA - W R GRACE & CO", ticker: "GRA" },
    { name: "GTLS - CHART INDUSTRIES INC", ticker: "GTLS" },
    { name: "SLQT - SelectQuote, Inc.", ticker: "SLQT" },
    { name: "NKTR - NEKTAR THERAPEUTICS", ticker: "NKTR" },
    { name: "ESI - Element Solutions Inc", ticker: "ESI" },
    { name: "PNFP - PINNACLE FINANCIAL PARTNERS INC", ticker: "PNFP" },
    { name: "CBU - COMMUNITY BANK SYSTEM, INC.", ticker: "CBU" },
    { name: "QRTEA - Qurate Retail, Inc.", ticker: "QRTEA" },
    { name: "OSTK - OVERSTOCK.COM, INC", ticker: "OSTK" },
    { name: "DNP - DNP SELECT INCOME FUND INC", ticker: "DNP" },
    { name: "TRUP - TRUPANION, INC.", ticker: "TRUP" },
    { name: "AY - Atlantica Sustainable Infrastructure plc", ticker: "AY" },
    { name: "SPSC - SPS COMMERCE INC", ticker: "SPSC" },
    { name: "SEM - SELECT MEDICAL HOLDINGS CORP", ticker: "SEM" },
    { name: "LCII - LCI INDUSTRIES", ticker: "LCII" },
    { name: "THC - TENET HEALTHCARE CORP", ticker: "THC" },
    { name: "SPWR - SUNPOWER CORP", ticker: "SPWR" },
    { name: "KRNT - Kornit Digital Ltd.", ticker: "KRNT" },
    { name: "BHF - Brighthouse Financial, Inc.", ticker: "BHF" },
    { name: "APNHY - Aspen Pharmacare Holdings Ltd / ADR", ticker: "APNHY" },
    { name: "EQX - Equinox Gold Corp.", ticker: "EQX" },
    { name: "OPK - OPKO HEALTH, INC.", ticker: "OPK" },
    { name: "MOMO - Momo Inc.", ticker: "MOMO" },
    { name: "SR - SPIRE INC", ticker: "SR" },
    { name: "AJRD - AEROJET ROCKETDYNE HOLDINGS, INC.", ticker: "AJRD" },
    { name: "ALRM - Alarm.com Holdings, Inc.", ticker: "ALRM" },
    { name: "MEGGY - Meggitt PLC", ticker: "MEGGY" },
    { name: "ELP - ENERGY CO OF PARANA", ticker: "ELP" },
    { name: "DORM - Dorman Products, Inc.", ticker: "DORM" },
    { name: "VMI - VALMONT INDUSTRIES INC", ticker: "VMI" },
    { name: "ACHC - Acadia Healthcare Company, Inc.", ticker: "ACHC" },
    { name: "AVNT - AVIENT CORP", ticker: "AVNT" },
    { name: "LXP - LEXINGTON REALTY TRUST", ticker: "LXP" },
    { name: "WYND - Wyndham Destinations, Inc.", ticker: "WYND" },
    { name: "CWST - CASELLA WASTE SYSTEMS INC", ticker: "CWST" },
    { name: "VIAV - VIAVI SOLUTIONS INC.", ticker: "VIAV" },
    { name: "FELE - FRANKLIN ELECTRIC CO INC", ticker: "FELE" },
    { name: "BLKB - BLACKBAUD INC", ticker: "BLKB" },
    { name: "LAUR - LAUREATE EDUCATION, INC.", ticker: "LAUR" },
    { name: "SXT - SENSIENT TECHNOLOGIES CORP", ticker: "SXT" },
    { name: "NSP - INSPERITY, INC.", ticker: "NSP" },
    { name: "OZK - Bank OZK", ticker: "OZK" },
    { name: "WERN - WERNER ENTERPRISES INC", ticker: "WERN" },
    { name: "IMAB - I-Mab", ticker: "IMAB" },
    { name: "HXL - HEXCEL CORP /DE/", ticker: "HXL" },
    { name: "KMT - KENNAMETAL INC", ticker: "KMT" },
    { name: "BNR - Burning Rock Biotech Ltd", ticker: "BNR" },
    { name: "CBRL - CRACKER BARREL OLD COUNTRY STORE, INC", ticker: "CBRL" },
    { name: "SBRA - Sabra Health Care REIT, Inc.", ticker: "SBRA" },
    { name: "BJCHY - Beijing Capital International Airport Co / ADR", ticker: "BJCHY" },
    { name: "SWTX - SpringWorks Therapeutics, Inc.", ticker: "SWTX" },
    { name: "SHAK - Shake Shack Inc.", ticker: "SHAK" },
    { name: "GMELY - GOME Retail Holdings Limited/ADR", ticker: "GMELY" },
    { name: "PBSFY - PROSIEBENSAT.1 MEDIA SE/ADR", ticker: "PBSFY" },
    { name: "ITRI - ITRON, INC.", ticker: "ITRI" },
    { name: "AWR - AMERICAN STATES WATER CO", ticker: "AWR" },
    { name: "BB - BLACKBERRY Ltd", ticker: "BB" },
    { name: "MCRB - Seres Therapeutics, Inc.", ticker: "MCRB" },
    { name: "ENR - ENERGIZER HOLDINGS, INC.", ticker: "ENR" },
    { name: "RVMD - Revolution Medicines, Inc.", ticker: "RVMD" },
    { name: "NHNKY - Nihon Kohden Corporation/ADR", ticker: "NHNKY" },
    { name: "WTM - WHITE MOUNTAINS INSURANCE GROUP LTD", ticker: "WTM" },
    { name: "WTFC - WINTRUST FINANCIAL CORP", ticker: "WTFC" },
    { name: "JBT - John Bean Technologies CORP", ticker: "JBT" },
    { name: "MIME - Mimecast Ltd", ticker: "MIME" },
    { name: "NCR - NCR CORP", ticker: "NCR" },
    { name: "CNS - COHEN & STEERS, INC.", ticker: "CNS" },
    { name: "IIPR - INNOVATIVE INDUSTRIAL PROPERTIES INC", ticker: "IIPR" },
    { name: "NUS - NU SKIN ENTERPRISES, INC.", ticker: "NUS" },
    { name: "OLN - OLIN Corp", ticker: "OLN" },
    { name: "AEIS - ADVANCED ENERGY INDUSTRIES INC", ticker: "AEIS" },
    { name: "CCOI - COGENT COMMUNICATIONS HOLDINGS, INC.", ticker: "CCOI" },
    { name: "ZNKKY - ZENKOKU HOSHO Co., Ltd./ADR", ticker: "ZNKKY" },
    { name: "SYNA - SYNAPTICS Inc", ticker: "SYNA" },
    { name: "AVT - AVNET INC", ticker: "AVT" },
    { name: "CWH - Camping World Holdings, Inc.", ticker: "CWH" },
    { name: "HL - HECLA MINING CO/DE/", ticker: "HL" },
    { name: "ALE - ALLETE INC", ticker: "ALE" },
    { name: "JTEKY - JTEKT Corp", ticker: "JTEKY" },
    { name: "UMBF - UMB FINANCIAL CORP", ticker: "UMBF" },
    { name: "SVNBY - Seven Bank Ltd / ADR", ticker: "SVNBY" },
    { name: "NJR - NEW JERSEY RESOURCES CORP", ticker: "NJR" },
    { name: "TTEC - TTEC Holdings, Inc.", ticker: "TTEC" },
    { name: "YUEIY - Yue Yuen Industrial (Holdings) Ltd.", ticker: "YUEIY" },
    { name: "WOR - WORTHINGTON INDUSTRIES INC", ticker: "WOR" },
    { name: "R - RYDER SYSTEM INC", ticker: "R" },
    { name: "WK - WORKIVA INC", ticker: "WK" },
    { name: "HOMB - HOME BANCSHARES INC", ticker: "HOMB" },
    { name: "WDFC - WD 40 CO", ticker: "WDFC" },
    { name: "MSLOY - Mitsui OSK Lines Ltd", ticker: "MSLOY" },
    { name: "OFC - CORPORATE OFFICE PROPERTIES TRUST", ticker: "OFC" },
    { name: "ALKS - Alkermes plc.", ticker: "ALKS" },
    { name: "IRBT - IROBOT CORP", ticker: "IRBT" },
    { name: "BBAVY - BBA AVIATION PLC", ticker: "BBAVY" },
    { name: "BRFS - BRF S.A.", ticker: "BRFS" },
    { name: "AILIH - Ameren Illinois Co", ticker: "AILIH" },
    { name: "CIGI - Colliers International Group Inc.", ticker: "CIGI" },
    { name: "BZUN - Baozun Inc.", ticker: "BZUN" },
    { name: "SPB - Spectrum Brands Holdings, Inc.", ticker: "SPB" },
    { name: "TGNA - TEGNA INC", ticker: "TGNA" },
    { name: "TRIP - TripAdvisor, Inc.", ticker: "TRIP" },
    { name: "AXSM - Axsome Therapeutics, Inc.", ticker: "AXSM" },
    { name: "PZZA - PAPA JOHNS INTERNATIONAL INC", ticker: "PZZA" },
    { name: "MTLS - MATERIALISE NV", ticker: "MTLS" },
    { name: "NOVA - Sunnova Energy International Inc.", ticker: "NOVA" },
    { name: "AZIHY - Azimut Holding SpA/ADR", ticker: "AZIHY" },
    { name: "LIVN - LivaNova PLC", ticker: "LIVN" },
    { name: "MMSI - MERIT MEDICAL SYSTEMS INC", ticker: "MMSI" },
    { name: "WBS - WEBSTER FINANCIAL CORP", ticker: "WBS" },
    { name: "PACB - PACIFIC BIOSCIENCES OF CALIFORNIA, INC.", ticker: "PACB" },
    { name: "CSIQ - Canadian Solar Inc.", ticker: "CSIQ" },
    { name: "BIPC - Brookfield Infrastructure Corp", ticker: "BIPC" },
    { name: "NNI - NELNET INC", ticker: "NNI" },
    { name: "USM - UNITED STATES CELLULAR CORP", ticker: "USM" },
    { name: "SCL - STEPAN CO", ticker: "SCL" },
    { name: "ARNC - Arconic Corp", ticker: "ARNC" },
    { name: "PJT - PJT Partners Inc.", ticker: "PJT" },
    { name: "CWK - Cushman & Wakefield plc", ticker: "CWK" },
    { name: "CNO - CNO Financial Group, Inc.", ticker: "CNO" },
    { name: "NWE - NORTHWESTERN CORP", ticker: "NWE" },
    { name: "GOLF - Acushnet Holdings Corp.", ticker: "GOLF" },
    { name: "SATS - EchoStar CORP", ticker: "SATS" },
    { name: "EVTC - EVERTEC, Inc.", ticker: "EVTC" },
    { name: "BBU - Brookfield Business Partners L.P.", ticker: "BBU" },
    { name: "FHI - FEDERATED HERMES, INC.", ticker: "FHI" },
    { name: "TRTN - Triton International Ltd", ticker: "TRTN" },
    { name: "APG - APi Group Corp", ticker: "APG" },
    { name: "OPCH - Option Care Health, Inc.", ticker: "OPCH" },
    { name: "VSH - VISHAY INTERTECHNOLOGY INC", ticker: "VSH" },
    { name: "STEP - StepStone Group Inc.", ticker: "STEP" },
    { name: "PDCO - PATTERSON COMPANIES, INC.", ticker: "PDCO" },
    { name: "FUL - FULLER H B CO", ticker: "FUL" },
    { name: "KTOS - KRATOS DEFENSE & SECURITY SOLUTIONS, INC.", ticker: "KTOS" },
    { name: "NHI - NATIONAL HEALTH INVESTORS INC", ticker: "NHI" },
    { name: "TRN - TRINITY INDUSTRIES INC", ticker: "TRN" },
    { name: "APLS - Apellis Pharmaceuticals, Inc.", ticker: "APLS" },
    { name: "PRE-PF - PARTNERRE LTD", ticker: "PRE-PF" },
    { name: "CAR - AVIS BUDGET GROUP, INC.", ticker: "CAR" },
    { name: "EXLS - ExlService Holdings, Inc.", ticker: "EXLS" },
    { name: "BOX - BOX INC", ticker: "BOX" },
    { name: "SWAV - Shockwave Medical, Inc.", ticker: "SWAV" },
    { name: "FCFS - FIRSTCASH, INC", ticker: "FCFS" },
    { name: "DOOR - MASONITE INTERNATIONAL CORP", ticker: "DOOR" },
    { name: "SFM - Sprouts Farmers Market, Inc.", ticker: "SFM" },
    { name: "TJBH - Tengjun Biotechnology Corp.", ticker: "TJBH" },
    { name: "CDNA - CareDx, Inc.", ticker: "CDNA" },
    { name: "SFRGY - Salvatore Ferragamo S.p.A./ADR", ticker: "SFRGY" },
    { name: "SPT - Sprout Social, Inc.", ticker: "SPT" },
    { name: "PTVE - Pactiv Evergreen Inc.", ticker: "PTVE" },
    { name: "GKOS - GLAUKOS Corp", ticker: "GKOS" },
    { name: "TWOU - 2U, Inc.", ticker: "TWOU" },
    { name: "CMC - COMMERCIAL METALS Co", ticker: "CMC" },
    { name: "VLDR - Velodyne Lidar, Inc.", ticker: "VLDR" },
    { name: "NGVT - Ingevity Corp", ticker: "NGVT" },
    { name: "BE - Bloom Energy Corp", ticker: "BE" },
    { name: "AEL - AMERICAN EQUITY INVESTMENT LIFE HOLDING CO", ticker: "AEL" },
    { name: "OVV - Ovintiv Inc.", ticker: "OVV" },
    { name: "COTY - COTY INC.", ticker: "COTY" },
    { name: "UPWK - Upwork Inc.", ticker: "UPWK" },
    { name: "ADS - ALLIANCE DATA SYSTEMS CORP", ticker: "ADS" },
    { name: "WKHS - Workhorse Group Inc.", ticker: "WKHS" },
    { name: "AGIO - AGIOS PHARMACEUTICALS, INC.", ticker: "AGIO" },
    { name: "TPH - TRI Pointe Group, Inc.", ticker: "TPH" },
    { name: "JJSF - J&J SNACK FOODS CORP", ticker: "JJSF" },
    { name: "JELD - JELD-WEN Holding, Inc.", ticker: "JELD" },
    { name: "BECN - BEACON ROOFING SUPPLY INC", ticker: "BECN" },
    { name: "AIT - APPLIED INDUSTRIAL TECHNOLOGIES INC", ticker: "AIT" },
    { name: "MTSI - MACOM Technology Solutions Holdings, Inc.", ticker: "MTSI" },
    { name: "VC - VISTEON CORP", ticker: "VC" },
    { name: "FNB - FNB CORP/PA/", ticker: "FNB" },
    { name: "GATX - GATX CORP", ticker: "GATX" },
    { name: "MGEE - MGE ENERGY INC", ticker: "MGEE" },
    { name: "CVBF - CVB FINANCIAL CORP", ticker: "CVBF" },
    { name: "KEX - KIRBY CORP", ticker: "KEX" },
    { name: "HRMY - Harmony Biosciences Holdings, Inc.", ticker: "HRMY" },
    { name: "AHCO - AdaptHealth Corp.", ticker: "AHCO" },
    { name: "EBC - Eastern Bankshares, Inc.", ticker: "EBC" },
    { name: "PD - PagerDuty, Inc.", ticker: "PD" },
    { name: "NIU - Niu Technologies", ticker: "NIU" },
    { name: "AA - Alcoa Corp", ticker: "AA" },
    { name: "PCVX - Vaxcyte, Inc.", ticker: "PCVX" },
    { name: "SDIPF - Frasers Group plc/ADR", ticker: "SDIPF" },
    { name: "ASCCY - ASICS Corporation/ADR", ticker: "ASCCY" },
    { name: "CNMD - CONMED CORP", ticker: "CNMD" },
    { name: "STRA - Strategic Education, Inc.", ticker: "STRA" },
    { name: "PGNY - Progyny, Inc.", ticker: "PGNY" },
    { name: "XNCR - Xencor Inc", ticker: "XNCR" },
    { name: "UNIT - Uniti Group Inc.", ticker: "UNIT" },
    { name: "WWW - WOLVERINE WORLD WIDE INC /DE/", ticker: "WWW" },
    { name: "AG - FIRST MAJESTIC SILVER CORP", ticker: "AG" },
    { name: "VSAT - VIASAT INC", ticker: "VSAT" },
    { name: "VCYT - VERACYTE, INC.", ticker: "VCYT" },
    { name: "CARG - CarGurus, Inc.", ticker: "CARG" },
    { name: "ACA - Arcosa, Inc.", ticker: "ACA" },
    { name: "HI - Hillenbrand, Inc.", ticker: "HI" },
    { name: "BCO - BRINKS CO", ticker: "BCO" },
    { name: "ONB - OLD NATIONAL BANCORP /IN/", ticker: "ONB" },
    { name: "GPI - GROUP 1 AUTOMOTIVE INC", ticker: "GPI" },
    { name: "COKE - Coca-Cola Consolidated, Inc.", ticker: "COKE" },
    { name: "FN - Fabrinet", ticker: "FN" },
    { name: "PK - Park Hotels & Resorts Inc.", ticker: "PK" },
    { name: "AFYA - Afya Ltd", ticker: "AFYA" },
    { name: "FNMA - FEDERAL NATIONAL MORTGAGE ASSOCIATION FANNIE MAE", ticker: "FNMA" },
    { name: "EGO - ELDORADO GOLD CORP /FI", ticker: "EGO" },
    { name: "GBTC - Grayscale Bitcoin Trust (BTC)", ticker: "GBTC" },
    { name: "AEO - AMERICAN EAGLE OUTFITTERS INC", ticker: "AEO" },
    { name: "ANIOY - Acerinox SA", ticker: "ANIOY" },
    { name: "BXS - BancorpSouth Bank", ticker: "BXS" },
    { name: "CNX - CNX Resources Corp", ticker: "CNX" },
    { name: "PPBI - PACIFIC PREMIER BANCORP INC", ticker: "PPBI" },
    { name: "REGI - Renewable Energy Group, Inc.", ticker: "REGI" },
    { name: "ABG - ASBURY AUTOMOTIVE GROUP INC", ticker: "ABG" },
    { name: "CBT - CABOT CORP", ticker: "CBT" },
    { name: "FIBK - FIRST INTERSTATE BANCSYSTEM INC", ticker: "FIBK" },
    { name: "TDC - TERADATA CORP /DE/", ticker: "TDC" },
    { name: "NSA - National Storage Affiliates Trust", ticker: "NSA" },
    { name: "WCC - WESCO INTERNATIONAL INC", ticker: "WCC" },
    { name: "GT - GOODYEAR TIRE & RUBBER CO /OH/", ticker: "GT" },
    { name: "VEON - VEON Ltd.", ticker: "VEON" },
    { name: "BKU - BankUnited, Inc.", ticker: "BKU" },
    { name: "APLE - Apple Hospitality REIT, Inc.", ticker: "APLE" },
    { name: "BOH - BANK OF HAWAII CORP", ticker: "BOH" },
    { name: "PLMR - Palomar Holdings, Inc.", ticker: "PLMR" },
    { name: "CWT - CALIFORNIA WATER SERVICE GROUP", ticker: "CWT" },
    { name: "TARO - TARO PHARMACEUTICAL INDUSTRIES LTD", ticker: "TARO" },
    { name: "BMI - BADGER METER INC", ticker: "BMI" },
    { name: "ESE - ESCO TECHNOLOGIES INC", ticker: "ESE" },
    { name: "PCRX - Pacira BioSciences, Inc.", ticker: "PCRX" },
    { name: "RHP - Ryman Hospitality Properties, Inc.", ticker: "RHP" },
    { name: "SPXC - SPX CORP", ticker: "SPXC" },
    { name: "ABM - ABM INDUSTRIES INC /DE/", ticker: "ABM" },
    { name: "FORM - FORMFACTOR INC", ticker: "FORM" },
    { name: "THS - TreeHouse Foods, Inc.", ticker: "THS" },
    { name: "CCU - UNITED BREWERIES CO INC", ticker: "CCU" },
    { name: "MCY - MERCURY GENERAL CORP", ticker: "MCY" },
    { name: "COOP - Mr. Cooper Group Inc.", ticker: "COOP" },
    { name: "PRMW - Primo Water Corp /CN/", ticker: "PRMW" },
    { name: "SSTK - Shutterstock, Inc.", ticker: "SSTK" },
    { name: "TUIFY - TUI AG", ticker: "TUIFY" },
    { name: "RRC - RANGE RESOURCES CORP", ticker: "RRC" },
    { name: "SUM - Summit Materials, Inc.", ticker: "SUM" },
    { name: "AVA - AVISTA CORP", ticker: "AVA" },
    { name: "SHEN - SHENANDOAH TELECOMMUNICATIONS CO/VA/", ticker: "SHEN" },
    { name: "MEOH - METHANEX CORP", ticker: "MEOH" },
    { name: "GSH - GUANGSHEN RAILWAY CO LTD", ticker: "GSH" },
    { name: "URBN - URBAN OUTFITTERS INC", ticker: "URBN" },
    { name: "PACW - PACWEST BANCORP", ticker: "PACW" },
    { name: "AGO - ASSURED GUARANTY LTD", ticker: "AGO" },
    { name: "PSMT - PRICESMART INC", ticker: "PSMT" },
    { name: "JGCCY - JGC Corp", ticker: "JGCCY" },
    { name: "CPA - Copa Holdings, S.A.", ticker: "CPA" },
    { name: "GBDC - GOLUB CAPITAL BDC, Inc.", ticker: "GBDC" },
    { name: "MANU - Manchester United plc", ticker: "MANU" },
    { name: "RRR - Red Rock Resorts, Inc.", ticker: "RRR" },
    { name: "MATX - Matson, Inc.", ticker: "MATX" },
    { name: "NINOY - Nikon Corp", ticker: "NINOY" },
    { name: "ROCK - GIBRALTAR INDUSTRIES, INC.", ticker: "ROCK" },
    { name: "ALGT - Allegiant Travel CO", ticker: "ALGT" },
    { name: "NSIT - INSIGHT ENTERPRISES INC", ticker: "NSIT" },
    { name: "SABR - Sabre Corp", ticker: "SABR" },
    { name: "ROG - ROGERS CORP", ticker: "ROG" },
    { name: "DAN - DANA INC", ticker: "DAN" },
    { name: "CMPR - CIMPRESS plc", ticker: "CMPR" },
    { name: "CDLX - Cardlytics, Inc.", ticker: "CDLX" },
    { name: "EHTH - eHealth, Inc.", ticker: "EHTH" },
    { name: "GEF - GREIF, INC", ticker: "GEF" },
    { name: "SRNE - Sorrento Therapeutics, Inc.", ticker: "SRNE" },
    { name: "ADCT - ADC Therapeutics SA", ticker: "ADCT" },
    { name: "DY - DYCOM INDUSTRIES INC", ticker: "DY" },
    { name: "GNW - GENWORTH FINANCIAL INC", ticker: "GNW" },
    { name: "MOG-A - MOOG INC.", ticker: "MOG-A" },
    { name: "IGT - International Game Technology PLC", ticker: "IGT" },
    { name: "YEXT - Yext, Inc.", ticker: "YEXT" },
    { name: "UTZ - Utz Brands, Inc.", ticker: "UTZ" },
    { name: "SILK - Silk Road Medical Inc", ticker: "SILK" },
    { name: "ITGR - Integer Holdings Corp", ticker: "ITGR" },
    { name: "IBTX - Independent Bank Group, Inc.", ticker: "IBTX" },
    { name: "TSEM - TOWER SEMICONDUCTOR LTD", ticker: "TSEM" },
    { name: "CRNC - Cerence Inc.", ticker: "CRNC" },
    { name: "BRP - BRP Group, Inc.", ticker: "BRP" },
    { name: "CMP - COMPASS MINERALS INTERNATIONAL INC", ticker: "CMP" },
    { name: "IIJIY - INTERNET INITIATIVE JAPAN INC", ticker: "IIJIY" },
    { name: "PLXS - PLEXUS CORP", ticker: "PLXS" },
    { name: "CRSR - Corsair Gaming, Inc.", ticker: "CRSR" },
    { name: "ASB - ASSOCIATED BANC-CORP", ticker: "ASB" },
    { name: "EAT - BRINKER INTERNATIONAL, INC", ticker: "EAT" },
    { name: "SFBS - ServisFirst Bancshares, Inc.", ticker: "SFBS" },
    { name: "BRC - BRADY CORP", ticker: "BRC" },
    { name: "MC - Moelis & Co", ticker: "MC" },
    { name: "CENT - CENTRAL GARDEN & PET CO", ticker: "CENT" },
    { name: "NAVG - NAVIGATORS GROUP INC", ticker: "NAVG" },
    { name: "IGMS - IGM Biosciences, Inc.", ticker: "IGMS" },
    { name: "BIG - BIG LOTS INC", ticker: "BIG" },
    { name: "SUN - Sunoco LP", ticker: "SUN" },
    { name: "EDIT - Editas Medicine, Inc.", ticker: "EDIT" },
    { name: "SPR - Spirit AeroSystems Holdings, Inc.", ticker: "SPR" },
    { name: "ADNT - Adient plc", ticker: "ADNT" },
    { name: "GHC - Graham Holdings Co", ticker: "GHC" },
    { name: "CORT - CORCEPT THERAPEUTICS INC", ticker: "CORT" },
    { name: "GGAL - GRUPO FINANCIERO GALICIA SA", ticker: "GGAL" },
    { name: "FHB - FIRST HAWAIIAN, INC.", ticker: "FHB" },
    { name: "MLHR - HERMAN MILLER INC", ticker: "MLHR" },
    { name: "WGO - WINNEBAGO INDUSTRIES INC", ticker: "WGO" },
    { name: "ITCI - Intra-Cellular Therapies, Inc.", ticker: "ITCI" },
    { name: "AMRC - Ameresco, Inc.", ticker: "AMRC" },
    { name: "LILA - Liberty Latin America Ltd.", ticker: "LILA" },
    { name: "JACK - JACK IN THE BOX INC /NEW/", ticker: "JACK" },
    { name: "FIX - COMFORT SYSTEMS USA INC", ticker: "FIX" },
    { name: "TR - TOOTSIE ROLL INDUSTRIES INC", ticker: "TR" },
    { name: "KRTX - Karuna Therapeutics, Inc.", ticker: "KRTX" },
    { name: "NMIH - NMI Holdings, Inc.", ticker: "NMIH" },
    { name: "B - BARNES GROUP INC", ticker: "B" },
    { name: "DPUKY - Domino's Pizza UK & IRL plc/ADR", ticker: "DPUKY" },
    { name: "KW - Kennedy-Wilson Holdings, Inc.", ticker: "KW" },
    { name: "SJI - SOUTH JERSEY INDUSTRIES INC", ticker: "SJI" },
    { name: "OUT - OUTFRONT Media Inc.", ticker: "OUT" },
    { name: "SMPL - Simply Good Foods Co", ticker: "SMPL" },
    { name: "HTH - Hilltop Holdings Inc.", ticker: "HTH" },
    { name: "CRON - Cronos Group Inc.", ticker: "CRON" },
    { name: "MMYT - MakeMyTrip Ltd", ticker: "MMYT" },
    { name: "KAR - KAR Auction Services, Inc.", ticker: "KAR" },
    { name: "ZYME - Zymeworks Inc.", ticker: "ZYME" },
    { name: "UEHPY - ULTRA ELECTRONICS HOLDINGS PLC", ticker: "UEHPY" },
    { name: "MTX - MINERALS TECHNOLOGIES INC", ticker: "MTX" },
    { name: "M - Macy's, Inc.", ticker: "M" },
    { name: "CIM - CHIMERA INVESTMENT CORP", ticker: "CIM" },
    { name: "MAIN - Main Street Capital CORP", ticker: "MAIN" },
    { name: "AMBA - AMBARELLA INC", ticker: "AMBA" },
    { name: "OR - Osisko Gold Royalties LTD", ticker: "OR" },
    { name: "EPRT - ESSENTIAL PROPERTIES REALTY TRUST, INC.", ticker: "EPRT" },
    { name: "COMM - CommScope Holding Company, Inc.", ticker: "COMM" },
    { name: "OMAB - Central North Airport Group", ticker: "OMAB" },
    { name: "MDGL - MADRIGAL PHARMACEUTICALS, INC.", ticker: "MDGL" },
    { name: "X - UNITED STATES STEEL CORP", ticker: "X" },
    { name: "AUB - Atlantic Union Bankshares Corp", ticker: "AUB" },
    { name: "ELY - CALLAWAY GOLF CO", ticker: "ELY" },
    { name: "PSEC - PROSPECT CAPITAL CORP", ticker: "PSEC" },
    { name: "CVLT - COMMVAULT SYSTEMS INC", ticker: "CVLT" },
    { name: "RUSHA - RUSH ENTERPRISES INC TX", ticker: "RUSHA" },
    { name: "JWN - NORDSTROM INC", ticker: "JWN" },
    { name: "HWC - HANCOCK WHITNEY CORP", ticker: "HWC" },
    { name: "BPOSY - bpost SA/NV/ADR", ticker: "BPOSY" },
    { name: "ACCD - Accolade, Inc.", ticker: "ACCD" },
    { name: "AUPH - Aurinia Pharmaceuticals Inc.", ticker: "AUPH" },
    { name: "AOZOY - AOZORA BANK LTD", ticker: "AOZOY" },
    { name: "FSK - FS KKR Capital Corp", ticker: "FSK" },
    { name: "NAVI - NAVIENT CORP", ticker: "NAVI" },
    { name: "CDE - Coeur Mining, Inc.", ticker: "CDE" },
    { name: "QNTQY - QINETIQ GROUP PLC", ticker: "QNTQY" },
    { name: "FCPT - Four Corners Property Trust, Inc.", ticker: "FCPT" },
    { name: "TDS - TELEPHONE & DATA SYSTEMS INC /DE/", ticker: "TDS" },
    { name: "OM - Outset Medical, Inc.", ticker: "OM" },
    { name: "HGV - Hilton Grand Vacations Inc.", ticker: "HGV" },
    { name: "AMRN - AMARIN CORP PLC\\UK", ticker: "AMRN" },
    { name: "OMI - OWENS & MINOR INC/VA/", ticker: "OMI" },
    { name: "COLB - COLUMBIA BANKING SYSTEM, INC.", ticker: "COLB" },
    { name: "TCBI - TEXAS CAPITAL BANCSHARES INC/TX", ticker: "TCBI" },
    { name: "FSS - FEDERAL SIGNAL CORP /DE/", ticker: "FSS" },
    { name: "CIOXY - Cielo S.A.", ticker: "CIOXY" },
    { name: "ABCB - Ameris Bancorp", ticker: "ABCB" },
    { name: "CALM - CAL-MAINE FOODS INC", ticker: "CALM" },
    { name: "EAF - GRAFTECH INTERNATIONAL LTD", ticker: "EAF" },
    { name: "ANAT - American National Group Inc", ticker: "ANAT" },
    { name: "WD - Walker & Dunlop, Inc.", ticker: "WD" },
    { name: "CATY - CATHAY GENERAL BANCORP", ticker: "CATY" },
    { name: "AXNX - Axonics Modulation Technologies, Inc.", ticker: "AXNX" },
    { name: "SHOO - STEVEN MADDEN, LTD.", ticker: "SHOO" },
    { name: "BNDSY - Banco de Sabadell SA", ticker: "BNDSY" },
    { name: "INO - INOVIO PHARMACEUTICALS, INC.", ticker: "INO" },
    { name: "ESRT - Empire State Realty Trust, Inc.", ticker: "ESRT" },
    { name: "IDCC - InterDigital, Inc.", ticker: "IDCC" },
    { name: "BMA - Macro Bank Inc.", ticker: "BMA" },
    { name: "ESBA - Empire State Realty OP, L.P.", ticker: "ESBA" },
    { name: "SFNC - SIMMONS FIRST NATIONAL CORP", ticker: "SFNC" },
    { name: "QFIN - 360 DigiTech, Inc.", ticker: "QFIN" },
    { name: "SEAS - SeaWorld Entertainment, Inc.", ticker: "SEAS" },
    { name: "LYSDY - Lynas CORP LTD", ticker: "LYSDY" },
    { name: "IAG - IAMGOLD CORP", ticker: "IAG" },
    { name: "AVAV - AeroVironment Inc", ticker: "AVAV" },
    { name: "PRAA - PRA GROUP INC", ticker: "PRAA" },
    { name: "SANM - SANMINA CORP", ticker: "SANM" },
    { name: "AVNS - Avanos Medical, Inc.", ticker: "AVNS" },
    { name: "KURA - Kura Oncology, Inc.", ticker: "KURA" },
    { name: "BGS - B&G Foods, Inc.", ticker: "BGS" },
    { name: "KRON - Kronos Bio, Inc.", ticker: "KRON" },
    { name: "IBOC - INTERNATIONAL BANCSHARES CORP", ticker: "IBOC" },
    { name: "JW-A - JOHN WILEY & SONS, INC.", ticker: "JW-A" },
    { name: "RCII - RENT A CENTER INC DE", ticker: "RCII" },
    { name: "OIBR-C - OI S.A. - In Judicial Reorganization", ticker: "OIBR-C" },
    { name: "BCNAY - Barco NV", ticker: "BCNAY" },
    { name: "AIN - ALBANY INTERNATIONAL CORP /DE/", ticker: "AIN" },
    { name: "BKUH - Bakhu Holdings, Corp.", ticker: "BKUH" },
    { name: "OI - O-I Glass, Inc. /DE/", ticker: "OI" },
    { name: "SNBR - Sleep Number Corp", ticker: "SNBR" },
    { name: "CYRX - Cryoport, Inc.", ticker: "CYRX" },
    { name: "TAC - TRANSALTA CORP", ticker: "TAC" },
    { name: "HUBG - Hub Group, Inc.", ticker: "HUBG" },
    { name: "SAPMY - SAIPEM S P A /FI", ticker: "SAPMY" },
    { name: "DEA - Easterly Government Properties, Inc.", ticker: "DEA" },
    { name: "PBH - Prestige Consumer Healthcare Inc.", ticker: "PBH" },
    { name: "EGHT - 8X8 INC /DE/", ticker: "EGHT" },
    { name: "AKO-A - ANDINA BOTTLING CO INC", ticker: "AKO-A" },
    { name: "PRPL - Purple Innovation, Inc.", ticker: "PRPL" },
    { name: "ORRYY - Orora Limited/ADR", ticker: "ORRYY" },
    { name: "PRGS - PROGRESS SOFTWARE CORP /MA", ticker: "PRGS" },
    { name: "SIX - Six Flags Entertainment Corp", ticker: "SIX" },
    { name: "ATRC - AtriCure, Inc.", ticker: "ATRC" },
    { name: "TEX - TEREX CORP", ticker: "TEX" },
    { name: "KTB - Kontoor Brands, Inc.", ticker: "KTB" },
    { name: "QURE - uniQure N.V.", ticker: "QURE" },
    { name: "MWA - Mueller Water Products, Inc.", ticker: "MWA" },
    { name: "WETG - WeTrade Group Inc.", ticker: "WETG" },
    { name: "MXL - MAXLINEAR INC", ticker: "MXL" },
    { name: "SWN - SOUTHWESTERN ENERGY CO", ticker: "SWN" },
    { name: "HTHT - Huazhu Group Ltd", ticker: "HTHT" },
    { name: "SJW - SJW GROUP", ticker: "SJW" },
    { name: "HCSG - HEALTHCARE SERVICES GROUP INC", ticker: "HCSG" },
    { name: "FWRD - FORWARD AIR CORP", ticker: "FWRD" },
    { name: "RPAY - Repay Holdings Corp", ticker: "RPAY" },
    { name: "PQG - PQ Group Holdings Inc.", ticker: "PQG" },
    { name: "NOAH - Noah Holdings Ltd", ticker: "NOAH" },
    { name: "MED - MEDIFAST INC", ticker: "MED" },
    { name: "ATSG - Air Transport Services Group, Inc.", ticker: "ATSG" },
    { name: "EPR - EPR PROPERTIES", ticker: "EPR" },
    { name: "OFLX - Omega Flex, Inc.", ticker: "OFLX" },
    { name: "SAH - SONIC AUTOMOTIVE INC", ticker: "SAH" },
    { name: "MDRX - ALLSCRIPTS HEALTHCARE SOLUTIONS, INC.", ticker: "MDRX" },
    { name: "INDB - INDEPENDENT BANK CORP", ticker: "INDB" },
    { name: "BDN - BRANDYWINE REALTY TRUST", ticker: "BDN" },
    { name: "REPL - Replimune Group, Inc.", ticker: "REPL" },
    { name: "AMK - AssetMark Financial Holdings, Inc.", ticker: "AMK" },
    { name: "KFY - KORN FERRY", ticker: "KFY" },
    { name: "NTCT - NETSCOUT SYSTEMS INC", ticker: "NTCT" },
    { name: "KYMR - Kymera Therapeutics, Inc.", ticker: "KYMR" },
    { name: "VTKLY - VTECH HOLDINGS LTD/ADR/", ticker: "VTKLY" },
    { name: "WAFD - WASHINGTON FEDERAL INC", ticker: "WAFD" },
    { name: "UCBI - UNITED COMMUNITY BANKS INC", ticker: "UCBI" },
    { name: "CTRE - CareTrust REIT, Inc.", ticker: "CTRE" },
    { name: "MLI - MUELLER INDUSTRIES INC", ticker: "MLI" },
    { name: "EURN - Euronav NV", ticker: "EURN" },
    { name: "NWBO - NORTHWEST BIOTHERAPEUTICS INC", ticker: "NWBO" },
    { name: "BEAM - Beam Therapeutics Inc.", ticker: "BEAM" },
    { name: "MSGE - Madison Square Garden Entertainment Corp.", ticker: "MSGE" },
    { name: "NSTG - NanoString Technologies Inc", ticker: "NSTG" },
    { name: "CVCO - CAVCO INDUSTRIES INC.", ticker: "CVCO" },
    { name: "SAVE - Spirit Airlines, Inc.", ticker: "SAVE" },
    { name: "YMAB - Y-mAbs Therapeutics, Inc.", ticker: "YMAB" },
    { name: "KLIC - KULICKE & SOFFA INDUSTRIES INC", ticker: "KLIC" },
    { name: "SHO - Sunstone Hotel Investors, Inc.", ticker: "SHO" },
    { name: "IOSP - INNOSPEC INC.", ticker: "IOSP" },
    { name: "FLR - FLUOR CORP", ticker: "FLR" },
    { name: "FUWAY - FURUKAWA ELECTRIC CO LTD", ticker: "FUWAY" },
    { name: "FULT - FULTON FINANCIAL CORP", ticker: "FULT" },
    { name: "COGNY - Kroton Educational S.A.", ticker: "COGNY" },
    { name: "JEHLY - JOHNSON ELECTRIC HOLDINGS LTD /FI", ticker: "JEHLY" },
    { name: "FRHC - Freedom Holding Corp.", ticker: "FRHC" },
    { name: "MSC - STUDIO CITY INTERNATIONAL HOLDINGS Ltd", ticker: "MSC" },
    { name: "FLWS - 1 800 FLOWERS COM INC", ticker: "FLWS" },
    { name: "LUNG - Pulmonx Corp", ticker: "LUNG" },
    { name: "ALVR - Allovir, Inc.", ticker: "ALVR" },
    { name: "RVNC - Revance Therapeutics, Inc.", ticker: "RVNC" },
    { name: "MAG - MAG SILVER CORP", ticker: "MAG" },
    { name: "PDM - Piedmont Office Realty Trust, Inc.", ticker: "PDM" },
    { name: "CRVL - CORVEL CORP", ticker: "CRVL" },
    { name: "VRRM - VERRA MOBILITY Corp", ticker: "VRRM" },
    { name: "LZB - LA-Z-BOY INC", ticker: "LZB" },
    { name: "PEB - Pebblebrook Hotel Trust", ticker: "PEB" },
    { name: "ONTO - ONTO INNOVATION INC.", ticker: "ONTO" },
    { name: "MSTR - MICROSTRATEGY Inc", ticker: "MSTR" },
    { name: "RMBS - RAMBUS INC", ticker: "RMBS" },
    { name: "USNA - USANA HEALTH SCIENCES INC", ticker: "USNA" },
    { name: "ZNTL - Zentalis Pharmaceuticals, Inc.", ticker: "ZNTL" },
    { name: "KRO - KRONOS WORLDWIDE INC", ticker: "KRO" },
    { name: "SONO - Sonos Inc", ticker: "SONO" },
    { name: "NVMI - NOVA MEASURING INSTRUMENTS LTD", ticker: "NVMI" },
    { name: "LGF-A - LIONS GATE ENTERTAINMENT CORP /CN/", ticker: "LGF-A" },
    { name: "PMT - PennyMac Mortgage Investment Trust", ticker: "PMT" },
    { name: "OTTR - Otter Tail Corp", ticker: "OTTR" },
    { name: "WSBC - WESBANCO INC", ticker: "WSBC" },
    { name: "CFFN - Capitol Federal Financial, Inc.", ticker: "CFFN" },
    { name: "WW - WW INTERNATIONAL, INC.", ticker: "WW" },
    { name: "AHL-PC - ASPEN INSURANCE HOLDINGS LTD", ticker: "AHL-PC" },
    { name: "ALXO - ALX ONCOLOGY HOLDINGS INC", ticker: "ALXO" },
    { name: "ADUS - Addus HomeCare Corp", ticker: "ADUS" },
    { name: "AX - Axos Financial, Inc.", ticker: "AX" },
    { name: "HP - Helmerich & Payne, Inc.", ticker: "HP" },
    { name: "PMVP - PMV Pharmaceuticals, Inc.", ticker: "PMVP" },
    { name: "AZUL - AZUL SA", ticker: "AZUL" },
    { name: "SPNS - SAPIENS INTERNATIONAL CORP N V", ticker: "SPNS" },
    { name: "HLG - Hailiang Education Group Inc.", ticker: "HLG" },
    { name: "SAND - SANDSTORM GOLD LTD", ticker: "SAND" },
    { name: "EPC - EDGEWELL PERSONAL CARE Co", ticker: "EPC" },
    { name: "MYTHY - Mytilineos Holdings S.A.", ticker: "MYTHY" },
    { name: "YELP - YELP INC", ticker: "YELP" },
    { name: "AMWD - AMERICAN WOODMARK CORP", ticker: "AMWD" },
    { name: "BCC - BOISE CASCADE Co", ticker: "BCC" },
    { name: "CYDY - CytoDyn Inc.", ticker: "CYDY" },
    { name: "PAM - Pampa Energy Inc.", ticker: "PAM" },
    { name: "SKYW - SKYWEST INC", ticker: "SKYW" },
    { name: "WRE - WASHINGTON REAL ESTATE INVESTMENT TRUST", ticker: "WRE" },
    { name: "HNI - HNI CORP", ticker: "HNI" },
    { name: "JRVR - James River Group Holdings, Ltd.", ticker: "JRVR" },
    { name: "PRSC - PROVIDENCE SERVICE CORP", ticker: "PRSC" },
    { name: "JOE - ST JOE CO", ticker: "JOE" },
    { name: "VGR - VECTOR GROUP LTD", ticker: "VGR" },
    { name: "SKY - Skyline Champion Corp", ticker: "SKY" },
    { name: "RNST - RENASANT CORP", ticker: "RNST" },
    { name: "GSBD - Goldman Sachs BDC, Inc.", ticker: "GSBD" },
    { name: "PSLV - Sprott Physical Silver Trust", ticker: "PSLV" },
    { name: "CRTX - Cortexyme, Inc.", ticker: "CRTX" },
    { name: "HTLD - HEARTLAND EXPRESS INC", ticker: "HTLD" },
    { name: "MGRC - MCGRATH RENTCORP", ticker: "MGRC" },
    { name: "CELH - Celsius Holdings, Inc.", ticker: "CELH" },
    { name: "CLNY - Colony Capital, Inc.", ticker: "CLNY" },
    { name: "IRWD - IRONWOOD PHARMACEUTICALS INC", ticker: "IRWD" },
    { name: "AVSFY - AVI Ltd. / ADR", ticker: "AVSFY" },
    { name: "RCKT - ROCKET PHARMACEUTICALS, INC.", ticker: "RCKT" },
    { name: "WSFS - WSFS FINANCIAL CORP", ticker: "WSFS" },
    { name: "THRM - GENTHERM Inc", ticker: "THRM" },
    { name: "SITM - SITIME Corp", ticker: "SITM" },
    { name: "GB - Global Blue Group Holding AG", ticker: "GB" },
    { name: "PIPR - PIPER SANDLER COMPANIES", ticker: "PIPR" },
    { name: "BMDPY - BANCA MONTE DEI PASCHI DI SIENA SPA", ticker: "BMDPY" },
    { name: "CCS - Century Communities, Inc.", ticker: "CCS" },
    { name: "SGMO - SANGAMO THERAPEUTICS, INC", ticker: "SGMO" },
    { name: "BDC - BELDEN INC.", ticker: "BDC" },
    { name: "PATK - PATRICK INDUSTRIES INC", ticker: "PATK" },
    { name: "PRK - PARK NATIONAL CORP /OH/", ticker: "PRK" },
    { name: "BLMN - Bloomin' Brands, Inc.", ticker: "BLMN" },
    { name: "KN - Knowles Corp", ticker: "KN" },
    { name: "CAKE - CHEESECAKE FACTORY INC", ticker: "CAKE" },
    { name: "TRMK - TRUSTMARK CORP", ticker: "TRMK" },
    { name: "PRO - PROS Holdings, Inc.", ticker: "PRO" },
    { name: "PRFT - PERFICIENT INC", ticker: "PRFT" },
    { name: "BANF - BANCFIRST CORP /OK/", ticker: "BANF" },
    { name: "WABC - WESTAMERICA BANCORPORATION", ticker: "WABC" },
    { name: "NGD - New Gold Inc. /FI", ticker: "NGD" },
    { name: "OSIS - OSI SYSTEMS INC", ticker: "OSIS" },
    { name: "ADLDY - ADBRI Limited/ADR", ticker: "ADLDY" },
    { name: "CPK - CHESAPEAKE UTILITIES CORP", ticker: "CPK" },
    { name: "HMN - HORACE MANN EDUCATORS CORP /DE/", ticker: "HMN" },
    { name: "EGFEY - EFG Eurobank Ergasias S.A./ADR", ticker: "EGFEY" },
    { name: "PGRE - Paramount Group, Inc.", ticker: "PGRE" },
    { name: "AAT - American Assets Trust, Inc.", ticker: "AAT" },
    { name: "FUN - CEDAR FAIR L P", ticker: "FUN" },
    { name: "FTAI - Fortress Transportation & Infrastructure Investors LLC", ticker: "FTAI" },
    { name: "MNRO - MONRO, INC.", ticker: "MNRO" },
    { name: "YDUQY - ESTACIO PARTICIPACOES S.A.", ticker: "YDUQY" },
    { name: "NTLA - Intellia Therapeutics, Inc.", ticker: "NTLA" },
    { name: "LGND - LIGAND PHARMACEUTICALS INC", ticker: "LGND" },
    { name: "ALG - ALAMO GROUP INC", ticker: "ALG" },
    { name: "TWO - TWO HARBORS INVESTMENT CORP.", ticker: "TWO" },
    { name: "INT - WORLD FUEL SERVICES CORP", ticker: "INT" },
    { name: "FLIDY - FLSMIDTH & CO. A/S", ticker: "FLIDY" },
    { name: "CLBK - Columbia Financial, Inc.", ticker: "CLBK" },
    { name: "AZRE - Azure Power Global Ltd", ticker: "AZRE" },
    { name: "RLJ - RLJ Lodging Trust", ticker: "RLJ" },
    { name: "MESO - MESOBLAST LTD", ticker: "MESO" },
    { name: "ILPT - Industrial Logistics Properties Trust", ticker: "ILPT" },
    { name: "SBGI - SINCLAIR BROADCAST GROUP INC", ticker: "SBGI" },
    { name: "REZI - RESIDEO TECHNOLOGIES, INC.", ticker: "REZI" },
    { name: "MLAB - MESA LABORATORIES INC /CO/", ticker: "MLAB" },
    { name: "HRTX - HERON THERAPEUTICS, INC. /DE/", ticker: "HRTX" },
    { name: "ATGE - Adtalem Global Education Inc.", ticker: "ATGE" },
    { name: "WHD - Cactus, Inc.", ticker: "WHD" },
    { name: "PYTCY - Playtech Ltd.", ticker: "PYTCY" },
    { name: "SITC - SITE Centers Corp.", ticker: "SITC" },
    { name: "SMCI - Super Micro Computer, Inc.", ticker: "SMCI" },
    { name: "SIMO - Silicon Motion Technology CORP", ticker: "SIMO" },
    { name: "HLIO - HELIOS TECHNOLOGIES, INC.", ticker: "HLIO" },
    { name: "NWN - Northwest Natural Holding Co", ticker: "NWN" },
    { name: "SCS - STEELCASE INC", ticker: "SCS" },
    { name: "NNOX - Nano-X Imaging Ltd.", ticker: "NNOX" },
    { name: "GHG - GreenTree Hospitality Group Ltd.", ticker: "GHG" },
    { name: "CADE - Cadence Bancorporation", ticker: "CADE" },
    { name: "SLP - SIMULATIONS PLUS INC", ticker: "SLP" },
    { name: "FRME - FIRST MERCHANTS CORP", ticker: "FRME" },
    { name: "PBI - PITNEY BOWES INC /DE/", ticker: "PBI" },
    { name: "QTRX - Quanterix Corp", ticker: "QTRX" },
    { name: "MYOV - Myovant Sciences Ltd.", ticker: "MYOV" },
    { name: "GNL - Global Net Lease, Inc.", ticker: "GNL" },
    { name: "FBP - FIRST BANCORP /PR/", ticker: "FBP" },
    { name: "SY - So-Young International Inc.", ticker: "SY" },
    { name: "VITL - Vital Farms, Inc.", ticker: "VITL" },
    { name: "XPER - Xperi Holding Corp", ticker: "XPER" },
    { name: "TROX - Tronox Holdings plc", ticker: "TROX" },
    { name: "CSGS - CSG SYSTEMS INTERNATIONAL INC", ticker: "CSGS" },
    { name: "YPF - YPF SOCIEDAD ANONIMA", ticker: "YPF" },
    { name: "BV - BrightView Holdings, Inc.", ticker: "BV" },
    { name: "LX - LexinFintech Holdings Ltd.", ticker: "LX" },
    { name: "NTB - Bank of N.T. Butterfield & Son Ltd", ticker: "NTB" },
    { name: "KAI - KADANT INC", ticker: "KAI" },
    { name: "ITCB - CORPBANCA/FI", ticker: "ITCB" },
    { name: "LFUGF - Li & Fung Ltd", ticker: "LFUGF" },
    { name: "LTC - LTC PROPERTIES INC", ticker: "LTC" },
    { name: "RVLV - Revolve Group, Inc.", ticker: "RVLV" },
    { name: "FFBC - FIRST FINANCIAL BANCORP /OH/", ticker: "FFBC" },
    { name: "ALEDY - Allied Group Limited/ADR", ticker: "ALEDY" },
    { name: "MRTN - MARTEN TRANSPORT LTD", ticker: "MRTN" },
    { name: "CSTM - Constellium SE", ticker: "CSTM" },
    { name: "ENLC - EnLink Midstream, LLC", ticker: "ENLC" },
    { name: "MUR - MURPHY OIL CORP", ticker: "MUR" },
    { name: "TTGT - TechTarget Inc", ticker: "TTGT" },
    { name: "NRC - NATIONAL RESEARCH CORP", ticker: "NRC" },
    { name: "KEN - Kenon Holdings Ltd.", ticker: "KEN" },
    { name: "HRI - HERC HOLDINGS INC", ticker: "HRI" },
    { name: "LOB - Live Oak Bancshares, Inc.", ticker: "LOB" },
    { name: "FORTY - FORMULA SYSTEMS (1985) LTD", ticker: "FORTY" },
    { name: "FBK - FB Financial Corp", ticker: "FBK" },
    { name: "MHO - M/I HOMES, INC.", ticker: "MHO" },
    { name: "ACMR - ACM Research, Inc.", ticker: "ACMR" },
    { name: "GFF - GRIFFON CORP", ticker: "GFF" },
    { name: "CMPS - COMPASS Pathways plc", ticker: "CMPS" },
    { name: "TTMI - TTM TECHNOLOGIES INC", ticker: "TTMI" },
    { name: "ICFI - ICF International, Inc.", ticker: "ICFI" },
    { name: "AIFLY - AIFUL CORP /FI", ticker: "AIFLY" },
    { name: "VCTR - Victory Capital Holdings, Inc.", ticker: "VCTR" },
    { name: "ASTE - ASTEC INDUSTRIES INC", ticker: "ASTE" },
    { name: "INMD - InMode Ltd.", ticker: "INMD" },
    { name: "HCAT - Health Catalyst, Inc.", ticker: "HCAT" },
    { name: "ARI - Apollo Commercial Real Estate Finance, Inc.", ticker: "ARI" },
    { name: "NWBI - Northwest Bancshares, Inc.", ticker: "NWBI" },
    { name: "CRK - COMSTOCK RESOURCES INC", ticker: "CRK" },
    { name: "SVC - Service Properties Trust", ticker: "SVC" },
    { name: "CBZ - CBIZ, Inc.", ticker: "CBZ" },
    { name: "BANR - BANNER CORP", ticker: "BANR" },
    { name: "CALX - CALIX, INC", ticker: "CALX" },
    { name: "HTGC - Hercules Capital, Inc.", ticker: "HTGC" },
    { name: "UPLD - Upland Software, Inc.", ticker: "UPLD" },
    { name: "WMK - WEIS MARKETS INC", ticker: "WMK" },
    { name: "FRO - FRONTLINE LTD /", ticker: "FRO" },
    { name: "TSE - Trinseo S.A.", ticker: "TSE" },
    { name: "SVM - SILVERCORP METALS INC", ticker: "SVM" },
    { name: "MFA - MFA FINANCIAL, INC.", ticker: "MFA" },
    { name: "BSM - Black Stone Minerals, L.P.", ticker: "BSM" },
    { name: "FSM - FORTUNA SILVER MINES INC", ticker: "FSM" },
    { name: "VRTS - VIRTUS INVESTMENT PARTNERS, INC.", ticker: "VRTS" },
    { name: "ABR - ARBOR REALTY TRUST INC", ticker: "ABR" },
    { name: "CSWI - CSW INDUSTRIALS, INC.", ticker: "CSWI" },
    { name: "ECPG - ENCORE CAPITAL GROUP INC", ticker: "ECPG" },
    { name: "ZUO - ZUORA INC", ticker: "ZUO" },
    { name: "STOK - Stoke Therapeutics, Inc.", ticker: "STOK" },
    { name: "IPAR - INTER PARFUMS INC", ticker: "IPAR" },
    { name: "ISMAY - Indra Sistemas", ticker: "ISMAY" },
    { name: "SILV - SilverCrest Metals Inc.", ticker: "SILV" },
    { name: "PRLD - Prelude Therapeutics Inc", ticker: "PRLD" },
    { name: "SA - SEABRIDGE GOLD INC", ticker: "SA" },
    { name: "ALX - ALEXANDERS INC", ticker: "ALX" },
    { name: "MGY - Magnolia Oil & Gas Corp", ticker: "MGY" },
    { name: "RCUS - Arcus Biosciences, Inc.", ticker: "RCUS" },
    { name: "MGNX - MACROGENICS INC", ticker: "MGNX" },
    { name: "HBM - Hudbay Minerals Inc.", ticker: "HBM" },
    { name: "CGEN - COMPUGEN LTD", ticker: "CGEN" },
    { name: "LKNCY - Luckin Coffee Inc.", ticker: "LKNCY" },
    { name: "NPO - ENPRO INDUSTRIES, INC", ticker: "NPO" },
    { name: "PAGP - PLAINS GP HOLDINGS LP", ticker: "PAGP" },
    { name: "ARGO - Argo Group International Holdings, Ltd.", ticker: "ARGO" },
    { name: "VNOM - Viper Energy Partners LP", ticker: "VNOM" },
    { name: "HTLF - HEARTLAND FINANCIAL USA INC", ticker: "HTLF" },
    { name: "TPIC - TPI COMPOSITES, INC", ticker: "TPIC" },
    { name: "FMCC - FEDERAL HOME LOAN MORTGAGE CORP", ticker: "FMCC" },
    { name: "REAL - TheRealReal, Inc.", ticker: "REAL" },
    { name: "PHR - Phreesia, Inc.", ticker: "PHR" },
    { name: "SIG - SIGNET JEWELERS LTD", ticker: "SIG" },
    { name: "MODN - MODEL N, INC.", ticker: "MODN" },
    { name: "BSIG - BrightSphere Investment Group Inc.", ticker: "BSIG" },
    { name: "HSC - HARSCO CORP", ticker: "HSC" },
    { name: "DKL - Delek Logistics Partners, LP", ticker: "DKL" },
    { name: "GEO - GEO GROUP INC", ticker: "GEO" },
    { name: "ARCT - Arcturus Therapeutics Holdings Inc.", ticker: "ARCT" },
    { name: "NBTB - NBT BANCORP INC", ticker: "NBTB" },
    { name: "GOL - Gol Intelligent Airlines Inc.", ticker: "GOL" },
    { name: "ROIC - RETAIL OPPORTUNITY INVESTMENTS CORP", ticker: "ROIC" },
    { name: "SIM - GROUP SIMEC SA DE CV", ticker: "SIM" },
    { name: "DNIYY - Danieli S.p.A.", ticker: "DNIYY" },
    { name: "CVGW - CALAVO GROWERS INC", ticker: "CVGW" },
    { name: "INFN - INFINERA Corp", ticker: "INFN" },
    { name: "STC - STEWART INFORMATION SERVICES CORP", ticker: "STC" },
    { name: "YALA - Yalla Group Ltd", ticker: "YALA" },
    { name: "MMI - Marcus & Millichap, Inc.", ticker: "MMI" },
    { name: "VSTO - Vista Outdoor Inc.", ticker: "VSTO" },
    { name: "KNCAY - Konica Minolta Holdings Inc", ticker: "KNCAY" },
    { name: "JMIA - Jumia Technologies AG", ticker: "JMIA" },
    { name: "AMCX - AMC Networks Inc.", ticker: "AMCX" },
    { name: "LRN - K12 INC", ticker: "LRN" },
    { name: "RLGY - REALOGY HOLDINGS CORP.", ticker: "RLGY" },
    { name: "LKFN - LAKELAND FINANCIAL CORP", ticker: "LKFN" },
    { name: "GTN - GRAY TELEVISION INC", ticker: "GTN" },
    { name: "CHRS - Coherus BioSciences, Inc.", ticker: "CHRS" },
    { name: "ATRI - ATRION CORP", ticker: "ATRI" },
    { name: "CNXN - PC CONNECTION INC", ticker: "CNXN" },
    { name: "EAR - Eargo, Inc.", ticker: "EAR" },
    { name: "SASR - SANDY SPRING BANCORP INC", ticker: "SASR" },
    { name: "KAMN - KAMAN Corp", ticker: "KAMN" },
    { name: "EBON - Ebang International Holdings Inc.", ticker: "EBON" },
    { name: "MRSN - Mersana Therapeutics, Inc.", ticker: "MRSN" },
    { name: "KAIKY - Kawasaki Kisen Kaisha Ltd", ticker: "KAIKY" },
    { name: "CVI - CVR ENERGY INC", ticker: "CVI" },
    { name: "BPXXY - BPER BANCA S.p.A./ADR", ticker: "BPXXY" },
    { name: "KNSA - Kiniksa Pharmaceuticals, Ltd.", ticker: "KNSA" },
    { name: "IPOB - Social Capital Hedosophia Holdings Corp. II", ticker: "IPOB" },
    { name: "NS - NuStar Energy L.P.", ticker: "NS" },
    { name: "CCCC - C4 Therapeutics, Inc.", ticker: "CCCC" },
    { name: "TBPH - Theravance Biopharma, Inc.", ticker: "TBPH" },
    { name: "EPAC - ENERPAC TOOL GROUP CORP", ticker: "EPAC" },
    { name: "CODI - Compass Diversified Holdings", ticker: "CODI" },
    { name: "TNC - TENNANT CO", ticker: "TNC" },
    { name: "MSEX - MIDDLESEX WATER CO", ticker: "MSEX" },
    { name: "ATI - ALLEGHENY TECHNOLOGIES INC", ticker: "ATI" },
    { name: "UE - Urban Edge Properties", ticker: "UE" },
    { name: "MD - MEDNAX, INC.", ticker: "MD" },
    { name: "MBUU - MALIBU BOATS, INC.", ticker: "MBUU" },
    { name: "FDP - FRESH DEL MONTE PRODUCE INC", ticker: "FDP" },
    { name: "FARO - FARO TECHNOLOGIES INC", ticker: "FARO" },
    { name: "PGTI - PGT Innovations, Inc.", ticker: "PGTI" },
    { name: "CYTK - CYTOKINETICS INC", ticker: "CYTK" },
    { name: "RGR - STURM RUGER & CO INC", ticker: "RGR" },
    { name: "ODP - ODP Corp", ticker: "ODP" },
    { name: "LOMA - Loma Negra Compania Industrial Argentina Sociedad Anonima", ticker: "LOMA" },
    { name: "LNN - LINDSAY CORP", ticker: "LNN" },
    { name: "MEI - METHODE ELECTRONICS INC", ticker: "MEI" },
    { name: "FEAC - Flying Eagle Acquisition Corp.", ticker: "FEAC" },
    { name: "CVTV - China VTV Ltd", ticker: "CVTV" },
    { name: "TRS - TRIMAS CORP", ticker: "TRS" },
    { name: "ADVM - Adverum Biotechnologies, Inc.", ticker: "ADVM" },
    { name: "VSTA - Vasta Platform Ltd", ticker: "VSTA" },
    { name: "LAC - LITHIUM AMERICAS CORP.", ticker: "LAC" },
    { name: "NGM - NGM BIOPHARMACEUTICALS INC", ticker: "NGM" },
    { name: "MTRN - MATERION Corp", ticker: "MTRN" },
    { name: "BKE - BUCKLE INC", ticker: "BKE" },
    { name: "GMS - GMS Inc.", ticker: "GMS" },
    { name: "RDWR - RADWARE LTD", ticker: "RDWR" },
    { name: "ROAD - Construction Partners, Inc.", ticker: "ROAD" },
    { name: "SGRY - Surgery Partners, Inc.", ticker: "SGRY" },
    { name: "ATNX - Athenex, Inc.", ticker: "ATNX" },
    { name: "DOMO - DOMO, INC.", ticker: "DOMO" },
    { name: "SMMT - Summit Therapeutics Inc.", ticker: "SMMT" },
    { name: "IRT - INDEPENDENCE REALTY TRUST, INC.", ticker: "IRT" },
    { name: "SBCF - SEACOAST BANKING CORP OF FLORIDA", ticker: "SBCF" },
    { name: "OPRA - Opera Ltd", ticker: "OPRA" },
    { name: "AMSF - AMERISAFE INC", ticker: "AMSF" },
    { name: "AUDC - AUDIOCODES LTD", ticker: "AUDC" },
    { name: "CRNCY - CAIRN ENERGY PLC", ticker: "CRNCY" },
    { name: "FOE - FERRO CORP", ticker: "FOE" },
    { name: "IH - iHuman Inc.", ticker: "IH" },
    { name: "CHCT - Community Healthcare Trust Inc", ticker: "CHCT" },
    { name: "TBK - Triumph Bancorp, Inc.", ticker: "TBK" },
    { name: "IMPJY - Salini Impregilo S.p.A/ADR", ticker: "IMPJY" },
    { name: "ATKR - Atkore International Group Inc.", ticker: "ATKR" },
    { name: "KPTI - Karyopharm Therapeutics Inc.", ticker: "KPTI" },
    { name: "SNEX - StoneX Group Inc.", ticker: "SNEX" },
    { name: "DRD - DRDGOLD LTD", ticker: "DRD" },
    { name: "RMAX - RE/MAX Holdings, Inc.", ticker: "RMAX" },
    { name: "USPH - U S PHYSICAL THERAPY INC /NV", ticker: "USPH" },
    { name: "CLI - MACK CALI REALTY CORP", ticker: "CLI" },
    { name: "USAC - USA Compression Partners, LP", ticker: "USAC" },
    { name: "PNTG - Pennant Group, Inc.", ticker: "PNTG" },
    { name: "IPOC - Social Capital Hedosophia Holdings Corp. III", ticker: "IPOC" },
    { name: "NTGR - NETGEAR, INC.", ticker: "NTGR" },
    { name: "MAC - MACERICH CO", ticker: "MAC" },
    { name: "CERS - CERUS CORP", ticker: "CERS" },
    { name: "GBX - GREENBRIER COMPANIES INC", ticker: "GBX" },
    { name: "RTRX - Retrophin, Inc.", ticker: "RTRX" },
    { name: "GTY - GETTY REALTY CORP /MD/", ticker: "GTY" },
    { name: "GPRO - GoPro, Inc.", ticker: "GPRO" },
    { name: "BEST - BEST Inc.", ticker: "BEST" },
    { name: "NXRT - NexPoint Residential Trust, Inc.", ticker: "NXRT" },
    { name: "DLX - DELUXE CORP", ticker: "DLX" },
    { name: "BDTX - Black Diamond Therapeutics, Inc.", ticker: "BDTX" },
    { name: "ANNX - Annexon, Inc.", ticker: "ANNX" },
    { name: "OSUR - ORASURE TECHNOLOGIES INC", ticker: "OSUR" },
    { name: "SUPN - SUPERNUS PHARMACEUTICALS, INC.", ticker: "SUPN" },
    { name: "ELF - e.l.f. Beauty, Inc.", ticker: "ELF" },
    { name: "SMP - STANDARD MOTOR PRODUCTS, INC.", ticker: "SMP" },
    { name: "SBH - Sally Beauty Holdings, Inc.", ticker: "SBH" },
    { name: "SWM - SCHWEITZER MAUDUIT INTERNATIONAL INC", ticker: "SWM" },
    { name: "DDS - DILLARD'S, INC.", ticker: "DDS" },
    { name: "PRRFY - Premier Foods plc", ticker: "PRRFY" },
    { name: "GBIO - Generation Bio Co.", ticker: "GBIO" },
    { name: "ATRA - Atara Biotherapeutics, Inc.", ticker: "ATRA" },
    { name: "NRIX - Nurix Therapeutics, Inc.", ticker: "NRIX" },
    { name: "CNK - Cinemark Holdings, Inc.", ticker: "CNK" },
    { name: "ARQT - Arcutis Biotherapeutics, Inc.", ticker: "ARQT" },
    { name: "PSNL - Personalis, Inc.", ticker: "PSNL" },
    { name: "OTRK - Ontrak, Inc.", ticker: "OTRK" },
    { name: "KROS - Keros Therapeutics, Inc.", ticker: "KROS" },
    { name: "BPMP - BP Midstream Partners LP", ticker: "BPMP" },
    { name: "SAFT - SAFETY INSURANCE GROUP INC", ticker: "SAFT" },
    { name: "LABL - MULTI COLOR Corp", ticker: "LABL" },
    { name: "VBTX - Veritex Holdings, Inc.", ticker: "VBTX" },
    { name: "ATGSY - Autogrill SpA", ticker: "ATGSY" },
    { name: "BTAI - BioXcel Therapeutics, Inc.", ticker: "BTAI" },
    { name: "ULNV - Porter Holding International, Inc.", ticker: "ULNV" },
    { name: "AR - ANTERO RESOURCES Corp", ticker: "AR" },
    { name: "KALU - KAISER ALUMINUM CORP", ticker: "KALU" },
    { name: "PRAX - Praxis Precision Medicines, Inc.", ticker: "PRAX" },
    { name: "EVER - EverQuote, Inc.", ticker: "EVER" },
    { name: "RNA - Avidity Biosciences, Inc.", ticker: "RNA" },
    { name: "TUP - TUPPERWARE BRANDS CORP", ticker: "TUP" },
    { name: "ACEL - Accel Entertainment, Inc.", ticker: "ACEL" },
    { name: "QIWI - QIWI", ticker: "QIWI" },
    { name: "RGNX - REGENXBIO Inc.", ticker: "RGNX" },
    { name: "NYMT - NEW YORK MORTGAGE TRUST INC", ticker: "NYMT" },
    { name: "UVV - UNIVERSAL CORP /VA/", ticker: "UVV" },
    { name: "XHR - Xenia Hotels & Resorts, Inc.", ticker: "XHR" },
    { name: "INVA - Innoviva, Inc.", ticker: "INVA" },
    { name: "MGNI - MAGNITE, INC.", ticker: "MGNI" },
    { name: "MYGN - MYRIAD GENETICS INC", ticker: "MYGN" },
    { name: "OSPN - OneSpan Inc.", ticker: "OSPN" },
    { name: "MTDR - Matador Resources Co", ticker: "MTDR" },
    { name: "UNFI - UNITED NATURAL FOODS INC", ticker: "UNFI" },
    { name: "FXCNY - FIH Mobile Ltd", ticker: "FXCNY" },
    { name: "PLUS - EPLUS INC", ticker: "PLUS" },
    { name: "SPH - SUBURBAN PROPANE PARTNERS LP", ticker: "SPH" },
    { name: "BGCP - BGC Partners, Inc.", ticker: "BGCP" },
    { name: "GTH - Genetron Holdings Ltd", ticker: "GTH" },
    { name: "HOPE - HOPE BANCORP INC", ticker: "HOPE" },
    { name: "DRH - DiamondRock Hospitality Co", ticker: "DRH" },
    { name: "RYTM - RHYTHM PHARMACEUTICALS, INC.", ticker: "RYTM" },
    { name: "IMGN - ImmunoGen, Inc.", ticker: "IMGN" },
    { name: "KREF - KKR Real Estate Finance Trust Inc.", ticker: "KREF" },
    { name: "GRBK - Green Brick Partners, Inc.", ticker: "GRBK" },
    { name: "AMPH - Amphastar Pharmaceuticals, Inc.", ticker: "AMPH" },
    { name: "INSG - INSEEGO CORP.", ticker: "INSG" },
    { name: "BUSE - FIRST BUSEY CORP /NV/", ticker: "BUSE" },
    { name: "ZLAB - Zai Lab Ltd", ticker: "ZLAB" },
    { name: "BROG - Brooge Energy Ltd", ticker: "BROG" },
    { name: "HURN - Huron Consulting Group Inc.", ticker: "HURN" },
    { name: "NHC - NATIONAL HEALTHCARE CORP", ticker: "NHC" },
    { name: "WIRE - ENCORE WIRE CORP", ticker: "WIRE" },
    { name: "DIN - Dine Brands Global, Inc.", ticker: "DIN" },
    { name: "OPI - OFFICE PROPERTIES INCOME TRUST", ticker: "OPI" },
    { name: "CSTL - CASTLE BIOSCIENCES INC", ticker: "CSTL" },
    { name: "CEVA - CEVA INC", ticker: "CEVA" },
    { name: "EGBN - EAGLE BANCORP INC", ticker: "EGBN" },
    { name: "UCTT - Ultra Clean Holdings, Inc.", ticker: "UCTT" },
    { name: "SWBI - SMITH & WESSON BRANDS, INC.", ticker: "SWBI" },
    { name: "LTMAQ - LATAM AIRLINES GROUP S.A.", ticker: "LTMAQ" },
    { name: "ESPR - Esperion Therapeutics, Inc.", ticker: "ESPR" },
    { name: "PRIM - Primoris Services Corp", ticker: "PRIM" },
    { name: "NKTX - Nkarta, Inc.", ticker: "NKTX" },
    { name: "AVO - Mission Produce, Inc.", ticker: "AVO" },
    { name: "KRG - KITE REALTY GROUP TRUST", ticker: "KRG" },
    { name: "BLFS - BIOLIFE SOLUTIONS INC", ticker: "BLFS" },
    { name: "CHCO - CITY HOLDING CO", ticker: "CHCO" },
    { name: "PHAT - Phathom Pharmaceuticals, Inc.", ticker: "PHAT" },
    { name: "RWT - REDWOOD TRUST INC", ticker: "RWT" },
    { name: "ANF - ABERCROMBIE & FITCH CO /DE/", ticker: "ANF" },
    { name: "CCF - CHASE CORP", ticker: "CCF" },
    { name: "GVA - GRANITE CONSTRUCTION INC", ticker: "GVA" },
    { name: "VCEL - Vericel Corp", ticker: "VCEL" },
    { name: "OCFC - OCEANFIRST FINANCIAL CORP", ticker: "OCFC" },
    { name: "TGP - Teekay LNG Partners L.P.", ticker: "TGP" },
    { name: "KIDS - ORTHOPEDIATRICS CORP", ticker: "KIDS" },
    { name: "SZGPY - Salzgitter AG / ADR", ticker: "SZGPY" },
    { name: "SCWX - SecureWorks Corp", ticker: "SCWX" },
    { name: "BOOT - Boot Barn Holdings, Inc.", ticker: "BOOT" },
    { name: "EVH - Evolent Health, Inc.", ticker: "EVH" },
    { name: "NBHC - National Bank Holdings Corp", ticker: "NBHC" },
    { name: "AKRO - Akero Therapeutics, Inc.", ticker: "AKRO" },
    { name: "URYL - United Royale Holdings Corp.", ticker: "URYL" },
    { name: "EIG - Employers Holdings, Inc.", ticker: "EIG" },
    { name: "KRYS - Krystal Biotech, Inc.", ticker: "KRYS" },
    { name: "TGH - TEXTAINER GROUP HOLDINGS LTD", ticker: "TGH" },
    { name: "CXW - CoreCivic, Inc.", ticker: "CXW" },
    { name: "NMFC - New Mountain Finance Corp", ticker: "NMFC" },
    { name: "AZZ - AZZ INC", ticker: "AZZ" },
    { name: "NK - NantKwest, Inc.", ticker: "NK" },
    { name: "CMRE - Costamare Inc.", ticker: "CMRE" },
    { name: "CLS - CELESTICA INC", ticker: "CLS" },
    { name: "PETQ - PetIQ, Inc.", ticker: "PETQ" },
    { name: "OEC - Orion Engineered Carbons S.A.", ticker: "OEC" },
    { name: "CMCO - COLUMBUS MCKINNON CORP", ticker: "CMCO" },
    { name: "QNST - QUINSTREET, INC", ticker: "QNST" },
    { name: "STAR - ISTAR INC.", ticker: "STAR" },
    { name: "RMR - RMR GROUP INC.", ticker: "RMR" },
    { name: "GME - GameStop Corp.", ticker: "GME" },
    { name: "SYX - SYSTEMAX INC", ticker: "SYX" },
    { name: "JOUT - JOHNSON OUTDOORS INC", ticker: "JOUT" },
    { name: "PLAY - Dave & Buster's Entertainment, Inc.", ticker: "PLAY" },
    { name: "ALEX - Alexander & Baldwin, Inc.", ticker: "ALEX" },
    { name: "NMRK - NEWMARK GROUP, INC.", ticker: "NMRK" },
    { name: "RPTX - Repare Therapeutics Inc.", ticker: "RPTX" },
    { name: "AROC - Archrock, Inc.", ticker: "AROC" },
    { name: "LBRT - Liberty Oilfield Services Inc.", ticker: "LBRT" },
    { name: "DRQ - DRIL-QUIP INC", ticker: "DRQ" },
    { name: "SFL - SFL Corp Ltd.", ticker: "SFL" },
    { name: "GSAH - GS Acquisition Holdings Corp II", ticker: "GSAH" },
    { name: "JWS - Jaws Acquisition Corp.", ticker: "JWS" },
    { name: "IRET - INVESTORS REAL ESTATE TRUST", ticker: "IRET" },
    { name: "LASR - NLIGHT, INC.", ticker: "LASR" },
    { name: "FANH - FANHUA INC.", ticker: "FANH" },
    { name: "FOR - Forestar Group Inc.", ticker: "FOR" },
    { name: "ENTA - ENANTA PHARMACEUTICALS INC", ticker: "ENTA" },
    { name: "DHT - DHT Holdings, Inc.", ticker: "DHT" },
    { name: "TCBK - TRICO BANCSHARES /", ticker: "TCBK" },
    { name: "GOGO - Gogo Inc.", ticker: "GOGO" },
    { name: "LNTH - Lantheus Holdings, Inc.", ticker: "LNTH" },
    { name: "DDD - 3D SYSTEMS CORP", ticker: "DDD" },
    { name: "CCX - Churchill Capital Corp II", ticker: "CCX" },
    { name: "GRC - GORMAN RUPP CO", ticker: "GRC" },
    { name: "JBSS - SANFILIPPO JOHN B & SON INC", ticker: "JBSS" },
    { name: "PFS - PROVIDENT FINANCIAL SERVICES INC", ticker: "PFS" },
    { name: "VLRS - Controladora Vuela Compania de Aviacion, S.A.B. de C.V.", ticker: "VLRS" },
    { name: "GRWG - GrowGeneration Corp.", ticker: "GRWG" },
    { name: "AKR - ACADIA REALTY TRUST", ticker: "AKR" },
    { name: "ERJ - EMBRAER S.A.", ticker: "ERJ" },
    { name: "SBSI - SOUTHSIDE BANCSHARES INC", ticker: "SBSI" },
    { name: "GLNG - GOLAR LNG LTD", ticker: "GLNG" },
    { name: "SRCE - 1ST SOURCE CORP", ticker: "SRCE" },
    { name: "RAPT - RAPT Therapeutics, Inc.", ticker: "RAPT" },
    { name: "ALP-PQ - ALABAMA POWER CO", ticker: "ALP-PQ" },
    { name: "FCF - FIRST COMMONWEALTH FINANCIAL CORP /PA/", ticker: "FCF" },
    { name: "ARCO - Arcos Dorados Holdings Inc.", ticker: "ARCO" },
    { name: "SYBT - Stock Yards Bancorp, Inc.", ticker: "SYBT" },
    { name: "ARCB - ARCBEST CORP /DE/", ticker: "ARCB" },
    { name: "WRLD - WORLD ACCEPTANCE CORP", ticker: "WRLD" },
    { name: "NVGI - Noble Vici Group, Inc.", ticker: "NVGI" },
    { name: "HEES - H&E Equipment Services, Inc.", ticker: "HEES" },
    { name: "STTK - Shattuck Labs, Inc.", ticker: "STTK" },
    { name: "TMP - TOMPKINS FINANCIAL CORP", ticker: "TMP" },
    { name: "PGEN - PRECIGEN, INC.", ticker: "PGEN" },
    { name: "PRDO - PERDOCEO EDUCATION Corp", ticker: "PRDO" },
    { name: "CRS - CARPENTER TECHNOLOGY CORP", ticker: "CRS" },
    { name: "EB - Eventbrite, Inc.", ticker: "EB" },
    { name: "SSP - E.W. SCRIPPS Co", ticker: "SSP" },
    { name: "LADR - Ladder Capital Corp", ticker: "LADR" },
    { name: "BRBR - BELLRING BRANDS, INC.", ticker: "BRBR" },
    { name: "RDNT - RadNet, Inc.", ticker: "RDNT" },
    { name: "CASH - META FINANCIAL GROUP INC", ticker: "CASH" },
    { name: "CTS - CTS CORP", ticker: "CTS" },
    { name: "TLRY - Tilray, Inc.", ticker: "TLRY" },
    { name: "ADAP - Adaptimmune Therapeutics PLC", ticker: "ADAP" },
    { name: "CDXS - CODEXIS, INC.", ticker: "CDXS" },
    { name: "MCRI - MONARCH CASINO & RESORT INC", ticker: "MCRI" },
    { name: "KFRC - KFORCE INC", ticker: "KFRC" },
    { name: "HIBB - HIBBETT SPORTS INC", ticker: "HIBB" },
    { name: "ARVN - ARVINAS, INC.", ticker: "ARVN" },
    { name: "GRVY - GRAVITY Co., Ltd.", ticker: "GRVY" },
    { name: "PRA - PROASSURANCE CORP", ticker: "PRA" },
    { name: "CANG - Cango Inc.", ticker: "CANG" },
    { name: "IESC - IES Holdings, Inc.", ticker: "IESC" },
    { name: "GES - GUESS INC", ticker: "GES" },
    { name: "ALPC - Alpha Investment Inc.", ticker: "ALPC" },
    { name: "PAR - PAR TECHNOLOGY CORP", ticker: "PAR" },
    { name: "PLRX - PLIANT THERAPEUTICS, INC.", ticker: "PLRX" },
    { name: "SII - SPROTT INC.", ticker: "SII" },
    { name: "STBA - S&T BANCORP INC", ticker: "STBA" },
    { name: "GABC - GERMAN AMERICAN BANCORP, INC.", ticker: "GABC" },
    { name: "MORF - Morphic Holding, Inc.", ticker: "MORF" },
    { name: "BWMX - Betterware de Mexico, S.A.B. de C.V.", ticker: "BWMX" },
    { name: "PLOW - DOUGLAS DYNAMICS, INC", ticker: "PLOW" },
    { name: "TCX - TUCOWS INC /PA/", ticker: "TCX" },
    { name: "NLS - NAUTILUS, INC.", ticker: "NLS" },
    { name: "COHU - COHU INC", ticker: "COHU" },
    { name: "FUBO - fuboTV Inc. /FL", ticker: "FUBO" },
    { name: "FLGT - Fulgent Genetics, Inc.", ticker: "FLGT" },
    { name: "NVEE - NV5 Global, Inc.", ticker: "NVEE" },
    { name: "SSYS - STRATASYS LTD.", ticker: "SSYS" },
    { name: "ITOS - iTeos Therapeutics, Inc.", ticker: "ITOS" },
    { name: "BRRAY - BARLOWORLD LTD", ticker: "BRRAY" },
    { name: "XPEL - XPEL, Inc.", ticker: "XPEL" },
    { name: "BEDU - Bright Scholar Education Holdings Ltd", ticker: "BEDU" },
    { name: "AC - Associated Capital Group, Inc.", ticker: "AC" },
    { name: "DK - Delek US Holdings, Inc.", ticker: "DK" },
    { name: "ACLS - AXCELIS TECHNOLOGIES INC", ticker: "ACLS" },
    { name: "SXI - STANDEX INTERNATIONAL CORP/DE/", ticker: "SXI" },
    { name: "PLT - PLANTRONICS INC /CA/", ticker: "PLT" },
    { name: "ZUMZ - Zumiez Inc", ticker: "ZUMZ" },
    { name: "NUNZ - NUNZIA PHARMACEUTICAL Co", ticker: "NUNZ" },
    { name: "ATEC - Alphatec Holdings, Inc.", ticker: "ATEC" },
    { name: "BHE - BENCHMARK ELECTRONICS INC", ticker: "BHE" },
    { name: "DHC - DIVERSIFIED HEALTHCARE TRUST", ticker: "DHC" },
    { name: "CRTO - Criteo S.A.", ticker: "CRTO" },
    { name: "VAPO - VAPOTHERM INC", ticker: "VAPO" },
    { name: "PACK - Ranpak Holdings Corp.", ticker: "PACK" },
    { name: "CYD - CHINA YUCHAI INTERNATIONAL LTD", ticker: "CYD" },
    { name: "EFSC - ENTERPRISE FINANCIAL SERVICES CORP", ticker: "EFSC" },
    { name: "CNDT - CONDUENT Inc", ticker: "CNDT" },
    { name: "TSHA - Taysha Gene Therapies, Inc.", ticker: "TSHA" },
    { name: "AMRX - Amneal Pharmaceuticals, Inc.", ticker: "AMRX" },
    { name: "EVRI - Everi Holdings Inc.", ticker: "EVRI" },
    { name: "FGROY - FirstGroup", ticker: "FGROY" },
    { name: "CBB - CINCINNATI BELL INC", ticker: "CBB" },
    { name: "KELYA - KELLY SERVICES INC", ticker: "KELYA" },
    { name: "ORIC - Oric Pharmaceuticals, Inc.", ticker: "ORIC" },
    { name: "ICLK - iClick Interactive Asia Group Ltd", ticker: "ICLK" },
    { name: "KRNY - Kearny Financial Corp.", ticker: "KRNY" },
    { name: "PASG - Passage BIO, Inc.", ticker: "PASG" },
    { name: "DYN - Dyne Therapeutics, Inc.", ticker: "DYN" },
    { name: "IMKTA - INGLES MARKETS INC", ticker: "IMKTA" },
    { name: "LL - Lumber Liquidators Holdings, Inc.", ticker: "LL" },
    { name: "QUOT - Quotient Technology Inc.", ticker: "QUOT" },
    { name: "IIIV - i3 Verticals, Inc.", ticker: "IIIV" },
    { name: "TGS - GAS TRANSPORTER OF THE SOUTH INC", ticker: "TGS" },
    { name: "ANDE - Andersons, Inc.", ticker: "ANDE" },
    { name: "HCC - WARRIOR MET COAL, INC.", ticker: "HCC" },
    { name: "AGEN - AGENUS INC", ticker: "AGEN" },
    { name: "ATNI - ATN International, Inc.", ticker: "ATNI" },
    { name: "AXL - AMERICAN AXLE & MANUFACTURING HOLDINGS INC", ticker: "AXL" },
    { name: "OFG - OFG BANCORP", ticker: "OFG" },
    { name: "WNC - WABASH NATIONAL Corp", ticker: "WNC" },
    { name: "TPRE - Third Point Reinsurance Ltd.", ticker: "TPRE" },
    { name: "LLNW - Limelight Networks, Inc.", ticker: "LLNW" },
    { name: "UIS - UNISYS CORP", ticker: "UIS" },
    { name: "IMOS - CHIPMOS TECHNOLOGIES INC", ticker: "IMOS" },
    { name: "PTNR - PARTNER COMMUNICATIONS CO LTD", ticker: "PTNR" },
    { name: "CLLS - Cellectis S.A.", ticker: "CLLS" },
    { name: "HFWA - HERITAGE FINANCIAL CORP /WA/", ticker: "HFWA" },
    { name: "BRKL - BROOKLINE BANCORP INC", ticker: "BRKL" },
    { name: "UHT - UNIVERSAL HEALTH REALTY INCOME TRUST", ticker: "UHT" },
    { name: "ALEC - Alector, Inc.", ticker: "ALEC" },
    { name: "MYRG - MYR GROUP INC.", ticker: "MYRG" },
    { name: "HMI - Huami Corp", ticker: "HMI" },
    { name: "SPTN - SpartanNash Co", ticker: "SPTN" },
    { name: "HOLI - Hollysys Automation Technologies, Ltd.", ticker: "HOLI" },
    { name: "PTGX - Protagonist Therapeutics, Inc", ticker: "PTGX" },
    { name: "SHYF - SHYFT GROUP, INC.", ticker: "SHYF" },
    { name: "PDFS - PDF SOLUTIONS INC", ticker: "PDFS" },
    { name: "MATW - MATTHEWS INTERNATIONAL CORP", ticker: "MATW" },
    { name: "HY - HYSTER-YALE MATERIALS HANDLING, INC.", ticker: "HY" },
    { name: "CEPU - CENTRAL PUERTO S.A.", ticker: "CEPU" },
    { name: "OCUL - OCULAR THERAPEUTIX, INC", ticker: "OCUL" },
    { name: "SOHU - Sohu.com Ltd", ticker: "SOHU" },
    { name: "AGM - FEDERAL AGRICULTURAL MORTGAGE CORP", ticker: "AGM" },
    { name: "SWDHY - Skyworth Digital Holdings Limited/ADR", ticker: "SWDHY" },
    { name: "BJRI - BJs RESTAURANTS INC", ticker: "BJRI" },
    { name: "SCHL - SCHOLASTIC CORP", ticker: "SCHL" },
    { name: "PAHC - PHIBRO ANIMAL HEALTH CORP", ticker: "PAHC" },
    { name: "TOGL - Toga Ltd", ticker: "TOGL" },
    { name: "SIBN - SI-BONE, Inc.", ticker: "SIBN" },
    { name: "GLDD - Great Lakes Dredge & Dock CORP", ticker: "GLDD" },
    { name: "SRG - Seritage Growth Properties", ticker: "SRG" },
    { name: "HUTCY - Hutchison Telecommunications Hong Kong Holdings Ltd", ticker: "HUTCY" },
    { name: "OXM - OXFORD INDUSTRIES INC", ticker: "OXM" },
    { name: "NEXA - Nexa Resources S.A.", ticker: "NEXA" },
    { name: "CAMT - CAMTEK LTD", ticker: "CAMT" },
    { name: "TRWH - Twin River Worldwide Holdings, Inc.", ticker: "TRWH" },
    { name: "MDXG - MIMEDX GROUP, INC.", ticker: "MDXG" },
    { name: "APOG - APOGEE ENTERPRISES, INC.", ticker: "APOG" },
    { name: "IMTX - Immatics N.V.", ticker: "IMTX" },
    { name: "ONE - OneSmart International Education Group Ltd", ticker: "ONE" },
    { name: "HGEN - HUMANIGEN, INC", ticker: "HGEN" },
    { name: "ITPOF - INTERTAPE POLYMER GROUP INC", ticker: "ITPOF" },
    { name: "MMX - MAVERIX METALS INC.", ticker: "MMX" },
    { name: "AIR - AAR CORP", ticker: "AIR" },
    { name: "VTOL - Bristow Group Inc.", ticker: "VTOL" },
    { name: "CRY - CRYOLIFE INC", ticker: "CRY" },
    { name: "MGPI - MGP INGREDIENTS INC", ticker: "MGPI" },
    { name: "ANAB - ANAPTYSBIO, INC", ticker: "ANAB" },
    { name: "AFIB - Acutus Medical, Inc.", ticker: "AFIB" },
    { name: "TCMD - TACTILE SYSTEMS TECHNOLOGY INC", ticker: "TCMD" },
    { name: "CLDX - Celldex Therapeutics, Inc.", ticker: "CLDX" },
    { name: "CARA - Cara Therapeutics, Inc.", ticker: "CARA" },
    { name: "IIM - Invesco Value Municipal Income Trust", ticker: "IIM" },
    { name: "FORR - FORRESTER RESEARCH, INC.", ticker: "FORR" },
    { name: "INBX - Inhibrx, Inc.", ticker: "INBX" },
    { name: "HNGR - HANGER, INC.", ticker: "HNGR" },
    { name: "FREQ - Frequency Therapeutics, Inc.", ticker: "FREQ" },
    { name: "TPC - TUTOR PERINI CORP", ticker: "TPC" },
    { name: "STKL - SunOpta Inc.", ticker: "STKL" },
    { name: "AHH - Armada Hoffler Properties, Inc.", ticker: "AHH" },
    { name: "IGR - CBRE CLARION GLOBAL REAL ESTATE INCOME FUND", ticker: "IGR" },
    { name: "SPWH - SPORTSMAN'S WAREHOUSE HOLDINGS, INC.", ticker: "SPWH" },
    { name: "NWLI - National Western Life Group, Inc.", ticker: "NWLI" },
    { name: "OMER - OMEROS CORP", ticker: "OMER" },
    { name: "CENX - CENTURY ALUMINUM CO", ticker: "CENX" },
    { name: "CALT - Calliditas Therapeutics AB", ticker: "CALT" },
    { name: "NESR - National Energy Services Reunited Corp.", ticker: "NESR" },
    { name: "NEW - Puxin Ltd", ticker: "NEW" },
    { name: "FFWM - First Foundation Inc.", ticker: "FFWM" },
    { name: "SLRC - Solar Capital Ltd.", ticker: "SLRC" },
    { name: "PFC - PREMIER FINANCIAL CORP", ticker: "PFC" },
    { name: "CPG - Crescent Point Energy Corp.", ticker: "CPG" },
    { name: "HZAC - Horizon Acquisition Corp", ticker: "HZAC" },
    { name: "COLL - COLLEGIUM PHARMACEUTICAL, INC", ticker: "COLL" },
    { name: "MGIC - MAGIC SOFTWARE ENTERPRISES LTD", ticker: "MGIC" },
    { name: "OCSL - Oaktree Specialty Lending Corp", ticker: "OCSL" },
    { name: "FCEL - FUELCELL ENERGY INC", ticker: "FCEL" },
    { name: "HMST - HomeStreet, Inc.", ticker: "HMST" },
    { name: "SBLK - Star Bulk Carriers Corp.", ticker: "SBLK" },
    { name: "FINV - FinVolution Group", ticker: "FINV" },
    { name: "PEIX - Pacific Ethanol, Inc.", ticker: "PEIX" },
    { name: "PBF - PBF Energy Inc.", ticker: "PBF" },
    { name: "TIG - Trean Insurance Group, Inc.", ticker: "TIG" },
    { name: "YUMM - YUMMIES INC", ticker: "YUMM" },
    { name: "KODK - EASTMAN KODAK CO", ticker: "KODK" },
    { name: "WLKP - Westlake Chemical Partners LP", ticker: "WLKP" },
    { name: "GIII - G III APPAREL GROUP LTD /DE/", ticker: "GIII" },
    { name: "RUPRF - RUPERT RESOURCES LTD", ticker: "RUPRF" },
    { name: "FPH - Five Point Holdings, LLC", ticker: "FPH" },
    { name: "PLAB - PHOTRONICS INC", ticker: "PLAB" },
    { name: "PSTX - Poseida Therapeutics, Inc.", ticker: "PSTX" },
    { name: "GOSS - Gossamer Bio, Inc.", ticker: "GOSS" },
    { name: "HSTM - HEALTHSTREAM INC", ticker: "HSTM" },
    { name: "CLB - CORE LABORATORIES N V", ticker: "CLB" },
    { name: "TIGR - UP Fintech Holding Ltd", ticker: "TIGR" },
    { name: "FBNC - FIRST BANCORP /NC/", ticker: "FBNC" },
    { name: "ARZTY - ARYZTA AG (fka IAWS GROUP PLC)", ticker: "ARZTY" },
    { name: "RILY - B. Riley Financial, Inc.", ticker: "RILY" },
    { name: "MEG - Montrose Environmental Group, Inc.", ticker: "MEG" },
    { name: "ALBO - ALBIREO PHARMA, INC.", ticker: "ALBO" },
    { name: "AKUS - Akouos, Inc.", ticker: "AKUS" },
    { name: "PI - IMPINJ INC", ticker: "PI" },
    { name: "NX - Quanex Building Products CORP", ticker: "NX" },
    { name: "IMAX - IMAX CORP", ticker: "IMAX" },
    { name: "NXE - NexGen Energy Ltd.", ticker: "NXE" },
    { name: "AGX - ARGAN INC", ticker: "AGX" },
    { name: "HZO - MARINEMAX INC", ticker: "HZO" },
    { name: "HA - HAWAIIAN HOLDINGS INC", ticker: "HA" },
    { name: "AFIN - American Finance Trust, Inc", ticker: "AFIN" },
    { name: "GRSV - Gores Holdings V Inc.", ticker: "GRSV" },
    { name: "SGSVF - Sabina Gold & Silver Corp.", ticker: "SGSVF" },
    { name: "DPHC - DiamondPeak Holdings Corp.", ticker: "DPHC" },
    { name: "HIMX - Himax Technologies, Inc.", ticker: "HIMX" },
    { name: "OFIX - Orthofix Medical Inc.", ticker: "OFIX" },
    { name: "NP - Neenah Inc", ticker: "NP" },
    { name: "TREB - Trebia Acquisition Corp.", ticker: "TREB" },
    { name: "ATHA - Athira Pharma, Inc.", ticker: "ATHA" },
    { name: "CPAC - CEMENTOS PACASMAYO SAA", ticker: "CPAC" },
    { name: "GLT - Glatfelter Corp", ticker: "GLT" },
    { name: "CRMT - AMERICAS CARMART INC", ticker: "CRMT" },
    { name: "AMEH - Apollo Medical Holdings, Inc.", ticker: "AMEH" },
    { name: "DENN - DENNY'S Corp", ticker: "DENN" },
    { name: "LMAT - LEMAITRE VASCULAR INC", ticker: "LMAT" },
    { name: "TBI - TrueBlue, Inc.", ticker: "TBI" },
    { name: "CLW - Clearwater Paper Corp", ticker: "CLW" },
    { name: "STNG - Scorpio Tankers Inc.", ticker: "STNG" },
    { name: "RC - Ready Capital Corp", ticker: "RC" },
    { name: "BCSF - Bain Capital Specialty Finance, Inc.", ticker: "BCSF" },
    { name: "AGYS - AGILYSYS INC", ticker: "AGYS" },
    { name: "CEL - Cellcom Israel Ltd.", ticker: "CEL" },
    { name: "SNDX - Syndax Pharmaceuticals Inc", ticker: "SNDX" },
    { name: "NCBS - NICOLET BANKSHARES INC", ticker: "NCBS" },
    { name: "SBE - Switchback Energy Acquisition Corp", ticker: "SBE" },
    { name: "VSLAX - Invesco Senior Loan Fund", ticker: "VSLAX" },
    { name: "SRI - STONERIDGE INC", ticker: "SRI" },
    { name: "MBIN - Merchants Bancorp", ticker: "MBIN" },
    { name: "SCU - Sculptor Capital Management, Inc.", ticker: "SCU" },
    { name: "CNOB - ConnectOne Bancorp, Inc.", ticker: "CNOB" },
    { name: "VECO - VEECO INSTRUMENTS INC", ticker: "VECO" },
    { name: "AXDX - Accelerate Diagnostics, Inc", ticker: "AXDX" },
    { name: "INGN - Inogen Inc", ticker: "INGN" },
    { name: "GMRE - Global Medical REIT Inc.", ticker: "GMRE" },
    { name: "TRTX - TPG RE Finance Trust, Inc.", ticker: "TRTX" },
    { name: "DQWS - DSwiss Inc", ticker: "DQWS" },
    { name: "ENVA - Enova International, Inc.", ticker: "ENVA" },
    { name: "RBCAA - REPUBLIC BANCORP INC /KY/", ticker: "RBCAA" },
    { name: "BCRX - BIOCRYST PHARMACEUTICALS INC", ticker: "BCRX" },
    { name: "HLIT - HARMONIC INC", ticker: "HLIT" },
    { name: "WINA - WINMARK CORP", ticker: "WINA" },
    { name: "PRTS - CarParts.com, Inc.", ticker: "PRTS" },
    { name: "PETS - PETMED EXPRESS INC", ticker: "PETS" },
    { name: "EGAN - EGAIN Corp", ticker: "EGAN" },
    { name: "ARR - Armour Residential REIT, Inc.", ticker: "ARR" },
    { name: "AMBC - AMBAC FINANCIAL GROUP INC", ticker: "AMBC" },
    { name: "LOCO - El Pollo Loco Holdings, Inc.", ticker: "LOCO" },
    { name: "SGH - SMART Global Holdings, Inc.", ticker: "SGH" },
    { name: "CLNC - Colony Credit Real Estate, Inc.", ticker: "CLNC" },
    { name: "ACCO - ACCO BRANDS Corp", ticker: "ACCO" },
    { name: "EGRX - EAGLE PHARMACEUTICALS, INC.", ticker: "EGRX" },
    { name: "AUTL - Autolus Therapeutics plc", ticker: "AUTL" },
    { name: "VBIV - VBI Vaccines Inc/BC", ticker: "VBIV" },
    { name: "ULH - UNIVERSAL LOGISTICS HOLDINGS, INC.", ticker: "ULH" },
    { name: "YORW - YORK WATER CO", ticker: "YORW" },
    { name: "CASS - CASS INFORMATION SYSTEMS INC", ticker: "CASS" },
    { name: "VSBC - VITASPRING BIOMEDICAL CO. LTD.", ticker: "VSBC" },
    { name: "GPRE - Green Plains Inc.", ticker: "GPRE" },
    { name: "CHEF - Chefs' Warehouse, Inc.", ticker: "CHEF" },
    { name: "GOOD - GLADSTONE COMMERCIAL CORP", ticker: "GOOD" },
    { name: "TPB - Turning Point Brands, Inc.", ticker: "TPB" },
    { name: "BFS - SAUL CENTERS, INC.", ticker: "BFS" },
    { name: "FVAC - Fortress Value Acquisition Corp.", ticker: "FVAC" },
    { name: "MPX - MARINE PRODUCTS CORP", ticker: "MPX" },
    { name: "UTL - UNITIL CORP", ticker: "UTL" },
    { name: "EBIX - EBIX INC", ticker: "EBIX" },
    { name: "PCPL - CC Neuberger Principal Holdings I", ticker: "PCPL" },
    { name: "SKT - TANGER FACTORY OUTLET CENTERS, INC", ticker: "SKT" },
    { name: "WASH - WASHINGTON TRUST BANCORP INC", ticker: "WASH" },
    { name: "IMXI - International Money Express, Inc.", ticker: "IMXI" },
    { name: "ATEX - Anterix Inc.", ticker: "ATEX" },
    { name: "VXRT - Vaxart, Inc.", ticker: "VXRT" },
    { name: "DBD - DIEBOLD NIXDORF, Inc", ticker: "DBD" },
    { name: "AMRS - AMYRIS, INC.", ticker: "AMRS" },
    { name: "OSW - ONESPAWORLD HOLDINGS Ltd", ticker: "OSW" },
    { name: "SCHN - SCHNITZER STEEL INDUSTRIES, INC.", ticker: "SCHN" },
    { name: "CARS - Cars.com Inc.", ticker: "CARS" },
    { name: "AGRO - Adecoagro S.A.", ticker: "AGRO" },
    { name: "HBIA - HILLS BANCORPORATION", ticker: "HBIA" },
    { name: "RBBN - Ribbon Communications Inc.", ticker: "RBBN" },
    { name: "OYST - Oyster Point Pharma, Inc.", ticker: "OYST" },
    { name: "UMH - UMH PROPERTIES, INC.", ticker: "UMH" },
    { name: "USLM - UNITED STATES LIME & MINERALS INC", ticker: "USLM" },
    { name: "CYH - COMMUNITY HEALTH SYSTEMS INC", ticker: "CYH" },
    { name: "RES - RPC INC", ticker: "RES" },
    { name: "CBAY - CymaBay Therapeutics, Inc.", ticker: "CBAY" },
    { name: "DUO - Fangdd Network Group Ltd.", ticker: "DUO" },
    { name: "GERN - GERON CORP", ticker: "GERN" },
    { name: "ARCH - ARCH RESOURCES, INC.", ticker: "ARCH" },
    { name: "SEII - SHARING ECONOMY INTERNATIONAL INC.", ticker: "SEII" },
    { name: "FMCB - FARMERS & MERCHANTS BANCORP", ticker: "FMCB" },
    { name: "GEL - GENESIS ENERGY LP", ticker: "GEL" },
    { name: "GGN - GAMCO Global Gold, Natural Resources & Income Trust", ticker: "GGN" },
    { name: "ATEN - A10 Networks, Inc.", ticker: "ATEN" },
    { name: "BANC - BANC OF CALIFORNIA, INC.", ticker: "BANC" },
    { name: "DNOW - NOW Inc.", ticker: "DNOW" },
    { name: "AVRO - AVROBIO, Inc.", ticker: "AVRO" },
    { name: "EXTR - EXTREME NETWORKS INC", ticker: "EXTR" },
    { name: "MAXN - Maxeon Solar Technologies, Ltd.", ticker: "MAXN" },
    { name: "NSRPF - Novo Resources Corp.", ticker: "NSRPF" },
    { name: "YI - 111, Inc.", ticker: "YI" },
    { name: "INN - Summit Hotel Properties, Inc.", ticker: "INN" },
    { name: "EFC - Ellington Financial Inc.", ticker: "EFC" },
    { name: "NPK - NATIONAL PRESTO INDUSTRIES INC", ticker: "NPK" },
    { name: "SRDX - SURMODICS INC", ticker: "SRDX" },
    { name: "CAPL - CrossAmerica Partners LP", ticker: "CAPL" },
    { name: "VNDA - Vanda Pharmaceuticals Inc.", ticker: "VNDA" },
    { name: "TCPC - BlackRock TCP Capital Corp.", ticker: "TCPC" },
    { name: "CPAA - Conyers Park II Acquisition Corp.", ticker: "CPAA" },
    { name: "NFBK - Northfield Bancorp, Inc.", ticker: "NFBK" },
    { name: "ADTN - ADTRAN INC", ticker: "ADTN" },
    { name: "ICHR - ICHOR HOLDINGS, LTD.", ticker: "ICHR" },
    { name: "CTAGY - Capita Group/ADR", ticker: "CTAGY" },
    { name: "BHLB - BERKSHIRE HILLS BANCORP INC", ticker: "BHLB" },
    { name: "GRPN - Groupon, Inc.", ticker: "GRPN" },
    { name: "IVA - Inventiva S.A.", ticker: "IVA" },
    { name: "OPT - Opthea Ltd", ticker: "OPT" },
    { name: "GSBC - GREAT SOUTHERN BANCORP, INC.", ticker: "GSBC" },
    { name: "FRLN - Freeline Therapeutics Holdings plc", ticker: "FRLN" },
    { name: "SPPI - SPECTRUM PHARMACEUTICALS INC", ticker: "SPPI" },
    { name: "PTHIY - PT Solusi Bangun Indonesia TBK/ADR", ticker: "PTHIY" },
    { name: "CTBI - COMMUNITY TRUST BANCORP INC /KY/", ticker: "CTBI" },
    { name: "OBNK - Origin Bancorp, Inc.", ticker: "OBNK" },
    { name: "USAT - USA TECHNOLOGIES INC", ticker: "USAT" },
    { name: "ACB - AURORA CANNABIS INC", ticker: "ACB" },
    { name: "EXK - ENDEAVOUR SILVER CORP", ticker: "EXK" },
    { name: "IHRT - iHeartMedia, Inc.", ticker: "IHRT" },
    { name: "VREX - Varex Imaging Corp", ticker: "VREX" },
    { name: "UFCS - UNITED FIRE GROUP INC", ticker: "UFCS" },
    { name: "BQ - Boqii Holding Ltd", ticker: "BQ" },
    { name: "XBIT - XBiotech Inc.", ticker: "XBIT" },
    { name: "HWKN - HAWKINS INC", ticker: "HWKN" },
    { name: "RLMD - RELMADA THERAPEUTICS, INC.", ticker: "RLMD" },
    { name: "BLX - FOREIGN TRADE BANK OF LATIN AMERICA, INC.", ticker: "BLX" },
    { name: "INZY - Inozyme Pharma, Inc.", ticker: "INZY" },
    { name: "RAD - RITE AID CORP", ticker: "RAD" },
    { name: "AXGN - Axogen, Inc.", ticker: "AXGN" },
    { name: "MITK - MITEK SYSTEMS INC", ticker: "MITK" },
    { name: "LBAI - LAKELAND BANCORP INC", ticker: "LBAI" },
    { name: "FF - FutureFuel Corp.", ticker: "FF" },
    { name: "BKD - Brookdale Senior Living Inc.", ticker: "BKD" },
    { name: "UEIC - UNIVERSAL ELECTRONICS INC", ticker: "UEIC" },
    { name: "KOP - Koppers Holdings Inc.", ticker: "KOP" },
    { name: "AINV - APOLLO INVESTMENT CORP", ticker: "AINV" },
    { name: "GHIV - Gores Holdings IV, Inc.", ticker: "GHIV" },
    { name: "CVM - CEL SCI CORP", ticker: "CVM" },
    { name: "CLNE - Clean Energy Fuels Corp.", ticker: "CLNE" },
    { name: "TBBK - Bancorp, Inc.", ticker: "TBBK" },
    { name: "BBAR - Banco BBVA Argentina S.A.", ticker: "BBAR" },
    { name: "TRST - TRUSTCO BANK CORP N Y", ticker: "TRST" },
    { name: "REVG - REV Group, Inc.", ticker: "REVG" },
    { name: "MDP - MEREDITH CORP", ticker: "MDP" },
    { name: "HONE - HarborOne Bancorp, Inc.", ticker: "HONE" },
    { name: "SCSC - SCANSOURCE, INC.", ticker: "SCSC" },
    { name: "HBNC - HORIZON BANCORP INC /IN/", ticker: "HBNC" },
    { name: "ERII - Energy Recovery, Inc.", ticker: "ERII" },
    { name: "LCA - Landcadia Holdings II, Inc.", ticker: "LCA" },
    { name: "FUSN - Fusion Pharmaceuticals Inc.", ticker: "FUSN" },
    { name: "CMBM - Cambium Networks Corp", ticker: "CMBM" },
    { name: "PLYA - Playa Hotels & Resorts N.V.", ticker: "PLYA" },
    { name: "COE - China Online Education Group", ticker: "COE" },
    { name: "ZIOP - ZIOPHARM ONCOLOGY INC", ticker: "ZIOP" },
    { name: "APRE - Aprea Therapeutics, Inc.", ticker: "APRE" },
    { name: "ATRS - ANTARES PHARMA, INC.", ticker: "ATRS" },
    { name: "DLTH - DULUTH HOLDINGS INC.", ticker: "DLTH" },
    { name: "MYE - MYERS INDUSTRIES INC", ticker: "MYE" },
    { name: "BCOR - BLUCORA, INC.", ticker: "BCOR" },
    { name: "BY - BYLINE BANCORP, INC.", ticker: "BY" },
    { name: "GMHI - Gores Metropoulos, Inc.", ticker: "GMHI" },
    { name: "SIGA - SIGA TECHNOLOGIES INC", ticker: "SIGA" },
    { name: "GSAT - Globalstar, Inc.", ticker: "GSAT" },
    { name: "PFBC - Preferred Bank", ticker: "PFBC" },
    { name: "BCEL - Atreca, Inc.", ticker: "BCEL" },
    { name: "TG - TREDEGAR CORP", ticker: "TG" },
    { name: "NAK - NORTHERN DYNASTY MINERALS LTD", ticker: "NAK" },
    { name: "ANIK - Anika Therapeutics, Inc.", ticker: "ANIK" },
    { name: "AKBA - Akebia Therapeutics, Inc.", ticker: "AKBA" },
    { name: "FLDM - FLUIDIGM CORP", ticker: "FLDM" },
    { name: "TRUE - TrueCar, Inc.", ticker: "TRUE" },
    { name: "TALO - TALOS ENERGY INC.", ticker: "TALO" },
    { name: "FBMS - FIRST BANCSHARES INC /MS/", ticker: "FBMS" },
    { name: "NAT - NORDIC AMERICAN TANKERS Ltd", ticker: "NAT" },
    { name: "MTEM - Molecular Templates, Inc.", ticker: "MTEM" },
    { name: "TRVG - trivago N.V.", ticker: "TRVG" },
    { name: "PTEN - PATTERSON UTI ENERGY INC", ticker: "PTEN" },
    { name: "LSF - Laird Superfood, Inc.", ticker: "LSF" },
    { name: "TRMD - TORM plc", ticker: "TRMD" },
    { name: "TCS - Container Store Group, Inc.", ticker: "TCS" },
    { name: "IVR - Invesco Mortgage Capital Inc.", ticker: "IVR" },
    { name: "RIG - Transocean Ltd.", ticker: "RIG" },
    { name: "CLVS - Clovis Oncology, Inc.", ticker: "CLVS" },
    { name: "ASMB - ASSEMBLY BIOSCIENCES, INC.", ticker: "ASMB" },
    { name: "HYAC - Haymaker Acquisition Corp. II", ticker: "HYAC" },
    { name: "DGII - DIGI INTERNATIONAL INC", ticker: "DGII" },
    { name: "GOGL - Golden Ocean Group Ltd", ticker: "GOGL" },
    { name: "EH - EHang Holdings Ltd", ticker: "EH" },
    { name: "APLT - Applied Therapeutics Inc.", ticker: "APLT" },
    { name: "TSHMY - Toshiba Machine Co., Ltd. / ADR", ticker: "TSHMY" },
    { name: "HPK - HighPeak Energy, Inc.", ticker: "HPK" },
    { name: "BOOM - DMC Global Inc.", ticker: "BOOM" },
    { name: "LBC - Luther Burbank Corp", ticker: "LBC" },
    { name: "CRNX - Crinetics Pharmaceuticals, Inc.", ticker: "CRNX" },
    { name: "MX - MAGNACHIP SEMICONDUCTOR Corp", ticker: "MX" },
    { name: "APTO - Aptose Biosciences Inc.", ticker: "APTO" },
    { name: "DESP - Despegar.com, Corp.", ticker: "DESP" },
    { name: "AMSWA - AMERICAN SOFTWARE INC", ticker: "AMSWA" },
    { name: "FIXX - Homology Medicines, Inc.", ticker: "FIXX" },
    { name: "BFC - Bank First Corp", ticker: "BFC" },
    { name: "ALGS - Aligos Therapeutics, Inc.", ticker: "ALGS" },
    { name: "ETNB - 89bio, Inc.", ticker: "ETNB" },
    { name: "NLTX - Neoleukin Therapeutics, Inc.", ticker: "NLTX" },
    { name: "CFB - CROSSFIRST BANKSHARES, INC.", ticker: "CFB" },
    { name: "MITFY - Mitie Group plc/ADR", ticker: "MITFY" },
    { name: "MGTX - MeiraGTx Holdings plc", ticker: "MGTX" },
    { name: "GLP - GLOBAL PARTNERS LP", ticker: "GLP" },
    { name: "CGBD - TCG BDC, INC.", ticker: "CGBD" },
    { name: "NPACY - Quadient S.A./ADR", ticker: "NPACY" },
    { name: "LOVE - Lovesac Co", ticker: "LOVE" },
    { name: "CAC - CAMDEN NATIONAL CORP", ticker: "CAC" },
    { name: "STRL - STERLING CONSTRUCTION CO INC", ticker: "STRL" },
    { name: "DFIN - Donnelley Financial Solutions, Inc.", ticker: "DFIN" },
    { name: "ADVV - Adveco Group Inc.", ticker: "ADVV" },
    { name: "GTHX - G1 Therapeutics, Inc.", ticker: "GTHX" },
    { name: "URGN - UroGen Pharma Ltd.", ticker: "URGN" },
    { name: "QCRH - QCR HOLDINGS INC", ticker: "QCRH" },
    { name: "SCVL - SHOE CARNIVAL INC", ticker: "SCVL" },
    { name: "GPRK - GeoPark Ltd", ticker: "GPRK" },
    { name: "VEC - Vectrus, Inc.", ticker: "VEC" },
    { name: "ZYXI - ZYNEX INC", ticker: "ZYXI" },
    { name: "CBTX - CBTX, Inc.", ticker: "CBTX" },
    { name: "ARDX - ARDELYX, INC.", ticker: "ARDX" },
    { name: "BCOV - BRIGHTCOVE INC", ticker: "BCOV" },
    { name: "LE - LANDS' END, INC.", ticker: "LE" },
    { name: "BOMN - BOSTON OMAHA Corp", ticker: "BOMN" },
    { name: "NGL - NGL Energy Partners LP", ticker: "NGL" },
    { name: "VRAY - ViewRay, Inc.", ticker: "VRAY" },
    { name: "THFF - FIRST FINANCIAL CORP /IN/", ticker: "THFF" },
    { name: "MIRM - Mirum Pharmaceuticals, Inc.", ticker: "MIRM" },
    { name: "BBSI - BARRETT BUSINESS SERVICES INC", ticker: "BBSI" },
    { name: "MERC - MERCER INTERNATIONAL INC.", ticker: "MERC" },
    { name: "KOS - Kosmos Energy Ltd.", ticker: "KOS" },
    { name: "CLAR - Clarus Corp", ticker: "CLAR" },
    { name: "NTST - NETSTREIT Corp.", ticker: "NTST" },
    { name: "WISM - Wiseman Global Ltd", ticker: "WISM" },
    { name: "CHUY - CHUY'S HOLDINGS, INC.", ticker: "CHUY" },
    { name: "MNKD - MANNKIND CORP", ticker: "MNKD" },
    { name: "REX - REX AMERICAN RESOURCES Corp", ticker: "REX" },
    { name: "SVA - SINOVAC BIOTECH LTD", ticker: "SVA" },
    { name: "USX - US XPRESS ENTERPRISES INC", ticker: "USX" },
    { name: "CDMO - Avid Bioservices, Inc.", ticker: "CDMO" },
    { name: "LPG - DORIAN LPG LTD.", ticker: "LPG" },
    { name: "ORTX - Orchard Therapeutics plc", ticker: "ORTX" },
    { name: "DHIL - DIAMOND HILL INVESTMENT GROUP INC", ticker: "DHIL" },
    { name: "EFR - EATON VANCE SENIOR FLOATING RATE TRUST", ticker: "EFR" },
    { name: "DMRC - Digimarc CORP", ticker: "DMRC" },
    { name: "FMBH - FIRST MID BANCSHARES, INC.", ticker: "FMBH" },
    { name: "UVSP - UNIVEST FINANCIAL Corp", ticker: "UVSP" },
    { name: "DVAX - DYNAVAX TECHNOLOGIES CORP", ticker: "DVAX" },
    { name: "HYMC - HYCROFT MINING HOLDING CORP", ticker: "HYMC" },
    { name: "NVGS - Navigator Holdings Ltd.", ticker: "NVGS" },
    { name: "NSSC - NAPCO SECURITY TECHNOLOGIES, INC", ticker: "NSSC" },
    { name: "WOW - WideOpenWest, Inc.", ticker: "WOW" },
    { name: "PRTA - PROTHENA CORP PUBLIC LTD CO", ticker: "PRTA" },
    { name: "ERF - ENERPLUS Corp", ticker: "ERF" },
    { name: "HVT - HAVERTY FURNITURE COMPANIES INC", ticker: "HVT" },
    { name: "KNOP - KNOT Offshore Partners LP", ticker: "KNOP" },
    { name: "LIND - LINDBLAD EXPEDITIONS HOLDINGS, INC.", ticker: "LIND" },
    { name: "SEZNL - Sezzle Inc.", ticker: "SEZNL" },
    { name: "CCO - Clear Channel Outdoor Holdings, Inc.", ticker: "CCO" },
    { name: "BVXV - BiondVax Pharmaceuticals Ltd.", ticker: "BVXV" },
    { name: "GAN - GAN Ltd", ticker: "GAN" },
    { name: "CATC - CAMBRIDGE BANCORP", ticker: "CATC" },
    { name: "MMRTY - MASSMART HOLDINGS LTD", ticker: "MMRTY" },
    { name: "PEBO - PEOPLES BANCORP INC", ticker: "PEBO" },
    { name: "MUX - McEwen Mining Inc.", ticker: "MUX" },
    { name: "TXMD - TherapeuticsMD, Inc.", ticker: "TXMD" },
    { name: "TCDA - Tricida, Inc.", ticker: "TCDA" },
    { name: "BZH - BEAZER HOMES USA INC", ticker: "BZH" },
    { name: "PUMP - ProPetro Holding Corp.", ticker: "PUMP" },
    { name: "KALA - Kala Pharmaceuticals, Inc.", ticker: "KALA" },
    { name: "QK - Q&K INTERNATIONAL GROUP Ltd", ticker: "QK" },
    { name: "VVI - VIAD CORP", ticker: "VVI" },
    { name: "APEI - AMERICAN PUBLIC EDUCATION INC", ticker: "APEI" },
    { name: "UVE - UNIVERSAL INSURANCE HOLDINGS, INC.", ticker: "UVE" },
    { name: "MDRPF - MIDAS GOLD CORP.", ticker: "MDRPF" },
    { name: "EBF - ENNIS, INC.", ticker: "EBF" },
    { name: "RIGL - RIGEL PHARMACEUTICALS INC", ticker: "RIGL" },
    { name: "KCAC - Kensington Capital Acquisition Corp.", ticker: "KCAC" },
    { name: "ASIX - AdvanSix Inc.", ticker: "ASIX" },
    { name: "VET - VERMILION ENERGY INC.", ticker: "VET" },
    { name: "GDYN - GRID DYNAMICS HOLDINGS, INC.", ticker: "GDYN" },
    { name: "STRO - SUTRO BIOPHARMA, INC.", ticker: "STRO" },
    { name: "VYGR - Voyager Therapeutics, Inc.", ticker: "VYGR" },
    { name: "ELLO - Ellomay Capital Ltd.", ticker: "ELLO" },
    { name: "MRNS - MARINUS PHARMACEUTICALS INC", ticker: "MRNS" },
    { name: "WSBF - Waterstone Financial, Inc.", ticker: "WSBF" },
    { name: "AVD - AMERICAN VANGUARD CORP", ticker: "AVD" },
    { name: "AOSL - ALPHA & OMEGA SEMICONDUCTOR Ltd", ticker: "AOSL" },
    { name: "ESTA - ESTABLISHMENT LABS HOLDINGS INC.", ticker: "ESTA" },
    { name: "HTBK - HERITAGE COMMERCE CORP", ticker: "HTBK" },
    { name: "WUYI - China WuYi Mountain, Ltd.", ticker: "WUYI" },
    { name: "CO - Global Cord Blood Corp", ticker: "CO" },
    { name: "TRVN - TREVENA INC", ticker: "TRVN" },
    { name: "CSV - CARRIAGE SERVICES INC", ticker: "CSV" },
    { name: "FSP - FRANKLIN STREET PROPERTIES CORP /MA/", ticker: "FSP" },
    { name: "BMRC - Bank of Marin Bancorp", ticker: "BMRC" },
    { name: "BYSI - BeyondSpring Inc.", ticker: "BYSI" },
    { name: "JAGGF - Jaguar Mining Inc", ticker: "JAGGF" },
    { name: "TLSA - Tiziana Life Sciences plc", ticker: "TLSA" },
    { name: "ARLO - Arlo Technologies, Inc.", ticker: "ARLO" },
    { name: "AROW - ARROW FINANCIAL CORP", ticker: "AROW" },
    { name: "ORGO - Organogenesis Holdings Inc.", ticker: "ORGO" },
    { name: "HSII - HEIDRICK & STRUGGLES INTERNATIONAL INC", ticker: "HSII" },
    { name: "DSKE - Daseke, Inc.", ticker: "DSKE" },
    { name: "ETH - ETHAN ALLEN INTERIORS INC", ticker: "ETH" },
    { name: "CRDF - Cardiff Oncology, Inc.", ticker: "CRDF" },
    { name: "NEX - NEXTIER OILFIELD SOLUTIONS INC.", ticker: "NEX" },
    { name: "ANGO - ANGIODYNAMICS INC", ticker: "ANGO" },
    { name: "AMOT - ALLIED MOTION TECHNOLOGIES INC", ticker: "AMOT" },
    { name: "AMSC - AMERICAN SUPERCONDUCTOR CORP /DE/", ticker: "AMSC" },
    { name: "TRNE - Trine Acquisition Corp.", ticker: "TRNE" },
    { name: "SGU - STAR GROUP, L.P.", ticker: "SGU" },
    { name: "DGICA - DONEGAL GROUP INC", ticker: "DGICA" },
    { name: "CUE - Cue Biopharma, Inc.", ticker: "CUE" },
    { name: "BCEI - Bonanza Creek Energy, Inc.", ticker: "BCEI" },
    { name: "SLN - Silence Therapeutics plc", ticker: "SLN" },
    { name: "LAWS - LAWSON PRODUCTS INC/NEW/DE/", ticker: "LAWS" },
    { name: "VHC - VirnetX Holding Corp", ticker: "VHC" },
    { name: "DMS - Digital Media Solutions, Inc.", ticker: "DMS" },
    { name: "SPNE - SeaSpine Holdings Corp", ticker: "SPNE" },
    { name: "ESGC - Eros International PLC", ticker: "ESGC" },
    { name: "CNSL - Consolidated Communications Holdings, Inc.", ticker: "CNSL" },
    { name: "SBR - SABINE ROYALTY TRUST", ticker: "SBR" },
    { name: "SRRK - Scholar Rock Holding Corp", ticker: "SRRK" },
    { name: "AMTB - Amerant Bancorp Inc.", ticker: "AMTB" },
    { name: "CMTL - COMTECH TELECOMMUNICATIONS CORP /DE/", ticker: "CMTL" },
    { name: "CTT - CatchMark Timber Trust, Inc.", ticker: "CTT" },
    { name: "CPSI - COMPUTER PROGRAMS & SYSTEMS INC", ticker: "CPSI" },
    { name: "TARS - Tarsus Pharmaceuticals, Inc.", ticker: "TARS" },
    { name: "VIOT - Viomi Technology Co., Ltd", ticker: "VIOT" },
    { name: "CUBI - Customers Bancorp, Inc.", ticker: "CUBI" },
    { name: "QD - Qudian Inc.", ticker: "QD" },
    { name: "KNDI - Kandi Technologies Group, Inc.", ticker: "KNDI" },
    { name: "WIMI - WiMi Hologram Cloud Inc.", ticker: "WIMI" },
    { name: "CPF - CENTRAL PACIFIC FINANCIAL CORP", ticker: "CPF" },
    { name: "INSW - International Seaways, Inc.", ticker: "INSW" },
    { name: "VKTX - Viking Therapeutics, Inc.", ticker: "VKTX" },
    { name: "IIIN - INSTEEL INDUSTRIES INC", ticker: "IIIN" },
    { name: "TILE - INTERFACE INC", ticker: "TILE" },
    { name: "WVE - Wave Life Sciences Ltd.", ticker: "WVE" },
    { name: "JPDYY - Japan Display Inc./ADR", ticker: "JPDYY" },
    { name: "HCKT - HACKETT GROUP, INC.", ticker: "HCKT" },
    { name: "DCO - DUCOMMUN INC /DE/", ticker: "DCO" },
    { name: "SP - SP Plus Corp", ticker: "SP" },
    { name: "HLX - HELIX ENERGY SOLUTIONS GROUP INC", ticker: "HLX" },
    { name: "BBDC - Barings BDC, Inc.", ticker: "BBDC" },
    { name: "RNLX - Renalytix AI plc", ticker: "RNLX" },
    { name: "MRC - MRC GLOBAL INC.", ticker: "MRC" },
    { name: "HEBT - HEBRON TECHNOLOGY CO., LTD", ticker: "HEBT" },
    { name: "IRS - IRSA INVESTMENTS & REPRESENTATIONS INC", ticker: "IRS" },
    { name: "QH - QUHUO Ltd", ticker: "QH" },
    { name: "THR - Thermon Group Holdings, Inc.", ticker: "THR" },
    { name: "FRPH - FRP HOLDINGS, INC.", ticker: "FRPH" },
    { name: "OPRT - Oportun Financial Corp", ticker: "OPRT" },
    { name: "RTTO - Rito Group Corp.", ticker: "RTTO" },
    { name: "YJ - Yunji Inc.", ticker: "YJ" },
    { name: "OII - OCEANEERING INTERNATIONAL INC", ticker: "OII" },
    { name: "HFFG - HF Foods Group Inc.", ticker: "HFFG" },
    { name: "CODX - Co-Diagnostics, Inc.", ticker: "CODX" },
    { name: "KMDA - KAMADA LTD", ticker: "KMDA" },
    { name: "VMD - VIEMED HEALTHCARE, INC.", ticker: "VMD" },
    { name: "HUIZ - Huize Holding Ltd", ticker: "HUIZ" },
    { name: "SPRB - SPRUCE BIOSCIENCES, INC.", ticker: "SPRB" },
    { name: "AWH - Aspira Women's Health Inc.", ticker: "AWH" },
    { name: "BKT - BLACKROCK INCOME TRUST, INC.", ticker: "BKT" },
    { name: "ACAM - Acamar Partners Acquisition Corp.", ticker: "ACAM" },
    { name: "FBRX - Forte Biosciences, Inc.", ticker: "FBRX" },
    { name: "FI - FRANK'S INTERNATIONAL N.V.", ticker: "FI" },
    { name: "MCFT - MasterCraft Boat Holdings, Inc.", ticker: "MCFT" },
    { name: "HCAC - Hennessy Capital Acquisition Corp IV", ticker: "HCAC" },
    { name: "FLIC - FIRST OF LONG ISLAND CORP", ticker: "FLIC" },
    { name: "TRC - TEJON RANCH CO", ticker: "TRC" },
    { name: "SENEA - Seneca Foods Corp", ticker: "SENEA" },
    { name: "UXIN - Uxin Ltd", ticker: "UXIN" },
    { name: "CSTE - Caesarstone Ltd.", ticker: "CSTE" },
    { name: "BOMH - BOOMER HOLDINGS, INC.", ticker: "BOMH" },
    { name: "DJCO - DAILY JOURNAL CORP", ticker: "DJCO" },
    { name: "PLM - POLYMET MINING CORP", ticker: "PLM" },
    { name: "BDGE - BRIDGE BANCORP, INC.", ticker: "BDGE" },
    { name: "CURI - CuriosityStream Inc.", ticker: "CURI" },
    { name: "ALRS - ALERUS FINANCIAL CORP", ticker: "ALRS" },
    { name: "DBI - Designer Brands Inc.", ticker: "DBI" },
    { name: "HARP - Harpoon Therapeutics, Inc.", ticker: "HARP" },
    { name: "DMYT - dMY Technology Group, Inc.", ticker: "DMYT" },
    { name: "FLNG - Flex LNG Ltd.", ticker: "FLNG" },
    { name: "MRUS - Merus N.V.", ticker: "MRUS" },
    { name: "PROG - PROGENITY, INC.", ticker: "PROG" },
    { name: "MBI - MBIA INC", ticker: "MBI" },
    { name: "MCBS - MetroCity Bankshares, Inc.", ticker: "MCBS" },
    { name: "TGI - TRIUMPH GROUP INC", ticker: "TGI" },
    { name: "HCI - HCI Group, Inc.", ticker: "HCI" },
    { name: "NEWT - Newtek Business Services Corp.", ticker: "NEWT" },
    { name: "SGC - SUPERIOR GROUP OF COMPANIES, INC.", ticker: "SGC" },
    { name: "SOAC - Sustainable Opportunities Acquisition Corp.", ticker: "SOAC" },
    { name: "VHI - VALHI INC /DE/", ticker: "VHI" },
    { name: "DRRX - DURECT CORP", ticker: "DRRX" },
    { name: "PBYI - PUMA BIOTECHNOLOGY, INC.", ticker: "PBYI" },
    { name: "ALT - Altimmune, Inc.", ticker: "ALT" },
    { name: "NDLS - NOODLES & Co", ticker: "NDLS" },
    { name: "PARR - PAR PACIFIC HOLDINGS, INC.", ticker: "PARR" },
    { name: "XENE - Xenon Pharmaceuticals Inc.", ticker: "XENE" },
    { name: "DDLX - DD's Deluxe Rod Holder, Inc.", ticker: "DDLX" },
    { name: "GPMT - Granite Point Mortgage Trust Inc.", ticker: "GPMT" },
    { name: "RUBY - Rubius Therapeutics, Inc.", ticker: "RUBY" },
    { name: "BCYC - BICYCLE THERAPEUTICS plc", ticker: "BCYC" },
    { name: "OSMT - Osmotica Pharmaceuticals plc", ticker: "OSMT" },
    { name: "SURF - Surface Oncology, Inc.", ticker: "SURF" },
    { name: "AMAL - Amalgamated Financial Corp.", ticker: "AMAL" },
    { name: "RGP - RESOURCES CONNECTION INC", ticker: "RGP" },
    { name: "GRAM - Grana & Montero S.A.A.", ticker: "GRAM" },
    { name: "SMLR - Semler Scientific, Inc.", ticker: "SMLR" },
    { name: "GDEN - GOLDEN ENTERTAINMENT, INC.", ticker: "GDEN" },
    { name: "IDYA - IDEAYA Biosciences, Inc.", ticker: "IDYA" },
    { name: "DX - DYNEX CAPITAL INC", ticker: "DX" },
    { name: "KRP - Kimbell Royalty Partners, LP", ticker: "KRP" },
    { name: "IGIC - International General Insurance Holdings Ltd.", ticker: "IGIC" },
    { name: "HEXO - HEXO Corp.", ticker: "HEXO" },
    { name: "IMUX - IMMUNIC, INC.", ticker: "IMUX" },
    { name: "RDHL - RedHill Biopharma Ltd.", ticker: "RDHL" },
    { name: "MOD - MODINE MANUFACTURING CO", ticker: "MOD" },
    { name: "BMTM - Bright Mountain Media, Inc.", ticker: "BMTM" },
    { name: "LXFR - LUXFER HOLDINGS PLC", ticker: "LXFR" },
    { name: "ORPH - Orphazyme A/S", ticker: "ORPH" },
    { name: "SSDT - Shengshi Elevator International Holding Group Inc.", ticker: "SSDT" },
    { name: "RPLA - Replay Acquisition Corp.", ticker: "RPLA" },
    { name: "SSTI - SHOTSPOTTER, INC", ticker: "SSTI" },
    { name: "THCB - Tuscan Holdings Corp.", ticker: "THCB" },
    { name: "KLDI - KLDiscovery Inc.", ticker: "KLDI" },
    { name: "WEI - Weidai Ltd.", ticker: "WEI" },
    { name: "DMLP - DORCHESTER MINERALS, L.P.", ticker: "DMLP" },
    { name: "CTSO - Cytosorbents Corp", ticker: "CTSO" },
    { name: "PLCE - Childrens Place, Inc.", ticker: "PLCE" },
    { name: "GLDG - GoldMining Inc.", ticker: "GLDG" },
    { name: "SYRS - Syros Pharmaceuticals, Inc.", ticker: "SYRS" },
    { name: "CCAP - Crescent Capital BDC, Inc.", ticker: "CCAP" },
    { name: "WTTR - Select Energy Services, Inc.", ticker: "WTTR" },
    { name: "AGLE - Aeglea BioTherapeutics, Inc.", ticker: "AGLE" },
    { name: "CASA - Casa Systems Inc", ticker: "CASA" },
    { name: "RMT - ROYCE MICRO-CAP TRUST, INC.", ticker: "RMT" },
    { name: "LEGH - Legacy Housing Corp", ticker: "LEGH" },
    { name: "NODK - NI Holdings, Inc.", ticker: "NODK" },
    { name: "CLDT - Chatham Lodging Trust", ticker: "CLDT" },
    { name: "ORC - Orchid Island Capital, Inc.", ticker: "ORC" },
    { name: "CCBG - CAPITAL CITY BANK GROUP INC", ticker: "CCBG" },
    { name: "MBWM - MERCANTILE BANK CORP", ticker: "MBWM" },
    { name: "VPG - Vishay Precision Group, Inc.", ticker: "VPG" },
    { name: "ALLT - Allot Ltd.", ticker: "ALLT" },
    { name: "WLDN - Willdan Group, Inc.", ticker: "WLDN" },
    { name: "HOFT - HOOKER FURNITURE CORP", ticker: "HOFT" },
    { name: "CONN - CONNS INC", ticker: "CONN" },
    { name: "HAWEL - HAWAIIAN ELECTRIC CO INC", ticker: "HAWEL" },
    { name: "REDU - RISE Education Cayman Ltd", ticker: "REDU" },
    { name: "EVI - EVI INDUSTRIES, INC.", ticker: "EVI" },
    { name: "UCL - uCloudlink Group Inc.", ticker: "UCL" },
    { name: "IBIO - iBio, Inc.", ticker: "IBIO" },
    { name: "TMDX - TransMedics Group, Inc.", ticker: "TMDX" },
    { name: "LC - LendingClub Corp", ticker: "LC" },
    { name: "TNK - TEEKAY TANKERS LTD.", ticker: "TNK" },
    { name: "PUYI - PUYI, INC.", ticker: "PUYI" },
    { name: "HBT - HBT Financial, Inc.", ticker: "HBT" },
    { name: "CDZI - CADIZ INC", ticker: "CDZI" },
    { name: "CRD-A - CRAWFORD & CO", ticker: "CRD-A" },
    { name: "PLSE - Pulse Biosciences, Inc.", ticker: "PLSE" },
    { name: "VSEC - VSE CORP", ticker: "VSEC" },
    { name: "TAST - CARROLS RESTAURANT GROUP, INC.", ticker: "TAST" },
    { name: "GBL - GAMCO INVESTORS, INC. ET AL", ticker: "GBL" },
    { name: "SPRO - Spero Therapeutics, Inc.", ticker: "SPRO" },
    { name: "PROF - Profound Medical Corp.", ticker: "PROF" },
    { name: "ANIP - ANI PHARMACEUTICALS INC", ticker: "ANIP" },
    { name: "FCBC - FIRST COMMUNITY BANKSHARES INC /VA/", ticker: "FCBC" },
    { name: "WTRH - Waitr Holdings Inc.", ticker: "WTRH" },
    { name: "YRD - Yiren Digital Ltd.", ticker: "YRD" },
    { name: "CPRX - CATALYST PHARMACEUTICALS, INC.", ticker: "CPRX" },
    { name: "ARLP - ALLIANCE RESOURCE PARTNERS LP", ticker: "ARLP" },
    { name: "TITN - Titan Machinery Inc.", ticker: "TITN" },
    { name: "CURO - CURO Group Holdings Corp.", ticker: "CURO" },
    { name: "ONCR - Oncorus, Inc.", ticker: "ONCR" },
    { name: "OVID - Ovid Therapeutics Inc.", ticker: "OVID" },
    { name: "ARTNA - ARTESIAN RESOURCES CORP", ticker: "ARTNA" },
    { name: "CUTR - CUTERA INC", ticker: "CUTR" },
    { name: "BFST - Business First Bancshares, Inc.", ticker: "BFST" },
    { name: "AMC - AMC ENTERTAINMENT HOLDINGS, INC.", ticker: "AMC" },
    { name: "CAL - CALERES INC", ticker: "CAL" },
    { name: "CCAC - CITIC Capital Acquisition Corp.", ticker: "CCAC" },
    { name: "TPVG - TriplePoint Venture Growth BDC Corp.", ticker: "TPVG" },
    { name: "MOFG - MidWestOne Financial Group, Inc.", ticker: "MOFG" },
    { name: "MVIS - MICROVISION, INC.", ticker: "MVIS" },
    { name: "RRBI - RED RIVER BANCSHARES INC", ticker: "RRBI" },
    { name: "SI - Silvergate Capital Corp", ticker: "SI" },
    { name: "MGTA - Magenta Therapeutics, Inc.", ticker: "MGTA" },
    { name: "ACIU - AC Immune SA", ticker: "ACIU" },
    { name: "DTIL - PRECISION BIOSCIENCES INC", ticker: "DTIL" },
    { name: "LQDT - LIQUIDITY SERVICES INC", ticker: "LQDT" },
    { name: "SUPV - Grupo Supervielle S.A.", ticker: "SUPV" },
    { name: "MLR - MILLER INDUSTRIES INC /TN/", ticker: "MLR" },
    { name: "FFIC - FLUSHING FINANCIAL CORP", ticker: "FFIC" },
    { name: "OOMA - OOMA INC", ticker: "OOMA" },
    { name: "AGMH - AGM GROUP HOLDINGS, INC.", ticker: "AGMH" },
    { name: "OLP - ONE LIBERTY PROPERTIES INC", ticker: "OLP" },
    { name: "GBLI - Global Indemnity Group, LLC", ticker: "GBLI" },
    { name: "MGI - MONEYGRAM INTERNATIONAL INC", ticker: "MGI" },
    { name: "VFF - Village Farms International, Inc.", ticker: "VFF" },
    { name: "ITRN - Ituran Location & Control Ltd.", ticker: "ITRN" },
    { name: "FMNB - FARMERS NATIONAL BANC CORP /OH/", ticker: "FMNB" },
    { name: "COMS - ComSovereign Holding Corp.", ticker: "COMS" },
    { name: "AXAS - ABRAXAS PETROLEUM CORP", ticker: "AXAS" },
    { name: "GRAY - GRAYBUG VISION, INC.", ticker: "GRAY" },
    { name: "GRIF - GRIFFIN INDUSTRIAL REALTY, INC.", ticker: "GRIF" },
    { name: "BHB - BAR HARBOR BANKSHARES", ticker: "BHB" },
    { name: "ASPN - ASPEN AEROGELS INC", ticker: "ASPN" },
    { name: "CAAP - CORPORACION AMERICA AIRPORTS S.A.", ticker: "CAAP" },
    { name: "VYNE - VYNE Therapeutics Inc.", ticker: "VYNE" },
    { name: "USAS - Americas Gold & Silver Corp", ticker: "USAS" },
    { name: "RNWEY - RENEWABLE ENERGY CORP ASA", ticker: "RNWEY" },
    { name: "THRY - Thryv Holdings, Inc.", ticker: "THRY" },
    { name: "LAND - GLADSTONE LAND Corp", ticker: "LAND" },
    { name: "OPRX - OptimizeRx Corp", ticker: "OPRX" },
    { name: "FREE - Whole Earth Brands, Inc.", ticker: "FREE" },
    { name: "NH - NantHealth, Inc.", ticker: "NH" },
    { name: "PFLT - PennantPark Floating Rate Capital Ltd.", ticker: "PFLT" },
    { name: "TUWOY - TULLOW OIL PLC /FI", ticker: "TUWOY" },
    { name: "ATHX - ATHERSYS, INC / NEW", ticker: "ATHX" },
    { name: "BLBD - Blue Bird Corp", ticker: "BLBD" },
    { name: "HCCO - Healthcare Merger Corp.", ticker: "HCCO" },
    { name: "BCLI - BRAINSTORM CELL THERAPEUTICS INC.", ticker: "BCLI" },
    { name: "MSBI - Midland States Bancorp, Inc.", ticker: "MSBI" },
    { name: "MTA - Metalla Royalty & Streaming Ltd.", ticker: "MTA" },
    { name: "VTRU - Vitru Ltd", ticker: "VTRU" },
    { name: "MEIP - MEI Pharma, Inc.", ticker: "MEIP" },
    { name: "CATN - CAT9 Group Inc.", ticker: "CATN" },
    { name: "EDN - EDENOR", ticker: "EDN" },
    { name: "NXTC - NextCure, Inc.", ticker: "NXTC" },
    { name: "CRESY - CRESUD INC", ticker: "CRESY" },
    { name: "SSPK - Silver Spike Acquisition Corp.", ticker: "SSPK" },
    { name: "STCB - Starco Brands, Inc.", ticker: "STCB" },
    { name: "PLYM - Plymouth Industrial REIT Inc.", ticker: "PLYM" },
    { name: "OPY - OPPENHEIMER HOLDINGS INC", ticker: "OPY" },
    { name: "TFFP - TFF Pharmaceuticals, Inc.", ticker: "TFFP" },
    { name: "BWB - Bridgewater Bancshares Inc", ticker: "BWB" },
    { name: "IPHA - Innate Pharma SA", ticker: "IPHA" },
    { name: "CRSA - Crescent Acquisition Corp", ticker: "CRSA" },
    { name: "SPKE - Spark Energy, Inc.", ticker: "SPKE" },
    { name: "AVXL - ANAVEX LIFE SCIENCES CORP.", ticker: "AVXL" },
    { name: "SXC - SunCoke Energy, Inc.", ticker: "SXC" },
    { name: "CVLG - COVENANT LOGISTICS GROUP, INC.", ticker: "CVLG" },
    { name: "IMRA - IMARA Inc.", ticker: "IMRA" },
    { name: "GNTY - GUARANTY BANCSHARES INC /TX/", ticker: "GNTY" },
    { name: "GMHLY - GAM Holding AG", ticker: "GMHLY" },
    { name: "ACRE - Ares Commercial Real Estate Corp", ticker: "ACRE" },
    { name: "CTMX - CytomX Therapeutics, Inc.", ticker: "CTMX" },
    { name: "HBB - Hamilton Beach Brands Holding Co", ticker: "HBB" },
    { name: "IBCP - INDEPENDENT BANK CORP /MI/", ticker: "IBCP" },
    { name: "PGC - PEAPACK GLADSTONE FINANCIAL CORP", ticker: "PGC" },
    { name: "LITB - LightInTheBox Holding Co., Ltd.", ticker: "LITB" },
    { name: "GAU - Galiano Gold Inc.", ticker: "GAU" },
    { name: "GNK - GENCO SHIPPING & TRADING LTD", ticker: "GNK" },
    { name: "CRAI - CRA INTERNATIONAL, INC.", ticker: "CRAI" },
    { name: "FFNTF - 4Front Ventures Corp.", ticker: "FFNTF" },
    { name: "MSB - MESABI TRUST", ticker: "MSB" },
    { name: "KXIN - Kaixin Auto Holdings", ticker: "KXIN" },
    { name: "CAN - Canaan Inc.", ticker: "CAN" },
    { name: "KE - Kimball Electronics, Inc.", ticker: "KE" },
    { name: "ONEW - OneWater Marine Inc.", ticker: "ONEW" },
    { name: "MOGU - MOGU Inc.", ticker: "MOGU" },
    { name: "ESCA - ESCALADE INC", ticker: "ESCA" },
    { name: "LRMR - Larimar Therapeutics, Inc.", ticker: "LRMR" },
    { name: "NEXT - NextDecade Corp.", ticker: "NEXT" },
    { name: "UTMD - UTAH MEDICAL PRODUCTS INC", ticker: "UTMD" },
    { name: "CDXC - ChromaDex Corp.", ticker: "CDXC" },
    { name: "FNKO - Funko, Inc.", ticker: "FNKO" },
    { name: "KALV - KalVista Pharmaceuticals, Inc.", ticker: "KALV" },
    { name: "TCLRY - Technicolor", ticker: "TCLRY" },
    { name: "RCAR - RenovaCare, Inc.", ticker: "RCAR" },
    { name: "AKTS - Akoustis Technologies, Inc.", ticker: "AKTS" },
    { name: "CIO - City Office REIT, Inc.", ticker: "CIO" },
    { name: "AVDL - AVADEL PHARMACEUTICALS PLC", ticker: "AVDL" },
    { name: "GILT - GILAT SATELLITE NETWORKS LTD", ticker: "GILT" },
    { name: "BSRR - SIERRA BANCORP", ticker: "BSRR" },
    { name: "HRTG - Heritage Insurance Holdings, Inc.", ticker: "HRTG" },
    { name: "KOR - Corvus Gold Inc.", ticker: "KOR" },
    { name: "LNDC - LANDEC CORP \\CA\\", ticker: "LNDC" },
    { name: "LEJU - Leju Holdings Ltd", ticker: "LEJU" },
    { name: "GAIN - GLADSTONE INVESTMENT CORPORATION\\DE", ticker: "GAIN" },
    { name: "POWL - POWELL INDUSTRIES INC", ticker: "POWL" },
    { name: "EIGR - Eiger BioPharmaceuticals, Inc.", ticker: "EIGR" },
    { name: "MTW - MANITOWOC CO INC", ticker: "MTW" },
    { name: "INS - INTELLIGENT SYSTEMS CORP", ticker: "INS" },
    { name: "DXPE - DXP ENTERPRISES INC", ticker: "DXPE" },
    { name: "HESM - Hess Midstream LP", ticker: "HESM" },
    { name: "CNLHN - CONNECTICUT LIGHT & POWER CO", ticker: "CNLHN" },
    { name: "GWGH - GWG Holdings, Inc.", ticker: "GWGH" },
    { name: "CIA - CITIZENS, INC.", ticker: "CIA" },
    { name: "UFPT - UFP TECHNOLOGIES INC", ticker: "UFPT" },
    { name: "RMG - RMG Acquisition Corp.", ticker: "RMG" },
    { name: "PIC - Pivotal Investment Corp II", ticker: "PIC" },
    { name: "GNUS - Genius Brands International, Inc.", ticker: "GNUS" },
    { name: "NWPX - NORTHWEST PIPE CO", ticker: "NWPX" },
    { name: "BLNK - Blink Charging Co.", ticker: "BLNK" },
    { name: "FOSL - Fossil Group, Inc.", ticker: "FOSL" },
    { name: "ALDX - Aldeyra Therapeutics, Inc.", ticker: "ALDX" },
    { name: "MPAA - MOTORCAR PARTS AMERICA INC", ticker: "MPAA" },
    { name: "GCO - GENESCO INC", ticker: "GCO" },
    { name: "CNTG - Centogene N.V.", ticker: "CNTG" },
    { name: "CTRN - Citi Trends Inc", ticker: "CTRN" },
    { name: "FULC - Fulcrum Therapeutics, Inc.", ticker: "FULC" },
    { name: "CLFD - Clearfield, Inc.", ticker: "CLFD" },
    { name: "ARAY - ACCURAY INC", ticker: "ARAY" },
    { name: "SOI - Solaris Oilfield Infrastructure, Inc.", ticker: "SOI" },
    { name: "CABA - Cabaletta Bio, Inc.", ticker: "CABA" },
    { name: "SCVX - SCVX Corp.", ticker: "SCVX" },
    { name: "HTZ - HERTZ GLOBAL HOLDINGS, INC", ticker: "HTZ" },
    { name: "NGVC - Natural Grocers by Vitamin Cottage, Inc.", ticker: "NGVC" },
    { name: "WTBA - WEST BANCORPORATION INC", ticker: "WTBA" },
    { name: "AFMD - Affimed N.V.", ticker: "AFMD" },
    { name: "LOOP - Loop Industries, Inc.", ticker: "LOOP" },
    { name: "GMDA - Gamida Cell Ltd.", ticker: "GMDA" },
    { name: "ACRDF - Acreage Holdings, Inc.", ticker: "ACRDF" },
    { name: "GRTX - Galera Therapeutics, Inc.", ticker: "GRTX" },
    { name: "NINK - NAMI Corp.", ticker: "NINK" },
    { name: "EZPW - EZCORP INC", ticker: "EZPW" },
    { name: "VALU - VALUE LINE INC", ticker: "VALU" },
    { name: "CPS - Cooper-Standard Holdings Inc.", ticker: "CPS" },
    { name: "REV - REVLON INC /DE/", ticker: "REV" },
    { name: "CTK - CooTek(Cayman)Inc.", ticker: "CTK" },
    { name: "CCNE - CNB FINANCIAL CORP/PA", ticker: "CCNE" },
    { name: "CAMP - CalAmp Corp.", ticker: "CAMP" },
    { name: "PAYS - Paysign, Inc.", ticker: "PAYS" },
    { name: "CMCM - Cheetah Mobile Inc.", ticker: "CMCM" },
    { name: "KRMD - REPRO MED SYSTEMS INC", ticker: "KRMD" },
    { name: "RYI - Ryerson Holding Corp", ticker: "RYI" },
    { name: "CLMT - Calumet Specialty Products Partners, L.P.", ticker: "CLMT" },
    { name: "ITIC - INVESTORS TITLE CO", ticker: "ITIC" },
    { name: "CZNC - CITIZENS & NORTHERN CORP", ticker: "CZNC" },
    { name: "CECE - CECO ENVIRONMENTAL CORP", ticker: "CECE" },
    { name: "BH - Biglari Holdings Inc.", ticker: "BH" },
    { name: "VOXX - VOXX International Corp", ticker: "VOXX" },
    { name: "VRNA - Verona Pharma plc", ticker: "VRNA" },
    { name: "STG - Sunlands Technology Group", ticker: "STG" },
    { name: "TELL - TELLURIAN INC. /DE/", ticker: "TELL" },
    { name: "ODC - Oil-Dri Corp of America", ticker: "ODC" },
    { name: "MOV - MOVADO GROUP INC", ticker: "MOV" },
    { name: "TGB - TASEKO MINES LTD", ticker: "TGB" },
    { name: "RDVT - Red Violet, Inc.", ticker: "RDVT" },
    { name: "PSTI - PLURISTEM THERAPEUTICS INC", ticker: "PSTI" },
    { name: "JFU - 9F Inc.", ticker: "JFU" },
    { name: "HEAR - Turtle Beach Corp", ticker: "HEAR" },
    { name: "JE - Just Energy Group Inc.", ticker: "JE" },
    { name: "THM - INTERNATIONAL TOWER HILL MINES LTD", ticker: "THM" },
    { name: "RFL - Rafael Holdings, Inc.", ticker: "RFL" },
    { name: "NCNA - NuCana plc", ticker: "NCNA" },
    { name: "RVP - RETRACTABLE TECHNOLOGIES INC", ticker: "RVP" },
    { name: "INFU - InfuSystem Holdings, Inc", ticker: "INFU" },
    { name: "IRMD - IRADIMED CORP", ticker: "IRMD" },
    { name: "EBTC - ENTERPRISE BANCORP INC /MA/", ticker: "EBTC" },
    { name: "SMTS - Sierra Metals Inc.", ticker: "SMTS" },
    { name: "KZR - Kezar Life Sciences, Inc.", ticker: "KZR" },
    { name: "CCRN - CROSS COUNTRY HEALTHCARE INC", ticker: "CCRN" },
    { name: "TGLS - Tecnoglass Inc.", ticker: "TGLS" },
    { name: "NXQ - NUVEEN SELECT TAX FREE INCOME PORTFOLIO 2", ticker: "NXQ" },
    { name: "GHL - GREENHILL & CO INC", ticker: "GHL" },
    { name: "STXS - Stereotaxis, Inc.", ticker: "STXS" },
    { name: "WILC - G WILLI FOOD INTERNATIONAL LTD", ticker: "WILC" },
    { name: "RYAM - RAYONIER ADVANCED MATERIALS INC.", ticker: "RYAM" },
    { name: "IBEX - IBEX Ltd", ticker: "IBEX" },
    { name: "CALA - Calithera Biosciences, Inc.", ticker: "CALA" },
    { name: "PFIS - PEOPLES FINANCIAL SERVICES CORP.", ticker: "PFIS" },
    { name: "NNBR - NN INC", ticker: "NNBR" },
    { name: "KLDO - Kaleido Biosciences, Inc.", ticker: "KLDO" },
    { name: "WPRT - WESTPORT FUEL SYSTEMS INC.", ticker: "WPRT" },
    { name: "SPFI - SOUTH PLAINS FINANCIAL, INC.", ticker: "SPFI" },
    { name: "AUG - FURY GOLD MINES LTD", ticker: "AUG" },
    { name: "LMNR - Limoneira CO", ticker: "LMNR" },
    { name: "HAFC - HANMI FINANCIAL CORP", ticker: "HAFC" },
    { name: "MULG - MULIANG VIAGOO TECHNOLOGY, INC.", ticker: "MULG" },
    { name: "RLGT - RADIANT LOGISTICS, INC", ticker: "RLGT" },
    { name: "LMPX - LMP Automotive Holdings, Inc.", ticker: "LMPX" },
    { name: "AGRX - AGILE THERAPEUTICS INC", ticker: "AGRX" },
    { name: "OAC - Oaktree Acquisition Corp.", ticker: "OAC" },
    { name: "JYNT - JOINT Corp", ticker: "JYNT" },
    { name: "WSR - Whitestone REIT", ticker: "WSR" },
    { name: "FISI - FINANCIAL INSTITUTIONS INC", ticker: "FISI" },
    { name: "EZOO - Ezagoo Ltd", ticker: "EZOO" },
    { name: "SILC - SILICOM LTD.", ticker: "SILC" },
    { name: "AXTI - AXT INC", ticker: "AXTI" },
    { name: "IVC - INVACARE CORP", ticker: "IVC" },
    { name: "ACET - Adicet Bio, Inc.", ticker: "ACET" },
    { name: "PTSI - PAM TRANSPORTATION SERVICES INC", ticker: "PTSI" },
    { name: "OSBC - OLD SECOND BANCORP INC", ticker: "OSBC" },
    { name: "HTBI - HomeTrust Bancshares, Inc.", ticker: "HTBI" },
    { name: "FTHM - Fathom Holdings Inc.", ticker: "FTHM" },
    { name: "ECC - Eagle Point Credit Co Inc.", ticker: "ECC" },
    { name: "CMPI - Checkmate Pharmaceuticals, Inc.", ticker: "CMPI" },
    { name: "ASPU - ASPEN GROUP, INC.", ticker: "ASPU" },
    { name: "FNLC - First Bancorp, Inc /ME/", ticker: "FNLC" },
    { name: "IDT - IDT CORP", ticker: "IDT" },
    { name: "CSWC - CAPITAL SOUTHWEST CORP", ticker: "CSWC" },
    { name: "FFMGF - First Mining Gold Corp.", ticker: "FFMGF" },
    { name: "PRTY - Party City Holdco Inc.", ticker: "PRTY" },
    { name: "MTCR - Metacrine, Inc.", ticker: "MTCR" },
    { name: "EQOS - Diginex Ltd", ticker: "EQOS" },
    { name: "GWRS - Global Water Resources, Inc.", ticker: "GWRS" },
    { name: "AKU - AKUMIN INC.", ticker: "AKU" },
    { name: "EQBK - EQUITY BANCSHARES INC", ticker: "EQBK" },
    { name: "FDUS - FIDUS INVESTMENT Corp", ticker: "FDUS" },
    { name: "YRCW - YRC Worldwide Inc.", ticker: "YRCW" },
    { name: "FNGR - FingerMotion, Inc.", ticker: "FNGR" },
    { name: "AMNB - AMERICAN NATIONAL BANKSHARES INC.", ticker: "AMNB" },
    { name: "PLPC - PREFORMED LINE PRODUCTS CO", ticker: "PLPC" },
    { name: "MCB - Metropolitan Bank Holding Corp.", ticker: "MCB" },
    { name: "UEEC - United Health Products, Inc.", ticker: "UEEC" },
    { name: "FC - FRANKLIN COVEY CO", ticker: "FC" },
    { name: "FGOVF - FREEGOLD VENTURES LTD", ticker: "FGOVF" },
    { name: "TDW - TIDEWATER INC", ticker: "TDW" },
    { name: "AAOI - APPLIED OPTOELECTRONICS, INC.", ticker: "AAOI" },
    { name: "MCBC - MACATAWA BANK CORP", ticker: "MCBC" },
    { name: "BRY - Berry Corp (bry)", ticker: "BRY" },
    { name: "HOOK - HOOKIPA Pharma Inc.", ticker: "HOOK" },
    { name: "RACA - Therapeutics Acquisition Corp.", ticker: "RACA" },
    { name: "RM - Regional Management Corp.", ticker: "RM" },
    { name: "NUZE - NuZee, Inc.", ticker: "NUZE" },
    { name: "GPJA - GEORGIA POWER CO", ticker: "GPJA" },
    { name: "FBIO - Fortress Biotech, Inc.", ticker: "FBIO" },
    { name: "VRA - Vera Bradley, Inc.", ticker: "VRA" },
    { name: "SCPH - scPharmaceuticals Inc.", ticker: "SCPH" },
    { name: "XERS - XERIS PHARMACEUTICALS INC", ticker: "XERS" },
    { name: "PBFS - Pioneer Bancorp, Inc./MD", ticker: "PBFS" },
    { name: "ABUS - Arbutus Biopharma Corp", ticker: "ABUS" },
    { name: "VERI - Veritone, Inc.", ticker: "VERI" },
    { name: "GLAD - GLADSTONE CAPITAL CORP", ticker: "GLAD" },
    { name: "JOF - JAPAN SMALLER CAPITALIZATION FUND INC", ticker: "JOF" },
    { name: "NBEV - NewAge, Inc.", ticker: "NBEV" },
    { name: "RBB - RBB Bancorp", ticker: "RBB" },
    { name: "RMNI - Rimini Street, Inc.", ticker: "RMNI" },
    { name: "GLRE - GREENLIGHT CAPITAL RE, LTD.", ticker: "GLRE" },
    { name: "PKOH - PARK OHIO HOLDINGS CORP", ticker: "PKOH" },
    { name: "MNOV - MEDICINOVA INC", ticker: "MNOV" },
    { name: "NATR - NATURES SUNSHINE PRODUCTS INC", ticker: "NATR" },
    { name: "LCUT - LIFETIME BRANDS, INC", ticker: "LCUT" },
    { name: "NVEC - NVE CORP /NEW/", ticker: "NVEC" },
    { name: "AMRK - A-Mark Precious Metals, Inc.", ticker: "AMRK" },
    { name: "DNN - DENISON MINES CORP.", ticker: "DNN" },
    { name: "ATAX - AMERICA FIRST MULTIFAMILY INVESTORS, L.P.", ticker: "ATAX" },
    { name: "VLGEA - VILLAGE SUPER MARKET INC", ticker: "VLGEA" },
    { name: "RGS - REGIS CORP", ticker: "RGS" },
    { name: "BXC - BlueLinx Holdings Inc.", ticker: "BXC" },
    { name: "BIIO - Bionovate Technologies Corp.", ticker: "BIIO" },
    { name: "NEPT - Neptune Wellness Solutions Inc.", ticker: "NEPT" },
    { name: "ONDS - Ondas Holdings Inc.", ticker: "ONDS" },
    { name: "SONA - Southern National Bancorp of Virginia Inc", ticker: "SONA" },
    { name: "CINR - Ciner Resources LP", ticker: "CINR" },
    { name: "ALTG - ALTA EQUIPMENT GROUP INC.", ticker: "ALTG" },
    { name: "SRAC - Stable Road Acquisition Corp.", ticker: "SRAC" },
    { name: "COFS - CHOICEONE FINANCIAL SERVICES INC", ticker: "COFS" },
    { name: "WTI - W&T OFFSHORE INC", ticker: "WTI" },
    { name: "FDBC - FIDELITY D & D BANCORP INC", ticker: "FDBC" },
    { name: "ATRO - ASTRONICS CORP", ticker: "ATRO" },
    { name: "STXB - Spirit of Texas Bancshares, Inc.", ticker: "STXB" },
    { name: "UFI - UNIFI INC", ticker: "UFI" },
    { name: "GNE - Genie Energy Ltd.", ticker: "GNE" },
    { name: "SAVA - CASSAVA SCIENCES INC", ticker: "SAVA" },
    { name: "NL - NL INDUSTRIES INC", ticker: "NL" },
    { name: "FMAO - FARMERS & MERCHANTS BANCORP INC", ticker: "FMAO" },
    { name: "SELB - SELECTA BIOSCIENCES INC", ticker: "SELB" },
    { name: "TMQ - Trilogy Metals Inc.", ticker: "TMQ" },
    { name: "CSTR - CapStar Financial Holdings, Inc.", ticker: "CSTR" },
    { name: "OESX - ORION ENERGY SYSTEMS, INC.", ticker: "OESX" },
    { name: "OGI - ORGANIGRAM HOLDINGS INC.", ticker: "OGI" },
    { name: "OCN - OCWEN FINANCIAL CORP", ticker: "OCN" },
    { name: "NSCO - NESCO HOLDINGS, INC.", ticker: "NSCO" },
    { name: "HBCP - HOME BANCORP, INC.", ticker: "HBCP" },
    { name: "IMV - IMV Inc.", ticker: "IMV" },
    { name: "ABTI - ALTEROLA BIOTECH INC.", ticker: "ABTI" },
    { name: "FVTI - Fortune Valley Treasures, Inc.", ticker: "FVTI" },
    { name: "MCS - MARCUS CORP", ticker: "MCS" },
    { name: "LOAK - Live Oak Acquisition Corp", ticker: "LOAK" },
    { name: "PTAC - PropTech Acquisition Corp", ticker: "PTAC" },
    { name: "LTRPA - Liberty TripAdvisor Holdings, Inc.", ticker: "LTRPA" },
    { name: "CISO - CERBERUS CYBER SENTINEL CORP", ticker: "CISO" },
    { name: "MNCL - Monocle Acquisition Corp", ticker: "MNCL" },
    { name: "LND - BrasilAgro - Brazilian Agricultural Real Estate Co", ticker: "LND" },
    { name: "ALCO - ALICO, INC.", ticker: "ALCO" },
    { name: "MHH - Mastech Digital, Inc.", ticker: "MHH" },
    { name: "NOG - NORTHERN OIL & GAS, INC.", ticker: "NOG" },
    { name: "PKE - PARK AEROSPACE CORP", ticker: "PKE" },
    { name: "GIX - GigCapital2, Inc.", ticker: "GIX" },
    { name: "EMX - EMX Royalty Corp", ticker: "EMX" },
    { name: "ICAD - ICAD INC", ticker: "ICAD" },
    { name: "DAC - Danaos Corp", ticker: "DAC" },
    { name: "TSCHY - Trustco Group Holdings Ltd", ticker: "TSCHY" },
    { name: "TELA - TELA Bio, Inc.", ticker: "TELA" },
    { name: "GTXMQ - Garrett Motion Inc.", ticker: "GTXMQ" },
    { name: "BIOX - Bioceres Crop Solutions Corp.", ticker: "BIOX" },
    { name: "CIVB - CIVISTA BANCSHARES, INC.", ticker: "CIVB" },
    { name: "GFASY - Gafisa S.A.", ticker: "GFASY" },
    { name: "BBCP - Concrete Pumping Holdings, Inc.", ticker: "BBCP" },
    { name: "MLP - MAUI LAND & PINEAPPLE CO INC", ticker: "MLP" },
    { name: "DMTK - DermTech, Inc.", ticker: "DMTK" },
    { name: "SMBC - SOUTHERN MISSOURI BANCORP, INC.", ticker: "SMBC" },
    { name: "BYRN - Byrna Technologies Inc.", ticker: "BYRN" },
    { name: "EMP - ENTERGY MISSISSIPPI, LLC", ticker: "EMP" },
    { name: "VNTR - Venator Materials PLC", ticker: "VNTR" },
    { name: "EOSS - EOS INC.", ticker: "EOSS" },
    { name: "SAR - SARATOGA INVESTMENT CORP.", ticker: "SAR" },
    { name: "TARA - Protara Therapeutics, Inc.", ticker: "TARA" },
    { name: "RICK - RCI HOSPITALITY HOLDINGS, INC.", ticker: "RICK" },
    { name: "SUNS - Solar Senior Capital Ltd.", ticker: "SUNS" },
    { name: "CMCL - Caledonia Mining Corp Plc", ticker: "CMCL" },
    { name: "EVLO - Evelo Biosciences, Inc.", ticker: "EVLO" },
    { name: "AOUT - American Outdoor Brands, Inc.", ticker: "AOUT" },
    { name: "TXCB - Cang Bao Tian Xia International Art Trade Center, Inc.", ticker: "TXCB" },
    { name: "SMMF - SUMMIT FINANCIAL GROUP, INC.", ticker: "SMMF" },
    { name: "FLMN - Falcon Minerals Corp", ticker: "FLMN" },
    { name: "PYPD - PolyPid Ltd.", ticker: "PYPD" },
    { name: "GAIA - GAIA, INC", ticker: "GAIA" },
    { name: "XOMA - XOMA Corp", ticker: "XOMA" },
    { name: "MEPW - ME Renewable Power Corp", ticker: "MEPW" },
    { name: "SMBK - SMARTFINANCIAL INC.", ticker: "SMBK" },
    { name: "BCTG - BCTG Acquisition Corp.", ticker: "BCTG" },
    { name: "RRGB - RED ROBIN GOURMET BURGERS INC", ticker: "RRGB" },
    { name: "TK - TEEKAY CORP", ticker: "TK" },
    { name: "VRCA - Verrica Pharmaceuticals Inc.", ticker: "VRCA" },
    { name: "SOLO - ELECTRAMECCANICA VEHICLES CORP.", ticker: "SOLO" },
    { name: "CDAK - Codiak BioSciences, Inc.", ticker: "CDAK" },
    { name: "TCI - TRANSCONTINENTAL REALTY INVESTORS INC", ticker: "TCI" },
    { name: "UIHC - UNITED INSURANCE HOLDINGS CORP.", ticker: "UIHC" },
    { name: "JVCZY - JVCKENWOOD Corporation/ADR", ticker: "JVCZY" },
    { name: "NTP - NAM TAI PROPERTY INC.", ticker: "NTP" },
    { name: "HRZN - Horizon Technology Finance Corp", ticker: "HRZN" },
    { name: "EVFM - Evofem Biosciences, Inc.", ticker: "EVFM" },
    { name: "VIST - Vista Oil & Gas, S.A.B. de C.V.", ticker: "VIST" },
    { name: "ACBM - ACRO BIOMEDICAL CO., LTD.", ticker: "ACBM" },
    { name: "PCYO - PURE CYCLE CORP", ticker: "PCYO" },
    { name: "ENJ - ENTERGY NEW ORLEANS, LLC", ticker: "ENJ" },
    { name: "CTO - CTO Realty Growth, Inc.", ticker: "CTO" },
    { name: "HAYN - HAYNES INTERNATIONAL INC", ticker: "HAYN" },
    { name: "SIEN - Sientra, Inc.", ticker: "SIEN" },
    { name: "SIFY - SIFY TECHNOLOGIES LTD", ticker: "SIFY" },
    { name: "APT - ALPHA PRO TECH LTD", ticker: "APT" },
    { name: "VSTM - Verastem, Inc.", ticker: "VSTM" },
    { name: "INB - Cohen & Steers Global Income Builder, Inc", ticker: "INB" },
    { name: "HOV - HOVNANIAN ENTERPRISES INC", ticker: "HOV" },
    { name: "DBO - Invesco DB Oil Fund", ticker: "DBO" },
    { name: "KLR - Kaleyra, Inc.", ticker: "KLR" },
    { name: "ITEGY - ITE Group plc/ADR", ticker: "ITEGY" },
    { name: "NATH - NATHANS FAMOUS, INC.", ticker: "NATH" },
    { name: "ETM - ENTERCOM COMMUNICATIONS CORP", ticker: "ETM" },
    { name: "SFST - SOUTHERN FIRST BANCSHARES INC", ticker: "SFST" },
    { name: "GORO - GOLD RESOURCE CORP", ticker: "GORO" },
    { name: "ZEST - Ecoark Holdings, Inc.", ticker: "ZEST" },
    { name: "MTRX - MATRIX SERVICE CO", ticker: "MTRX" },
    { name: "AMCI - AMCI Acquisition Corp.", ticker: "AMCI" },
    { name: "TBNK - Territorial Bancorp Inc.", ticker: "TBNK" },
    { name: "JG - Aurora Mobile Ltd", ticker: "JG" },
    { name: "ASPS - Altisource Portfolio Solutions S.A.", ticker: "ASPS" },
    { name: "NBR - NABORS INDUSTRIES LTD", ticker: "NBR" },
    { name: "NBSE - NeuBase Therapeutics, Inc.", ticker: "NBSE" },
    { name: "PNNT - PENNANTPARK INVESTMENT CORP", ticker: "PNNT" },
    { name: "PDS - PRECISION DRILLING Corp", ticker: "PDS" },
    { name: "PERI - Perion Network Ltd.", ticker: "PERI" },
    { name: "MVBF - MVB FINANCIAL CORP", ticker: "MVBF" },
    { name: "CRNT - CERAGON NETWORKS LTD", ticker: "CRNT" },
    { name: "CNF - CNFinance Holdings Ltd.", ticker: "CNF" },
    { name: "WRTC - WRAP TECHNOLOGIES, INC.", ticker: "WRTC" },
    { name: "GNSS - Genasys Inc.", ticker: "GNSS" },
    { name: "ARYA - ARYA Sciences Acquisition Corp III", ticker: "ARYA" },
    { name: "DZSI - DZS INC.", ticker: "DZSI" },
    { name: "IDEX - IDEANOMICS, INC.", ticker: "IDEX" },
    { name: "LUNA - LUNA INNOVATIONS INC", ticker: "LUNA" },
    { name: "HURC - HURCO COMPANIES INC", ticker: "HURC" },
    { name: "UUUU - ENERGY FUELS INC", ticker: "UUUU" },
    { name: "TRNS - TRANSCAT INC", ticker: "TRNS" },
    { name: "SOL - ReneSola Ltd", ticker: "SOL" },
    { name: "FTK - FLOTEK INDUSTRIES INC/CN/", ticker: "FTK" },
    { name: "NWFL - NORWOOD FINANCIAL CORP", ticker: "NWFL" },
    { name: "TLYS - TILLY'S, INC.", ticker: "TLYS" },
    { name: "MKD - Molecular Data Inc.", ticker: "MKD" },
    { name: "APTX - Aptinyx Inc.", ticker: "APTX" },
    { name: "FUV - Arcimoto Inc", ticker: "FUV" },
    { name: "ATLC - Atlanticus Holdings Corp", ticker: "ATLC" },
    { name: "SLCA - U.S. SILICA HOLDINGS, INC.", ticker: "SLCA" },
    { name: "NNDM - Nano Dimension Ltd.", ticker: "NNDM" },
    { name: "FLXS - FLEXSTEEL INDUSTRIES INC", ticker: "FLXS" },
    { name: "FSBW - FS Bancorp, Inc.", ticker: "FSBW" },
    { name: "TCCR - FRONTIER OILFIELD SERVICES INC", ticker: "TCCR" },
    { name: "NOA - North American Construction Group Ltd.", ticker: "NOA" },
    { name: "APYX - Apyx Medical Corp", ticker: "APYX" },
    { name: "RGCO - RGC RESOURCES INC", ticker: "RGCO" },
    { name: "CASI - CASI Pharmaceuticals, Inc.", ticker: "CASI" },
    { name: "FPI - Farmland Partners Inc.", ticker: "FPI" },
    { name: "PWFL - PowerFleet, Inc.", ticker: "PWFL" },
    { name: "UBX - Unity Biotechnology, Inc.", ticker: "UBX" },
    { name: "BRT - BRT Apartments Corp.", ticker: "BRT" },
    { name: "CVGI - Commercial Vehicle Group, Inc.", ticker: "CVGI" },
    { name: "IEA - Infrastructure & Energy Alternatives, Inc.", ticker: "IEA" },
    { name: "OPTN - OptiNose, Inc.", ticker: "OPTN" },
    { name: "GCBC - GREENE COUNTY BANCORP INC", ticker: "GCBC" },
    { name: "FCAP - FIRST CAPITAL INC", ticker: "FCAP" },
    { name: "LAKE - LAKELAND INDUSTRIES INC", ticker: "LAKE" },
    { name: "HSAQ - Health Sciences Acquisitions Corp 2", ticker: "HSAQ" },
    { name: "CLSK - CLEANSPARK, INC.", ticker: "CLSK" },
    { name: "PRQR - ProQR Therapeutics N.V.", ticker: "PRQR" },
    { name: "HT - HERSHA HOSPITALITY TRUST", ticker: "HT" },
    { name: "GLG - TD Holdings, Inc.", ticker: "GLG" },
    { name: "SECO - Secoo Holding Ltd", ticker: "SECO" },
    { name: "PRTH - Priority Technology Holdings, Inc.", ticker: "PRTH" },
    { name: "FENC - FENNEC PHARMACEUTICALS INC.", ticker: "FENC" },
    { name: "SBT - Sterling Bancorp, Inc.", ticker: "SBT" },
    { name: "TTOO - T2 Biosystems, Inc.", ticker: "TTOO" },
    { name: "GP - GREENPOWER MOTOR Co INC.", ticker: "GP" },
    { name: "ACRS - Aclaris Therapeutics, Inc.", ticker: "ACRS" },
    { name: "BTE - BAYTEX ENERGY CORP.", ticker: "BTE" },
    { name: "FLNT - Fluent, Inc.", ticker: "FLNT" },
    { name: "XNET - Xunlei Ltd", ticker: "XNET" },
    { name: "DYAI - DYADIC INTERNATIONAL INC", ticker: "DYAI" },
    { name: "LCTX - Lineage Cell Therapeutics, Inc.", ticker: "LCTX" },
    { name: "METX - Meten EdtechX Education Group Ltd.", ticker: "METX" },
    { name: "LYTS - LSI INDUSTRIES INC", ticker: "LYTS" },
    { name: "INTZ - INTRUSION INC", ticker: "INTZ" },
    { name: "SWKH - SWK Holdings Corp", ticker: "SWKH" },
    { name: "QMCO - QUANTUM CORP /DE/", ticker: "QMCO" },
    { name: "UEC - URANIUM ENERGY CORP", ticker: "UEC" },
    { name: "NRIM - NORTHRIM BANCORP INC", ticker: "NRIM" },
    { name: "VUZI - Vuzix Corp", ticker: "VUZI" },
    { name: "BVH - Bluegreen Vacations Holding Corp", ticker: "BVH" },
    { name: "ALPN - ALPINE IMMUNE SCIENCES, INC.", ticker: "ALPN" },
    { name: "ADMA - ADMA BIOLOGICS, INC.", ticker: "ADMA" },
    { name: "VIAO - VIA optronics AG", ticker: "VIAO" },
    { name: "XGN - EXAGEN INC.", ticker: "XGN" },
    { name: "ATOM - Atomera Inc", ticker: "ATOM" },
    { name: "MWK - Mohawk Group Holdings, Inc.", ticker: "MWK" },
    { name: "EEX - Emerald Holding, Inc.", ticker: "EEX" },
    { name: "MEC - Mayville Engineering Company, Inc.", ticker: "MEC" },
    { name: "ETON - Eton Pharmaceuticals, Inc.", ticker: "ETON" },
    { name: "SLGL - Sol-Gel Technologies Ltd.", ticker: "SLGL" },
    { name: "CPE - Callon Petroleum Co", ticker: "CPE" },
    { name: "CERC - Cerecor Inc.", ticker: "CERC" },
    { name: "NYMX - NYMOX PHARMACEUTICAL CORP", ticker: "NYMX" },
    { name: "MDNA - Medicenna Therapeutics Corp.", ticker: "MDNA" },
    { name: "PFHD - Professional Holding Corp.", ticker: "PFHD" },
    { name: "EPIX - ESSA Pharma Inc.", ticker: "EPIX" },
    { name: "RCKY - ROCKY BRANDS, INC.", ticker: "RCKY" },
    { name: "STRS - STRATUS PROPERTIES INC", ticker: "STRS" },
    { name: "AJX - Great Ajax Corp.", ticker: "AJX" },
    { name: "CBAT - CBAK Energy Technology, Inc.", ticker: "CBAT" },
    { name: "HTBX - HEAT BIOLOGICS, INC.", ticker: "HTBX" },
    { name: "ACNB - ACNB CORP", ticker: "ACNB" },
    { name: "WBQNL - Woodbridge Liquidation Trust", ticker: "WBQNL" },
    { name: "REKR - Rekor Systems, Inc.", ticker: "REKR" },
    { name: "ENLV - Enlivex Therapeutics Ltd.", ticker: "ENLV" },
    { name: "AQB - AquaBounty Technologies, Inc.", ticker: "AQB" },
    { name: "SIC - Select Interior Concepts, Inc.", ticker: "SIC" },
    { name: "SALT - SCORPIO BULKERS INC.", ticker: "SALT" },
    { name: "TMST - TimkenSteel Corp", ticker: "TMST" },
    { name: "IMMR - IMMERSION CORP", ticker: "IMMR" },
    { name: "CMRX - CHIMERIX INC", ticker: "CMRX" },
    { name: "FXY - Invesco CurrencyShares Japanese Yen Trust", ticker: "FXY" },
    { name: "EGLE - Eagle Bulk Shipping Inc.", ticker: "EGLE" },
    { name: "GPP - Green Plains Partners LP", ticker: "GPP" },
    { name: "SBEV - SPLASH BEVERAGE GROUP, INC.", ticker: "SBEV" },
    { name: "LCNB - LCNB CORP", ticker: "LCNB" },
    { name: "LFAC - LF Capital Acquisition Corp.", ticker: "LFAC" },
    { name: "BKCC - BlackRock Capital Investment Corp", ticker: "BKCC" },
    { name: "DBVT - DBV Technologies S.A.", ticker: "DBVT" },
    { name: "FKWL - FRANKLIN WIRELESS CORP", ticker: "FKWL" },
    { name: "MIXT - MiX Telematics Ltd", ticker: "MIXT" },
    { name: "TWI - TITAN INTERNATIONAL INC", ticker: "TWI" },
    { name: "CDEV - Centennial Resource Development, Inc.", ticker: "CDEV" },
    { name: "OIS - OIL STATES INTERNATIONAL, INC", ticker: "OIS" },
    { name: "NEN - NEW ENGLAND REALTY ASSOCIATES LIMITED PARTNERSHIP", ticker: "NEN" },
    { name: "BGFV - BIG 5 SPORTING GOODS Corp", ticker: "BGFV" },
    { name: "OTIC - OTONOMY, INC.", ticker: "OTIC" },
    { name: "AQST - Aquestive Therapeutics, Inc.", ticker: "AQST" },
    { name: "CRMD - CorMedix Inc.", ticker: "CRMD" },
    { name: "XYF - X Financial", ticker: "XYF" },
    { name: "SPOK - Spok Holdings, Inc", ticker: "SPOK" },
    { name: "DAKT - DAKTRONICS INC /SD/", ticker: "DAKT" },
    { name: "TIPT - TIPTREE INC.", ticker: "TIPT" },
    { name: "OSG - OVERSEAS SHIPHOLDING GROUP INC", ticker: "OSG" },
    { name: "ATXG - ADDENTAX GROUP CORP.", ticker: "ATXG" },
    { name: "BGR - BlackRock Energy & Resources Trust", ticker: "BGR" },
    { name: "WNDW - SolarWindow Technologies, Inc.", ticker: "WNDW" },
    { name: "AIH - Aesthetic Medical International Holdings Group Ltd", ticker: "AIH" },
    { name: "UTI - UNIVERSAL TECHNICAL INSTITUTE INC", ticker: "UTI" },
    { name: "UEPS - NET 1 UEPS TECHNOLOGIES INC", ticker: "UEPS" },
    { name: "MBIO - MUSTANG BIO, INC.", ticker: "MBIO" },
    { name: "ITRG - Integra Resources Corp.", ticker: "ITRG" },
    { name: "CVCY - CENTRAL VALLEY COMMUNITY BANCORP", ticker: "CVCY" },
    { name: "LOMLF - Lion One Metals Ltd.", ticker: "LOMLF" },
    { name: "LIQT - LIQTECH INTERNATIONAL INC", ticker: "LIQT" },
    { name: "TISI - TEAM INC", ticker: "TISI" },
    { name: "ALYA - Alithya Group inc", ticker: "ALYA" },
    { name: "GENC - GENCOR INDUSTRIES INC", ticker: "GENC" },
    { name: "CSSE - Chicken Soup for the Soul Entertainment, Inc.", ticker: "CSSE" },
    { name: "SM - SM Energy Co", ticker: "SM" },
    { name: "AXGT - Axovant Gene Therapies Ltd.", ticker: "AXGT" },
    { name: "KVHI - KVH INDUSTRIES INC \\DE\\", ticker: "KVHI" },
    { name: "MIST - Milestone Pharmaceuticals Inc.", ticker: "MIST" },
    { name: "WNEB - Western New England Bancorp, Inc.", ticker: "WNEB" },
    { name: "SMSI - SMITH MICRO SOFTWARE, INC.", ticker: "SMSI" },
    { name: "RIOT - Riot Blockchain, Inc.", ticker: "RIOT" },
    { name: "INBK - First Internet Bancorp", ticker: "INBK" },
    { name: "VERU - VERU INC.", ticker: "VERU" },
    { name: "ATLO - AMES NATIONAL CORP", ticker: "ATLO" },
    { name: "SSSS - SURO CAPITAL CORP.", ticker: "SSSS" },
    { name: "GLOP - GasLog Partners LP", ticker: "GLOP" },
    { name: "GLEO - Galileo Acquisition Corp.", ticker: "GLEO" },
    { name: "MTNB - Matinas BioPharma Holdings, Inc.", ticker: "MTNB" },
    { name: "LFVN - Lifevantage Corp", ticker: "LFVN" },
    { name: "CRCW - Crypto Co", ticker: "CRCW" },
    { name: "GSIT - GSI TECHNOLOGY INC", ticker: "GSIT" },
    { name: "CZFS - CITIZENS FINANCIAL SERVICES INC", ticker: "CZFS" },
    { name: "THTX - Theratechnologies Inc.", ticker: "THTX" },
    { name: "ITI - ITERIS, INC.", ticker: "ITI" },
    { name: "CIH - China Index Holdings Ltd", ticker: "CIH" },
    { name: "PICO - PICO HOLDINGS INC /NEW", ticker: "PICO" },
    { name: "NCMI - National CineMedia, Inc.", ticker: "NCMI" },
    { name: "HQDA - HQDA ELDERLY LIFE NETWORK CORP.", ticker: "HQDA" },
    { name: "REBL - Rebel Group, Inc.", ticker: "REBL" },
    { name: "AEYE - AUDIOEYE INC", ticker: "AEYE" },
    { name: "CHMG - CHEMUNG FINANCIAL CORP", ticker: "CHMG" },
    { name: "TSBK - TIMBERLAND BANCORP INC", ticker: "TSBK" },
    { name: "NKSH - NATIONAL BANKSHARES INC", ticker: "NKSH" },
    { name: "MPB - MID PENN BANCORP INC", ticker: "MPB" },
    { name: "CNTY - CENTURY CASINOS INC /CO/", ticker: "CNTY" },
    { name: "BTBT - Bit Digital, Inc", ticker: "BTBT" },
    { name: "CCB - COASTAL FINANCIAL CORP", ticker: "CCB" },
    { name: "SAMG - Silvercrest Asset Management Group Inc.", ticker: "SAMG" },
    { name: "CIX - COMPX INTERNATIONAL INC", ticker: "CIX" },
    { name: "JFIN - Jiayin Group Inc.", ticker: "JFIN" },
    { name: "CKPT - Checkpoint Therapeutics, Inc.", ticker: "CKPT" },
    { name: "PVBC - Provident Bancorp, Inc. /MD/", ticker: "PVBC" },
    { name: "NBN - NORTHEAST BANCORP /ME/", ticker: "NBN" },
    { name: "AXLA - Axcella Health Inc.", ticker: "AXLA" },
    { name: "SAMA - Schultze Special Purpose Acquisition Corp.", ticker: "SAMA" },
    { name: "PDLB - PDL Community Bancorp", ticker: "PDLB" },
    { name: "SJ - Scienjoy Holding Corp", ticker: "SJ" },
    { name: "CTVZ - CINDERELLA TARGET VALUE ZONES INC", ticker: "CTVZ" },
    { name: "KIRK - KIRKLAND'S, INC", ticker: "KIRK" },
    { name: "BRID - BRIDGFORD FOODS CORP", ticker: "BRID" },
    { name: "EVC - ENTRAVISION COMMUNICATIONS CORP", ticker: "EVC" },
    { name: "OMWS - OMNIA WELLNESS INC.", ticker: "OMWS" },
    { name: "ORRCF - OROCO RESOURCE CORP", ticker: "ORRCF" },
    { name: "FVCB - FVCBankcorp, Inc.", ticker: "FVCB" },
    { name: "SLDB - Solid Biosciences Inc.", ticker: "SLDB" },
    { name: "VERY - Vericity, Inc.", ticker: "VERY" },
    { name: "GNFT - Genfit S.A.", ticker: "GNFT" },
    { name: "FRTG - FRONTERA GROUP INC.", ticker: "FRTG" },
    { name: "BSET - BASSETT FURNITURE INDUSTRIES INC", ticker: "BSET" },
    { name: "MCMJ - Merida Merger Corp. I", ticker: "MCMJ" },
    { name: "FSTR - FOSTER L B CO", ticker: "FSTR" },
    { name: "MREO - Mereo Biopharma Group plc", ticker: "MREO" },
    { name: "HZN - Horizon Global Corp", ticker: "HZN" },
    { name: "WFTLF - Weatherford International plc", ticker: "WFTLF" },
    { name: "RBTK - ZHEN DING RESOURCES INC.", ticker: "RBTK" },
    { name: "CWCO - Consolidated Water Co. Ltd.", ticker: "CWCO" },
    { name: "LYRA - Lyra Therapeutics, Inc.", ticker: "LYRA" },
    { name: "PKBK - PARKE BANCORP, INC.", ticker: "PKBK" },
    { name: "GLYC - GLYCOMIMETICS INC", ticker: "GLYC" },
    { name: "CATO - CATO CORP", ticker: "CATO" },
    { name: "BPSR - Organicell Regenerative Medicine, Inc.", ticker: "BPSR" },
    { name: "ACTG - ACACIA RESEARCH CORP", ticker: "ACTG" },
    { name: "ALAC - Alberton Acquisition Corp", ticker: "ALAC" },
    { name: "ALTM - Altus Midstream Co", ticker: "ALTM" },
    { name: "LQDA - Liquidia Technologies Inc", ticker: "LQDA" },
    { name: "FSDC - FS Development Corp.", ticker: "FSDC" },
    { name: "LAZY - Lazydays Holdings, Inc.", ticker: "LAZY" },
    { name: "ACRX - ACELRX PHARMACEUTICALS INC", ticker: "ACRX" },
    { name: "TAQR - TRAQER CORP", ticker: "TAQR" },
    { name: "ENOB - Enochian Biosciences Inc", ticker: "ENOB" },
    { name: "XCUR - EXICURE, INC.", ticker: "XCUR" },
    { name: "VNRX - VOLITIONRX LTD", ticker: "VNRX" },
    { name: "WEYS - WEYCO GROUP INC", ticker: "WEYS" },
    { name: "GSMG - GLORY STAR NEW MEDIA GROUP HOLDINGS Ltd", ticker: "GSMG" },
    { name: "SPI - SPI Energy Co., Ltd.", ticker: "SPI" },
    { name: "CHMI - Cherry Hill Mortgage Investment Corp", ticker: "CHMI" },
    { name: "NYC - New York City REIT, Inc.", ticker: "NYC" },
    { name: "LIVX - LiveXLive Media, Inc.", ticker: "LIVX" },
    { name: "BSGM - BioSig Technologies, Inc.", ticker: "BSGM" },
    { name: "CULP - CULP INC", ticker: "CULP" },
    { name: "GALT - GALECTIN THERAPEUTICS INC", ticker: "GALT" },
    { name: "RMBI - Richmond Mutual Bancorporation, Inc.", ticker: "RMBI" },
    { name: "AAGH - America Great Health", ticker: "AAGH" },
    { name: "FUAIY - FUNAI ELECTRIC CO LTD", ticker: "FUAIY" },
    { name: "SRGA - SURGALIGN HOLDINGS, INC.", ticker: "SRGA" },
    { name: "NIOBF - NIOCORP DEVELOPMENTS LTD", ticker: "NIOBF" },
    { name: "NRP - NATURAL RESOURCE PARTNERS LP", ticker: "NRP" },
    { name: "AVEO - AVEO PHARMACEUTICALS, INC.", ticker: "AVEO" },
    { name: "MRAM - EVERSPIN TECHNOLOGIES INC", ticker: "MRAM" },
    { name: "EDUC - EDUCATIONAL DEVELOPMENT CORP", ticker: "EDUC" },
    { name: "QUAD - Quad/Graphics, Inc.", ticker: "QUAD" },
    { name: "ISTR - Investar Holding Corp", ticker: "ISTR" },
    { name: "CFRX - CONTRAFECT Corp", ticker: "CFRX" },
    { name: "SCOR - COMSCORE, INC.", ticker: "SCOR" },
    { name: "LMNL - Liminal BioSciences Inc.", ticker: "LMNL" },
    { name: "SLNO - SOLENO THERAPEUTICS INC", ticker: "SLNO" },
    { name: "ATNM - Actinium Pharmaceuticals, Inc.", ticker: "ATNM" },
    { name: "TNP - TSAKOS ENERGY NAVIGATION LTD", ticker: "TNP" },
    { name: "ORRF - ORRSTOWN FINANCIAL SERVICES INC", ticker: "ORRF" },
    { name: "MICT - MICT, Inc.", ticker: "MICT" },
    { name: "SQNS - SEQUANS COMMUNICATIONS", ticker: "SQNS" },
    { name: "TOMZ - TOMI Environmental Solutions, Inc.", ticker: "TOMZ" },
    { name: "LXRX - LEXICON PHARMACEUTICALS, INC.", ticker: "LXRX" },
    { name: "IDN - Intellicheck, Inc.", ticker: "IDN" },
    { name: "OFED - Oconee Federal Financial Corp.", ticker: "OFED" },
    { name: "PWOD - PENNS WOODS BANCORP INC", ticker: "PWOD" },
    { name: "NC - NACCO INDUSTRIES INC", ticker: "NC" },
    { name: "FBIZ - FIRST BUSINESS FINANCIAL SERVICES, INC.", ticker: "FBIZ" },
    { name: "LINC - LINCOLN EDUCATIONAL SERVICES CORP", ticker: "LINC" },
    { name: "MRCC - MONROE CAPITAL Corp", ticker: "MRCC" },
    { name: "JT - Jianpu Technology Inc.", ticker: "JT" },
    { name: "PHGE - BiomX Inc.", ticker: "PHGE" },
    { name: "BCBP - BCB BANCORP INC", ticker: "BCBP" },
    { name: "AMPE - Ampio Pharmaceuticals, Inc.", ticker: "AMPE" },
    { name: "UNTY - UNITY BANCORP INC /NJ/", ticker: "UNTY" },
    { name: "ESSA - ESSA Bancorp, Inc.", ticker: "ESSA" },
    { name: "XSPA - XpresSpa Group, Inc.", ticker: "XSPA" },
    { name: "AUNFF - Aurcana Corp", ticker: "AUNFF" },
    { name: "ARL - AMERICAN REALTY INVESTORS INC", ticker: "ARL" },
    { name: "SPLP - STEEL PARTNERS HOLDINGS L.P.", ticker: "SPLP" },
    { name: "BCML - BayCom Corp", ticker: "BCML" },
    { name: "BLU - BELLUS Health Inc.", ticker: "BLU" },
    { name: "SHBI - SHORE BANCSHARES INC", ticker: "SHBI" },
    { name: "EDAP - EDAP TMS SA", ticker: "EDAP" },
    { name: "PCB - PCB BANCORP", ticker: "PCB" },
    { name: "FCUV - FOCUS UNIVERSAL INC.", ticker: "FCUV" },
    { name: "TGRF - TGR Financial, Inc.", ticker: "TGRF" },
    { name: "GDRZF - GOLD RESERVE INC", ticker: "GDRZF" },
    { name: "PANL - Pangaea Logistics Solutions Ltd.", ticker: "PANL" },
    { name: "LGC - Legacy Acquisition Corp.", ticker: "LGC" },
    { name: "LTRX - LANTRONIX INC", ticker: "LTRX" },
    { name: "CBNK - Capital Bancorp Inc", ticker: "CBNK" },
    { name: "CPLP - Capital Product Partners L.P.", ticker: "CPLP" },
    { name: "HROW - HARROW HEALTH, INC.", ticker: "HROW" },
    { name: "PVAC - PENN VIRGINIA CORP", ticker: "PVAC" },
    { name: "IPI - Intrepid Potash, Inc.", ticker: "IPI" },
    { name: "RZLT - Rezolute, Inc.", ticker: "RZLT" },
    { name: "TOUR - Tuniu Corp", ticker: "TOUR" },
    { name: "SNCR - SYNCHRONOSS TECHNOLOGIES INC", ticker: "SNCR" },
    { name: "FGBI - First Guaranty Bancshares, Inc.", ticker: "FGBI" },
    { name: "ZVO - Zovio Inc", ticker: "ZVO" },
    { name: "PSTL - Postal Realty Trust, Inc.", ticker: "PSTL" },
    { name: "FONR - FONAR CORP", ticker: "FONR" },
    { name: "PLG - PLATINUM GROUP METALS LTD", ticker: "PLG" },
    { name: "NLST - NETLIST INC", ticker: "NLST" },
    { name: "CTRA - Contura Energy, Inc.", ticker: "CTRA" },
    { name: "GSL - Global Ship Lease, Inc.", ticker: "GSL" },
    { name: "NOVS - Novus Capital Corp", ticker: "NOVS" },
    { name: "EARN - Ellington Residential Mortgage REIT", ticker: "EARN" },
    { name: "SESN - Sesen Bio, Inc.", ticker: "SESN" },
    { name: "EQ - Equillium, Inc.", ticker: "EQ" },
    { name: "GNPX - Genprex, Inc.", ticker: "GNPX" },
    { name: "RTSL - Rapid Therapeutic Science Laboratories, Inc.", ticker: "RTSL" },
    { name: "AGTC - APPLIED GENETIC TECHNOLOGIES CORP", ticker: "AGTC" },
    { name: "SNFCA - SECURITY NATIONAL FINANCIAL CORP", ticker: "SNFCA" },
    { name: "UAVS - AgEagle Aerial Systems Inc.", ticker: "UAVS" },
    { name: "GHM - GRAHAM CORP", ticker: "GHM" },
    { name: "EML - EASTERN CO", ticker: "EML" },
    { name: "HLAN - HEARTLAND BANCCORP", ticker: "HLAN" },
    { name: "TDAC - Trident Acquisitions Corp.", ticker: "TDAC" },
    { name: "BW - Babcock & Wilcox Enterprises, Inc.", ticker: "BW" },
    { name: "PFSW - PFSWEB INC", ticker: "PFSW" },
    { name: "AUBN - AUBURN NATIONAL BANCORPORATION, INC", ticker: "AUBN" },
    { name: "WRN - Western Copper & Gold Corp", ticker: "WRN" },
    { name: "HGLB - HIGHLAND GLOBAL ALLOCATION FUND", ticker: "HGLB" },
    { name: "EBMT - Eagle Bancorp Montana, Inc.", ticker: "EBMT" },
    { name: "WLFC - WILLIS LEASE FINANCE CORP", ticker: "WLFC" },
    { name: "TRX - Tanzanian Gold Corp", ticker: "TRX" },
    { name: "DLA - DELTA APPAREL, INC", ticker: "DLA" },
    { name: "FRBK - REPUBLIC FIRST BANCORP INC", ticker: "FRBK" },
    { name: "CVLY - CODORUS VALLEY BANCORP INC", ticker: "CVLY" },
    { name: "BELFA - BEL FUSE INC /NJ", ticker: "BELFA" },
    { name: "EOLS - Evolus, Inc.", ticker: "EOLS" },
    { name: "BIVI - BIOVIE INC.", ticker: "BIVI" },
    { name: "NERV - Minerva Neurosciences, Inc.", ticker: "NERV" },
    { name: "METC - Ramaco Resources, Inc.", ticker: "METC" },
    { name: "SJT - SAN JUAN BASIN ROYALTY TRUST", ticker: "SJT" },
    { name: "IVAC - INTEVAC INC", ticker: "IVAC" },
    { name: "PIRS - PIERIS PHARMACEUTICALS, INC.", ticker: "PIRS" },
    { name: "MBCN - MIDDLEFIELD BANC CORP", ticker: "MBCN" },
    { name: "ASUR - ASURE SOFTWARE INC", ticker: "ASUR" },
    { name: "TCFC - COMMUNITY FINANCIAL CORP /MD/", ticker: "TCFC" },
    { name: "LNGB - KAOPU GROUP INC", ticker: "LNGB" },
    { name: "FSFG - First Savings Financial Group, Inc.", ticker: "FSFG" },
    { name: "AIRG - AIRGAIN INC", ticker: "AIRG" },
    { name: "ALID - Allied Corp.", ticker: "ALID" },
    { name: "POETF - POET TECHNOLOGIES INC.", ticker: "POETF" },
    { name: "DRTT - DIRTT ENVIRONMENTAL SOLUTIONS LTD", ticker: "DRTT" },
    { name: "LEU - CENTRUS ENERGY CORP", ticker: "LEU" },
    { name: "ZEUS - OLYMPIC STEEL INC", ticker: "ZEUS" },
    { name: "ESQ - Esquire Financial Holdings, Inc.", ticker: "ESQ" },
    { name: "CDTX - Cidara Therapeutics, Inc.", ticker: "CDTX" },
    { name: "EVOA - EVO Transportation & Energy Services, Inc.", ticker: "EVOA" },
    { name: "LPTX - LEAP THERAPEUTICS, INC.", ticker: "LPTX" },
    { name: "RBYCF - RUBICON MINERALS CORP", ticker: "RBYCF" },
    { name: "CHND - CHINA MEDIA INC.", ticker: "CHND" },
    { name: "AYTU - AYTU BIOSCIENCE, INC", ticker: "AYTU" },
    { name: "CLXT - Calyxt, Inc.", ticker: "CLXT" },
    { name: "GNCA - GENOCEA BIOSCIENCES, INC.", ticker: "GNCA" },
    { name: "OBSV - ObsEva SA", ticker: "OBSV" },
    { name: "TYME - TYME TECHNOLOGIES, INC.", ticker: "TYME" },
    { name: "ISBA - ISABELLA BANK Corp", ticker: "ISBA" },
    { name: "OXSQ - Oxford Square Capital Corp.", ticker: "OXSQ" },
    { name: "IMNM - Immunome Inc.", ticker: "IMNM" },
    { name: "CLPT - ClearPoint Neuro, Inc.", ticker: "CLPT" },
    { name: "RDCM - RADCOM LTD", ticker: "RDCM" },
    { name: "NHVCF - Northern Vertex Mining Corp.", ticker: "NHVCF" },
    { name: "PDEX - PRO DEX INC", ticker: "PDEX" },
    { name: "EVOK - Evoke Pharma Inc", ticker: "EVOK" },
    { name: "XXII - 22nd Century Group, Inc.", ticker: "XXII" },
    { name: "PURE - PURE BIOSCIENCE, INC.", ticker: "PURE" },
    { name: "SFE - SAFEGUARD SCIENTIFICS INC", ticker: "SFE" },
    { name: "ALEAF - Aleafia Health Inc.", ticker: "ALEAF" },
    { name: "EVBN - EVANS BANCORP INC", ticker: "EVBN" },
    { name: "EWLU - Merion, Inc.", ticker: "EWLU" },
    { name: "GNLN - Greenlane Holdings, Inc.", ticker: "GNLN" },
    { name: "OVLY - Oak Valley Bancorp", ticker: "OVLY" },
    { name: "KRUS - KURA SUSHI USA, INC.", ticker: "KRUS" },
    { name: "HFUS - Hartford Great Health Corp.", ticker: "HFUS" },
    { name: "ELA - Envela Corp", ticker: "ELA" },
    { name: "ESKYF - ESKAY MINING CORP", ticker: "ESKYF" },
    { name: "BWFG - Bankwell Financial Group, Inc.", ticker: "BWFG" },
    { name: "MESA - MESA AIR GROUP INC", ticker: "MESA" },
    { name: "HWBK - HAWTHORN BANCSHARES, INC.", ticker: "HWBK" },
    { name: "DSX - DIANA SHIPPING INC.", ticker: "DSX" },
    { name: "AGFS - AgroFresh Solutions, Inc.", ticker: "AGFS" },
    { name: "ATTO - Atento S.A.", ticker: "ATTO" },
    { name: "TGAN - Transphorm, Inc.", ticker: "TGAN" },
    { name: "LKCO - Luokung Technology Corp.", ticker: "LKCO" },
    { name: "MRGE - Mirage Energy Corp", ticker: "MRGE" },
    { name: "PLX - Protalix BioTherapeutics, Inc.", ticker: "PLX" },
    { name: "BNED - Barnes & Noble Education, Inc.", ticker: "BNED" },
    { name: "YCBD - cbdMD, Inc.", ticker: "YCBD" },
    { name: "IFRX - InflaRx N.V.", ticker: "IFRX" },
    { name: "HBIO - HARVARD BIOSCIENCE INC", ticker: "HBIO" },
    { name: "WBAI - 500.com Ltd", ticker: "WBAI" },
    { name: "CGLO - Coro Global Inc.", ticker: "CGLO" },
    { name: "LCHD - Leader Capital Holdings Corp.", ticker: "LCHD" },
    { name: "TH - Target Hospitality Corp.", ticker: "TH" },
    { name: "BANX - StoneCastle Financial Corp.", ticker: "BANX" },
    { name: "FNCB - FNCB Bancorp, Inc.", ticker: "FNCB" },
    { name: "PNRG - PRIMEENERGY RESOURCES CORP", ticker: "PNRG" },
    { name: "AVNW - AVIAT NETWORKS, INC.", ticker: "AVNW" },
    { name: "AZYO - AZIYO BIOLOGICS, INC.", ticker: "AZYO" },
    { name: "BATL - BATTALION OIL CORP", ticker: "BATL" },
    { name: "WINT - WINDTREE THERAPEUTICS INC /DE/", ticker: "WINT" },
    { name: "MNSB - MainStreet Bancshares, Inc.", ticker: "MNSB" },
    { name: "CIZN - CITIZENS HOLDING CO /MS/", ticker: "CIZN" },
    { name: "CSBR - CHAMPIONS ONCOLOGY, INC.", ticker: "CSBR" },
    { name: "PED - PEDEVCO CORP", ticker: "PED" },
    { name: "SBFG - SB FINANCIAL GROUP, INC.", ticker: "SBFG" },
    { name: "IIN - INTRICON CORP", ticker: "IIN" },
    { name: "NGS - NATURAL GAS SERVICES GROUP INC", ticker: "NGS" },
    { name: "MDXL - MediXall Group, Inc.", ticker: "MDXL" },
    { name: "XFOR - X4 Pharmaceuticals, Inc", ticker: "XFOR" },
    { name: "CYAD - Celyad Oncology SA", ticker: "CYAD" },
    { name: "APRN - Blue Apron Holdings, Inc.", ticker: "APRN" },
    { name: "RENN - Renren Inc.", ticker: "RENN" },
    { name: "CMCT - CIM Commercial Trust Corp", ticker: "CMCT" },
    { name: "CBAN - COLONY BANKCORP INC", ticker: "CBAN" },
    { name: "VTVT - vTv Therapeutics Inc.", ticker: "VTVT" },
    { name: "SGA - SAGA COMMUNICATIONS INC", ticker: "SGA" },
    { name: "SIEB - SIEBERT FINANCIAL CORP", ticker: "SIEB" },
    { name: "INVE - Identiv, Inc.", ticker: "INVE" },
    { name: "EVGN - Evogene Ltd.", ticker: "EVGN" },
    { name: "MARK - REMARK HOLDINGS, INC.", ticker: "MARK" },
    { name: "MHGU - MERITAGE HOSPITALITY GROUP INC", ticker: "MHGU" },
    { name: "BENH - Bio-En Holdings Corp.", ticker: "BENH" },
    { name: "NTOX - NOTOX TECHNOLOGIES CORP.", ticker: "NTOX" },
    { name: "DLHC - DLH Holdings Corp.", ticker: "DLHC" },
    { name: "STIM - Neuronetics, Inc.", ticker: "STIM" },
    { name: "CBIO - CATALYST BIOSCIENCES, INC.", ticker: "CBIO" },
    { name: "AGD - ABERDEEN GLOBAL DYNAMIC DIVIDEND FUND", ticker: "AGD" },
    { name: "ERYP - Erytech Pharma S.A.", ticker: "ERYP" },
    { name: "MG - Mistras Group, Inc.", ticker: "MG" },
    { name: "LUMO - LUMOS PHARMA, INC.", ticker: "LUMO" },
    { name: "WPG - WASHINGTON PRIME GROUP INC.", ticker: "WPG" },
    { name: "LSAC - LifeSci Acquisition Corp.", ticker: "LSAC" },
    { name: "AKOM - Aerkomm Inc.", ticker: "AKOM" },
    { name: "ELVT - Elevate Credit, Inc.", ticker: "ELVT" },
    { name: "ANPCY - ANGLE plc", ticker: "ANPCY" },
    { name: "GMGI - Golden Matrix Group, Inc.", ticker: "GMGI" },
    { name: "MLSS - MILESTONE SCIENTIFIC INC.", ticker: "MLSS" },
    { name: "KOPN - KOPIN CORP", ticker: "KOPN" },
    { name: "TSRMF - TREASURY METALS INC", ticker: "TSRMF" },
    { name: "KULR - KULR Technology Group, Inc.", ticker: "KULR" },
    { name: "INSE - Inspired Entertainment, Inc.", ticker: "INSE" },
    { name: "ELOX - Eloxx Pharmaceuticals, Inc.", ticker: "ELOX" },
    { name: "HCHC - HC2 HOLDINGS, INC.", ticker: "HCHC" },
    { name: "FNWB - First Northwest Bancorp", ticker: "FNWB" },
    { name: "CRVS - Corvus Pharmaceuticals, Inc.", ticker: "CRVS" },
    { name: "AGS - PlayAGS, Inc.", ticker: "AGS" },
    { name: "DHX - DHI GROUP, INC.", ticker: "DHX" },
    { name: "AFI - Armstrong Flooring, Inc.", ticker: "AFI" },
    { name: "LOV - Spark Networks SE", ticker: "LOV" },
    { name: "RVSB - RIVERVIEW BANCORP INC", ticker: "RVSB" },
    { name: "PTGEF - PORTAGE BIOTECH INC.", ticker: "PTGEF" },
    { name: "MPV - BARINGS PARTICIPATION INVESTORS", ticker: "MPV" },
    { name: "INMB - Inmune Bio, Inc.", ticker: "INMB" },
    { name: "ABEO - ABEONA THERAPEUTICS INC.", ticker: "ABEO" },
    { name: "CATB - CATABASIS PHARMACEUTICALS INC", ticker: "CATB" },
    { name: "ORGS - Orgenesis Inc.", ticker: "ORGS" },
    { name: "MYFW - First Western Financial Inc", ticker: "MYFW" },
    { name: "NWIN - NORTHWEST INDIANA BANCORP", ticker: "NWIN" },
    { name: "SGOC - SGOCO Group, Ltd.", ticker: "SGOC" },
    { name: "CFFI - C & F FINANCIAL CORP", ticker: "CFFI" },
    { name: "CWGL - Crimson Wine Group, Ltd", ticker: "CWGL" },
    { name: "AAU - ALMADEN MINERALS LTD", ticker: "AAU" },
    { name: "MITT - AG Mortgage Investment Trust, Inc.", ticker: "MITT" },
    { name: "LAIX - LAIX Inc.", ticker: "LAIX" },
    { name: "GRTS - Gritstone Oncology, Inc.", ticker: "GRTS" },
    { name: "KBLB - Kraig Biocraft Laboratories, Inc", ticker: "KBLB" },
    { name: "BFIN - BankFinancial CORP", ticker: "BFIN" },
    { name: "POWW - AMMO, INC.", ticker: "POWW" },
    { name: "MRBK - Meridian Corp", ticker: "MRBK" },
    { name: "ATBPF - Antibe Therapeutics Inc.", ticker: "ATBPF" },
    { name: "CXDO - Crexendo, Inc.", ticker: "CXDO" },
    { name: "UNB - UNION BANKSHARES INC", ticker: "UNB" },
    { name: "LJPC - LA JOLLA PHARMACEUTICAL CO", ticker: "LJPC" },
    { name: "LTRN - Lantern Pharma Inc.", ticker: "LTRN" },
    { name: "PGSVY - PGS ASA", ticker: "PGSVY" },
    { name: "LXEH - Lixiang Education Holding Co . Ltd", ticker: "LXEH" },
    { name: "MTBC - MTBC, Inc.", ticker: "MTBC" },
    { name: "CLPR - Clipper Realty Inc.", ticker: "CLPR" },
    { name: "FKYS - FIRST KEYSTONE CORP", ticker: "FKYS" },
    { name: "VVPR - VivoPower International PLC", ticker: "VVPR" },
    { name: "XTNT - Xtant Medical Holdings, Inc.", ticker: "XTNT" },
    { name: "LQMT - LIQUIDMETAL TECHNOLOGIES INC", ticker: "LQMT" },
    { name: "CEIX - CONSOL Energy Inc.", ticker: "CEIX" },
    { name: "OVBC - OHIO VALLEY BANC CORP", ticker: "OVBC" },
    { name: "EMKR - EMCORE CORP", ticker: "EMKR" },
    { name: "FNRN - FIRST NORTHERN COMMUNITY BANCORP", ticker: "FNRN" },
    { name: "CBFV - CB Financial Services, Inc.", ticker: "CBFV" },
    { name: "KRKR - 36Kr Holdings Inc.", ticker: "KRKR" },
    { name: "STAL - Star Alliance International Corp.", ticker: "STAL" },
    { name: "NMTR - 9 METERS BIOPHARMA, INC.", ticker: "NMTR" },
    { name: "ZYNE - Zynerba Pharmaceuticals, Inc.", ticker: "ZYNE" },
    { name: "CALB - California BanCorp", ticker: "CALB" },
    { name: "ISSC - INNOVATIVE SOLUTIONS & SUPPORT INC", ticker: "ISSC" },
    { name: "VGZ - VISTA GOLD CORP", ticker: "VGZ" },
    { name: "LTDH - LIVING 3D HOLDINGS, INC.", ticker: "LTDH" },
    { name: "LPI - Laredo Petroleum, Inc.", ticker: "LPI" },
    { name: "CVEO - Civeo Corp", ticker: "CVEO" },
    { name: "PLBC - PLUMAS BANCORP", ticker: "PLBC" },
    { name: "PBT - PERMIAN BASIN ROYALTY TRUST", ticker: "PBT" },
    { name: "LARK - LANDMARK BANCORP INC", ticker: "LARK" },
    { name: "CMLS - CUMULUS MEDIA INC", ticker: "CMLS" },
    { name: "ENBP - ENB Financial Corp", ticker: "ENBP" },
    { name: "GSM - Ferroglobe PLC", ticker: "GSM" },
    { name: "PEBK - PEOPLES BANCORP OF NORTH CAROLINA INC", ticker: "PEBK" },
    { name: "TEDU - Tarena International, Inc.", ticker: "TEDU" },
    { name: "PINE - Alpine Income Property Trust, Inc.", ticker: "PINE" },
    { name: "HQI - HireQuest, Inc.", ticker: "HQI" },
    { name: "FENG - Phoenix New Media Ltd", ticker: "FENG" },
    { name: "KAVL - Kaival Brands Innovations Group, Inc.", ticker: "KAVL" },
    { name: "TMRC - Texas Mineral Resources Corp.", ticker: "TMRC" },
    { name: "FCCO - FIRST COMMUNITY CORP /SC/", ticker: "FCCO" },
    { name: "XIN - Xinyuan Real Estate Co., Ltd.", ticker: "XIN" },
    { name: "PHAS - PhaseBio Pharmaceuticals Inc", ticker: "PHAS" },
    { name: "UBFO - UNITED SECURITY BANCSHARES", ticker: "UBFO" },
    { name: "BSBK - Bogota Financial Corp.", ticker: "BSBK" },
    { name: "DS - Drive Shack Inc.", ticker: "DS" },
    { name: "XAIR - Beyond Air, Inc.", ticker: "XAIR" },
    { name: "CPSS - CONSUMER PORTFOLIO SERVICES, INC.", ticker: "CPSS" },
    { name: "WATT - Energous Corp", ticker: "WATT" },
    { name: "WTER - ALKALINE WATER Co INC", ticker: "WTER" },
    { name: "PCTI - PC TEL INC", ticker: "PCTI" },
    { name: "PROV - PROVIDENT FINANCIAL HOLDINGS INC", ticker: "PROV" },
    { name: "ASC - Ardmore Shipping Corp", ticker: "ASC" },
    { name: "OTLK - Outlook Therapeutics, Inc.", ticker: "OTLK" },
    { name: "CTGO - Contango ORE, Inc.", ticker: "CTGO" },
    { name: "WSTG - Wayside Technology Group, Inc.", ticker: "WSTG" },
    { name: "III - Information Services Group Inc.", ticker: "III" },
    { name: "FLUX - Flux Power Holdings, Inc.", ticker: "FLUX" },
    { name: "GASS - StealthGas Inc.", ticker: "GASS" },
    { name: "LSYN - Liberated Syndication Inc.", ticker: "LSYN" },
    { name: "XTEG - XT Energy Group, Inc.", ticker: "XTEG" },
    { name: "LIVK - LIV Capital Acquisition Corp.", ticker: "LIVK" },
    { name: "MHLD - Maiden Holdings, Ltd.", ticker: "MHLD" },
    { name: "FRAF - FRANKLIN FINANCIAL SERVICES CORP /PA/", ticker: "FRAF" },
    { name: "NRBO - NeuroBo Pharmaceuticals, Inc.", ticker: "NRBO" },
    { name: "MDWD - MediWound Ltd.", ticker: "MDWD" },
    { name: "QLGN - Qualigen Therapeutics, Inc.", ticker: "QLGN" },
    { name: "SPAZF - SPANISH MOUNTAIN GOLD LTD.", ticker: "SPAZF" },
    { name: "OCX - OncoCyte Corp", ticker: "OCX" },
    { name: "BASA - BASANITE, INC.", ticker: "BASA" },
    { name: "CAAS - CHINA AUTOMOTIVE SYSTEMS INC", ticker: "CAAS" },
    { name: "LOVV - LOVE INTERNATIONAL GROUP, INC.", ticker: "LOVV" },
    { name: "QNBC - QNB CORP", ticker: "QNBC" },
    { name: "CEMI - CHEMBIO DIAGNOSTICS, INC.", ticker: "CEMI" },
    { name: "ULBI - ULTRALIFE CORP", ticker: "ULBI" },
    { name: "KSHB - KushCo Holdings, Inc.", ticker: "KSHB" },
    { name: "WHG - WESTWOOD HOLDINGS GROUP INC", ticker: "WHG" },
    { name: "BEEM - Envision Solar International, Inc.", ticker: "BEEM" },
    { name: "SPPP - SPROTT PHYSICAL PLATINUM & PALLADIUM TRUST", ticker: "SPPP" },
    { name: "PCYG - PARK CITY GROUP INC", ticker: "PCYG" },
    { name: "SB - SAFE BULKERS, INC.", ticker: "SB" },
    { name: "AERO - AeroGrow International, Inc.", ticker: "AERO" },
    { name: "ERDCF - Erdene Resource Development Corp", ticker: "ERDCF" },
    { name: "KTCC - KEY TRONIC CORP", ticker: "KTCC" },
    { name: "DRIO - DarioHealth Corp.", ticker: "DRIO" },
    { name: "OPBK - OP Bancorp", ticker: "OPBK" },
    { name: "UONE - URBAN ONE, INC.", ticker: "UONE" },
    { name: "ENZ - ENZO BIOCHEM INC", ticker: "ENZ" },
    { name: "LIZI - LIZHI INC.", ticker: "LIZI" },
    { name: "VERO - Venus Concept Inc.", ticker: "VERO" },
    { name: "PTN - PALATIN TECHNOLOGIES INC", ticker: "PTN" },
    { name: "RMTI - ROCKWELL MEDICAL, INC.", ticker: "RMTI" },
    { name: "APCX - AppTech Corp.", ticker: "APCX" },
    { name: "PAVM - PAVmed Inc.", ticker: "PAVM" },
    { name: "BORR - Borr Drilling Ltd", ticker: "BORR" },
    { name: "FREVS - FIRST REAL ESTATE INVESTMENT TRUST OF NEW JERSEY", ticker: "FREVS" },
    { name: "SACH - Sachem Capital Corp.", ticker: "SACH" },
    { name: "JUVF - JUNIATA VALLEY FINANCIAL CORP", ticker: "JUVF" },
    { name: "CPTP - CAPITAL PROPERTIES INC /RI/", ticker: "CPTP" },
    { name: "EMYB - Embassy Bancorp, Inc.", ticker: "EMYB" },
    { name: "WEYL - LOGIQ, INC.", ticker: "WEYL" },
    { name: "ONCY - ONCOLYTICS BIOTECH INC", ticker: "ONCY" },
    { name: "FFNW - First Financial Northwest, Inc.", ticker: "FFNW" },
    { name: "SDSYA - SOUTH DAKOTA SOYBEAN PROCESSORS LLC", ticker: "SDSYA" },
    { name: "PTRS - PARTNERS BANCORP", ticker: "PTRS" },
    { name: "FTFT - Future FinTech Group Inc.", ticker: "FTFT" },
    { name: "AMTX - AEMETIS, INC", ticker: "AMTX" },
    { name: "AI-old(changed) - Arlington Asset Investment Corp.", ticker: "AI-old(changed)" },
    { name: "NMRD - Nemaura Medical Inc.", ticker: "NMRD" },
    { name: "ORN - Orion Group Holdings Inc", ticker: "ORN" },
    { name: "PBPB - POTBELLY CORP", ticker: "PBPB" },
    { name: "SFUN - Fang Holdings Ltd", ticker: "SFUN" },
    { name: "EACO - EACO CORP", ticker: "EACO" },
    { name: "CSBB - CSB BANCORP INC /OH", ticker: "CSBB" },
    { name: "ONCS - ONCOSEC MEDICAL Inc", ticker: "ONCS" },
    { name: "SSVFF - SOUTHERN SILVER EXPLORATION CORP", ticker: "SSVFF" },
    { name: "VEL - Velocity Financial, Inc.", ticker: "VEL" },
    { name: "FUNC - FIRST UNITED CORP/MD/", ticker: "FUNC" },
    { name: "SENS - Senseonics Holdings, Inc.", ticker: "SENS" },
    { name: "TNXP - Tonix Pharmaceuticals Holding Corp.", ticker: "TNXP" },
    { name: "RPMT - REGO PAYMENT ARCHITECTURES, INC.", ticker: "RPMT" },
    { name: "FEIM - FREQUENCY ELECTRONICS INC", ticker: "FEIM" },
    { name: "USDP - USD Partners LP", ticker: "USDP" },
    { name: "ALRN - AILERON THERAPEUTICS INC", ticker: "ALRN" },
    { name: "HBP - HUTTIG BUILDING PRODUCTS INC", ticker: "HBP" },
    { name: "BKSC - BANK OF SOUTH CAROLINA CORP", ticker: "BKSC" },
    { name: "MNTX - Manitex International, Inc.", ticker: "MNTX" },
    { name: "PSIX - POWER SOLUTIONS INTERNATIONAL, INC.", ticker: "PSIX" },
    { name: "AE - ADAMS RESOURCES & ENERGY, INC.", ticker: "AE" },
    { name: "AVCO - Avalon GloboCare Corp.", ticker: "AVCO" },
    { name: "BGSF - BG Staffing, Inc.", ticker: "BGSF" },
    { name: "BAYK - BAY BANKS OF VIRGINIA INC", ticker: "BAYK" },
    { name: "CYCN - Cyclerion Therapeutics, Inc.", ticker: "CYCN" },
    { name: "TSQ - Townsquare Media, Inc.", ticker: "TSQ" },
    { name: "ASM - AVINO SILVER & GOLD MINES LTD", ticker: "ASM" },
    { name: "CHRA - Charah Solutions, Inc.", ticker: "CHRA" },
    { name: "NUVR - Nuvera Communications, Inc.", ticker: "NUVR" },
    { name: "GRNQ - Greenpro Capital Corp.", ticker: "GRNQ" },
    { name: "LPCN - Lipocine Inc.", ticker: "LPCN" },
    { name: "ASYS - AMTECH SYSTEMS INC", ticker: "ASYS" },
    { name: "AMST - Amesite Inc.", ticker: "AMST" },
    { name: "PXLW - PIXELWORKS, INC", ticker: "PXLW" },
    { name: "INTEQ - Intelsat S.A.", ticker: "INTEQ" },
    { name: "CFBK - CF BANKSHARES INC.", ticker: "CFBK" },
    { name: "APM - Aptorum Group Ltd", ticker: "APM" },
    { name: "EYEN - EYENOVIA, INC.", ticker: "EYEN" },
    { name: "CGAAY - A2B Australia Limited/ADR", ticker: "CGAAY" },
    { name: "UTGN - UTG INC", ticker: "UTGN" },
    { name: "AIM - AIM ImmunoTech Inc.", ticker: "AIM" },
    { name: "BSVN - Bank7 Corp.", ticker: "BSVN" },
    { name: "REFR - RESEARCH FRONTIERS INC", ticker: "REFR" },
    { name: "NEON - Neonode Inc.", ticker: "NEON" },
    { name: "RMBL - RumbleON, Inc.", ticker: "RMBL" },
    { name: "WKEY - Wisekey International Holding S.A.", ticker: "WKEY" },
    { name: "OPES - Opes Acquisition Corp.", ticker: "OPES" },
    { name: "NOBH - NOBILITY HOMES INC", ticker: "NOBH" },
    { name: "EXN - EXCELLON RESOURCES INC", ticker: "EXN" },
    { name: "BLPH - Bellerophon Therapeutics, Inc.", ticker: "BLPH" },
    { name: "WCAGY - Wirecard AG/ADR", ticker: "WCAGY" },
    { name: "CAPR - CAPRICOR THERAPEUTICS, INC.", ticker: "CAPR" },
    { name: "ACU - ACME UNITED CORP", ticker: "ACU" },
    { name: "EFSI - EAGLE FINANCIAL SERVICES INC", ticker: "EFSI" },
    { name: "RMRM - RMR Mortgage Trust", ticker: "RMRM" },
    { name: "STRT - STRATTEC SECURITY CORP", ticker: "STRT" },
    { name: "NVOS - Novo Integrated Sciences, Inc.", ticker: "NVOS" },
    { name: "DLNG - Dynagas LNG Partners LP", ticker: "DLNG" },
    { name: "MAGS - MAGAL SECURITY SYSTEMS LTD", ticker: "MAGS" },
    { name: "RRTS - Roadrunner Transportation Systems, Inc.", ticker: "RRTS" },
    { name: "TZOO - TRAVELZOO", ticker: "TZOO" },
    { name: "GLBD - Global Seed Corp", ticker: "GLBD" },
    { name: "CDJM - Carnegie Development, Inc", ticker: "CDJM" },
    { name: "GEVO - Gevo, Inc.", ticker: "GEVO" },
    { name: "UAN - CVR PARTNERS, LP", ticker: "UAN" },
    { name: "CBSC - CB SCIENTIFIC, INC.", ticker: "CBSC" },
    { name: "NBRV - Nabriva Therapeutics plc", ticker: "NBRV" },
    { name: "GEN - Genesis Healthcare, Inc.", ticker: "GEN" },
    { name: "PESI - PERMA FIX ENVIRONMENTAL SERVICES INC", ticker: "PESI" },
    { name: "RDI - READING INTERNATIONAL INC", ticker: "RDI" },
    { name: "IMMP - IMMUTEP Ltd", ticker: "IMMP" },
    { name: "MCHX - MARCHEX INC", ticker: "MCHX" },
    { name: "CXDC - China XD Plastics Co Ltd", ticker: "CXDC" },
    { name: "AVBH - Avidbank Holdings, Inc.", ticker: "AVBH" },
    { name: "ISDR - ISSUER DIRECT CORP", ticker: "ISDR" },
    { name: "MCAC - Mountain Crest Acquisition Corp.", ticker: "MCAC" },
    { name: "ADES - Advanced Emissions Solutions, Inc.", ticker: "ADES" },
    { name: "LWAY - Lifeway Foods, Inc.", ticker: "LWAY" },
    { name: "JP - Jupai Holdings Ltd", ticker: "JP" },
    { name: "HSTI - High Sierra Technologies, Inc.", ticker: "HSTI" },
    { name: "PFMT - Performant Financial Corp", ticker: "PFMT" },
    { name: "PRPH - ProPhase Labs, Inc.", ticker: "PRPH" },
    { name: "ICTSF - ICTS INTERNATIONAL N V", ticker: "ICTSF" },
    { name: "BRBS - BLUE RIDGE BANKSHARES, INC.", ticker: "BRBS" },
    { name: "OPOF - OLD POINT FINANCIAL CORP", ticker: "OPOF" },
    { name: "ARAV - Aravive, Inc.", ticker: "ARAV" },
    { name: "FLL - FULL HOUSE RESORTS INC", ticker: "FLL" },
    { name: "NTZ - NATUZZI S P A", ticker: "NTZ" },
    { name: "SINC - Sincerity Applied Materials Holdings Corp.", ticker: "SINC" },
    { name: "PFLC - PACIFIC FINANCIAL CORP", ticker: "PFLC" },
    { name: "DMAC - DiaMedica Therapeutics Inc.", ticker: "DMAC" },
    { name: "GEOS - GEOSPACE TECHNOLOGIES CORP", ticker: "GEOS" },
    { name: "CZWI - Citizens Community Bancorp Inc.", ticker: "CZWI" },
    { name: "TNGL - TONOGOLD RESOURCES INC", ticker: "TNGL" },
    { name: "IWBB - IWEB, Inc.", ticker: "IWBB" },
    { name: "ABML - AMERICAN BATTERY METALS CORP", ticker: "ABML" },
    { name: "ABVC - American BriVision (Holding) Corp", ticker: "ABVC" },
    { name: "AIRRF - Aurion Resources Ltd.", ticker: "AIRRF" },
    { name: "CRBP - Corbus Pharmaceuticals Holdings, Inc.", ticker: "CRBP" },
    { name: "BNGO - Bionano Genomics, Inc", ticker: "BNGO" },
    { name: "FETM - FENTURA FINANCIAL INC", ticker: "FETM" },
    { name: "BOXL - Boxlight Corp", ticker: "BOXL" },
    { name: "GTE - GRAN TIERRA ENERGY INC.", ticker: "GTE" },
    { name: "BHR - Braemar Hotels & Resorts Inc.", ticker: "BHR" },
    { name: "MARA - Marathon Patent Group, Inc.", ticker: "MARA" },
    { name: "BKGM - BankGuam Holding Co", ticker: "BKGM" },
    { name: "TC - TuanChe Ltd", ticker: "TC" },
    { name: "AP - AMPCO PITTSBURGH CORP", ticker: "AP" },
    { name: "NTIC - NORTHERN TECHNOLOGIES INTERNATIONAL CORP", ticker: "NTIC" },
    { name: "AERG - APPLIED ENERGETICS, INC.", ticker: "AERG" },
    { name: "MRKR - Marker Therapeutics, Inc.", ticker: "MRKR" },
    { name: "CRECF - Critical Elements Lithium Corp", ticker: "CRECF" },
    { name: "RBKB - Rhinebeck Bancorp, Inc.", ticker: "RBKB" },
    { name: "LIXT - LIXTE BIOTECHNOLOGY HOLDINGS, INC.", ticker: "LIXT" },
    { name: "AMBO - Ambow Education Holding Ltd.", ticker: "AMBO" },
    { name: "URG - UR-ENERGY INC", ticker: "URG" },
    { name: "ELMD - Electromed, Inc.", ticker: "ELMD" },
    { name: "ECOR - electroCore, Inc.", ticker: "ECOR" },
    { name: "EPSN - Epsilon Energy Ltd.", ticker: "EPSN" },
    { name: "BBLG - Bone Biologics Corp", ticker: "BBLG" },
    { name: "MFAC - Megalith Financial Acquisition Corp", ticker: "MFAC" },
    { name: "SANW - S&W Seed Co", ticker: "SANW" },
    { name: "GRIN - Grindrod Shipping Holdings Ltd.", ticker: "GRIN" },
    { name: "ASRT - Assertio Holdings, Inc.", ticker: "ASRT" },
    { name: "NR - NEWPARK RESOURCES INC", ticker: "NR" },
    { name: "SFBC - Sound Financial Bancorp, Inc.", ticker: "SFBC" },
    { name: "HWIN - HOMETOWN INTERNATIONAL, INC.", ticker: "HWIN" },
    { name: "CCM - Concord Medical Services Holdings Ltd", ticker: "CCM" },
    { name: "FCRD - First Eagle Alternative Capital BDC, Inc.", ticker: "FCRD" },
    { name: "KTOV - Kitov Pharma Ltd.", ticker: "KTOV" },
    { name: "LSBK - LAKE SHORE BANCORP, INC.", ticker: "LSBK" },
    { name: "ADMP - Adamis Pharmaceuticals Corp", ticker: "ADMP" },
    { name: "MRZM - MARIZYME INC", ticker: "MRZM" },
    { name: "FARM - FARMER BROTHERS CO", ticker: "FARM" },
    { name: "IMBI - iMedia Brands, Inc.", ticker: "IMBI" },
    { name: "CMTV - COMMUNITY BANCORP /VT", ticker: "CMTV" },
    { name: "DTSS - DATASEA INC.", ticker: "DTSS" },
    { name: "RYB - RYB Education, Inc.", ticker: "RYB" },
    { name: "HSBI - HERITAGE SOUTHEAST BANCORPORATION, INC.", ticker: "HSBI" },
    { name: "CORR - CorEnergy Infrastructure Trust, Inc.", ticker: "CORR" },
    { name: "BWEN - BROADWIND, INC.", ticker: "BWEN" },
    { name: "IDRA - IDERA PHARMACEUTICALS, INC.", ticker: "IDRA" },
    { name: "TUSK - MAMMOTH ENERGY SERVICES, INC.", ticker: "TUSK" },
    { name: "NREF - NexPoint Real Estate Finance, Inc.", ticker: "NREF" },
    { name: "CMT - CORE MOLDING TECHNOLOGIES INC", ticker: "CMT" },
    { name: "LKCRU - LAKE AREA CORN PROCESSORS LLC", ticker: "LKCRU" },
    { name: "TWIN - TWIN DISC INC", ticker: "TWIN" },
    { name: "SCTY - MONITRONICS INTERNATIONAL INC", ticker: "SCTY" },
    { name: "INTG - INTERGROUP CORP", ticker: "INTG" },
    { name: "LMB - Limbach Holdings, Inc.", ticker: "LMB" },
    { name: "AXIM - AXIM BIOTECHNOLOGIES, INC.", ticker: "AXIM" },
    { name: "TRRB - TripBorn, Inc.", ticker: "TRRB" },
    { name: "RNDB - Randolph Bancorp, Inc.", ticker: "RNDB" },
    { name: "EPM - EVOLUTION PETROLEUM CORP", ticker: "EPM" },
    { name: "LNSR - LENSAR, Inc.", ticker: "LNSR" },
    { name: "TLLYF - Trilogy International Partners Inc.", ticker: "TLLYF" },
    { name: "ASLN - ASLAN Pharmaceuticals Ltd", ticker: "ASLN" },
    { name: "UBAB - UNITED BANCORPORATION OF ALABAMA INC", ticker: "UBAB" },
    { name: "JCPNQ - J C PENNEY CO INC", ticker: "JCPNQ" },
    { name: "IPIX - Innovation Pharmaceuticals Inc.", ticker: "IPIX" },
    { name: "UBCP - UNITED BANCORP INC /OH/", ticker: "UBCP" },
    { name: "FFBW - FFBW, Inc. /MD/", ticker: "FFBW" },
    { name: "TTI - TETRA TECHNOLOGIES INC", ticker: "TTI" },
    { name: "GRNV - GreenVision Acquisition Corp.", ticker: "GRNV" },
    { name: "GRBX - GreenBox POS", ticker: "GRBX" },
    { name: "PETZ - TDH Holdings, Inc.", ticker: "PETZ" },
    { name: "SFDL - SECURITY FEDERAL CORP", ticker: "SFDL" },
    { name: "INFI - INFINITY PHARMACEUTICALS, INC.", ticker: "INFI" },
    { name: "MMLP - MARTIN MIDSTREAM PARTNERS L.P.", ticker: "MMLP" },
    { name: "GRRB - GRANDSOUTH BANCORPORATION", ticker: "GRRB" },
    { name: "MOST - MobileSmith, Inc.", ticker: "MOST" },
    { name: "NOVN - Novan, Inc.", ticker: "NOVN" },
    { name: "HYRE - HyreCar Inc.", ticker: "HYRE" },
    { name: "MODD - Modular Medical, Inc.", ticker: "MODD" },
    { name: "WMPN - William Penn Bancorporation", ticker: "WMPN" },
    { name: "LWLG - Lightwave Logic, Inc.", ticker: "LWLG" },
    { name: "TANH - TANTECH HOLDINGS LTD", ticker: "TANH" },
    { name: "IGAP - Integrity Applications, Inc.", ticker: "IGAP" },
    { name: "HOFV - Hall of Fame Resort & Entertainment Co", ticker: "HOFV" },
    { name: "SOLI - SOLEI SYSTEMS, INC.", ticker: "SOLI" },
    { name: "CWBC - COMMUNITY WEST BANCSHARES /", ticker: "CWBC" },
    { name: "HCFT - Hunt Companies Finance Trust, Inc.", ticker: "HCFT" },
    { name: "CLIR - ClearSign Technologies Corp", ticker: "CLIR" },
    { name: "UG - UNITED GUARDIAN INC", ticker: "UG" },
    { name: "SYBX - SYNLOGIC, INC.", ticker: "SYBX" },
    { name: "AUMN - Golden Minerals Co", ticker: "AUMN" },
    { name: "KFS - KINGSWAY FINANCIAL SERVICES INC", ticker: "KFS" },
    { name: "GLMD - Galmed Pharmaceuticals Ltd.", ticker: "GLMD" },
    { name: "ARDS - Aridis Pharmaceuticals, Inc.", ticker: "ARDS" },
    { name: "PLTYF - Plastec Technologies, Ltd.", ticker: "PLTYF" },
    { name: "AYRO - AYRO, Inc.", ticker: "AYRO" },
    { name: "FPOCF - FPX Nickel Corp.", ticker: "FPOCF" },
    { name: "GFNL - GENESIS FINANCIAL INC", ticker: "GFNL" },
    { name: "NMM - Navios Maritime Partners L.P.", ticker: "NMM" },
    { name: "HMNF - HMN FINANCIAL INC", ticker: "HMNF" },
    { name: "NHTC - NATURAL HEALTH TRENDS CORP", ticker: "NHTC" },
    { name: "RWBYF - Red White & Bloom Brands Inc.", ticker: "RWBYF" },
    { name: "PRED - PREDICTIVE TECHNOLOGY GROUP, INC.", ticker: "PRED" },
    { name: "KZIA - KAZIA THERAPEUTICS LTD", ticker: "KZIA" },
    { name: "BWAY - Brainsway Ltd.", ticker: "BWAY" },
    { name: "FGNV - FORGE INNOVATION DEVELOPMENT CORP.", ticker: "FGNV" },
    { name: "MMMB - MamaMancini's Holdings, Inc.", ticker: "MMMB" },
    { name: "SUND - Sundance Strategies, Inc.", ticker: "SUND" },
    { name: "STKS - ONE Group Hospitality, Inc.", ticker: "STKS" },
    { name: "NAVB - NAVIDEA BIOPHARMACEUTICALS, INC.", ticker: "NAVB" },
    { name: "AQMS - Aqua Metals, Inc.", ticker: "AQMS" },
    { name: "CODA - Coda Octopus Group, Inc.", ticker: "CODA" },
    { name: "CIDM - Cinedigm Corp.", ticker: "CIDM" },
    { name: "NNAX - New Momentum Corp.", ticker: "NNAX" },
    { name: "UBIA - UBI Blockchain Internet LTD-DE", ticker: "UBIA" },
    { name: "REEMF - RARE ELEMENT RESOURCES LTD", ticker: "REEMF" },
    { name: "FAT - Fat Brands, Inc", ticker: "FAT" },
    { name: "JFK - 8i Enterprises Acquisition Corp.", ticker: "JFK" },
    { name: "GSTX - Graphene & Solar Technologies Ltd", ticker: "GSTX" },
    { name: "CLSD - Clearside Biomedical, Inc.", ticker: "CLSD" },
    { name: "TACT - TRANSACT TECHNOLOGIES INC", ticker: "TACT" },
    { name: "XELA - Exela Technologies, Inc.", ticker: "XELA" },
    { name: "GMBL - ESPORTS ENTERTAINMENT GROUP, INC.", ticker: "GMBL" },
    { name: "GCEH - Global Clean Energy Holdings, Inc.", ticker: "GCEH" },
    { name: "HGBL - Heritage Global Inc.", ticker: "HGBL" },
    { name: "INLB - Item 9 Labs Corp.", ticker: "INLB" },
    { name: "SBBI - S.B.C.P. Bancorp, Inc.", ticker: "SBBI" },
    { name: "BMRA - BIOMERICA INC", ticker: "BMRA" },
    { name: "FXNC - FIRST NATIONAL CORP /VA/", ticker: "FXNC" },
    { name: "LACQ - Leisure Acquisition Corp.", ticker: "LACQ" },
    { name: "ORMP - ORAMED PHARMACEUTICALS INC.", ticker: "ORMP" },
    { name: "CDBMF - Cordoba Minerals Corp.", ticker: "CDBMF" },
    { name: "CCGN - Consumer Capital Group, Inc.", ticker: "CCGN" },
    { name: "INOD - INNODATA INC", ticker: "INOD" },
    { name: "CRIS - CURIS INC", ticker: "CRIS" },
    { name: "ATIF - ATIF Holdings Ltd", ticker: "ATIF" },
    { name: "COCP - Cocrystal Pharma, Inc.", ticker: "COCP" },
    { name: "GECC - Great Elm Capital Corp.", ticker: "GECC" },
    { name: "BBXIA - BBX Capital, Inc.", ticker: "BBXIA" },
    { name: "NTIP - NETWORK 1 TECHNOLOGIES INC", ticker: "NTIP" },
    { name: "BKRRF - BLACKROCK GOLD CORP.", ticker: "BKRRF" },
    { name: "ARMP - Armata Pharmaceuticals, Inc.", ticker: "ARMP" },
    { name: "MFIN - MEDALLION FINANCIAL CORP", ticker: "MFIN" },
    { name: "OMEX - ODYSSEY MARINE EXPLORATION INC", ticker: "OMEX" },
    { name: "EYPT - EyePoint Pharmaceuticals, Inc.", ticker: "EYPT" },
    { name: "CTXR - Citius Pharmaceuticals, Inc.", ticker: "CTXR" },
    { name: "LXU - LSB INDUSTRIES INC", ticker: "LXU" },
    { name: "XAN - Exantas Capital Corp.", ticker: "XAN" },
    { name: "EDSA - Edesa Biotech, Inc.", ticker: "EDSA" },
    { name: "CYRN - CYREN Ltd.", ticker: "CYRN" },
    { name: "KINS - KINGSTONE COMPANIES, INC.", ticker: "KINS" },
    { name: "VABK - Virginia National Bankshares Corp", ticker: "VABK" },
    { name: "GWHP - Global Wholehealth Partners Corp", ticker: "GWHP" },
    { name: "LBTI - Lithium & Boron Technology, Inc.", ticker: "LBTI" },
    { name: "KNWN - KNOW LABS, INC.", ticker: "KNWN" },
    { name: "TRVI - Trevi Therapeutics, Inc.", ticker: "TRVI" },
    { name: "PTMN - Portman Ridge Finance Corp", ticker: "PTMN" },
    { name: "HNNA - HENNESSY ADVISORS INC", ticker: "HNNA" },
    { name: "TCON - Tracon Pharmaceuticals, Inc.", ticker: "TCON" },
    { name: "RSSS - Research Solutions, Inc.", ticker: "RSSS" },
    { name: "CXXIF - C21 Investments Inc.", ticker: "CXXIF" },
    { name: "AGE - AgeX Therapeutics, Inc.", ticker: "AGE" },
    { name: "ATAO - ALTAIR INTERNATIONAL CORP.", ticker: "ATAO" },
    { name: "UBOH - UNITED BANCSHARES INC/OH", ticker: "UBOH" },
    { name: "REED - REED'S, INC.", ticker: "REED" },
    { name: "QUMU - Qumu Corp", ticker: "QUMU" },
    { name: "BIOC - BIOCEPT INC", ticker: "BIOC" },
    { name: "MHPC - MANUFACTURED HOUSING PROPERTIES INC.", ticker: "MHPC" },
    { name: "AGBA - AGBA Acquisition Ltd", ticker: "AGBA" },
    { name: "RKFL - ROCKETFUEL BLOCKCHAIN, INC.", ticker: "RKFL" },
    { name: "SVRA - Savara Inc", ticker: "SVRA" },
    { name: "BMBN - BENCHMARK BANKSHARES INC", ticker: "BMBN" },
    { name: "MLLLF - Engine Media Holdings, Inc.", ticker: "MLLLF" },
    { name: "FMBM - F&M BANK CORP", ticker: "FMBM" },
    { name: "LPTH - LIGHTPATH TECHNOLOGIES INC", ticker: "LPTH" },
    { name: "FET - FORUM ENERGY TECHNOLOGIES, INC.", ticker: "FET" },
    { name: "ALOT - AstroNova, Inc.", ticker: "ALOT" },
    { name: "PTI - PROTEOSTASIS THERAPEUTICS, INC.", ticker: "PTI" },
    { name: "NICK - NICHOLAS FINANCIAL INC", ticker: "NICK" },
    { name: "CFMS - Conformis Inc", ticker: "CFMS" },
    { name: "AREC - American Resources Corp", ticker: "AREC" },
    { name: "ATXI - AVENUE THERAPEUTICS, INC.", ticker: "ATXI" },
    { name: "CURR - Cure Pharmaceutical Holding Corp.", ticker: "CURR" },
    { name: "VYST - Vystar Corp", ticker: "VYST" },
    { name: "VTGN - VistaGen Therapeutics, Inc.", ticker: "VTGN" },
    { name: "TMDI - TITAN MEDICAL INC", ticker: "TMDI" },
    { name: "APHE - ALPHA ENERGY INC", ticker: "APHE" },
    { name: "ZIVO - Zivo Bioscience, Inc.", ticker: "ZIVO" },
    { name: "CRWS - CROWN CRAFTS INC", ticker: "CRWS" },
    { name: "KBLM - KBL MERGER CORP. IV", ticker: "KBLM" },
    { name: "CPST - CAPSTONE TURBINE Corp", ticker: "CPST" },
    { name: "BRLI - Brilliant Acquisition Corp", ticker: "BRLI" },
    { name: "NEPH - NEPHROS INC", ticker: "NEPH" },
    { name: "SOTK - SONO TEK CORP", ticker: "SOTK" },
    { name: "VERB - Verb Technology Company, Inc.", ticker: "VERB" },
    { name: "SOBR - SOBR Safe, Inc.", ticker: "SOBR" },
    { name: "ZSAN - Zosano Pharma Corp", ticker: "ZSAN" },
    { name: "SHMP - NaturalShrimp Inc", ticker: "SHMP" },
    { name: "SD - SANDRIDGE ENERGY INC", ticker: "SD" },
    { name: "BASI - BIOANALYTICAL SYSTEMS INC", ticker: "BASI" },
    { name: "DXR - DAXOR CORP", ticker: "DXR" },
    { name: "OFS - OFS Capital Corp", ticker: "OFS" },
    { name: "RNWK - REALNETWORKS INC", ticker: "RNWK" },
    { name: "RELL - RICHARDSON ELECTRONICS LTD/DE", ticker: "RELL" },
    { name: "MOHO - ECMOHO Ltd", ticker: "MOHO" },
    { name: "SND - Smart Sand, Inc.", ticker: "SND" },
    { name: "RGRX - REGENERX BIOPHARMACEUTICALS INC", ticker: "RGRX" },
    { name: "ERLFF - Entree Resources Ltd.", ticker: "ERLFF" },
    { name: "TURN - 180 DEGREE CAPITAL CORP. /NY/", ticker: "TURN" },
    { name: "GEC - Great Elm Capital Group, Inc.", ticker: "GEC" },
    { name: "VNCE - VINCE HOLDING CORP.", ticker: "VNCE" },
    { name: "SBOW - SILVERBOW RESOURCES, INC.", ticker: "SBOW" },
    { name: "GIFI - GULF ISLAND FABRICATION INC", ticker: "GIFI" },
    { name: "CPHC - Canterbury Park Holding Corp", ticker: "CPHC" },
    { name: "AKTX - Akari Therapeutics Plc", ticker: "AKTX" },
    { name: "AWRE - AWARE INC /MA/", ticker: "AWRE" },
    { name: "MPVDF - Mountain Province Diamonds Inc.", ticker: "MPVDF" },
    { name: "CCNC - Code Chain New Continent Ltd", ticker: "CCNC" },
    { name: "ARPO - Aerpio Pharmaceuticals, Inc.", ticker: "ARPO" },
    { name: "ELTP - ELITE PHARMACEUTICALS INC /NV/", ticker: "ELTP" },
    { name: "GLSI - Greenwich LifeSciences, Inc.", ticker: "GLSI" },
    { name: "HYSR - SUNHYDROGEN, INC.", ticker: "HYSR" },
    { name: "NMGRF - Nouveau Monde Mining Enterprises Inc.", ticker: "NMGRF" },
    { name: "BKEP - Blueknight Energy Partners, L.P.", ticker: "BKEP" },
    { name: "ZMTP - Zoom Telephonics, Inc.", ticker: "ZMTP" },
    { name: "SGNI - StemGen, Inc.", ticker: "SGNI" },
    { name: "VBLT - Vascular Biogenics Ltd.", ticker: "VBLT" },
    { name: "MBOT - Microbot Medical Inc.", ticker: "MBOT" },
    { name: "EGY - VAALCO ENERGY INC /DE/", ticker: "EGY" },
    { name: "ANIX - Anixa Biosciences Inc", ticker: "ANIX" },
    { name: "CWBR - CohBar, Inc.", ticker: "CWBR" },
    { name: "GFGY - Granite Falls Energy, LLC", ticker: "GFGY" },
    { name: "TRIB - TRINITY BIOTECH PLC", ticker: "TRIB" },
    { name: "WCRS - WESTERN CAPITAL RESOURCES, INC.", ticker: "WCRS" },
    { name: "UNIB - UNIVERSITY BANCORP INC /DE/", ticker: "UNIB" },
    { name: "ALNA - Allena Pharmaceuticals, Inc.", ticker: "ALNA" },
    { name: "CELC - Celcuity Inc.", ticker: "CELC" },
    { name: "AXR - AMREP CORP.", ticker: "AXR" },
    { name: "KERN - Akerna Corp.", ticker: "KERN" },
    { name: "ADXN - Addex Therapeutics Ltd.", ticker: "ADXN" },
    { name: "CTGL - CITRINE GLOBAL, CORP.", ticker: "CTGL" },
    { name: "ONVO - ORGANOVO HOLDINGS, INC.", ticker: "ONVO" },
    { name: "CCEL - CRYO CELL INTERNATIONAL INC", ticker: "CCEL" },
    { name: "DGLY - DIGITAL ALLY INC", ticker: "DGLY" },
    { name: "SRL - Scully Royalty Ltd.", ticker: "SRL" },
    { name: "NULGF - NuLegacy Gold Corp", ticker: "NULGF" },
    { name: "DFFN - Diffusion Pharmaceuticals Inc.", ticker: "DFFN" },
    { name: "SNWV - SANUWAVE Health, Inc.", ticker: "SNWV" },
    { name: "IROQ - IF Bancorp, Inc.", ticker: "IROQ" },
    { name: "COSM - Cosmos Holdings Inc.", ticker: "COSM" },
    { name: "FRSX - Foresight Autonomous Holdings Ltd.", ticker: "FRSX" },
    { name: "SFEF - SANTA FE FINANCIAL CORP", ticker: "SFEF" },
    { name: "CLPS - CLPS Inc", ticker: "CLPS" },
    { name: "CRAWA - CRAWFORD UNITED Corp", ticker: "CRAWA" },
    { name: "PT - Pintec Technology Holdings Ltd", ticker: "PT" },
    { name: "MCC - Medley Capital Corp", ticker: "MCC" },
    { name: "INVU - Investview, Inc.", ticker: "INVU" },
    { name: "IDTY - Ipsidy Inc.", ticker: "IDTY" },
    { name: "JRSH - Jerash Holdings (US), Inc.", ticker: "JRSH" },
    { name: "MNPR - Monopar Therapeutics", ticker: "MNPR" },
    { name: "FTMR - Fortem Resources Inc.", ticker: "FTMR" },
    { name: "PGTK - Pacific Green Technologies Inc.", ticker: "PGTK" },
    { name: "ARC - ARC DOCUMENT SOLUTIONS, INC.", ticker: "ARC" },
    { name: "TREN - TREND INNOVATIONS HOLDING INC.", ticker: "TREN" },
    { name: "WWR - WESTWATER RESOURCES, INC.", ticker: "WWR" },
    { name: "DWNX - DELHI BANK CORP", ticker: "DWNX" },
    { name: "SCYX - SCYNEXIS INC", ticker: "SCYX" },
    { name: "PFBX - PEOPLES FINANCIAL CORP /MS/", ticker: "PFBX" },
    { name: "PKKW - Parkway Acquisition Corp.", ticker: "PKKW" },
    { name: "NAII - NATURAL ALTERNATIVES INTERNATIONAL INC", ticker: "NAII" },
    { name: "CVSI - CV Sciences, Inc.", ticker: "CVSI" },
    { name: "YTRA - Yatra Online, Inc.", ticker: "YTRA" },
    { name: "SHWZ - Medicine Man Technologies, Inc.", ticker: "SHWZ" },
    { name: "KFFB - Kentucky First Federal Bancorp", ticker: "KFFB" },
    { name: "ONTX - Onconova Therapeutics, Inc.", ticker: "ONTX" },
    { name: "CNIG - Corning Natural Gas Holding Corp", ticker: "CNIG" },
    { name: "ICGL - Image Chain Group Limited, Inc.", ticker: "ICGL" },
    { name: "LEE - LEE ENTERPRISES, Inc", ticker: "LEE" },
    { name: "MACK - MERRIMACK PHARMACEUTICALS INC", ticker: "MACK" },
    { name: "USAP - UNIVERSAL STAINLESS & ALLOY PRODUCTS INC", ticker: "USAP" },
    { name: "CDELF - CANDELARIA MINING CORP.", ticker: "CDELF" },
    { name: "IOR - INCOME OPPORTUNITY REALTY INVESTORS INC /TX/", ticker: "IOR" },
    { name: "HALL - HALLMARK FINANCIAL SERVICES INC", ticker: "HALL" },
    { name: "SNGX - SOLIGENIX, INC.", ticker: "SNGX" },
    { name: "FLWPF - Flowr Corp", ticker: "FLWPF" },
    { name: "OPTT - Ocean Power Technologies, Inc.", ticker: "OPTT" },
    { name: "BRQS - Borqs Technologies, Inc.", ticker: "BRQS" },
    { name: "BBW - BUILD-A-BEAR WORKSHOP INC", ticker: "BBW" },
    { name: "LGHL - Lion Group Holding Ltd", ticker: "LGHL" },
    { name: "YUANF - FINCERA INC.", ticker: "YUANF" },
    { name: "IGC - India Globalization Capital, Inc.", ticker: "IGC" },
    { name: "ASRV - AMERISERV FINANCIAL INC /PA/", ticker: "ASRV" },
    { name: "KANP - KAANAPALI LAND LLC", ticker: "KANP" },
    { name: "INTT - INTEST CORP", ticker: "INTT" },
    { name: "SEED - Origin Agritech LTD", ticker: "SEED" },
    { name: "GURE - GULF RESOURCES, INC.", ticker: "GURE" },
    { name: "PBHC - Pathfinder Bancorp, Inc.", ticker: "PBHC" },
    { name: "KNIT - KINETIC GROUP INC.", ticker: "KNIT" },
    { name: "FSEA - First Seacoast Bancorp", ticker: "FSEA" },
    { name: "PIXY - ShiftPixy, Inc.", ticker: "PIXY" },
    { name: "AIHS - Senmiao Technology Ltd", ticker: "AIHS" },
    { name: "SOS - SOS Ltd", ticker: "SOS" },
    { name: "GOED - 1847 Goedeker Inc.", ticker: "GOED" },
    { name: "MBRX - Moleculin Biotech, Inc.", ticker: "MBRX" },
    { name: "HDSN - HUDSON TECHNOLOGIES INC /NY", ticker: "HDSN" },
    { name: "SMHI - SEACOR Marine Holdings Inc.", ticker: "SMHI" },
    { name: "RSKIA - GEORGE RISK INDUSTRIES, INC.", ticker: "RSKIA" },
    { name: "PDSB - PDS Biotechnology Corp", ticker: "PDSB" },
    { name: "SHRG - SHARING SERVICES GLOBAL Corp", ticker: "SHRG" },
    { name: "CHNR - CHINA NATURAL RESOURCES INC", ticker: "CHNR" },
    { name: "JGLDF - Japan Gold Corp.", ticker: "JGLDF" },
    { name: "BYFC - BROADWAY FINANCIAL CORP \\DE\\", ticker: "BYFC" },
    { name: "UGHL - UNION BRIDGE HOLDINGS LTD.", ticker: "UGHL" },
    { name: "MFON - MOBIVITY HOLDINGS CORP.", ticker: "MFON" },
    { name: "LGL - LGL GROUP INC", ticker: "LGL" },
    { name: "NUMD - Nu-Med Plus, Inc.", ticker: "NUMD" },
    { name: "BFGX - BANGFU TECHNOLOGY GROUP CO., LTD.", ticker: "BFGX" },
    { name: "DWSN - DAWSON GEOPHYSICAL CO", ticker: "DWSN" },
    { name: "PNPL - PINEAPPLE, INC.", ticker: "PNPL" },
    { name: "MMNFF - MedMen Enterprises, Inc.", ticker: "MMNFF" },
    { name: "OPGN - OPGEN INC", ticker: "OPGN" },
    { name: "REPH - Recro Pharma, Inc.", ticker: "REPH" },
    { name: "MEDS - TRXADE GROUP, INC.", ticker: "MEDS" },
    { name: "ZNRG - Znergy, Inc.", ticker: "ZNRG" },
    { name: "FUSB - FIRST US BANCSHARES INC", ticker: "FUSB" },
    { name: "VJET - voxeljet AG", ticker: "VJET" },
    { name: "WFCF - Where Food Comes From, Inc.", ticker: "WFCF" },
    { name: "EXPR - EXPRESS, INC.", ticker: "EXPR" },
    { name: "ZCMD - Zhongchao Inc.", ticker: "ZCMD" },
    { name: "MGYR - Magyar Bancorp, Inc.", ticker: "MGYR" },
    { name: "WYY - WIDEPOINT CORP", ticker: "WYY" },
    { name: "MNDO - MIND CTI LTD", ticker: "MNDO" },
    { name: "CBKM - CONSUMERS BANCORP INC /OH/", ticker: "CBKM" },
    { name: "SUNW - Sunworks, Inc.", ticker: "SUNW" },
    { name: "VIVC - VIVIC CORP.", ticker: "VIVC" },
    { name: "GVXXF - GoviEx Uranium Inc.", ticker: "GVXXF" },
    { name: "REI - RING ENERGY, INC.", ticker: "REI" },
    { name: "AUVI - Applied UV, Inc.", ticker: "AUVI" },
    { name: "STRM - STREAMLINE HEALTH SOLUTIONS INC.", ticker: "STRM" },
    { name: "ACOR - ACORDA THERAPEUTICS INC", ticker: "ACOR" },
    { name: "DCTH - DELCATH SYSTEMS, INC.", ticker: "DCTH" },
    { name: "PPIH - Perma-Pipe International Holdings, Inc.", ticker: "PPIH" },
    { name: "NTRB - NutriBand Inc.", ticker: "NTRB" },
    { name: "SINT - Sintx Technologies, Inc.", ticker: "SINT" },
    { name: "SMLP - Summit Midstream Partners, LP", ticker: "SMLP" },
    { name: "SEOVF - SERNOVA CORP.", ticker: "SEOVF" },
    { name: "ODII - Odyssey Semiconductor Technologies, Inc.", ticker: "ODII" },
    { name: "PEI - PENNSYLVANIA REAL ESTATE INVESTMENT TRUST", ticker: "PEI" },
    { name: "INPX - INPIXON", ticker: "INPX" },
    { name: "GENE - GENETIC TECHNOLOGIES LTD", ticker: "GENE" },
    { name: "HX - Hexindai Inc.", ticker: "HX" },
    { name: "CYAP - Cyber Apps World", ticker: "CYAP" },
    { name: "CPIX - CUMBERLAND PHARMACEUTICALS INC", ticker: "CPIX" },
    { name: "SRTS - Sensus Healthcare, Inc.", ticker: "SRTS" },
    { name: "PMHG - Prime Meridian Holding Co", ticker: "PMHG" },
    { name: "MTLQU - Motors Liquidation Co", ticker: "MTLQU" },
    { name: "BCOW - 1895 Bancorp of Wisconsin, Inc.", ticker: "BCOW" },
    { name: "PCSA - Processa Pharmaceuticals, Inc.", ticker: "PCSA" },
    { name: "AVHOQ - Avianca Holdings S.A.", ticker: "AVHOQ" },
    { name: "VBFC - Village Bank & Trust Financial Corp.", ticker: "VBFC" },
    { name: "HAPP - Happiness Biotech Group Ltd", ticker: "HAPP" },
    { name: "ICCH - ICC Holdings, Inc.", ticker: "ICCH" },
    { name: "BTIM - BOATIM INC.", ticker: "BTIM" },
    { name: "RFIL - R F INDUSTRIES LTD", ticker: "RFIL" },
    { name: "BOTJ - BANK OF THE JAMES FINANCIAL GROUP INC", ticker: "BOTJ" },
    { name: "MAYS - MAYS J W INC", ticker: "MAYS" },
    { name: "FWP - Forward Pharma A/S", ticker: "FWP" },
    { name: "DSWL - DESWELL INDUSTRIES INC", ticker: "DSWL" },
    { name: "TOPS - TOP SHIPS INC.", ticker: "TOPS" },
    { name: "KDOZF - KIDOZ INC.", ticker: "KDOZF" },
    { name: "AAME - ATLANTIC AMERICAN CORP", ticker: "AAME" },
    { name: "MSVB - Mid-Southern Bancorp, Inc.", ticker: "MSVB" },
    { name: "DOGZ - Dogness (International) Corp", ticker: "DOGZ" },
    { name: "PNCKF - Galleon Gold Corp.", ticker: "PNCKF" },
    { name: "WWIN - AllyMe Group, Inc./NV", ticker: "WWIN" },
    { name: "CLGN - CollPlant Biotechnologies Ltd", ticker: "CLGN" },
    { name: "IZEA - IZEA Worldwide, Inc.", ticker: "IZEA" },
    { name: "AGTX - Agentix Corp.", ticker: "AGTX" },
    { name: "SEEL - SEELOS THERAPEUTICS, INC.", ticker: "SEEL" },
    { name: "ESP - ESPEY MFG & ELECTRONICS CORP", ticker: "ESP" },
    { name: "ELRE - Yinfu Gold Corp.", ticker: "ELRE" },
    { name: "EDTK - Skillful Craftsman Education Technology Ltd", ticker: "EDTK" },
    { name: "OCGN - Ocugen, Inc.", ticker: "OCGN" },
    { name: "MDJH - MDJM LTD", ticker: "MDJH" },
    { name: "HNCKF - Giga Metals Corp", ticker: "HNCKF" },
    { name: "LINK - INTERLINK ELECTRONICS INC", ticker: "LINK" },
    { name: "FEDU - Four Seasons Education (Cayman) Inc.", ticker: "FEDU" },
    { name: "APDN - APPLIED DNA SCIENCES INC", ticker: "APDN" },
    { name: "ZOM - Zomedica Corp.", ticker: "ZOM" },
    { name: "UEXCF - UEX CORP", ticker: "UEXCF" },
    { name: "PULM - Pulmatrix, Inc.", ticker: "PULM" },
    { name: "CRKN - Crown Electrokinetics Corp.", ticker: "CRKN" },
    { name: "SSKN - STRATA Skin Sciences, Inc.", ticker: "SSKN" },
    { name: "LYL - Dragon Victory International Ltd", ticker: "LYL" },
    { name: "ICMB - Investcorp Credit Management BDC, Inc.", ticker: "ICMB" },
    { name: "ICCC - IMMUCELL CORP /DE/", ticker: "ICCC" },
    { name: "NCRA - NOCERA, INC.", ticker: "NCRA" },
    { name: "MRMD - MARIMED INC.", ticker: "MRMD" },
    { name: "XTGRF - XTRA-GOLD RESOURCES CORP", ticker: "XTGRF" },
    { name: "TRXC - TRANSENTERIX, INC.", ticker: "TRXC" },
    { name: "LONCF - Loncor Resources Inc.", ticker: "LONCF" },
    { name: "MOGO - Mogo Inc.", ticker: "MOGO" },
    { name: "NNVC - NANOVIRICIDES, INC.", ticker: "NNVC" },
    { name: "FRD - FRIEDMAN INDUSTRIES INC", ticker: "FRD" },
    { name: "IMRN - Immuron Ltd", ticker: "IMRN" },
    { name: "ALJJ - ALJ REGIONAL HOLDINGS INC", ticker: "ALJJ" },
    { name: "CLHRF - CORAL GOLD RESOURCES, LTD.", ticker: "CLHRF" },
    { name: "BBGI - BEASLEY BROADCAST GROUP INC", ticker: "BBGI" },
    { name: "CBLI - CLEVELAND BIOLABS INC", ticker: "CBLI" },
    { name: "WLMS - Williams Industrial Services Group Inc.", ticker: "WLMS" },
    { name: "BTTR - Better Choice Co Inc.", ticker: "BTTR" },
    { name: "UWHR - UWHARRIE CAPITAL CORP", ticker: "UWHR" },
    { name: "GGROU - Golden Growers Cooperative", ticker: "GGROU" },
    { name: "UTSI - UTSTARCOM HOLDINGS CORP.", ticker: "UTSI" },
    { name: "CCLP - CSI Compressco LP", ticker: "CCLP" },
    { name: "TPHS - Trinity Place Holdings Inc.", ticker: "TPHS" },
    { name: "PZG - Paramount Gold Nevada Corp.", ticker: "PZG" },
    { name: "DXF - Dunxin Financial Holdings Ltd", ticker: "DXF" },
    { name: "RKDA - Arcadia Biosciences, Inc.", ticker: "RKDA" },
    { name: "LOAN - MANHATTAN BRIDGE CAPITAL, INC", ticker: "LOAN" },
    { name: "BRFH - BARFRESH FOOD GROUP INC.", ticker: "BRFH" },
    { name: "CLEU - China Liberal Education Holdings Ltd", ticker: "CLEU" },
    { name: "PTBS - POTOMAC BANCSHARES INC", ticker: "PTBS" },
    { name: "ARKR - ARK RESTAURANTS CORP", ticker: "ARKR" },
    { name: "ECRP - Chee Corp.", ticker: "ECRP" },
    { name: "ATMO - AMERICATOWNE HOLDINGS, INC.", ticker: "ATMO" },
    { name: "IVST - Innovest Global, Inc.", ticker: "IVST" },
    { name: "QRHC - Quest Resource Holding Corp", ticker: "QRHC" },
    { name: "CJJD - CHINA JO-JO DRUGSTORES, INC.", ticker: "CJJD" },
    { name: "EMMA - Emmaus Life Sciences, Inc.", ticker: "EMMA" },
    { name: "PTE - POLARITYTE, INC.", ticker: "PTE" },
    { name: "EMGCQ - EMERGENT CAPITAL, INC.", ticker: "EMGCQ" },
    { name: "APEN - Apollo Endosurgery, Inc.", ticker: "APEN" },
    { name: "VCNX - VACCINEX, INC.", ticker: "VCNX" },
    { name: "AACG - ATA Creativity Global", ticker: "AACG" },
    { name: "BEBE - bebe stores, inc.", ticker: "BEBE" },
    { name: "NINE - Nine Energy Service, Inc.", ticker: "NINE" },
    { name: "SNDL - Sundial Growers Inc.", ticker: "SNDL" },
    { name: "RELI - Reliance Global Group, Inc.", ticker: "RELI" },
    { name: "BTCY - BIOTRICITY INC.", ticker: "BTCY" },
    { name: "TPCS - TECHPRECISION CORP", ticker: "TPCS" },
    { name: "RNGR - Ranger Energy Services, Inc.", ticker: "RNGR" },
    { name: "BFGC - Bullfrog Gold Corp.", ticker: "BFGC" },
    { name: "SQFT - Presidio Property Trust, Inc.", ticker: "SQFT" },
    { name: "IBTN - InsCorp Inc", ticker: "IBTN" },
    { name: "AAMC - Altisource Asset Management Corp", ticker: "AAMC" },
    { name: "ABIO - ARCA biopharma, Inc.", ticker: "ABIO" },
    { name: "STCN - Steel Connect, Inc.", ticker: "STCN" },
    { name: "NWPP - NEW PEOPLES BANKSHARES INC", ticker: "NWPP" },
    { name: "GROW - U S GLOBAL INVESTORS INC", ticker: "GROW" },
    { name: "HFBL - Home Federal Bancorp, Inc. of Louisiana", ticker: "HFBL" },
    { name: "SONM - SONIM TECHNOLOGIES INC", ticker: "SONM" },
    { name: "OSS - ONE STOP SYSTEMS, INC.", ticker: "OSS" },
    { name: "SUP - SUPERIOR INDUSTRIES INTERNATIONAL INC", ticker: "SUP" },
    { name: "GXSFF - Goldsource Mines Inc.", ticker: "GXSFF" },
    { name: "ANPC - AnPac Bio-Medical Science Co., Ltd.", ticker: "ANPC" },
    { name: "USIO - Usio, Inc.", ticker: "USIO" },
    { name: "FBVA - Farmers Bankshares, Inc.", ticker: "FBVA" },
    { name: "BWMY - BorrowMoney.com, Inc.", ticker: "BWMY" },
    { name: "BSFC - Blue Star Foods Corp.", ticker: "BSFC" },
    { name: "CNTTQ - CannTrust Holdings Inc.", ticker: "CNTTQ" },
    { name: "EKSO - EKSO BIONICS HOLDINGS, INC.", ticker: "EKSO" },
    { name: "SLNG - Stabilis Solutions, Inc.", ticker: "SLNG" },
    { name: "PRPO - Precipio, Inc.", ticker: "PRPO" },
    { name: "BUKS - BUTLER NATIONAL CORP", ticker: "BUKS" },
    { name: "VPLM - Voip-pal.com Inc", ticker: "VPLM" },
    { name: "SRAX - SRAX, Inc.", ticker: "SRAX" },
    { name: "SIOCF - Crystal Lake Mining Corp", ticker: "SIOCF" },
    { name: "CTAM - A. M. Castle & Co.", ticker: "CTAM" },
    { name: "AXNVF - AXION VENTURES INC.", ticker: "AXNVF" },
    { name: "PECK - PECK Co HOLDINGS, INC.", ticker: "PECK" },
    { name: "SONN - Sonnet BioTherapeutics Holdings, Inc.", ticker: "SONN" },
    { name: "SELF - Global Self Storage, Inc.", ticker: "SELF" },
    { name: "TATT - TAT TECHNOLOGIES LTD", ticker: "TATT" },
    { name: "CRT - CROSS TIMBERS ROYALTY TRUST", ticker: "CRT" },
    { name: "JCS - COMMUNICATIONS SYSTEMS INC", ticker: "JCS" },
    { name: "PW - Power REIT", ticker: "PW" },
    { name: "ONCT - Oncternal Therapeutics, Inc.", ticker: "ONCT" },
    { name: "INUV - Inuvo, Inc.", ticker: "INUV" },
    { name: "LODE - Comstock Mining Inc.", ticker: "LODE" },
    { name: "FPAY - FlexShopper, Inc.", ticker: "FPAY" },
    { name: "IDWM - IDW MEDIA HOLDINGS, INC.", ticker: "IDWM" },
    { name: "AESE - Allied Esports Entertainment, Inc.", ticker: "AESE" },
    { name: "INDO - Indonesia Energy Corp Ltd", ticker: "INDO" },
    { name: "NJMC - NEW JERSEY MINING CO", ticker: "NJMC" },
    { name: "BKTI - BK Technologies Corp", ticker: "BKTI" },
    { name: "KLXE - KLX Energy Services Holdings, Inc.", ticker: "KLXE" },
    { name: "CUII - China United Insurance Service, Inc.", ticker: "CUII" },
    { name: "PHCF - Puhui Wealth Investment Management Co., Ltd.", ticker: "PHCF" },
    { name: "DECN - DECISION DIAGNOSTICS CORP", ticker: "DECN" },
    { name: "TPTW - TPT GLOBAL TECH, INC.", ticker: "TPTW" },
    { name: "SRRE - SUNRISE REAL ESTATE GROUP INC", ticker: "SRRE" },
    { name: "MGAFF - Mega Uranium Ltd.", ticker: "MGAFF" },
    { name: "ANDAU - Andina Acquisition Corp. III", ticker: "ANDAU" },
    { name: "UFAB - Unique Fabricating, Inc.", ticker: "UFAB" },
    { name: "VKIN - VIKING ENERGY GROUP, INC.", ticker: "VKIN" },
    { name: "VINO - Gaucho Group Holdings, Inc.", ticker: "VINO" },
    { name: "TLCC - TWINLAB CONSOLIDATED HOLDINGS, INC.", ticker: "TLCC" },
    { name: "GCTY - GAIN CITIES LTD", ticker: "GCTY" },
    { name: "JCTCF - JEWETT CAMERON TRADING CO LTD", ticker: "JCTCF" },
    { name: "PGCG - PRIME GLOBAL CAPITAL GROUP Inc", ticker: "PGCG" },
    { name: "KTRA - Kintara Therapeutics, Inc.", ticker: "KTRA" },
    { name: "SYNL - SYNALLOY CORP", ticker: "SYNL" },
    { name: "SMID - SMITH MIDLAND CORP", ticker: "SMID" },
    { name: "ZGSI - Zero Gravity Solutions, Inc.", ticker: "ZGSI" },
    { name: "PHX - PHX MINERALS INC.", ticker: "PHX" },
    { name: "PHUN - Phunware, Inc.", ticker: "PHUN" },
    { name: "CLEV - Concrete Leveling Systems Inc", ticker: "CLEV" },
    { name: "DIT - AMCON DISTRIBUTING CO", ticker: "DIT" },
    { name: "JILL - J.Jill, Inc.", ticker: "JILL" },
    { name: "PFIE - PROFIRE ENERGY INC", ticker: "PFIE" },
    { name: "MTEX - MANNATECH INC", ticker: "MTEX" },
    { name: "AVEPY - Aveng Ltd", ticker: "AVEPY" },
    { name: "STMH - Stem Holdings, Inc.", ticker: "STMH" },
    { name: "CLRO - CLEARONE INC", ticker: "CLRO" },
    { name: "MKGI - Monaker Group, Inc.", ticker: "MKGI" },
    { name: "CLOW - Cloudweb, Inc.", ticker: "CLOW" },
    { name: "HGLD - Patagonia Gold Corp.", ticker: "HGLD" },
    { name: "HGSH - CHINA HGS REAL ESTATE INC.", ticker: "HGSH" },
    { name: "QUIK - QUICKLOGIC Corp", ticker: "QUIK" },
    { name: "HCBC - HIGH COUNTRY BANCORP INC", ticker: "HCBC" },
    { name: "GRNF - GRN Holding Corp", ticker: "GRNF" },
    { name: "ANVS - Annovis Bio, Inc.", ticker: "ANVS" },
    { name: "KLFE - Kannalife Inc", ticker: "KLFE" },
    { name: "SILO - Silo Pharma, Inc.", ticker: "SILO" },
    { name: "TAYD - TAYLOR DEVICES INC", ticker: "TAYD" },
    { name: "CLRB - Cellectar Biosciences, Inc.", ticker: "CLRB" },
    { name: "LIFE - aTYR PHARMA INC", ticker: "LIFE" },
    { name: "TFECY - Thin Film Electronics ASA", ticker: "TFECY" },
    { name: "VIRC - VIRCO MFG CORPORATION", ticker: "VIRC" },
    { name: "CSPI - CSP INC /MA/", ticker: "CSPI" },
    { name: "NTWK - NETSOL TECHNOLOGIES INC", ticker: "NTWK" },
    { name: "BRSF - BRAIN SCIENTIFIC INC.", ticker: "BRSF" },
    { name: "OGEN - ORAGENICS INC", ticker: "OGEN" },
    { name: "MLND - Millendo Therapeutics, Inc.", ticker: "MLND" },
    { name: "AHC - A. H. Belo Corp", ticker: "AHC" },
    { name: "VOLT - VOLT INFORMATION SCIENCES, INC.", ticker: "VOLT" },
    { name: "ATHE - ALTERITY THERAPEUTICS LTD", ticker: "ATHE" },
    { name: "ACER - Acer Therapeutics Inc.", ticker: "ACER" },
    { name: "SRMC - SIERRA MONITOR CORP /CA/", ticker: "SRMC" },
    { name: "BLGO - BIOLARGO, INC.", ticker: "BLGO" },
    { name: "FSI - FLEXIBLE SOLUTIONS INTERNATIONAL INC", ticker: "FSI" },
    { name: "NETE - Net Element, Inc.", ticker: "NETE" },
    { name: "FGPR - FERRELLGAS PARTNERS L P", ticker: "FGPR" },
    { name: "TGA - TRANSGLOBE ENERGY CORP", ticker: "TGA" },
    { name: "PRSI - PORTSMOUTH SQUARE INC", ticker: "PRSI" },
    { name: "DARE - Dare Bioscience, Inc.", ticker: "DARE" },
    { name: "DAIO - DATA I/O CORP", ticker: "DAIO" },
    { name: "NBY - NovaBay Pharmaceuticals, Inc.", ticker: "NBY" },
    { name: "AIRI - AIR INDUSTRIES GROUP", ticker: "AIRI" },
    { name: "UURAF - Ucore Rare Metals Inc.", ticker: "UURAF" },
    { name: "GNRV - GRAND RIVER COMMERCE INC", ticker: "GNRV" },
    { name: "BHAT - Blue Hat Interactive Entertainment Technology", ticker: "BHAT" },
    { name: "BLRX - BioLineRx Ltd.", ticker: "BLRX" },
    { name: "CLBS - CALADRIUS BIOSCIENCES, INC.", ticker: "CLBS" },
    { name: "WVVI - WILLAMETTE VALLEY VINEYARDS INC", ticker: "WVVI" },
    { name: "MOAEY - Mongolia Energy Corp Ltd", ticker: "MOAEY" },
    { name: "NSFDF - NXT Energy Solutions Inc.", ticker: "NSFDF" },
    { name: "LEAT - Leatt Corp", ticker: "LEAT" },
    { name: "HFBK - Harford Bank", ticker: "HFBK" },
    { name: "WGMCF - WINSTON GOLD CORP.", ticker: "WGMCF" },
    { name: "INVO - INVO Bioscience, Inc.", ticker: "INVO" },
    { name: "OPNT - OPIANT PHARMACEUTICALS, INC.", ticker: "OPNT" },
    { name: "OCCI - OFS Credit Company, Inc.", ticker: "OCCI" },
    { name: "GAXY - GALAXY NEXT GENERATION, INC.", ticker: "GAXY" },
    { name: "BDL - FLANIGANS ENTERPRISES INC", ticker: "BDL" },
    { name: "BNTT - Bnet Media Group, Inc.", ticker: "BNTT" },
    { name: "GNWSF - STAGEZERO LIFE SCIENCES LTD.", ticker: "GNWSF" },
    { name: "ARTH - Arch Therapeutics, Inc.", ticker: "ARTH" },
    { name: "SFRX - SEAFARER EXPLORATION CORP", ticker: "SFRX" },
    { name: "POLA - Polar Power, Inc.", ticker: "POLA" },
    { name: "CBL - CBL & ASSOCIATES PROPERTIES INC", ticker: "CBL" },
    { name: "CNSP - CNS Pharmaceuticals, Inc.", ticker: "CNSP" },
    { name: "FTNW - FTE Networks, Inc.", ticker: "FTNW" },
    { name: "GIGM - GIGAMEDIA Ltd", ticker: "GIGM" },
    { name: "AEHR - AEHR TEST SYSTEMS", ticker: "AEHR" },
    { name: "USAU - U.S. GOLD CORP.", ticker: "USAU" },
    { name: "TECTP - Tectonic Financial, Inc.", ticker: "TECTP" },
    { name: "MEEC - Midwest Energy Emissions Corp.", ticker: "MEEC" },
    { name: "CNET - ChinaNet Online Holdings, Inc.", ticker: "CNET" },
    { name: "MPAD - MICROPAC INDUSTRIES INC", ticker: "MPAD" },
    { name: "CYDVF - CYPRESS DEVELOPMENT CORP", ticker: "CYDVF" },
    { name: "TBLT - Toughbuilt Industries, Inc", ticker: "TBLT" },
    { name: "BLCM - BELLICUM PHARMACEUTICALS, INC", ticker: "BLCM" },
    { name: "SEAC - SEACHANGE INTERNATIONAL INC", ticker: "SEAC" },
    { name: "CNCG - CONCIERGE TECHNOLOGIES INC", ticker: "CNCG" },
    { name: "LBAO - LUBOA GROUP, INC.", ticker: "LBAO" },
    { name: "ALDS - APPlife Digital Solutions Inc", ticker: "ALDS" },
    { name: "MBCQ - MB Bancorp Inc", ticker: "MBCQ" },
    { name: "SKKY - Skkynet Cloud Systems, Inc.", ticker: "SKKY" },
    { name: "PBSV - Pharma-Bio Serv, Inc.", ticker: "PBSV" },
    { name: "SPYR - SPYR, Inc.", ticker: "SPYR" },
    { name: "LEPX - LEPOTA INC", ticker: "LEPX" },
    { name: "PPBN - PINNACLE BANKSHARES CORP", ticker: "PPBN" },
    { name: "MVO - MV Oil Trust", ticker: "MVO" },
    { name: "ACHV - ACHIEVE LIFE SCIENCES, INC.", ticker: "ACHV" },
    { name: "CSCW - Color Star Technology Co., Ltd.", ticker: "CSCW" },
    { name: "CHMD - Median Group Inc", ticker: "CHMD" },
    { name: "LMRXF - LARAMIDE RESOURCES LTD", ticker: "LMRXF" },
    { name: "HEPA - Hepion Pharmaceuticals, Inc.", ticker: "HEPA" },
    { name: "EMHTF - Emerald Health Therapeutics Inc.", ticker: "EMHTF" },
    { name: "BEOB - BEO BANCORP", ticker: "BEOB" },
    { name: "PATI - PATRIOT TRANSPORTATION HOLDING, INC.", ticker: "PATI" },
    { name: "OSBK - OCONEE FINANCIAL CORP", ticker: "OSBK" },
    { name: "AMPY - Amplify Energy Corp.", ticker: "AMPY" },
    { name: "IMH - IMPAC MORTGAGE HOLDINGS INC", ticker: "IMH" },
    { name: "CLCS - Cell Source, Inc.", ticker: "CLCS" },
    { name: "GTEC - Greenland Technologies Holding Corp.", ticker: "GTEC" },
    { name: "PAXH - PREAXIA HEALTH CARE PAYMENT SYSTEMS INC.", ticker: "PAXH" },
    { name: "DRVD - Driven Deliveries, Inc.", ticker: "DRVD" },
    { name: "MOTS - Motus GI Holdings, Inc.", ticker: "MOTS" },
    { name: "PVCT - PROVECTUS BIOPHARMACEUTICALS, INC.", ticker: "PVCT" },
    { name: "MGEN - MIRAGEN THERAPEUTICS, INC.", ticker: "MGEN" },
    { name: "VTSI - VirTra, Inc", ticker: "VTSI" },
    { name: "SUME - SUMMER ENERGY HOLDINGS INC", ticker: "SUME" },
    { name: "PMTS - CPI Card Group Inc.", ticker: "PMTS" },
    { name: "SHIP - Seanergy Maritime Holdings Corp.", ticker: "SHIP" },
    { name: "RWLK - ReWalk Robotics Ltd.", ticker: "RWLK" },
    { name: "PLXP - PLx Pharma Inc.", ticker: "PLXP" },
    { name: "BRPA - Big Rock Partners Acquisition Corp.", ticker: "BRPA" },
    { name: "GSHN - Gushen, Inc", ticker: "GSHN" },
    { name: "HVBC - HV Bancorp, Inc.", ticker: "HVBC" },
    { name: "RAND - RAND CAPITAL CORP", ticker: "RAND" },
    { name: "TTCM - TAUTACHROME INC.", ticker: "TTCM" },
    { name: "NCSM - NCS Multistage Holdings, Inc.", ticker: "NCSM" },
    { name: "SNBP - Sun BioPharma, Inc.", ticker: "SNBP" },
    { name: "CANF - Can-Fite BioPharma Ltd.", ticker: "CANF" },
    { name: "HUGE - FSD Pharma Inc.", ticker: "HUGE" },
    { name: "BHTG - BIOHITECH GLOBAL, INC.", ticker: "BHTG" },
    { name: "ORMNF - OREX MINERALS INC", ticker: "ORMNF" },
    { name: "BDREX - Broadstone Real Estate Access Fund", ticker: "BDREX" },
    { name: "BCDA - BioCardia, Inc.", ticker: "BCDA" },
    { name: "DTEA - DAVIDsTEA Inc.", ticker: "DTEA" },
    { name: "SALM - SALEM MEDIA GROUP, INC. /DE/", ticker: "SALM" },
    { name: "GRYN - GREEN HYGIENICS HOLDINGS INC.", ticker: "GRYN" },
    { name: "HCDI - Harbor Custom Development, Inc.", ticker: "HCDI" },
    { name: "AIRT - AIR T INC", ticker: "AIRT" },
    { name: "HEOL - HIGHWATER ETHANOL LLC", ticker: "HEOL" },
    { name: "CRWE - Crown Equity Holdings, Inc.", ticker: "CRWE" },
    { name: "RAIL - FreightCar America, Inc.", ticker: "RAIL" },
    { name: "BKYI - BIO KEY INTERNATIONAL INC", ticker: "BKYI" },
    { name: "BRRZY - Total Brain Limited/ADR", ticker: "BRRZY" },
    { name: "CVV - CVD EQUIPMENT CORP", ticker: "CVV" },
    { name: "VENV - VENTURE VANADIUM INC.", ticker: "VENV" },
    { name: "NWGI - Newgioco Group, Inc.", ticker: "NWGI" },
    { name: "DOFSQ - DIAMOND OFFSHORE DRILLING, INC.", ticker: "DOFSQ" },
    { name: "NRT - NORTH EUROPEAN OIL ROYALTY TRUST", ticker: "NRT" },
    { name: "TRCH - TORCHLIGHT ENERGY RESOURCES INC", ticker: "TRCH" },
    { name: "DENR - Discovery Energy Corp.", ticker: "DENR" },
    { name: "WHLR - Wheeler Real Estate Investment Trust, Inc.", ticker: "WHLR" },
    { name: "SCYYF - SCANDIUM INTERNATIONAL MINING CORP.", ticker: "SCYYF" },
    { name: "ISR - Isoray, Inc.", ticker: "ISR" },
    { name: "PNBK - PATRIOT NATIONAL BANCORP INC", ticker: "PNBK" },
    { name: "MIND - MIND TECHNOLOGY, INC", ticker: "MIND" },
    { name: "PPSI - PIONEER POWER SOLUTIONS, INC.", ticker: "PPSI" },
    { name: "TLRS - Timberline Resources Corp", ticker: "TLRS" },
    { name: "USLG - U.S. Lighting Group, Inc.", ticker: "USLG" },
    { name: "VGRBF - VGRAB COMMUNICATIONS INC.", ticker: "VGRBF" },
    { name: "TLFA - TANDY LEATHER FACTORY INC", ticker: "TLFA" },
    { name: "SCTC - ScoutCam Inc.", ticker: "SCTC" },
    { name: "UNAM - UNICO AMERICAN CORP", ticker: "UNAM" },
    { name: "ECRD - ECARD INC.", ticker: "ECRD" },
    { name: "MSBC - MISSION BANCORP", ticker: "MSBC" },
    { name: "IOTC - IOTA COMMUNICATIONS, INC.", ticker: "IOTC" },
    { name: "HSON - Hudson Global, Inc.", ticker: "HSON" },
    { name: "GLBZ - GLEN BURNIE BANCORP", ticker: "GLBZ" },
    { name: "GLGI - GREYSTONE LOGISTICS, INC.", ticker: "GLGI" },
    { name: "BIOL - BIOLASE, INC", ticker: "BIOL" },
    { name: "BMMJ - BODY & MIND INC.", ticker: "BMMJ" },
    { name: "PSHG - Performance Shipping Inc.", ticker: "PSHG" },
    { name: "FFLO - Free Flow, Inc.", ticker: "FFLO" },
    { name: "RIHC - RORINE INTERNATIONAL HOLDING Corp", ticker: "RIHC" },
    { name: "OMQS - OMNIQ Corp.", ticker: "OMQS" },
    { name: "TZACU - Tenzing Acquisition Corp.", ticker: "TZACU" },
    { name: "MVEN - theMaven, Inc.", ticker: "MVEN" },
    { name: "NMTC - NEUROONE MEDICAL TECHNOLOGIES Corp", ticker: "NMTC" },
    { name: "QBIO - Q BioMed Inc.", ticker: "QBIO" },
    { name: "KIQ - KELSO TECHNOLOGIES INC", ticker: "KIQ" },
    { name: "VICP - Vicapsys Life Sciences, Inc.", ticker: "VICP" },
    { name: "ODYY - Odyssey Group International, Inc.", ticker: "ODYY" },
    { name: "IRIX - IRIDEX CORP", ticker: "IRIX" },
    { name: "GRWC - GROW CAPITAL, INC.", ticker: "GRWC" },
    { name: "TGEN - TECOGEN INC.", ticker: "TGEN" },
    { name: "SLGG - Super League Gaming, Inc.", ticker: "SLGG" },
    { name: "HBIS - Home Bistro, Inc. /NV/", ticker: "HBIS" },
    { name: "JROOF - Jericho Oil Corp", ticker: "JROOF" },
    { name: "CRMZ - CREDITRISKMONITOR COM INC", ticker: "CRMZ" },
    { name: "CRCUF - CANARC RESOURCE CORP", ticker: "CRCUF" },
    { name: "RCEL - Avita Therapeutics, Inc.", ticker: "RCEL" },
    { name: "CELP - Cypress Environmental Partners, L.P.", ticker: "CELP" },
    { name: "FSRL - FIRST RELIANCE BANCSHARES INC", ticker: "FSRL" },
    { name: "SYPR - SYPRIS SOLUTIONS INC", ticker: "SYPR" },
    { name: "DTRC - DAKOTA TERRITORY RESOURCE CORP", ticker: "DTRC" },
    { name: "MTC - MMTec, Inc.", ticker: "MTC" },
    { name: "CPTA - Capitala Finance Corp.", ticker: "CPTA" },
    { name: "ZKIN - ZK International Group Co., Ltd.", ticker: "ZKIN" },
    { name: "PRT - PermRock Royalty Trust", ticker: "PRT" },
    { name: "HSTO - Histogen Inc.", ticker: "HSTO" },
    { name: "MTP - Midatech Pharma Plc", ticker: "MTP" },
    { name: "CTHR - CHARLES & COLVARD LTD", ticker: "CTHR" },
    { name: "GYRO - Gyrodyne, LLC", ticker: "GYRO" },
    { name: "PMCB - PharmaCyte Biotech, Inc.", ticker: "PMCB" },
    { name: "UAMY - UNITED STATES ANTIMONY CORP", ticker: "UAMY" },
    { name: "RIBT - RiceBran Technologies", ticker: "RIBT" },
    { name: "ENG - ENGLOBAL CORP", ticker: "ENG" },
    { name: "SOFO - SONIC FOUNDRY INC", ticker: "SOFO" },
    { name: "AVGR - Avinger Inc", ticker: "AVGR" },
    { name: "NANX - NANOPHASE TECHNOLOGIES Corp", ticker: "NANX" },
    { name: "EBML - eBullion, Inc.", ticker: "EBML" },
    { name: "NSRCF - NextSource Materials Inc.", ticker: "NSRCF" },
    { name: "TIGCF - Triumph Gold Corp.", ticker: "TIGCF" },
    { name: "CFDB - Central Federal Bancshares, Inc", ticker: "CFDB" },
    { name: "SLS - SELLAS Life Sciences Group, Inc.", ticker: "SLS" },
    { name: "EFOI - ENERGY FOCUS, INC/DE", ticker: "EFOI" },
    { name: "SOHO - Sotherly Hotels Inc.", ticker: "SOHO" },
    { name: "VOC - VOC Energy Trust", ticker: "VOC" },
    { name: "OBELF - OBSIDIAN ENERGY LTD.", ticker: "OBELF" },
    { name: "SYCRF - SYNCORA HOLDINGS LTD", ticker: "SYCRF" },
    { name: "PKTX - ProtoKinetix, Inc.", ticker: "PKTX" },
    { name: "XPL - SOLITARIO ZINC CORP.", ticker: "XPL" },
    { name: "HUSN - Hudson Capital Inc.", ticker: "HUSN" },
    { name: "SDRLF - Seadrill Ltd", ticker: "SDRLF" },
    { name: "COHN - Cohen & Co Inc.", ticker: "COHN" },
    { name: "CNFR - Conifer Holdings, Inc.", ticker: "CNFR" },
    { name: "HOTH - Hoth Therapeutics, Inc.", ticker: "HOTH" },
    { name: "ITRM - Iterum Therapeutics plc", ticker: "ITRM" },
    { name: "ADIL - ADIAL PHARMACEUTICALS, INC.", ticker: "ADIL" },
    { name: "TAOP - Taoping Inc.", ticker: "TAOP" },
    { name: "PIAC - PRINCETON CAPITAL CORP", ticker: "PIAC" },
    { name: "SNSS - SUNESIS PHARMACEUTICALS INC", ticker: "SNSS" },
    { name: "KBNT - Kubient, Inc.", ticker: "KBNT" },
    { name: "AEY - ADDVANTAGE TECHNOLOGIES GROUP INC", ticker: "AEY" },
    { name: "SCND - SCIENTIFIC INDUSTRIES INC", ticker: "SCND" },
    { name: "DLPN - Dolphin Entertainment, Inc.", ticker: "DLPN" },
    { name: "BIMI - BOQI International Medical, Inc.", ticker: "BIMI" },
    { name: "CLAD - China Liaoning Dingxu Ecological Agriculture Development, Inc.", ticker: "CLAD" },
    { name: "MOBQ - Mobiquity Technologies, Inc.", ticker: "MOBQ" },
    { name: "COSG - Cosmos Group Holdings Inc.", ticker: "COSG" },
    { name: "CRTD - Creatd, Inc.", ticker: "CRTD" },
    { name: "CMXC - Cell MedX Corp.", ticker: "CMXC" },
    { name: "EDNT - EDISON NATION, INC.", ticker: "EDNT" },
    { name: "PMD - PSYCHEMEDICS CORP", ticker: "PMD" },
    { name: "BUDZ - WEED, INC.", ticker: "BUDZ" },
    { name: "CLOK - CIPHERLOC Corp", ticker: "CLOK" },
    { name: "OVTZ - OCULUS VISIONTECH INC.", ticker: "OVTZ" },
    { name: "BRMT - BARE METAL STANDARD INC.", ticker: "BRMT" },
    { name: "KEQU - KEWAUNEE SCIENTIFIC CORP /DE/", ticker: "KEQU" },
    { name: "PRKA - PARKS AMERICA, INC", ticker: "PRKA" },
    { name: "APVO - Aptevo Therapeutics Inc.", ticker: "APVO" },
    { name: "OCC - OPTICAL CABLE CORP", ticker: "OCC" },
    { name: "DPW - DPW Holdings, Inc.", ticker: "DPW" },
    { name: "OLB - OLB GROUP, INC.", ticker: "OLB" },
    { name: "IO - ION GEOPHYSICAL CORP", ticker: "IO" },
    { name: "ALIM - ALIMERA SCIENCES INC", ticker: "ALIM" },
    { name: "BTN - BALLANTYNE STRONG, INC.", ticker: "BTN" },
    { name: "QURT - Quarta-Rad, Inc.", ticker: "QURT" },
    { name: "ELTK - ELTEK LTD", ticker: "ELTK" },
    { name: "MFH - Mercurity Fintech Holding Inc.", ticker: "MFH" },
    { name: "CHHE - China Health Industries Holdings, Inc.", ticker: "CHHE" },
    { name: "PCFP - Apotheca Biosciences, Inc.", ticker: "PCFP" },
    { name: "BBI - Brickell Biotech, Inc.", ticker: "BBI" },
    { name: "CPSH - CPS TECHNOLOGIES CORP/DE/", ticker: "CPSH" },
    { name: "PERS - SandRidge Permian Trust", ticker: "PERS" },
    { name: "APWC - ASIA PACIFIC WIRE & CABLE CORP LTD", ticker: "APWC" },
    { name: "AZRX - AzurRx BioPharma, Inc.", ticker: "AZRX" },
    { name: "HNRG - HALLADOR ENERGY CO", ticker: "HNRG" },
    { name: "PLAG - Planet Green Holdings Corp.", ticker: "PLAG" },
    { name: "INIS - INTERNATIONAL ISOTOPES INC", ticker: "INIS" },
    { name: "ITP - IT TECH PACKAGING, INC.", ticker: "ITP" },
    { name: "AGNPF - Algernon Pharmaceuticals Inc.", ticker: "AGNPF" },
    { name: "TLTFF - THERALASE TECHNOLOGIES INC /FI", ticker: "TLTFF" },
    { name: "EXEO - Exeo Entertainment, Inc.", ticker: "EXEO" },
    { name: "NDVN - nDivision Inc.", ticker: "NDVN" },
    { name: "GGTHF - GOLDEN GOLIATH RESOURCES LTD", ticker: "GGTHF" },
    { name: "HTGM - HTG MOLECULAR DIAGNOSTICS, INC", ticker: "HTGM" },
    { name: "BNSO - BONSO ELECTRONICS INTERNATIONAL INC", ticker: "BNSO" },
    { name: "AEZS - Aeterna Zentaris Inc.", ticker: "AEZS" },
    { name: "CGOL - Contact Gold Corp.", ticker: "CGOL" },
    { name: "PBTS - Powerbridge Technologies Co., Ltd.", ticker: "PBTS" },
    { name: "TGLO - THEGLOBE COM INC", ticker: "TGLO" },
    { name: "NVUS - Novus Therapeutics, Inc.", ticker: "NVUS" },
    { name: "HITC - Healthcare Integrated Technologies Inc.", ticker: "HITC" },
    { name: "QNTO - QUAINT OAK BANCORP INC", ticker: "QNTO" },
    { name: "SIF - SIFCO INDUSTRIES INC", ticker: "SIF" },
    { name: "DSS - DOCUMENT SECURITY SYSTEMS INC", ticker: "DSS" },
    { name: "VTNR - Vertex Energy Inc.", ticker: "VTNR" },
    { name: "WHLT - CHASE PACKAGING CORP", ticker: "WHLT" },
    { name: "OEG - Orbital Energy Group, Inc.", ticker: "OEG" },
    { name: "SBPH - Spring Bank Pharmaceuticals, Inc.", ticker: "SBPH" },
    { name: "GADS - Gadsden Properties, Inc.", ticker: "GADS" },
    { name: "CNBX - Cannabics Pharmaceuticals Inc.", ticker: "CNBX" },
    { name: "SLGD - Scott's Liquid Gold - Inc.", ticker: "SLGD" },
    { name: "MDIA - Mediaco Holding Inc.", ticker: "MDIA" },
    { name: "FDCT - FDCTECH, INC.", ticker: "FDCT" },
    { name: "DTST - Data Storage Corp", ticker: "DTST" },
    { name: "OBLG - Oblong, Inc.", ticker: "OBLG" },
    { name: "SHLDQ - SEARS HOLDINGS CORP", ticker: "SHLDQ" },
    { name: "ATURF - SIXTH WAVE INNOVATIONS INC.", ticker: "ATURF" },
    { name: "CYTR - CYTRX CORP", ticker: "CYTR" },
    { name: "RSRV - RESERVE PETROLEUM CO", ticker: "RSRV" },
    { name: "JVA - COFFEE HOLDING CO INC", ticker: "JVA" },
    { name: "LEON - LEONE ASSET MANAGEMENT, INC.", ticker: "LEON" },
    { name: "VISL - Vislink Technologies, Inc.", ticker: "VISL" },
    { name: "CEI - CAMBER ENERGY, INC.", ticker: "CEI" },
    { name: "WAFU - Wah Fu Education Group Ltd", ticker: "WAFU" },
    { name: "STLY - HG Holdings, Inc.", ticker: "STLY" },
    { name: "GTMAY - GRUPO TMM SAB", ticker: "GTMAY" },
    { name: "PWVI - POWERVERDE, INC.", ticker: "PWVI" },
    { name: "AHPI - ALLIED HEALTHCARE PRODUCTS INC", ticker: "AHPI" },
    { name: "SCX - STARRETT L S CO", ticker: "SCX" },
    { name: "DLTI - DLT Resolution Inc.", ticker: "DLTI" },
    { name: "SGBX - SG BLOCKS, INC.", ticker: "SGBX" },
    { name: "GVP - GSE SYSTEMS INC", ticker: "GVP" },
    { name: "OZSC - OZOP SURGICAL CORP.", ticker: "OZSC" },
    { name: "BFNH - BIOFORCE NANOSCIENCES HOLDINGS, INC.", ticker: "BFNH" },
    { name: "CLSN - Celsion CORP", ticker: "CLSN" },
    { name: "PRKR - PARKERVISION INC", ticker: "PRKR" },
    { name: "PLYN - Palayan Resources, Inc.", ticker: "PLYN" },
    { name: "PLIN - China Xiangtai Food Co., Ltd.", ticker: "PLIN" },
    { name: "GTIM - Good Times Restaurants Inc.", ticker: "GTIM" },
    { name: "PETV - PetVivo Holdings, Inc.", ticker: "PETV" },
    { name: "GHMP - Good Hemp, Inc.", ticker: "GHMP" },
    { name: "MSN - EMERSON RADIO CORP", ticker: "MSN" },
    { name: "NPWI - New Leap, Inc.", ticker: "NPWI" },
    { name: "SFET - Safe-T Group Ltd.", ticker: "SFET" },
    { name: "RSLS - ReShape Lifesciences Inc.", ticker: "RSLS" },
    { name: "FALC - FALCONSTOR SOFTWARE INC", ticker: "FALC" },
    { name: "RYES - Rise Gold Corp.", ticker: "RYES" },
    { name: "CVR - CHICAGO RIVET & MACHINE CO", ticker: "CVR" },
    { name: "BLBX - BLACKBOXSTOCKS INC.", ticker: "BLBX" },
    { name: "YTEN - YIELD10 BIOSCIENCE, INC.", ticker: "YTEN" },
    { name: "RBCN - Rubicon Technology, Inc.", ticker: "RBCN" },
    { name: "SLOT - San Lotus Holding Inc", ticker: "SLOT" },
    { name: "FTEK - FUEL TECH, INC.", ticker: "FTEK" },
    { name: "AIKI - Aikido Pharma Inc.", ticker: "AIKI" },
    { name: "HRRB - Horizon Bancorp Inc/AZ", ticker: "HRRB" },
    { name: "RCAT - Red Cat Holdings, Inc.", ticker: "RCAT" },
    { name: "TRNF - Taronis Fuels, Inc.", ticker: "TRNF" },
    { name: "BTZI - BOTS, Inc./PR", ticker: "BTZI" },
    { name: "DCNPF - Duncan Park Holdings Corp", ticker: "DCNPF" },
    { name: "EYES - SECOND SIGHT MEDICAL PRODUCTS INC", ticker: "EYES" },
    { name: "SVT - SERVOTRONICS INC /DE/", ticker: "SVT" },
    { name: "ATOS - ATOSSA THERAPEUTICS, INC.", ticker: "ATOS" },
    { name: "LEMIF - Leading Edge Materials Corp.", ticker: "LEMIF" },
    { name: "HSDT - HELIUS MEDICAL TECHNOLOGIES, INC.", ticker: "HSDT" },
    { name: "OTIVF - ON TRACK INNOVATIONS LTD", ticker: "OTIVF" },
    { name: "MOXC - Moxian, Inc.", ticker: "MOXC" },
    { name: "HANNF - Hannan Metals Ltd.", ticker: "HANNF" },
    { name: "GRCAF - TRIMETALS MINING INC.", ticker: "GRCAF" },
    { name: "AVLNF - Avalon Advanced Materials Inc.", ticker: "AVLNF" },
    { name: "SVBL - SILVER BULL RESOURCES, INC.", ticker: "SVBL" },
    { name: "GLXZ - Galaxy Gaming, Inc.", ticker: "GLXZ" },
    { name: "INTI - Inhibitor Therapeutics, Inc.", ticker: "INTI" },
    { name: "CYCC - Cyclacel Pharmaceuticals, Inc.", ticker: "CYCC" },
    { name: "ENTX - Entera Bio Ltd.", ticker: "ENTX" },
    { name: "CTRM - Castor Maritime Inc.", ticker: "CTRM" },
    { name: "PXS - Pyxis Tankers Inc.", ticker: "PXS" },
    { name: "WECT - WECONNECT Tech International, Inc.", ticker: "WECT" },
    { name: "THMO - ThermoGenesis Holdings, Inc.", ticker: "THMO" },
    { name: "AKER - Akers Biosciences, Inc.", ticker: "AKER" },
    { name: "ALPE - alpha-En Corp", ticker: "ALPE" },
    { name: "PBMLF - Pacific Booker Minerals Inc.", ticker: "PBMLF" },
    { name: "CHFS - CHF Solutions, Inc.", ticker: "CHFS" },
    { name: "PUBC - PureBase Corp", ticker: "PUBC" },
    { name: "SMIT - SCHMITT INDUSTRIES INC", ticker: "SMIT" },
    { name: "FAMI - Farmmi, Inc.", ticker: "FAMI" },
    { name: "PHCG - Pure Harvest Corporate Group, Inc.", ticker: "PHCG" },
    { name: "CSU - CAPITAL SENIOR LIVING CORP", ticker: "CSU" },
    { name: "NCTY - The9 LTD", ticker: "NCTY" },
    { name: "SNTW - Summit Networks Inc.", ticker: "SNTW" },
    { name: "ACST - Acasti Pharma Inc.", ticker: "ACST" },
    { name: "CARV - CARVER BANCORP INC", ticker: "CARV" },
    { name: "BIMT - BITMIS CORP.", ticker: "BIMT" },
    { name: "CVLB - CONVERSION LABS, INC.", ticker: "CVLB" },
    { name: "ADTX - ADiTx Therapeutics, Inc.", ticker: "ADTX" },
    { name: "XITO - Xenous Holdings, Inc.", ticker: "XITO" },
    { name: "CANN - GENERAL CANNABIS CORP", ticker: "CANN" },
    { name: "TRUX - Truxton Corp", ticker: "TRUX" },
    { name: "QUBT - Quantum Computing Inc.", ticker: "QUBT" },
    { name: "AHT - ASHFORD HOSPITALITY TRUST INC", ticker: "AHT" },
    { name: "NTEC - Intec Pharma Ltd.", ticker: "NTEC" },
    { name: "CHCI - Comstock Holding Companies, Inc.", ticker: "CHCI" },
    { name: "CTDH - Cyclo Therapeutics, Inc.", ticker: "CTDH" },
    { name: "ORNC - ORANCO INC", ticker: "ORNC" },
    { name: "PACD - PACIFIC DRILLING S.A.", ticker: "PACD" },
    { name: "AEMD - AETHLON MEDICAL INC", ticker: "AEMD" },
    { name: "OREAF - COLUMBUS GOLD CORP", ticker: "OREAF" },
    { name: "ALRT - ALR TECHNOLOGIES INC.", ticker: "ALRT" },
    { name: "EWST - E-WASTE CORP.", ticker: "EWST" },
    { name: "ESEA - EUROSEAS LTD.", ticker: "ESEA" },
    { name: "CKX - CKX LANDS, INC.", ticker: "CKX" },
    { name: "PAYD - PAID INC", ticker: "PAYD" },
    { name: "CPHI - CHINA PHARMA HOLDINGS, INC.", ticker: "CPHI" },
    { name: "BKOR - Oak Ridge Financial Services, Inc.", ticker: "BKOR" },
    { name: "XELB - XCel Brands, Inc.", ticker: "XELB" },
    { name: "GRIL - Muscle Maker, Inc.", ticker: "GRIL" },
    { name: "HJLI - Hancock Jaffe Laboratories, Inc.", ticker: "HJLI" },
    { name: "JAKK - JAKKS PACIFIC INC", ticker: "JAKK" },
    { name: "RMCF - Rocky Mountain Chocolate Factory, Inc.", ticker: "RMCF" },
    { name: "VRME - VerifyMe, Inc.", ticker: "VRME" },
    { name: "ZICX - Zicix Corp", ticker: "ZICX" },
    { name: "LIVE - LIVE VENTURES Inc", ticker: "LIVE" },
    { name: "RGLS - Regulus Therapeutics Inc.", ticker: "RGLS" },
    { name: "IMLFF - InMed Pharmaceuticals Inc.", ticker: "IMLFF" },
    { name: "HLYK - HealthLynked Corp", ticker: "HLYK" },
    { name: "CPMD - CANNAPHARMARX, INC.", ticker: "CPMD" },
    { name: "CETX - CEMTREX INC", ticker: "CETX" },
    { name: "JCTG - Jiucaitong Group Ltd", ticker: "JCTG" },
    { name: "LTUM - Lithium Corp", ticker: "LTUM" },
    { name: "CRYO - AMERICAN CRYOSTEM Corp", ticker: "CRYO" },
    { name: "JOB - GEE Group Inc.", ticker: "JOB" },
    { name: "TAPP - TAP RESOURCES, INC.", ticker: "TAPP" },
    { name: "NDRA - ENDRA Life Sciences Inc.", ticker: "NDRA" },
    { name: "CYAN - CYANOTECH CORP", ticker: "CYAN" },
    { name: "JKSM - Jacksam Corp", ticker: "JKSM" },
    { name: "IPWR - Ideal Power Inc.", ticker: "IPWR" },
    { name: "CUEN - Cuentas Inc.", ticker: "CUEN" },
    { name: "WISA - Summit Wireless Technologies, Inc.", ticker: "WISA" },
    { name: "PVL - Permianville Royalty Trust", ticker: "PVL" },
    { name: "PQEFF - PETROTEQ ENERGY INC.", ticker: "PQEFF" },
    { name: "FBSI - FIRST BANCSHARES INC /MO/", ticker: "FBSI" },
    { name: "OPXS - Optex Systems Holdings Inc", ticker: "OPXS" },
    { name: "CQCQ - MAKINGORG, INC.", ticker: "CQCQ" },
    { name: "BNET - BION ENVIRONMENTAL TECHNOLOGIES INC", ticker: "BNET" },
    { name: "ZDGE - Zedge, Inc.", ticker: "ZDGE" },
    { name: "RMED - Ra Medical Systems, Inc.", ticker: "RMED" },
    { name: "GHSI - Guardion Health Sciences, Inc.", ticker: "GHSI" },
    { name: "EYEG - EYEGATE PHARMACEUTICALS INC", ticker: "EYEG" },
    { name: "EMED - Electromedical Technologies, Inc", ticker: "EMED" },
    { name: "IPTK - AS-IP TECH INC", ticker: "IPTK" },
    { name: "WHLM - Wilhelmina International, Inc.", ticker: "WHLM" },
    { name: "ZPAS - Zoompass Holdings, Inc.", ticker: "ZPAS" },
    { name: "MDGS - Medigus Ltd.", ticker: "MDGS" },
    { name: "ADOM - ADOMANI, INC.", ticker: "ADOM" },
    { name: "PGID - PEREGRINE INDUSTRIES INC", ticker: "PGID" },
    { name: "MATN - MATEON THERAPEUTICS INC", ticker: "MATN" },
    { name: "YVR - Liquid Media Group Ltd.", ticker: "YVR" },
    { name: "SXTC - China SXT Pharmaceuticals, Inc.", ticker: "SXTC" },
    { name: "RETO - ReTo Eco-Solutions, Inc.", ticker: "RETO" },
    { name: "SGRP - SPAR GROUP INC", ticker: "SGRP" },
    { name: "BDIC - Blow & Drive Interlock Corp", ticker: "BDIC" },
    { name: "GTBP - GT Biopharma, Inc.", ticker: "GTBP" },
    { name: "WSCRF - North American Nickel Inc.", ticker: "WSCRF" },
    { name: "KOSS - KOSS CORP", ticker: "KOSS" },
    { name: "GNBT - GENEREX BIOTECHNOLOGY CORP", ticker: "GNBT" },
    { name: "INTWF - Sharc International Systems Inc.", ticker: "INTWF" },
    { name: "JAGX - Jaguar Health, Inc.", ticker: "JAGX" },
    { name: "KGKG - KONA GOLD SOLUTIONS, INC.", ticker: "KGKG" },
    { name: "KSPN - Kaspien Holdings Inc.", ticker: "KSPN" },
    { name: "RDGC - Andina Gold Corp.", ticker: "RDGC" },
    { name: "QUTR - QUTURE INTERNATIONAL, INC.", ticker: "QUTR" },
    { name: "WSTRF - Western Uranium & Vanadium Corp.", ticker: "WSTRF" },
    { name: "BSQR - BSQUARE CORP /WA", ticker: "BSQR" },
    { name: "CHEK - Check-Cap Ltd", ticker: "CHEK" },
    { name: "MYO - MYOMO, INC.", ticker: "MYO" },
    { name: "SSBP - SSB Bancorp, Inc.", ticker: "SSBP" },
    { name: "PEYE - PRECISION OPTICS CORPORATION, INC.", ticker: "PEYE" },
    { name: "EPGG - Empire Global Gaming, Inc.", ticker: "EPGG" },
    { name: "DYSL - DYNASIL CORP OF AMERICA", ticker: "DYSL" },
    { name: "EXDW - Exceed World, Inc.", ticker: "EXDW" },
    { name: "ALLM - ALLIANCE BIOENERGY PLUS, INC.", ticker: "ALLM" },
    { name: "GPFT - Grapefruit USA, Inc", ticker: "GPFT" },
    { name: "EVK - Ever-Glory International Group, Inc.", ticker: "EVK" },
    { name: "RCMT - RCM TECHNOLOGIES, INC.", ticker: "RCMT" },
    { name: "VONI - Veroni Brands Corp.", ticker: "VONI" },
    { name: "TKAT - Takung Art Co., Ltd.", ticker: "TKAT" },
    { name: "SNOA - Sonoma Pharmaceuticals, Inc.", ticker: "SNOA" },
    { name: "IGXT - IntelGenx Technologies Corp.", ticker: "IGXT" },
    { name: "TMBXF - TOMBSTONE EXPLORATION CORP", ticker: "TMBXF" },
    { name: "TLSS - Transportation & Logistics Systems, Inc.", ticker: "TLSS" },
    { name: "EQS - EQUUS TOTAL RETURN, INC.", ticker: "EQS" },
    { name: "SLRX - Salarius Pharmaceuticals, Inc.", ticker: "SLRX" },
    { name: "QTRRF - QUATERRA RESOURCES INC", ticker: "QTRRF" },
    { name: "PWCO - PwrCor, Inc.", ticker: "PWCO" },
    { name: "IWSY - IMAGEWARE SYSTEMS INC", ticker: "IWSY" },
    { name: "LXRP - Lexaria Bioscience Corp.", ticker: "LXRP" },
    { name: "TBBA - TEB Bancorp, Inc.", ticker: "TBBA" },
    { name: "IMUN - Immune Therapeutics, Inc.", ticker: "IMUN" },
    { name: "PIH - 1347 Property Insurance Holdings, Inc.", ticker: "PIH" },
    { name: "FTLF - FITLIFE BRANDS, INC.", ticker: "FTLF" },
    { name: "NUGS - CANNABIS STRATEGIC VENTURES", ticker: "NUGS" },
    { name: "GRCK - GREY CLOAK TECH INC.", ticker: "GRCK" },
    { name: "PCTL - PCT LTD", ticker: "PCTL" },
    { name: "TSOI - THERAPEUTIC SOLUTIONS INTERNATIONAL, INC.", ticker: "TSOI" },
    { name: "JCDAF - JACADA LTD", ticker: "JCDAF" },
    { name: "FDLB - FIDELITY FEDERAL BANCORP", ticker: "FDLB" },
    { name: "GZCC - GUOZI ZHONGYU CAPITAL HOLDINGS", ticker: "GZCC" },
    { name: "PFIN - P&F INDUSTRIES INC", ticker: "PFIN" },
    { name: "OILFF - Nextleaf Solutions Ltd.", ticker: "OILFF" },
    { name: "TENX - TENAX THERAPEUTICS, INC.", ticker: "TENX" },
    { name: "GARWF - Golden Arrow Resources Corp", ticker: "GARWF" },
    { name: "EMPM - Empire Post Media, Inc.", ticker: "EMPM" },
    { name: "CGA - China Green Agriculture, Inc.", ticker: "CGA" },
    { name: "SGLB - SIGMA LABS, INC.", ticker: "SGLB" },
    { name: "SGMA - SIGMATRON INTERNATIONAL INC", ticker: "SGMA" },
    { name: "LTBR - LIGHTBRIDGE Corp", ticker: "LTBR" },
    { name: "DYNR - DYNARESOURCE INC", ticker: "DYNR" },
    { name: "RLBY - RELIABILITY INC", ticker: "RLBY" },
    { name: "BPTH - BIO-PATH HOLDINGS INC", ticker: "BPTH" },
    { name: "TRT - TRIO-TECH INTERNATIONAL", ticker: "TRT" },
    { name: "AIRO - AIRSPAN NETWORKS INC", ticker: "AIRO" },
    { name: "HIHO - HIGHWAY HOLDINGS LTD", ticker: "HIHO" },
    { name: "EQTRF - Altamira Gold Corp.", ticker: "EQTRF" },
    { name: "TRTC - Terra Tech Corp.", ticker: "TRTC" },
    { name: "MYT - Urban Tea, Inc.", ticker: "MYT" },
    { name: "FMFG - Farmers & Merchants Bancshares, Inc.", ticker: "FMFG" },
    { name: "LLIT - Lianluo Smart Ltd", ticker: "LLIT" },
    { name: "IVDN - INNOVATIVE DESIGNS INC", ticker: "IVDN" },
    { name: "IHT - INNSUITES HOSPITALITY TRUST", ticker: "IHT" },
    { name: "WDDD - WORLDS INC", ticker: "WDDD" },
    { name: "YGYI - Youngevity International, Inc.", ticker: "YGYI" },
    { name: "NXTD - Nxt-ID, Inc.", ticker: "NXTD" },
    { name: "BIXT - BIOXYTRAN, INC", ticker: "BIXT" },
    { name: "CETY - Clean Energy Technologies, Inc.", ticker: "CETY" },
    { name: "FORD - Forward Industries, Inc.", ticker: "FORD" },
    { name: "DRRSF - ARIANNE PHOSPHATE INC.", ticker: "DRRSF" },
    { name: "SNDE - Sundance Energy Inc.", ticker: "SNDE" },
    { name: "IMTE - Integrated Media Technology Ltd", ticker: "IMTE" },
    { name: "MYOS - MYOS RENS TECHNOLOGY INC.", ticker: "MYOS" },
    { name: "FOTB - FIRST OTTAWA BANCSHARES, INC", ticker: "FOTB" },
    { name: "MNKKQ - Mallinckrodt plc", ticker: "MNKKQ" },
    { name: "MYMX - MYMETICS CORP", ticker: "MYMX" },
    { name: "DUOT - DUOS TECHNOLOGIES GROUP, INC.", ticker: "DUOT" },
    { name: "IPDN - Professional Diversity Network, Inc.", ticker: "IPDN" },
    { name: "TGIFF - 1933 Industries Inc.", ticker: "TGIFF" },
    { name: "GRLB - GL Brands, Inc.", ticker: "GRLB" },
    { name: "SNNF - Seneca Financial Corp.", ticker: "SNNF" },
    { name: "DXYN - DIXIE GROUP INC", ticker: "DXYN" },
    { name: "LAAB - Startech Labs, Inc.", ticker: "LAAB" },
    { name: "INBP - INTEGRATED BIOPHARMA INC", ticker: "INBP" },
    { name: "ERKH - Eureka Homestead Bancorp, Inc.", ticker: "ERKH" },
    { name: "TVE - Tennessee Valley Authority", ticker: "TVE" },
    { name: "ANTE - AIRNET TECHNOLOGY INC.", ticker: "ANTE" },
    { name: "DXLG - DESTINATION XL GROUP, INC.", ticker: "DXLG" },
    { name: "TTNP - TITAN PHARMACEUTICALS INC", ticker: "TTNP" },
    { name: "TBTC - TABLE TRAC INC", ticker: "TBTC" },
    { name: "HDVY - HEALTH DISCOVERY CORP", ticker: "HDVY" },
    { name: "ORHK - ORANGEHOOK, INC.", ticker: "ORHK" },
    { name: "TAIT - TAITRON COMPONENTS INC", ticker: "TAIT" },
    { name: "VRVR - VIRTUAL INTERACTIVE TECHNOLOGIES CORP.", ticker: "VRVR" },
    { name: "TMBR - Timber Pharmaceuticals, Inc.", ticker: "TMBR" },
    { name: "CFOK - COMMUNITY FIRST BANCORP", ticker: "CFOK" },
    { name: "DRAD - DIGIRAD CORP", ticker: "DRAD" },
    { name: "IDXG - INTERPACE BIOSCIENCES, INC.", ticker: "IDXG" },
    { name: "TARSF - Alianza Minerals Ltd.", ticker: "TARSF" },
    { name: "SPND - SPINDLETOP OIL & GAS CO", ticker: "SPND" },
    { name: "ETHOF - Ethos Gold Corp.", ticker: "ETHOF" },
    { name: "SECI - SECTOR 10 INC", ticker: "SECI" },
    { name: "WORX - SCWorx Corp.", ticker: "WORX" },
    { name: "IVFH - INNOVATIVE FOOD HOLDINGS INC", ticker: "IVFH" },
    { name: "SPCB - SuperCom Ltd", ticker: "SPCB" },
    { name: "ELSE - ELECTRO SENSORS INC", ticker: "ELSE" },
    { name: "HEWA - HealthWarehouse.com, Inc.", ticker: "HEWA" },
    { name: "GRMM - Grom Social Enterprises, Inc.", ticker: "GRMM" },
    { name: "SSNT - SilverSun Technologies, Inc.", ticker: "SSNT" },
    { name: "NVDEF - NEVADA EXPLORATION INC", ticker: "NVDEF" },
    { name: "EVOL - EVOLVING SYSTEMS INC", ticker: "EVOL" },
    { name: "RSASF - RESAAS Services Inc.", ticker: "RSASF" },
    { name: "ASTC - ASTROTECH Corp", ticker: "ASTC" },
    { name: "NSPR - InspireMD, Inc.", ticker: "NSPR" },
    { name: "CLCI - CLIC TECHNOLOGY, INC.", ticker: "CLCI" },
    { name: "EAWD - Energy & Water Development Corp", ticker: "EAWD" },
    { name: "SOACF - SOUTHERN ARC MINERALS INC", ticker: "SOACF" },
    { name: "CCYC - Clancy Corp", ticker: "CCYC" },
    { name: "NSYS - NORTECH SYSTEMS INC", ticker: "NSYS" },
    { name: "SHVLF - STARCORE INTERNATIONAL MINES LTD.", ticker: "SHVLF" },
    { name: "WINR - SIMPLICITY ESPORTS & GAMING Co", ticker: "WINR" },
    { name: "BNTC - Benitec Biopharma Inc.", ticker: "BNTC" },
    { name: "NAKD - NAKED BRAND GROUP Ltd", ticker: "NAKD" },
    { name: "RGBD - Regional Brands Inc.", ticker: "RGBD" },
    { name: "ICD - Independence Contract Drilling, Inc.", ticker: "ICD" },
    { name: "NUKK - Nukkleus Inc.", ticker: "NUKK" },
    { name: "HRTH - HARTE HANKS INC", ticker: "HRTH" },
    { name: "ABCP - AMBASE CORP", ticker: "ABCP" },
    { name: "AINC - Ashford Inc.", ticker: "AINC" },
    { name: "GNOLF - GENOIL INC", ticker: "GNOLF" },
    { name: "STAF - Staffing 360 Solutions, Inc.", ticker: "STAF" },
    { name: "BGI - BIRKS GROUP INC.", ticker: "BGI" },
    { name: "FGCO - Financial Gravity Companies, Inc.", ticker: "FGCO" },
    { name: "QRON - Qrons Inc.", ticker: "QRON" },
    { name: "PTIX - Protagenic Therapeutics, Inc.\\new", ticker: "PTIX" },
    { name: "CLABF - CORE ONE LABS INC.", ticker: "CLABF" },
    { name: "DKMR - DUKE MOUNTAIN RESOURCES, INC.", ticker: "DKMR" },
    { name: "SNCA - Seneca Biopharma, Inc.", ticker: "SNCA" },
    { name: "ITNRF - Intelligent Energy Holdings Plc", ticker: "ITNRF" },
    { name: "LEDS - SemiLEDs Corp", ticker: "LEDS" },
    { name: "ACFN - ACORN ENERGY, INC.", ticker: "ACFN" },
    { name: "TOMDF - TODOS MEDICAL LTD.", ticker: "TOMDF" },
    { name: "BETRF - BetterLife Pharma Inc.", ticker: "BETRF" },
    { name: "BDR - BLONDER TONGUE LABORATORIES INC", ticker: "BDR" },
    { name: "PFHO - PACIFIC HEALTH CARE ORGANIZATION INC", ticker: "PFHO" },
    { name: "ESOA - Energy Services of America CORP", ticker: "ESOA" },
    { name: "NVFY - Nova Lifestyle, Inc.", ticker: "NVFY" },
    { name: "CRTG - CORETEC GROUP INC.", ticker: "CRTG" },
    { name: "RMHB - Rocky Mountain High Brands, Inc.", ticker: "RMHB" },
    { name: "SURG - Surge Holdings, Inc.", ticker: "SURG" },
    { name: "HUSA - HOUSTON AMERICAN ENERGY CORP", ticker: "HUSA" },
    { name: "ILAL - International Land Alliance Inc.", ticker: "ILAL" },
    { name: "PHIO - Phio Pharmaceuticals Corp.", ticker: "PHIO" },
    { name: "BXNG - Bang Holdings Corp.", ticker: "BXNG" },
    { name: "QHYG - QHY GROUP", ticker: "QHYG" },
    { name: "APEUF - ATLAS ENGINEERED PRODUCTS LTD.", ticker: "APEUF" },
    { name: "SYHBF - SKYHARBOUR RESOURCES LTD", ticker: "SYHBF" },
    { name: "BSTG - Biostage, Inc.", ticker: "BSTG" },
    { name: "PSTV - PLUS THERAPEUTICS, INC.", ticker: "PSTV" },
    { name: "GOVX - GeoVax Labs, Inc.", ticker: "GOVX" },
    { name: "FLYLF - FLYHT Aerospace Solutions Ltd.", ticker: "FLYLF" },
    { name: "TSSI - TSS, Inc.", ticker: "TSSI" },
    { name: "SNMP - Sanchez Midstream Partners LP", ticker: "SNMP" },
    { name: "GDSI - GLOBAL DIGITAL SOLUTIONS INC", ticker: "GDSI" },
    { name: "EAST - Eastside Distilling, Inc.", ticker: "EAST" },
    { name: "POAI - Predictive Oncology Inc.", ticker: "POAI" },
    { name: "SUIC - Sino United Worldwide Consolidated Ltd.", ticker: "SUIC" },
    { name: "SUWN - SUNWIN STEVIA INTERNATIONAL, INC.", ticker: "SUWN" },
    { name: "KBPH - Kyto Technology & Life Science, Inc.", ticker: "KBPH" },
    { name: "CRZY - CRAZY WOMAN CREEK BANCORP INC", ticker: "CRZY" },
    { name: "XTLB - XTL BIOPHARMACEUTICALS LTD", ticker: "XTLB" },
    { name: "ANY - Sphere 3D Corp", ticker: "ANY" },
    { name: "NBGV - NewBridge Global Ventures, Inc.", ticker: "NBGV" },
    { name: "SDPI - Superior Drilling Products, Inc.", ticker: "SDPI" },
    { name: "NNUP - NOCOPI TECHNOLOGIES INC/MD/", ticker: "NNUP" },
    { name: "EFSH - 1847 Holdings LLC", ticker: "EFSH" },
    { name: "CHKR - CHESAPEAKE GRANITE WASH TRUST", ticker: "CHKR" },
    { name: "ARGC - ARION GROUP CORP.", ticker: "ARGC" },
    { name: "RSCF - REFLECT SCIENTIFIC INC", ticker: "RSCF" },
    { name: "PRPCF - Silver Elephant Mining Corp.", ticker: "PRPCF" },
    { name: "AMS - AMERICAN SHARED HOSPITAL SERVICES", ticker: "AMS" },
    { name: "WCUI - Wellness Center USA, Inc.", ticker: "WCUI" },
    { name: "TIKK - TEL INSTRUMENT ELECTRONICS CORP", ticker: "TIKK" },
    { name: "CREX - CREATIVE REALITIES, INC.", ticker: "CREX" },
    { name: "MLRKF - Millrock Resources Inc", ticker: "MLRKF" },
    { name: "ACAN - AmeriCann, Inc.", ticker: "ACAN" },
    { name: "DGDM - Digital Development Partners, Inc.", ticker: "DGDM" },
    { name: "ARTW - ARTS WAY MANUFACTURING CO INC", ticker: "ARTW" },
    { name: "ARCW - ARC Group Worldwide, Inc.", ticker: "ARCW" },
    { name: "FUGI - FUEGO ENTERPRISES, INC.", ticker: "FUGI" },
    { name: "SMDM - SINGING MACHINE CO INC", ticker: "SMDM" },
    { name: "MXC - MEXCO ENERGY CORP", ticker: "MXC" },
    { name: "NVNT - NOVINT TECHNOLOGIES INC", ticker: "NVNT" },
    { name: "ESBS - ES Bancshares, Inc.", ticker: "ESBS" },
    { name: "BLNC - Balance Labs, Inc.", ticker: "BLNC" },
    { name: "TSRI - TSR INC", ticker: "TSRI" },
    { name: "QTMM - QUANTUM MATERIALS CORP.", ticker: "QTMM" },
    { name: "GIGA - GIGA TRONICS INC", ticker: "GIGA" },
    { name: "ANAV - ALPHA NETWORK ALLIANCE VENTURES INC.", ticker: "ANAV" },
    { name: "BOSC - BOS BETTER ONLINE SOLUTIONS LTD", ticker: "BOSC" },
    { name: "ANCN - Anchiano Therapeutics Ltd.", ticker: "ANCN" },
    { name: "OXBR - OXBRIDGE RE HOLDINGS Ltd", ticker: "OXBR" },
    { name: "BKUCF - BLUE SKY URANIUM CORP.", ticker: "BKUCF" },
    { name: "MDRR - Medalist Diversified REIT, Inc.", ticker: "MDRR" },
    { name: "NAHD - New Asia Holdings, Inc.", ticker: "NAHD" },
    { name: "NAUH - National American University Holdings, Inc.", ticker: "NAUH" },
    { name: "WNDM - Sanara MedTech Inc.", ticker: "WNDM" },
    { name: "CREG - CHINA RECYCLING ENERGY CORP", ticker: "CREG" },
    { name: "ABMT - Advanced Biomedical Technologies Inc.", ticker: "ABMT" },
    { name: "KSBI - KS BANCORP INC", ticker: "KSBI" },
    { name: "MXROF - MAX RESOURCE CORP.", ticker: "MXROF" },
    { name: "LVRLF - CordovaCann Corp.", ticker: "LVRLF" },
    { name: "MRIN - MARIN SOFTWARE INC", ticker: "MRIN" },
    { name: "WMLLF - Wealth Minerals Ltd.", ticker: "WMLLF" },
    { name: "ENSV - Enservco Corp", ticker: "ENSV" },
    { name: "THMG - THUNDER MOUNTAIN GOLD INC", ticker: "THMG" },
    { name: "LPTV - Loop Media, Inc.", ticker: "LPTV" },
    { name: "ZXAIY - China Zenix Auto International Ltd", ticker: "ZXAIY" },
    { name: "PRLX - PARALLAX HEALTH SCIENCES, INC.", ticker: "PRLX" },
    { name: "TKLS - Trutankless, Inc.", ticker: "TKLS" },
    { name: "HPTO - hopTo Inc.", ticker: "HPTO" },
    { name: "PRSEY - Prosafe SE/ADR", ticker: "PRSEY" },
    { name: "RAVE - RAVE RESTAURANT GROUP, INC.", ticker: "RAVE" },
    { name: "URLOF - BRISIO INNOVATIONS INC.", ticker: "URLOF" },
    { name: "LIBFF - Nova Mentis Life Science Corp.", ticker: "LIBFF" },
    { name: "MMND - MASTERMIND, INC.", ticker: "MMND" },
    { name: "RIII - RENAVOTIO, INC.", ticker: "RIII" },
    { name: "SRSG - SPIRITS TIME INTERNATIONAL, INC.", ticker: "SRSG" },
    { name: "INNO - INNOCAP INC", ticker: "INNO" },
    { name: "MMTIF - MICROMEM TECHNOLOGIES INC", ticker: "MMTIF" },
    { name: "VFRM - Veritas Farms, Inc.", ticker: "VFRM" },
    { name: "TGC - TENGASCO INC", ticker: "TGC" },
    { name: "BLILF - BEARING LITHIUM CORP.", ticker: "BLILF" },
    { name: "NDYN - VININGS HOLDINGS, INC.", ticker: "NDYN" },
    { name: "ZYJT - Zhong Ya International Ltd", ticker: "ZYJT" },
    { name: "CBAI - CBA Florida, Inc.", ticker: "CBAI" },
    { name: "DYNT - DYNATRONICS CORP", ticker: "DYNT" },
    { name: "CBDS - Cannabis Sativa, Inc.", ticker: "CBDS" },
    { name: "BLYQ - BALLY, CORP.", ticker: "BLYQ" },
    { name: "INLX - INTELLINETICS, INC.", ticker: "INLX" },
    { name: "REXN - REXAHN PHARMACEUTICALS, INC.", ticker: "REXN" },
    { name: "BLIN - Bridgeline Digital, Inc.", ticker: "BLIN" },
    { name: "CGIX - CANCER GENETICS, INC", ticker: "CGIX" },
    { name: "QSEP - QS Energy, Inc.", ticker: "QSEP" },
    { name: "VLDI - VALIDIAN CORP", ticker: "VLDI" },
    { name: "MMTRS - MILLS MUSIC TRUST", ticker: "MMTRS" },
    { name: "SMKG - SmartCard Marketing Systems Inc", ticker: "SMKG" },
    { name: "SPRS - SURGE COMPONENTS INC", ticker: "SPRS" },
    { name: "RCON - Recon Technology, Ltd", ticker: "RCON" },
    { name: "NWCN - NETWORK CN INC", ticker: "NWCN" },
    { name: "LHIL - Leader Hill Corp", ticker: "LHIL" },
    { name: "JSDA - JONES SODA CO", ticker: "JSDA" },
    { name: "FERL - FEARLESS FILMS, INC.", ticker: "FERL" },
    { name: "ABCFF - ABACUS MINING & EXPLORATION CORP", ticker: "ABCFF" },
    { name: "SENR - Strategic Environmental & Energy Resources, Inc.", ticker: "SENR" },
    { name: "CLSH - CLS Holdings USA, Inc.", ticker: "CLSH" },
    { name: "EDRY - EuroDry Ltd.", ticker: "EDRY" },
    { name: "NVSGF - Nevada Sunrise Gold Corp", ticker: "NVSGF" },
    { name: "EQMEF - Equity Metals Corp", ticker: "EQMEF" },
    { name: "TVLF - TENNESSEE VALLEY FINANCIAL HOLDINGS INC", ticker: "TVLF" },
    { name: "JSHG - JOSHUA GOLD RESOURCES INC", ticker: "JSHG" },
    { name: "CSJT - Changsheng International Group Ltd", ticker: "CSJT" },
    { name: "GRST - ETHEMA HEALTH Corp", ticker: "GRST" },
    { name: "GRUSF - Grown Rogue International Inc.", ticker: "GRUSF" },
    { name: "EMBI - Emerald Bioscience, Inc.", ticker: "EMBI" },
    { name: "SQBG - Sequential Brands Group, Inc.", ticker: "SQBG" },
    { name: "BMNM - BIMINI CAPITAL MANAGEMENT, INC.", ticker: "BMNM" },
    { name: "NROM - NOBLE ROMANS INC", ticker: "NROM" },
    { name: "BVTEF - ICONIC MINERALS LTD.", ticker: "BVTEF" },
    { name: "SNNY - Sunnyside Bancorp, Inc.", ticker: "SNNY" },
    { name: "CLWT - EURO TECH HOLDINGS CO LTD", ticker: "CLWT" },
    { name: "BICX - BioCorRx Inc.", ticker: "BICX" },
    { name: "GTII - GLOBAL TECH INDUSTRIES GROUP, INC.", ticker: "GTII" },
    { name: "VAUCF - Viva Gold Corp.", ticker: "VAUCF" },
    { name: "MJNE - MJ Holdings, Inc.", ticker: "MJNE" },
    { name: "ARTL - ARTELO BIOSCIENCES, INC.", ticker: "ARTL" },
    { name: "NGTF - NightFood Holdings, Inc.", ticker: "NGTF" },
    { name: "FRAN - Francesca's Holdings CORP", ticker: "FRAN" },
    { name: "LMFA - LM FUNDING AMERICA, INC.", ticker: "LMFA" },
    { name: "NRIS - Norris Industries, Inc.", ticker: "NRIS" },
    { name: "IMAC - IMAC Holdings, Inc.", ticker: "IMAC" },
    { name: "WHEN - WORLD HEALTH ENERGY HOLDINGS, INC.", ticker: "WHEN" },
    { name: "USEG - US ENERGY CORP", ticker: "USEG" },
    { name: "DSGT - DSG Global Inc.", ticker: "DSGT" },
    { name: "CVVUF - CANALASKA URANIUM LTD", ticker: "CVVUF" },
    { name: "SSY - SUNLINK HEALTH SYSTEMS INC", ticker: "SSY" },
    { name: "SYTE - ENTERPRISE DIVERSIFIED, INC.", ticker: "SYTE" },
    { name: "CMOT - Curtiss Motorcycle Company, Inc.", ticker: "CMOT" },
    { name: "ZPHYF - ZEPHYR MINERALS LTD.", ticker: "ZPHYF" },
    { name: "WKSP - Worksport, Ltd", ticker: "WKSP" },
    { name: "MEXGF - Mexican Gold Corp.", ticker: "MEXGF" },
    { name: "TOFB - TOFUTTI BRANDS INC", ticker: "TOFB" },
    { name: "SCKT - SOCKET MOBILE, INC.", ticker: "SCKT" },
    { name: "VYND - Vynleads, Inc.", ticker: "VYND" },
    { name: "AMCT - AMERICAN EDUCATION CENTER, INC.", ticker: "AMCT" },
    { name: "AXREF - AMARC RESOURCES LTD", ticker: "AXREF" },
    { name: "VBIO - Vitality Biopharma, Inc.", ticker: "VBIO" },
    { name: "HWIS - Home Bancorp Wisconsin, Inc.", ticker: "HWIS" },
    { name: "TYHT - SHINECO, INC.", ticker: "TYHT" },
    { name: "CBEV - CAPITAL BEVERAGE CORP", ticker: "CBEV" },
    { name: "SAFO - Save Foods Inc.", ticker: "SAFO" },
    { name: "CTDT - CENTAURUS DIAMOND TECHNOLOGIES, INC.", ticker: "CTDT" },
    { name: "INRD - Inrad Optics, Inc.", ticker: "INRD" },
    { name: "HHSE - Hannover House, Inc.", ticker: "HHSE" },
    { name: "MARPS - MARINE PETROLEUM TRUST", ticker: "MARPS" },
    { name: "ADAD - Adaiah Distribution Inc", ticker: "ADAD" },
    { name: "OPHC - OptimumBank Holdings, Inc.", ticker: "OPHC" },
    { name: "JAN - JanOne Inc.", ticker: "JAN" },
    { name: "AQSP - ACQUIRED SALES CORP", ticker: "AQSP" },
    { name: "ISIG - INSIGNIA SYSTEMS INC/MN", ticker: "ISIG" },
    { name: "HWKE - Hawkeye Systems, Inc.", ticker: "HWKE" },
    { name: "SIPN - SIPP International Industries, Inc.", ticker: "SIPN" },
    { name: "POTN - PotNetwork Holdings, Inc.", ticker: "POTN" },
    { name: "CNNC - Cannonau Corp.", ticker: "CNNC" },
    { name: "VIVE - VIVEVE MEDICAL, INC.", ticker: "VIVE" },
    { name: "ANFC - Black Ridge Oil & Gas, Inc.", ticker: "ANFC" },
    { name: "RWRDP - iConsumer Corp.", ticker: "RWRDP" },
    { name: "NLBS - NUTRALIFE BIOSCIENCES, INC", ticker: "NLBS" },
    { name: "GBR - New Concept Energy, Inc.", ticker: "GBR" },
    { name: "AMRH - AMERI Holdings, Inc.", ticker: "AMRH" },
    { name: "RCG - RENN Fund, Inc.", ticker: "RCG" },
    { name: "AMAR - AMARILLO BIOSCIENCES INC", ticker: "AMAR" },
    { name: "PGOL - PATRIOT GOLD CORP", ticker: "PGOL" },
    { name: "OMPS - OMPHALOS, CORP", ticker: "OMPS" },
    { name: "BCII - Blockchain Industries, Inc.", ticker: "BCII" },
    { name: "EPWCF - Empower Clinics Inc.", ticker: "EPWCF" },
    { name: "VXEL - Vitaxel Group Ltd", ticker: "VXEL" },
    { name: "YAYO - YayYo, Inc.", ticker: "YAYO" },
    { name: "RCRT - Recruiter.com Group, Inc.", ticker: "RCRT" },
    { name: "UPZS - UNIQUE FOODS Corp", ticker: "UPZS" },
    { name: "CTIB - Yunhong CTI Ltd.", ticker: "CTIB" },
    { name: "EGRN - Evergreen-Agra Global Investments, Inc.", ticker: "EGRN" },
    { name: "ADMT - ADM TRONICS UNLIMITED, INC.", ticker: "ADMT" },
    { name: "MHTX - MANHATTAN SCIENTIFICS INC", ticker: "MHTX" },
    { name: "GBLX - GB SCIENCES INC", ticker: "GBLX" },
    { name: "MYSZ - My Size, Inc.", ticker: "MYSZ" },
    { name: "NAOV - NanoVibronix, Inc.", ticker: "NAOV" },
    { name: "BGAVF - Bravada Gold Corp", ticker: "BGAVF" },
    { name: "JANL - JANEL CORP", ticker: "JANL" },
    { name: "BRN - BARNWELL INDUSTRIES INC", ticker: "BRN" },
    { name: "SIAF - Sino Agro Food, Inc.", ticker: "SIAF" },
    { name: "FUST - FUSE GROUP HOLDING INC.", ticker: "FUST" },
    { name: "ATCC - Ameritrust Corp", ticker: "ATCC" },
    { name: "PVNC - PREVENTION INSURANCE COM INC", ticker: "PVNC" },
    { name: "NWYU - New You, Inc.", ticker: "NWYU" },
    { name: "HLRTF - HILLCREST PETROLEUM LTD.", ticker: "HLRTF" },
    { name: "CHCR - Advanzeon Solutions, Inc.", ticker: "CHCR" },
    { name: "AEHL - Antelope Enterprise Holdings Ltd", ticker: "AEHL" },
    { name: "IAALF - IBC Advanced Alloys Corp.", ticker: "IAALF" },
    { name: "OWPC - One World Pharma, Inc.", ticker: "OWPC" },
    { name: "EMPR - EMPIRE PETROLEUM CORP", ticker: "EMPR" },
    { name: "IAIC - INFORMATION ANALYSIS INC", ticker: "IAIC" },
    { name: "UNEX - UNEX HOLDINGS INC.", ticker: "UNEX" },
    { name: "UCLE - US NUCLEAR CORP.", ticker: "UCLE" },
    { name: "TGLTY - TGLT S.A./ADR", ticker: "TGLTY" },
    { name: "IBAL - INTERNATIONAL BALER CORP", ticker: "IBAL" },
    { name: "EVGI - Evergreen International Corp.", ticker: "EVGI" },
    { name: "OBLN - OBALON THERAPEUTICS INC", ticker: "OBLN" },
    { name: "FZMD - Fuse Medical, Inc.", ticker: "FZMD" },
    { name: "VIDE - VIDEO DISPLAY CORP", ticker: "VIDE" },
    { name: "IKNX - IKONICS CORP", ticker: "IKNX" },
    { name: "MTR - MESA ROYALTY TRUST/TX", ticker: "MTR" },
    { name: "AWX - AVALON HOLDINGS CORP", ticker: "AWX" },
    { name: "QMCI - QUOTEMEDIA INC", ticker: "QMCI" },
    { name: "IPSI - Innovative Payment Solutions, Inc.", ticker: "IPSI" },
    { name: "SINO - Sino-Global Shipping America, Ltd.", ticker: "SINO" },
    { name: "CLNH - Clinigence Holdings, Inc.", ticker: "CLNH" },
    { name: "JRSS - JRSIS HEALTH CARE Corp", ticker: "JRSS" },
    { name: "CDYCF - CARDERO RESOURCE CORP.", ticker: "CDYCF" },
    { name: "QEGY - QUANTUM ENERGY INC.", ticker: "QEGY" },
    { name: "ZYQG - ZYQC Group Holding Ltd", ticker: "ZYQG" },
    { name: "LUVU - Luvu Brands, Inc.", ticker: "LUVU" },
    { name: "CFOO - China Foods Holdings Ltd.", ticker: "CFOO" },
    { name: "ACEZ - Ariel Clean Energy, Inc.", ticker: "ACEZ" },
    { name: "HXBM - HELIX BIOMEDIX INC", ticker: "HXBM" },
    { name: "YEWB - Yew Bio-Pharm Group, Inc.", ticker: "YEWB" },
    { name: "PLRTF - Plymouth Rock Technologies Inc.", ticker: "PLRTF" },
    { name: "ENZN - ENZON PHARMACEUTICALS, INC.", ticker: "ENZN" },
    { name: "AMMX - Ameramex International Inc", ticker: "AMMX" },
    { name: "VRTY - Healthcare Solutions Management Group, Inc.", ticker: "VRTY" },
    { name: "IONI - I-ON Digital Corp.", ticker: "IONI" },
    { name: "GPOX - GPO Plus, Inc.", ticker: "GPOX" },
    { name: "ICNB - Iconic Brands, Inc.", ticker: "ICNB" },
    { name: "WTNW - Water Now, Inc.", ticker: "WTNW" },
    { name: "UPDC - UPD HOLDING CORP.", ticker: "UPDC" },
    { name: "MCUJF - MEDICURE INC", ticker: "MCUJF" },
    { name: "MJHI - MJ Harvest, Inc.", ticker: "MJHI" },
    { name: "MMNT - MOMENTOUS HOLDINGS CORP.", ticker: "MMNT" },
    { name: "PENC - Nano Magic Inc.", ticker: "PENC" },
    { name: "ABMC - AMERICAN BIO MEDICA CORP", ticker: "ABMC" },
    { name: "CBKC - CHRISTOPHER & BANKS CORP", ticker: "CBKC" },
    { name: "SNNAF - SIENNA RESOURCES INC", ticker: "SNNAF" },
    { name: "DUUO - DUO WORLD INC", ticker: "DUUO" },
    { name: "TCNT - TOUCAN INTERACTIVE CORP", ticker: "TCNT" },
    { name: "AVMR - AVRA Medical Robotics, Inc.", ticker: "AVMR" },
    { name: "NRGMF - NRG METALS INC.", ticker: "NRGMF" },
    { name: "USDR - UAS Drone Corp.", ticker: "USDR" },
    { name: "MICR - MICRON SOLUTIONS INC /DE/", ticker: "MICR" },
    { name: "NTN - NTN BUZZTIME INC", ticker: "NTN" },
    { name: "GPLA - GAMEPLAN INC", ticker: "GPLA" },
    { name: "AMIH - AMERICAN INTERNATIONAL HOLDINGS CORP.", ticker: "AMIH" },
    { name: "DSNY - DESTINY MEDIA TECHNOLOGIES INC", ticker: "DSNY" },
    { name: "CLTS - EARTH LIFE SCIENCES INC", ticker: "CLTS" },
    { name: "AREB - AMERICAN REBEL HOLDINGS INC", ticker: "AREB" },
    { name: "EARS - Auris Medical Holding Ltd.", ticker: "EARS" },
    { name: "DFCO - DALRADA FINANCIAL CORP", ticker: "DFCO" },
    { name: "SSTT - SStarTradeTech Inc.", ticker: "SSTT" },
    { name: "NURO - NeuroMetrix, Inc.", ticker: "NURO" },
    { name: "SYN - Synthetic Biologics, Inc.", ticker: "SYN" },
    { name: "ELVG - Elvictor Group, Inc.", ticker: "ELVG" },
    { name: "WARM - COOL TECHNOLOGIES, INC.", ticker: "WARM" },
    { name: "SDRMU - SandRidge Mississippian Trust II", ticker: "SDRMU" },
    { name: "PBIO - PRESSURE BIOSCIENCES INC", ticker: "PBIO" },
    { name: "EMGE - Emergent Health Corp.", ticker: "EMGE" },
    { name: "KBSF - KBS Fashion Group Ltd", ticker: "KBSF" },
    { name: "RASP - Rasna Therapeutics Inc.", ticker: "RASP" },
    { name: "NVIV - INVIVO THERAPEUTICS HOLDINGS CORP.", ticker: "NVIV" },
    { name: "TCFF - Trillion Energy International Inc.", ticker: "TCFF" },
    { name: "CBDY - Target Group Inc.", ticker: "CBDY" },
    { name: "MFBP - M&F BANCORP INC /NC/", ticker: "MFBP" },
    { name: "TCCO - TECHNICAL COMMUNICATIONS CORP", ticker: "TCCO" },
    { name: "HMMR - HAMMER FIBER OPTICS HOLDINGS CORP", ticker: "HMMR" },
    { name: "SNDD - RedHawk Holdings Corp.", ticker: "SNDD" },
    { name: "RDGL - VIVOS INC", ticker: "RDGL" },
    { name: "CRVW - CareView Communications Inc", ticker: "CRVW" },
    { name: "CLRI - Cleartronic, Inc.", ticker: "CLRI" },
    { name: "LVVV - LiveWire Ergogenics, Inc.", ticker: "LVVV" },
    { name: "KITL - Kisses From Italy, Inc.", ticker: "KITL" },
    { name: "ACUR - ACURA PHARMACEUTICALS, INC", ticker: "ACUR" },
    { name: "GRMC - GOLDRICH MINING CO", ticker: "GRMC" },
    { name: "PVNNF - PV Nano Cell, Ltd.", ticker: "PVNNF" },
    { name: "IGEN - IGEN NETWORKS CORP", ticker: "IGEN" },
    { name: "RGMP - Regnum Corp.", ticker: "RGMP" },
    { name: "MAGE - MAGELLAN GOLD Corp", ticker: "MAGE" },
    { name: "MOSY - MoSys, Inc.", ticker: "MOSY" },
    { name: "BNKL - Bionik Laboratories Corp.", ticker: "BNKL" },
    { name: "CLOQ - CYBERLOQ TECHNOLOGIES, INC.", ticker: "CLOQ" },
    { name: "MGTI - MGT CAPITAL INVESTMENTS, INC.", ticker: "MGTI" },
    { name: "MYHI - Mountain High Acquisitions Corp.", ticker: "MYHI" },
    { name: "FWAV - FOURTH WAVE ENERGY, INC.", ticker: "FWAV" },
    { name: "SBFM - Sunshine Biopharma, Inc", ticker: "SBFM" },
    { name: "UMEWF - UMeWorld Ltd", ticker: "UMEWF" },
    { name: "IINX - IONIX TECHNOLOGY, INC.", ticker: "IINX" },
    { name: "TURV - TWO RIVERS WATER & FARMING Co", ticker: "TURV" },
    { name: "MTSL - MER TELEMANAGEMENT SOLUTIONS LTD", ticker: "MTSL" },
    { name: "XBIO - Xenetic Biosciences, Inc.", ticker: "XBIO" },
    { name: "SMME - SmartMetric, Inc.", ticker: "SMME" },
    { name: "BBLS - Petrolia Energy Corp", ticker: "BBLS" },
    { name: "CAVR - CAVU Resources, Inc.", ticker: "CAVR" },
    { name: "SNES - SenesTech, Inc.", ticker: "SNES" },
    { name: "ECTM - ECA Marcellus Trust I", ticker: "ECTM" },
    { name: "SRNA - Surna Inc.", ticker: "SRNA" },
    { name: "ALPP - Alpine 4 Technologies Ltd.", ticker: "ALPP" },
    { name: "LBSR - LIBERTY STAR URANIUM & METALS CORP.", ticker: "LBSR" },
    { name: "GSPE - GULFSLOPE ENERGY, INC.", ticker: "GSPE" },
    { name: "ROYL - Royale Energy, Inc.", ticker: "ROYL" },
    { name: "GWTI - GREENWAY TECHNOLOGIES INC", ticker: "GWTI" },
    { name: "BDCO - BLUE DOLPHIN ENERGY CO", ticker: "BDCO" },
    { name: "ECIA - ENCISION INC", ticker: "ECIA" },
    { name: "BTCS - BTCS Inc.", ticker: "BTCS" },
    { name: "GTHP - GUIDED THERAPEUTICS INC", ticker: "GTHP" },
    { name: "AUSI - AURA SYSTEMS INC", ticker: "AUSI" },
    { name: "DTGI - Digerati Technologies, Inc.", ticker: "DTGI" },
    { name: "JUPGF - Jupiter Gold Corp", ticker: "JUPGF" },
    { name: "LTRE - LEARNING TREE INTERNATIONAL, INC.", ticker: "LTRE" },
    { name: "KIRY - KIEWIT ROYALTY TRUST", ticker: "KIRY" },
    { name: "LKAI - LKA GOLD Inc /DE/", ticker: "LKAI" },
    { name: "KAYS - Kaya Holdings, Inc.", ticker: "KAYS" },
    { name: "ICOTF - ICO THERAPEUTICS INC", ticker: "ICOTF" },
    { name: "LTGJ - Xiamen Lutong International Travel Agency Co., Ltd.", ticker: "LTGJ" },
    { name: "PEER - PALTALK, INC.", ticker: "PEER" },
    { name: "YUSG - YUS INTERNATIONAL GROUP Ltd", ticker: "YUSG" },
    { name: "UUU - UNIVERSAL SECURITY INSTRUMENTS INC", ticker: "UUU" },
    { name: "MKTY - MECHANICAL TECHNOLOGY INC", ticker: "MKTY" },
    { name: "SING - SinglePoint Inc.", ticker: "SING" },
    { name: "LBUY - LEAFBUYER TECHNOLOGIES, INC.", ticker: "LBUY" },
    { name: "RVIV - Reviv3 Procare Co", ticker: "RVIV" },
    { name: "DWOG - DEEP WELL OIL & GAS INC", ticker: "DWOG" },
    { name: "BZYR - BURZYNSKI RESEARCH INSTITUTE INC", ticker: "BZYR" },
    { name: "INQD - Indoor Harvest Corp", ticker: "INQD" },
    { name: "GMOL - General Moly, Inc", ticker: "GMOL" },
    { name: "UNIR - UNIROYAL GLOBAL ENGINEERED PRODUCTS, INC.", ticker: "UNIR" },
    { name: "CLWD - CLOUDCOMMERCE, INC.", ticker: "CLWD" },
    { name: "SMRN - Smartag International, Inc.", ticker: "SMRN" },
    { name: "FNAM - EVOLUTIONARY GENOMICS, INC.", ticker: "FNAM" },
    { name: "IWSH - Wright Investors Service Holdings, Inc.", ticker: "IWSH" },
    { name: "SWISF - GlobeX Data Ltd.", ticker: "SWISF" },
    { name: "TAUG - TAURIGA SCIENCES, INC.", ticker: "TAUG" },
    { name: "LCTC - Lifeloc Technologies, Inc", ticker: "LCTC" },
    { name: "LRDG - Lord Global Corp", ticker: "LRDG" },
    { name: "PTNYF - ParcelPal Technology Inc.", ticker: "PTNYF" },
    { name: "TCRI - TechCom, Inc.", ticker: "TCRI" },
    { name: "SCIA - SCI Engineered Materials, Inc.", ticker: "SCIA" },
    { name: "GBCS - GLOBAL HEALTHCARE REIT, INC.", ticker: "GBCS" },
    { name: "VYEY - VICTORY OILFIELD TECH, INC.", ticker: "VYEY" },
    { name: "OPVS - NanoFlex Power Corp", ticker: "OPVS" },
    { name: "AVCRF - Avricore Health Inc.", ticker: "AVCRF" },
    { name: "IPCIF - Intellipharmaceutics International Inc.", ticker: "IPCIF" },
    { name: "ISCO - International Stem Cell CORP", ticker: "ISCO" },
    { name: "BASX - BASIC ENERGY SERVICES, INC.", ticker: "BASX" },
    { name: "AXXA - Exxe Group, Inc.", ticker: "AXXA" },
    { name: "CNFN - CFN Enterprises Inc.", ticker: "CNFN" },
    { name: "NDTP - MISTRAL VENTURES INC", ticker: "NDTP" },
    { name: "HYBT - Heyu Biological Technology Corp", ticker: "HYBT" },
    { name: "TORM - TOR MINERALS INTERNATIONAL INC", ticker: "TORM" },
    { name: "VYCO - VYCOR MEDICAL INC", ticker: "VYCO" },
    { name: "ENRT - Enertopia Corp.", ticker: "ENRT" },
    { name: "FLES - 4Less Group, Inc.", ticker: "FLES" },
    { name: "FIFG - First Foods Group, Inc.", ticker: "FIFG" },
    { name: "CPWR - Ocean Thermal Energy Corp", ticker: "CPWR" },
    { name: "SGMD - Sugarmade, Inc.", ticker: "SGMD" },
    { name: "LGMH - Light Media Holdings, Inc.", ticker: "LGMH" },
    { name: "XERI - XERIANT, INC.", ticker: "XERI" },
    { name: "BWMG - Brownie's Marine Group, Inc", ticker: "BWMG" },
    { name: "SDTTU - SandRidge Mississippian Trust I", ticker: "SDTTU" },
    { name: "ASKDF - First Energy Metals Ltd", ticker: "ASKDF" },
    { name: "BYOC - Beyond Commerce, Inc.", ticker: "BYOC" },
    { name: "HBUV - Hubilu Venture Corp", ticker: "HBUV" },
    { name: "NGLD - Nevada Canyon Gold Corp.", ticker: "NGLD" },
    { name: "PXHI - usell.com, Inc.", ticker: "PXHI" },
    { name: "ANLDF - ANFIELD ENERGY INC.", ticker: "ANLDF" },
    { name: "QBAK - QUALSTAR CORP", ticker: "QBAK" },
    { name: "SRMX - SADDLE RANCH MEDIA, INC.", ticker: "SRMX" },
    { name: "CMGO - CMG HOLDINGS GROUP, INC.", ticker: "CMGO" },
    { name: "HGTXU - HUGOTON ROYALTY TRUST", ticker: "HGTXU" },
    { name: "IQST - iQSTEL Inc", ticker: "IQST" },
    { name: "FQFC - Fuquan Financial Co", ticker: "FQFC" },
    { name: "SSOK - Sunstock, Inc.", ticker: "SSOK" },
    { name: "FECOF - FEC Resources Inc.", ticker: "FECOF" },
    { name: "CLSI - CLANCY SYSTEMS INTERNATIONAL INC /CO/", ticker: "CLSI" },
    { name: "DPDW - Deep Down, Inc.", ticker: "DPDW" },
    { name: "PHOT - GROWLIFE, INC.", ticker: "PHOT" },
    { name: "VASO - VASO Corp", ticker: "VASO" },
    { name: "ASFT - Appsoft Technologies, Inc.", ticker: "ASFT" },
    { name: "USAQ - USA EQUITIES CORP.", ticker: "USAQ" },
    { name: "TUMIF - Kingsmen Resources Ltd.", ticker: "TUMIF" },
    { name: "TRCK - Track Group, Inc.", ticker: "TRCK" },
    { name: "VRUS - VERUS INTERNATIONAL, INC.", ticker: "VRUS" },
    { name: "ASDN - Astro Aerospace Ltd.", ticker: "ASDN" },
    { name: "LSMG - Lode-Star Mining Inc.", ticker: "LSMG" },
    { name: "AVOI - Advanced Voice Recognition Systems, Inc", ticker: "AVOI" },
    { name: "LRTTF - LIBERTY ONE LITHIUM CORP", ticker: "LRTTF" },
    { name: "GAHC - Global Arena Holding, Inc.", ticker: "GAHC" },
    { name: "NRBT - Novus Robotics Inc.", ticker: "NRBT" },
    { name: "NRRWF - Nuran Wireless Inc.", ticker: "NRRWF" },
    { name: "BTDG - B2Digital, Inc.", ticker: "BTDG" },
    { name: "PHBI - Pharmagreen Biotech Inc.", ticker: "PHBI" },
    { name: "MDEX - Madison Technologies Inc.", ticker: "MDEX" },
    { name: "GSFI - Green Stream Holdings Inc.", ticker: "GSFI" },
    { name: "CIIT - Tianci International, Inc.", ticker: "CIIT" },
    { name: "HCGS - HighCom Global Security, Inc.", ticker: "HCGS" },
    { name: "ROYTL - Pacific Coast Oil Trust", ticker: "ROYTL" },
    { name: "CLCN - CREATIVE LEARNING Corp", ticker: "CLCN" },
    { name: "ALKM - ALKAME HOLDINGS, INC.", ticker: "ALKM" },
    { name: "ZDPY - Zoned Properties, Inc.", ticker: "ZDPY" },
    { name: "HRBR - HARBOR DIVERSIFIED, INC.", ticker: "HRBR" },
    { name: "GENH - Generation Hemp, Inc.", ticker: "GENH" },
    { name: "REPCF - REPLICEL LIFE SCIENCES INC.", ticker: "REPCF" },
    { name: "ARSN - Aureus Inc", ticker: "ARSN" },
    { name: "TLGT - Teligent, Inc.", ticker: "TLGT" },
    { name: "PLSI - Phoenix Life Sciences International Limited.", ticker: "PLSI" },
    { name: "NBIO - Nascent Biotech Inc.", ticker: "NBIO" },
    { name: "BABB - BAB, INC.", ticker: "BABB" },
    { name: "XLRM - XLR MEDICAL CORP.", ticker: "XLRM" },
    { name: "MGHL - MORGAN GROUP HOLDING CO", ticker: "MGHL" },
    { name: "ERVFF - ERIN VENTURES INC", ticker: "ERVFF" },
    { name: "ECPN - EL CAPITAN PRECIOUS METALS INC", ticker: "ECPN" },
    { name: "OWCP - OWC Pharmaceutical Research Corp.", ticker: "OWCP" },
    { name: "FLXT - FLEXPOINT SENSOR SYSTEMS INC", ticker: "FLXT" },
    { name: "VTLR - VirtualArmour International Inc.", ticker: "VTLR" },
    { name: "BORNY - CHINA NEW BORUN Corp", ticker: "BORNY" },
    { name: "SGBI - SANGUI BIOTECH INTERNATIONAL INC", ticker: "SGBI" },
    { name: "NXEN - NEXIEN BIOPHARMA, INC.", ticker: "NXEN" },
    { name: "SPGX - Sustainable Projects Group Inc.", ticker: "SPGX" },
    { name: "BSRC - BioSolar Inc", ticker: "BSRC" },
    { name: "AMBS - Amarantus Bioscience Holdings, Inc.", ticker: "AMBS" },
    { name: "IMCI - INFINITE GROUP INC", ticker: "IMCI" },
    { name: "AMPG - AmpliTech Group, Inc.", ticker: "AMPG" },
    { name: "STSN - Stemsation International, Inc.", ticker: "STSN" },
    { name: "WSML - Williamsville Sears Management, Inc.", ticker: "WSML" },
    { name: "SCGY - SCIENTIFIC ENERGY, INC", ticker: "SCGY" },
    { name: "TALN - TALON INTERNATIONAL, INC.", ticker: "TALN" },
    { name: "ARAO - AuraSource, Inc.", ticker: "ARAO" },
    { name: "CBNT - C-Bond Systems, Inc", ticker: "CBNT" },
    { name: "ACY - AEROCENTURY CORP", ticker: "ACY" },
    { name: "INNV - INNOVUS PHARMACEUTICALS, INC.", ticker: "INNV" },
    { name: "CHYL - China Senior Living Industry International Holding Corp", ticker: "CHYL" },
    { name: "ICCT - iCoreConnect Inc.", ticker: "ICCT" },
    { name: "PTZH - Photozou Holdings, Inc.", ticker: "PTZH" },
    { name: "NIMU - NON INVASIVE MONITORING SYSTEMS INC /FL/", ticker: "NIMU" },
    { name: "BOTH - BIOETHICS LTD", ticker: "BOTH" },
    { name: "MOJO - MOJO Organics, Inc.", ticker: "MOJO" },
    { name: "SCON - SUPERCONDUCTOR TECHNOLOGIES INC", ticker: "SCON" },
    { name: "MMMM - Quad M Solutions, Inc.", ticker: "MMMM" },
    { name: "QSMG - Quest Management Inc", ticker: "QSMG" },
    { name: "WIZP - Wize Pharma, Inc.", ticker: "WIZP" },
    { name: "TOWTF - TOWER ONE WIRELESS CORP.", ticker: "TOWTF" },
    { name: "SNNN - Sinorama Corp", ticker: "SNNN" },
    { name: "AVPMF - AVRUPA MINERALS LTD.", ticker: "AVPMF" },
    { name: "AMTY - AMERITYRE CORP", ticker: "AMTY" },
    { name: "RDGA - RIDGEFIELD ACQUISITION CORP", ticker: "RDGA" },
    { name: "SRGZ - Star Gold Corp.", ticker: "SRGZ" },
    { name: "HLBYL - Heron Lake BioEnergy, LLC", ticker: "HLBYL" },
    { name: "ANFIF - Amira Nature Foods Ltd.", ticker: "ANFIF" },
    { name: "APPB - Applied BioSciences Corp.", ticker: "APPB" },
    { name: "AMMJ - American Cannabis Company, Inc.", ticker: "AMMJ" },
    { name: "EXNN - EXENT CORP.", ticker: "EXNN" },
    { name: "DBMM - Digital Brand Media & Marketing Group, Inc.", ticker: "DBMM" },
    { name: "PMPG - Premier Product Group, Inc.", ticker: "PMPG" },
    { name: "TRNX - BBHC, INC.", ticker: "TRNX" },
    { name: "WIZD - WIZARD BRANDS, INC.", ticker: "WIZD" },
    { name: "MILC - Millennium Investment & Acquisition Co Inc.", ticker: "MILC" },
    { name: "MGHCF - MINCO GOLD CORP", ticker: "MGHCF" },
    { name: "RSSV - Resort Savers, Inc.", ticker: "RSSV" },
    { name: "CVAT - Cavitation Technologies, Inc.", ticker: "CVAT" },
    { name: "UMHL - Umatrin Holding Ltd", ticker: "UMHL" },
    { name: "FPFI - FRESH PROMISE FOODS, INC.", ticker: "FPFI" },
    { name: "DGJI - DRAGON JADE INTERNATIONAL LTD", ticker: "DGJI" },
    { name: "SNRG - SusGlobal Energy Corp.", ticker: "SNRG" },
    { name: "NOVC - NOVATION COMPANIES, INC.", ticker: "NOVC" },
    { name: "SOAN - AngioSoma, Inc.", ticker: "SOAN" },
    { name: "CRGS - CurAegis Technologies, Inc.", ticker: "CRGS" },
    { name: "RLLY - ARC Group, Inc.", ticker: "RLLY" },
    { name: "TIKRF - TIKCRO TECHNOLOGIES LTD", ticker: "TIKRF" },
    { name: "VSTR - ValueSetters Inc.", ticker: "VSTR" },
    { name: "BCTXF - BriaCell Therapeutics Corp.", ticker: "BCTXF" },
    { name: "VNUE - VNUE, Inc.", ticker: "VNUE" },
    { name: "REMI - REMEDENT, INC.", ticker: "REMI" },
    { name: "GLFH - Galenfeha, Inc.", ticker: "GLFH" },
    { name: "CAPC - CAPSTONE COMPANIES, INC.", ticker: "CAPC" },
    { name: "CNMXF - CANAMEX GOLD CORP.", ticker: "CNMXF" },
    { name: "GSRX - GSRX INDUSTRIES INC.", ticker: "GSRX" },
    { name: "IDFB - Idaho First Bank", ticker: "IDFB" },
    { name: "WEWA - WEWARDS, INC.", ticker: "WEWA" },
    { name: "RHE - REGIONAL HEALTH PROPERTIES, INC", ticker: "RHE" },
    { name: "USRM - U.S. Stem Cell, Inc.", ticker: "USRM" },
    { name: "CRBO - Carbon Energy Corp", ticker: "CRBO" },
    { name: "IPICQ - iPic Entertainment Inc.", ticker: "IPICQ" },
    { name: "ZZLL - ZZLL INFORMATION TECHNOLOGY, INC", ticker: "ZZLL" },
    { name: "QPRC - QUEST PATENT RESEARCH CORP", ticker: "QPRC" },
    { name: "CPPXF - CONTINENTAL ENERGY CORP", ticker: "CPPXF" },
    { name: "FIND - FINDEX COM INC", ticker: "FIND" },
    { name: "EXDI - Exactus, Inc.", ticker: "EXDI" },
    { name: "MITI - Mitesco, Inc.", ticker: "MITI" },
    { name: "PCYN - PROCYON CORP", ticker: "PCYN" },
    { name: "IGPK - Integrated Cannabis Solutions, Inc.", ticker: "IGPK" },
    { name: "APOP - Cellect Biotechnology Ltd.", ticker: "APOP" },
    { name: "FSSN - FISION Corp", ticker: "FSSN" },
    { name: "TKOI - TELKONET INC", ticker: "TKOI" },
    { name: "BEGI - BLACKSTAR ENTERPRISE GROUP, INC.", ticker: "BEGI" },
    { name: "BITTF - BITTERROOT RESOURCES LTD", ticker: "BITTF" },
    { name: "AFH - Atlas Financial Holdings, Inc.", ticker: "AFH" },
    { name: "PRTT - PROTECT PHARMACEUTICAL Corp", ticker: "PRTT" },
    { name: "ILCC - INTERNATIONAL LEADERS CAPITAL Corp", ticker: "ILCC" },
    { name: "NMEX - NORTHERN MINERALS & EXPLORATION LTD.", ticker: "NMEX" },
    { name: "SMGI - SMG Industries Inc.", ticker: "SMGI" },
    { name: "FLCX - flooidCX Corp.", ticker: "FLCX" },
    { name: "LIVC - Live Current Media Inc.", ticker: "LIVC" },
    { name: "ITKG - INTEGRAL TECHNOLOGIES INC", ticker: "ITKG" },
    { name: "WSCO - Wall Street Media Co, Inc.", ticker: "WSCO" },
    { name: "MTWD - METWOOD INC", ticker: "MTWD" },
    { name: "AURX - Nuo Therapeutics, Inc.", ticker: "AURX" },
    { name: "ATDS - Data443 Risk Mitigation, Inc.", ticker: "ATDS" },
    { name: "HSCHF - H-SOURCE HOLDINGS LTD.", ticker: "HSCHF" },
    { name: "WHSI - WEARABLE HEALTH SOLUTIONS, INC.", ticker: "WHSI" },
    { name: "SRUS - STRATUS CAPITAL CORP", ticker: "SRUS" },
    { name: "ETFM - FOMO CORP.", ticker: "ETFM" },
    { name: "PSSR - PASSUR Aerospace, Inc.", ticker: "PSSR" },
    { name: "BSPK - Bespoke Extracts, Inc.", ticker: "BSPK" },
    { name: "BEAG - BLUE EAGLE LITHIUM INC.", ticker: "BEAG" },
    { name: "VRSCF - VALTERRA RESOURCE CORP", ticker: "VRSCF" },
    { name: "CSUI - CANNABIS SUISSE CORP.", ticker: "CSUI" },
    { name: "CCTC - Clean Coal Technologies Inc.", ticker: "CCTC" },
    { name: "REAC - REAC GROUP, INC.", ticker: "REAC" },
    { name: "GLTC - GelTech Solutions, Inc.", ticker: "GLTC" },
    { name: "GRVE - GROOVE BOTANICALS INC.", ticker: "GRVE" },
    { name: "ABVN - ABV CONSULTING, INC.", ticker: "ABVN" },
    { name: "ANDR - ANDREA ELECTRONICS CORP", ticker: "ANDR" },
    { name: "KTEL - KonaTel, Inc.", ticker: "KTEL" },
    { name: "RSPI - RespireRx Pharmaceuticals Inc.", ticker: "RSPI" },
    { name: "RAHGF - Roan Holdings Group Co., Ltd.", ticker: "RAHGF" },
    { name: "FULO - FULLNET COMMUNICATIONS INC", ticker: "FULO" },
    { name: "ISGN - iSign Solutions Inc.", ticker: "ISGN" },
    { name: "IMAHF - I-Minerals Inc", ticker: "IMAHF" },
    { name: "PESXQ - PIONEER ENERGY SERVICES CORP", ticker: "PESXQ" },
    { name: "AMSU - AMANASU ENVIRONMENT CORP", ticker: "AMSU" },
    { name: "USNU - U.S. NeuroSurgical Holdings, Inc.", ticker: "USNU" },
    { name: "KOAN - Resonate Blends, Inc.", ticker: "KOAN" },
    { name: "ASTI - Ascent Solar Technologies, Inc.", ticker: "ASTI" },
    { name: "INTV - INTEGRATED VENTURES, INC.", ticker: "INTV" },
    { name: "GULTU - Gulf Coast Ultra Deep Royalty Trust", ticker: "GULTU" },
    { name: "VEII - Value Exchange International, Inc.", ticker: "VEII" },
    { name: "MSLP - MusclePharm Corp", ticker: "MSLP" },
    { name: "RMES - RED METAL RESOURCES, LTD.", ticker: "RMES" },
    { name: "TRLFF - True Leaf Brands Inc.", ticker: "TRLFF" },
    { name: "OBTX - OBITX, Inc.", ticker: "OBTX" },
    { name: "SKAS - Saker Aviation Services, Inc.", ticker: "SKAS" },
    { name: "TNLX - TRANS LUX Corp", ticker: "TNLX" },
    { name: "QNTA - QUANTA INC", ticker: "QNTA" },
    { name: "NXMR - NextMart Inc.", ticker: "NXMR" },
    { name: "NPHC - NUTRA PHARMA CORP", ticker: "NPHC" },
    { name: "LITH - U.S. Lithium Corp.", ticker: "LITH" },
    { name: "SAML - Samsara Luggage, Inc.", ticker: "SAML" },
    { name: "LMDCF - LINGO MEDIA CORP", ticker: "LMDCF" },
    { name: "CANB - Can B Corp", ticker: "CANB" },
    { name: "AWSM - Simply, Inc.", ticker: "AWSM" },
    { name: "HLTY - PreCheck Health Services, Inc.", ticker: "HLTY" },
    { name: "ALTD - ALTITUDE INTERNATIONAL HOLDINGS, INC.", ticker: "ALTD" },
    { name: "GBBT - Global Boatworks Holdings, Inc.", ticker: "GBBT" },
    { name: "AIVI - Kemiao Garment Holding Group", ticker: "AIVI" },
    { name: "FPVD - Force Protection Video Equipment Corp.", ticker: "FPVD" },
    { name: "FSNR - FREESTONE RESOURCES, INC.", ticker: "FSNR" },
    { name: "GTCH - GBT Technologies Inc.", ticker: "GTCH" },
    { name: "SODE - SOCIAL DETENTION INC.", ticker: "SODE" },
    { name: "RGUS - REGI U S INC", ticker: "RGUS" },
    { name: "BANM - Banner Energy Services Corp.", ticker: "BANM" },
    { name: "HCYT - H-CYTE, INC.", ticker: "HCYT" },
    { name: "MNTR - Mentor Capital, Inc.", ticker: "MNTR" },
    { name: "CCOB - Century Cobalt Corp.", ticker: "CCOB" },
    { name: "TNRG - Thunder Energies Corp", ticker: "TNRG" },
    { name: "BQST - Bioquest Corp", ticker: "BQST" },
    { name: "BUUZ - CalEthos, Inc.", ticker: "BUUZ" },
    { name: "EWLL - eWELLNESS HEALTHCARE Corp", ticker: "EWLL" },
    { name: "AHNR - ATHENA SILVER CORP", ticker: "AHNR" },
    { name: "IVITF - Invictus MD Strategies Corp.", ticker: "IVITF" },
    { name: "SFIV - Sector 5, Inc.", ticker: "SFIV" },
    { name: "TDNT - Trident Brands Inc", ticker: "TDNT" },
    { name: "CDXI - CARDAX, INC.", ticker: "CDXI" },
    { name: "WTXR - West Texas Resources, Inc.", ticker: "WTXR" },
    { name: "PROP - PLEDGE PETROLEUM CORP", ticker: "PROP" },
    { name: "EQUR - E-Qure Corp.", ticker: "EQUR" },
    { name: "TRPXY - Therapix Biosciences Ltd.", ticker: "TRPXY" },
    { name: "SRCO - SPARTA COMMERCIAL SERVICES, INC.", ticker: "SRCO" },
    { name: "TAPM - Tapinator, Inc.", ticker: "TAPM" },
    { name: "CLUBQ - TOWN SPORTS INTERNATIONAL HOLDINGS INC", ticker: "CLUBQ" },
    { name: "ATMS - Artemis Therapeutics, Inc.", ticker: "ATMS" },
    { name: "CBGL - CANNABIS GLOBAL, INC.", ticker: "CBGL" },
    { name: "KWBT - KIWA BIO-TECH PRODUCTS GROUP CORP", ticker: "KWBT" },
    { name: "CNGT - Cannagistics Inc.", ticker: "CNGT" },
    { name: "VPRB - VPR Brands, LP.", ticker: "VPRB" },
    { name: "GSIH - GENERAL STEEL HOLDINGS INC", ticker: "GSIH" },
    { name: "HPTY - Hemp Technology, Inc.", ticker: "HPTY" },
    { name: "VRTC - VERITEC INC", ticker: "VRTC" },
    { name: "LFAP - LGBTQ Loyalty Holdings, Inc.", ticker: "LFAP" },
    { name: "PTSC - PATRIOT SCIENTIFIC CORP", ticker: "PTSC" },
    { name: "CICN - CICERO INC", ticker: "CICN" },
    { name: "IFNY - INFINITY ENERGY RESOURCES, INC", ticker: "IFNY" },
    { name: "DHCC - DIAMONDHEAD CASINO CORP", ticker: "DHCC" },
    { name: "RDCO - Redefy Corp", ticker: "RDCO" },
    { name: "ABILF - Ability Inc.", ticker: "ABILF" },
    { name: "KPAY - KinerjaPay Corp.", ticker: "KPAY" },
    { name: "NTWN - NEWTOWN LANE MARKETING INC", ticker: "NTWN" },
    { name: "GLAE - GlassBridge Enterprises, Inc.", ticker: "GLAE" },
    { name: "IMII - INCEPTION MINING INC.", ticker: "IMII" },
    { name: "RGIN - Regenicin, Inc.", ticker: "RGIN" },
    { name: "VRDR - VERDE RESOURCES, INC.", ticker: "VRDR" },
    { name: "NIHK - Video River Networks, Inc.", ticker: "NIHK" },
    { name: "TKCI - TurnKey Capital, Inc.", ticker: "TKCI" },
    { name: "WHZT - Whiting USA Trust II", ticker: "WHZT" },
    { name: "ARET - ARETE INDUSTRIES INC", ticker: "ARET" },
    { name: "GFOO - Genufood Energy Enzymes Corp.", ticker: "GFOO" },
    { name: "ETCK - ENERTECK CORP", ticker: "ETCK" },
    { name: "BHLL - Bunker Hill Mining Corp.", ticker: "BHLL" },
    { name: "DREM - Dream Homes & Development Corp.", ticker: "DREM" },
    { name: "ACMC - AMERICAN CHURCH MORTGAGE CO", ticker: "ACMC" },
    { name: "AEGG - AMERICAN ENERGY GROUP LTD", ticker: "AEGG" },
    { name: "BRST - Broad Street Realty, Inc.", ticker: "BRST" },
    { name: "FRZT - Freeze Tag, Inc.", ticker: "FRZT" },
    { name: "DGWR - Deep Green Waste & Recycling, Inc.", ticker: "DGWR" },
    { name: "ESSI - ECO SCIENCE SOLUTIONS, INC.", ticker: "ESSI" },
    { name: "SHNL - Shentang International, Inc.", ticker: "SHNL" },
    { name: "WOLV - Wolverine Technologies Corp.", ticker: "WOLV" },
    { name: "MMEX - MMEX Resources Corp", ticker: "MMEX" },
    { name: "VSPC - VIASPACE Inc.", ticker: "VSPC" },
    { name: "KGJI - KINGOLD JEWELRY, INC.", ticker: "KGJI" },
    { name: "SDLPF - Seadrill Partners LLC", ticker: "SDLPF" },
    { name: "MDFZF - Medifocus Inc.", ticker: "MDFZF" },
    { name: "PPCB - Propanc Biopharma, Inc.", ticker: "PPCB" },
    { name: "ELST - ELECTRONIC SYSTEMS TECHNOLOGY INC", ticker: "ELST" },
    { name: "NUVG - Nuvus Gro Corp", ticker: "NUVG" },
    { name: "BRVO - Bravo Multinational Inc.", ticker: "BRVO" },
    { name: "IRCC - Indigenous Roots Corp.", ticker: "IRCC" },
    { name: "PTCO - PetroGas Co", ticker: "PTCO" },
    { name: "AITX - Artificial Intelligence Technology Solutions Inc.", ticker: "AITX" },
    { name: "SBES - South Beach Spirits, Inc.", ticker: "SBES" },
    { name: "MCOA - Marijuana Co of America, Inc.", ticker: "MCOA" },
    { name: "SKLV - SKYE LIFE VENTURES LTD.", ticker: "SKLV" },
    { name: "NEIK - NORTHSTAR ELECTRONICS INC", ticker: "NEIK" },
    { name: "VISM - VISIUM TECHNOLOGIES, INC.", ticker: "VISM" },
    { name: "ALYE - Aly Energy Services, Inc.", ticker: "ALYE" },
    { name: "SNPW - Sun Pacific Holding Corp.", ticker: "SNPW" },
    { name: "LVBX - LevelBlox, Inc.", ticker: "LVBX" },
    { name: "NTRR - NEUTRA CORP.", ticker: "NTRR" },
    { name: "TRXO - T-REX OIL, INC.", ticker: "TRXO" },
    { name: "LVWD - LIVEWORLD, INC.", ticker: "LVWD" },
    { name: "ENDV - ENDONOVO THERAPEUTICS, INC.", ticker: "ENDV" },
    { name: "DIGAF - Digatrade Financial Corp", ticker: "DIGAF" },
    { name: "MFCO - MICROWAVE FILTER CO INC /NY/", ticker: "MFCO" },
    { name: "AIKO - Alternative Investment Corp", ticker: "AIKO" },
    { name: "JRVS - iMine Corp", ticker: "JRVS" },
    { name: "HCCC - VISION HYDROGEN Corp", ticker: "HCCC" },
    { name: "ECMT - ECOMAT INC", ticker: "ECMT" },
    { name: "ACCA - Acacia Diversified Holdings, Inc.", ticker: "ACCA" },
    { name: "FRLI - Frelii, Inc.", ticker: "FRLI" },
    { name: "EMRN - EMARINE GLOBAL INC.", ticker: "EMRN" },
    { name: "GTXO - GTX CORP", ticker: "GTXO" },
    { name: "CIIX - Chineseinvestors.com, Inc.", ticker: "CIIX" },
    { name: "BANT - Bantec, Inc.", ticker: "BANT" },
    { name: "AMNL - Applied Minerals, Inc.", ticker: "AMNL" },
    { name: "ITOX - IIOT-OXYS, Inc.", ticker: "ITOX" },
    { name: "BMIX - Brazil Minerals, Inc.", ticker: "BMIX" },
    { name: "CHMJF - Chemistree Technology Inc.", ticker: "CHMJF" },
    { name: "DLOC - Digital Locations, Inc.", ticker: "DLOC" },
    { name: "BLXX - Blox, Inc.", ticker: "BLXX" },
    { name: "BIEI - PREMIER BIOMEDICAL INC", ticker: "BIEI" },
    { name: "STCC - STERLING CONSOLIDATED Corp", ticker: "STCC" },
    { name: "PGAS - PETROGRESS, INC", ticker: "PGAS" },
    { name: "ECOS - ECOLOCAP SOLUTIONS INC.", ticker: "ECOS" },
    { name: "GNAL - Generation Alpha, Inc.", ticker: "GNAL" },
    { name: "CNTFY - China Techfaith Wireless Communication Technology LTD", ticker: "CNTFY" },
    { name: "GTHR - GENETHERA INC", ticker: "GTHR" },
    { name: "AREXQ - Approach Resources Inc", ticker: "AREXQ" },
    { name: "BYIN - Baying Ecological Holding Group Inc.", ticker: "BYIN" },
    { name: "SEDO - SEEDO CORP.", ticker: "SEDO" },
    { name: "GTVI - Joway Health Industries Group Inc", ticker: "GTVI" },
    { name: "ETST - Earth Science Tech, Inc.", ticker: "ETST" },
    { name: "CWRK - CurrencyWorks Inc.", ticker: "CWRK" },
    { name: "MSRT - MassRoots, Inc.", ticker: "MSRT" },
    { name: "FCIC - FCCC INC", ticker: "FCIC" },
    { name: "ARGQ - ARGENTUM 47, INC.", ticker: "ARGQ" },
    { name: "SPIN - Spine Injury Solutions, Inc", ticker: "SPIN" },
    { name: "AASP - ALL AMERICAN SPORTPARK INC", ticker: "AASP" },
    { name: "MCCX - MCX Technologies Corp", ticker: "MCCX" },
    { name: "ASKH - ASTIKA HOLDINGS INC.", ticker: "ASKH" },
    { name: "ESMC - ESCALON MEDICAL CORP", ticker: "ESMC" },
    { name: "ALTX - ALTEX INDUSTRIES INC", ticker: "ALTX" },
    { name: "NGBL - Notis Global, Inc.", ticker: "NGBL" },
    { name: "ITDN - INTERDYNE CO", ticker: "ITDN" },
    { name: "STQN - STRATEGIC ACQUISITIONS INC /NV/", ticker: "STQN" },
    { name: "CDTI - CDTI ADVANCED MATERIALS, INC.", ticker: "CDTI" },
    { name: "QPWR - Q2Earth Inc.", ticker: "QPWR" },
    { name: "DIGP - Digipath, Inc.", ticker: "DIGP" },
    { name: "MLFB - MAJOR LEAGUE FOOTBALL INC", ticker: "MLFB" },
    { name: "SKYL - SKY RESORT INTERNATIONAL Ltd", ticker: "SKYL" },
    { name: "INKW - Greene Concepts, Inc", ticker: "INKW" },
    { name: "LEAI - Legacy Education Alliance, Inc.", ticker: "LEAI" },
    { name: "RAYT - RAYONT, INC.", ticker: "RAYT" },
    { name: "BLAB - BIO LAB NATURALS, INC.", ticker: "BLAB" },
    { name: "VBHI - VERDE BIO HOLDINGS, INC.", ticker: "VBHI" },
    { name: "BTHE - Boston Therapeutics, Inc.", ticker: "BTHE" },
    { name: "IHSI - Intelligent Highway Solutions, Inc.", ticker: "IHSI" },
    { name: "THCT - THC Therapeutics, Inc.", ticker: "THCT" },
    { name: "ACCR - Access-Power & Co., Inc.", ticker: "ACCR" },
    { name: "TXSO - Texas South Energy, Inc.", ticker: "TXSO" },
    { name: "ATRX - Adhera Therapeutics, Inc.", ticker: "ATRX" },
    { name: "PHIL - PHI GROUP INC", ticker: "PHIL" },
    { name: "JPOTF - Jackpot Digital Inc.", ticker: "JPOTF" },
    { name: "GNTOF - GENTOR RESOURCES INC.", ticker: "GNTOF" },
    { name: "TEGY - TRANSACT ENERGY CORP", ticker: "TEGY" },
    { name: "BSTN - Boston Carriers, Inc.", ticker: "BSTN" },
    { name: "SDON - SANDSTON CORP", ticker: "SDON" },
    { name: "MVES - MOVIE STUDIO, INC.", ticker: "MVES" },
    { name: "ALDA - ATLANTICA INC", ticker: "ALDA" },
    { name: "DXIEF - DXI Energy Inc.", ticker: "DXIEF" },
    { name: "OMTK - Omnitek Engineering Corp", ticker: "OMTK" },
    { name: "TGHI - Touchpoint Group Holdings Inc.", ticker: "TGHI" },
    { name: "RYMM - ROYAL MINES & MINERALS CORP", ticker: "RYMM" },
    { name: "CELZ - CREATIVE MEDICAL TECHNOLOGY HOLDINGS, INC.", ticker: "CELZ" },
    { name: "CHGI - China Carbon Graphite Group, Inc.", ticker: "CHGI" },
    { name: "EZCL - Ezy Cloud Holding Inc.", ticker: "EZCL" },
    { name: "SFHI - SPORTS FIELD HOLDINGS, INC.", ticker: "SFHI" },
    { name: "RMSL - RemSleep Holdings Inc.", ticker: "RMSL" },
    { name: "NTPY - NetPay International Inc", ticker: "NTPY" },
    { name: "CLTH - CleanTech Biofuels, Inc.", ticker: "CLTH" },
    { name: "HMNY - Helios & Matheson Analytics Inc.", ticker: "HMNY" },
    { name: "PRHL - PREMIER HOLDING CORP.", ticker: "PRHL" },
    { name: "FSTJ - First America Resources Corp", ticker: "FSTJ" },
    { name: "DPWW - DIEGO PELLICER WORLDWIDE, INC", ticker: "DPWW" },
    { name: "SIML - Simlatus Corp", ticker: "SIML" },
    { name: "DCLT - Data Call Technologies", ticker: "DCLT" },
    { name: "ONCI - ON4 COMMUNICATIONS INC.", ticker: "ONCI" },
    { name: "ZMDC - USA Zhimingde International Group Corp", ticker: "ZMDC" },
    { name: "DVLP - Golden Developing Solutions, Inc.", ticker: "DVLP" },
    { name: "DLCR - Kibush Capital Corp", ticker: "DLCR" },
    { name: "KRBF - Kreido Biofuels, Inc.", ticker: "KRBF" },
    { name: "PGUS - Progreen US, Inc.", ticker: "PGUS" },
    { name: "PACV - Pacific Ventures Group, Inc.", ticker: "PACV" },
    { name: "FMHS - FARMHOUSE, INC. /NV", ticker: "FMHS" },
    { name: "GFMH - Goliath Film & Media Holdings", ticker: "GFMH" },
    { name: "NTCXF - Natcore Technology Inc.", ticker: "NTCXF" },
    { name: "XSNX - NovAccess Global Inc.", ticker: "XSNX" },
    { name: "DBRM - DAYBREAK OIL & GAS, INC.", ticker: "DBRM" },
    { name: "PYYX - PYXUS INTERNATIONAL, INC.", ticker: "PYYX" },
    { name: "MAGAA - MAGNA LAB INC", ticker: "MAGAA" },
    { name: "DBUB - DBUB GROUP, INC", ticker: "DBUB" },
    { name: "JFIL - Jubilant Flame International, Ltd", ticker: "JFIL" },
    { name: "ADSV - Allied Security Innovations, Inc.", ticker: "ADSV" },
    { name: "PSWW - Principal Solar, Inc.", ticker: "PSWW" },
    { name: "ABCE - ABCO Energy, Inc.", ticker: "ABCE" },
    { name: "LVXI - MAPTELLIGENT, INC.", ticker: "LVXI" },
    { name: "GLUC - Glucose Health, Inc.", ticker: "GLUC" },
    { name: "GMPW - GIVEMEPOWER CORP", ticker: "GMPW" },
    { name: "LRDC - Laredo Oil, Inc.", ticker: "LRDC" },
    { name: "EVIO - EVIO, INC.", ticker: "EVIO" },
    { name: "GHAV - GRAND HAVANA INC.", ticker: "GHAV" },
    { name: "MAXD - Max Sound Corp", ticker: "MAXD" },
    { name: "COIL - Citadel Exploration, Inc.", ticker: "COIL" },
    { name: "GMER - GOOD GAMING, INC.", ticker: "GMER" },
    { name: "TWGL - 20/20 Global, Inc.", ticker: "TWGL" },
    { name: "PTPF - ALL MARKETING SOLUTIONS, INC.", ticker: "PTPF" },
    { name: "AVRN - AVRA INC.", ticker: "AVRN" },
    { name: "OSAT - ORBSAT CORP", ticker: "OSAT" },
    { name: "OCLN - ORIGINCLEAR, INC.", ticker: "OCLN" },
    { name: "BDPT - BIOADAPTIVES, INC.", ticker: "BDPT" },
    { name: "NAFS - North America Frac Sand, Inc.", ticker: "NAFS" },
    { name: "BLIS - Treasure & Shipwreck Recovery, Inc.", ticker: "BLIS" },
    { name: "GBHL - Global Entertainment Holdings, Inc.", ticker: "GBHL" },
    { name: "ATIN - ATI Nationwide Holding Corp.", ticker: "ATIN" },
    { name: "WSCC - WATERSIDE CAPITAL CORP", ticker: "WSCC" },
    { name: "GEIN - Genesys Industries, Inc.", ticker: "GEIN" },
    { name: "SNNC - Sibannac, Inc.", ticker: "SNNC" },
    { name: "ESNC - EnSync, Inc.", ticker: "ESNC" },
    { name: "OOIL - Perkins Oil & Gas, Inc.", ticker: "OOIL" },
    { name: "AGHC - Aeon Global Health Corp.", ticker: "AGHC" },
    { name: "ANTH - Anthera Pharmaceuticals Inc", ticker: "ANTH" },
    { name: "ATPT - All State Properties Holdings, Inc.", ticker: "ATPT" },
    { name: "PAPA - W O Group, Inc.", ticker: "PAPA" },
    { name: "USDF - US-DADI FERTILIZER INDUSTRY INTERNATIONAL, INC.", ticker: "USDF" },
    { name: "MYDX - MyDx, Inc.", ticker: "MYDX" },
    { name: "EHVVF - Ehave, Inc.", ticker: "EHVVF" },
    { name: "HYBG - HYB Holding Corp.", ticker: "HYBG" },
    { name: "ATLT - Atlas Technology International, Inc.", ticker: "ATLT" },
    { name: "ADYX - Adynxx, Inc.", ticker: "ADYX" },
    { name: "VBIX - Viewbix Inc.", ticker: "VBIX" },
    { name: "IRNC - IRONCLAD ENCRYPTION Corp", ticker: "IRNC" },
    { name: "GRSO - GROW SOLUTIONS HOLDINGS, INC.", ticker: "GRSO" },
    { name: "ASNB - EKIMAS Corp", ticker: "ASNB" },
    { name: "EXNT - ENXNET INC", ticker: "EXNT" },
    { name: "SENY - SAUER ENERGY, INC.", ticker: "SENY" },
    { name: "FTXP - FOOTHILLS EXPLORATION, INC.", ticker: "FTXP" },
    { name: "JADG - Jade Global Holdings, Inc.", ticker: "JADG" },
    { name: "MTLK - METALINK LTD", ticker: "MTLK" },
    { name: "CYPW - CYCLONE POWER TECHNOLOGIES INC", ticker: "CYPW" },
    { name: "KRED - KonaRed Corp", ticker: "KRED" },
    { name: "SIGN - SIGNET INTERNATIONAL HOLDINGS, INC.", ticker: "SIGN" },
    { name: "MDIT - Medite Cancer Diagnostics, Inc.", ticker: "MDIT" },
    { name: "SYNE - SYNTHESIS ENERGY SYSTEMS INC", ticker: "SYNE" },
    { name: "ARRT - Artisan Consumer Goods, Inc.", ticker: "ARRT" },
    { name: "LFER - Life On Earth, Inc.", ticker: "LFER" },
    { name: "VEND - Generation NEXT Franchise Brands, Inc.", ticker: "VEND" },
    { name: "SKYF - Sky440, Inc.", ticker: "SKYF" },
    { name: "ZIMCF - ZIM CORP", ticker: "ZIMCF" },
    { name: "UCBB - US-China Biomedical Technology, Inc.", ticker: "UCBB" },
    { name: "SCIE - SPECTRASCIENCE INC", ticker: "SCIE" },
    { name: "ABWN - AIRBORNE WIRELESS NETWORK", ticker: "ABWN" },
    { name: "CCAN - CANADIAN CANNABIS CORP.", ticker: "CCAN" },
    { name: "TXHG - TX Holdings, Inc.", ticker: "TXHG" },
    { name: "SCRH - SCORES HOLDING CO INC", ticker: "SCRH" },
    { name: "TWOH - Two Hands Corp", ticker: "TWOH" },
    { name: "XDSL - MPHASE TECHNOLOGIES INC", ticker: "XDSL" },
    { name: "INVT - Inventergy Global, Inc.", ticker: "INVT" },
    { name: "ICLD - INTERCLOUD SYSTEMS, INC.", ticker: "ICLD" },
    { name: "ANSU - AMANASU TECHNO HOLDINGS CORP", ticker: "ANSU" },
    { name: "CNABQ - United Cannabis Corp", ticker: "CNABQ" },
    { name: "GPIW - Grand Perfecta, Inc.", ticker: "GPIW" },
    { name: "PRLE - PILLARSTONE CAPITAL REIT", ticker: "PRLE" },
    { name: "GDET - GD Entertainment & Technology, Inc.", ticker: "GDET" },
    { name: "SITOQ - SITO MOBILE, LTD.", ticker: "SITOQ" },
    { name: "GWSN - Gulf West Security Network, Inc.", ticker: "GWSN" },
    { name: "EVTN - ENVIRO TECHNOLOGIES, INC.", ticker: "EVTN" },
    { name: "SPHS - SOPHIRIS BIO INC.", ticker: "SPHS" },
    { name: "OMAG - Omagine, Inc.", ticker: "OMAG" },
    { name: "BDGY - BRIDGEWAY NATIONAL CORP.", ticker: "BDGY" },
    { name: "HHER - Her Imports", ticker: "HHER" },
    { name: "STLT - Spotlight Innovation Inc.", ticker: "STLT" },
    { name: "SSINQ - STAGE STORES INC", ticker: "SSINQ" },
    { name: "TBLZ - TRAILBLAZER RESOURCES INC.", ticker: "TBLZ" },
    { name: "DPLS - DarkPulse, Inc.", ticker: "DPLS" },
    { name: "POYN - Po Yuen Cultural Holdings (Hong Kong) Co., Ltd.", ticker: "POYN" },
    { name: "AMAZ - Amazing Energy Oil & Gas, Co.", ticker: "AMAZ" },
    { name: "ATVK - AMERITEK VENTURES", ticker: "ATVK" },
    { name: "CYBF - Cyberfort Software, Inc.", ticker: "CYBF" },
    { name: "EUENF - EURASIA ENERGY LTD", ticker: "EUENF" },
    { name: "XALL - Xalles Holdings Inc.", ticker: "XALL" },
    { name: "ZENO - ZENOSENSE, INC.", ticker: "ZENO" },
    { name: "HSTC - HST Global, Inc.", ticker: "HSTC" },
    { name: "GCAN - Greater Cannabis Company, Inc.", ticker: "GCAN" },
    { name: "DEVV - BIOSCIENCE NEUTRACEUTICALS, INC.", ticker: "DEVV" },
    { name: "FCCN - SPECTRAL CAPITAL Corp", ticker: "FCCN" },
    { name: "QZMRF - QUARTZ MOUNTAIN RESOURCES LTD", ticker: "QZMRF" },
    { name: "BLPG - Blue Line Protection Group, Inc.", ticker: "BLPG" },
    { name: "YBAO - YBCC, Inc.", ticker: "YBAO" },
    { name: "QTXB - QUANTRX BIOMEDICAL CORP", ticker: "QTXB" },
    { name: "CXBS - Corix Bioscience, Inc.", ticker: "CXBS" },
    { name: "MUSS - MULTI SOLUTIONS II, INC", ticker: "MUSS" },
    { name: "LCLP - Life Clips, Inc.", ticker: "LCLP" },
    { name: "BOXS - BOXSCORE BRANDS, INC.", ticker: "BOXS" },
    { name: "DTII - DEFENSE TECHNOLOGIES INTERNATIONAL CORP.", ticker: "DTII" },
    { name: "CZNI - Cruzani, Inc.", ticker: "CZNI" },
    { name: "EVCC - ENVIRONMENTAL CONTROL CORP.", ticker: "EVCC" },
    { name: "AOXY - ADVANCED OXYGEN TECHNOLOGIES INC", ticker: "AOXY" },
    { name: "OBMP - THERALINK TECHNOLOGIES, INC.", ticker: "OBMP" },
    { name: "SPUP - Sipup Corp", ticker: "SPUP" },
    { name: "AHIX - ALUF HOLDINGS, INC.", ticker: "AHIX" },
    { name: "USBL - UNITED STATES BASKETBALL LEAGUE INC", ticker: "USBL" },
    { name: "RGSEQ - Real Goods Solar, Inc.", ticker: "RGSEQ" },
    { name: "VCBD - Vitalibis, Inc.", ticker: "VCBD" },
    { name: "GMVP - GridIron BioNutrients, Inc.", ticker: "GMVP" },
    { name: "INND - INNERSCOPE HEARING TECHNOLOGIES, INC.", ticker: "INND" },
    { name: "WCVC - WEST COAST VENTURES GROUP CORP.", ticker: "WCVC" },
    { name: "CIRX - CIRTRAN CORP", ticker: "CIRX" },
    { name: "VICA - Rafina Innovations Inc.", ticker: "VICA" },
    { name: "IMTL - IMAGE PROTECT, INC.", ticker: "IMTL" },
    { name: "ETNI - ENTEST GROUP, INC.", ticker: "ETNI" },
    { name: "VIBI - Vilacto Bio Inc.", ticker: "VIBI" },
    { name: "ECOX - ECO INNOVATION GROUP, INC.", ticker: "ECOX" },
    { name: "DSOX - Triton Emission Solutions Inc.", ticker: "DSOX" },
    { name: "PXPP - Phoenix Apps Inc.", ticker: "PXPP" },
    { name: "CXKJ - CX Network Group, Inc.", ticker: "CXKJ" },
    { name: "BLGI - BLGI, INC.", ticker: "BLGI" },
    { name: "GLPH - Gala Pharmaceutical Inc.", ticker: "GLPH" },
    { name: "CBDEF - BlueNRGY Group Ltd", ticker: "CBDEF" },
    { name: "SPOWF - Strata Power Corp", ticker: "SPOWF" },
    { name: "AVNI - ARVANA INC", ticker: "AVNI" },
    { name: "OPTI - Optec International, Inc.", ticker: "OPTI" },
    { name: "DKGH - DKG Capital Inc.", ticker: "DKGH" },
    { name: "HLWD - Almost Never Films Inc.", ticker: "HLWD" },
    { name: "PASO - Patient Access Solutions, Inc.", ticker: "PASO" },
    { name: "EOPT - Eos Petro, Inc.", ticker: "EOPT" },
    { name: "LGYV - LEGACY VENTURES INTERNATIONAL INC.", ticker: "LGYV" },
    { name: "NDMT - NowNews Digital Media Technology Co. Ltd.", ticker: "NDMT" },
    { name: "BRTI - BlackRidge Technology International, Inc.", ticker: "BRTI" },
    { name: "GBGD - GLOBAL GOLD CORP", ticker: "GBGD" },
    { name: "GMEV - GME INNOTAINMENT, INC.", ticker: "GMEV" },
    { name: "FRFR - Fritzy Tech Inc.", ticker: "FRFR" },
    { name: "RNVA - Rennova Health, Inc.", ticker: "RNVA" },
    { name: "VMHG - VICTORY MARINE HOLDINGS CORP", ticker: "VMHG" },
    { name: "HHHEF - 37 CAPITAL INC", ticker: "HHHEF" },
    { name: "FDBL - Friendable, Inc.", ticker: "FDBL" },
    { name: "LQWC - LIFEQUEST WORLD CORP.", ticker: "LQWC" },
    { name: "PVEG - PACIFIC VEGAS GLOBAL STRATEGIES INC", ticker: "PVEG" },
    { name: "AGTK - AGRITEK HOLDINGS, INC.", ticker: "AGTK" },
    { name: "SIGO - Sunset Island Group", ticker: "SIGO" },
    { name: "NHMD - Nate's Food Co.", ticker: "NHMD" },
    { name: "VCPS - VinCompass Corp.", ticker: "VCPS" },
    { name: "EVARF - Lombard Medical, Inc.", ticker: "EVARF" },
    { name: "PRZM - Prism Technologies Group, Inc.", ticker: "PRZM" },
    { name: "NEXS - NEXUS BIOPHARMA INC", ticker: "NEXS" },
    { name: "WDLF - Social Life Network, Inc.", ticker: "WDLF" },
    { name: "GHHC - GH Capital Inc.", ticker: "GHHC" },
    { name: "HMPQ - HempAmericana, Inc.", ticker: "HMPQ" },
    { name: "MXSG - Mexus Gold US", ticker: "MXSG" },
    { name: "MJTK - CANNASYS INC", ticker: "MJTK" },
    { name: "CURM - CUR MEDIA, INC.", ticker: "CURM" },
    { name: "ASCK - AUSCRETE Corp", ticker: "ASCK" },
    { name: "SKVI - SKINVISIBLE, INC.", ticker: "SKVI" },
    { name: "CNCT - China Teletech Holding Inc", ticker: "CNCT" },
    { name: "RBZHF - Reebonz Holding Ltd", ticker: "RBZHF" },
    { name: "KDCE - KID CASTLE EDUCATIONAL CORP", ticker: "KDCE" },
    { name: "BSPM - Biostar Pharmaceuticals, Inc.", ticker: "BSPM" },
    { name: "RZZN - Jialijia Group Corp Ltd", ticker: "RZZN" },
    { name: "MYDP - Dougherty's Pharmacy, Inc.", ticker: "MYDP" },
    { name: "INFX - INFINEX VENTURES INC", ticker: "INFX" },
    { name: "RGBP - Regen BioPharma Inc", ticker: "RGBP" },
    { name: "KONAQ - KONA GRILL INC", ticker: "KONAQ" },
    { name: "BISA - BALTIC INTERNATIONAL USA INC", ticker: "BISA" },
    { name: "CPFH - Capital Financial Holdings, Inc", ticker: "CPFH" },
    { name: "TWER - TOWERSTREAM CORP", ticker: "TWER" },
    { name: "CLKA - Clikia Corp.", ticker: "CLKA" },
    { name: "HCMC - Healthier Choices Management Corp.", ticker: "HCMC" },
    { name: "DESTQ - Destination Maternity Corp", ticker: "DESTQ" },
    { name: "ICNN - Incoming, Inc.", ticker: "ICNN" },
    { name: "WODI - WOD Retail Solutions, Inc.", ticker: "WODI" },
    { name: "BOTY - LINGERIE FIGHTING CHAMPIONSHIPS, INC.", ticker: "BOTY" },
    { name: "VAPE - Vape Holdings, Inc.", ticker: "VAPE" },
    { name: "FTWS - Flitways Technology Inc.", ticker: "FTWS" },
    { name: "GROG - GroGenesis, Inc.", ticker: "GROG" },
    { name: "MIHI - MEDICAL INNOVATION HOLDINGS, INC.", ticker: "MIHI" },
    { name: "ENCR - Ener-Core, Inc.", ticker: "ENCR" },
    { name: "WBSI - WebSafety, Inc.", ticker: "WBSI" },
    { name: "GNTW - Globe Net Wireless Corp.", ticker: "GNTW" },
    { name: "SYSX - Sysorex, Inc.", ticker: "SYSX" },
    { name: "RTON - Right On Brands, Inc.", ticker: "RTON" },
    { name: "SSET - STARSTREAM ENTERTAINMENT, INC.", ticker: "SSET" },
    { name: "ISRB - Inspired Builders, Inc.", ticker: "ISRB" },
    { name: "ESPH - ECOSPHERE TECHNOLOGIES INC", ticker: "ESPH" },
    { name: "ETAH - ETERNITY HEALTHCARE INC.", ticker: "ETAH" },
    { name: "BRGO - Bergio International, Inc.", ticker: "BRGO" },
    { name: "WESC - W&E Source Corp.", ticker: "WESC" },
    { name: "CXCQ - CARDXX INC", ticker: "CXCQ" },
    { name: "AGGG - ANTILIA GROUP, CORP.", ticker: "AGGG" },
    { name: "IFXY - INFRAX SYSTEMS, INC.", ticker: "IFXY" },
    { name: "MJTV - MJ BIOTECH, INC.", ticker: "MJTV" },
    { name: "AITA - WUNONG ASIA PACIFIC Co Ltd", ticker: "AITA" },
    { name: "LOGQ - Logicquest Technology, Inc.", ticker: "LOGQ" },
    { name: "VNTH - Nano Mobile Healthcare, Inc.", ticker: "VNTH" },
    { name: "NRTSF - Nobilis Health Corp.", ticker: "NRTSF" },
    { name: "CSHEF - CHINA ENTERPRISES LTD", ticker: "CSHEF" },
    { name: "ORGH - OrgHarvest, Inc.", ticker: "ORGH" },
    { name: "RLBD - Real Brands, Inc.", ticker: "RLBD" },
    { name: "GIGL - Giggles N' Hugs, Inc.", ticker: "GIGL" },
    { name: "BRLL - Barrel Energy Inc.", ticker: "BRLL" },
    { name: "MGPC - Moregain Pictures, Inc.", ticker: "MGPC" },
    { name: "BNGI - BANGI INC.", ticker: "BNGI" },
    { name: "BZRD - Blubuzzard, Inc.", ticker: "BZRD" },
    { name: "SGSI - Spectrum Global Solutions, Inc.", ticker: "SGSI" },
    { name: "RIVX - RIVEX TECHNOLOGY CORP.", ticker: "RIVX" },
    { name: "COGLF - CHELSEA OIL & GAS LTD.", ticker: "COGLF" },
    { name: "GLBS - GLOBUS MARITIME LTD", ticker: "GLBS" },
    { name: "NSPX - Inspyr Therapeutics, Inc.", ticker: "NSPX" },
    { name: "CXUS - Celexus, Inc", ticker: "CXUS" },
    { name: "ACNV - ACCELERA INNOVATIONS, INC.", ticker: "ACNV" },
    { name: "DRSV - DEBT RESOLVE INC", ticker: "DRSV" },
    { name: "RETC - 12 Retech Corp", ticker: "RETC" },
    { name: "AFOM - ALL FOR ONE MEDIA CORP.", ticker: "AFOM" },
    { name: "ICTV - ICTV Brands Inc.", ticker: "ICTV" },
    { name: "WLBAQ - WESTMORELAND COAL Co", ticker: "WLBAQ" },
    { name: "NGRP - NGEN TECHNOLOGIES HOLDINGS CORP.", ticker: "NGRP" },
    { name: "SCGX - SAXON CAPITAL GROUP INC", ticker: "SCGX" },
    { name: "AXPWQ - Axion Power International, Inc.", ticker: "AXPWQ" },
    { name: "MEDH - MedX Holdings, Inc.", ticker: "MEDH" },
    { name: "MSSV - MESO NUMISMATICS, INC.", ticker: "MSSV" },
    { name: "UNRG - UNITED ENERGY CORP /NV/", ticker: "UNRG" },
    { name: "YGTYF - SSLJ. COM Ltd", ticker: "YGTYF" },
    { name: "STRZ - STAR BUFFET INC", ticker: "STRZ" },
    { name: "PACQF - PRIME ACQUISITION CORP", ticker: "PACQF" },
    { name: "CGLD - Buscar Co", ticker: "CGLD" },
    { name: "BFRE - Bluefire Renewables, Inc.", ticker: "BFRE" },
    { name: "CWSS - Creative Waste Solutions, Inc.", ticker: "CWSS" },
    { name: "ELTZ - ELITE GROUP INC.", ticker: "ELTZ" },
    { name: "OTTV - Viva Entertainment Group Inc.", ticker: "OTTV" },
    { name: "SFOR - StrikeForce Technologies Inc.", ticker: "SFOR" },
    { name: "ADAC - Adama Technologies Corp", ticker: "ADAC" },
    { name: "FTEG - For The Earth Corp.", ticker: "FTEG" },
    { name: "GLYE - GlyEco, Inc.", ticker: "GLYE" },
    { name: "FWLAF - FlatWorld Acquisition Corp.", ticker: "FWLAF" },
    { name: "ADGO - Advantego Corp", ticker: "ADGO" },
    { name: "YUMAQ - Yuma Energy, Inc.", ticker: "YUMAQ" },
    { name: "KYNC - KYN Capital Group, Inc.", ticker: "KYNC" },
    { name: "LTTGF - LOTTOGOPHER HOLDINGS INC", ticker: "LTTGF" },
    { name: "GFTX - Global Fiber Technologies, Inc.", ticker: "GFTX" },
    { name: "PVHO - Provision Holding, Inc.", ticker: "PVHO" },
    { name: "BMMCF - KBRIDGE ENERGY CORP.", ticker: "BMMCF" },
    { name: "UNGS - Sylios Corp", ticker: "UNGS" },
    { name: "PNAT - PURA NATURALS, INC.", ticker: "PNAT" },
    { name: "VTXB - Vortex Brands Co.", ticker: "VTXB" },
    { name: "ABQQ - AB INTERNATIONAL GROUP CORP.", ticker: "ABQQ" },
    { name: "DIRV - DIRECTVIEW HOLDINGS INC", ticker: "DIRV" },
    { name: "VTNL - BrewBilt Manufacturing Inc.", ticker: "VTNL" },
    { name: "DPSI - DecisionPoint Systems, Inc.", ticker: "DPSI" },
    { name: "PFWIQ - PETRONE WORLDWIDE, INC.", ticker: "PFWIQ" },
    { name: "CORX - Core Lithium Corp.", ticker: "CORX" },
    { name: "NCAP - NORTHSIGHT CAPITAL, INC.", ticker: "NCAP" },
    { name: "CBDL - CBD Life Sciences Inc.", ticker: "CBDL" },
    { name: "ASNT - Arias Intel Corp.", ticker: "ASNT" },
    { name: "AEPT - American Energy Partners, Inc.", ticker: "AEPT" },
    { name: "DLYT - DAIS Corp", ticker: "DLYT" },
    { name: "TMGI - Marquie Group, Inc.", ticker: "TMGI" },
    { name: "PGAI - PGI INC", ticker: "PGAI" },
    { name: "PHBR - PhoneBrasil Internetional Inc", ticker: "PHBR" },
    { name: "NBDR - No Borders, Inc.", ticker: "NBDR" },
    { name: "VTDRF - VANTAGE DRILLING INTERNATIONAL", ticker: "VTDRF" },
    { name: "DNAX - DNA BRANDS INC", ticker: "DNAX" },
    { name: "CCOP - COMPETITIVE COMPANIES INC", ticker: "CCOP" },
    { name: "WAYS - Wave Sync Corp.", ticker: "WAYS" },
    { name: "CDIX - Cardiff Lexington Corp", ticker: "CDIX" },
    { name: "BVTK - Bravatek Solutions, Inc.", ticker: "BVTK" },
    { name: "HKEB - HK EBUS Corp", ticker: "HKEB" },
    { name: "ROSGQ - Rosetta Genomics Ltd.", ticker: "ROSGQ" },
    { name: "BRKK - Gen 2 Technologies Inc.", ticker: "BRKK" },
    { name: "GPLS - Geopulse Exploration Inc.", ticker: "GPLS" },
    { name: "MDTR - ADVANCED CONTAINER TECHNOLOGIES, INC.", ticker: "MDTR" },
    { name: "SIRC - SOLAR INTEGRATED ROOFING CORP.", ticker: "SIRC" },
    { name: "MFST - Medifirst Solutions, Inc.", ticker: "MFST" },
    { name: "BNCM - 24/7 Labs Corp", ticker: "BNCM" },
    { name: "BKIT - BIOHEMP INTERNATIONAL, INC.", ticker: "BKIT" },
    { name: "PLYZ - Plyzer Technologies Inc.", ticker: "PLYZ" },
    { name: "QBAN - TELCO CUBA, INC..", ticker: "QBAN" },
    { name: "STTH - STEALTH TECHNOLOGIES, INC.", ticker: "STTH" },
    { name: "WMLPQ - Westmoreland Resource Partners, LP", ticker: "WMLPQ" },
    { name: "IORG - INTREorg SYSTEMS INC.", ticker: "IORG" },
    { name: "ARST - Arista Financial Corp.", ticker: "ARST" },
    { name: "FVRG - FOREVERGREEN WORLDWIDE CORP", ticker: "FVRG" },
    { name: "LWLW - Longwen Group Corp.", ticker: "LWLW" },
    { name: "CWNOF - CHINESEWORLDNET COM INC", ticker: "CWNOF" },
    { name: "GXXM - GEX MANAGEMENT, INC.", ticker: "GXXM" },
    { name: "GTLL - GLOBAL TECHNOLOGIES LTD", ticker: "GTLL" },
    { name: "TGRR - Tiger Reef, Inc.", ticker: "TGRR" },
    { name: "TCHC - Tech Central, Inc.", ticker: "TCHC" },
    { name: "GETH - GREEN ENVIROTECH HOLDINGS CORP.", ticker: "GETH" },
    { name: "HPMM - Hemp Naturals, Inc.", ticker: "HPMM" },
    { name: "INBT - Inbit Corp", ticker: "INBT" },
    { name: "FOEAF - Dolphin Drilling ASA/ADR", ticker: "FOEAF" },
    { name: "XSPT - XSport Global, Inc.", ticker: "XSPT" },
    { name: "OLMM - ONELIFE TECHNOLOGIES CORP", ticker: "OLMM" },
    { name: "ECXJ - CXJ GROUP CO., Ltd", ticker: "ECXJ" },
    { name: "BIQIF - BIQI INTERNATIONAL HOLDINGS CORP", ticker: "BIQIF" },
    { name: "BRTX - BioRestorative Therapies, Inc.", ticker: "BRTX" },
    { name: "TPAC - Trans-Pacific Aerospace Company, Inc.", ticker: "TPAC" },
    { name: "CGYG - CHINA LONGYI GROUP INTERNATIONAL HOLDINGS LTD", ticker: "CGYG" },
    { name: "EPXY - Epoxy, Inc.", ticker: "EPXY" },
    { name: "EPTI - Environmental Packaging Technologies Holdings, Inc.", ticker: "EPTI" },
    { name: "NANN - Nanovation Microtech, Inc.", ticker: "NANN" },
    { name: "ZNGYQ - ZENERGY BRANDS, INC.", ticker: "ZNGYQ" },
    { name: "CMCI - China Modern Agricultural Information, Inc.", ticker: "CMCI" },
    { name: "LDHL - LD HOLDINGS, INC.", ticker: "LDHL" },
    { name: "INCT - InCapta, Inc.", ticker: "INCT" },
    { name: "MSMY - MC Endeavors, Inc.", ticker: "MSMY" },
    { name: "BLKG - Black Stallion Oil & Gas Inc.", ticker: "BLKG" },
    { name: "FREEF - FREESEAS INC.", ticker: "FREEF" },
    { name: "GBPT - Globe Photos, Inc.", ticker: "GBPT" },
    { name: "CGAC - CODE GREEN APPAREL CORP", ticker: "CGAC" },
    { name: "NXES - Nexus Enterprise Solutions, Inc.", ticker: "NXES" },
    { name: "BTHR - SPORTS VENUES OF FLORIDA, INC.", ticker: "BTHR" },
    { name: "BCRD - BlueOne Card, Inc.", ticker: "BCRD" },
    { name: "MJDS - MOJO DATA SOLUTIONS, INC.", ticker: "MJDS" },
    { name: "TGRO - Tiger Oil & Energy, Inc.", ticker: "TGRO" },
    { name: "NGEY - New Global Energy, Inc.", ticker: "NGEY" },
    { name: "URAL - UNITED RAIL, INC.", ticker: "URAL" },
    { name: "FJHL - Fovea Jewelry Holdings Ltd.", ticker: "FJHL" },
    { name: "PGEC - PRESTIGE CAPITAL CORP", ticker: "PGEC" },
    { name: "PLSB - Pulse Beverage Corp", ticker: "PLSB" },
    { name: "GTEH - GENTECH HOLDINGS, INC.", ticker: "GTEH" },
    { name: "SRUP - SIRRUS CORP.", ticker: "SRUP" },
    { name: "ONCX - Oncolix, Inc.", ticker: "ONCX" },
    { name: "BPOL - BLACKPOLL FLEET INTERNATIONAL, INC.", ticker: "BPOL" },
    { name: "SPDL - SPINDLE, INC.", ticker: "SPDL" },
    { name: "TSMI - Total Sports Media, Inc.", ticker: "TSMI" },
    { name: "CNNA - Cann American Corp.", ticker: "CNNA" },
    { name: "CCRE - CAN CAL RESOURCES LTD", ticker: "CCRE" },
    { name: "JWHI - JIN WAN HONG INTERNATIONAL HOLDINGS Ltd", ticker: "JWHI" },
    { name: "MOMC - BLOCKHOLD CAPITAL CORP", ticker: "MOMC" },
    { name: "NAEX - National Art Exchange, Inc.", ticker: "NAEX" },
    { name: "PNHT - PANAMERA HEALTHCARE Corp", ticker: "PNHT" },
    { name: "VCOR - VISIBER57 CORP.", ticker: "VCOR" },
    { name: "XNDA - XINDA INTERNATIONAL CORP.", ticker: "XNDA" },
    { name: "SVDN - SavDen Group Corp.", ticker: "SVDN" },
    { name: "SWGI - STAR WEALTH GROUP INC.", ticker: "SWGI" },
    { name: "AVRPX - Stone Ridge Trust III", ticker: "AVRPX" },
    { name: "EQGP - EQGP Holdings, LP", ticker: "EQGP" },
    { name: "AVIR - Atea Pharmaceuticals, Inc.", ticker: "AVIR" },
    { name: "ZOES - Zoe's Kitchen, Inc.", ticker: "ZOES" },
    { name: "GCREX - Griffin Institutional Access Real Estate Fund", ticker: "GCREX" },
    { name: "CTYWY - Countrywide plc/ADR", ticker: "CTYWY" },
    { name: "ANHGY - Mediclinic International Plc/ADR", ticker: "ANHGY" },
    { name: "HTBC - HotApp Blockchain Inc.", ticker: "HTBC" },
    { name: "GCEA - Griffin Capital Essential Asset REIT, Inc.", ticker: "GCEA" },
    { name: "NLRT - Nogales Resources Corp", ticker: "NLRT" },
    { name: "SQZ - SQZ Biotechnologies Co", ticker: "SQZ" },
    { name: "PSOIX - Palmer Square Opportunistic Income Fund", ticker: "PSOIX" },
    { name: "CIVI - Civitas Solutions, Inc.", ticker: "CIVI" },
    { name: "XPEAX - AMG Pantheon Fund, LLC", ticker: "XPEAX" },
    { name: "TMIN - TRENDMAKER INC. LTD.", ticker: "TMIN" },
    { name: "AHI - AVADIM HEALTH, INC.", ticker: "AHI" },
    { name: "BHCV - Edge Data Solutions, Inc.", ticker: "BHCV" },
    { name: "XPASX - Peachtree Alternative Strategies Fund", ticker: "XPASX" },
    { name: "VCRRX - Versus Capital Real Assets Fund LLC", ticker: "VCRRX" },
    { name: "IDIV - Metaurus Equity Component Trust", ticker: "IDIV" },
    { name: "PFFLX - PIMCO Flexible Credit Income Fund", ticker: "PFFLX" },
    { name: "USQIX - USQ Core Real Estate Fund", ticker: "USQIX" },
    { name: "CNRLX - City National Rochdale Select Strategies Fund", ticker: "CNRLX" },
    { name: "PLTM - GraniteShares Platinum Trust", ticker: "PLTM" },
    { name: "MSYN - MS YOUNG ADVENTURE ENTERPRISE, INC.", ticker: "MSYN" },
    { name: "MGOM - Migom Global Corp.", ticker: "MGOM" },
    { name: "CCCP - Crona Corp.", ticker: "CCCP" },
    { name: "VFLEX - Relative Value Fund", ticker: "VFLEX" },
    { name: "JSMM - China King Spirit Group Ltd.", ticker: "JSMM" },
    { name: "BXXY - Boxxy Inc.", ticker: "BXXY" },
    { name: "BTLR - Battlers Corp.", ticker: "BTLR" },
    { name: "XPTFX - Federated Hermes Project & Trade Finance Tender Fund", ticker: "XPTFX" },
    { name: "LNBY - Landbay Inc", ticker: "LNBY" },
    { name: "ASAV - ASI Aviation, Inc.", ticker: "ASAV" },
    { name: "MDVP - MED SPA VACATIONS INC.", ticker: "MDVP" },
    { name: "SMGE - Sigmata Electronics, Inc.", ticker: "SMGE" },
    { name: "SLGB - Slinger Bag Inc.", ticker: "SLGB" },
    { name: "LENDX - Stone Ridge Trust V", ticker: "LENDX" },
    { name: "FLLZ - Fellazo Corp", ticker: "FLLZ" },
    { name: "HPGN - HypGen Inc", ticker: "HPGN" },
    { name: "APXX - APEX RESOURCES INC/NV", ticker: "APXX" },
    { name: "RDMR - Road Marshall, Inc.", ticker: "RDMR" },
    { name: "XOGQ - Extraction Oil & Gas, Inc.", ticker: "XOGQ" },
    { name: "HGHH - High Desert Holding Corp.", ticker: "HGHH" },
    { name: "RCCC - RC-1, Inc.", ticker: "RCCC" },
    { name: "GSGG - GSG GROUP INC.", ticker: "GSGG" },
    { name: "XNTFX - CC Real Estate Income Fund-T", ticker: "XNTFX" },
    { name: "RLLT - Reliant Service Inc", ticker: "RLLT" },
    { name: "SNHR - SEGUIN NATURAL HAIR PRODUCTS INC.", ticker: "SNHR" },
    { name: "SLPA - Sleepaid Holding Co.", ticker: "SLPA" },
    { name: "SIGY - Reign Resources Corp", ticker: "SIGY" },
    { name: "SVMB - SavMobi Technology Inc.", ticker: "SVMB" },
    { name: "WBST - Webstar Technology Group Inc.", ticker: "WBST" },
    { name: "GIPR - GENERATION INCOME PROPERTIES, INC.", ticker: "GIPR" },
    { name: "TCAI - PHMC, Inc.", ticker: "TCAI" },
    { name: "IQNDY - iQnovate Ltd", ticker: "IQNDY" },
    { name: "ARRAF - Arria NLG PLC", ticker: "ARRAF" },
    { name: "BESP - Benefit Street Partners Realty Trust, Inc.", ticker: "BESP" },
    { name: "TRTK - TORtec Group Corp", ticker: "TRTK" },
    { name: "HTIA - Healthcare Trust, Inc.", ticker: "HTIA" },
    { name: "ZYRX - ZYROX MINING INTERNATIONAL INC", ticker: "ZYRX" },
    { name: "CVMCA - Sila Realty Trust, Inc.", ticker: "CVMCA" },
    { name: "PRDEX - PREDEX", ticker: "PRDEX" },
    { name: "ANVI - ANVI GLOBAL HOLDINGS, INC.", ticker: "ANVI" },
    { name: "LWEL - Luckwel Pharmaceuticals Inc.", ticker: "LWEL" },
    { name: "GRAH - Griffin-American Healthcare REIT III, Inc.", ticker: "GRAH" },
    { name: "BBMPY - BBMG Corporation/ADR", ticker: "BBMPY" },
    { name: "AMPO - AMPERICO LTD", ticker: "AMPO" },
    { name: "RMRI - Rocky Mountain Industrials, Inc.", ticker: "RMRI" },
    { name: "AUDD - Clip Interactive, LLC", ticker: "AUDD" },
    { name: "CRREX - Resource Real Estate Diversified Income Fund", ticker: "CRREX" },
    { name: "RXDX - Ignyta, Inc.", ticker: "RXDX" },
    { name: "CPYA - CORPORATE PROPERTY ASSOCIATES 18 GLOBAL INC", ticker: "CPYA" },
    { name: "TIPLX - Bluerock Total Income (plus) Real Estate Fund", ticker: "TIPLX" },
    { name: "OUNZ - VanEck Merk Gold Trust", ticker: "OUNZ" },
    { name: "STFR - Steadfast Apartment REIT, Inc.", ticker: "STFR" },
    { name: "WEFCX - Wildermuth Endowment Fund", ticker: "WEFCX" },
    { name: "MPGR - CANNA Corp", ticker: "MPGR" },
    { name: "CNRQ - China Soar Information Technology, Inc.", ticker: "CNRQ" },
    { name: "SEGR - Southeastern Grocers, Inc.", ticker: "SEGR" },
    { name: "DTLA-P - Brookfield DTLA Fund Office Trust Investor Inc.", ticker: "DTLA-P" },
    { name: "GVBT - GREEN VISION BIOTECHNOLOGY CORP.", ticker: "GVBT" },
    { name: "UBLI - Yinghong Guangda Technology Ltd", ticker: "UBLI" },
    { name: "VXBT - Vortex Blockchain Technologies Inc.", ticker: "VXBT" },
    { name: "SWPLY - Swire Properties Limited/ADR", ticker: "SWPLY" },
    { name: "JGW - J.G. Wentworth Co", ticker: "JGW" },
    { name: "FUPEY - Fuchs Petrolub SE/ADR", ticker: "FUPEY" },
    { name: "ARMT - Ameri Metro, Inc. (formerly Yellowwood)", ticker: "ARMT" },
    { name: "JEMC - J.E.M. CAPITAL, INC.", ticker: "JEMC" },
    { name: "HRDV - Health-Right Discoveries, Inc.", ticker: "HRDV" },
    { name: "SIRR - Sierra Income Corp", ticker: "SIRR" },
    { name: "INRE - Inland Real Estate Income Trust, Inc.", ticker: "INRE" },
    { name: "ARP - Titan Energy, LLC", ticker: "ARP" },
    { name: "LVDW - LiquidValue Development Inc.", ticker: "LVDW" },
    { name: "NHHS - NorthStar Healthcare Income, Inc.", ticker: "NHHS" },
    { name: "DNXG - Dongxing International Inc.", ticker: "DNXG" },
    { name: "CKDXF - Opthea Ltd / ADR", ticker: "CKDXF" },
    { name: "MTGE - MTGE Investment Corp.", ticker: "MTGE" },
    { name: "GATO - Sunshine Silver Mining & Refining Corp", ticker: "GATO" },
    { name: "GLNS - Golden Star Resource Corp.", ticker: "GLNS" },
    { name: "NEUL - NEULION, INC.", ticker: "NEUL" },
    { name: "TONJ - Tongji Healthcare Group, Inc.", ticker: "TONJ" },
    { name: "ALIN-PA - Altera Infrastructure L.P.", ticker: "ALIN-PA" },
    { name: "THRO - Theron Resource Group", ticker: "THRO" },
    { name: "ONTY - Cascadian Therapeutics, Inc.", ticker: "ONTY" },
    { name: "GPLB - Green Planet Bio Engineering Co. Ltd.", ticker: "GPLB" },
    { name: "BLGPY - BOART LONGYEAR LTD", ticker: "BLGPY" },
    { name: "UGA - United States Gasoline Fund, LP", ticker: "UGA" },
    { name: "JMBA - JAMBA, INC.", ticker: "JMBA" },
    { name: "SAIG - SAFE AUTO INSURANCE GROUP, INC.", ticker: "SAIG" },
    { name: "YFTD - Yacht Finders, Inc.", ticker: "YFTD" },
    { name: "IEBS - Independence Bancshares, Inc.", ticker: "IEBS" },
    { name: "PAY - VERIFONE SYSTEMS, INC.", ticker: "PAY" },
    { name: "BHOR - Behringer Harvard Opportunity REIT I, Inc.", ticker: "BHOR" },
    { name: "LPNT - LEGACY LIFEPOINT HEALTH, INC.", ticker: "LPNT" },
    { name: "EDR - Education Realty Trust, Inc.", ticker: "EDR" },
    { name: "USPB - U. S. Premium Beef, LLC", ticker: "USPB" },
    { name: "ANWWQ - AEGEAN MARINE PETROLEUM NETWORK INC.", ticker: "ANWWQ" },
    { name: "UIFD - Unifunds Ltd", ticker: "UIFD" },
    { name: "INTB - Intelligent Buying, Inc.", ticker: "INTB" },
    { name: "LAKF - Lake Forest Minerals Inc.", ticker: "LAKF" },
    { name: "BDSX - BIODESIX INC", ticker: "BDSX" },
    { name: "ABFOF - Abertis Infraestructuras S.A.", ticker: "ABFOF" },
    { name: "DNO - United States Short Oil Fund, LP", ticker: "DNO" },
    { name: "SCGEY - Shougang Concord International", ticker: "SCGEY" },
    { name: "HJGP - AS Capital, Inc.", ticker: "HJGP" },
    { name: "TALR - TALON REAL ESTATE HOLDING CORP.", ticker: "TALR" },
    { name: "BLTN - BRIGHTLANE CORP.", ticker: "BLTN" },
    { name: "WLOC - Willow Creek Enterprises Inc.", ticker: "WLOC" },
    { name: "ETI-P - ENTERGY TEXAS, INC.", ticker: "ETI-P" },
    { name: "IILG - ILG, LLC", ticker: "IILG" },
    { name: "HSNI - HSN, Inc.", ticker: "HSNI" },
    { name: "TCYBY - Tietoenator OYJ", ticker: "TCYBY" },
    { name: "KDNY - ADURO BIOTECH, INC.", ticker: "KDNY" },
    { name: "LTAFX - Alternative Strategies Fund", ticker: "LTAFX" },
    { name: "RVALL - REVA Medical, Inc.", ticker: "RVALL" },
    { name: "GCACU - Growth Capital Acquisition Corp.", ticker: "GCACU" },
    { name: "ONDR - ONLINE DISRUPTIVE TECHNOLOGIES, INC.", ticker: "ONDR" },
    { name: "PHEC - Phillips Edison & Company, Inc.", ticker: "PHEC" },
    { name: "ASDOF - Ansaldo STS SpA/ADR", ticker: "ASDOF" },
    { name: "ODZA - Odenza Corp.", ticker: "ODZA" },
    { name: "AFFG - AFF Holding Group Inc.", ticker: "AFFG" },
    { name: "PPPMF - PRIMERO MINING CORP", ticker: "PPPMF" },
    { name: "URMCY - Unibail-Rodamco SE/ADR", ticker: "URMCY" },
    { name: "SIVR - Aberdeen Standard Silver ETF Trust", ticker: "SIVR" },
    { name: "SGOL - Aberdeen Standard Gold ETF Trust", ticker: "SGOL" },
    { name: "STAEY - Stanley Electric Co., Ltd./ADR", ticker: "STAEY" },
    { name: "RIVU - Rivulet Media, Inc.", ticker: "RIVU" },
    { name: "AGGX - AngioGenex, Inc.", ticker: "AGGX" },
    { name: "SKDI - Sun Kissed Industries, Inc.", ticker: "SKDI" },
    { name: "OPCO - OURPETS CO", ticker: "OPCO" },
    { name: "QDM - QDM International Inc.", ticker: "QDM" },
    { name: "SONS - Sonus, Inc.", ticker: "SONS" },
    { name: "ARGS - ARGOS THERAPEUTICS INC", ticker: "ARGS" },
    { name: "CNCL - CANCER CAPITAL CORP", ticker: "CNCL" },
    { name: "LZGI - LZG INTERNATIONAL, INC.", ticker: "LZGI" },
    { name: "QWIKF - QWICK MEDIA INC.", ticker: "QWIKF" },
    { name: "IFTV - INFITECH VENTURES INC", ticker: "IFTV" },
    { name: "HMPR - Xenith Bankshares, Inc.", ticker: "HMPR" },
    { name: "TRYF - Trycera Financial, Inc.", ticker: "TRYF" },
    { name: "ABCO - ADVISORY BOARD CO", ticker: "ABCO" },
    { name: "FCAA - FICAAR, INC", ticker: "FCAA" },
    { name: "HTM - US GEOTHERMAL INC", ticker: "HTM" },
    { name: "CMFT - COMMUNITY FIRST INC", ticker: "CMFT" },
    { name: "SSNI - Itron Networked Solutions, Inc.", ticker: "SSNI" },
    { name: "CRDC - Dex Liquidating Co.", ticker: "CRDC" },
    { name: "CLLY - CNL LIFESTYLE PROPERTIES INC", ticker: "CLLY" },
    { name: "QVCD - QVC INC", ticker: "QVCD" },
    { name: "GOIGD - GoIP GLOBAL, INC.", ticker: "GOIGD" },
    { name: "USVR - US VR Global.com Inc.", ticker: "USVR" },
    { name: "FMSA - Bison Merger Sub I, LLC", ticker: "FMSA" },
    { name: "NDN - 99 CENTS ONLY STORES LLC", ticker: "NDN" },
    { name: "TCCI - THANKSGIVING COFFEE CO INC", ticker: "TCCI" },
    { name: "KDUS - CADUS CORP", ticker: "KDUS" },
    { name: "EXAC - EXACTECH INC", ticker: "EXAC" },
    { name: "HLM-P - HILLMAN COMPANIES INC", ticker: "HLM-P" },
    { name: "IPGYY - INTERPUMP GROUP SPA /FI", ticker: "IPGYY" },
    { name: "VYSM - VIEW SYSTEMS INC", ticker: "VYSM" },
    { name: "SGIL - SUNBURST ACQUISITIONS V INC", ticker: "SGIL" },
    { name: "PPYH - PHYSICAL PROPERTY HOLDINGS, INC.", ticker: "PPYH" },
    { name: "MADL - MAN AHL DIVERSIFIED I LP", ticker: "MADL" },
    { name: "CCAA - CALA CORP", ticker: "CCAA" },
    { name: "FEPI - FIRST EQUITY PROPERTIES INC", ticker: "FEPI" },
    { name: "SVRH - SEVIER COUNTY BANCSHARES, INC.", ticker: "SVRH" },
    { name: "CHOD - ENERKON SOLAR INTERNATIONAL, INC.", ticker: "CHOD" },
    { name: "CHSCP - CHS INC", ticker: "CHSCP" },
    { name: "AXIN - AiXin Life International, Inc.", ticker: "AXIN" },
    { name: "ALGM - ALLEGRO MICROSYSTEMS INC", ticker: "ALGM" },
    { name: "BONT - BON TON STORES INC", ticker: "BONT" },
    { name: "PBKC - PIONEER BANKCORP INC", ticker: "PBKC" },
    { name: "WGA - AG&E HOLDINGS INC.", ticker: "WGA" },
    { name: "TLS - TELOS CORP", ticker: "TLS" },
    { name: "CA - CA, INC.", ticker: "CA" },
    { name: "REGT - REGENT TECHNOLOGIES INC", ticker: "REGT" },
    { name: "SADDP - SADDLEBROOK RESORTS INC", ticker: "SADDP" },
    { name: "FTRQ - FRONTIER COMMUNICATIONS CORP", ticker: "FTRQ" },
    { name: "CLE - CLAIRES STORES INC", ticker: "CLE" },
    { name: "BCR - BARD C R INC /NJ/", ticker: "BCR" },
    { name: "NRUC - NATIONAL RURAL UTILITIES COOPERATIVE FINANCE CORP /DC/", ticker: "NRUC" },
    { name: "TSO - ANDEAVOR LLC", ticker: "TSO" },
    { name: "IHRC - Investors Heritage Capital Corp", ticker: "IHRC" },
    { name: "OKASY - ONWARD KASHIYAMA CO LTD", ticker: "OKASY" },
    { name: "AVHI - AV Homes, Inc.", ticker: "AVHI" },
    { name: "RICE-UN - Rice Acquisition Corp.", ticker: "RICE-UN" },
    { name: "LUXA-UN - Lux Health Tech Acquisition Corp.", ticker: "LUXA-UN" },
    { name: "HIGA-UN - H.I.G. Acquisition Corp.", ticker: "HIGA-UN" },
    { name: "ARKO - ARKO Corp.", ticker: "ARKO" },
    { name: "ARBGU - Aequi Acquisition Corp.", ticker: "ARBGU" },
    { name: "LCPU - LCP Acquisition Corp", ticker: "LCPU" },
    { name: "LNFA-UN - L&F Acquisition Corp.", ticker: "LNFA-UN" },
    { name: "AGCUU - Altimeter Growth Corp.", ticker: "AGCUU" },
    { name: "GBNY - Generations Bancorp NY, Inc.", ticker: "GBNY" },
    { name: "AFBI - Affinity Bancshares, Inc.", ticker: "AFBI" },
    { name: "CTAQU - Carney Technology Acquisition Corp. II", ticker: "CTAQU" },
    { name: "SPNV-UN - Supernova Partners Acquisition Company, Inc.", ticker: "SPNV-UN" },
    { name: "IIAC-UN - Investindustrial Acquisition Corp.", ticker: "IIAC-UN" },
    { name: "DIAM - Diamond Standard Trust", ticker: "DIAM" },
    { name: "WETH - Wetouch Technology Inc.", ticker: "WETH" },
    { name: "NBA-UN - New Beginnings Acquisition Corp.", ticker: "NBA-UN" },
    { name: "ATACU - ALTIMAR ACQUISITION CORP.", ticker: "ATACU" },
    { name: "CTAC-UN - Cerberus Telecom Acquisition Corp.", ticker: "CTAC-UN" },
    { name: "NOACU - Natural Order Acquisition Corp.", ticker: "NOACU" },
    { name: "CHFW-UN - Consonance-HFW Acquisition Corp.", ticker: "CHFW-UN" },
    { name: "DMYI-UN - dMY Technology Group, Inc. III", ticker: "DMYI-UN" },
    { name: "AJAX-UN - Ajax I", ticker: "AJAX-UN" },
    { name: "GCMG - GCM Grosvenor Inc.", ticker: "GCMG" },
    { name: "GNPK-UN - Genesis Park Acquisition Corp.", ticker: "GNPK-UN" },
    { name: "RTP-UN - Reinvent Technology Partners", ticker: "RTP-UN" },
    { name: "TRIT - Netfin Holdco", ticker: "TRIT" },
    { name: "LCYAU - Landcadia Holdings III, Inc.", ticker: "LCYAU" },
    { name: "CLNN - Chelsea Worldwide Inc.", ticker: "CLNN" },
    { name: "PIPP-UN - Pine Island Acquisition Corp.", ticker: "PIPP-UN" },
    { name: "VYGG-UN - Vy Global Growth", ticker: "VYGG-UN" },
    { name: "EMPW-UN - Empower Ltd.", ticker: "EMPW-UN" },
    { name: "EUCRU - Eucrates Biomedical Acquisition Corp.", ticker: "EUCRU" },
    { name: "SVSVU - SPRING VALLEY ACQUISITION CORP.", ticker: "SVSVU" },
    { name: "CONXU - CONX Corp.", ticker: "CONXU" },
    { name: "KWAC-UN - Kingswood Global Holdings Inc.", ticker: "KWAC-UN" },
    { name: "DBDRU - Roman DBDR Tech Acquisition Corp.", ticker: "DBDRU" },
    { name: "BLSA - BCLS Acquisition Corp.", ticker: "BLSA" },
    { name: "AHN - AmeriHome, Inc.", ticker: "AHN" },
    { name: "SEAH-UN - Sports Entertainment Acquisition Corp.", ticker: "SEAH-UN" },
    { name: "APSG-UN - Apollo Strategic Growth Capital", ticker: "APSG-UN" },
    { name: "KINZ-UN - KINS Technology Group, Inc.", ticker: "KINZ-UN" },
    { name: "OACB-UN - Oaktree Acquisition Corp. II", ticker: "OACB-UN" },
    { name: "IACA-UN - ION Acquisition Corp 1 Ltd.", ticker: "IACA-UN" },
    { name: "CLII-UN - Climate Change Crisis Real Impact I Acquisition Corp", ticker: "CLII-UN" },
    { name: "GHLD - Guild Holdings Co", ticker: "GHLD" },
    { name: "GLSPU - Global SPAC Partners Co,", ticker: "GLSPU" },
    { name: "QELL-UN - Qell Acquisition Corp", ticker: "QELL-UN" },
    { name: "PDAC-UN - PERIDOT ACQUISITION CORP.", ticker: "PDAC-UN" },
    { name: "OTRAU - OTR Acquisition Corp.", ticker: "OTRAU" },
    { name: "HOMS - Caliber Home Loans, Inc.", ticker: "HOMS" },
    { name: "HLXA - Helix Acquisition Corp", ticker: "HLXA" },
    { name: "TMKR-UN - Tastemaker Acquisition Corp.", ticker: "TMKR-UN" },
    { name: "XPOA-UN - DPCM Capital, Inc.", ticker: "XPOA-UN" },
    { name: "HCON-UN - Horizon Acquisition Corp II", ticker: "HCON-UN" },
    { name: "LESL - Leslie's, Inc.", ticker: "LESL" },
    { name: "TEKKU - Tekkorp Digital Acquisition Corp.", ticker: "TEKKU" },
    { name: "FMAC-UN - FirstMark Horizon Acquisition Corp.", ticker: "FMAC-UN" },
    { name: "CAS-UN - Cascade Acquisition Corp", ticker: "CAS-UN" },
    { name: "JCICU - Jack Creek Investment Corp.", ticker: "JCICU" },
    { name: "MOTNU - Motion Acquisition Corp.", ticker: "MOTNU" },
    { name: "ALTUU - Altitude Acquisition Corp.", ticker: "ALTUU" },
    { name: "FHTX - Foghorn Therapeutics Inc.", ticker: "FHTX" },
    { name: "LSAQ - Lifesci Acquisition II Corp.", ticker: "LSAQ" },
    { name: "IPOD-UN - Social Capital Hedosophia Holdings Corp. IV", ticker: "IPOD-UN" },
    { name: "XMET - XXStream Entertainment, Inc.", ticker: "XMET" },
    { name: "IPOF-UN - Social Capital Hedosophia Holdings Corp. VI", ticker: "IPOF-UN" },
    { name: "IPOE-UN - Social Capital Hedosophia Holdings Corp. V", ticker: "IPOE-UN" },
    { name: "PIAI-UN - Prime Impact Acquisition I", ticker: "PIAI-UN" },
    { name: "TWCTU - TWC Tech Holdings II Corp.", ticker: "TWCTU" },
    { name: "GHVIU - Gores Holdings VI, Inc.", ticker: "GHVIU" },
    { name: "TPGY-UN - TPG Pace Beneficial Finance Corp.", ticker: "TPGY-UN" },
    { name: "PACE-UN - TPG Pace Tech Opportunities Corp.", ticker: "PACE-UN" },
    { name: "STWOU - ACON S2 Acquisition Corp.", ticker: "STWOU" },
    { name: "NGACU - NextGen Acquisition Corp", ticker: "NGACU" },
    { name: "ASAQ-UN - Atlantic Avenue Acquisition Corp", ticker: "ASAQ-UN" },
    { name: "ASPL-UN - Aspirational Consumer Lifestyle Corp.", ticker: "ASPL-UN" },
    { name: "SNPR-UN - Tortoise Acquisition Corp. II", ticker: "SNPR-UN" },
    { name: "AVAN-UN - Avanti Acquisition Corp.", ticker: "AVAN-UN" },
    { name: "CLVR - Clever Leaves Holdings Inc.", ticker: "CLVR" },
    { name: "GWACU - GOOD WORKS ACQUISITION CORP.", ticker: "GWACU" },
    { name: "VACQU - Vector Acquisition Corp", ticker: "VACQU" },
    { name: "RMGBU - RMG Acquisition Corp. II", ticker: "RMGBU" },
    { name: "IMPX-UN - AEA-Bridges Impact Corp.", ticker: "IMPX-UN" },
    { name: "SGAMU - Seaport Global Acquisition Corp", ticker: "SGAMU" },
    { name: "LEGOU - Legato Merger Corp.", ticker: "LEGOU" },
    { name: "VIHU - VPC Impact Acquisition Holdings", ticker: "VIHU" },
    { name: "TVACU - Thayer Ventures Acquisition Corp", ticker: "TVACU" },
    { name: "CRHC-UN - Cohn Robbins Holdings Corp.", ticker: "CRHC-UN" },
    { name: "EQD-UN - Equity Distribution Acquisition Corp.", ticker: "EQD-UN" },
    { name: "CMLFU - CM Life Sciences, Inc.", ticker: "CMLFU" },
    { name: "LEAP-UN - Ribbit LEAP, Ltd.", ticker: "LEAP-UN" },
    { name: "BFT-UN - Foley Trasimene Acquisition II", ticker: "BFT-UN" },
    { name: "VIRI - Virios Therapeutics, LLC", ticker: "VIRI" },
    { name: "DGNR-UN - Dragoneer Growth Opportunities Corp.", ticker: "DGNR-UN" },
    { name: "AHACU - Alpha Healthcare Acquisition Corp.", ticker: "AHACU" },
    { name: "MAX - MediaAlpha, Inc.", ticker: "MAX" },
    { name: "FGNA-UN - FG New America Acquisition Corp.", ticker: "FGNA-UN" },
    { name: "DISTU - Distoken Acquisition Corp", ticker: "DISTU" },
    { name: "CFACU - CF Finance Acquisition Corp. III", ticker: "CFACU" },
    { name: "AONE-UN - one", ticker: "AONE-UN" },
    { name: "SBG-UN - Sandbridge Acquisition Corp", ticker: "SBG-UN" },
    { name: "ASO - Academy Sports & Outdoors, Inc.", ticker: "ASO" },
    { name: "RCHGU - Recharge Acquisition Corp.", ticker: "RCHGU" },
    { name: "BLUWU - Blue Water Acquisition Corp.", ticker: "BLUWU" },
    { name: "BOAC.U - Bluescape Opportunities Acquisition Corp.", ticker: "BOAC.U" },
    { name: "YSU - Yellowstone Acquisition Co", ticker: "YSU" },
    { name: "FRX-UN - Forest Road Acquisition Corp.", ticker: "FRX-UN" },
    { name: "DEH-UN - D8 Holdings Corp.", ticker: "DEH-UN" },
    { name: "CCV-UN - Churchill Capital Corp V", ticker: "CCV-UN" },
    { name: "DWIN-UN - Delwinds Insurance Acquisition Corp.", ticker: "DWIN-UN" },
    { name: "CFIIU - CF Finance Acquisition Corp II", ticker: "CFIIU" },
    { name: "PANA - Panacea Acquisition Corp", ticker: "PANA" },
    { name: "CCIV-UN - Churchill Capital Corp IV", ticker: "CCIV-UN" },
    { name: "VMACU - Vistas Media Acquisition Co Inc.", ticker: "VMACU" },
    { name: "PAICU - Petra Acquisition Inc.", ticker: "PAICU" },
    { name: "SPEL - Spinal Elements Holdings, Inc.", ticker: "SPEL" },
    { name: "WPF-UN - Foley Trasimene Acquisition Corp.", ticker: "WPF-UN" },
    { name: "HIGR - Hi-Great Group Holding Co", ticker: "HIGR" },
    { name: "FUSE-UN - Fusion Acquisition Corp.", ticker: "FUSE-UN" },
    { name: "UPC - Universe Pharmaceuticals INC", ticker: "UPC" },
    { name: "HPX-UN - HPX Corp.", ticker: "HPX-UN" },
    { name: "PXMD - PaxMedica, Inc.", ticker: "PXMD" },
    { name: "ACEV-UN - ACE Convergence Acquisition Corp.", ticker: "ACEV-UN" },
    { name: "BOWXU - BowX Acquisition Corp.", ticker: "BOWXU" },
    { name: "VMAR - Vision Marine Technologies Inc.", ticker: "VMAR" },
    { name: "PRPB-UN - CC Neuberger Principal Holdings II", ticker: "PRPB-UN" },
    { name: "TWND-UN - Tailwind Acquisition Corp.", ticker: "TWND-UN" },
    { name: "KSMTU - Kismet Acquisition One Corp", ticker: "KSMTU" },
    { name: "BTWNU - Bridgetown Holdings Ltd", ticker: "BTWNU" },
    { name: "ILAG - Intelligent Living Application Group Inc.", ticker: "ILAG" },
    { name: "ETACU - E.Merge Technology Acquisition Corp.", ticker: "ETACU" },
    { name: "JZXN - Jiuzi Holdings, Inc.", ticker: "JZXN" },
    { name: "FCACU - Falcon Capital Acquisition Corp.", ticker: "FCACU" },
    { name: "ENPC-UN - Executive Network Partnering Corp", ticker: "ENPC-UN" },
    { name: "GOAC-UN - GO Acquisition Corp.", ticker: "GOAC-UN" },
    { name: "CLA-UN - Colonnade Acquisition Corp.", ticker: "CLA-UN" },
    { name: "FST-UN - FAST Acquisition Corp.", ticker: "FST-UN" },
    { name: "NGA-UN - Northern Genesis Acquisition Corp.", ticker: "NGA-UN" },
    { name: "RBAC-UN - RedBall Acquisition Corp.", ticker: "RBAC-UN" },
    { name: "YAC-UN - Yucaipa Acquisition Corp", ticker: "YAC-UN" },
    { name: "BSN-UN - Broadstone Acquisition Corp.", ticker: "BSN-UN" },
    { name: "FAII-UN - Fortress Value Acquisition Corp. II", ticker: "FAII-UN" },
    { name: "LU - Lufax Holding Ltd", ticker: "LU" },
    { name: "NSH-UN - NavSight Holdings, Inc.", ticker: "NSH-UN" },
    { name: "GRDAF - Guardforce AI Co., Ltd", ticker: "GRDAF" },
    { name: "HDLS - Hub Deals Corp.", ticker: "HDLS" },
    { name: "NGIO - NUGENEREX IMMUNO-ONCOLOGY, INC.", ticker: "NGIO" },
    { name: "VGAC-UN - VG Acquisition Corp.", ticker: "VGAC-UN" },
    { name: "AMHG - Amergent Hospitality Group, Inc", ticker: "AMHG" },
    { name: "LGVW-UN - Longview Acquisition Corp.", ticker: "LGVW-UN" },
    { name: "BMRG-UN - B. Riley Principal Merger Corp. II", ticker: "BMRG-UN" },
    { name: "CPSR-UN - CAPSTAR SPECIAL PURPOSE ACQUISITION CORP.", ticker: "CPSR-UN" },
    { name: "GIK-UN - GigCapital3, Inc.", ticker: "GIK-UN" },
    { name: "SCIT - Sancai Holding Group Ltd.", ticker: "SCIT" },
    { name: "MACUU - Mallard Acquisition Corp.", ticker: "MACUU" },
    { name: "PSACU - Property Solutions Acquisition Corp.", ticker: "PSACU" },
    { name: "ACND-UN - Ascendant Digital Acquisition Corp.", ticker: "ACND-UN" },
    { name: "NHICU - NewHold Investment Corp.", ticker: "NHICU" },
    { name: "HYGO - Hygo Energy Transition Ltd.", ticker: "HYGO" },
    { name: "PMVC-UN - PMV Consumer Acquisition Corp.", ticker: "PMVC-UN" },
    { name: "MLACU - Malacca Straits Acquisition Co Ltd", ticker: "MLACU" },
    { name: "PTK-UN - PTK Acquisition Corp.", ticker: "PTK-UN" },
    { name: "DFPHU - DFP HEALTHCARE ACQUISITIONS CORP.", ticker: "DFPHU" },
    { name: "AUNA - AUNA S.A.A.", ticker: "AUNA" },
    { name: "DDI - DoubleDown Interactive Co., Ltd.", ticker: "DDI" },
    { name: "ASLE - Monocle Holdings Inc.", ticker: "ASLE" },
    { name: "GTWY - GTWY Holdings Ltd", ticker: "GTWY" },
    { name: "ROCHU - Roth CH Acquisition I Co", ticker: "ROCHU" },
    { name: "CHAQ-UN - Chardan Healthcare Acquisition 2 Corp.", ticker: "CHAQ-UN" },
    { name: "WCAP - White Cap Supply Holdings, Inc.", ticker: "WCAP" },
    { name: "GLTO - Galecto Inc.", ticker: "GLTO" },
    { name: "BYNOU - byNordic Acquisition Corp", ticker: "BYNOU" },
    { name: "PRFX - PAINREFORM LTD.", ticker: "PRFX" },
    { name: "LCAPU - Lionheart Acquisition Corp. II", ticker: "LCAPU" },
    { name: "EIC - Eagle Point Income Co Inc.", ticker: "EIC" },
    { name: "AAIDX - Axonic Alternative Income Fund", ticker: "AAIDX" },
    { name: "SDWL - Shengda Network Technology, Inc.", ticker: "SDWL" },
    { name: "HZ - HeZhong International (Holding) Ltd", ticker: "HZ" },
    { name: "SFTW-UN - Osprey Technology Acquisition Corp.", ticker: "SFTW-UN" },
    { name: "GXGXU - GX Acquisition Corp.", ticker: "GXGXU" },
    { name: "UNXP - United Express Inc.", ticker: "UNXP" },
    { name: "MUGH - MU GLOBAL HOLDING Ltd", ticker: "MUGH" },
    { name: "FBOX - Fit Boxx Holdings Ltd", ticker: "FBOX" },
    { name: "PRMI - Priam Properties Inc.", ticker: "PRMI" },
    { name: "OWSCX - 1WS Credit Income Fund", ticker: "OWSCX" },
    { name: "NEOV - NeoVolta Inc.", ticker: "NEOV" },
    { name: "BELP - Belpointe REIT, Inc.", ticker: "BELP" },
    { name: "OGAA - Organic Agricultural Co Ltd", ticker: "OGAA" },
    { name: "HFEN - HF Enterprises Inc.", ticker: "HFEN" },
    { name: "BXT - United States Bitcoin & Treasury Investment Trust", ticker: "BXT" },
    { name: "IKT - Inhibikase Therapeutics, Inc.", ticker: "IKT" },
    { name: "BKSW - Baikang Biological Group Holdings Ltd", ticker: "BKSW" },
    { name: "STPK-UN - Star Peak Energy Transition Corp.", ticker: "STPK-UN" },
    { name: "MEDU - Meten International Education Group", ticker: "MEDU" },
    { name: "BEER - Bricktown Brewery Restaurants LLC", ticker: "BEER" },
    { name: "UWHGF - United World Holding Group Ltd.", ticker: "UWHGF" },
    { name: "SEAV - SEATech Ventures Corp.", ticker: "SEAV" },
    { name: "CPRDX - Clarion Partners Real Estate Income Fund Inc.", ticker: "CPRDX" },
    { name: "REEY - REED Ltd", ticker: "REEY" },
    { name: "SFT - SHIFT TECHNOLOGIES, INC.", ticker: "SFT" },
    { name: "GMVD - G Medical Innovations Holdings Ltd.", ticker: "GMVD" },
    { name: "JUPW - Jupiter Wellness, Inc.", ticker: "JUPW" },
    { name: "ONL - Oxford Northeast Ltd.", ticker: "ONL" },
    { name: "EJH - E-Home Household Service Holdings Ltd", ticker: "EJH" },
    { name: "MITQ - MOVING iMAGE TECHNOLOGIES INC.", ticker: "MITQ" },
    { name: "CMDS - CloudMinds Inc.", ticker: "CMDS" },
    { name: "GRCYU - Greencity Acquisition Corp", ticker: "GRCYU" },
    { name: "QQCY - Green Grass Ecological Technology Development Co., Ltd.", ticker: "QQCY" },
    { name: "DFWH - Oriental Culture Holding LTD", ticker: "DFWH" },
    { name: "WEIX - Dynamic Shares Trust", ticker: "WEIX" },
    { name: "DFNS-UN - LGL Systems Acquisition Corp.", ticker: "DFNS-UN" },
    { name: "QLI - Qilian International Holding Group Ltd", ticker: "QLI" },
    { name: "ZGHB - China Eco-Materials Group Co. Ltd", ticker: "ZGHB" },
    { name: "ML - Meili Auto Holdings Ltd", ticker: "ML" },
    { name: "NWRCF - Northway Resources Corp.", ticker: "NWRCF" },
    { name: "TIRX - TIAN RUIXIANG HOLDINGS LTD", ticker: "TIRX" },
    { name: "SBGLF - Sibanye-Stillwater Limited/ADR", ticker: "SBGLF" },
    { name: "GJCU - GJ Culture Group US, Inc.", ticker: "GJCU" },
    { name: "YGMZ - MingZhu Logistics Holdings Ltd", ticker: "YGMZ" },
    { name: "GMWX - GameWorks, Inc.", ticker: "GMWX" },
    { name: "GIP - Global Internet of People, Inc.", ticker: "GIP" },
    { name: "CNEY - CN ENERGY GROUP, INC.", ticker: "CNEY" },
    { name: "IPV-UN - InterPrivate Acquisition Corp.", ticker: "IPV-UN" },
    { name: "DPUI - DISCOUNT PRINT USA, INC.", ticker: "DPUI" },
    { name: "VTRS - Upjohn Inc", ticker: "VTRS" },
    { name: "GOXS - Goxus, Inc", ticker: "GOXS" },
    { name: "HUDI - Huadi International Group Co., Ltd.", ticker: "HUDI" },
    { name: "GNRSU - Greenrose Acquisition Corp.", ticker: "GNRSU" },
    { name: "CLHN - Cole Haan, Inc.", ticker: "CLHN" },
    { name: "SVACU - STARBOARD VALUE ACQUISITION CORP.", ticker: "SVACU" },
    { name: "SVIX - VS Trust", ticker: "SVIX" },
    { name: "UTXOU - UTXO Acquisition Inc.", ticker: "UTXOU" },
    { name: "NOTR - Nowtransit Inc", ticker: "NOTR" },
    { name: "CHPMU - CHP Merger Corp.", ticker: "CHPMU" },
    { name: "CDP - CDP Holdings, Ltd", ticker: "CDP" },
    { name: "EXCL - Excellerant, Inc.", ticker: "EXCL" },
    { name: "LOHA - LOHA CO. LTD.", ticker: "LOHA" },
    { name: "CARH - Car House Holding Co., Ltd.", ticker: "CARH" },
    { name: "MVNR - Mavenir Private Holdings II Ltd.", ticker: "MVNR" },
    { name: "FLRZ - F5 Finishes, Inc", ticker: "FLRZ" },
    { name: "ROOT - Root, Inc.", ticker: "ROOT" },
    { name: "AMHCU - Amplitude Healthcare Acquisition Corp", ticker: "AMHCU" },
    { name: "JIH-UN - Juniper Industrial Holdings, Inc.", ticker: "JIH-UN" },
    { name: "WNW - Wunong Net Technology Co Ltd", ticker: "WNW" },
    { name: "HTHC - Hightimes Holding Corp.", ticker: "HTHC" },
    { name: "BUR - Burford Capital Ltd", ticker: "BUR" },
    { name: "DCRBU - Decarbonization Plus Acquisition Corp", ticker: "DCRBU" },
    { name: "VVOS - Vivos Therapeutics, Inc.", ticker: "VVOS" },
    { name: "ATTP - Agape ATP Corp", ticker: "ATTP" },
    { name: "AANC - Andover National Corp", ticker: "AANC" },
    { name: "BTBD - BT Brands, Inc.", ticker: "BTBD" },
    { name: "GRAL - Grail, Inc.", ticker: "GRAL" },
    { name: "YJGJ - YIJIA GROUP CORP.", ticker: "YJGJ" },
    { name: "AIDG - AIS Holdings Group, Inc.", ticker: "AIDG" },
    { name: "KYHHY - Kyushu Railway Company/ADR", ticker: "KYHHY" },
    { name: "VRPX - Virpax Pharmaceuticals, Inc.", ticker: "VRPX" },
    { name: "ETCG - Grayscale Ethereum Classic Trust (ETC)", ticker: "ETCG" },
    { name: "UGRO - urban-gro, Inc.", ticker: "UGRO" },
    { name: "PMTG - PIMCO Mortgage Income Trust Inc.", ticker: "PMTG" },
    { name: "HKIT - HiTek Global Inc.", ticker: "HKIT" },
    { name: "CWPE - CW Petroleum Corp", ticker: "CWPE" },
    { name: "TTCF - Tattooed Chef, Inc.", ticker: "TTCF" },
    { name: "LXAM - Lux Amber, Corp.", ticker: "LXAM" },
    { name: "INAB - IN8BIO, INC.", ticker: "INAB" },
    { name: "CMPX - Compass Therapeutics, Inc.", ticker: "CMPX" },
    { name: "CNROX - City National Rochdale Strategic Credit Fund", ticker: "CNROX" },
    { name: "CCLFX - Cliffwater Corporate Lending Fund", ticker: "CCLFX" },
    { name: "NICHX - Variant Alternative Income Fund", ticker: "NICHX" },
    { name: "FNNAX - FS Multi-Alternative Income Fund", ticker: "FNNAX" },
    { name: "LDSN - Luduson G Inc.", ticker: "LDSN" },
    { name: "NTAR - NexTech AR Solutions Corp.", ticker: "NTAR" },
    { name: "JMEXF - JMAX INTERNATIONAL Ltd", ticker: "JMEXF" },
    { name: "AEXL - AXELEREX CORP.", ticker: "AEXL" },
    { name: "WALL - Golden Metropolis International Ltd", ticker: "WALL" },
    { name: "MSP - DATTO HOLDING CORP.", ticker: "MSP" },
    { name: "UCASU - UC Asset LP", ticker: "UCASU" },
    { name: "FQJR - FUQIN FINTECH LTD", ticker: "FQJR" },
    { name: "CEDAX - Destra International & Event-Driven Credit Fund", ticker: "CEDAX" },
    { name: "TAKAX - Carlyle Tactical Private Credit Fund", ticker: "TAKAX" },
    { name: "ETHE - Grayscale Ethereum Trust (ETH)", ticker: "ETHE" },
    { name: "FROPX - Flat Rock Opportunity Fund", ticker: "FROPX" },
    { name: "RCHR - ArcherDX, Inc.", ticker: "RCHR" },
    { name: "SDEC - Smart Decision, Inc.", ticker: "SDEC" },
    { name: "CSCA - CORNERSTONE MANAGEMENT, INC.", ticker: "CSCA" },
    { name: "GOOGL - Alphabet Inc.", ticker: "GOOGL" },
    { name: "TCTZF - Tencent Holdings Ltd", ticker: "TCTZF" },
    { name: "HSBC-PA - HSBC HOLDINGS PLC", ticker: "HSBC-PA" },
    { name: "BRK-B - BERKSHIRE HATHAWAY INC", ticker: "BRK-B" },
    { name: "SAN-PB - Banco Santander, S.A.", ticker: "SAN-PB" },
    { name: "BML-PL - BANK OF AMERICA CORP /DE/", ticker: "BML-PL" },
    { name: "BAC-PE - BANK OF AMERICA CORP /DE/", ticker: "BAC-PE" },
    { name: "BML-PG - BANK OF AMERICA CORP /DE/", ticker: "BML-PG" },
    { name: "BML-PH - BANK OF AMERICA CORP /DE/", ticker: "BML-PH" },
    { name: "BML-PJ - BANK OF AMERICA CORP /DE/", ticker: "BML-PJ" },
    { name: "BAC-PL - BANK OF AMERICA CORP /DE/", ticker: "BAC-PL" },
    { name: "BAC-PB - BANK OF AMERICA CORP /DE/", ticker: "BAC-PB" },
    { name: "BAC-PK - BANK OF AMERICA CORP /DE/", ticker: "BAC-PK" },
    { name: "BAC-PC - BANK OF AMERICA CORP /DE/", ticker: "BAC-PC" },
    { name: "LVMHF - LVMH MOET HENNESSY LOUIS VUITTON", ticker: "LVMHF" },
    { name: "IDCBF - Industrial & Commercial Bank of China", ticker: "IDCBF" },
    { name: "WFC-PX - WELLS FARGO & COMPANY/MN", ticker: "WFC-PX" },
    { name: "WFC-PN - WELLS FARGO & COMPANY/MN", ticker: "WFC-PN" },
    { name: "WFC-PO - WELLS FARGO & COMPANY/MN", ticker: "WFC-PO" },
    { name: "WFC-PY - WELLS FARGO & COMPANY/MN", ticker: "WFC-PY" },
    { name: "WFC-PP - WELLS FARGO & COMPANY/MN", ticker: "WFC-PP" },
    { name: "WFC-PT - WELLS FARGO & COMPANY/MN", ticker: "WFC-PT" },
    { name: "WFC-PQ - WELLS FARGO & COMPANY/MN", ticker: "WFC-PQ" },
    { name: "WFC-PL - WELLS FARGO & COMPANY/MN", ticker: "WFC-PL" },
    { name: "WFC-PR - WELLS FARGO & COMPANY/MN", ticker: "WFC-PR" },
    { name: "WFC-PW - WELLS FARGO & COMPANY/MN", ticker: "WFC-PW" },
    { name: "WFC-PV - WELLS FARGO & COMPANY/MN", ticker: "WFC-PV" },
    { name: "CICHF - China Construction Bank Corp", ticker: "CICHF" },
    { name: "TBB - AT&T INC.", ticker: "TBB" },
    { name: "ACGBF - Agricultural Bank of China Limited/ADR", ticker: "ACGBF" },
    { name: "C-PJ - CITIGROUP INC", ticker: "C-PJ" },
    { name: "C-PS - CITIGROUP INC", ticker: "C-PS" },
    { name: "CIHHF - China Merchants Bank Co., Ltd./ADR/", ticker: "CIHHF" },
    { name: "DHR-PA - DANAHER CORP /DE/", ticker: "DHR-PA" },
    { name: "UTX - RAYTHEON TECHNOLOGIES CORP", ticker: "UTX" },
    { name: "BACHF - BANK OF CHINA LTD", ticker: "BACHF" },
    { name: "JDCMF - JD.com, Inc.", ticker: "JDCMF" },
    { name: "SFTBF - SOFTBANK GROUP CORP", ticker: "SFTBF" },
    { name: "AAIGF - AIA Group Ltd/ADR", ticker: "AAIGF" },
    { name: "GS-PN - GOLDMAN SACHS GROUP INC", ticker: "GS-PN" },
    { name: "RY-PT - ROYAL BANK OF CANADA", ticker: "RY-PT" },
    { name: "HESAF - HERMES INTERNATIONAL S.C.A.", ticker: "HESAF" },
    { name: "ISG - ING GROEP NV", ticker: "ISG" },
    { name: "RDS-B - Royal Dutch Shell plc", ticker: "RDS-B" },
    { name: "USB-PH - US BANCORP \\DE\\", ticker: "USB-PH" },
    { name: "CTA-PB - DUPONT E I DE NEMOURS & CO", ticker: "CTA-PB" },
    { name: "GS-PA - GOLDMAN SACHS GROUP INC", ticker: "GS-PA" },
    { name: "PPRUF - Kering", ticker: "PPRUF" },
    { name: "USB-PP - US BANCORP \\DE\\", ticker: "USB-PP" },
    { name: "GS-PD - GOLDMAN SACHS GROUP INC", ticker: "GS-PD" },
    { name: "CHDRF - Christian Dior SE/ADR", ticker: "CHDRF" },
    { name: "MS-PA - MORGAN STANLEY", ticker: "MS-PA" },
    { name: "USB-PO - US BANCORP \\DE\\", ticker: "USB-PO" },
    { name: "USB-PM - US BANCORP \\DE\\", ticker: "USB-PM" },
    { name: "NTTYY - NIPPON TELEGRAPH & TELEPHONE CORP", ticker: "NTTYY" },
    { name: "MS-PK - MORGAN STANLEY", ticker: "MS-PK" },
    { name: "GS-PJ - GOLDMAN SACHS GROUP INC", ticker: "GS-PJ" },
    { name: "MS-PI - MORGAN STANLEY", ticker: "MS-PI" },
    { name: "GS-PK - GOLDMAN SACHS GROUP INC", ticker: "GS-PK" },
    { name: "AIQUF - L AIR LIQUIDE SA /FI", ticker: "AIQUF" },
    { name: "MS-PE - MORGAN STANLEY", ticker: "MS-PE" },
    { name: "MS-PF - MORGAN STANLEY", ticker: "MS-PF" },
    { name: "FRCOF - Fast Retailing Co Ltd", ticker: "FRCOF" },
    { name: "PUK-PA - PRUDENTIAL PLC", ticker: "PUK-PA" },
    { name: "DUK-PA - Duke Energy CORP", ticker: "DUK-PA" },
    { name: "CHGCF - Chugai Pharmaceutical Co., Ltd. / ADR", ticker: "CHGCF" },
    { name: "RBGPF - RECKITT BENCKISER GROUP PLC", ticker: "RBGPF" },
    { name: "SBGSF - SCHNEIDER ELECTRIC SA", ticker: "SBGSF" },
    { name: "DOGEF - Orsted A/S / ADR", ticker: "DOGEF" },
    { name: "BDXA - BECTON DICKINSON & CO", ticker: "BDXA" },
    { name: "DCUE - DOMINION ENERGY, INC", ticker: "DCUE" },
    { name: "EADSF - Airbus SE/ADR", ticker: "EADSF" },
    { name: "DDAIF - DAIMLER AG", ticker: "DDAIF" },
    { name: "ESLOF - ESSILOR INTERNATIONAL /FI", ticker: "ESLOF" },
    { name: "CCZ - COMCAST CORP", ticker: "CCZ" },
    { name: "HKXCF - Hong Kong Exchanges & Clearing Ltd", ticker: "HKXCF" },
    { name: "PNC-PQ - PNC FINANCIAL SERVICES GROUP, INC.", ticker: "PNC-PQ" },
    { name: "KDDIF - KDDI CORP", ticker: "KDDIF" },
    { name: "SPG-PJ - SIMON PROPERTY GROUP INC /DE/", ticker: "SPG-PJ" },
    { name: "SHECF - Shin-Etsu Chemical Co., Ltd.", ticker: "SHECF" },
    { name: "SFBQF - SOFTBANK GROUP CORP", ticker: "SFBQF" },
    { name: "BYDDF - BYD CO LTD", ticker: "BYDDF" },
    { name: "DKILF - Daikin Industries Ltd", ticker: "DKILF" },
    { name: "SCHW-PD - SCHWAB CHARLES CORP", ticker: "SCHW-PD" },
    { name: "SCHW-PC - SCHWAB CHARLES CORP", ticker: "SCHW-PC" },
    { name: "AIG-PA - AMERICAN INTERNATIONAL GROUP INC", ticker: "AIG-PA" },
    { name: "MET-PE - METLIFE INC", ticker: "MET-PE" },
    { name: "MET-PA - METLIFE INC", ticker: "MET-PA" },
    { name: "VCISF - VINCI /FI", ticker: "VCISF" },
    { name: "BNPQF - BNP PARIBAS", ticker: "BNPQF" },
    { name: "LZAGF - Lonza Group AG", ticker: "LZAGF" },
    { name: "CUAEF - China Shenhua Energy Co Ltd", ticker: "CUAEF" },
    { name: "PBR-A - PETROBRAS - PETROLEO BRASILEIRO SA", ticker: "PBR-A" },
    { name: "OLCLF - Oriental Land Co., Ltd./ADR", ticker: "OLCLF" },
    { name: "SAFRF - SAFRAN S.A.", ticker: "SAFRF" },
    { name: "KNYJF - Kone OYJ", ticker: "KNYJF" },
    { name: "FMCKK - FEDERAL HOME LOAN MORTGAGE CORP", ticker: "FMCKK" },
    { name: "FMCCT - FEDERAL HOME LOAN MORTGAGE CORP", ticker: "FMCCT" },
    { name: "JARLF - JARDINE MATHESON HOLDINGS LTD \\ /FI", ticker: "JARLF" },
    { name: "MRAAF - Murata Manufacturing Co., Ltd./ADR", ticker: "MRAAF" },
    { name: "BKFCF - Bank of Communications Co Ltd", ticker: "BKFCF" },
    { name: "FREJP - FEDERAL HOME LOAN MORTGAGE CORP", ticker: "FREJP" },
    { name: "PDRDF - PERNOD RICARD S A /FI", ticker: "PDRDF" },
    { name: "COF-PG - CAPITAL ONE FINANCIAL CORP", ticker: "COF-PG" },
    { name: "NTOIF - Neste OYJ", ticker: "NTOIF" },
    { name: "FREJO - FEDERAL HOME LOAN MORTGAGE CORP", ticker: "FREJO" },
    { name: "CHPXF - China Pacific Insurance (Group) Co., Ltd./ADR", ticker: "CHPXF" },
    { name: "AMOV - AMERICA MOVIL SAB DE CV/", ticker: "AMOV" },
    { name: "TOELF - Tokyo Electron LTD", ticker: "TOELF" },
    { name: "COF-PH - CAPITAL ONE FINANCIAL CORP", ticker: "COF-PH" },
    { name: "VOLAF - AKTIEBOLAGET VOLVO \\PUBL\\", ticker: "VOLAF" },
    { name: "VOLVF - AKTIEBOLAGET VOLVO \\PUBL\\", ticker: "VOLVF" },
    { name: "ENBA - ENBRIDGE INC", ticker: "ENBA" },
    { name: "COF-PF - CAPITAL ONE FINANCIAL CORP", ticker: "COF-PF" },
    { name: "BK-PC - Bank of New York Mellon Corp", ticker: "BK-PC" },
    { name: "LDNXF - London Stock Exchange Group", ticker: "LDNXF" },
    { name: "AHCHF - Anhui Conch Cement Co Ltd\\ADR", ticker: "AHCHF" },
    { name: "GVDBF - GIVAUDAN SA /FI", ticker: "GVDBF" },
    { name: "CFRHF - COMPAGNIE FINANCIERE RICHEMONT AG /FI", ticker: "CFRHF" },
    { name: "VNNVF - Vonovia SE/ADR", ticker: "VNNVF" },
    { name: "JDSHF - JARDINE STRATEGIC HOLDINGS LTD /FI", ticker: "JDSHF" },
    { name: "ECIFF - ELECTRICITE DE FRANCE S.A.", ticker: "ECIFF" },
    { name: "WFAFF - WESFARMERS LTD", ticker: "WFAFF" },
    { name: "FANUF - Fanuc Ltd", ticker: "FANUF" },
    { name: "STZB - CONSTELLATION BRANDS, INC.", ticker: "STZB" },
    { name: "ITOCF - ITOCHU CORP", ticker: "ITOCF" },
    { name: "ALL-PG - ALLSTATE CORP", ticker: "ALL-PG" },
    { name: "DNZOF - Denso Corp", ticker: "DNZOF" },
    { name: "S - SPRINT Corp", ticker: "S" },
    { name: "ALL-PH - ALLSTATE CORP", ticker: "ALL-PH" },
    { name: "VWSYF - VESTAS WIND SYSTEMS A/S", ticker: "VWSYF" },
    { name: "YAHOF - Yahoo! Japan Corp", ticker: "YAHOF" },
    { name: "ALL-PB - ALLSTATE CORP", ticker: "ALL-PB" },
    { name: "HMRZF - H&M HENNES & MAURITZ AB", ticker: "HMRZF" },
    { name: "CHBJF - China CITIC Bank Corp Limited/ADR/", ticker: "CHBJF" },
    { name: "CLPBF - COLOPLAST A/S", ticker: "CLPBF" },
    { name: "VIVEF - VIVENDI", ticker: "VIVEF" },
    { name: "CGMBF - China Minsheng Banking Corp., Ltd.", ticker: "CGMBF" },
    { name: "TCANF - TC ENERGY CORP", ticker: "TCANF" },
    { name: "CRBJF - China Resources Land Ltd / ADR", ticker: "CRBJF" },
    { name: "LNGPF - Longfor Group Holdings Limited/ADR", ticker: "LNGPF" },
    { name: "BBDO - BANK BRADESCO", ticker: "BBDO" },
    { name: "TNCAF - TC ENERGY CORP", ticker: "TNCAF" },
    { name: "MTRJF - MTR CORP LTD", ticker: "MTRJF" },
    { name: "ADRNY - Royal Ahold Delhaize", ticker: "ADRNY" },
    { name: "DBOEF - Deutsche Boerse", ticker: "DBOEF" },
    { name: "SVNDF - SEVEN & I HOLDINGS CO LTD", ticker: "SVNDF" },
    { name: "BFB - BROWN FORMAN CORP", ticker: "BFB" },
    { name: "DLR-PK - DIGITAL REALTY TRUST, INC.", ticker: "DLR-PK" },
    { name: "SCHYF - Sands China Ltd. /ADR", ticker: "SCHYF" },
    { name: "GLCNF - Glencore plc/ADR", ticker: "GLCNF" },
    { name: "HCMLF - LafargeHolcim Ltd/ADR", ticker: "HCMLF" },
    { name: "TRUMF - Terumo Corp", ticker: "TRUMF" },
    { name: "GWLLF - Great Wall Motor Co Limited/ADR", ticker: "GWLLF" },
    { name: "OVCHF - Oversea-Chinese Banking Corp / ADR", ticker: "OVCHF" },
    { name: "UNCHF - Unicharm Corp", ticker: "UNCHF" },
    { name: "DLR-PJ - DIGITAL REALTY TRUST, INC.", ticker: "DLR-PJ" },
    { name: "ASAZF - ASSA ABLOY AB", ticker: "ASAZF" },
    { name: "CTRYF - Country Garden Holdings Co Ltd /ADR", ticker: "CTRYF" },
    { name: "DLR-PG - DIGITAL REALTY TRUST, INC.", ticker: "DLR-PG" },
    { name: "CJPRF - CENTRAL JAPAN RAILWAY CO", ticker: "CJPRF" },
    { name: "SOJC - SOUTHERN CO", ticker: "SOJC" },
    { name: "TSCDF - TESCO PLC /FI", ticker: "TSCDF" },
    { name: "PDYPF - Paddy Power plc/ADR", ticker: "PDYPF" },
    { name: "ALPMF - Astellas Pharma Inc", ticker: "ALPMF" },
    { name: "SOJB - SOUTHERN CO", ticker: "SOJB" },
    { name: "LBRDB - Liberty Broadband Corp", ticker: "LBRDB" },
    { name: "EGRNF - China Evergrande Group/ADR", ticker: "EGRNF" },
    { name: "DLR-PC - DIGITAL REALTY TRUST, INC.", ticker: "DLR-PC" },
    { name: "DLR-PI - DIGITAL REALTY TRUST, INC.", ticker: "DLR-PI" },
    { name: "LBRDK - Liberty Broadband Corp", ticker: "LBRDK" },
    { name: "FTV-PA - Fortive Corp", ticker: "FTV-PA" },
    { name: "CRARF - CREDIT AGRICOLE S A", ticker: "CRARF" },
    { name: "AMADF - Amadeus IT Group, S.A./ADR", ticker: "AMADF" },
    { name: "KHNGF - Kuehne & Nagel International AG / ADR", ticker: "KHNGF" },
    { name: "ETP-PE - Energy Transfer Operating, L.P.", ticker: "ETP-PE" },
    { name: "ZLDSF - Zalando SE/ADR", ticker: "ZLDSF" },
    { name: "HTNGF - Haitong Securities Co., LTD/ADR", ticker: "HTNGF" },
    { name: "ZIJMF - Zijin Mining Group Co., Ltd./ADR", ticker: "ZIJMF" },
    { name: "SAXPF - Sampo OYJ", ticker: "SAXPF" },
    { name: "CKHUF - CK Hutchison Holdings Limited/ADR", ticker: "CKHUF" },
    { name: "AONNF - AEON CO., LTD.", ticker: "AONNF" },
    { name: "ARZGF - Assicurazioni Generali S.p.A.", ticker: "ARZGF" },
    { name: "Z - ZILLOW GROUP, INC.", ticker: "Z" },
    { name: "EJPRF - EAST JAPAN RAILWAY CO /FI", ticker: "EJPRF" },
    { name: "ZTCOF - ZTE CORP", ticker: "ZTCOF" },
    { name: "STT-PG - STATE STREET CORP", ticker: "STT-PG" },
    { name: "KBCSF - KBC Group NV", ticker: "KBCSF" },
    { name: "KKR-PA - KKR & Co. Inc.", ticker: "KKR-PA" },
    { name: "GBERF - GEBERIT AG", ticker: "GBERF" },
    { name: "CODGF - COMPAGNIE DE SAINT GOBAIN", ticker: "CODGF" },
    { name: "ETP-PD - Energy Transfer Operating, L.P.", ticker: "ETP-PD" },
    { name: "STT-PD - STATE STREET CORP", ticker: "STT-PD" },
    { name: "OTSKF - Otsuka Holdings Co., Ltd./ADR", ticker: "OTSKF" },
    { name: "CAPMF - CAP GEMINI SA", ticker: "CAPMF" },
    { name: "GELYF - Geely Automobile Holdings Limited/ADR", ticker: "GELYF" },
    { name: "SZKMF - SUZUKI MOTOR CORP", ticker: "SZKMF" },
    { name: "KYOCF - KYOCERA CORP", ticker: "KYOCF" },
    { name: "HIG-PG - HARTFORD FINANCIAL SERVICES GROUP, INC.", ticker: "HIG-PG" },
    { name: "KYOCY - KYOCERA CORP", ticker: "KYOCY" },
    { name: "GCTAF - GAMESA S A /FI", ticker: "GCTAF" },
    { name: "GASNF - GAS NATURAL SDG SA", ticker: "GASNF" },
    { name: "UCBJF - UCB S.A.", ticker: "UCBJF" },
    { name: "BAESF - BAE SYSTEMS PLC /FI/", ticker: "BAESF" },
    { name: "SSMXF - Sysmex Corporation/ADR", ticker: "SSMXF" },
    { name: "TYIDF - TOYOTA INDUSTRIES CORP /FI", ticker: "TYIDF" },
    { name: "MGDDF - MICHELIN COMPAGNIE GENERALE DES ETABLISSEMENTS MICHELIN /FI", ticker: "MGDDF" },
    { name: "AKZOF - AKZO NOBEL NV", ticker: "AKZOF" },
    { name: "FITBI - FIFTH THIRD BANCORP", ticker: "FITBI" },
    { name: "SGSOF - SGS SOCIETE GENERALE DE SURVEILLANCE HOLDING SA /FI", ticker: "SGSOF" },
    { name: "KKR-PB - KKR & Co. Inc.", ticker: "KKR-PB" },
    { name: "SBMFF - Sino Biopharmaceutical Limited/ADR", ticker: "SBMFF" },
    { name: "FOJCF - Fortum OYJ", ticker: "FOJCF" },
    { name: "TLPFF - Teleperformance SA / ADR", ticker: "TLPFF" },
    { name: "SYIEF - Symrise AG", ticker: "SYIEF" },
    { name: "WEICF - Weichai Power Co., Ltd. / ADR", ticker: "WEICF" },
    { name: "NVZMF - NOVOZYMES AS/FI", ticker: "NVZMF" },
    { name: "FRRVF - CINTRA Concesiones de Infraestructuras", ticker: "FRRVF" },
    { name: "RBSPF - NatWest Group plc", ticker: "RBSPF" },
    { name: "SHMDF - Shimano Inc./ADR", ticker: "SHMDF" },
    { name: "POAHF - Porsche Automobil Holding SE / ADR", ticker: "POAHF" },
    { name: "SVNLF - Svenska Handelsbanken AB", ticker: "SVNLF" },
    { name: "PPERF - PT Bank Mandiri (Persero) Tbk / ADR", ticker: "PPERF" },
    { name: "TLSNF - TELIA Co AB", ticker: "TLSNF" },
    { name: "MTSFF - Mitsui Fudosan Co Ltd", ticker: "MTSFF" },
    { name: "FRC-PI - FIRST REPUBLIC BANK", ticker: "FRC-PI" },
    { name: "ASHTF - Ashtead Group plc/ADR", ticker: "ASHTF" },
    { name: "BIO-B - BIO-RAD LABORATORIES, INC.", ticker: "BIO-B" },
    { name: "SNMRF - Snam Rete Gas SpA", ticker: "SNMRF" },
    { name: "VIACA - ViacomCBS Inc.", ticker: "VIACA" },
    { name: "FRC-PH - FIRST REPUBLIC BANK", ticker: "FRC-PH" },
    { name: "SONVF - Sonova Holding AG / ADR", ticker: "SONVF" },
    { name: "PEUGF - PEUGEOT S A /FI", ticker: "PEUGF" },
    { name: "THLEF - Thales S.A./ADR", ticker: "THLEF" },
    { name: "CFG-PD - CITIZENS FINANCIAL GROUP INC/RI", ticker: "CFG-PD" },
    { name: "CGHOF - China Gas Holdings LTD/ADR", ticker: "CGHOF" },
    { name: "FRC-PG - FIRST REPUBLIC BANK", ticker: "FRC-PG" },
    { name: "IMBBF - IMPERIAL TOBACCO GROUP PLC", ticker: "IMBBF" },
    { name: "OPHLF - ONO PHARMACEUTICAL CO LTD", ticker: "OPHLF" },
    { name: "PPCCF - PICC Property & Casualty Co Ltd", ticker: "PPCCF" },
    { name: "CWYCF - CHINA RAILWAY CONSTRUCTION CORP LTD", ticker: "CWYCF" },
    { name: "SWPFF - Swire Properties Limited/ADR", ticker: "SWPFF" },
    { name: "FRC-PF - FIRST REPUBLIC BANK", ticker: "FRC-PF" },
    { name: "FOX - Fox Corp", ticker: "FOX" },
    { name: "CCCGF - China Communications Construction Co", ticker: "CCCGF" },
    { name: "VNO-PK - VORNADO REALTY TRUST", ticker: "VNO-PK" },
    { name: "ACGLO - ARCH CAPITAL GROUP LTD.", ticker: "ACGLO" },
    { name: "LENB - LENNAR CORP /NEW/", ticker: "LENB" },
    { name: "SGIOF - SHIONOGI & CO LTD", ticker: "SGIOF" },
    { name: "FUJHF - FUJI HEAVY INDUSTRIES LTD /FI", ticker: "FUJHF" },
    { name: "RNECF - NEC ELECTRONICS CORP", ticker: "RNECF" },
    { name: "VNO-PM - VORNADO REALTY TRUST", ticker: "VNO-PM" },
    { name: "RKUNF - Rakuten, Inc.", ticker: "RKUNF" },
    { name: "MAA-PI - MID AMERICA APARTMENT COMMUNITIES INC.", ticker: "MAA-PI" },
    { name: "ATASF - Atlantia SpA", ticker: "ATASF" },
    { name: "BPYPP - Brookfield Property Partners L.P.", ticker: "BPYPP" },
    { name: "VNO-PL - VORNADO REALTY TRUST", ticker: "VNO-PL" },
    { name: "HEI-A - HEICO CORP", ticker: "HEI-A" },
    { name: "GJNSF - Gjensidige Forsikring ASA/ADR", ticker: "GJNSF" },
    { name: "SIOPF - Shimao Group Holdings Limited/ADR", ticker: "SIOPF" },
    { name: "APO-PB - Apollo Global Management, Inc.", ticker: "APO-PB" },
    { name: "LSXMK - Liberty Media Corp", ticker: "LSXMK" },
    { name: "APO-PA - Apollo Global Management, Inc.", ticker: "APO-PA" },
    { name: "HRNNF - Hydro One Ltd", ticker: "HRNNF" },
    { name: "NLY-PD - ANNALY CAPITAL MANAGEMENT INC", ticker: "NLY-PD" },
    { name: "FANDF - FirstRand Ltd / ADR", ticker: "FANDF" },
    { name: "AVTR-PA - Avantor, Inc.", ticker: "AVTR-PA" },
    { name: "CJEWF - Chow Tai Fook Jewellery Group Limited/ADR", ticker: "CJEWF" },
    { name: "SWSDF - Swiss Life Holding", ticker: "SWSDF" },
    { name: "PNC-PP - PNC FINANCIAL SERVICES GROUP, INC.", ticker: "PNC-PP" },
    { name: "IKTSF - Intertek Group plc", ticker: "IKTSF" },
    { name: "HLBZF - HeidelbergCement AG", ticker: "HLBZF" },
    { name: "LSXMB - Liberty Media Corp", ticker: "LSXMB" },
    { name: "XNGSF - ENN Energy Holdings Ltd / ADR", ticker: "XNGSF" },
    { name: "SCE-PD - SOUTHERN CALIFORNIA EDISON Co", ticker: "SCE-PD" },
    { name: "DVDCF - DAVIDE CAMPARI MILANO SPA", ticker: "DVDCF" },
    { name: "LBTYB - Liberty Global plc", ticker: "LBTYB" },
    { name: "LBTYK - Liberty Global plc", ticker: "LBTYK" },
    { name: "CKISF - CK Infrastructure Holdings Limited/ADR", ticker: "CKISF" },
    { name: "NNGPF - NN Group NV/ADR", ticker: "NNGPF" },
    { name: "EDNMF - Edenred/ADR", ticker: "EDNMF" },
    { name: "NLY-PF - ANNALY CAPITAL MANAGEMENT INC", ticker: "NLY-PF" },
    { name: "CTL - CENTURYLINK, INC", ticker: "CTL" },
    { name: "FXFLF - FAIRFAX FINANCIAL HOLDINGS LTD/ CAN", ticker: "FXFLF" },
    { name: "CIXPF - CaixaBank/ADR", ticker: "CIXPF" },
    { name: "SWP - STANLEY BLACK & DECKER, INC.", ticker: "SWP" },
    { name: "SWGAF - Swatch Group AG\\ADR", ticker: "SWGAF" },
    { name: "SWGNF - Swatch Group AG\\ADR", ticker: "SWGNF" },
    { name: "UBSFF - Ubisoft Entertainment SA", ticker: "UBSFF" },
    { name: "FRFGF - FAIRFAX FINANCIAL HOLDINGS LTD/ CAN", ticker: "FRFGF" },
    { name: "SZEVF - SUEZ ENVIRONNEMENT CO S.A.", ticker: "SZEVF" },
    { name: "KKPNF - KONINKLIJKE KPN N V", ticker: "KKPNF" },
    { name: "FNMAS - FEDERAL NATIONAL MORTGAGE ASSOCIATION FANNIE MAE", ticker: "FNMAS" },
    { name: "NLY-PG - ANNALY CAPITAL MANAGEMENT INC", ticker: "NLY-PG" },
    { name: "ILIAF - Iliad S.A./ADR", ticker: "ILIAF" },
    { name: "CNP-PB - CENTERPOINT ENERGY INC", ticker: "CNP-PB" },
    { name: "CRGGF - China Resources Gas Group Limited/ADR", ticker: "CRGGF" },
    { name: "JEC - JACOBS ENGINEERING GROUP INC /DE/", ticker: "JEC" },
    { name: "JXHGF - ENEOS Holdings, Inc./ADR", ticker: "JXHGF" },
    { name: "STBFF - Suntory Beverage & Food Limited/ADR", ticker: "STBFF" },
    { name: "SCE-PE - SOUTHERN CALIFORNIA EDISON Co", ticker: "SCE-PE" },
    { name: "SCE-PC - SOUTHERN CALIFORNIA EDISON Co", ticker: "SCE-PC" },
    { name: "WTR - Essential Utilities, Inc.", ticker: "WTR" },
    { name: "FRFFF - FAIRFAX FINANCIAL HOLDINGS LTD/ CAN", ticker: "FRFFF" },
    { name: "SCE-PB - SOUTHERN CALIFORNIA EDISON Co", ticker: "SCE-PB" },
    { name: "SURRF - Sun Art Retail Group Limited/ADR", ticker: "SURRF" },
    { name: "FAXXF - FAIRFAX FINANCIAL HOLDINGS LTD/ CAN", ticker: "FAXXF" },
    { name: "FRFXF - FAIRFAX FINANCIAL HOLDINGS LTD/ CAN", ticker: "FRFXF" },
    { name: "NURAF - NOMURA RESEARCH INSTITUTE LTD", ticker: "NURAF" },
    { name: "FNMAJ - FEDERAL NATIONAL MORTGAGE ASSOCIATION FANNIE MAE", ticker: "FNMAJ" },
    { name: "HRELF - Haier Electronics Group Co., Ltd./ADR", ticker: "HRELF" },
    { name: "FNMAT - FEDERAL NATIONAL MORTGAGE ASSOCIATION FANNIE MAE", ticker: "FNMAT" },
    { name: "UEPEO - UNION ELECTRIC CO", ticker: "UEPEO" },
    { name: "FNMAM - FEDERAL NATIONAL MORTGAGE ASSOCIATION FANNIE MAE", ticker: "FNMAM" },
    { name: "COIHF - Croda International Plc/ADR", ticker: "COIHF" },
    { name: "FRT-PC - FEDERAL REALTY INVESTMENT TRUST", ticker: "FRT-PC" },
    { name: "FNMFN - FEDERAL NATIONAL MORTGAGE ASSOCIATION FANNIE MAE", ticker: "FNMFN" },
    { name: "AOMFF - ALSTOM", ticker: "AOMFF" },
    { name: "FNMFM - FEDERAL NATIONAL MORTGAGE ASSOCIATION FANNIE MAE", ticker: "FNMFM" },
    { name: "JBARF - Julius Baer Group Ltd.", ticker: "JBARF" },
    { name: "FNMAI - FEDERAL NATIONAL MORTGAGE ASSOCIATION FANNIE MAE", ticker: "FNMAI" },
    { name: "UEPCN - UNION ELECTRIC CO", ticker: "UEPCN" },
    { name: "FNMAH - FEDERAL NATIONAL MORTGAGE ASSOCIATION FANNIE MAE", ticker: "FNMAH" },
    { name: "RMSYF - Ramsay Health Care Limited/ADR", ticker: "RMSYF" },
    { name: "UEPEP - UNION ELECTRIC CO", ticker: "UEPEP" },
    { name: "AMIGF - Admiral Group", ticker: "AMIGF" },
    { name: "FNMAG - FEDERAL NATIONAL MORTGAGE ASSOCIATION FANNIE MAE", ticker: "FNMAG" },
    { name: "GGDVF - GUANGDONG INVESTMENT LTD /FI", ticker: "GGDVF" },
    { name: "FNMAN - FEDERAL NATIONAL MORTGAGE ASSOCIATION FANNIE MAE", ticker: "FNMAN" },
    { name: "FNMAL - FEDERAL NATIONAL MORTGAGE ASSOCIATION FANNIE MAE", ticker: "FNMAL" },
    { name: "SGGEF - SAGE GROUP PLC", ticker: "SGGEF" },
    { name: "FNMAK - FEDERAL NATIONAL MORTGAGE ASSOCIATION FANNIE MAE", ticker: "FNMAK" },
    { name: "PSMMF - Persimmon", ticker: "PSMMF" },
    { name: "PRDSF - Prada S.p.A./ADR", ticker: "PRDSF" },
    { name: "RDEIF - Red Electrica Corporacion SA/ADR", ticker: "RDEIF" },
    { name: "UEPCP - UNION ELECTRIC CO", ticker: "UEPCP" },
    { name: "CHEOF - Cochlear Ltd / ADR", ticker: "CHEOF" },
    { name: "YASKF - Yaskawa Electric Corp/ADR", ticker: "YASKF" },
    { name: "NDEKF - NITTO DENKO CORP / ADR/", ticker: "NDEKF" },
    { name: "UEPEM - UNION ELECTRIC CO", ticker: "UEPEM" },
    { name: "FOSUF - Fosun International Ltd / ADR", ticker: "FOSUF" },
    { name: "MTUAF - MTU AERO ENGINES HOLDING AG", ticker: "MTUAF" },
    { name: "RANJF - RANDSTAD HOLDING NV /FI", ticker: "RANJF" },
    { name: "CICOF - COSCO SHIPPING Holdings Co., Ltd./ADR", ticker: "CICOF" },
    { name: "BNTGF - Brenntag AG/ADR", ticker: "BNTGF" },
    { name: "RZB - REINSURANCE GROUP OF AMERICA INC", ticker: "RZB" },
    { name: "HGH - HARTFORD FINANCIAL SERVICES GROUP, INC.", ticker: "HGH" },
    { name: "UMICF - Umicore/ADR", ticker: "UMICF" },
    { name: "FNMFO - FEDERAL NATIONAL MORTGAGE ASSOCIATION FANNIE MAE", ticker: "FNMFO" },
    { name: "ZLIOF - Zoomlion Heavy Industry Science & Technology Co., Ltd./ADR", ticker: "ZLIOF" },
    { name: "MARUF - MARUBENI CORP /FI", ticker: "MARUF" },
    { name: "DISCB - Discovery, Inc.", ticker: "DISCB" },
    { name: "NISTF - NIPPON STEEL CORP", ticker: "NISTF" },
    { name: "KIKOF - Kikkoman Corp", ticker: "KIKOF" },
    { name: "GS-PC - GOLDMAN SACHS GROUP INC", ticker: "GS-PC" },
    { name: "FNMAO - FEDERAL NATIONAL MORTGAGE ASSOCIATION FANNIE MAE", ticker: "FNMAO" },
    { name: "VER-PF - VEREIT, Inc.", ticker: "VER-PF" },
    { name: "ALFVF - ALFA LAVAL AB /FI", ticker: "ALFVF" },
    { name: "NNN-PF - NATIONAL RETAIL PROPERTIES, INC.", ticker: "NNN-PF" },
    { name: "AMH-PH - American Homes 4 Rent", ticker: "AMH-PH" },
    { name: "SHWGF - Shandong Weigao Group Medical Polymer Co Limited/ADR", ticker: "SHWGF" },
    { name: "AMH-PG - American Homes 4 Rent", ticker: "AMH-PG" },
    { name: "AMH-PF - American Homes 4 Rent", ticker: "AMH-PF" },
    { name: "AHEXF - Adecco Group AG/ADR", ticker: "AHEXF" },
    { name: "EBR-B - BRAZILIAN ELECTRIC POWER CO", ticker: "EBR-B" },
    { name: "UEPEN - UNION ELECTRIC CO", ticker: "UEPEN" },
    { name: "STMNF - Sumitomo Metal Mining Co., LTD./ADR", ticker: "STMNF" },
    { name: "PGPEF - PUBLICIS GROUPE SA", ticker: "PGPEF" },
    { name: "ERRAF - EMERA INC", ticker: "ERRAF" },
    { name: "CNPAF - CNP Assurances SA / ADR", ticker: "CNPAF" },
    { name: "VOYA-PB - Voya Financial, Inc.", ticker: "VOYA-PB" },
    { name: "TLTZY - TELE2 AB", ticker: "TLTZY" },
    { name: "TLTZF - TELE2 AB", ticker: "TLTZF" },
    { name: "ASEKF - Aisin Seiki Co., Ltd./ADR", ticker: "ASEKF" },
    { name: "HRGLF - Hargreaves Lansdown PLC/ADR", ticker: "HRGLF" },
    { name: "AMH-PE - American Homes 4 Rent", ticker: "AMH-PE" },
    { name: "AMH-PD - American Homes 4 Rent", ticker: "AMH-PD" },
    { name: "ATH-PA - Athene Holding Ltd", ticker: "ATH-PA" },
    { name: "KIM-PM - KIMCO REALTY CORP", ticker: "KIM-PM" },
    { name: "RNR-PF - RENAISSANCERE HOLDINGS LTD", ticker: "RNR-PF" },
    { name: "HEGIF - Hengan International Group Co. Ltd.", ticker: "HEGIF" },
    { name: "KIM-PL - KIMCO REALTY CORP", ticker: "KIM-PL" },
    { name: "RNSDF - Renault SA Unsponsored ADR Facility", ticker: "RNSDF" },
    { name: "XYIGF - Xinyi Glass Holdings Limited/ADR", ticker: "XYIGF" },
    { name: "FWONK - Liberty Media Corp", ticker: "FWONK" },
    { name: "FWONA - Liberty Media Corp", ticker: "FWONA" },
    { name: "NWS - NEWS CORP", ticker: "NWS" },
    { name: "WILLF - Demant AS/ADR", ticker: "WILLF" },
    { name: "SNPHF - Santen Pharmaceutical Co Ltd/ADR", ticker: "SNPHF" },
    { name: "AGNCM - AGNC Investment Corp.", ticker: "AGNCM" },
    { name: "SMTOF - SUMITOMO ELECTRIC INDUSTRIES LTD/ADR/", ticker: "SMTOF" },
    { name: "AGNCN - AGNC Investment Corp.", ticker: "AGNCN" },
    { name: "RNR-PE - RENAISSANCERE HOLDINGS LTD", ticker: "RNR-PE" },
    { name: "SBYSF - Sibanye Stillwater Ltd", ticker: "SBYSF" },
    { name: "IAUGF - INSURANCE AUSTRALIA GROUP LTD", ticker: "IAUGF" },
    { name: "INGIF - INGENICO GROUP", ticker: "INGIF" },
    { name: "PRYMF - Prysmian S.p.A.", ticker: "PRYMF" },
    { name: "ACSAF - ACS Actividades de Construccion y Servicios SA", ticker: "ACSAF" },
    { name: "PCG-PA - PG&E Corp", ticker: "PCG-PA" },
    { name: "TSG - Flutter Entertainment plc", ticker: "TSG" },
    { name: "WYNMF - Wynn Macau Limited/ADR", ticker: "WYNMF" },
    { name: "CMSA - CMS ENERGY CORP", ticker: "CMSA" },
    { name: "TAP-A - MOLSON COORS BEVERAGE CO", ticker: "TAP-A" },
    { name: "RTMVF - Rightmove PLC/ADR", ticker: "RTMVF" },
    { name: "SHPMF - Shanghai Pharmaceuticals Holding Co., Ltd./ADR", ticker: "SHPMF" },
    { name: "MDIBF - Mediobanca - Banca di Credito Finanziario SpA", ticker: "MDIBF" },
    { name: "HTCMF - Hitachi Construction Machinery Co Ltd", ticker: "HTCMF" },
    { name: "GRPTF - Groupe Eurotunnel SA", ticker: "GRPTF" },
    { name: "IPXHF - INPEX HOLDINGS INC", ticker: "IPXHF" },
    { name: "CHKVP - CHESAPEAKE ENERGY CORP", ticker: "CHKVP" },
    { name: "PCG-PB - PG&E Corp", ticker: "PCG-PB" },
    { name: "TOKUF - TOKYU CORP", ticker: "TOKUF" },
    { name: "VOPKF - Koninklijke Vopak N.V. / ADR", ticker: "VOPKF" },
    { name: "KOSCF - Kose Corporation/ADR", ticker: "KOSCF" },
    { name: "SLFPF - STANDARD LIFE PLC", ticker: "SLFPF" },
    { name: "MAGOF - Man AG", ticker: "MAGOF" },
    { name: "AACAF - AAC Acoustic Technologies Holdings Inc.", ticker: "AACAF" },
    { name: "ATDRF - Auto Trader Group plc/ADR", ticker: "ATDRF" },
    { name: "OAK-PB - Oaktree Capital Group, LLC", ticker: "OAK-PB" },
    { name: "ASGLF - AGC Inc./ADR", ticker: "ASGLF" },
    { name: "UNBLF - Unibail-Rodamco SE/ADR", ticker: "UNBLF" },
    { name: "TISCF - TAISEI CORP LTD /ADR/", ticker: "TISCF" },
    { name: "PCG-PC - PG&E Corp", ticker: "PCG-PC" },
    { name: "GDI - Ingersoll Rand Inc.", ticker: "GDI" },
    { name: "ELUXF - AKTIEBOLAGET ELECTROLUX", ticker: "ELUXF" },
    { name: "PCG-PE - PG&E Corp", ticker: "PCG-PE" },
    { name: "PCG-PD - PG&E Corp", ticker: "PCG-PD" },
    { name: "PSB-PY - PS BUSINESS PARKS INC/CA", ticker: "PSB-PY" },
    { name: "CCOZF - CHINA COAL ENERGY CO LTD", ticker: "CCOZF" },
    { name: "FMCKL - FEDERAL HOME LOAN MORTGAGE CORP", ticker: "FMCKL" },
    { name: "PSB-PX - PS BUSINESS PARKS INC/CA", ticker: "PSB-PX" },
    { name: "ROHCF - ROHM Co., Ltd.", ticker: "ROHCF" },
    { name: "ISUZF - ISUZU MOTORS LTD/ADR/", ticker: "ISUZF" },
    { name: "PCG-PG - PG&E Corp", ticker: "PCG-PG" },
    { name: "DSECF - Daiwa Securities Group Inc.", ticker: "DSECF" },
    { name: "FUPBY - Fuchs Petrolub SE/ADR", ticker: "FUPBY" },
    { name: "FUPEF - Fuchs Petrolub SE/ADR", ticker: "FUPEF" },
    { name: "WARFF - WHARF HOLDINGS LTD /FI", ticker: "WARFF" },
    { name: "PSB-PW - PS BUSINESS PARKS INC/CA", ticker: "PSB-PW" },
    { name: "CLZNF - CLARIANT AG", ticker: "CLZNF" },
    { name: "TGE - Tallgrass Energy, LP", ticker: "TGE" },
    { name: "PCG-PI - PG&E Corp", ticker: "PCG-PI" },
    { name: "FMCKJ - FEDERAL HOME LOAN MORTGAGE CORP", ticker: "FMCKJ" },
    { name: "SHTDF - Sinopharm Group Co/ADR", ticker: "SHTDF" },
    { name: "ZBK - ZIONS BANCORPORATION, NATIONAL ASSOCIATION /UT/", ticker: "ZBK" },
    { name: "PCG-PH - PG&E Corp", ticker: "PCG-PH" },
    { name: "BGAOF - Proximus", ticker: "BGAOF" },
    { name: "FMCKM - FEDERAL HOME LOAN MORTGAGE CORP", ticker: "FMCKM" },
    { name: "SHCAF - SHARP CORP /FI", ticker: "SHCAF" },
    { name: "BMRPF - B&M European Value Retail S.A./ADR", ticker: "BMRPF" },
    { name: "UVRBF - Universal Robina Corporation/ADR", ticker: "UVRBF" },
    { name: "ASOMF - ASOS plc", ticker: "ASOMF" },
    { name: "UNMA - Unum Group", ticker: "UNMA" },
    { name: "SJMHF - SJM Holdings Limited/ADR", ticker: "SJMHF" },
    { name: "FMCKO - FEDERAL HOME LOAN MORTGAGE CORP", ticker: "FMCKO" },
    { name: "ENGGF - Enagas, S.A.", ticker: "ENGGF" },
    { name: "DNFGF - Dongfeng Motor Group Co Ltd / ADR", ticker: "DNFGF" },
    { name: "LNDNF - Lundin Petroleum AB", ticker: "LNDNF" },
    { name: "FMCKN - FEDERAL HOME LOAN MORTGAGE CORP", ticker: "FMCKN" },
    { name: "KOTMF - Koito Manufacturing Co., Ltd./ADR", ticker: "KOTMF" },
    { name: "KUNUF - KunLun Energy Co Ltd", ticker: "KUNUF" },
    { name: "CLPXF - China Longyuan Power Group Corp Limited/ADR/", ticker: "CLPXF" },
    { name: "FMCCO - FEDERAL HOME LOAN MORTGAGE CORP", ticker: "FMCCO" },
    { name: "FMCCH - FEDERAL HOME LOAN MORTGAGE CORP", ticker: "FMCCH" },
    { name: "CWEN - Clearway Energy, Inc.", ticker: "CWEN" },
    { name: "FMCKI - FEDERAL HOME LOAN MORTGAGE CORP", ticker: "FMCKI" },
    { name: "FMCCG - FEDERAL HOME LOAN MORTGAGE CORP", ticker: "FMCCG" },
    { name: "UAA - Under Armour, Inc.", ticker: "UAA" },
    { name: "ARES-PA - Ares Management Corp", ticker: "ARES-PA" },
    { name: "FMCCS - FEDERAL HOME LOAN MORTGAGE CORP", ticker: "FMCCS" },
    { name: "HMTLF - HITACHI METALS LTD /ADR/", ticker: "HMTLF" },
    { name: "MSG - Madison Square Garden Sports Corp.", ticker: "MSG" },
    { name: "SHO-PF - Sunstone Hotel Investors, Inc.", ticker: "SHO-PF" },
    { name: "KAJMF - Kajima Corp", ticker: "KAJMF" },
    { name: "OGFGF - ORIGIN ENERGY LTD", ticker: "OGFGF" },
    { name: "SHO-PE - Sunstone Hotel Investors, Inc.", ticker: "SHO-PE" },
    { name: "FMCCP - FEDERAL HOME LOAN MORTGAGE CORP", ticker: "FMCCP" },
    { name: "OSAGF - OSRAM Licht AG/ADR", ticker: "OSAGF" },
    { name: "FMCCK - FEDERAL HOME LOAN MORTGAGE CORP", ticker: "FMCCK" },
    { name: "FMCKP - FEDERAL HOME LOAN MORTGAGE CORP", ticker: "FMCKP" },
    { name: "BHFAL - Brighthouse Financial, Inc.", ticker: "BHFAL" },
    { name: "FMCCM - FEDERAL HOME LOAN MORTGAGE CORP", ticker: "FMCCM" },
    { name: "DIISF - Direct Line Insurance Group plc/ADR", ticker: "DIISF" },
    { name: "HLKHF - Hella KGaA Hueck & Co./ADR", ticker: "HLKHF" },
    { name: "FMCCL - FEDERAL HOME LOAN MORTGAGE CORP", ticker: "FMCCL" },
    { name: "FMCCJ - FEDERAL HOME LOAN MORTGAGE CORP", ticker: "FMCCJ" },
    { name: "FMCCI - FEDERAL HOME LOAN MORTGAGE CORP", ticker: "FMCCI" },
    { name: "BNMDF - Banca Mediolanum S.p.A./ADR", ticker: "BNMDF" },
    { name: "FMCCN - FEDERAL HOME LOAN MORTGAGE CORP", ticker: "FMCCN" },
    { name: "MRWSF - WM Morrison Supermarkets plc", ticker: "MRWSF" },
    { name: "SHMUF - Shimizu Corporation/ADR", ticker: "SHMUF" },
    { name: "SNV-PD - SYNOVUS FINANCIAL CORP", ticker: "SNV-PD" },
    { name: "FREGP - FEDERAL HOME LOAN MORTGAGE CORP", ticker: "FREGP" },
    { name: "FREJN - FEDERAL HOME LOAN MORTGAGE CORP", ticker: "FREJN" },
    { name: "VLPNF - VOESTALPINE AG", ticker: "VLPNF" },
    { name: "TSUKF - TOYO SUISAN KAISHA LTD/ADR/", ticker: "TSUKF" },
    { name: "WRTBF - Wartsila OYJ", ticker: "WRTBF" },
    { name: "AXS-PE - AXIS CAPITAL HOLDINGS LTD", ticker: "AXS-PE" },
    { name: "BCAUF - BRILLIANCE CHINA AUTOMOTIVE HOLDINGS LTD", ticker: "BCAUF" },
    { name: "HWDJF - Howden Joinery Group Plc/ADR", ticker: "HWDJF" },
    { name: "EKTAF - Elekta AB / ADR", ticker: "EKTAF" },
    { name: "SOMMF - Sumitomo Chemical Co., Ltd.", ticker: "SOMMF" },
    { name: "CNVVF - ConvaTec Group PLC/ADR", ticker: "CNVVF" },
    { name: "DTW - DTE ENERGY CO", ticker: "DTW" },
    { name: "MPFRF - MAPFRE S.A.", ticker: "MPFRF" },
    { name: "MAURF - MARUI CO LTD /ADR/", ticker: "MAURF" },
    { name: "SR-PA - SPIRE INC", ticker: "SR-PA" },
    { name: "DCP-PC - DCP Midstream, LP", ticker: "DCP-PC" },
    { name: "NYCB-PA - NEW YORK COMMUNITY BANCORP INC", ticker: "NYCB-PA" },
    { name: "STAEF - Stanley Electric Co., Ltd./ADR", ticker: "STAEF" },
    { name: "ASMVF - ASM Pacific Technology Ltd.", ticker: "ASMVF" },
    { name: "AFC - ARES CAPITAL CORP", ticker: "AFC" },
    { name: "REXR-PB - Rexford Industrial Realty, Inc.", ticker: "REXR-PB" },
    { name: "EQM - EQM Midstream Partners, LP", ticker: "EQM" },
    { name: "FHN-PA - FIRST HORIZON NATIONAL CORP", ticker: "FHN-PA" },
    { name: "BHFAP - Brighthouse Financial, Inc.", ticker: "BHFAP" },
    { name: "EQC-PD - Equity Commonwealth", ticker: "EQC-PD" },
    { name: "SUMCF - SUMCO CORP", ticker: "SUMCF" },
    { name: "CSSSF - carsales.com Limited/ADR", ticker: "CSSSF" },
    { name: "REXR-PA - Rexford Industrial Realty, Inc.", ticker: "REXR-PA" },
    { name: "BZZUF - BUZZI UNICEM S.p.A.", ticker: "BZZUF" },
    { name: "NKRKF - Nokian Tyres OYJ", ticker: "NKRKF" },
    { name: "GFSZF - G4S", ticker: "GFSZF" },
    { name: "STL-PA - STERLING BANCORP", ticker: "STL-PA" },
    { name: "SF-PB - STIFEL FINANCIAL CORP", ticker: "SF-PB" },
    { name: "NPSKF - NSK LTD /ADR/", ticker: "NPSKF" },
    { name: "AL-PA - AIR LEASE CORP", ticker: "AL-PA" },
    { name: "GULRF - Guoco Group Ltd", ticker: "GULRF" },
    { name: "SEPJF - Spectris PLC/ADR", ticker: "SEPJF" },
    { name: "BRTHF - BROTHER INDUSTRIES LTD/ADR/", ticker: "BRTHF" },
    { name: "ASB-PC - ASSOCIATED BANC-CORP", ticker: "ASB-PC" },
    { name: "UNPSF - Uni-President China Holdings Ltd.", ticker: "UNPSF" },
    { name: "ZHUZF - Zhuzhou CRRC Times Electric Co., Ltd./ADR", ticker: "ZHUZF" },
    { name: "WYGPF - Worleyparsons Ltd/ADR", ticker: "WYGPF" },
    { name: "IBKCO - IBERIABANK CORP", ticker: "IBKCO" },
    { name: "ITVPF - ITV PLC", ticker: "ITVPF" },
    { name: "QTS-PB - QTS Realty Trust, Inc.", ticker: "QTS-PB" },
    { name: "RNMBF - RHEINMETALL / ADR", ticker: "RNMBF" },
    { name: "WIMHF - William Hill plc / ADR", ticker: "WIMHF" },
    { name: "ERI - Caesars Entertainment, Inc.", ticker: "ERI" },
    { name: "BZZFF - BUZZI UNICEM S.p.A.", ticker: "BZZFF" },
    { name: "ESGRO - Enstar Group LTD", ticker: "ESGRO" },
    { name: "ABCZY - Abcam plc", ticker: "ABCZY" },
    { name: "STAG-PC - STAG Industrial, Inc.", ticker: "STAG-PC" },
    { name: "FII - FEDERATED HERMES, INC.", ticker: "FII" },
    { name: "MZDAF - Mazda Motor Corp", ticker: "MZDAF" },
    { name: "PBI-PB - PITNEY BOWES INC /DE/", ticker: "PBI-PB" },
    { name: "MXCHF - Orbia Advance Corporation, S.A.B. de C.V./ADR", ticker: "MXCHF" },
    { name: "WTFCM - WINTRUST FINANCIAL CORP", ticker: "WTFCM" },
    { name: "IBKCN - IBERIABANK CORP", ticker: "IBKCN" },
    { name: "IBKCP - IBERIABANK CORP", ticker: "IBKCP" },
    { name: "SEKEF - SEIKO EPSON CORP", ticker: "SEKEF" },
    { name: "CMHHF - China Merchants Holdings International Co Ltd", ticker: "CMHHF" },
    { name: "KZMYF - Kaz Minerals Plc", ticker: "KZMYF" },
    { name: "CHFFF - China Everbright International Limited/ADR", ticker: "CHFFF" },
    { name: "ASB-PE - ASSOCIATED BANC-CORP", ticker: "ASB-PE" },
    { name: "ADRZF - Andritz AG", ticker: "ADRZF" },
    { name: "KURRF - Kuraray Co Ltd", ticker: "KURRF" },
    { name: "ASB-PD - ASSOCIATED BANC-CORP", ticker: "ASB-PD" },
    { name: "EBRPF - Ebro Puleva SA / ADR", ticker: "EBRPF" },
    { name: "MALRF - Mineral Resources Limited/ADR", ticker: "MALRF" },
    { name: "PEB-PE - Pebblebrook Hotel Trust", ticker: "PEB-PE" },
    { name: "PEB-PF - Pebblebrook Hotel Trust", ticker: "PEB-PF" },
    { name: "PEB-PC - Pebblebrook Hotel Trust", ticker: "PEB-PC" },
    { name: "CCOHF - China State Construction International Holdings Limited/ADR", ticker: "CCOHF" },
    { name: "WRB-PE - BERKLEY W R CORP", ticker: "WRB-PE" },
    { name: "LTSF - LADENBURG THALMANN FINANCIAL SERVICES INC.", ticker: "LTSF" },
    { name: "LILAB - Liberty Latin America Ltd.", ticker: "LILAB" },
    { name: "TCO-PK - TAUBMAN CENTERS INC", ticker: "TCO-PK" },
    { name: "TCO-PJ - TAUBMAN CENTERS INC", ticker: "TCO-PJ" },
    { name: "APRDN - ALABAMA POWER CO", ticker: "APRDN" },
    { name: "APRDO - ALABAMA POWER CO", ticker: "APRDO" },
    { name: "APRDM - ALABAMA POWER CO", ticker: "APRDM" },
    { name: "THKLF - THK Co., Ltd.", ticker: "THKLF" },
    { name: "APRDP - ALABAMA POWER CO", ticker: "APRDP" },
    { name: "ALPVN - ALABAMA POWER CO", ticker: "ALPVN" },
    { name: "LTSL - LADENBURG THALMANN FINANCIAL SERVICES INC.", ticker: "LTSL" },
    { name: "IRDEF - Iren S.p.A./ADR", ticker: "IRDEF" },
    { name: "AFSIA - Amtrust Financial Services, Inc.", ticker: "AFSIA" },
    { name: "PEB-PD - Pebblebrook Hotel Trust", ticker: "PEB-PD" },
    { name: "APRCP - ALABAMA POWER CO", ticker: "APRCP" },
    { name: "QRTEB - Qurate Retail, Inc.", ticker: "QRTEB" },
    { name: "ROYMF - Royal Mail plc/ADR", ticker: "ROYMF" },
    { name: "AFSIB - Amtrust Financial Services, Inc.", ticker: "AFSIB" },
    { name: "CIG-C - ENERGY CO OF MINAS GERAIS", ticker: "CIG-C" },
    { name: "AFSIM - Amtrust Financial Services, Inc.", ticker: "AFSIM" },
    { name: "AFSIC - Amtrust Financial Services, Inc.", ticker: "AFSIC" },
    { name: "TWO-PD - TWO HARBORS INVESTMENT CORP.", ticker: "TWO-PD" },
    { name: "QTS-PA - QTS Realty Trust, Inc.", ticker: "QTS-PA" },
    { name: "TWO-PE - TWO HARBORS INVESTMENT CORP.", ticker: "TWO-PE" },
    { name: "APNHF - Aspen Pharmacare Holdings Ltd / ADR", ticker: "APNHF" },
    { name: "TCBIP - TEXAS CAPITAL BANCSHARES INC/TX", ticker: "TCBIP" },
    { name: "MEGGF - Meggitt PLC", ticker: "MEGGF" },
    { name: "APELY - ALPS ALPINE CO., LTD.", ticker: "APELY" },
    { name: "ELPVY - ENERGY CO OF PARANA", ticker: "ELPVY" },
    { name: "TWO-PC - TWO HARBORS INVESTMENT CORP.", ticker: "TWO-PC" },
    { name: "SPTJF - SINOPEC SHANGHAI PETROCHEMICAL CO LTD", ticker: "SPTJF" },
    { name: "TWO-PA - TWO HARBORS INVESTMENT CORP.", ticker: "TWO-PA" },
    { name: "BJCHF - Beijing Capital International Airport Co / ADR", ticker: "BJCHF" },
    { name: "TWO-PB - TWO HARBORS INVESTMENT CORP.", ticker: "TWO-PB" },
    { name: "AILLI - Ameren Illinois Co", ticker: "AILLI" },
    { name: "AILLM - Ameren Illinois Co", ticker: "AILLM" },
    { name: "BOLD - Audentes Therapeutics, Inc.", ticker: "BOLD" },
    { name: "JTEKF - JTEKT Corp", ticker: "JTEKF" },
    { name: "YUEIF - Yue Yuen Industrial (Holdings) Ltd.", ticker: "YUEIF" },
    { name: "ENR-PA - ENERGIZER HOLDINGS, INC.", ticker: "ENR-PA" },
    { name: "NSA-PA - National Storage Affiliates Trust", ticker: "NSA-PA" },
    { name: "AILLN - Ameren Illinois Co", ticker: "AILLN" },
    { name: "AILIM - Ameren Illinois Co", ticker: "AILIM" },
    { name: "PRE-PH - PARTNERRE LTD", ticker: "PRE-PH" },
    { name: "AZIHF - Azimut Holding SpA/ADR", ticker: "AZIHF" },
    { name: "PBSFF - PROSIEBENSAT.1 MEDIA SE/ADR", ticker: "PBSFF" },
    { name: "PRE-PG - PARTNERRE LTD", ticker: "PRE-PG" },
    { name: "MSLOF - Mitsui OSK Lines Ltd", ticker: "MSLOF" },
    { name: "PRE-PI - PARTNERRE LTD", ticker: "PRE-PI" },
    { name: "LXP-PC - LEXINGTON REALTY TRUST", ticker: "LXP-PC" },
    { name: "AILLP - Ameren Illinois Co", ticker: "AILLP" },
    { name: "BBAVF - BBA AVIATION PLC", ticker: "BBAVF" },
    { name: "SFRGF - Salvatore Ferragamo S.p.A./ADR", ticker: "SFRGF" },
    { name: "AILLO - Ameren Illinois Co", ticker: "AILLO" },
    { name: "AILIN - Ameren Illinois Co", ticker: "AILIN" },
    { name: "TRTN-PA - Triton International Ltd", ticker: "TRTN-PA" },
    { name: "ASCCF - ASICS Corporation/ADR", ticker: "ASCCF" },
    { name: "POL - AVIENT CORP", ticker: "POL" },
    { name: "SITC-PA - SITE Centers Corp.", ticker: "SITC-PA" },
    { name: "SITC-PK - SITE Centers Corp.", ticker: "SITC-PK" },
    { name: "NINOF - Nikon Corp", ticker: "NINOF" },
    { name: "TUIFF - TUI AG", ticker: "TUIFF" },
    { name: "JGCCF - JGC Corp", ticker: "JGCCF" },
    { name: "THOR - Synthorx, Inc.", ticker: "THOR" },
    { name: "GEF-B - GREIF, INC", ticker: "GEF-B" },
    { name: "UZA - UNITED STATES CELLULAR CORP", ticker: "UZA" },
    { name: "MOG-B - MOOG INC.", ticker: "MOG-B" },
    { name: "CENTA - CENTRAL GARDEN & PET CO", ticker: "CENTA" },
    { name: "BRFRF - Burford Capital Ltd", ticker: "BRFRF" },
    { name: "TKCM - TOKEN COMMUNITIES LTD.", ticker: "TKCM" },
    { name: "JELCF - JOHNSON ELECTRIC HOLDINGS LTD /FI", ticker: "JELCF" },
    { name: "AKO-B - ANDINA BOTTLING CO INC", ticker: "AKO-B" },
    { name: "LILAK - Liberty Latin America Ltd.", ticker: "LILAK" },
    { name: "CCIV - Churchill Capital Corp IV", ticker: "CCIV" },
    { name: "TGP-PA - Teekay LNG Partners L.P.", ticker: "TGP-PA" },
    { name: "APELF - ALPS ALPINE CO., LTD.", ticker: "APELF" },
    { name: "COT - Primo Water Corp /CN/", ticker: "COT" },
    { name: "RUSHB - RUSH ENTERPRISES INC TX", ticker: "RUSHB" },
    { name: "OUKPF - Outotec OYJ", ticker: "OUKPF" },
    { name: "QNTQF - QINETIQ GROUP PLC", ticker: "QNTQF" },
    { name: "FG - FGL Holdings", ticker: "FG" },
    { name: "BNDSF - Banco de Sabadell SA", ticker: "BNDSF" },
    { name: "LYSCF - Lynas CORP LTD", ticker: "LYSCF" },
    { name: "OGCP - Empire State Realty OP, L.P.", ticker: "OGCP" },
    { name: "JW-B - JOHN WILEY & SONS, INC.", ticker: "JW-B" },
    { name: "IVR-PA - Invesco Mortgage Capital Inc.", ticker: "IVR-PA" },
    { name: "BCNAF - Barco NV", ticker: "BCNAF" },
    { name: "FISK - Empire State Realty OP, L.P.", ticker: "FISK" },
    { name: "SAPMF - SAIPEM S P A /FI", ticker: "SAPMF" },
    { name: "ORRAF - Orora Limited/ADR", ticker: "ORRAF" },
    { name: "TLSRP - TELOS CORP", ticker: "TLSRP" },
    { name: "MHLA - Maiden Holdings, Ltd.", ticker: "MHLA" },
    { name: "VTKLF - VTECH HOLDINGS LTD/ADR/", ticker: "VTKLF" },
    { name: "KROTF - Kroton Educational S.A.", ticker: "KROTF" },
    { name: "GNL-PA - Global Net Lease, Inc.", ticker: "GNL-PA" },
    { name: "IVR-PC - Invesco Mortgage Capital Inc.", ticker: "IVR-PC" },
    { name: "SF-PA - STIFEL FINANCIAL CORP", ticker: "SF-PA" },
    { name: "FUWAF - FURUKAWA ELECTRIC CO LTD", ticker: "FUWAF" },
    { name: "JJAQF - APi Group Corp", ticker: "JJAQF" },
    { name: "SHLL-UN - Hyliion Holdings Corp.", ticker: "SHLL-UN" },
    { name: "BFS-PD - SAUL CENTERS, INC.", ticker: "BFS-PD" },
    { name: "IVR-PB - Invesco Mortgage Capital Inc.", ticker: "IVR-PB" },
    { name: "LGF-B - LIONS GATE ENTERTAINMENT CORP /CN/", ticker: "LGF-B" },
    { name: "DWT - CITIGROUP INC", ticker: "DWT" },
    { name: "BPOSF - bpost SA/NV/ADR", ticker: "BPOSF" },
    { name: "MYTHF - Mytilineos Holdings S.A.", ticker: "MYTHF" },
    { name: "AHL-PD - ASPEN INSURANCE HOLDINGS LTD", ticker: "AHL-PD" },
    { name: "PMT-PA - PennyMac Mortgage Investment Trust", ticker: "PMT-PA" },
    { name: "PMT-PB - PennyMac Mortgage Investment Trust", ticker: "PMT-PB" },
    { name: "OIBRQ - OI S.A. - In Judicial Reorganization", ticker: "OIBRQ" },
    { name: "BMDPF - BANCA MONTE DEI PASCHI DI SIENA SPA", ticker: "BMDPF" },
    { name: "ADBCF - ADBRI Limited/ADR", ticker: "ADBCF" },
    { name: "EGFEF - EFG Eurobank Ergasias S.A./ADR", ticker: "EGFEF" },
    { name: "VTIQU - Nikola Corp", ticker: "VTIQU" },
    { name: "HCXY - Hercules Capital, Inc.", ticker: "HCXY" },
    { name: "ABR-PC - ARBOR REALTY TRUST INC", ticker: "ABR-PC" },
    { name: "ABR-PB - ARBOR REALTY TRUST INC", ticker: "ABR-PB" },
    { name: "ABR-PA - ARBOR REALTY TRUST INC", ticker: "ABR-PA" },
    { name: "CCXX - MultiPlan Corp", ticker: "CCXX" },
    { name: "FLIDF - FLSMIDTH & CO. A/S", ticker: "FLIDF" },
    { name: "MNR-PC - MONMOUTH REAL ESTATE INVESTMENT CORP", ticker: "MNR-PC" },
    { name: "ISMAF - Indra Sistemas", ticker: "ISMAF" },
    { name: "SHLL - Hyliion Holdings Corp.", ticker: "SHLL" },
    { name: "MCV - Medley Capital Corp", ticker: "MCV" },
    { name: "GTN-A - GRAY TELEVISION INC", ticker: "GTN-A" },
    { name: "CRNZF - CAIRN ENERGY PLC", ticker: "CRNZF" },
    { name: "EAI - ENTERGY ARKANSAS, LLC", ticker: "EAI" },
    { name: "KNCAF - Konica Minolta Holdings Inc", ticker: "KNCAF" },
    { name: "FRCK - TREND INNOVATIONS HOLDING INC.", ticker: "FRCK" },
    { name: "CADNF - CASCADES INC", ticker: "CADNF" },
    { name: "OFG-PA - OFG BANCORP", ticker: "OFG-PA" },
    { name: "CODI-PB - Compass Diversified Holdings", ticker: "CODI-PB" },
    { name: "NMFX - New Mountain Finance Corp", ticker: "NMFX" },
    { name: "CODI-PA - Compass Diversified Holdings", ticker: "CODI-PA" },
    { name: "NBGIF - NATIONAL BANK OF GREECE SA", ticker: "NBGIF" },
    { name: "AFINP - American Finance Trust, Inc", ticker: "AFINP" },
    { name: "INTL - StoneX Group Inc.", ticker: "INTL" },
    { name: "IIPR-PA - INNOVATIVE INDUSTRIAL PROPERTIES INC", ticker: "IIPR-PA" },
    { name: "BATRA - Liberty Media Corp", ticker: "BATRA" },
    { name: "OFG-PD - OFG BANCORP", ticker: "OFG-PD" },
    { name: "NYMTN - NEW YORK MORTGAGE TRUST INC", ticker: "NYMTN" },
    { name: "BATRK - Liberty Media Corp", ticker: "BATRK" },
    { name: "WPF - Foley Trasimene Acquisition Corp.", ticker: "WPF" },
    { name: "PFODF - Premier Foods plc", ticker: "PFODF" },
    { name: "GLOG-PA - GasLog Ltd.", ticker: "GLOG-PA" },
    { name: "ATGSF - Autogrill SpA", ticker: "ATGSF" },
    { name: "HL-PB - HECLA MINING CO/DE/", ticker: "HL-PB" },
    { name: "TANNI - TravelCenters of America Inc. /MD/", ticker: "TANNI" },
    { name: "HCACW - Hennessy Capital Acquisition Corp IV", ticker: "HCACW" },
    { name: "TGP-PB - Teekay LNG Partners L.P.", ticker: "TGP-PB" },
    { name: "TANNL - TravelCenters of America Inc. /MD/", ticker: "TANNL" },
    { name: "FXCNF - FIH Mobile Ltd", ticker: "FXCNF" },
    { name: "SWDHF - Skyworth Digital Holdings Limited/ADR", ticker: "SWDHF" },
    { name: "DGNR - Dragoneer Growth Opportunities Corp.", ticker: "DGNR" },
    { name: "TANNZ - TravelCenters of America Inc. /MD/", ticker: "TANNZ" },
    { name: "CCH-UN - Utz Brands, Inc.", ticker: "CCH-UN" },
    { name: "CCH - Utz Brands, Inc.", ticker: "CCH" },
    { name: "GSAH-UN - GS Acquisition Holdings Corp II", ticker: "GSAH-UN" },
    { name: "GRAF-UN - Velodyne Lidar, Inc.", ticker: "GRAF-UN" },
    { name: "AACQ - Artius Acquisition Inc.", ticker: "AACQ" },
    { name: "NEBUU - Nebula Acquisition Corp", ticker: "NEBUU" },
    { name: "SPAQ-UN - Spartan Energy Acquisition Corp.", ticker: "SPAQ-UN" },
    { name: "DEAC - DraftKings Inc.", ticker: "DEAC" },
    { name: "SPOXF - SPROTT INC.", ticker: "SPOXF" },
    { name: "NGL-PC - NGL Energy Partners LP", ticker: "NGL-PC" },
    { name: "FPAC - Far Point Acquisition Corp", ticker: "FPAC" },
    { name: "FPAC-UN - Far Point Acquisition Corp", ticker: "FPAC-UN" },
    { name: "PRPB - CC Neuberger Principal Holdings II", ticker: "PRPB" },
    { name: "NGL-PB - NGL Energy Partners LP", ticker: "NGL-PB" },
    { name: "TCRZ - First Eagle Alternative Capital BDC, Inc.", ticker: "TCRZ" },
    { name: "APY - ChampionX Corp", ticker: "APY" },
    { name: "AGM-PD - FEDERAL AGRICULTURAL MORTGAGE CORP", ticker: "AGM-PD" },
    { name: "IRET-PC - INVESTORS REAL ESTATE TRUST", ticker: "IRET-PC" },
    { name: "KELYB - KELLY SERVICES INC", ticker: "KELYB" },
    { name: "FGROF - FirstGroup", ticker: "FGROF" },
    { name: "AGM-PC - FEDERAL AGRICULTURAL MORTGAGE CORP", ticker: "AGM-PC" },
    { name: "DPHCU - DiamondPeak Holdings Corp.", ticker: "DPHCU" },
    { name: "INSW-PA - International Seaways, Inc.", ticker: "INSW-PA" },
    { name: "AILLL - Ameren Illinois Co", ticker: "AILLL" },
    { name: "AGM-PA - FEDERAL AGRICULTURAL MORTGAGE CORP", ticker: "AGM-PA" },
    { name: "AGM-A - FEDERAL AGRICULTURAL MORTGAGE CORP", ticker: "AGM-A" },
    { name: "HTCTF - Hutchison Telecommunications Hong Kong Holdings Ltd", ticker: "HTCTF" },
    { name: "RUBI - MAGNITE, INC.", ticker: "RUBI" },
    { name: "FDEF - PREMIER FINANCIAL CORP", ticker: "FDEF" },
    { name: "GLOP-PA - GasLog Partners LP", ticker: "GLOP-PA" },
    { name: "AOBC - SMITH & WESSON BRANDS, INC.", ticker: "AOBC" },
    { name: "NPACF - Quadient S.A./ADR", ticker: "NPACF" },
    { name: "TOO - Altera Infrastructure L.P.", ticker: "TOO" },
    { name: "FMCI - Tattooed Chef, Inc.", ticker: "FMCI" },
    { name: "CUBI-PD - Customers Bancorp, Inc.", ticker: "CUBI-PD" },
    { name: "SPAR - SHYFT GROUP, INC.", ticker: "SPAR" },
    { name: "CMRE-PB - Costamare Inc.", ticker: "CMRE-PB" },
    { name: "GLP-PA - GLOBAL PARTNERS LP", ticker: "GLP-PA" },
    { name: "ARZTF - ARYZTA AG (fka IAWS GROUP PLC)", ticker: "ARZTF" },
    { name: "CUBI-PF - Customers Bancorp, Inc.", ticker: "CUBI-PF" },
    { name: "CUBI-PE - Customers Bancorp, Inc.", ticker: "CUBI-PE" },
    { name: "TPGH-UN - Accel Entertainment, Inc.", ticker: "TPGH-UN" },
    { name: "CMRE-PC - Costamare Inc.", ticker: "CMRE-PC" },
    { name: "CUBI-PC - Customers Bancorp, Inc.", ticker: "CUBI-PC" },
    { name: "CMRE-PD - Costamare Inc.", ticker: "CMRE-PD" },
    { name: "HMLP-PA - Hoegh LNG Partners LP", ticker: "HMLP-PA" },
    { name: "CMRE-PE - Costamare Inc.", ticker: "CMRE-PE" },
    { name: "GLOP-PB - GasLog Partners LP", ticker: "GLOP-PB" },
    { name: "GRSHU - PAE Inc", ticker: "GRSHU" },
    { name: "JMPD - JMP GROUP LLC", ticker: "JMPD" },
    { name: "CTAGF - Capita Group/ADR", ticker: "CTAGF" },
    { name: "LCAHU - Landcadia Holdings II, Inc.", ticker: "LCAHU" },
    { name: "GLOP-PC - GasLog Partners LP", ticker: "GLOP-PC" },
    { name: "GMHIU - Gores Metropoulos, Inc.", ticker: "GMHIU" },
    { name: "UMH-PC - UMH PROPERTIES, INC.", ticker: "UMH-PC" },
    { name: "UMH-PD - UMH PROPERTIES, INC.", ticker: "UMH-PD" },
    { name: "USATP - USA TECHNOLOGIES INC", ticker: "USATP" },
    { name: "HEC - Hudson Executive Investment Corp.", ticker: "HEC" },
    { name: "UMH-PB - UMH PROPERTIES, INC.", ticker: "UMH-PB" },
    { name: "HWGG - Ho Wah Genting Group Ltd", ticker: "HWGG" },
    { name: "CRCM - Care.com Inc", ticker: "CRCM" },
    { name: "LDSSF - Radius Global Infrastructure, Inc.", ticker: "LDSSF" },
    { name: "NEBU - Nebula Acquisition Corp", ticker: "NEBU" },
    { name: "APXT - Apex Technology Acquisition Corp", ticker: "APXT" },
    { name: "ACTTU - Whole Earth Brands, Inc.", ticker: "ACTTU" },
    { name: "MBINP - Merchants Bancorp", ticker: "MBINP" },
    { name: "EROS - Eros International PLC", ticker: "EROS" },
    { name: "MOSC-UN - Vivint Smart Home, Inc.", ticker: "MOSC-UN" },
    { name: "NEXCF - NexTech AR Solutions Corp.", ticker: "NEXCF" },
    { name: "CATS - Ontrak, Inc.", ticker: "CATS" },
    { name: "JIH - Juniper Industrial Holdings, Inc.", ticker: "JIH" },
    { name: "JCAP-PB - Jernigan Capital, Inc.", ticker: "JCAP-PB" },
    { name: "FUSE - Fusion Acquisition Corp.", ticker: "FUSE" },
    { name: "CACA - China Crawfish, Ltd.", ticker: "CACA" },
    { name: "PUB - Altabancorp", ticker: "PUB" },
    { name: "GMRE-PA - Global Medical REIT Inc.", ticker: "GMRE-PA" },
    { name: "LMRKN - Landmark Infrastructure Partners LP", ticker: "LMRKN" },
    { name: "TOO-PB - Altera Infrastructure L.P.", ticker: "TOO-PB" },
    { name: "DEH - D8 Holdings Corp.", ticker: "DEH" },
    { name: "NFC - New Frontier Health Corp", ticker: "NFC" },
    { name: "LGC-UN - Legacy Acquisition Corp.", ticker: "LGC-UN" },
    { name: "LGVW - Longview Acquisition Corp.", ticker: "LGVW" },
    { name: "ACTT - Whole Earth Brands, Inc.", ticker: "ACTT" },
    { name: "JNNDF - Japan Display Inc./ADR", ticker: "JNNDF" },
    { name: "VRML - Aspira Women's Health Inc.", ticker: "VRML" },
    { name: "SFTW - Osprey Technology Acquisition Corp.", ticker: "SFTW" },
    { name: "SENEB - Seneca Foods Corp", ticker: "SENEB" },
    { name: "UBA - URSTADT BIDDLE PROPERTIES INC", ticker: "UBA" },
    { name: "CHPM - CHP Merger Corp.", ticker: "CHPM" },
    { name: "PTHIF - PT Solusi Bangun Indonesia TBK/ADR", ticker: "PTHIF" },
    { name: "HAWLN - HAWAIIAN ELECTRIC CO INC", ticker: "HAWLN" },
    { name: "RPLA-UN - Replay Acquisition Corp.", ticker: "RPLA-UN" },
    { name: "CFII - CF Finance Acquisition Corp II", ticker: "CFII" },
    { name: "HABT - Habit Restaurants, Inc.", ticker: "HABT" },
    { name: "RYKKF - Ryohin Keikaku Co/ADR", ticker: "RYKKF" },
    { name: "GLDLF - GoldMining Inc.", ticker: "GLDLF" },
    { name: "CRD-B - CRAWFORD & CO", ticker: "CRD-B" },
    { name: "LK - Luckin Coffee Inc.", ticker: "LK" },
    { name: "SPKEP - Spark Energy, Inc.", ticker: "SPKEP" },
    { name: "CORVF - Corvus Gold Inc.", ticker: "CORVF" },
    { name: "EXPC - Experience Investment Corp.", ticker: "EXPC" },
    { name: "HAWEN - HAWAIIAN ELECTRIC CO INC", ticker: "HAWEN" },
    { name: "RECN - RESOURCES CONNECTION INC", ticker: "RECN" },
    { name: "BBXTD - Bluegreen Vacations Holding Corp", ticker: "BBXTD" },
    { name: "RNWEF - RENEWABLE ENERGY CORP ASA", ticker: "RNWEF" },
    { name: "CRSAU - Crescent Acquisition Corp", ticker: "CRSAU" },
    { name: "TUWLF - TULLOW OIL PLC /FI", ticker: "TUWLF" },
    { name: "FSRV - FinServ Acquisition Corp.", ticker: "FSRV" },
    { name: "TOO-PE - Altera Infrastructure L.P.", ticker: "TOO-PE" },
    { name: "GMHLF - GAM Holding AG", ticker: "GMHLF" },
    { name: "IPV - InterPrivate Acquisition Corp.", ticker: "IPV" },
    { name: "RMG-UN - RMG Acquisition Corp.", ticker: "RMG-UN" },
    { name: "DFPH - DFP HEALTHCARE ACQUISITIONS CORP.", ticker: "DFPH" },
    { name: "SPLP-PA - STEEL PARTNERS HOLDINGS L.P.", ticker: "SPLP-PA" },
    { name: "NPA - New Providence Acquisition Corp.", ticker: "NPA" },
    { name: "ACRHF - Acreage Holdings, Inc.", ticker: "ACRHF" },
    { name: "LHC-UN - Digital Media Solutions, Inc.", ticker: "LHC-UN" },
    { name: "TBRGU - Repay Holdings Corp", ticker: "TBRGU" },
    { name: "ACEV - ACE Convergence Acquisition Corp.", ticker: "ACEV" },
    { name: "BH-A - Biglari Holdings Inc.", ticker: "BH-A" },
    { name: "TOO-PA - Altera Infrastructure L.P.", ticker: "TOO-PA" },
    { name: "ACRGF - Acreage Holdings, Inc.", ticker: "ACRGF" },
    { name: "BCOM - B COMMUNICATIONS LTD", ticker: "BCOM" },
    { name: "TNP-PC - TSAKOS ENERGY NAVIGATION LTD", ticker: "TNP-PC" },
    { name: "FOSI - FRONTIER OILFIELD SERVICES INC", ticker: "FOSI" },
    { name: "BBXTB - Bluegreen Vacations Holding Corp", ticker: "BBXTB" },
    { name: "GIK - GigCapital3, Inc.", ticker: "GIK" },
    { name: "TNP-PD - TSAKOS ENERGY NAVIGATION LTD", ticker: "TNP-PD" },
    { name: "FUAIF - FUNAI ELECTRIC CO LTD", ticker: "FUAIF" },
    { name: "AKG - Galiano Gold Inc.", ticker: "AKG" },
    { name: "BHR-PB - Braemar Hotels & Resorts Inc.", ticker: "BHR-PB" },
    { name: "TNP-PF - TSAKOS ENERGY NAVIGATION LTD", ticker: "TNP-PF" },
    { name: "FIII - Forum Merger III Corp", ticker: "FIII" },
    { name: "TNP-PE - TSAKOS ENERGY NAVIGATION LTD", ticker: "TNP-PE" },
    { name: "CLA - Colonnade Acquisition Corp.", ticker: "CLA" },
    { name: "INSU - SHIFT TECHNOLOGIES, INC.", ticker: "INSU" },
    { name: "CVTI - COVENANT LOGISTICS GROUP, INC.", ticker: "CVTI" },
    { name: "LHC - Digital Media Solutions, Inc.", ticker: "LHC" },
    { name: "ADRO - ADURO BIOTECH, INC.", ticker: "ADRO" },
    { name: "ROAN - Pressburg, LLC", ticker: "ROAN" },
    { name: "RTIX - SURGALIGN HOLDINGS, INC.", ticker: "RTIX" },
    { name: "XAN-PC - Exantas Capital Corp.", ticker: "XAN-PC" },
    { name: "MNLO - VYNE Therapeutics Inc.", ticker: "MNLO" },
    { name: "MFAC-UN - Megalith Financial Acquisition Corp", ticker: "MFAC-UN" },
    { name: "BMRG - B. Riley Principal Merger Corp. II", ticker: "BMRG" },
    { name: "ENO - ENTERGY NEW ORLEANS, LLC", ticker: "ENO" },
    { name: "PKD - PARKER DRILLING CO /DE/", ticker: "PKD" },
    { name: "DFNS - LGL Systems Acquisition Corp.", ticker: "DFNS" },
    { name: "DNJR - Bit Digital, Inc", ticker: "DNJR" },
    { name: "GNRS - Greenrose Acquisition Corp.", ticker: "GNRS" },
    { name: "ITEPF - ITE Group plc/ADR", ticker: "ITEPF" },
    { name: "CDR-PB - CEDAR REALTY TRUST, INC.", ticker: "CDR-PB" },
    { name: "CDR-PC - CEDAR REALTY TRUST, INC.", ticker: "CDR-PC" },
    { name: "IRRZD - Integra Resources Corp.", ticker: "IRRZD" },
    { name: "DFHT - Deerfield Healthcare Technology Acquisitions Corp.", ticker: "DFHT" },
    { name: "BHR-PD - Braemar Hotels & Resorts Inc.", ticker: "BHR-PD" },
    { name: "SAQN - CuriosityStream Inc.", ticker: "SAQN" },
    { name: "EKKH - New Momentum Corp.", ticker: "EKKH" },
    { name: "BVHBB - Bluegreen Vacations Holding Corp", ticker: "BVHBB" },
    { name: "GLLXD - OMNIA WELLNESS INC.", ticker: "GLLXD" },
    { name: "BUROF - Burcon NutraScience Corp", ticker: "BUROF" },
    { name: "SEIID - SHARING ECONOMY INTERNATIONAL INC.", ticker: "SEIID" },
    { name: "GTX - Garrett Motion Inc.", ticker: "GTX" },
    { name: "SAB - SARATOGA INVESTMENT CORP.", ticker: "SAB" },
    { name: "CHK-PD - CHESAPEAKE ENERGY CORP", ticker: "CHK-PD" },
    { name: "MITFF - Mitie Group plc/ADR", ticker: "MITFF" },
    { name: "QTRH - Quarterhill Inc.", ticker: "QTRH" },
    { name: "NHIC - NewHold Investment Corp.", ticker: "NHIC" },
    { name: "CHKDG - CHESAPEAKE ENERGY CORP", ticker: "CHKDG" },
    { name: "DLNG-PA - Dynagas LNG Partners LP", ticker: "DLNG-PA" },
    { name: "IPATF - ImmunoPrecise Antibodies Ltd.", ticker: "IPATF" },
    { name: "SB-PD - SAFE BULKERS, INC.", ticker: "SB-PD" },
    { name: "SB-PC - SAFE BULKERS, INC.", ticker: "SB-PC" },
    { name: "VMAC - Vistas Media Acquisition Co Inc.", ticker: "VMAC" },
    { name: "RZLTD - Rezolute, Inc.", ticker: "RZLTD" },
    { name: "BELFB - BEL FUSE INC /NJ", ticker: "BELFB" },
    { name: "DO - DIAMOND OFFSHORE DRILLING, INC.", ticker: "DO" },
    { name: "TCRD - First Eagle Alternative Capital BDC, Inc.", ticker: "TCRD" },
    { name: "AMHC - Amplitude Healthcare Acquisition Corp", ticker: "AMHC" },
    { name: "RIF - RMR Mortgage Trust", ticker: "RIF" },
    { name: "ANPCF - ANGLE plc", ticker: "ANPCF" },
    { name: "TOMZD - TOMI Environmental Solutions, Inc.", ticker: "TOMZD" },
    { name: "DBCP - PARTNERS BANCORP", ticker: "DBCP" },
    { name: "PBBI - PB Bancorp, Inc.", ticker: "PBBI" },
    { name: "WINTD - WINDTREE THERAPEUTICS INC /DE/", ticker: "WINTD" },
    { name: "PKDCD - PARKER DRILLING CO /DE/", ticker: "PKDCD" },
    { name: "ERA - Bristow Group Inc.", ticker: "ERA" },
    { name: "FTEO - FRONTEO, INC.", ticker: "FTEO" },
    { name: "PAAC - PROFICIENT ALPHA ACQUISITION CORP", ticker: "PAAC" },
    { name: "PTGED - PORTAGE BIOTECH INC.", ticker: "PTGED" },
    { name: "MDWTD - MIDWEST HOLDING INC.", ticker: "MDWTD" },
    { name: "PGEJF - PGS ASA", ticker: "PGEJF" },
    { name: "TRNE-UN - Trine Acquisition Corp.", ticker: "TRNE-UN" },
    { name: "CHAQ - Chardan Healthcare Acquisition 2 Corp.", ticker: "CHAQ" },
    { name: "MH-PC - Maiden Holdings, Ltd.", ticker: "MH-PC" },
    { name: "HUNTF - Hunter Maritime Acquisition Corp.", ticker: "HUNTF" },
    { name: "EXLLD - EXCELLON RESOURCES INC", ticker: "EXLLD" },
    { name: "MH-PA - Maiden Holdings, Ltd.", ticker: "MH-PA" },
    { name: "MH-PD - Maiden Holdings, Ltd.", ticker: "MH-PD" },
    { name: "UMRX - Cogent Biosciences, Inc.", ticker: "UMRX" },
    { name: "FBIOP - Fortress Biotech, Inc.", ticker: "FBIOP" },
    { name: "UONEK - URBAN ONE, INC.", ticker: "UONEK" },
    { name: "ROCH - Roth CH Acquisition I Co", ticker: "ROCH" },
    { name: "AHT-PF - ASHFORD HOSPITALITY TRUST INC", ticker: "AHT-PF" },
    { name: "AHT-PG - ASHFORD HOSPITALITY TRUST INC", ticker: "AHT-PG" },
    { name: "AHT-PH - ASHFORD HOSPITALITY TRUST INC", ticker: "AHT-PH" },
    { name: "AHT-PI - ASHFORD HOSPITALITY TRUST INC", ticker: "AHT-PI" },
    { name: "TECR - CITRINE GLOBAL, CORP.", ticker: "TECR" },
    { name: "WRCDF - Wirecard AG/ADR", ticker: "WRCDF" },
    { name: "REMOD - BOOMER HOLDINGS, INC.", ticker: "REMOD" },
    { name: "JE-PA - Just Energy Group Inc.", ticker: "JE-PA" },
    { name: "CVLBD - CONVERSION LABS, INC.", ticker: "CVLBD" },
    { name: "RDIB - READING INTERNATIONAL INC", ticker: "RDIB" },
    { name: "EVSI - Envision Solar International, Inc.", ticker: "EVSI" },
    { name: "CSSEP - Chicken Soup for the Soul Entertainment, Inc.", ticker: "CSSEP" },
    { name: "AHT-PD - ASHFORD HOSPITALITY TRUST INC", ticker: "AHT-PD" },
    { name: "CYWDF - Countrywide plc/ADR", ticker: "CYWDF" },
    { name: "JFKKU - 8i Enterprises Acquisition Corp.", ticker: "JFKKU" },
    { name: "MDCL - Medicine Man Technologies, Inc.", ticker: "MDCL" },
    { name: "TDACU - Trident Acquisitions Corp.", ticker: "TDACU" },
    { name: "GSL-PB - Global Ship Lease, Inc.", ticker: "GSL-PB" },
    { name: "IRRZF - Integra Resources Corp.", ticker: "IRRZF" },
    { name: "GPAQ - Hall of Fame Resort & Entertainment Co", ticker: "GPAQ" },
    { name: "HHHH - Scienjoy Holding Corp", ticker: "HHHH" },
    { name: "KBBTF - KUBOTA PHARMACEUTICAL HOLDINGS CO LTD", ticker: "KBBTF" },
    { name: "PBNC - Paragon Commercial CORP", ticker: "PBNC" },
    { name: "OPESU - Opes Acquisition Corp.", ticker: "OPESU" },
    { name: "BBXIB - BBX Capital, Inc.", ticker: "BBXIB" },
    { name: "VAL - Valaris plc", ticker: "VAL" },
    { name: "DDMX - DD3 Acquisition Corp., S.A. de C.V.", ticker: "DDMX" },
    { name: "MNK - Mallinckrodt plc", ticker: "MNK" },
    { name: "MLLLD - Engine Media Holdings, Inc.", ticker: "MLLLD" },
    { name: "RGNP - Reign Resources Corp", ticker: "RGNP" },
    { name: "CHKDP - CHESAPEAKE ENERGY CORP", ticker: "CHKDP" },
    { name: "DLNG-PB - Dynagas LNG Partners LP", ticker: "DLNG-PB" },
    { name: "JCP - J C PENNEY CO INC", ticker: "JCP" },
    { name: "MNCLU - Monocle Acquisition Corp", ticker: "MNCLU" },
    { name: "MELR - Melrose Bancorp, Inc.", ticker: "MELR" },
    { name: "GPAQU - Hall of Fame Resort & Entertainment Co", ticker: "GPAQU" },
    { name: "OLBG - OLB GROUP, INC.", ticker: "OLBG" },
    { name: "TZAC - Tenzing Acquisition Corp.", ticker: "TZAC" },
    { name: "TMSR - Code Chain New Continent Ltd", ticker: "TMSR" },
    { name: "GRCY - Greencity Acquisition Corp", ticker: "GRCY" },
    { name: "MTBCP - MTBC, Inc.", ticker: "MTBCP" },
    { name: "GPVRF - GREENPOWER MOTOR Co INC.", ticker: "GPVRF" },
    { name: "KBLMU - KBL MERGER CORP. IV", ticker: "KBLMU" },
    { name: "EMGC - EMERGENT CAPITAL, INC.", ticker: "EMGC" },
    { name: "SOLQ - Shengda Network Technology, Inc.", ticker: "SOLQ" },
    { name: "ZN - ZION OIL & GAS INC", ticker: "ZN" },
    { name: "ESCU - Carnegie Development, Inc", ticker: "ESCU" },
    { name: "WAYN - WAYNE SAVINGS BANCSHARES INC /DE/", ticker: "WAYN" },
    { name: "WVVIP - WILLAMETTE VALLEY VINEYARDS INC", ticker: "WVVIP" },
    { name: "XRF - SOS Ltd", ticker: "XRF" },
    { name: "ASIN - AS Capital, Inc.", ticker: "ASIN" },
    { name: "ITRK - Loop Media, Inc.", ticker: "ITRK" },
    { name: "PPHI - POSITIVE PHYSICIANS HOLDINGS, INC.", ticker: "PPHI" },
    { name: "BITCF - FIRST BITCOIN CAPITAL CORP.", ticker: "BITCF" },
    { name: "FLFG - Federal Life Group, Inc.", ticker: "FLFG" },
    { name: "MINDP - MIND TECHNOLOGY, INC", ticker: "MINDP" },
    { name: "TFECF - Thin Film Electronics ASA", ticker: "TFECF" },
    { name: "WRLSU - American Virtual Cloud Technologies, Inc.", ticker: "WRLSU" },
    { name: "SMTA - SMTA Liquidating Trust", ticker: "SMTA" },
    { name: "OTTW - Ottawa Bancorp Inc", ticker: "OTTW" },
    { name: "BCTF - Bancorp 34, Inc.", ticker: "BCTF" },
    { name: "PIHPP - 1347 Property Insurance Holdings, Inc.", ticker: "PIHPP" },
    { name: "HRST - Harvest Oil & Gas Corp.", ticker: "HRST" },
    { name: "EQFN - Equitable Financial Corp.", ticker: "EQFN" },
    { name: "INVOD - INVO Bioscience, Inc.", ticker: "INVOD" },
    { name: "UCUT - Silo Pharma, Inc.", ticker: "UCUT" },
    { name: "DCIX - Performance Shipping Inc.", ticker: "DCIX" },
    { name: "TTBLF - Total Brain Limited/ADR", ticker: "TTBLF" },
    { name: "JMDA - Creatd, Inc.", ticker: "JMDA" },
    { name: "MRDDF - OUTCROP GOLD CORP", ticker: "MRDDF" },
    { name: "SHNC - VITASPRING BIOMEDICAL CO. LTD.", ticker: "SHNC" },
    { name: "TLF - TANDY LEATHER FACTORY INC", ticker: "TLF" },
    { name: "AFGC - AMERICAN FINANCIAL GROUP INC", ticker: "AFGC" },
    { name: "MOBQD - Mobiquity Technologies, Inc.", ticker: "MOBQD" },
    { name: "HHT - Color Star Technology Co., Ltd.", ticker: "HHT" },
    { name: "FSBC - FSB Bancorp, Inc.", ticker: "FSBC" },
    { name: "EFBI - Eagle Financial Bancorp, Inc.", ticker: "EFBI" },
    { name: "EXLLF - EXCELLON RESOURCES INC", ticker: "EXLLF" },
    { name: "JMDAD - Creatd, Inc.", ticker: "JMDAD" },
    { name: "BOARF - BOART LONGYEAR LTD", ticker: "BOARF" },
    { name: "TDRYF - Red White & Bloom Brands Inc.", ticker: "TDRYF" },
    { name: "HHHHU - Scienjoy Holding Corp", ticker: "HHHHU" },
    { name: "KLDA - BANGFU TECHNOLOGY GROUP CO., LTD.", ticker: "KLDA" },
    { name: "TLDN - Telidyne, Inc.", ticker: "TLDN" },
    { name: "CUI - Orbital Energy Group, Inc.", ticker: "CUI" },
    { name: "INNT - 9 METERS BIOPHARMA, INC.", ticker: "INNT" },
    { name: "MOAEF - Mongolia Energy Corp Ltd", ticker: "MOAEF" },
    { name: "GRTDD - Home Bistro, Inc. /NV/", ticker: "GRTDD" },
    { name: "BMSN - Rivulet Media, Inc.", ticker: "BMSN" },
    { name: "GRWCD - GROW CAPITAL, INC.", ticker: "GRWCD" },
    { name: "NORZF - NORZINC LTD.", ticker: "NORZF" },
    { name: "NM-PG - Navios Maritime Holdings Inc.", ticker: "NM-PG" },
    { name: "GLLX - OMNIA WELLNESS INC.", ticker: "GLLX" },
    { name: "PVOTF - BetterLife Pharma Inc.", ticker: "PVOTF" },
    { name: "WRLS - American Virtual Cloud Technologies, Inc.", ticker: "WRLS" },
    { name: "GHHHD - GPO Plus, Inc.", ticker: "GHHHD" },
    { name: "PER - SandRidge Permian Trust", ticker: "PER" },
    { name: "ELCQ - Electromedical Technologies, Inc", ticker: "ELCQ" },
    { name: "EMMS - EMMIS COMMUNICATIONS CORP", ticker: "EMMS" },
    { name: "NM-PH - Navios Maritime Holdings Inc.", ticker: "NM-PH" },
    { name: "LFIN - Longfin Corp", ticker: "LFIN" },
    { name: "ZCOR - Zyla Life Sciences", ticker: "ZCOR" },
    { name: "HRSTD - Harvest Oil & Gas Corp.", ticker: "HRSTD" },
    { name: "CNAT - Histogen Inc.", ticker: "CNAT" },
    { name: "EVSIW - Envision Solar International, Inc.", ticker: "EVSIW" },
    { name: "UWT - CITIGROUP INC", ticker: "UWT" },
    { name: "HHS - HARTE HANKS INC", ticker: "HHS" },
    { name: "HRGG - Heritage NOLA Bancorp, Inc.", ticker: "HRGG" },
    { name: "GMO - General Moly, Inc", ticker: "GMO" },
    { name: "WCFB - WCF Bancorp, Inc.", ticker: "WCFB" },
    { name: "AWSMD - Simply, Inc.", ticker: "AWSMD" },
    { name: "RTW - RTW Retailwinds, Inc.", ticker: "RTW" },
    { name: "SVBLD - SILVER BULL RESOURCES, INC.", ticker: "SVBLD" },
    { name: "ROSE - Rosehill Resources Inc.", ticker: "ROSE" },
    { name: "GRYOD - Ameritrust Corp", ticker: "GRYOD" },
    { name: "ULUR - ULURU Inc.", ticker: "ULUR" },
    { name: "TROV - Cardiff Oncology, Inc.", ticker: "TROV" },
    { name: "DMPI - Kintara Therapeutics, Inc.", ticker: "DMPI" },
    { name: "HCR - Hi-Crush Inc.", ticker: "HCR" },
    { name: "TLRD - TAILORED BRANDS INC", ticker: "TLRD" },
    { name: "PIR - PIER 1 IMPORTS INC/DE", ticker: "PIR" },
    { name: "RYCE - Amira Nature Foods Ltd.", ticker: "RYCE" },
    { name: "MCIG - BOTS, Inc./PR", ticker: "MCIG" },
    { name: "WHLRD - Wheeler Real Estate Investment Trust, Inc.", ticker: "WHLRD" },
    { name: "GHHH - GPO Plus, Inc.", ticker: "GHHH" },
    { name: "MDRIQ - MCDERMOTT INTERNATIONAL INC", ticker: "MDRIQ" },
    { name: "TVC - Tennessee Valley Authority", ticker: "TVC" },
    { name: "ESCC - EVANS & SUTHERLAND COMPUTER CORP", ticker: "ESCC" },
    { name: "CPKA - CHASE PACKAGING CORP", ticker: "CPKA" },
    { name: "ROYT - Pacific Coast Oil Trust", ticker: "ROYT" },
    { name: "TUES - TUESDAY MORNING CORP/DE", ticker: "TUES" },
    { name: "BMSND - Rivulet Media, Inc.", ticker: "BMSND" },
    { name: "PSV - HERMITAGE OFFSHORE SERVICES LTD.", ticker: "PSV" },
    { name: "UNT - UNIT CORP", ticker: "UNT" },
    { name: "CIFS - Hudson Capital Inc.", ticker: "CIFS" },
    { name: "GNMX - Aevi Genomic Medicine, LLC", ticker: "GNMX" },
    { name: "ULURD - ULURU Inc.", ticker: "ULURD" },
    { name: "CSHB - COMMUNITY SHORES BANK CORP", ticker: "CSHB" },
    { name: "TWMC - Kaspien Holdings Inc.", ticker: "TWMC" },
    { name: "AKRX - AKORN INC", ticker: "AKRX" },
    { name: "TORC - Adicet Bio, Inc.", ticker: "TORC" },
    { name: "SEGN - RENAVOTIO, INC.", ticker: "SEGN" },
    { name: "BXEFF - Bellatrix Exploration Ltd.", ticker: "BXEFF" },
    { name: "WSTL - WESTELL TECHNOLOGIES INC", ticker: "WSTL" },
    { name: "HYAS - HUALE ACOUSTICS Ltd", ticker: "HYAS" },
    { name: "JTBK - Jetblack Corp", ticker: "JTBK" },
    { name: "CETXP - CEMTREX INC", ticker: "CETXP" },
    { name: "CNMF - SPLASH BEVERAGE GROUP, INC.", ticker: "CNMF" },
    { name: "EMITF - ELBIT IMAGING LTD", ticker: "EMITF" },
    { name: "PRSEF - Prosafe SE/ADR", ticker: "PRSEF" },
    { name: "CNWHF - China Networks International Holdings Ltd", ticker: "CNWHF" },
    { name: "NDYND - VININGS HOLDINGS, INC.", ticker: "NDYND" },
    { name: "WHLRP - Wheeler Real Estate Investment Trust, Inc.", ticker: "WHLRP" },
    { name: "CTRC - Centric Brands Inc.", ticker: "CTRC" },
    { name: "COFE - COFFEESMITHS COLLECTIVE, INC.", ticker: "COFE" },
    { name: "ROYE - Royal Energy Resources, Inc.", ticker: "ROYE" },
    { name: "ILXP - International Luxury Products, Inc.", ticker: "ILXP" },
    { name: "BNTCW - Benitec Biopharma LTD/ADR", ticker: "BNTCW" },
    { name: "SIGM - SIGMA DESIGNS INC", ticker: "SIGM" },
    { name: "WISH - Wright Investors Service Holdings, Inc.", ticker: "WISH" },
    { name: "INLXD - INTELLINETICS, INC.", ticker: "INLXD" },
    { name: "VVUS - VIVUS INC", ticker: "VVUS" },
    { name: "MDDT - Medico International Inc.", ticker: "MDDT" },
    { name: "FHRT - FIRST HARTFORD CORP", ticker: "FHRT" },
    { name: "ETBI - EASTGATE BIOTECH CORP", ticker: "ETBI" },
    { name: "CCCL - Antelope Enterprise Holdings Ltd", ticker: "CCCL" },
    { name: "ADHG - Ando Holdings Ltd.", ticker: "ADHG" },
    { name: "NMGX - Nano Magic Inc.", ticker: "NMGX" },
    { name: "ENT - Global Eagle Entertainment Inc.", ticker: "ENT" },
    { name: "ECT - ECA Marcellus Trust I", ticker: "ECT" },
    { name: "SPNV - Supernova Partners Acquisition Company, Inc.", ticker: "SPNV" },
    { name: "LONE - Lonestar Resources US Inc.", ticker: "LONE" },
    { name: "SPN - SUPERIOR ENERGY SERVICES INC", ticker: "SPN" },
    { name: "PIRE - FOURTH WAVE ENERGY, INC.", ticker: "PIRE" },
    { name: "BLGID - BLGI, INC.", ticker: "BLGID" },
    { name: "ASNA - Ascena Retail Group, Inc.", ticker: "ASNA" },
    { name: "CRSAW - Crescent Acquisition Corp", ticker: "CRSAW" },
    { name: "MILVD - MISTRAL VENTURES INC", ticker: "MILVD" },
    { name: "ALTN - Alternus Energy Inc.", ticker: "ALTN" },
    { name: "SLNM - SALON MEDIA GROUP INC", ticker: "SLNM" },
    { name: "VERBW - Verb Technology Company, Inc.", ticker: "VERBW" },
    { name: "YRIV - Yangtze River Port & Logistics Ltd", ticker: "YRIV" },
    { name: "MCTC - CANNABIS GLOBAL, INC.", ticker: "MCTC" },
    { name: "RMDM - TechCom, Inc.", ticker: "RMDM" },
    { name: "MXSGD - Mexus Gold US", ticker: "MXSGD" },
    { name: "PNTV - PLAYERS NETWORK", ticker: "PNTV" },
    { name: "GFOOD - Genufood Energy Enzymes Corp.", ticker: "GFOOD" },
    { name: "WMGR - Wellness Matrix Group, Inc.", ticker: "WMGR" },
    { name: "SNYR - Synergy CHC Corp.", ticker: "SNYR" },
    { name: "CCSB - Community Savings Bancorp, Inc.", ticker: "CCSB" },
    { name: "TRPX - Therapix Biosciences Ltd.", ticker: "TRPX" },
    { name: "SNIPF - Snipp Interactive Inc.", ticker: "SNIPF" },
    { name: "PARF - PARADISE INC", ticker: "PARF" },
    { name: "ELGX - ENDOLOGIX INC /DE/", ticker: "ELGX" },
    { name: "GLFW - Wetouch Technology Inc.", ticker: "GLFW" },
    { name: "GGBXF - Green Growth Brands Inc.", ticker: "GGBXF" },
    { name: "UBID - RDE, Inc.", ticker: "UBID" },
    { name: "MISM - MISSION MINING Co", ticker: "MISM" },
    { name: "MDTRD - ADVANCED CONTAINER TECHNOLOGIES, INC.", ticker: "MDTRD" },
    { name: "MCPI - Mansfield-Martin Exploration Mining, Inc.", ticker: "MCPI" },
    { name: "FNHI - Worksport, Ltd", ticker: "FNHI" },
    { name: "SMRT - STEIN MART INC", ticker: "SMRT" },
    { name: "RYCFF - Amira Nature Foods Ltd.", ticker: "RYCFF" },
    { name: "MISMD - MISSION MINING Co", ticker: "MISMD" },
    { name: "BJCD - Luduson G Inc.", ticker: "BJCD" },
    { name: "NTRU - Natur International Corp.", ticker: "NTRU" },
    { name: "INSYQ - Insys Therapeutics, Inc.", ticker: "INSYQ" },
    { name: "ZFGN - Larimar Therapeutics, Inc.", ticker: "ZFGN" },
    { name: "UBIDD - RDE, Inc.", ticker: "UBIDD" },
    { name: "QHCCQ - Quorum Health Corp", ticker: "QHCCQ" },
    { name: "BFFI - Ben Franklin Financial, Inc.", ticker: "BFFI" },
    { name: "BANJ - XERIANT, INC.", ticker: "BANJ" },
    { name: "UPLC - ULTRA PETROLEUM CORP", ticker: "UPLC" },
    { name: "TNTY - Mitesco, Inc.", ticker: "TNTY" },
    { name: "AGHI - Agora Holdings, Inc.", ticker: "AGHI" },
    { name: "GQMNF - Golden Queen Mining Consolidated Ltd.", ticker: "GQMNF" },
    { name: "MLLS - MILLER INDUSTRIES INC", ticker: "MLLS" },
    { name: "TEHG - Technovative Group, Inc.", ticker: "TEHG" },
    { name: "VEGL - Vegalab, Inc.", ticker: "VEGL" },
    { name: "NTAHD - NEVTAH CAPITAL MANAGEMENT CORP", ticker: "NTAHD" },
    { name: "THST - Truett-Hurst, Inc.", ticker: "THST" },
    { name: "IPIC - iPic Entertainment Inc.", ticker: "IPIC" },
    { name: "INAP - Internap Corp", ticker: "INAP" },
    { name: "MOBO - Mobile Lads Corp", ticker: "MOBO" },
    { name: "HDII - HYPERTENSION DIAGNOSTICS INC /MN", ticker: "HDII" },
    { name: "AIVN - AMERICAN INTERNATIONAL VENTURES INC /DE/", ticker: "AIVN" },
    { name: "RHE-PA - REGIONAL HEALTH PROPERTIES, INC", ticker: "RHE-PA" },
    { name: "TOCA - Forte Biosciences, Inc.", ticker: "TOCA" },
    { name: "PTOI - Plastic2Oil, Inc.", ticker: "PTOI" },
    { name: "SAEX - SAExploration Holdings, Inc.", ticker: "SAEX" },
    { name: "GKIT - GREENKRAFT, INC.", ticker: "GKIT" },
    { name: "CPOW - Hemp Technology, Inc.", ticker: "CPOW" },
    { name: "AFTM - AFTERMASTER, INC.", ticker: "AFTM" },
    { name: "CRRT - CARBO CERAMICS INC", ticker: "CRRT" },
    { name: "IGLDF - INTERNET GOLD GOLDEN LINES LTD", ticker: "IGLDF" },
    { name: "SBSAA - SPANISH BROADCASTING SYSTEM INC", ticker: "SBSAA" },
    { name: "AMRQQ - Alta Mesa Resources, Inc. /DE", ticker: "AMRQQ" },
    { name: "BRQSW - Borqs Technologies, Inc.", ticker: "BRQSW" },
    { name: "MLNTQ - MELINTA THERAPEUTICS, INC. /NEW/", ticker: "MLNTQ" },
    { name: "TAKD - TRANSAKT LTD.", ticker: "TAKD" },
    { name: "PACVD - Pacific Ventures Group, Inc.", ticker: "PACVD" },
    { name: "BTHI - Big Time Holdings, Inc.", ticker: "BTHI" },
    { name: "HCTI - HYBRID Coating Technologies Inc.", ticker: "HCTI" },
    { name: "CLIS - ClickStream Corp", ticker: "CLIS" },
    { name: "SYEV - SEYCHELLE ENVIRONMENTAL TECHNOLOGIES INC /CA", ticker: "SYEV" },
    { name: "JASN - Jason Industries, Inc.", ticker: "JASN" },
    { name: "TEAR - TearLab Corp", ticker: "TEAR" },
    { name: "CNAB - United Cannabis Corp", ticker: "CNAB" },
    { name: "IMUC - ImmunoCellular Therapeutics, Ltd.", ticker: "IMUC" },
    { name: "LKSD - LSC Communications, Inc.", ticker: "LKSD" },
    { name: "XSNXD - NovAccess Global Inc.", ticker: "XSNXD" },
    { name: "TVMDD - QDM International Inc.", ticker: "TVMDD" },
    { name: "SITO - SITO MOBILE, LTD.", ticker: "SITO" },
    { name: "FCHS - First Choice Healthcare Solutions, Inc.", ticker: "FCHS" },
    { name: "CMHZ - Banny Cosmic International Holdings, Inc", ticker: "CMHZ" },
    { name: "APYP - APPYEA, INC", ticker: "APYP" },
    { name: "PKPH - PEAK PHARMACEUTICALS, INC.", ticker: "PKPH" },
    { name: "STRI - STR HOLDINGS, INC.", ticker: "STRI" },
    { name: "IMUCD - ImmunoCellular Therapeutics, Ltd.", ticker: "IMUCD" },
    { name: "DCAR - AYRO, Inc.", ticker: "DCAR" },
    { name: "YOGA - YogaWorks, Inc.", ticker: "YOGA" },
    { name: "FELPQ - Foresight Energy LP", ticker: "FELPQ" },
    { name: "GSPH - Geospatial Corp", ticker: "GSPH" },
    { name: "DXIED - DXI Energy Inc.", ticker: "DXIED" },
    { name: "PFTI - PURADYN FILTER TECHNOLOGIES INC", ticker: "PFTI" },
    { name: "RTTR - Qualigen Therapeutics, Inc.", ticker: "RTTR" },
    { name: "CAPS - Capstone Therapeutics Corp.", ticker: "CAPS" },
    { name: "SNECQ - Sanchez Energy Corp", ticker: "SNECQ" },
    { name: "GRYO - Ameritrust Corp", ticker: "GRYO" },
    { name: "FLSS - Forbes Energy Services Ltd.", ticker: "FLSS" },
    { name: "LOGG - BRIDGEWAY NATIONAL CORP.", ticker: "LOGG" },
    { name: "HOSS - HORNBECK OFFSHORE SERVICES INC /LA", ticker: "HOSS" },
    { name: "ARDMQ - ARADIGM CORP", ticker: "ARDMQ" },
    { name: "PTRC - Petro River Oil Corp.", ticker: "PTRC" },
    { name: "EVTND - ENVIRO TECHNOLOGIES, INC.", ticker: "EVTND" },
    { name: "SSNYY - Samson Oil & Gas LTD", ticker: "SSNYY" },
    { name: "RGNPD - Reign Resources Corp", ticker: "RGNPD" },
    { name: "PSYC - Telemynd, Inc.", ticker: "PSYC" },
    { name: "RHNO - Rhino Resource Partners LP", ticker: "RHNO" },
    { name: "RNVAD - Rennova Health, Inc.", ticker: "RNVAD" },
    { name: "INCM - INNOCOM TECHNOLOGY HOLDINGS, INC.", ticker: "INCM" },
    { name: "IMLE - SOBR Safe, Inc.", ticker: "IMLE" },
    { name: "SGSID - Spectrum Global Solutions, Inc.", ticker: "SGSID" },
    { name: "COHO - Crednology Holding Corp", ticker: "COHO" },
    { name: "DGTW - DigitalTown, Inc.", ticker: "DGTW" },
    { name: "GRTD - Home Bistro, Inc. /NV/", ticker: "GRTD" },
    { name: "ENCC - TRAILBLAZER RESOURCES INC.", ticker: "ENCC" },
    { name: "WMTN - WESTMOUNTAIN GOLD, INC.", ticker: "WMTN" },
    { name: "PWDY - POWERDYNE INTERNATIONAL, INC.", ticker: "PWDY" },
    { name: "QPWRD - Q2Earth Inc.", ticker: "QPWRD" },
    { name: "BLEG - Branded Legacy, Inc.", ticker: "BLEG" },
    { name: "AKAOQ - Achaogen, Inc.", ticker: "AKAOQ" },
    { name: "ATIS - Attis Industries Inc.", ticker: "ATIS" },
    { name: "CRRTQ - CARBO CERAMICS INC", ticker: "CRRTQ" },
    { name: "PTLF - PetLife Pharmaceuticals, Inc.", ticker: "PTLF" },
    { name: "GIDYL - GI DYNAMICS, INC.", ticker: "GIDYL" },
    { name: "FBEC - FBEC Worldwide Inc.", ticker: "FBEC" },
    { name: "LFERD - Life On Earth, Inc.", ticker: "LFERD" },
    { name: "PSRU - PURESPECTRUM, INC.", ticker: "PSRU" },
    { name: "ATNWW - Actinium Pharmaceuticals, Inc.", ticker: "ATNWW" },
    { name: "MNELF - Mission NewEnergy Ltd", ticker: "MNELF" },
    { name: "SCOO - SCHOOL SPECIALTY INC", ticker: "SCOO" },
    { name: "CLDPQ - CLOUD PEAK ENERGY INC.", ticker: "CLDPQ" },
    { name: "ROKK - Rokk3r Inc.", ticker: "ROKK" },
    { name: "ROKKD - Rokk3r Inc.", ticker: "ROKKD" },
    { name: "NVTRQ - Nuvectra Corp", ticker: "NVTRQ" },
    { name: "ADADD - Adaiah Distribution Inc", ticker: "ADADD" },
    { name: "FREDQ - FREDS INC", ticker: "FREDQ" },
    { name: "PVDG - Poverty Dignified, Inc.", ticker: "PVDG" },
    { name: "MZEIQ - MEDIZONE INTERNATIONAL INC", ticker: "MZEIQ" },
    { name: "AWGI - Ambient Water Corp", ticker: "AWGI" },
    { name: "NSPXD - Inspyr Therapeutics, Inc.", ticker: "NSPXD" },
    { name: "VBVT - Viabuilt Ventures Inc.", ticker: "VBVT" },
    { name: "ITCC - InsPro Technologies Corp", ticker: "ITCC" },
    { name: "GEMP - NeuroBo Pharmaceuticals, Inc.", ticker: "GEMP" },
    { name: "TMPSW - Tempus Applied Solutions Holdings, Inc.", ticker: "TMPSW" },
    { name: "IMUCW - ImmunoCellular Therapeutics, Ltd.", ticker: "IMUCW" },
    { name: "VLRXQ - Valeritas Holdings Inc.", ticker: "VLRXQ" },
    { name: "INTP - Boston Carriers, Inc.", ticker: "INTP" },
    { name: "ARTLW - ARTELO BIOSCIENCES, INC.", ticker: "ARTLW" },
    { name: "MPAY - MOBETIZE, CORP.", ticker: "MPAY" },
    { name: "ADMG - ADAMANT DRI PROCESSING & MINERALS GROUP", ticker: "ADMG" },
    { name: "APHDD - VERDE BIO HOLDINGS, INC.", ticker: "APHDD" },
    { name: "SIMLD - Simlatus Corp", ticker: "SIMLD" },
    { name: "GLBR - Global Brokerage, Inc.", ticker: "GLBR" },
    { name: "PRHRQ - PetroShare Corp.", ticker: "PRHRQ" },
    { name: "GFGVF - PROSALUTIS HOLDINGS INC.", ticker: "GFGVF" },
    { name: "AIRTW - AIR T INC", ticker: "AIRTW" },
    { name: "STWC - STWC. Holdings, Inc.", ticker: "STWC" },
    { name: "VCON - VICON INDUSTRIES INC /NY/", ticker: "VCON" },
    { name: "RNVAW - Rennova Health, Inc.", ticker: "RNVAW" },
    { name: "CDIXD - Cardiff Lexington Corp", ticker: "CDIXD" },
    { name: "ESES - Eco-Stim Energy Solutions, Inc.", ticker: "ESES" },
    { name: "FPPP - FIELDPOINT PETROLEUM CORP", ticker: "FPPP" },
    { name: "STJO - ST JOSEPH INC", ticker: "STJO" },
    { name: "COTE - COATES INTERNATIONAL LTD", ticker: "COTE" },
    { name: "APTY - APT Systems Inc", ticker: "APTY" },
    { name: "SGRB - SIGMABROADBAND CO.", ticker: "SGRB" },
    { name: "AIFM - AIFARM, LTD.", ticker: "AIFM" },
    { name: "CHWE - CHINAWE COM INC", ticker: "CHWE" },
    { name: "BTGI - Bulova Technologies Group, Inc.", ticker: "BTGI" },
    { name: "SHIPZ - Seanergy Maritime Holdings Corp.", ticker: "SHIPZ" },
    { name: "TPNI - Pulse Network, Inc.", ticker: "TPNI" },
    { name: "ESESQ - Eco-Stim Energy Solutions, Inc.", ticker: "ESESQ" },
    { name: "SHIPW - Seanergy Maritime Holdings Corp.", ticker: "SHIPW" },
    { name: "AITXD - Artificial Intelligence Technology Solutions Inc.", ticker: "AITXD" },
    { name: "HCCCD - VISION HYDROGEN Corp", ticker: "HCCCD" },
    { name: "UNEQ - UNEEQO, INC.", ticker: "UNEQ" },
    { name: "SYATF - Siyata Mobile Inc.", ticker: "SYATF" },
    { name: "FAVO - Favo Realty, Inc", ticker: "FAVO" },
    { name: "UNEQD - UNEEQO, INC.", ticker: "UNEQD" },
    { name: "AHCP - Changsheng International Group Ltd", ticker: "AHCP" },
    { name: "DRNG - Drone Guarder, Inc.", ticker: "DRNG" },
    { name: "NHEL - NATURAL HEALTH FARM HOLDINGS INC", ticker: "NHEL" },
    { name: "STTHD - STEALTH TECHNOLOGIES, INC.", ticker: "STTHD" },
    { name: "SCHS - SMARTCHASE CORP.", ticker: "SCHS" },
    { name: "BKCT - DTS8 COFFEE COMPANY, LTD.", ticker: "BKCT" },
    { name: "HDYNQ - HYPERDYNAMICS CORP", ticker: "HDYNQ" },
    { name: "MTST - MetaStat, Inc.", ticker: "MTST" },
    { name: "CSRH - Consorteum Holdings, Inc.", ticker: "CSRH" },
    { name: "GRSU - Greenhouse Solutions, Inc.", ticker: "GRSU" },
    { name: "GXXMD - GEX MANAGEMENT, INC.", ticker: "GXXMD" },
    { name: "TVMD - QDM International Inc.", ticker: "TVMD" },
    { name: "OMSH - Omni Shrimp, Inc.", ticker: "OMSH" },
    { name: "CRSM - Carsmartt, Inc.", ticker: "CRSM" },
    { name: "ANVV - Anvia Holdings Corp", ticker: "ANVV" },
    { name: "PBYA - Probility Media Corp", ticker: "PBYA" },
    { name: "SVTE - Service Team Inc.", ticker: "SVTE" },
    { name: "LMNK - LIFESTYLE MEDICAL NETWORK, INC.", ticker: "LMNK" },
    { name: "FUTL - FUTURELAND CORP.", ticker: "FUTL" },
    { name: "BRKKD - Gen 2 Technologies Inc.", ticker: "BRKKD" },
    { name: "VATE - Branded Legacy, Inc.", ticker: "VATE" },
    { name: "MILV - MISTRAL VENTURES INC", ticker: "MILV" },
    { name: "KLMN - Nanovation Microtech, Inc.", ticker: "KLMN" },
    { name: "NTAH - NEVTAH CAPITAL MANAGEMENT CORP", ticker: "NTAH" },
    { name: "PRGNF - Paragon Shipping Inc.", ticker: "PRGNF" },
    { name: "PAQWF - PRIME ACQUISITION CORP", ticker: "PAQWF" },
    { name: "APHD - VERDE BIO HOLDINGS, INC.", ticker: "APHD" },
    { name: "PSID - POSITIVEID Corp", ticker: "PSID" },
    { name: "RBNW - Renewable Energy & Power, Inc.", ticker: "RBNW" },
    { name: "CALI - China Auto Logistics Inc", ticker: "CALI" },
    { name: "FJHLD - Fovea Jewelry Holdings Ltd.", ticker: "FJHLD" },
    { name: "RPT-PD - RPT Realty", ticker: "RPT-PD" },
    { name: "CBS - ViacomCBS Inc.", ticker: "CBS" },
    { name: "JCQQF - APi Group Corp", ticker: "JCQQF" },
    { name: "LSACU - LifeSci Acquisition Corp.", ticker: "LSACU" },
    { name: "JCQQ - APi Group Corp", ticker: "JCQQ" },
    { name: "METXW - Meten EdtechX Education Group Ltd.", ticker: "METXW" },
    { name: "MTXWF - Meten EdtechX Education Group Ltd.", ticker: "MTXWF" },
    { name: "PTK-WT - PTK Acquisition Corp.", ticker: "PTK-WT" },
    { name: "SOAC-UN - Sustainable Opportunities Acquisition Corp.", ticker: "SOAC-UN" },
    { name: "SOAC-WT - Sustainable Opportunities Acquisition Corp.", ticker: "SOAC-WT" },
    { name: "CHAQ-WT - Chardan Healthcare Acquisition 2 Corp.", ticker: "CHAQ-WT" },
    { name: "GB-WT - Global Blue Group Holding AG", ticker: "GB-WT" },
    { name: "PCPL-UN - CC Neuberger Principal Holdings I", ticker: "PCPL-UN" },
    { name: "PCPL-WT - CC Neuberger Principal Holdings I", ticker: "PCPL-WT" },
    { name: "JWS-UN - Jaws Acquisition Corp.", ticker: "JWS-UN" },
    { name: "JWS-WT - Jaws Acquisition Corp.", ticker: "JWS-WT" },
    { name: "LCAPW - Lionheart Acquisition Corp. II", ticker: "LCAPW" },
    { name: "LCAP - Lionheart Acquisition Corp. II", ticker: "LCAP" },
    { name: "FEAC-WT - Flying Eagle Acquisition Corp.", ticker: "FEAC-WT" },
    { name: "FEAC-UN - Flying Eagle Acquisition Corp.", ticker: "FEAC-UN" },
    { name: "FVAC-UN - Fortress Value Acquisition Corp.", ticker: "FVAC-UN" },
    { name: "FVAC-WT - Fortress Value Acquisition Corp.", ticker: "FVAC-WT" },
    { name: "IPOC-WT - Social Capital Hedosophia Holdings Corp. III", ticker: "IPOC-WT" },
    { name: "IPOB-WT - Social Capital Hedosophia Holdings Corp. II", ticker: "IPOB-WT" },
    { name: "PSAC - Property Solutions Acquisition Corp.", ticker: "PSAC" },
    { name: "ACND-WT - Ascendant Digital Acquisition Corp.", ticker: "ACND-WT" },
    { name: "ACND - Ascendant Digital Acquisition Corp.", ticker: "ACND" },
    { name: "TREB-UN - Trebia Acquisition Corp.", ticker: "TREB-UN" },
    { name: "TREB-WT - Trebia Acquisition Corp.", ticker: "TREB-WT" },
    { name: "MLACW - Malacca Straits Acquisition Co Ltd", ticker: "MLACW" },
    { name: "OLENW - Open Lending Corp", ticker: "OLENW" },
    { name: "LGHLW - Lion Group Holding Ltd", ticker: "LGHLW" },
    { name: "LGVW-WT - Longview Acquisition Corp.", ticker: "LGVW-WT" },
    { name: "CPSR-WT - CAPSTAR SPECIAL PURPOSE ACQUISITION CORP.", ticker: "CPSR-WT" },
    { name: "BMRG-WT - B. Riley Principal Merger Corp. II", ticker: "BMRG-WT" },
    { name: "CPSR - CAPSTAR SPECIAL PURPOSE ACQUISITION CORP.", ticker: "CPSR" },
    { name: "GIK-WT - GigCapital3, Inc.", ticker: "GIK-WT" },
    { name: "AACQW - Artius Acquisition Inc.", ticker: "AACQW" },
    { name: "HECCW - Hudson Executive Investment Corp.", ticker: "HECCW" },
    { name: "KSMTW - Kismet Acquisition One Corp", ticker: "KSMTW" },
    { name: "KSMT - Kismet Acquisition One Corp", ticker: "KSMT" },
    { name: "RBAC-WT - RedBall Acquisition Corp.", ticker: "RBAC-WT" },
    { name: "HOLUW - Holicity Inc.", ticker: "HOLUW" },
    { name: "ERESW - East Resources Acquisition Co", ticker: "ERESW" },
    { name: "ETACW - E.Merge Technology Acquisition Corp.", ticker: "ETACW" },
    { name: "ETAC - E.Merge Technology Acquisition Corp.", ticker: "ETAC" },
    { name: "ERES - East Resources Acquisition Co", ticker: "ERES" },
    { name: "DFHTW - Deerfield Healthcare Technology Acquisitions Corp.", ticker: "DFHTW" },
    { name: "FAII-WT - Fortress Value Acquisition Corp. II", ticker: "FAII-WT" },
    { name: "FAII - Fortress Value Acquisition Corp. II", ticker: "FAII" },
    { name: "YAC-WT - Yucaipa Acquisition Corp", ticker: "YAC-WT" },
    { name: "NGA-WT - Northern Genesis Acquisition Corp.", ticker: "NGA-WT" },
    { name: "FST-WT - FAST Acquisition Corp.", ticker: "FST-WT" },
    { name: "CLA-WT - Colonnade Acquisition Corp.", ticker: "CLA-WT" },
    { name: "GOAC-WT - GO Acquisition Corp.", ticker: "GOAC-WT" },
    { name: "DMYD-UN - dMY Technology Group, Inc. II", ticker: "DMYD-UN" },
    { name: "DMYD-WT - dMY Technology Group, Inc. II", ticker: "DMYD-WT" },
    { name: "PANA-UN - Panacea Acquisition Corp", ticker: "PANA-UN" },
    { name: "CCIV-WT - Churchill Capital Corp IV", ticker: "CCIV-WT" },
    { name: "PANA-WT - Panacea Acquisition Corp", ticker: "PANA-WT" },
    { name: "LSSDF - Radius Global Infrastructure, Inc.", ticker: "LSSDF" },
    { name: "VMACW - Vistas Media Acquisition Co Inc.", ticker: "VMACW" },
    { name: "KCAC-UN - Kensington Capital Acquisition Corp.", ticker: "KCAC-UN" },
    { name: "KCAC-WT - Kensington Capital Acquisition Corp.", ticker: "KCAC-WT" },
    { name: "PSTH-UN - Pershing Square Tontine Holdings, Ltd.", ticker: "PSTH-UN" },
    { name: "PSTH-WT - Pershing Square Tontine Holdings, Ltd.", ticker: "PSTH-WT" },
    { name: "DEH-WT - D8 Holdings Corp.", ticker: "DEH-WT" },
    { name: "PRPB-WT - CC Neuberger Principal Holdings II", ticker: "PRPB-WT" },
    { name: "FUSE-WT - Fusion Acquisition Corp.", ticker: "FUSE-WT" },
    { name: "WPF-WT - Foley Trasimene Acquisition Corp.", ticker: "WPF-WT" },
    { name: "GSAH-WT - GS Acquisition Holdings Corp II", ticker: "GSAH-WT" },
    { name: "HPX-WT - HPX Corp.", ticker: "HPX-WT" },
    { name: "IMTXW - Immatics N.V.", ticker: "IMTXW" },
    { name: "HPX - HPX Corp.", ticker: "HPX" },
    { name: "YSW - Yellowstone Acquisition Co", ticker: "YSW" },
    { name: "YS - Yellowstone Acquisition Co", ticker: "YS" },
    { name: "NBA - New Beginnings Acquisition Corp.", ticker: "NBA" },
    { name: "LCY - Landcadia Holdings III, Inc.", ticker: "LCY" },
    { name: "ASAQ-WT - Atlantic Avenue Acquisition Corp", ticker: "ASAQ-WT" },
    { name: "IPOD - Social Capital Hedosophia Holdings Corp. IV", ticker: "IPOD" },
    { name: "IPOE - Social Capital Hedosophia Holdings Corp. V", ticker: "IPOE" },
    { name: "BFT-WT - Foley Trasimene Acquisition II", ticker: "BFT-WT" },
    { name: "DGNR-WT - Dragoneer Growth Opportunities Corp.", ticker: "DGNR-WT" },
    { name: "IPOF - Social Capital Hedosophia Holdings Corp. VI", ticker: "IPOF" },
    { name: "AONE-WT - one", ticker: "AONE-WT" },
    { name: "GRSVU - Gores Holdings V Inc.", ticker: "GRSVU" },
    { name: "GRSVW - Gores Holdings V Inc.", ticker: "GRSVW" },
    { name: "HZAC-UN - Horizon Acquisition Corp", ticker: "HZAC-UN" },
    { name: "HZAC-WT - Horizon Acquisition Corp", ticker: "HZAC-WT" },
    { name: "NFH-WT - New Frontier Health Corp", ticker: "NFH-WT" },
    { name: "GSMGW - GLORY STAR NEW MEDIA GROUP HOLDINGS Ltd", ticker: "GSMGW" },
    { name: "ELAT - Elanco Animal Health Inc", ticker: "ELAT" },
    { name: "PHGE-UN - BiomX Inc.", ticker: "PHGE-UN" },
    { name: "PHGE-WT - BiomX Inc.", ticker: "PHGE-WT" },
    { name: "UTZ-WT - Utz Brands, Inc.", ticker: "UTZ-WT" },
    { name: "CCH-WT - Utz Brands, Inc.", ticker: "CCH-WT" },
    { name: "FPAC-WT - Far Point Acquisition Corp", ticker: "FPAC-WT" },
    { name: "GTECW - Greenland Technologies Holding Corp.", ticker: "GTECW" },
    { name: "TZACW - Tenzing Acquisition Corp.", ticker: "TZACW" },
    { name: "GDYNW - GRID DYNAMICS HOLDINGS, INC.", ticker: "GDYNW" },
    { name: "AMCIW - AMCI Acquisition Corp.", ticker: "AMCIW" },
    { name: "ARYAW - ARYA SCIENCES ACQUISITION CORP.", ticker: "ARYAW" },
    { name: "GRAF-WT - Velodyne Lidar, Inc.", ticker: "GRAF-WT" },
    { name: "FMCIW - Tattooed Chef, Inc.", ticker: "FMCIW" },
    { name: "CFFAW - CF Finance Acquisition Corp.", ticker: "CFFAW" },
    { name: "IMACW - IMAC Holdings, Inc.", ticker: "IMACW" },
    { name: "AVGOP - Broadcom Inc.", ticker: "AVGOP" },
    { name: "OPESW - Opes Acquisition Corp.", ticker: "OPESW" },
    { name: "MFAC-WT - Megalith Financial Acquisition Corp", ticker: "MFAC-WT" },
    { name: "DMS-WT - Digital Media Solutions, Inc.", ticker: "DMS-WT" },
    { name: "AHCOW - AdaptHealth Corp.", ticker: "AHCOW" },
    { name: "LHC-WT - Digital Media Solutions, Inc.", ticker: "LHC-WT" },
    { name: "CNJG - Jufeel International Group", ticker: "CNJG" },
    { name: "ACEL-WT - Accel Entertainment, Inc.", ticker: "ACEL-WT" },
    { name: "LGC-WT - Legacy Acquisition Corp.", ticker: "LGC-WT" },
    { name: "NESRW - National Energy Services Reunited Corp.", ticker: "NESRW" },
    { name: "BBCPW - Concrete Pumping Holdings, Inc.", ticker: "BBCPW" },
    { name: "KYYHF - Kyushu Railway Company/ADR", ticker: "KYYHF" },
    { name: "WRLSR - American Virtual Cloud Technologies, Inc.", ticker: "WRLSR" },
    { name: "WRLSW - American Virtual Cloud Technologies, Inc.", ticker: "WRLSW" },
    { name: "FATBP - Fat Brands, Inc", ticker: "FATBP" },
    { name: "FATBW - Fat Brands, Inc", ticker: "FATBW" },
    { name: "SPCE-UN - Virgin Galactic Holdings, Inc", ticker: "SPCE-UN" },
    { name: "SPCE-WT - Virgin Galactic Holdings, Inc", ticker: "SPCE-WT" },
    { name: "GPAQW - Hall of Fame Resort & Entertainment Co", ticker: "GPAQW" },
    { name: "HOFVW - Hall of Fame Resort & Entertainment Co", ticker: "HOFVW" },
    { name: "AESEW - Allied Esports Entertainment, Inc.", ticker: "AESEW" },
    { name: "NSCO-WT - NESCO HOLDINGS, INC.", ticker: "NSCO-WT" },
    { name: "WINRW - SIMPLICITY ESPORTS & GAMING Co", ticker: "WINRW" },
    { name: "YGTY - SSLJ. COM Ltd", ticker: "YGTY" },
    { name: "BRPAW - Big Rock Partners Acquisition Corp.", ticker: "BRPAW" },
    { name: "KLR-WT - Kaleyra, Inc.", ticker: "KLR-WT" },
    { name: "RPAYW - Repay Holdings Corp", ticker: "RPAYW" },
    { name: "HYMCW - HYCROFT MINING HOLDING CORP", ticker: "HYMCW" },
    { name: "HYMWW - HYCROFT MINING HOLDING CORP", ticker: "HYMWW" },
    { name: "SPAQ-WT - Spartan Energy Acquisition Corp.", ticker: "SPAQ-WT" },
    { name: "LACQW - Leisure Acquisition Corp.", ticker: "LACQW" },
    { name: "VVNT-WT - Vivint Smart Home, Inc.", ticker: "VVNT-WT" },
    { name: "THWWW - Target Hospitality Corp.", ticker: "THWWW" },
    { name: "PACK-WT - Ranpak Holdings Corp.", ticker: "PACK-WT" },
    { name: "KXINW - Kaixin Auto Holdings", ticker: "KXINW" },
    { name: "IGICW - International General Insurance Holdings Ltd.", ticker: "IGICW" },
    { name: "DMYT-UN - dMY Technology Group, Inc.", ticker: "DMYT-UN" },
    { name: "CCXX-UN - MultiPlan Corp", ticker: "CCXX-UN" },
    { name: "CCXX-WT - MultiPlan Corp", ticker: "CCXX-WT" },
    { name: "MPLN-WT - MultiPlan Corp", ticker: "MPLN-WT" },
    { name: "SCVX-UN - SCVX Corp.", ticker: "SCVX-UN" },
    { name: "CCAC-UN - CITIC Capital Acquisition Corp.", ticker: "CCAC-UN" },
    { name: "ATCO-PD - Atlas Corp.", ticker: "ATCO-PD" },
    { name: "ATCO-PE - Atlas Corp.", ticker: "ATCO-PE" },
    { name: "ATCO-PG - Atlas Corp.", ticker: "ATCO-PG" },
    { name: "ATCO-PH - Atlas Corp.", ticker: "ATCO-PH" },
    { name: "ATCO-PI - Atlas Corp.", ticker: "ATCO-PI" },
    { name: "GNRSW - Greenrose Acquisition Corp.", ticker: "GNRSW" },
    { name: "HPKEW - HighPeak Energy, Inc.", ticker: "HPKEW" },
    { name: "LIVKU - LIV Capital Acquisition Corp.", ticker: "LIVKU" },
    { name: "LIVKW - LIV Capital Acquisition Corp.", ticker: "LIVKW" },
    { name: "EQOSW - Diginex Ltd", ticker: "EQOSW" },
    { name: "HCCOU - Healthcare Merger Corp.", ticker: "HCCOU" },
    { name: "HCCOW - Healthcare Merger Corp.", ticker: "HCCOW" },
    { name: "JIH-WT - Juniper Industrial Holdings, Inc.", ticker: "JIH-WT" },
    { name: "AMHCW - Amplitude Healthcare Acquisition Corp", ticker: "AMHCW" },
    { name: "BWXMF - Betterware de Mexico, S.A.B. de C.V.", ticker: "BWXMF" },
    { name: "IPV-WT - InterPrivate Acquisition Corp.", ticker: "IPV-WT" },
    { name: "GRNVR - GreenVision Acquisition Corp.", ticker: "GRNVR" },
    { name: "GRNVU - GreenVision Acquisition Corp.", ticker: "GRNVU" },
    { name: "GRNVW - GreenVision Acquisition Corp.", ticker: "GRNVW" },
    { name: "BRLIR - Brilliant Acquisition Corp", ticker: "BRLIR" },
    { name: "BRLIU - Brilliant Acquisition Corp", ticker: "BRLIU" },
    { name: "FSRVW - FinServ Acquisition Corp.", ticker: "FSRVW" },
    { name: "MCMJW - Merida Merger Corp. I", ticker: "MCMJW" },
    { name: "NREF-PA - NexPoint Real Estate Finance, Inc.", ticker: "NREF-PA" },
    { name: "CHPMW - CHP Merger Corp.", ticker: "CHPMW" },
    { name: "GLEO-UN - Galileo Acquisition Corp.", ticker: "GLEO-UN" },
    { name: "GLEO-WT - Galileo Acquisition Corp.", ticker: "GLEO-WT" },
    { name: "BRMK-WT - Broadmark Realty Capital Inc.", ticker: "BRMK-WT" },
    { name: "FIIIW - Forum Merger III Corp", ticker: "FIIIW" },
    { name: "PTACU - PropTech Acquisition Corp", ticker: "PTACU" },
    { name: "PTACW - PropTech Acquisition Corp", ticker: "PTACW" },
    { name: "HYACW - Haymaker Acquisition Corp. II", ticker: "HYACW" },
    { name: "FLLC - Fellazo Inc.", ticker: "FLLC" },
    { name: "FLZOF - Fellazo Inc.", ticker: "FLZOF" },
    { name: "ZGYHU - Yunhong International", ticker: "ZGYHU" },
    { name: "DEACU - DraftKings Inc.", ticker: "DEACU" },
    { name: "DEACW - DraftKings Inc.", ticker: "DEACW" },
    { name: "DKNGW - DraftKings Inc.", ticker: "DKNGW" },
    { name: "PIC-UN - Pivotal Investment Corp II", ticker: "PIC-UN" },
    { name: "PIC-WT - Pivotal Investment Corp II", ticker: "PIC-WT" },
    { name: "CURIW - CuriosityStream Inc.", ticker: "CURIW" },
    { name: "SBE-UN - Switchback Energy Acquisition Corp", ticker: "SBE-UN" },
    { name: "SBE-WT - Switchback Energy Acquisition Corp", ticker: "SBE-WT" },
    { name: "SAQNW - CuriosityStream Inc.", ticker: "SAQNW" },
    { name: "CCX-UN - Churchill Capital Corp II", ticker: "CCX-UN" },
    { name: "CCX-WT - Churchill Capital Corp II", ticker: "CCX-WT" },
    { name: "OAC-UN - Oaktree Acquisition Corp.", ticker: "OAC-UN" },
    { name: "OAC-WT - Oaktree Acquisition Corp.", ticker: "OAC-WT" },
    { name: "BROGW - Brooge Energy Ltd", ticker: "BROGW" },
    { name: "APXTW - Apex Technology Acquisition Corp", ticker: "APXTW" },
    { name: "LOAK-UN - Live Oak Acquisition Corp", ticker: "LOAK-UN" },
    { name: "LOAK-WT - Live Oak Acquisition Corp", ticker: "LOAK-WT" },
    { name: "SSPKW - Silver Spike Acquisition Corp.", ticker: "SSPKW" },
    { name: "NPAWW - New Providence Acquisition Corp.", ticker: "NPAWW" },
    { name: "GFLU - GFL Environmental Inc.", ticker: "GFLU" },
    { name: "GHIVU - Gores Holdings IV, Inc.", ticker: "GHIVU" },
    { name: "ECOLW - US Ecology, Inc.", ticker: "ECOLW" },
    { name: "ALUS-UN - Alussa Energy Acquisition Corp.", ticker: "ALUS-UN" },
    { name: "ALUS-WT - Alussa Energy Acquisition Corp.", ticker: "ALUS-WT" },
    { name: "SRACU - Stable Road Acquisition Corp.", ticker: "SRACU" },
    { name: "SRACW - Stable Road Acquisition Corp.", ticker: "SRACW" },
    { name: "RBZAW - Reebonz Holding Ltd", ticker: "RBZAW" },
    { name: "RBZWF - Reebonz Holding Ltd", ticker: "RBZWF" },
    { name: "RBNZF - Reebonz Holding Ltd", ticker: "RBNZF" },
    { name: "KLDIW - KLDiscovery Inc.", ticker: "KLDIW" },
    { name: "DDMXU - DD3 Acquisition Corp., S.A. de C.V.", ticker: "DDMXU" },
    { name: "HHHHW - Scienjoy Holding Corp", ticker: "HHHHW" },
    { name: "ACTTW - Whole Earth Brands, Inc.", ticker: "ACTTW" },
    { name: "FREEW - Whole Earth Brands, Inc.", ticker: "FREEW" },
    { name: "HHHHR - Scienjoy Holding Corp", ticker: "HHHHR" },
    { name: "SJOYW - Scienjoy Holding Corp", ticker: "SJOYW" },
    { name: "JFKKW - 8i Enterprises Acquisition Corp.", ticker: "JFKKW" },
    { name: "SFTW-WT - Osprey Technology Acquisition Corp.", ticker: "SFTW-WT" },
    { name: "TRNE-WT - Trine Acquisition Corp.", ticker: "TRNE-WT" },
    { name: "MNCLW - Monocle Acquisition Corp", ticker: "MNCLW" },
    { name: "RMG-WT - RMG Acquisition Corp.", ticker: "RMG-WT" },
    { name: "RMO - RMG Acquisition Corp.", ticker: "RMO" },
    { name: "CHNGU - Change Healthcare Inc.", ticker: "CHNGU" },
    { name: "EQXWF - Equinox Gold Corp.", ticker: "EQXWF" },
    { name: "KERNW - Akerna Corp.", ticker: "KERNW" },
    { name: "ALTG-WT - ALTA EQUIPMENT GROUP INC.", ticker: "ALTG-WT" },
    { name: "SHLL-WT - Hyliion Holdings Corp.", ticker: "SHLL-WT" },
    { name: "ACAMW - Acamar Partners Acquisition Corp.", ticker: "ACAMW" },
    { name: "GMHIW - Gores Metropoulos, Inc.", ticker: "GMHIW" },
    { name: "STPK-WT - Star Peak Energy Transition Corp.", ticker: "STPK-WT" },
    { name: "STPK - Star Peak Energy Transition Corp.", ticker: "STPK" },
    { name: "INSUW - SHIFT TECHNOLOGIES, INC.", ticker: "INSUW" },
    { name: "RPLA-WT - Replay Acquisition Corp.", ticker: "RPLA-WT" },
    { name: "GRCYW - Greencity Acquisition Corp", ticker: "GRCYW" },
    { name: "AGBAW - AGBA Acquisition Ltd", ticker: "AGBAW" },
    { name: "BIOX-WT - Bioceres Crop Solutions Corp.", ticker: "BIOX-WT" },
    { name: "THBRW - Thunder Bridge Acquisition II, LTD", ticker: "THBRW" },
    { name: "GIX-RI - GigCapital2, Inc.", ticker: "GIX-RI" },
    { name: "GIX-UN - GigCapital2, Inc.", ticker: "GIX-UN" },
    { name: "GIX-WT - GigCapital2, Inc.", ticker: "GIX-WT" },
    { name: "PAACR - PROFICIENT ALPHA ACQUISITION CORP", ticker: "PAACR" },
    { name: "PAACU - PROFICIENT ALPHA ACQUISITION CORP", ticker: "PAACU" },
    { name: "IMVTU - Immunovant, Inc.", ticker: "IMVTU" },
    { name: "IMVTW - Immunovant, Inc.", ticker: "IMVTW" },
    { name: "SCPE-UN - SC Health Corp", ticker: "SCPE-UN" },
    { name: "SCPE-WT - SC Health Corp", ticker: "SCPE-WT" },
    { name: "PAACW - PROFICIENT ALPHA ACQUISITION CORP", ticker: "PAACW" },
    { name: "LCAHW - Landcadia Holdings II, Inc.", ticker: "LCAHW" },
    { name: "AGNCO - AGNC Investment Corp.", ticker: "AGNCO" },
    { name: "AGNCP - AGNC Investment Corp.", ticker: "AGNCP" },
    { name: "UGL - ProShares Trust II", ticker: "UGL" },
    { name: "ULE - ProShares Trust II", ticker: "ULE" },
    { name: "EUO - ProShares Trust II", ticker: "EUO" },
    { name: "GMLPP - Golar LNG Partners LP", ticker: "GMLPP" },
    { name: "OSLE - Oaktree Specialty Lending Corp", ticker: "OSLE" },
    { name: "TPDNF - Topdanmark AS", ticker: "TPDNF" },
    { name: "NSPR-WT - InspireMD, Inc.", ticker: "NSPR-WT" },
    { name: "NSPR-WTB - InspireMD, Inc.", ticker: "NSPR-WTB" },
    { name: "BLNKW - Blink Charging Co.", ticker: "BLNKW" },
    { name: "ARR-PC - Armour Residential REIT, Inc.", ticker: "ARR-PC" },
    { name: "KAKKF - Kawasaki Kisen Kaisha Ltd", ticker: "KAKKF" },
    { name: "GMELF - GOME Retail Holdings Limited/ADR", ticker: "GMELF" },
    { name: "CAKFF - McKesson Europe AG/ADR", ticker: "CAKFF" },
    { name: "DQJCF - Don Quijote Holdings Co Ltd", ticker: "DQJCF" },
    { name: "JSGCF - JS Group CORP", ticker: "JSGCF" },
    { name: "AEMMF - A2A SpA", ticker: "AEMMF" },
    { name: "DNIEF - Danieli S.p.A.", ticker: "DNIEF" },
    { name: "CIOXF - Cielo S.A.", ticker: "CIOXF" },
    { name: "SBBA - Scorpio Tankers Inc.", ticker: "SBBA" },
    { name: "PYTCF - Playtech Ltd.", ticker: "PYTCF" },
    { name: "LANDO - GLADSTONE LAND Corp", ticker: "LANDO" },
    { name: "FYRTF - FamilyMart Co., Ltd. / ADR", ticker: "FYRTF" },
    { name: "SZGPF - Salzgitter AG / ADR", ticker: "SZGPF" },
    { name: "OPINL - OFFICE PROPERTIES INCOME TRUST", ticker: "OPINL" },
    { name: "IDW - IDW MEDIA HOLDINGS, INC.", ticker: "IDW" },
    { name: "SEBNF - Seven Bank Ltd / ADR", ticker: "SEBNF" },
    { name: "RILYL - B. Riley Financial, Inc.", ticker: "RILYL" },
    { name: "RILYM - B. Riley Financial, Inc.", ticker: "RILYM" },
    { name: "RILYN - B. Riley Financial, Inc.", ticker: "RILYN" },
    { name: "RILYO - B. Riley Financial, Inc.", ticker: "RILYO" },
    { name: "RILYP - B. Riley Financial, Inc.", ticker: "RILYP" },
    { name: "TCRW - First Eagle Alternative Capital BDC, Inc.", ticker: "TCRW" },
    { name: "IPCI - Intellipharmaceutics International Inc.", ticker: "IPCI" },
    { name: "EDGE - PDS Biotechnology Corp", ticker: "EDGE" },
    { name: "SOYB - Teucrium Commodity Trust", ticker: "SOYB" },
    { name: "TAGS - Teucrium Commodity Trust", ticker: "TAGS" },
    { name: "CRTDW - Creatd, Inc.", ticker: "CRTDW" },
    { name: "CODI-PC - Compass Diversified Holdings", ticker: "CODI-PC" },
    { name: "SGYP - SYNERGY PHARMACEUTICALS, INC.", ticker: "SGYP" },
    { name: "ELC - ENTERGY LOUISIANA, LLC", ticker: "ELC" },
    { name: "GEUR - PetLife Pharmaceuticals, Inc.", ticker: "GEUR" },
    { name: "EQH-PA - Equitable Holdings, Inc.", ticker: "EQH-PA" },
    { name: "IGCIW - India Globalization Capital, Inc.", ticker: "IGCIW" },
    { name: "DUKB - Duke Energy CORP", ticker: "DUKB" },
    { name: "DCP-PB - DCP Midstream, LP", ticker: "DCP-PB" },
    { name: "BXS-PA - BancorpSouth Bank", ticker: "BXS-PA" },
    { name: "DRH-PA - DiamondRock Hospitality Co", ticker: "DRH-PA" },
    { name: "DLR-PL - DIGITAL REALTY TRUST, INC.", ticker: "DLR-PL" },
    { name: "TDHOF - T&D HOLDINGS INC", ticker: "TDHOF" },
    { name: "HGEND - HUMANIGEN, INC", ticker: "HGEND" },
    { name: "BLYYF - BOART LONGYEAR LTD", ticker: "BLYYF" },
    { name: "IHETW - iHeartMedia, Inc.", ticker: "IHETW" },
    { name: "BEEMW - Envision Solar International, Inc.", ticker: "BEEMW" },
    { name: "KBRS - KBS Real Estate Investment Trust II, Inc.", ticker: "KBRS" },
    { name: "EFC-PA - Ellington Financial Inc.", ticker: "EFC-PA" },
    { name: "MHNC - Maiden Holdings, Ltd.", ticker: "MHNC" },
    { name: "KKR-PC - KKR & Co. Inc.", ticker: "KKR-PC" },
    { name: "OAK-PA - Oaktree Capital Group, LLC", ticker: "OAK-PA" },
    { name: "BIP-PA - Brookfield Infrastructure Partners L.P.", ticker: "BIP-PA" },
    { name: "UPZSD - UNIQUE FOODS Corp", ticker: "UPZSD" },
    { name: "UUUU-WT - ENERGY FUELS INC", ticker: "UUUU-WT" },
    { name: "AYTUW - AYTU BIOSCIENCE, INC", ticker: "AYTUW" },
    { name: "AYTUZ - AYTU BIOSCIENCE, INC", ticker: "AYTUZ" },
    { name: "ALIN-PB - Altera Infrastructure L.P.", ticker: "ALIN-PB" },
    { name: "ALIN-PE - Altera Infrastructure L.P.", ticker: "ALIN-PE" },
    { name: "EYEGW - EYEGATE PHARMACEUTICALS INC", ticker: "EYEGW" },
    { name: "UEHPF - ULTRA ELECTRONICS HOLDINGS PLC", ticker: "UEHPF" },
    { name: "AFFT - Amtrust Financial Services, Inc.", ticker: "AFFT" },
    { name: "AFSIN - Amtrust Financial Services, Inc.", ticker: "AFSIN" },
    { name: "AFSIP - Amtrust Financial Services, Inc.", ticker: "AFSIP" },
    { name: "OASM - Oasmia Pharmaceutical AB", ticker: "OASM" },
    { name: "LMBHW - Limbach Holdings, Inc.", ticker: "LMBHW" },
    { name: "CLDC - Roan Holdings Group Co., Ltd.", ticker: "CLDC" },
    { name: "RONWF - Roan Holdings Group Co., Ltd.", ticker: "RONWF" },
    { name: "KTOVW - Kitov Pharma Ltd.", ticker: "KTOVW" },
    { name: "TRPXD - Therapix Biosciences Ltd.", ticker: "TRPXD" },
    { name: "CHEKZ - Check-Cap Ltd", ticker: "CHEKZ" },
    { name: "SABRP - Sabre Corp", ticker: "SABRP" },
    { name: "ORPN - Enlivex Therapeutics Ltd.", ticker: "ORPN" },
    { name: "SYF-PA - Synchrony Financial", ticker: "SYF-PA" },
    { name: "PAVMZ - PAVmed Inc.", ticker: "PAVMZ" },
    { name: "GLDW - World Gold Trust", ticker: "GLDW" },
    { name: "MDGSW - Medigus Ltd.", ticker: "MDGSW" },
    { name: "MBINO - Merchants Bancorp", ticker: "MBINO" },
    { name: "PECKW - PECK Co HOLDINGS, INC.", ticker: "PECKW" },
    { name: "ENTXW - Entera Bio Ltd.", ticker: "ENTXW" },
    { name: "SOLOW - ELECTRAMECCANICA VEHICLES CORP.", ticker: "SOLOW" },
    { name: "PXSAP - Pyxis Tankers Inc.", ticker: "PXSAP" },
    { name: "PXSAW - Pyxis Tankers Inc.", ticker: "PXSAW" },
    { name: "CCNCW - Code Chain New Continent Ltd", ticker: "CCNCW" },
    { name: "BHFAO - Brighthouse Financial, Inc.", ticker: "BHFAO" },
    { name: "IMXIW - International Money Express, Inc.", ticker: "IMXIW" },
    { name: "XDIV - Metaurus Equity Component Trust", ticker: "XDIV" },
    { name: "KBLMW - KBL MERGER CORP. IV", ticker: "KBLMW" },
    { name: "AMRWQ - Alta Mesa Resources, Inc. /DE", ticker: "AMRWQ" },
    { name: "AMRWW - Alta Mesa Resources, Inc. /DE", ticker: "AMRWW" },
    { name: "LVXID - MAPTELLIGENT, INC.", ticker: "LVXID" },
    { name: "XYNPW - XYNOMIC PHARMACEUTICALS HOLDINGS, INC.", ticker: "XYNPW" },
    { name: "MNSBP - MainStreet Bancshares, Inc.", ticker: "MNSBP" },
    { name: "NDRAW - ENDRA Life Sciences Inc.", ticker: "NDRAW" },
    { name: "SACC - Sachem Capital Corp.", ticker: "SACC" },
    { name: "SCCB - Sachem Capital Corp.", ticker: "SCCB" },
    { name: "SCCC - Sachem Capital Corp.", ticker: "SCCC" },
    { name: "HUNTU - Hunter Maritime Acquisition Corp.", ticker: "HUNTU" },
    { name: "HUNTW - Hunter Maritime Acquisition Corp.", ticker: "HUNTW" },
    { name: "HNTWF - Hunter Maritime Acquisition Corp.", ticker: "HNTWF" },
    { name: "HUNT - Hunter Maritime Acquisition Corp.", ticker: "HUNT" },
    { name: "CSSEN - Chicken Soup for the Soul Entertainment, Inc.", ticker: "CSSEN" },
    { name: "TDACW - Trident Acquisitions Corp.", ticker: "TDACW" },
    { name: "VERT-UN - Vertiv Holdings Co", ticker: "VERT-UN" },
    { name: "VRT-WT - Vertiv Holdings Co", ticker: "VRT-WT" },
    { name: "APOPW - Cellect Biotechnology Ltd.", ticker: "APOPW" },
    { name: "USOD - USCF Funds Trust", ticker: "USOD" },
    { name: "USOU - USCF Funds Trust", ticker: "USOU" },
    { name: "SCAC - Saban Capital Acquisition Corp.", ticker: "SCAC" },
    { name: "SYTAW - Siyata Mobile Inc.", ticker: "SYTAW" },
    { name: "SYATD - Siyata Mobile Inc.", ticker: "SYATD" },
    { name: "NVTR - Nuvectra Corp", ticker: "NVTR" },
    { name: "IEAWW - Infrastructure & Energy Alternatives, Inc.", ticker: "IEAWW" },
    { name: "DMTKW - DermTech, Inc.", ticker: "DMTKW" },
    { name: "PRPLW - Purple Innovation, Inc.", ticker: "PRPLW" },
    { name: "YCBD-PA - cbdMD, Inc.", ticker: "YCBD-PA" },
    { name: "WSCWW - WillScot Mobile Mini Holdings Corp.", ticker: "WSCWW" },
    { name: "ROSEU - Rosehill Resources Inc.", ticker: "ROSEU" },
    { name: "ROSEW - Rosehill Resources Inc.", ticker: "ROSEW" },
    { name: "ROSUQ - Rosehill Resources Inc.", ticker: "ROSUQ" },
    { name: "TRTN-PC - Triton International Ltd", ticker: "TRTN-PC" },
    { name: "TRTN-PD - Triton International Ltd", ticker: "TRTN-PD" },
    { name: "MDRRP - Medalist Diversified REIT, Inc.", ticker: "MDRRP" },
    { name: "TBLTW - Toughbuilt Industries, Inc", ticker: "TBLTW" },
    { name: "FG-WT - FGL Holdings", ticker: "FG-WT" },
    { name: "TRTN-PB - Triton International Ltd", ticker: "TRTN-PB" },
    { name: "HJLIW - Hancock Jaffe Laboratories, Inc.", ticker: "HJLIW" },
    { name: "PHUNW - Phunware, Inc.", ticker: "PHUNW" },
    { name: "FRGAP - Franchise Group, Inc.", ticker: "FRGAP" },
    { name: "TAX - Franchise Group, Inc.", ticker: "TAX" },
    { name: "GNL-PB - Global Net Lease, Inc.", ticker: "GNL-PB" },
    { name: "RCA - Ready Capital Corp", ticker: "RCA" },
    { name: "RCB - Ready Capital Corp", ticker: "RCB" },
    { name: "ATH-PB - Athene Holding Ltd", ticker: "ATH-PB" },
    { name: "ATH-PC - Athene Holding Ltd", ticker: "ATH-PC" },
    { name: "BEP-PA - Brookfield Renewable Partners L.P.", ticker: "BEP-PA" },
    { name: "FUPPF - Fuchs Petrolub SE/ADR", ticker: "FUPPF" },
    { name: "XBIOW - Xenetic Biosciences, Inc.", ticker: "XBIOW" },
    { name: "NHNKF - Nihon Kohden Corporation/ADR", ticker: "NHNKF" },
    { name: "BPYPN - Brookfield Property Partners L.P.", ticker: "BPYPN" },
    { name: "BPYPO - Brookfield Property Partners L.P.", ticker: "BPYPO" },
    { name: "UNOV - Earth Science Tech, Inc.", ticker: "UNOV" },
    { name: "TBKCP - Triumph Bancorp, Inc.", ticker: "TBKCP" },
    { name: "APTV-PA - Aptiv PLC", ticker: "APTV-PA" },
    { name: "YTROF - Yatra Online, Inc.", ticker: "YTROF" },
    { name: "INSY - Insys Therapeutics, Inc.", ticker: "INSY" },
    { name: "ADILW - ADIAL PHARMACEUTICALS, INC.", ticker: "ADILW" },
    { name: "WRSS - Mountain High Acquisitions Corp.", ticker: "WRSS" },
    { name: "CHFSW - CHF Solutions, Inc.", ticker: "CHFSW" },
    { name: "EP-PC - KINDER MORGAN, INC.", ticker: "EP-PC" },
    { name: "FTD - GUE Liquidation Companies, Inc.", ticker: "FTD" },
    { name: "REXR-PC - Rexford Industrial Realty, Inc.", ticker: "REXR-PC" },
    { name: "AGFSW - AgroFresh Solutions, Inc.", ticker: "AGFSW" },
    { name: "LENS - Presbia PLC", ticker: "LENS" },
    { name: "FTAI-PA - Fortress Transportation & Infrastructure Investors LLC", ticker: "FTAI-PA" },
    { name: "FTAI-PB - Fortress Transportation & Infrastructure Investors LLC", ticker: "FTAI-PB" },
    { name: "GPVRD - GREENPOWER MOTOR Co INC.", ticker: "GPVRD" },
    { name: "EGLT - Zyla Life Sciences", ticker: "EGLT" },
    { name: "WEIFX - Wildermuth Endowment Fund", ticker: "WEIFX" },
    { name: "WESFX - Wildermuth Endowment Fund", ticker: "WESFX" },
    { name: "XGTI - Vislink Technologies, Inc.", ticker: "XGTI" },
    { name: "INBKZ - First Internet Bancorp", ticker: "INBKZ" },
    { name: "TTS - TILE SHOP HOLDINGS, INC.", ticker: "TTS" },
    { name: "INNTW - 9 METERS BIOPHARMA, INC.", ticker: "INNTW" },
    { name: "NRZ-PA - New Residential Investment Corp.", ticker: "NRZ-PA" },
    { name: "NRZ-PB - New Residential Investment Corp.", ticker: "NRZ-PB" },
    { name: "NRZ-PC - New Residential Investment Corp.", ticker: "NRZ-PC" },
    { name: "BMY-RI - BRISTOL MYERS SQUIBB CO", ticker: "BMY-RI" },
    { name: "CELG-RI - BRISTOL MYERS SQUIBB CO", ticker: "CELG-RI" },
    { name: "BC-PA - BRUNSWICK CORP", ticker: "BC-PA" },
    { name: "BC-PB - BRUNSWICK CORP", ticker: "BC-PB" },
    { name: "BC-PC - BRUNSWICK CORP", ticker: "BC-PC" },
    { name: "WRB-PF - BERKLEY W R CORP", ticker: "WRB-PF" },
    { name: "WRB-PG - BERKLEY W R CORP", ticker: "WRB-PG" },
    { name: "BDXB - BECTON DICKINSON & CO", ticker: "BDXB" },
    { name: "AIG-WT - AMERICAN INTERNATIONAL GROUP INC", ticker: "AIG-WT" },
    { name: "AP-WT - AMPCO PITTSBURGH CORP", ticker: "AP-WT" },
    { name: "ASB-PF - ASSOCIATED BANC-CORP", ticker: "ASB-PF" },
    { name: "AEP-PB - AMERICAN ELECTRIC POWER CO INC", ticker: "AEP-PB" },
    { name: "AEP-PC - AMERICAN ELECTRIC POWER CO INC", ticker: "AEP-PC" },
    { name: "AEPPZ - AMERICAN ELECTRIC POWER CO INC", ticker: "AEPPZ" },
    { name: "AILIO - Ameren Illinois Co", ticker: "AILIO" },
    { name: "AILIP - Ameren Illinois Co", ticker: "AILIP" },
    { name: "AILNP - Ameren Illinois Co", ticker: "AILNP" },
    { name: "FITBO - FIFTH THIRD BANCORP", ticker: "FITBO" },
    { name: "FITBP - FIFTH THIRD BANCORP", ticker: "FITBP" },
    { name: "USB-PA - US BANCORP \\DE\\", ticker: "USB-PA" },
    { name: "FHN-PE - FIRST HORIZON NATIONAL CORP", ticker: "FHN-PE" },
    { name: "MKCV - MCCORMICK & CO INC", ticker: "MKCV" },
    { name: "CTBB - QWEST CORP", ticker: "CTBB" },
    { name: "CTDD - QWEST CORP", ticker: "CTDD" },
    { name: "MER-PK - BANK OF AMERICA CORP /DE/", ticker: "MER-PK" },
    { name: "BAC-PA - BANK OF AMERICA CORP /DE/", ticker: "BAC-PA" },
    { name: "BAC-PM - BANK OF AMERICA CORP /DE/", ticker: "BAC-PM" },
    { name: "BAC-PN - BANK OF AMERICA CORP /DE/", ticker: "BAC-PN" },
    { name: "WFC-PZ - WELLS FARGO & COMPANY/MN", ticker: "WFC-PZ" },
    { name: "NTRSO - NORTHERN TRUST CORP", ticker: "NTRSO" },
    { name: "FHN-PB - FIRST HORIZON NATIONAL CORP", ticker: "FHN-PB" },
    { name: "FHN-PC - FIRST HORIZON NATIONAL CORP", ticker: "FHN-PC" },
    { name: "FHN-PD - FIRST HORIZON NATIONAL CORP", ticker: "FHN-PD" },
    { name: "F-PB - FORD MOTOR CO", ticker: "F-PB" },
    { name: "F-PC - FORD MOTOR CO", ticker: "F-PC" },
    { name: "ALLY-PA - Ally Financial Inc.", ticker: "ALLY-PA" },
    { name: "HAWLM - HAWAIIAN ELECTRIC CO INC", ticker: "HAWLM" },
    { name: "HAWLI - HAWAIIAN ELECTRIC CO INC", ticker: "HAWLI" },
    { name: "HAWLL - HAWAIIAN ELECTRIC CO INC", ticker: "HAWLL" },
    { name: "HAWEM - HAWAIIAN ELECTRIC CO INC", ticker: "HAWEM" },
    { name: "IFFT - INTERNATIONAL FLAVORS & FRAGRANCES INC", ticker: "IFFT" },
    { name: "PVCTW - PROVECTUS BIOPHARMACEUTICALS, INC.", ticker: "PVCTW" },
    { name: "DHR-PB - DANAHER CORP /DE/", ticker: "DHR-PB" },
    { name: "GAZ - BARCLAYS BANK PLC", ticker: "GAZ" },
    { name: "DTYS - BARCLAYS BANK PLC", ticker: "DTYS" },
    { name: "COW - BARCLAYS BANK PLC", ticker: "COW" },
    { name: "DJP - BARCLAYS BANK PLC", ticker: "DJP" },
    { name: "DLBS - BARCLAYS BANK PLC", ticker: "DLBS" },
    { name: "PHII - PHI Group, Inc./DE", ticker: "PHII" },
    { name: "PHIIK - PHI Group, Inc./DE", ticker: "PHIIK" },
    { name: "RJN - SWEDISH EXPORT CREDIT CORP /SWED/", ticker: "RJN" },
    { name: "RJZ - SWEDISH EXPORT CREDIT CORP /SWED/", ticker: "RJZ" },
    { name: "RJA - SWEDISH EXPORT CREDIT CORP /SWED/", ticker: "RJA" },
    { name: "RJI - SWEDISH EXPORT CREDIT CORP /SWED/", ticker: "RJI" },
    { name: "GRU - SWEDISH EXPORT CREDIT CORP /SWED/", ticker: "GRU" },
    { name: "DRADP - DIGIRAD CORP", ticker: "DRADP" },
    { name: "PHIG - PHI GROUP INC", ticker: "PHIG" },
    { name: "FMBIO - FIRST MIDWEST BANCORP INC", ticker: "FMBIO" },
    { name: "FMBIP - FIRST MIDWEST BANCORP INC", ticker: "FMBIP" },
    { name: "SF-PC - STIFEL FINANCIAL CORP", ticker: "SF-PC" },
    { name: "SFB - STIFEL FINANCIAL CORP", ticker: "SFB" },
    { name: "FNMAP - FEDERAL NATIONAL MORTGAGE ASSOCIATION FANNIE MAE", ticker: "FNMAP" },
    { name: "ATMP - BARCLAYS BANK PLC", ticker: "ATMP" },
    { name: "BAL - BARCLAYS BANK PLC", ticker: "BAL" },
    { name: "CAPE - BARCLAYS BANK PLC", ticker: "CAPE" },
    { name: "VXX - BARCLAYS BANK PLC", ticker: "VXX" },
    { name: "VXZ - BARCLAYS BANK PLC", ticker: "VXZ" },
    { name: "SGG - BARCLAYS BANK PLC", ticker: "SGG" },
    { name: "PGM - BARCLAYS BANK PLC", ticker: "PGM" },
    { name: "BCS22A - BARCLAYS BANK PLC", ticker: "BCS22A" },
    { name: "OILND - BARCLAYS BANK PLC", ticker: "OILND" },
    { name: "OILNF - BARCLAYS BANK PLC", ticker: "OILNF" },
    { name: "OLEM - BARCLAYS BANK PLC", ticker: "OLEM" },
    { name: "JJS - BARCLAYS BANK PLC", ticker: "JJS" },
    { name: "JJT - BARCLAYS BANK PLC", ticker: "JJT" },
    { name: "JJU - BARCLAYS BANK PLC", ticker: "JJU" },
    { name: "JO - BARCLAYS BANK PLC", ticker: "JO" },
    { name: "JJC - BARCLAYS BANK PLC", ticker: "JJC" },
    { name: "JJE - BARCLAYS BANK PLC", ticker: "JJE" },
    { name: "JJG - BARCLAYS BANK PLC", ticker: "JJG" },
    { name: "JJM - BARCLAYS BANK PLC", ticker: "JJM" },
    { name: "JJN - BARCLAYS BANK PLC", ticker: "JJN" },
    { name: "JJP - BARCLAYS BANK PLC", ticker: "JJP" },
    { name: "GRN - BARCLAYS BANK PLC", ticker: "GRN" },
    { name: "ZIONL - ZIONS BANCORPORATION, NATIONAL ASSOCIATION /UT/", ticker: "ZIONL" },
    { name: "ZIONO - ZIONS BANCORPORATION, NATIONAL ASSOCIATION /UT/", ticker: "ZIONO" },
    { name: "ZIONP - ZIONS BANCORPORATION, NATIONAL ASSOCIATION /UT/", ticker: "ZIONP" },
    { name: "OHGI - Touchpoint Group Holdings Inc.", ticker: "OHGI" },
    { name: "WSBCP - WESBANCO INC", ticker: "WSBCP" },
    { name: "SOLN - SOUTHERN CO", ticker: "SOLN" },
    { name: "SCE-PG - SOUTHERN CALIFORNIA EDISON Co", ticker: "SCE-PG" },
    { name: "SCE-PH - SOUTHERN CALIFORNIA EDISON Co", ticker: "SCE-PH" },
    { name: "SCE-PJ - SOUTHERN CALIFORNIA EDISON Co", ticker: "SCE-PJ" },
    { name: "SCE-PK - SOUTHERN CALIFORNIA EDISON Co", ticker: "SCE-PK" },
    { name: "SCE-PL - SOUTHERN CALIFORNIA EDISON Co", ticker: "SCE-PL" },
    { name: "TFC-PF - TRUIST FINANCIAL CORP", ticker: "TFC-PF" },
    { name: "TFC-PG - TRUIST FINANCIAL CORP", ticker: "TFC-PG" },
    { name: "SOJD - SOUTHERN CO", ticker: "SOJD" },
    { name: "TFC-PH - TRUIST FINANCIAL CORP", ticker: "TFC-PH" },
    { name: "TFC-PI - TRUIST FINANCIAL CORP", ticker: "TFC-PI" },
    { name: "TFC-PO - TRUIST FINANCIAL CORP", ticker: "TFC-PO" },
    { name: "TFC-PR - TRUIST FINANCIAL CORP", ticker: "TFC-PR" },
    { name: "UEPCO - UNION ELECTRIC CO", ticker: "UEPCO" },
    { name: "CMSC - CMS ENERGY CORP", ticker: "CMSC" },
    { name: "CMSD - CMS ENERGY CORP", ticker: "CMSD" },
    { name: "MHGUP - MERITAGE HOSPITALITY GROUP INC", ticker: "MHGUP" },
    { name: "NAV-PD - NAVISTAR INTERNATIONAL CORP", ticker: "NAV-PD" },
    { name: "EMMAW - Emmaus Life Sciences, Inc.", ticker: "EMMAW" },
    { name: "CHSCL - CHS INC", ticker: "CHSCL" },
    { name: "CHSCM - CHS INC", ticker: "CHSCM" },
    { name: "CHSCN - CHS INC", ticker: "CHSCN" },
    { name: "CHSCO - CHS INC", ticker: "CHSCO" },
    { name: "IIVIP - II-VI INC", ticker: "IIVIP" },
    { name: "UZD - UNITED STATES CELLULAR CORP", ticker: "UZD" },
    { name: "NVLN - NOVELION THERAPEUTICS INC.", ticker: "NVLN" },
    { name: "GOVXW - GeoVax Labs, Inc.", ticker: "GOVXW" },
    { name: "C-PK - CITIGROUP INC", ticker: "C-PK" },
    { name: "C-PN - CITIGROUP INC", ticker: "C-PN" },
    { name: "DLBR - CITIGROUP INC", ticker: "DLBR" },
    { name: "ULBR - CITIGROUP INC", ticker: "ULBR" },
    { name: "NEE-PO - NEXTERA ENERGY INC", ticker: "NEE-PO" },
    { name: "NEE-PP - NEXTERA ENERGY INC", ticker: "NEE-PP" },
    { name: "NEE-PQ - NEXTERA ENERGY INC", ticker: "NEE-PQ" },
    { name: "NXEGU - NEXTERA ENERGY INC", ticker: "NXEGU" },
    { name: "HWCPZ - HANCOCK WHITNEY CORP", ticker: "HWCPZ" },
    { name: "FRED - FREDS INC", ticker: "FRED" },
    { name: "TBC - AT&T INC.", ticker: "TBC" },
    { name: "T-PA - AT&T INC.", ticker: "T-PA" },
    { name: "T-PC - AT&T INC.", ticker: "T-PC" },
    { name: "CCNEP - CNB FINANCIAL CORP/PA", ticker: "CCNEP" },
    { name: "OXY-WT - OCCIDENTAL PETROLEUM CORP /DE/", ticker: "OXY-WT" },
    { name: "CFG-PE - CITIZENS FINANCIAL GROUP INC/RI", ticker: "CFG-PE" },
    { name: "RBS - NatWest Group plc", ticker: "RBS" },
    { name: "AGM-PE - FEDERAL AGRICULTURAL MORTGAGE CORP", ticker: "AGM-PE" },
    { name: "AGM-PF - FEDERAL AGRICULTURAL MORTGAGE CORP", ticker: "AGM-PF" },
    { name: "GWLOF - GREAT-WEST LIFECO INC.", ticker: "GWLOF" },
    { name: "UCBIO - UNITED COMMUNITY BANKS INC", ticker: "UCBIO" },
    { name: "TRXDW - TRANSENTERIX, INC.", ticker: "TRXDW" },
    { name: "AMBC-WT - AMBAC FINANCIAL GROUP INC", ticker: "AMBC-WT" },
    { name: "PSB-PZ - PS BUSINESS PARKS INC/CA", ticker: "PSB-PZ" },
    { name: "GCEC - GOLDMAN SACHS GROUP INC", ticker: "GCEC" },
    { name: "FRLG - GOLDMAN SACHS GROUP INC", ticker: "FRLG" },
    { name: "GCE - GOLDMAN SACHS GROUP INC", ticker: "GCE" },
    { name: "GSC - GOLDMAN SACHS GROUP INC", ticker: "GSC" },
    { name: "GSCE - GOLDMAN SACHS GROUP INC", ticker: "GSCE" },
    { name: "AUBAP - Atlantic Union Bankshares Corp", ticker: "AUBAP" },
    { name: "BSX-PA - BOSTON SCIENTIFIC CORP", ticker: "BSX-PA" },
    { name: "CHKGQ - CHESAPEAKE ENERGY CORP", ticker: "CHKGQ" },
    { name: "CHKLQ - CHESAPEAKE ENERGY CORP", ticker: "CHKLQ" },
    { name: "CNY - MORGAN STANLEY", ticker: "CNY" },
    { name: "URR - MORGAN STANLEY", ticker: "URR" },
    { name: "MS-PL - MORGAN STANLEY", ticker: "MS-PL" },
    { name: "INR - MORGAN STANLEY", ticker: "INR" },
    { name: "CHKPQ - CHESAPEAKE ENERGY CORP", ticker: "CHKPQ" },
    { name: "CHKDJ - CHESAPEAKE ENERGY CORP", ticker: "CHKDJ" },
    { name: "CHKVQ - CHESAPEAKE ENERGY CORP", ticker: "CHKVQ" },
    { name: "ALL-PI - ALLSTATE CORP", ticker: "ALL-PI" },
    { name: "PTIE - CASSAVA SCIENCES INC", ticker: "PTIE" },
    { name: "DHCNI - DIVERSIFIED HEALTHCARE TRUST", ticker: "DHCNI" },
    { name: "DHCNL - DIVERSIFIED HEALTHCARE TRUST", ticker: "DHCNL" },
    { name: "FSNN - Fusion Connect, Inc.", ticker: "FSNN" },
    { name: "CCI-PA - CROWN CASTLE INTERNATIONAL CORP", ticker: "CCI-PA" },
    { name: "DGAZ - CREDIT SUISSE AG", ticker: "DGAZ" },
    { name: "DGLD - CREDIT SUISSE AG", ticker: "DGLD" },
    { name: "ZIV - CREDIT SUISSE AG", ticker: "ZIV" },
    { name: "ZIVZF - CREDIT SUISSE AG", ticker: "ZIVZF" },
    { name: "UGLDF - CREDIT SUISSE AG", ticker: "UGLDF" },
    { name: "USLV - CREDIT SUISSE AG", ticker: "USLV" },
    { name: "USLVF - CREDIT SUISSE AG", ticker: "USLVF" },
    { name: "USOI - CREDIT SUISSE AG", ticker: "USOI" },
    { name: "VIIX - CREDIT SUISSE AG", ticker: "VIIX" },
    { name: "VIIXF - CREDIT SUISSE AG", ticker: "VIIXF" },
    { name: "SLVO - CREDIT SUISSE AG", ticker: "SLVO" },
    { name: "TVIX - CREDIT SUISSE AG", ticker: "TVIX" },
    { name: "TVIXF - CREDIT SUISSE AG", ticker: "TVIXF" },
    { name: "UGAZ - CREDIT SUISSE AG", ticker: "UGAZ" },
    { name: "UGAZF - CREDIT SUISSE AG", ticker: "UGAZF" },
    { name: "UGLD - CREDIT SUISSE AG", ticker: "UGLD" },
    { name: "MLPO - CREDIT SUISSE AG", ticker: "MLPO" },
    { name: "GLDI - CREDIT SUISSE AG", ticker: "GLDI" },
    { name: "DGLDF - CREDIT SUISSE AG", ticker: "DGLDF" },
    { name: "DSLVF - CREDIT SUISSE AG", ticker: "DSLVF" },
    { name: "AFGD - AMERICAN FINANCIAL GROUP INC", ticker: "AFGD" },
    { name: "AFGE - AMERICAN FINANCIAL GROUP INC", ticker: "AFGE" },
    { name: "AFGB - AMERICAN FINANCIAL GROUP INC", ticker: "AFGB" },
    { name: "NLY-PI - ANNALY CAPITAL MANAGEMENT INC", ticker: "NLY-PI" },
    { name: "AEL-PA - AMERICAN EQUITY INVESTMENT LIFE HOLDING CO", ticker: "AEL-PA" },
    { name: "AEL-PB - AMERICAN EQUITY INVESTMENT LIFE HOLDING CO", ticker: "AEL-PB" },
    { name: "HPTOU - hopTo Inc.", ticker: "HPTOU" },
    { name: "UPL - ULTRA PETROLEUM CORP", ticker: "UPL" },
    { name: "OTIV - ON TRACK INNOVATIONS LTD", ticker: "OTIV" },
    { name: "PTX - PERNIX THERAPEUTICS HOLDINGS, INC.", ticker: "PTX" },
    { name: "IPGLF - INTERPUMP GROUP SPA /FI", ticker: "IPGLF" },
    { name: "OFG-PB - OFG BANCORP", ticker: "OFG-PB" },
    { name: "LTSH - LADENBURG THALMANN FINANCIAL SERVICES INC.", ticker: "LTSH" },
    { name: "LTSK - LADENBURG THALMANN FINANCIAL SERVICES INC.", ticker: "LTSK" },
    { name: "DTP - DTE ENERGY CO", ticker: "DTP" },
    { name: "DNRRW - DENBURY INC", ticker: "DNRRW" },
    { name: "DNRWW - DENBURY INC", ticker: "DNRWW" },
    { name: "DCOMP - DIME COMMUNITY BANCSHARES INC", ticker: "DCOMP" },
    { name: "OCFCP - OCEANFIRST FINANCIAL CORP", ticker: "OCFCP" },
    { name: "PCGU - PG&E Corp", ticker: "PCGU" },
    { name: "MGR - AFFILIATED MANAGERS GROUP, INC.", ticker: "MGR" },
    { name: "WTFCP - WINTRUST FINANCIAL CORP", ticker: "WTFCP" },
    { name: "WCC-PA - WESCO INTERNATIONAL INC", ticker: "WCC-PA" },
    { name: "COF-PI - CAPITAL ONE FINANCIAL CORP", ticker: "COF-PI" },
    { name: "COF-PJ - CAPITAL ONE FINANCIAL CORP", ticker: "COF-PJ" },
    { name: "COF-PK - CAPITAL ONE FINANCIAL CORP", ticker: "COF-PK" },
    { name: "SECT - SECTOR 10 INC", ticker: "SECT" },
    { name: "BCDAW - BioCardia, Inc.", ticker: "BCDAW" },
    { name: "HTLFP - HEARTLAND FINANCIAL USA INC", ticker: "HTLFP" },
    { name: "PPX - PPL Corp", ticker: "PPX" },
    { name: "BFS-PE - SAUL CENTERS, INC.", ticker: "BFS-PE" },
    { name: "NYCB-PU - NEW YORK COMMUNITY BANCORP INC", ticker: "NYCB-PU" },
    { name: "FRFZF - FAIRFAX FINANCIAL HOLDINGS LTD/ CAN", ticker: "FRFZF" },
    { name: "FAXRF - FAIRFAX FINANCIAL HOLDINGS LTD/ CAN", ticker: "FAXRF" },
    { name: "VRMEW - VerifyMe, Inc.", ticker: "VRMEW" },
    { name: "MET-PF - METLIFE INC", ticker: "MET-PF" },
    { name: "PSTVZ - PLUS THERAPEUTICS, INC.", ticker: "PSTVZ" },
    { name: "IIJI - INTERNET INITIATIVE JAPAN INC", ticker: "IIJI" },
    { name: "ARGO-PA - Argo Group International Holdings, Ltd.", ticker: "ARGO-PA" },
    { name: "ARGD - Argo Group International Holdings, Ltd.", ticker: "ARGD" },
    { name: "OTRKP - Ontrak, Inc.", ticker: "OTRKP" },
    { name: "CEQP-P - Crestwood Equity Partners LP", ticker: "CEQP-P" },
    { name: "PRS - PRUDENTIAL FINANCIAL INC", ticker: "PRS" },
    { name: "PRAN - ALTERITY THERAPEUTICS LTD", ticker: "PRAN" },
    { name: "FRC-PJ - FIRST REPUBLIC BANK", ticker: "FRC-PJ" },
    { name: "FRC-PK - FIRST REPUBLIC BANK", ticker: "FRC-PK" },
    { name: "GRRBP - GRANDSOUTH BANCORPORATION", ticker: "GRRBP" },
    { name: "CYRXW - Cryoport, Inc.", ticker: "CYRXW" },
    { name: "PNFPP - PINNACLE FINANCIAL PARTNERS INC", ticker: "PNFPP" },
    { name: "AMNA - UBS AG", ticker: "AMNA" },
    { name: "AMND - UBS AG", ticker: "AMND" },
    { name: "AMUB - UBS AG", ticker: "AMUB" },
    { name: "BDCL - UBS AG", ticker: "BDCL" },
    { name: "UCIB - UBS AG", ticker: "UCIB" },
    { name: "WTID - UBS AG", ticker: "WTID" },
    { name: "WTIU - UBS AG", ticker: "WTIU" },
    { name: "OILX - UBS AG", ticker: "OILX" },
    { name: "PFFL - UBS AG", ticker: "PFFL" },
    { name: "SMHB - UBS AG", ticker: "SMHB" },
    { name: "SMHD - UBS AG", ticker: "SMHD" },
    { name: "MORL - UBS AG", ticker: "MORL" },
    { name: "MRRL - UBS AG", ticker: "MRRL" },
    { name: "MVRL - UBS AG", ticker: "MVRL" },
    { name: "MLPB - UBS AG", ticker: "MLPB" },
    { name: "MLPR - UBS AG", ticker: "MLPR" },
    { name: "MLPZ - UBS AG", ticker: "MLPZ" },
    { name: "LBDC - UBS AG", ticker: "LBDC" },
    { name: "LMLP - UBS AG", ticker: "LMLP" },
    { name: "LRET - UBS AG", ticker: "LRET" },
    { name: "HDLV - UBS AG", ticker: "HDLV" },
    { name: "HOML - UBS AG", ticker: "HOML" },
    { name: "FIEE - UBS AG", ticker: "FIEE" },
    { name: "HDLB - UBS AG", ticker: "HDLB" },
    { name: "DVHL - UBS AG", ticker: "DVHL" },
    { name: "EVIX - UBS AG", ticker: "EVIX" },
    { name: "EXIV - UBS AG", ticker: "EXIV" },
    { name: "FBGX - UBS AG", ticker: "FBGX" },
    { name: "CEFZ - UBS AG", ticker: "CEFZ" },
    { name: "DJCB - UBS AG", ticker: "DJCB" },
    { name: "BDCX - UBS AG", ticker: "BDCX" },
    { name: "BDCZ - UBS AG", ticker: "BDCZ" },
    { name: "CEFD - UBS AG", ticker: "CEFD" },
    { name: "CEFL - UBS AG", ticker: "CEFL" },
    { name: "VTEC - VALTECH SE", ticker: "VTEC" },
    { name: "CIT-PB - CIT GROUP INC", ticker: "CIT-PB" },
    { name: "AGQPF - ALGONQUIN POWER & UTILITIES CORP.", ticker: "AGQPF" },
    { name: "AQNA - ALGONQUIN POWER & UTILITIES CORP.", ticker: "AQNA" },
    { name: "AQNB - ALGONQUIN POWER & UTILITIES CORP.", ticker: "AQNB" },
    { name: "DGP - DEUTSCHE BANK AKTIENGESELLSCHAFT", ticker: "DGP" },
    { name: "DGZ - DEUTSCHE BANK AKTIENGESELLSCHAFT", ticker: "DGZ" },
    { name: "DTO - DEUTSCHE BANK AKTIENGESELLSCHAFT", ticker: "DTO" },
    { name: "DXB - DEUTSCHE BANK AKTIENGESELLSCHAFT", ticker: "DXB" },
    { name: "DZZ - DEUTSCHE BANK AKTIENGESELLSCHAFT", ticker: "DZZ" },
    { name: "NDMLF - NORTHERN DYNASTY MINERALS LTD", ticker: "NDMLF" },
    { name: "QVCC - QVC INC", ticker: "QVCC" },
    { name: "EXNRF - EXCELLON RESOURCES INC", ticker: "EXNRF" },
    { name: "WLLAW - WHITING PETROLEUM CORP", ticker: "WLLAW" },
    { name: "WLLBW - WHITING PETROLEUM CORP", ticker: "WLLBW" },
    { name: "KONA - KONA GRILL INC", ticker: "KONA" },
    { name: "AHL-PE - ASPEN INSURANCE HOLDINGS LTD", ticker: "AHL-PE" },
    { name: "NYMTM - NEW YORK MORTGAGE TRUST INC", ticker: "NYMTM" },
    { name: "WIN - WINDSTREAM HOLDINGS, INC.", ticker: "WIN" },
    { name: "DANOY - GROUPE DANONE", ticker: "DANOY" },
    { name: "RWEOY - RWE AG /FI", ticker: "RWEOY" },
    { name: "QS - QuantumScape Corp", ticker: "QS" },
    { name: "YSG - Yatsen Holding Ltd", ticker: "YSG" },
    { name: "OZON - Ozon Holdings PLC", ticker: "OZON" },
    { name: "SHC - Sotera Health Co", ticker: "SHC" },
    { name: "MRVI - MARAVAI LIFESCIENCES HOLDINGS, INC.", ticker: "MRVI" },
    { name: "CNXC - Concentrix Corp", ticker: "CNXC" },
    { name: "FSR - Fisker Inc./DE", ticker: "FSR" },
    { name: "ISDAY - ISRAEL DISCOUNT BANK LTD", ticker: "ISDAY" },
    { name: "PRG - PROG Holdings, Inc.", ticker: "PRG" },
    { name: "MP - MP Materials Corp. / DE", ticker: "MP" },
    { name: "ADV - Advantage Solutions Inc.", ticker: "ADV" },
    { name: "RIDE - Lordstown Motors Corp.", ticker: "RIDE" },
    { name: "SEER - Seer, Inc.", ticker: "SEER" },
    { name: "GSHHY - GUANGSHEN RAILWAY CO LTD", ticker: "GSHHY" },
    { name: "CERE - Cerevel Therapeutics Holdings, Inc.", ticker: "CERE" },
    { name: "BFT - Foley Trasimene Acquisition II", ticker: "BFT" },
    { name: "KNTE - Kinnate Biopharma Inc.", ticker: "KNTE" },
    { name: "OLMA - Olema Pharmaceuticals, Inc.", ticker: "OLMA" },
    { name: "BALY - Bally's Corp", ticker: "BALY" },
    { name: "LGSXY - Light S.A.", ticker: "LGSXY" },
    { name: "AAN - Aaron's Company, Inc.", ticker: "AAN" },
    { name: "PRTC - PureTech Health plc", ticker: "PRTC" },
    { name: "CRHC - Cohn Robbins Holdings Corp.", ticker: "CRHC" },
    { name: "APSG - Apollo Strategic Growth Capital", ticker: "APSG" },
    { name: "RTP - Reinvent Technology Partners", ticker: "RTP" },
    { name: "SLCJY - SLC Agricola S.A.", ticker: "SLCJY" },
    { name: "FPAC - Far Peak Acquisition Corp", ticker: "FPAC" },
    { name: "SBTX - Silverback Therapeutics, Inc.", ticker: "SBTX" },
    { name: "EOSE - Eos Energy Enterprises, Inc.", ticker: "EOSE" },
    { name: "VGAC - VG Acquisition Corp.", ticker: "VGAC" },
    { name: "HRVSF - HARVEST HEALTH & RECREATION INC.", ticker: "HRVSF" },
    { name: "TLMD - SOC Telemed, Inc.", ticker: "TLMD" },
    { name: "BCHG - Grayscale Bitcoin Cash Trust (BCH)", ticker: "BCHG" },
    { name: "PACE - TPG Pace Tech Opportunities Corp.", ticker: "PACE" },
    { name: "NGMS - NeoGames S.A.", ticker: "NGMS" },
    { name: "SOLS - SOLLENSYS CORP.", ticker: "SOLS" },
    { name: "FMAC - FirstMark Horizon Acquisition Corp.", ticker: "FMAC" },
    { name: "EQD - Equity Distribution Acquisition Corp.", ticker: "EQD" },
    { name: "ABST - ABSOLUTE SOFTWARE CORP", ticker: "ABST" },
    { name: "SMMC - South Mountain Merger Corp.", ticker: "SMMC" },
    { name: "SNPR - Tortoise Acquisition Corp. II", ticker: "SNPR" },
    { name: "ENPC - Executive Network Partnering Corp", ticker: "ENPC" },
    { name: "YAC - Yucaipa Acquisition Corp", ticker: "YAC" },
    { name: "TWND - Tailwind Acquisition Corp.", ticker: "TWND" },
    { name: "INAQ - INSU Acquisition Corp. II", ticker: "INAQ" },
    { name: "PIAI - Prime Impact Acquisition I", ticker: "PIAI" },
    { name: "DGNS - Dragoneer Growth Opportunities Corp. II", ticker: "DGNS" },
    { name: "BKRP - Black Rock Petroleum Co", ticker: "BKRP" },
    { name: "VACQ - Vector Acquisition Corp", ticker: "VACQ" },
    { name: "NISN - Nisun International Enterprise Development Group Co., Ltd", ticker: "NISN" },
    { name: "PDAC - PERIDOT ACQUISITION CORP.", ticker: "PDAC" },
    { name: "BSN - Broadstone Acquisition Corp.", ticker: "BSN" },
    { name: "PDDTF - Piedmont Lithium Ltd/ADR", ticker: "PDDTF" },
    { name: "IACA - ION Acquisition Corp 1 Ltd.", ticker: "IACA" },
    { name: "TNCP - TIBURON INTERNATIONAL TRADING CORP.", ticker: "TNCP" },
    { name: "ASPL - Aspirational Consumer Lifestyle Corp.", ticker: "ASPL" },
    { name: "CLII - Climate Change Crisis Real Impact I Acquisition Corp", ticker: "CLII" },
    { name: "DBDR - Roman DBDR Tech Acquisition Corp.", ticker: "DBDR" },
    { name: "NSH - NavSight Holdings, Inc.", ticker: "NSH" },
    { name: "SBG - Sandbridge Acquisition Corp", ticker: "SBG" },
    { name: "WHF - WhiteHorse Finance, Inc.", ticker: "WHF" },
    { name: "AONE - one", ticker: "AONE" },
    { name: "CARE - Carter Bankshares, Inc.", ticker: "CARE" },
    { name: "VIH - VPC Impact Acquisition Holdings", ticker: "VIH" },
    { name: "SMTI - Sanara MedTech Inc.", ticker: "SMTI" },
    { name: "FTIV - FinTech Acquisition Corp. IV", ticker: "FTIV" },
    { name: "GDLC - Grayscale Digital Large Cap Fund LLC", ticker: "GDLC" },
    { name: "PMVC - PMV Consumer Acquisition Corp.", ticker: "PMVC" },
    { name: "WRAP - WRAP TECHNOLOGIES, INC.", ticker: "WRAP" },
    { name: "ACTX - ADVANCED CONTAINER TECHNOLOGIES, INC.", ticker: "ACTX" },
    { name: "PTK - PTK Acquisition Corp.", ticker: "PTK" },
    { name: "LQDA - Liquidia Corp", ticker: "LQDA" },
    { name: "SIOX - Sio Gene Therapies Inc.", ticker: "SIOX" },
    { name: "LYBC - LYONS BANCORP INC", ticker: "LYBC" },
    { name: "LGIQ - LOGIQ, INC.", ticker: "LGIQ" },
    { name: "SMWPY - Connect Group PLC / ADR", ticker: "SMWPY" },
    { name: "AI - C3.ai, Inc.", ticker: "AI" },
    { name: "OCUP - Ocuphire Pharma, Inc.", ticker: "OCUP" },
    { name: "DDMX - DD3 Acquisition Corp. II", ticker: "DDMX" },
    { name: "ELYS - Elys Game Technology, Corp.", ticker: "ELYS" },
    { name: "SZSMF - Santacruz Silver Mining Ltd.", ticker: "SZSMF" },
    { name: "ANDA - Andina Acquisition Corp. III", ticker: "ANDA" },
    { name: "ATNF - 180 Life Sciences Corp.", ticker: "ATNF" },
    { name: "PBLA - Panbela Therapeutics, Inc.", ticker: "PBLA" },
    { name: "MLYF - Western Magnesium Corp.", ticker: "MLYF" },
    { name: "BBIG - Vinco Ventures, Inc.", ticker: "BBIG" },
    { name: "AGOL - Andina Gold Corp.", ticker: "AGOL" },
    { name: "NPTX - NEUROPATHIX, INC.", ticker: "NPTX" },
    { name: "BNVIF - Binovi Technologies Corp.", ticker: "BNVIF" },
    { name: "CBLAQ - CBL & ASSOCIATES PROPERTIES INC", ticker: "CBLAQ" },
    { name: "WRPSF - ORO X MINING CORP.", ticker: "WRPSF" },
    { name: "SIMP - Simply, Inc.", ticker: "SIMP" },
    { name: "ALXEF - ALX RESOURCES CORP.", ticker: "ALXEF" },
    { name: "WISH - ContextLogic Inc.", ticker: "WISH" },
    { name: "EGMCF - EMGOLD MINING CORP", ticker: "EGMCF" },
    { name: "FTGI - FINOTEC GROUP INC", ticker: "FTGI" },
    { name: "VIHD - VISION HYDROGEN Corp", ticker: "VIHD" },
    { name: "CBBT - CEREBAIN BIOTECH CORP.", ticker: "CBBT" },
    { name: "RESS - Sandy Springs Holdings, Inc.", ticker: "RESS" },
    { name: "MAPT - MAPTELLIGENT, INC.", ticker: "MAPT" },
    { name: "PRPI - PERPETUAL INDUSTRIES INC.", ticker: "PRPI" },
    { name: "POTG - Portage Resources Inc.", ticker: "POTG" },
    { name: "BRTXQ - BioRestorative Therapies, Inc.", ticker: "BRTXQ" },
    { name: "TQLB - Torque Lifestyle Brands, Inc.", ticker: "TQLB" },
    { name: "VTNA - VetaNova Inc.", ticker: "VTNA" },
    { name: "ASRE - Astra Energy, Inc.", ticker: "ASRE" },
    { name: "SLCH - Spotlight Capital Holdings, Inc", ticker: "SLCH" },
    { name: "UOLI - UONLIVE CORP", ticker: "UOLI" },
    { name: "VIVK - Vivakor, Inc.", ticker: "VIVK" },
    { name: "TVOG - TURNER VALLEY OIL & GAS INC", ticker: "TVOG" },
    { name: "LEGX - LegacyXChange, Inc.", ticker: "LEGX" },
    { name: "MDIN - MedGen, Inc.", ticker: "MDIN" },
    { name: "CNNAD - Cann American Corp.", ticker: "CNNAD" },
    { name: "SAGN - Sagoon Inc.", ticker: "SAGN" },
    { name: "UPST - Upstart Holdings, Inc.", ticker: "UPST" },
    { name: "FDMT - 4D Molecular Therapeutics Inc.", ticker: "FDMT" },
    { name: "ABCL - AbCellera Biologics Inc.", ticker: "ABCL" },
    { name: "HYFM - HYDROFARM HOLDINGS GROUP, INC.", ticker: "HYFM" },
    { name: "LGCP - Legion Capital Corp", ticker: "LGCP" },
    { name: "UPYY - UPAY", ticker: "UPYY" },
    { name: "MASS - 908 Devices Inc.", ticker: "MASS" },
    { name: "TGLBY - TGLT S.A./ADR", ticker: "TGLBY" },
    { name: "GKIN - Inspired Builders, Inc.", ticker: "GKIN" },
    { name: "ABNB - Airbnb, Inc.", ticker: "ABNB" },
    { name: "STSFF - SmartStop Self Storage REIT, Inc.", ticker: "STSFF" },
    { name: "PUBM - PubMatic, Inc.", ticker: "PUBM" },
    { name: "TVTX - Travere Therapeutics, Inc.", ticker: "TVTX" },
    { name: "MAOGY - Man AG", ticker: "MAOGY" },
    { name: "LVPR - LIGHTSTONE VALUE PLUS REAL ESTATE INVESTMENT TRUST II INC", ticker: "LVPR" },
    { name: "PCOK - Pacific Oak Strategic Opportunity REIT, Inc.", ticker: "PCOK" },
    { name: "CMRF - CIM REAL ESTATE FINANCE TRUST, INC.", ticker: "CMRF" },
    { name: "DNIFY - Danieli S.p.A.", ticker: "DNIFY" },
    { name: "SOWG - Black Ridge Oil & Gas, Inc.", ticker: "SOWG" },
    { name: "KBSR - KBS Real Estate Investment Trust III, Inc.", ticker: "KBSR" },
    { name: "GMPR - UNIQUE FOODS Corp", ticker: "GMPR" },
    { name: "RBLX - Roblox Corp", ticker: "RBLX" },
    { name: "TRWO - GoIP GLOBAL, INC.", ticker: "TRWO" },
    { name: "SAAYY - SAIPEM S P A /FI", ticker: "SAAYY" },
    { name: "URGP - Urigen Pharmaceuticals, Inc.", ticker: "URGP" },
    { name: "YBGJ - MAGNA LAB INC", ticker: "YBGJ" },
    { name: "ZNTE - Zanite Acquisition Corp.", ticker: "ZNTE" },
    { name: "RICE - Rice Acquisition Corp.", ticker: "RICE" },
    { name: "LUXAU - Lux Health Tech Acquisition Corp.", ticker: "LUXAU" },
    { name: "HIGA - H.I.G. Acquisition Corp.", ticker: "HIGA" },
    { name: "FIN - MARLIN TECHNOLOGY CORP.", ticker: "FIN" },
    { name: "ACICU - Atlas Crest Investment Corp.", ticker: "ACICU" },
    { name: "GFX - Golden Falcon Acquisition Corp.", ticker: "GFX" },
    { name: "NOAC - Natural Order Acquisition Corp.", ticker: "NOAC" },
    { name: "RAAC - Revolution Acceleration Acquisition Corp", ticker: "RAAC" },
    { name: "ADOC - Edoc Acquisition Corp.", ticker: "ADOC" },
    { name: "SPFR - JAWS Spitfire Acquisition Corp", ticker: "SPFR" },
    { name: "CHFW - Consonance-HFW Acquisition Corp.", ticker: "CHFW" },
    { name: "DMYI - dMY Technology Group, Inc. III", ticker: "DMYI" },
    { name: "AJAX - Ajax I", ticker: "AJAX" },
    { name: "IDBA - IDEX Biometrics ASA", ticker: "IDBA" },
    { name: "CERT - Certara, Inc.", ticker: "CERT" },
    { name: "MTAC - MedTech Acquisition Corp", ticker: "MTAC" },
    { name: "FRX - Forest Road Acquisition Corp.", ticker: "FRX" },
    { name: "BCAB - BioAtla, Inc.", ticker: "BCAB" },
    { name: "WOOF - PET Acquisition LLC", ticker: "WOOF" },
    { name: "TSIA - TS Innovation Acquisitions Corp.", ticker: "TSIA" },
    { name: "NEBC - Nebula Caravel Acquisition Corp.", ticker: "NEBC" },
    { name: "FLAC - Frazier Lifesciences Acquisition Corp", ticker: "FLAC" },
    { name: "FOA - Finance of America Companies Inc.", ticker: "FOA" },
    { name: "HMCO - HumanCo Acquisition Corp.", ticker: "HMCO" },
    { name: "SVOK - Seven Oaks Acquisition Corp.", ticker: "SVOK" },
    { name: "CBAH - CBRE Acquisition Holdings, Inc.", ticker: "CBAH" },
    { name: "MOTV - Motive Capital Corp", ticker: "MOTV" },
    { name: "RTPZ - Reinvent Technology Partners Z", ticker: "RTPZ" },
    { name: "PHAR - Pharming Group N.V.", ticker: "PHAR" },
    { name: "RSVA - Rodgers Silicon Valley Acquisition Corp", ticker: "RSVA" },
    { name: "PCT - Roth CH Acquisition I Co. Parent Corp.", ticker: "PCT" },
    { name: "LBPS - 4D Pharma PLC", ticker: "LBPS" },
    { name: "MRAC - Marquee Raine Acquisition Corp.", ticker: "MRAC" },
    { name: "FRGT - Hudson Capital Merger Sub I Inc.", ticker: "FRGT" },
    { name: "UFIN - Ufin Tek Limited", ticker: "UFIN" },
    { name: "LMACA - Liberty Media Acquisition Corp", ticker: "LMACA" },
    { name: "COOL - Corner Growth Acquisition Corp.", ticker: "COOL" },
    { name: "FORA - Forian Inc.", ticker: "FORA" },
    { name: "CAS - Cascade Acquisition Corp", ticker: "CAS" },
    { name: "ALTU - Altitude Acquisition Corp.", ticker: "ALTU" },
    { name: "LOKB - Live Oak Acquisition Corp II", ticker: "LOKB" },
    { name: "TMKR - Tastemaker Acquisition Corp.", ticker: "TMKR" },
    { name: "HZON - Horizon Acquisition Corp II", ticker: "HZON" },
    { name: "SPRQ - Spartan Acquisition Corp. II", ticker: "SPRQ" },
    { name: "VTAQ - Ventoux CCM Acquisition Corp.", ticker: "VTAQ" },
    { name: "YSACU - Yellowstone Acquisition Co", ticker: "YSACU" },
    { name: "EMPW - Empower Ltd.", ticker: "EMPW" },
    { name: "SV - SPRING VALLEY ACQUISITION CORP.", ticker: "SV" },
    { name: "KWAC - Kingswood Acquisition Corp.", ticker: "KWAC" },
    { name: "KINZ - KINS Technology Group, Inc.", ticker: "KINZ" },
    { name: "AIRC - Apartment Income REIT Corp.", ticker: "AIRC" },
    { name: "AFRM - Affirm Holdings, Inc.", ticker: "AFRM" },
    { name: "PTIC - PROPTECH INVESTMENT CORP. II", ticker: "PTIC" },
    { name: "OTRA - OTR Acquisition Corp.", ticker: "OTRA" },
    { name: "SGTX - Sigilon Therapeutics, Inc.", ticker: "SGTX" },
    { name: "UK - Ucommune International Ltd", ticker: "UK" },
    { name: "YQ - 17 Education & Technology Group Inc.", ticker: "YQ" },
    { name: "TVAC - Thayer Ventures Acquisition Corp", ticker: "TVAC" },
    { name: "RMGB - RMG Acquisition Corp. II", ticker: "RMGB" },
    { name: "TINV - Tiga Acquisition Corp.", ticker: "TINV" },
    { name: "SGAM - Seaport Global Acquisition Corp", ticker: "SGAM" },
    { name: "HTOO - Fusion Fuel Green PLC", ticker: "HTOO" },
    { name: "MRM - Medirom Healthcare Technologies Inc.", ticker: "MRM" },
    { name: "GNPK - Genesis Park Acquisition Corp.", ticker: "GNPK" },
    { name: "GWAC - GOOD WORKS ACQUISITION CORP.", ticker: "GWAC" },
    { name: "CCV - Churchill Capital Corp V", ticker: "CCV" },
    { name: "PTPI - Petros Pharmaceuticals, Inc.", ticker: "PTPI" },
    { name: "TKSI - Turnkey Solutions, Inc.", ticker: "TKSI" },
    { name: "STIC - Northern Star Acquisition Corp.", ticker: "STIC" },
    { name: "GHVI - Gores Holdings VI, Inc.", ticker: "GHVI" },
    { name: "CFAC - CF Finance Acquisition Corp. III", ticker: "CFAC" },
    { name: "FGNA - FG New America Acquisition Corp.", ticker: "FGNA" },
    { name: "BREZ - Breeze Holdings Acquisition Corp.", ticker: "BREZ" },
    { name: "BOAC - Bluescape Opportunities Acquisition Corp.", ticker: "BOAC" },
    { name: "LAZR - Luminar Technologies, Inc./DE", ticker: "LAZR" },
    { name: "BIGN - BIGEON CORP.", ticker: "BIGN" },
    { name: "LOVA - LOVARRA", ticker: "LOVA" },
    { name: "CAP - Capitol Investment Corp. V", ticker: "CAP" },
    { name: "JUVAF - JUVA LIFE INC./Canada", ticker: "JUVAF" },
    { name: "OCG - Oriental Culture Holding LTD", ticker: "OCG" },
    { name: "NBTX - Nanobiotix S.A.", ticker: "NBTX" },
    { name: "CHMT - Charmt, Inc.", ticker: "CHMT" },
    { name: "CRN - Coronado Global Resources Inc.", ticker: "CRN" },
    { name: "EZGO - EZGO Technologies Ltd.", ticker: "EZGO" },
    { name: "JWEL - Jowell Global Ltd.", ticker: "JWEL" },
    { name: "ACKIT - ACKRELL SPAC Partners I Co.", ticker: "ACKIT" },
    { name: "DASH - DoorDash Inc", ticker: "DASH" },
    { name: "BECEF - BCE INC", ticker: "BECEF" },
    { name: "NWWDF - NEW WORLD DEVELOPMENT CO LTD /FI", ticker: "NWWDF" },
    { name: "NI-PB - NISOURCE INC.", ticker: "NI-PB" },
    { name: "GLIBB - GCI LIBERTY, INC.", ticker: "GLIBB" },
    { name: "FCNCB - FIRST CITIZENS BANCSHARES INC /DE/", ticker: "FCNCB" },
    { name: "FPAC-UN - Far Peak Acquisition Corp", ticker: "FPAC-UN" },
    { name: "TWCT - TWC Tech Holdings II Corp.", ticker: "TWCT" },
    { name: "VSPR - Vesper Healthcare Acquisition Corp.", ticker: "VSPR" },
    { name: "CMLF - CM Life Sciences, Inc.", ticker: "CMLF" },
    { name: "SEAH - Sports Entertainment Acquisition Corp.", ticker: "SEAH" },
    { name: "SVAC - STARBOARD VALUE ACQUISITION CORP.", ticker: "SVAC" },
    { name: "SOLSD - SOLLENSYS CORP.", ticker: "SOLSD" },
    { name: "BOWX - BowX Acquisition Corp.", ticker: "BOWX" },
    { name: "GMMVF - G Medical Innovations Holdings Ltd.", ticker: "GMMVF" },
    { name: "FCAC - Falcon Capital Acquisition Corp.", ticker: "FCAC" },
    { name: "BWMYD - BorrowMoney.com, Inc.", ticker: "BWMYD" },
    { name: "STWO - ACON S2 Acquisition Corp.", ticker: "STWO" },
    { name: "AIXND - AiXin Life International, Inc.", ticker: "AIXND" },
    { name: "RCHG - Recharge Acquisition Corp.", ticker: "RCHG" },
    { name: "ONDSD - Ondas Holdings Inc.", ticker: "ONDSD" },
    { name: "AI-PC - Arlington Asset Investment Corp.", ticker: "AI-PC" },
    { name: "AI-PB - Arlington Asset Investment Corp.", ticker: "AI-PB" },
    { name: "PEI-PC - PENNSYLVANIA REAL ESTATE INVESTMENT TRUST", ticker: "PEI-PC" },
    { name: "PEI-PB - PENNSYLVANIA REAL ESTATE INVESTMENT TRUST", ticker: "PEI-PB" },
    { name: "PEI-PD - PENNSYLVANIA REAL ESTATE INVESTMENT TRUST", ticker: "PEI-PD" },
    { name: "THCBU - Tuscan Holdings Corp.", ticker: "THCBU" },
    { name: "IPATD - ImmunoPrecise Antibodies Ltd.", ticker: "IPATD" },
    { name: "AHAC - Alpha Healthcare Acquisition Corp.", ticker: "AHAC" },
    { name: "PAIC - Petra Acquisition Inc.", ticker: "PAIC" },
    { name: "TNCPD - TIBURON INTERNATIONAL TRADING CORP.", ticker: "TNCPD" },
    { name: "LIXTD - LIXTE BIOTECHNOLOGY HOLDINGS, INC.", ticker: "LIXTD" },
    { name: "FGCN - Flagship Global Corp", ticker: "FGCN" },
    { name: "NNUTU - ROYAL HAWAIIAN ORCHARDS, L.P.", ticker: "NNUTU" },
    { name: "TRIQ - TRAQIQ, INC.", ticker: "TRIQ" },
    { name: "WINRD - SIMPLICITY ESPORTS & GAMING Co", ticker: "WINRD" },
    { name: "CBL-PD - CBL & ASSOCIATES PROPERTIES INC", ticker: "CBL-PD" },
    { name: "CBL-PE - CBL & ASSOCIATES PROPERTIES INC", ticker: "CBL-PE" },
    { name: "CACAD - China Crawfish, Ltd.", ticker: "CACAD" },
    { name: "QUTRD - Born, Inc.", ticker: "QUTRD" },
    { name: "CLSID - CLANCY SYSTEMS INTERNATIONAL INC /CO/", ticker: "CLSID" },
    { name: "NGLDD - Nevada Canyon Gold Corp.", ticker: "NGLDD" },
    { name: "BOTHD - BIOETHICS LTD", ticker: "BOTHD" },
    { name: "ANDAR - Andina Acquisition Corp. III", ticker: "ANDAR" },
    { name: "PPCBD - Propanc Biopharma, Inc.", ticker: "PPCBD" },
    { name: "ALTND - Alternus Energy Inc.", ticker: "ALTND" },
    { name: "GMNI - FS Development Corp.", ticker: "GMNI" },
    { name: "TSGL - Staffing Group, Ltd.", ticker: "TSGL" },
    { name: "CTACU - GRID DYNAMICS HOLDINGS, INC.", ticker: "CTACU" },
    { name: "CAP-UN - Capitol Investment Corp. V", ticker: "CAP-UN" },
    { name: "FSR-WT - Fisker Inc./DE", ticker: "FSR-WT" },
    { name: "SVACW - STARBOARD VALUE ACQUISITION CORP.", ticker: "SVACW" },
    { name: "TLMDW - SOC Telemed, Inc.", ticker: "TLMDW" },
    { name: "HPKER - HighPeak Energy, Inc.", ticker: "HPKER" },
    { name: "CEREW - Cerevel Therapeutics Holdings, Inc.", ticker: "CEREW" },
    { name: "MACUW - Mallard Acquisition Corp.", ticker: "MACUW" },
    { name: "MACU - Mallard Acquisition Corp.", ticker: "MACU" },
    { name: "VGAC-WT - VG Acquisition Corp.", ticker: "VGAC-WT" },
    { name: "EOSEW - Eos Energy Enterprises, Inc.", ticker: "EOSEW" },
    { name: "IPOB-UN - Social Capital Hedosophia Holdings Corp. II", ticker: "IPOB-UN" },
    { name: "IPOC-UN - Social Capital Hedosophia Holdings Corp. III", ticker: "IPOC-UN" },
    { name: "ASPI - Aspire Real Estate Investors, Inc.", ticker: "ASPI" },
    { name: "UPH - GigCapital2, Inc.", ticker: "UPH" },
    { name: "THCBW - Tuscan Holdings Corp.", ticker: "THCBW" },
    { name: "HYLN-WT - Hyliion Holdings Corp.", ticker: "HYLN-WT" },
    { name: "JUPWW - Jupiter Wellness, Inc.", ticker: "JUPWW" },
    { name: "ADVWW - Advantage Solutions Inc.", ticker: "ADVWW" },
    { name: "FTIVW - FinTech Acquisition Corp. IV", ticker: "FTIVW" },
    { name: "SMMCW - South Mountain Merger Corp.", ticker: "SMMCW" },
    { name: "CAPAW - HighCape Capital Acquisition Corp.", ticker: "CAPAW" },
    { name: "ENPC-WT - Executive Network Partnering Corp", ticker: "ENPC-WT" },
    { name: "NSH-WT - NavSight Holdings, Inc.", ticker: "NSH-WT" },
    { name: "FCACW - Falcon Capital Acquisition Corp.", ticker: "FCACW" },
    { name: "VSPRW - Vesper Healthcare Acquisition Corp.", ticker: "VSPRW" },
    { name: "CRHC-WT - Cohn Robbins Holdings Corp.", ticker: "CRHC-WT" },
    { name: "CMLFW - CM Life Sciences, Inc.", ticker: "CMLFW" },
    { name: "EQD-WT - Equity Distribution Acquisition Corp.", ticker: "EQD-WT" },
    { name: "LEAP-WT - Ribbit LEAP, Ltd.", ticker: "LEAP-WT" },
    { name: "SBG-WT - Sandbridge Acquisition Corp", ticker: "SBG-WT" },
    { name: "BOAC-UN - Bluescape Opportunities Acquisition Corp.", ticker: "BOAC-UN" },
    { name: "RCHGW - Recharge Acquisition Corp.", ticker: "RCHGW" },
    { name: "AVAN-WT - Avanti Acquisition Corp.", ticker: "AVAN-WT" },
    { name: "SNPR-WT - Tortoise Acquisition Corp. II", ticker: "SNPR-WT" },
    { name: "STIC-UN - Northern Star Acquisition Corp.", ticker: "STIC-UN" },
    { name: "ASPL-WT - Aspirational Consumer Lifestyle Corp.", ticker: "ASPL-WT" },
    { name: "STWOW - ACON S2 Acquisition Corp.", ticker: "STWOW" },
    { name: "PACE-WT - TPG Pace Tech Opportunities Corp.", ticker: "PACE-WT" },
    { name: "TWCTW - TWC Tech Holdings II Corp.", ticker: "TWCTW" },
    { name: "TPGY-WT - TPG Pace Beneficial Finance Corp.", ticker: "TPGY-WT" },
    { name: "AHACW - Alpha Healthcare Acquisition Corp.", ticker: "AHACW" },
    { name: "FGNA-WT - FG New America Acquisition Corp.", ticker: "FGNA-WT" },
    { name: "IPOF-WT - Social Capital Hedosophia Holdings Corp. VI", ticker: "IPOF-WT" },
    { name: "IPOE-WT - Social Capital Hedosophia Holdings Corp. V", ticker: "IPOE-WT" },
    { name: "IPOD-WT - Social Capital Hedosophia Holdings Corp. IV", ticker: "IPOD-WT" },
    { name: "PIAI-WT - Prime Impact Acquisition I", ticker: "PIAI-WT" },
    { name: "INAQW - INSU Acquisition Corp. II", ticker: "INAQW" },
    { name: "MLE - INSU Acquisition Corp. II", ticker: "MLE" },
    { name: "BTWN - Bridgetown Holdings Ltd", ticker: "BTWN" },
    { name: "BTWNW - Bridgetown Holdings Ltd", ticker: "BTWNW" },
    { name: "BSN-WT - Broadstone Acquisition Corp.", ticker: "BSN-WT" },
    { name: "TWND-WT - Tailwind Acquisition Corp.", ticker: "TWND-WT" },
    { name: "BOWXW - BowX Acquisition Corp.", ticker: "BOWXW" },
    { name: "ACEVW - ACE Convergence Acquisition Corp.", ticker: "ACEVW" },
    { name: "PAICW - Petra Acquisition Inc.", ticker: "PAICW" },
    { name: "QS-WT - QuantumScape Corp", ticker: "QS-WT" },
    { name: "CFIIW - CF Finance Acquisition Corp II", ticker: "CFIIW" },
    { name: "PMVC-WT - PMV Consumer Acquisition Corp.", ticker: "PMVC-WT" },
    { name: "GLFWD - Wetouch Technology Inc.", ticker: "GLFWD" },
    { name: "TACA-UN - Trepont Acquistion Corp I", ticker: "TACA-UN" },
    { name: "OCA-UN - Omnichannel Acquisition Corp.", ticker: "OCA-UN" },
    { name: "SPFR-UN - JAWS Spitfire Acquisition Corp", ticker: "SPFR-UN" },
    { name: "CND-UN - Concord Acquisition Corp", ticker: "CND-UN" },
    { name: "NBA-WT - New Beginnings Acquisition Corp.", ticker: "NBA-WT" },
    { name: "FINU - MARLIN TECHNOLOGY CORP.", ticker: "FINU" },
    { name: "ZNTEU - Zanite Acquisition Corp.", ticker: "ZNTEU" },
    { name: "RSVAU - Rodgers Silicon Valley Acquisition Corp", ticker: "RSVAU" },
    { name: "RTPZ-UN - Reinvent Technology Partners Z", ticker: "RTPZ-UN" },
    { name: "HTPA-UN - Highland Transcend Partners I Corp.", ticker: "HTPA-UN" },
    { name: "HMCOU - HumanCo Acquisition Corp.", ticker: "HMCOU" },
    { name: "LCYAW - Landcadia Holdings III, Inc.", ticker: "LCYAW" },
    { name: "FMAC-WT - FirstMark Horizon Acquisition Corp.", ticker: "FMAC-WT" },
    { name: "HZON-UN - Horizon Acquisition Corp II", ticker: "HZON-UN" },
    { name: "SPRQ-UN - Spartan Acquisition Corp. II", ticker: "SPRQ-UN" },
    { name: "LOKB-UN - Live Oak Acquisition Corp II", ticker: "LOKB-UN" },
    { name: "AGCWW - Altimeter Growth Corp.", ticker: "AGCWW" },
    { name: "EMPW-WT - Empower Ltd.", ticker: "EMPW-WT" },
    { name: "VYGG-WT - Vy Global Growth", ticker: "VYGG-WT" },
    { name: "DBDRW - Roman DBDR Tech Acquisition Corp.", ticker: "DBDRW" },
    { name: "DSACW - Duddell Street Acquisition Corp.", ticker: "DSACW" },
    { name: "DSAC - Duddell Street Acquisition Corp.", ticker: "DSAC" },
    { name: "OACB-WT - Oaktree Acquisition Corp. II", ticker: "OACB-WT" },
    { name: "IACA-WT - ION Acquisition Corp 1 Ltd.", ticker: "IACA-WT" },
    { name: "APSG-WT - Apollo Strategic Growth Capital", ticker: "APSG-WT" },
    { name: "UKOMW - Ucommune International Ltd", ticker: "UKOMW" },
    { name: "PDAC-WT - PERIDOT ACQUISITION CORP.", ticker: "PDAC-WT" },
    { name: "CLII-WT - Climate Change Crisis Real Impact I Acquisition Corp", ticker: "CLII-WT" },
    { name: "GWACW - GOOD WORKS ACQUISITION CORP.", ticker: "GWACW" },
    { name: "RTP-WT - Reinvent Technology Partners", ticker: "RTP-WT" },
    { name: "GCMGW - GCM Grosvenor Inc.", ticker: "GCMGW" },
    { name: "IMPX-WT - AEA-Bridges Impact Corp.", ticker: "IMPX-WT" },
    { name: "VACQW - Vector Acquisition Corp", ticker: "VACQW" },
    { name: "ACTCW - ArcLight Clean Transition Corp.", ticker: "ACTCW" },
    { name: "VIHAW - VPC Impact Acquisition Holdings", ticker: "VIHAW" },
    { name: "VIHAU - VPC Impact Acquisition Holdings", ticker: "VIHAU" },
    { name: "CBLDQ - CBL & ASSOCIATES PROPERTIES INC", ticker: "CBLDQ" },
    { name: "CBLEQ - CBL & ASSOCIATES PROPERTIES INC", ticker: "CBLEQ" },
    { name: "NRGD - BANK OF MONTREAL /CAN/", ticker: "NRGD" },
    { name: "GDXD - BANK OF MONTREAL /CAN/", ticker: "GDXD" },
    { name: "GDXU - BANK OF MONTREAL /CAN/", ticker: "GDXU" },
    { name: "AMTR - UBS AG", ticker: "AMTR" },
    { name: "AAIC-PB - Arlington Asset Investment Corp.", ticker: "AAIC-PB" },
    { name: "AAIC-PC - Arlington Asset Investment Corp.", ticker: "AAIC-PC" },
    { name: "CNO-PA - CNO Financial Group, Inc.", ticker: "CNO-PA" },
    { name: "AIZN - ASSURANT, INC.", ticker: "AIZN" },
    { name: "BTEGF - BAYTEX ENERGY CORP.", ticker: "BTEGF" },
    { name: "USB-PQ - US BANCORP \\DE\\", ticker: "USB-PQ" },
    { name: "BAC-PO - BANK OF AMERICA CORP /DE/", ticker: "BAC-PO" },
    { name: "WFC-PA - WELLS FARGO & COMPANY/MN", ticker: "WFC-PA" },
    { name: "HSEPF - HUSKY ENERGY INC", ticker: "HSEPF" },
    { name: "HUSPF - HUSKY ENERGY INC", ticker: "HUSPF" },
    { name: "CFR-PB - CULLEN/FROST BANKERS, INC.", ticker: "CFR-PB" },
    { name: "LGL-WT - LGL GROUP INC", ticker: "LGL-WT" },
    { name: "FULTP - FULTON FINANCIAL CORP", ticker: "FULTP" },
    { name: "PHIGW - PHI GROUP INC", ticker: "PHIGW" },
    { name: "BCCCF - BCE INC", ticker: "BCCCF" },
    { name: "BCEFF - BCE INC", ticker: "BCEFF" },
    { name: "BCEPF - BCE INC", ticker: "BCEPF" },
    { name: "BCEXF - BCE INC", ticker: "BCEXF" },
    { name: "AMRHW - AMERI Holdings, Inc.", ticker: "AMRHW" },
    { name: "VNO-PN - VORNADO REALTY TRUST", ticker: "VNO-PN" },
    { name: "UZE - UNITED STATES CELLULAR CORP", ticker: "UZE" },
    { name: "TTXXF - TITAN MEDICAL INC", ticker: "TTXXF" },
    { name: "TIXXF - TITAN MEDICAL INC", ticker: "TIXXF" },
    { name: "FCNCP - FIRST CITIZENS BANCSHARES INC /DE/", ticker: "FCNCP" },
    { name: "BHFAN - Brighthouse Financial, Inc.", ticker: "BHFAN" },
    { name: "ANDAW - Andina Acquisition Corp. III", ticker: "ANDAW" },
    { name: "ATNFW - 180 Life Sciences Corp.", ticker: "ATNFW" },
    { name: "CRCQW - California Resources Corp", ticker: "CRCQW" },
    { name: "PRCD - Legacy Education Alliance, Inc.", ticker: "PRCD" },
    { name: "YGYIP - Youngevity International, Inc.", ticker: "YGYIP" },
    { name: "SDDXF - SANDSTORM GOLD LTD", ticker: "SDDXF" },
    { name: "LIXTW - LIXTE BIOTECHNOLOGY HOLDINGS, INC.", ticker: "LIXTW" },
    { name: "SKLZ - Skillz Inc.", ticker: "SKLZ" },
    { name: "DM - Desktop Metal, Inc.", ticker: "DM" },
    { name: "BCUCY - Brunello Cucinelli S.p.A./ADR", ticker: "BCUCY" },
    { name: "CSR - INVESTORS REAL ESTATE TRUST", ticker: "CSR" },
    { name: "AGC - Altimeter Growth Corp.", ticker: "AGC" },
    { name: "GOEV - Canoo Inc.", ticker: "GOEV" },
    { name: "LGORF - Largo Resources Ltd.", ticker: "LGORF" },
    { name: "SBOEY - Schoeller-Bleckmann Oilfield Equipment AG/ADR", ticker: "SBOEY" },
    { name: "XL - Pivotal Investment Corp II", ticker: "XL" },
    { name: "SAFLY - Safilo Group SpA/ADR", ticker: "SAFLY" },
    { name: "SCPS - Scopus BioPharma Inc.", ticker: "SCPS" },
    { name: "TMRR - TEMIR CORP.", ticker: "TMRR" },
    { name: "BFI - BurgerFi International, Inc.", ticker: "BFI" },
    { name: "ATBPD - Antibe Therapeutics Inc.", ticker: "ATBPD" },
    { name: "MINM - Zoom Telephonics, Inc.", ticker: "MINM" },
    { name: "RVPH - REVIVA PHARMACEUTICALS HOLDINGS, INC.", ticker: "RVPH" },
    { name: "FCTI - FACT, Inc.", ticker: "FCTI" },
    { name: "PPBT - Kitov Pharma Ltd.", ticker: "PPBT" },
    { name: "KALO - Kallo Inc.", ticker: "KALO" },
    { name: "ITHUF - iANTHUS CAPITAL HOLDINGS, INC.", ticker: "ITHUF" },
    { name: "UURAD - Ucore Rare Metals Inc.", ticker: "UURAD" },
    { name: "FGF - FG Financial Group, Inc.", ticker: "FGF" },
    { name: "VRSSF - Versus Systems Inc.", ticker: "VRSSF" },
    { name: "GCFFF - GOLDCLIFF RESOURCE CORP", ticker: "GCFFF" },
    { name: "OBCN - CLANCY SYSTEMS INTERNATIONAL INC /CO/", ticker: "OBCN" },
    { name: "TRLFD - True Leaf Brands Inc.", ticker: "TRLFD" },
    { name: "RPNRF - Rapid Nutrition PLC", ticker: "RPNRF" },
    { name: "PZOO - Pazoo, Inc.", ticker: "PZOO" },
    { name: "MBLV - MobiVentures Inc.", ticker: "MBLV" },
    { name: "BCYP - Big Cypress Acquisition Corp.", ticker: "BCYP" },
    { name: "PTAM - POTASH AMERICA, INC.", ticker: "PTAM" },
    { name: "DNAXD - DNA BRANDS INC", ticker: "DNAXD" },
    { name: "YMTX - PROTEOSTASIS THERAPEUTICS, INC.", ticker: "YMTX" },
    { name: "CTAQ - Carney Technology Acquisition Corp. II", ticker: "CTAQ" },
    { name: "VHAQ - Viveon Health Acquisition Corp.", ticker: "VHAQ" },
    { name: "INKA - KLUDEIN I ACQUISITION CORP", ticker: "INKA" },
    { name: "CFIV - CF ACQUISITION CORP. IV", ticker: "CFIV" },
    { name: "AGRI - AGRIFORCE GROWING SYSTEMS LTD.", ticker: "AGRI" },
    { name: "MNTK - Montauk Renewables, Inc.", ticker: "MNTK" },
    { name: "POSH - Poshmark, Inc.", ticker: "POSH" },
    { name: "VII - 7GC & Co. Holdings Inc.", ticker: "VII" },
    { name: "ARVL - Arrival Group", ticker: "ARVL" },
    { name: "FOXW - FoxWayne Enterprises Acquisition Corp.", ticker: "FOXW" },
    { name: "DWIN - Delwinds Insurance Acquisition Corp.", ticker: "DWIN" },
    { name: "BIRD - Infobird Co., Ltd", ticker: "BIRD" },
    { name: "OPEN - Opendoor Technologies Inc.", ticker: "OPEN" },
    { name: "VCKA - Vickers Vantage Corp. I", ticker: "VCKA" },
    { name: "BLUW - Blue Water Acquisition Corp.", ticker: "BLUW" },
    { name: "DUNE - Dune Acquisition Corp", ticker: "DUNE" },
    { name: "EEIQ - Elite Education Group International Ltd", ticker: "EEIQ" },
    { name: "SKMT - Chengda Technology Co., Ltd.", ticker: "SKMT" },
    { name: "FELTF - Fuji Electric Holdings Ltd", ticker: "FELTF" },
    { name: "HNTUF - Hunter Maritime Acquisition Corp.", ticker: "HNTUF" },
    { name: "VSLCX - Invesco Senior Loan Fund", ticker: "VSLCX" },
    { name: "VSLYX - Invesco Senior Loan Fund", ticker: "VSLYX" },
    { name: "ACIC - Atlas Crest Investment Corp.", ticker: "ACIC" },
    { name: "ECCX - Eagle Point Credit Co Inc.", ticker: "ECCX" },
    { name: "ECCB - Eagle Point Credit Co Inc.", ticker: "ECCB" },
    { name: "DCRB - Decarbonization Plus Acquisition Corp", ticker: "DCRB" },
    { name: "ZESTD - Ecoark Holdings, Inc.", ticker: "ZESTD" },
    { name: "YSAC - Yellowstone Acquisition Co", ticker: "YSAC" },
    { name: "VRSSD - Versus Systems Inc.", ticker: "VRSSD" },
    { name: "WFCFD - Where Food Comes From, Inc.", ticker: "WFCFD" },
    { name: "CRCUD - Canagold Resources Ltd.", ticker: "CRCUD" },
    { name: "OCCIP - OFS Credit Company, Inc.", ticker: "OCCIP" },
    { name: "CYTH - Cyclo Therapeutics, Inc.", ticker: "CYTH" },
    { name: "AMMXD - Ameramex International Inc", ticker: "AMMXD" },
    { name: "KAYSD - Kaya Holdings, Inc.", ticker: "KAYSD" },
    { name: "FERLD - FEARLESS FILMS, INC.", ticker: "FERLD" },
    { name: "AVPMD - AVRUPA MINERALS LTD.", ticker: "AVPMD" },
    { name: "SSOLD - SUNVALLEY SOLAR, INC.", ticker: "SSOLD" },
    { name: "SSOL - SUNVALLEY SOLAR, INC.", ticker: "SSOL" },
    { name: "NOVZ - Novagen Ingenium Inc.", ticker: "NOVZ" },
    { name: "ATPTD - PETRO USA, INC.", ticker: "ATPTD" },
    { name: "TDRYD - Red White & Bloom Brands Inc.", ticker: "TDRYD" },
    { name: "RVPHW - REVIVA PHARMACEUTICALS HOLDINGS, INC.", ticker: "RVPHW" },
    { name: "BFIIW - BurgerFi International, Inc.", ticker: "BFIIW" },
    { name: "VS - Versus Systems Inc.", ticker: "VS" },
    { name: "DCRBW - Decarbonization Plus Acquisition Corp", ticker: "DCRBW" },
    { name: "RSI - dMY Technology Group, Inc.", ticker: "RSI" },
    { name: "ACKIU - ACKRELL SPAC Partners I Co.", ticker: "ACKIU" },
    { name: "XL-WT - Pivotal Investment Corp II", ticker: "XL-WT" },
    { name: "BHSE - Bull Horn Holdings Corp.", ticker: "BHSE" },
    { name: "BHSEW - Bull Horn Holdings Corp.", ticker: "BHSEW" },
    { name: "GOEVW - Canoo Inc.", ticker: "GOEVW" },
    { name: "DM-WT - Desktop Metal, Inc.", ticker: "DM-WT" },
    { name: "MP-WT - MP Materials Corp. / DE", ticker: "MP-WT" },
    { name: "SKLZ-WT - Skillz Inc.", ticker: "SKLZ-WT" },
    { name: "TXAC - Therapeutics Acquisition Corp.", ticker: "TXAC" },
    { name: "BOAC-WT - Bluescape Opportunities Acquisition Corp.", ticker: "BOAC-WT" },
    { name: "NGAC - NextGen Acquisition Corp", ticker: "NGAC" },
    { name: "NGACW - NextGen Acquisition Corp", ticker: "NGACW" },
    { name: "BARK - Northern Star Acquisition Corp.", ticker: "BARK" },
    { name: "STIC-WT - Northern Star Acquisition Corp.", ticker: "STIC-WT" },
    { name: "CLVRW - Clever Leaves Holdings Inc.", ticker: "CLVRW" },
    { name: "HTOOW - Fusion Fuel Green PLC", ticker: "HTOOW" },
    { name: "SGAMW - Seaport Global Acquisition Corp", ticker: "SGAMW" },
    { name: "CONXW - CONX Corp.", ticker: "CONXW" },
    { name: "SVSVW - SPRING VALLEY ACQUISITION CORP.", ticker: "SVSVW" },
    { name: "XPOA-WT - DPCM Capital, Inc.", ticker: "XPOA-WT" },
    { name: "HZON-WT - Horizon Acquisition Corp II", ticker: "HZON-WT" },
    { name: "OTRAW - OTR Acquisition Corp.", ticker: "OTRAW" },
    { name: "MTACU - MedTech Acquisition Corp", ticker: "MTACU" },
    { name: "NEBCU - Nebula Caravel Acquisition Corp.", ticker: "NEBCU" },
    { name: "VIIU - 7GC & Co. Holdings Inc.", ticker: "VIIU" },
    { name: "SPNV-WT - Supernova Partners Acquisition Company, Inc.", ticker: "SPNV-WT" },
    { name: "ATA-UN - AMERICAS TECHNOLOGY ACQUISITION CORP.", ticker: "ATA-UN" },
    { name: "PCPC-UN - Periphas Capital Partnering Corp", ticker: "PCPC-UN" },
    { name: "AJAX-WT - Ajax I", ticker: "AJAX-WT" },
    { name: "MOTV-UN - Motive Capital Corp", ticker: "MOTV-UN" },
    { name: "CBAH-UN - CBRE Acquisition Holdings, Inc.", ticker: "CBAH-UN" },
    { name: "SVOKU - Seven Oaks Acquisition Corp.", ticker: "SVOKU" },
    { name: "DDMXU - DD3 Acquisition Corp. II", ticker: "DDMXU" },
    { name: "YSACW - Yellowstone Acquisition Co", ticker: "YSACW" },
    { name: "RICE-WT - Rice Acquisition Corp.", ticker: "RICE-WT" },
    { name: "HIGA-WT - H.I.G. Acquisition Corp.", ticker: "HIGA-WT" },
    { name: "GFX-UN - Golden Falcon Acquisition Corp.", ticker: "GFX-UN" },
    { name: "CTAC-WT - Cerberus Telecom Acquisition Corp.", ticker: "CTAC-WT" },
    { name: "RAACU - Revolution Acceleration Acquisition Corp", ticker: "RAACU" },
    { name: "ADOCR - Edoc Acquisition Corp.", ticker: "ADOCR" },
    { name: "ADOCW - Edoc Acquisition Corp.", ticker: "ADOCW" },
    { name: "ROCCU - Roth CH Acquisition II Co", ticker: "ROCCU" },
    { name: "CYTHW - Cyclo Therapeutics, Inc.", ticker: "CYTHW" },
    { name: "DGAZF - CREDIT SUISSE AG", ticker: "DGAZF" },
    { name: "PTEOD - PROTEO INC", ticker: "PTEOD" },
    { name: "MGHLD - MORGAN GROUP HOLDING CO", ticker: "MGHLD" },
    { name: "RTWI - RTW Retailwinds, Inc.", ticker: "RTWI" },
    { name: "SIGIP - SELECTIVE INSURANCE GROUP INC", ticker: "SIGIP" },
    { name: "XOMAP - XOMA Corp", ticker: "XOMAP" },
    { name: "CSR-PC - INVESTORS REAL ESTATE TRUST", ticker: "CSR-PC" },
    { name: "RZZND - Jialijia Group Corp Ltd", ticker: "RZZND" },
    { name: "NRSCX - NEXPOINT REAL ESTATE STRATEGIES FUND", ticker: "NRSCX" },
    { name: "HPMMD - Hemp Naturals, Inc.", ticker: "HPMMD" },
    { name: "ITRKD - Loop Media, Inc.", ticker: "ITRKD" },
    { name: "CCYCD - Clancy Corp", ticker: "CCYCD" },
    { name: "KLMND - Nanovation Microtech, Inc.", ticker: "KLMND" },
    { name: "PFALX - PIMCO Flexible Credit Income Fund", ticker: "PFALX" },
    { name: "LBRDP - Liberty Broadband Corp", ticker: "LBRDP" },
    { name: "MPMQ - MPM Holdings Inc.", ticker: "MPMQ" },
    { name: "AFINO - American Finance Trust, Inc", ticker: "AFINO" },
    { name: "MPLXP - MPLX LP", ticker: "MPLXP" },
    { name: "FGFPP - FG Financial Group, Inc.", ticker: "FGFPP" },
    { name: "MSFIX - Destra Multi-Alternative Fund", ticker: "MSFIX" },
    { name: "MSFYX - Destra Multi-Alternative Fund", ticker: "MSFYX" },
    { name: "SPOXD - SPROTT INC.", ticker: "SPOXD" },
    { name: "LTCFX - Alternative Strategies Fund", ticker: "LTCFX" },
    { name: "LTIFX - Alternative Strategies Fund", ticker: "LTIFX" },
    { name: "AHCPD - Changsheng International Group Ltd", ticker: "AHCPD" },
    { name: "BETRD - BetterLife Pharma Inc.", ticker: "BETRD" },
    { name: "IMLED - SOBR Safe, Inc.", ticker: "IMLED" },
    { name: "GMGID - Golden Matrix Group, Inc.", ticker: "GMGID" },
    { name: "URALD - UNITED RAIL, INC.", ticker: "URALD" },
    { name: "POTGD - Portage Resources Inc.", ticker: "POTGD" },
    { name: "SFORD - StrikeForce Technologies Inc.", ticker: "SFORD" },
    { name: "SBNYP - Signature Bank Corp", ticker: "SBNYP" },
    { name: "QRTEP - Qurate Retail, Inc.", ticker: "QRTEP" },
    { name: "DUFRY - Dufry AG/ADR", ticker: "DUFRY" },
    { name: "MODV - ModivCare Inc", ticker: "MODV" },
    { name: "DNMR - Danimer Scientific, Inc.", ticker: "DNMR" },
    { name: "GRCL - Gracell Biotechnologies Inc.", ticker: "GRCL" },
    { name: "GNOG - Golden Nugget Online Gaming, Inc.", ticker: "GNOG" },
    { name: "PRCH - Porch Group, Inc.", ticker: "PRCH" },
    { name: "CGEM - Cullinan Management, Inc.", ticker: "CGEM" },
    { name: "ASLE - AerSale Corp", ticker: "ASLE" },
    { name: "DGRLY - Delek Group, Ltd.", ticker: "DGRLY" },
    { name: "VINC - Vincera Pharma, Inc.", ticker: "VINC" },
    { name: "LHC - Leo Holdings Corp. II", ticker: "LHC" },
    { name: "VREOF - Vireo Health International, Inc.", ticker: "VREOF" },
    { name: "BRPM - B. Riley Principal 150 Merger Corp.", ticker: "BRPM" },
    { name: "GBS - GBS Inc.", ticker: "GBS" },
    { name: "LFT - Hunt Companies Finance Trust, Inc.", ticker: "LFT" },
    { name: "PFX - PhenixFIN Corp", ticker: "PFX" },
    { name: "GEG - Great Elm Group, Inc.", ticker: "GEG" },
    { name: "DUSYF - DUESENBERG TECHNOLOGIES INC.", ticker: "DUSYF" },
    { name: "ALACU - Alberton Acquisition Corp", ticker: "ALACU" },
    { name: "STBI - STURGIS BANCORP INC", ticker: "STBI" },
    { name: "ELDN - Eledon Pharmaceuticals, Inc.", ticker: "ELDN" },
    { name: "NCPL - Netcapital Inc.", ticker: "NCPL" },
    { name: "STRR - DIGIRAD CORP", ticker: "STRR" },
    { name: "BRRN - Born, Inc.", ticker: "BRRN" },
    { name: "WSFT - WIKISOFT CORP.", ticker: "WSFT" },
    { name: "ENVB - Enveric Biosciences, Inc.", ticker: "ENVB" },
    { name: "SWET - Athlon Acquisition Corp.", ticker: "SWET" },
    { name: "SITS - SOUTHERN ITS INTERNATIONAL, INC.", ticker: "SITS" },
    { name: "AHIXD - ALUF HOLDINGS, INC.", ticker: "AHIXD" },
    { name: "AAWC - Canning Street Corp", ticker: "AAWC" },
    { name: "NXPC - NEXPLORE Corp", ticker: "NXPC" },
    { name: "CWEN.A - Clearway Energy, Inc.", ticker: "CWEN.A" },
    { name: "LVVR - Lightstone Value Plus Real Estate Investment Trust III, Inc.", ticker: "LVVR" },
    { name: "LVVP - Lightstone Value Plus Real Estate Investment Trust V, Inc.", ticker: "LVVP" },
    { name: "FTFC - First Trinity Financial CORP", ticker: "FTFC" },
    { name: "KIDZ - KIDOZ INC.", ticker: "KIDZ" },
    { name: "BNPZY - BNP PARIBAS", ticker: "BNPZY" },
    { name: "GTN.A - GRAY TELEVISION INC", ticker: "GTN.A" },
    { name: "ONTF - ON24 INC", ticker: "ONTF" },
    { name: "MPH - MEDICURE INC", ticker: "MPH" },
    { name: "ENVI - Environmental Impact Acquisition Corp", ticker: "ENVI" },
    { name: "PACX - Pioneer Merger Corp.", ticker: "PACX" },
    { name: "NAAC - North Atlantic Acquisition Corp", ticker: "NAAC" },
    { name: "DHHC - DiamondHead Holdings Corp.", ticker: "DHHC" },
    { name: "STPC - Star Peak Corp II", ticker: "STPC" },
    { name: "OCDX - Ortho Clinical Diagnostics Holdings plc", ticker: "OCDX" },
    { name: "SVFA - SVF Investment Corp.", ticker: "SVFA" },
    { name: "RLX - RLX Technology Inc.", ticker: "RLX" },
    { name: "PLTK - Playtika Holding Corp.", ticker: "PLTK" },
    { name: "CFV - CF Acquisition Corp. V", ticker: "CFV" },
    { name: "ROT - Rotor Acquisition Corp.", ticker: "ROT" },
    { name: "CGNT - Cognyte Software Ltd.", ticker: "CGNT" },
    { name: "VINP - Vinci Partners Investments Ltd.", ticker: "VINP" },
    { name: "PPGH - POEMA Global Holdings Corp.", ticker: "PPGH" },
    { name: "PRSR - Prospector Capital Corp.", ticker: "PRSR" },
    { name: "CSTA - Constellation Acquisition Corp I", ticker: "CSTA" },
    { name: "DCRN - Decarbonization Plus Acquisition Corp II", ticker: "DCRN" },
    { name: "GMBT - Queen's Gambit Growth Capital", ticker: "GMBT" },
    { name: "SPNG - Spinning Eagle Acquisition Corp.", ticker: "SPNG" },
    { name: "RMGC - RMG Acquisition Corp. III", ticker: "RMGC" },
    { name: "APGB - Apollo Strategic Growth Capital II", ticker: "APGB" },
    { name: "CAHC - CA Healthcare Acquisition Corp.", ticker: "CAHC" },
    { name: "MCAD - Mountain Crest Acquisition Corp II", ticker: "MCAD" },
    { name: "PAQC - Provident Acquisition Corp.", ticker: "PAQC" },
    { name: "TBA - Thoma Bravo Advantage", ticker: "TBA" },
    { name: "EUSG - European Sustainable Growth Acquisition Corp.", ticker: "EUSG" },
    { name: "FORE - Foresight Acquisition Corp.", ticker: "FORE" },
    { name: "KUKE - Kuke Music Holding Ltd", ticker: "KUKE" },
    { name: "DRVN - Driven Brands Holdings Inc.", ticker: "DRVN" },
    { name: "CLOV - Social Capital Hedosophia Holdings Corp. III", ticker: "CLOV" },
    { name: "PV - Primavera Capital Acquisition Corp.", ticker: "PV" },
    { name: "IVAN - Ivanhoe Capital Acquisition Corp.", ticker: "IVAN" },
    { name: "MSGM - MOTORSPORT GAMING US LLC", ticker: "MSGM" },
    { name: "LSEA - Landsea Homes Corp", ticker: "LSEA" },
    { name: "BMTX - BM Technologies, Inc.", ticker: "BMTX" },
    { name: "FNB-PE - FNB CORP/PA/", ticker: "FNB-PE" },
    { name: "TCMFF - TELECOM ARGENTINA SA", ticker: "TCMFF" },
    { name: "TEKK - Tekkorp Digital Acquisition Corp.", ticker: "TEKK" },
    { name: "LHC-UN - Leo Holdings Corp. II", ticker: "LHC-UN" },
    { name: "EUCR - Eucrates Biomedical Acquisition Corp.", ticker: "EUCR" },
    { name: "PETVD - PetVivo Holdings, Inc.", ticker: "PETVD" },
    { name: "TRNFD - Taronis Fuels, Inc.", ticker: "TRNFD" },
    { name: "TLFE - CANNAPOWDER, INC.", ticker: "TLFE" },
    { name: "CRBOD - Carbon Energy Corp", ticker: "CRBOD" },
    { name: "RSPID - RespireRx Pharmaceuticals Inc.", ticker: "RSPID" },
    { name: "SRCOD - SPARTA COMMERCIAL SERVICES, INC.", ticker: "SRCOD" },
    { name: "VITX - GH Capital Inc.", ticker: "VITX" },
    { name: "ABCED - ABCO Energy, Inc.", ticker: "ABCED" },
    { name: "NXPCD - NEXPLORE Corp", ticker: "NXPCD" },
    { name: "AAWCD - Canning Street Corp", ticker: "AAWCD" },
    { name: "BMTX-WT - BM Technologies, Inc.", ticker: "BMTX-WT" },
    { name: "LSEAW - Landsea Homes Corp", ticker: "LSEAW" },
    { name: "UGROD - urban-gro, Inc.", ticker: "UGROD" },
    { name: "DNMR-WT - Danimer Scientific, Inc.", ticker: "DNMR-WT" },
    { name: "ALTG-PA - ALTA EQUIPMENT GROUP INC.", ticker: "ALTG-PA" },
    { name: "RMO-WT - Romeo Power, Inc.", ticker: "RMO-WT" },
    { name: "BCYPU - Big Cypress Acquisition Corp.", ticker: "BCYPU" },
    { name: "PAQCU - Provident Acquisition Corp.", ticker: "PAQCU" },
    { name: "MCADU - Mountain Crest Acquisition Corp II", ticker: "MCADU" },
    { name: "PPGHU - POEMA Global Holdings Corp.", ticker: "PPGHU" },
    { name: "VIIAU - 7GC & Co. Holdings Inc.", ticker: "VIIAU" },
    { name: "TSIAW - TS Innovation Acquisitions Corp.", ticker: "TSIAW" },
    { name: "CRU-UN - Crucible Acquisition Corp", ticker: "CRU-UN" },
    { name: "PRSRU - Prospector Capital Corp.", ticker: "PRSRU" },
    { name: "DMYI-WT - dMY Technology Group, Inc. III", ticker: "DMYI-WT" },
    { name: "ROCCW - Roth CH Acquisition II Co", ticker: "ROCCW" },
    { name: "FVT-UN - Fortress Value Acquisition Corp. III", ticker: "FVT-UN" },
    { name: "STPC-UN - Star Peak Corp II", ticker: "STPC-UN" },
    { name: "INKAU - KLUDEIN I ACQUISITION CORP", ticker: "INKAU" },
    { name: "RTPZ-WT - Reinvent Technology Partners Z", ticker: "RTPZ-WT" },
    { name: "RSVAW - Rodgers Silicon Valley Acquisition Corp", ticker: "RSVAW" },
    { name: "SVFAU - SVF Investment Corp.", ticker: "SVFAU" },
    { name: "ZNTEW - Zanite Acquisition Corp.", ticker: "ZNTEW" },
    { name: "LNFA-WT - L&F Acquisition Corp.", ticker: "LNFA-WT" },
    { name: "VTIQU - VectoIQ Acquisition Corp. II", ticker: "VTIQU" },
    { name: "ARKOW - ARKO Corp.", ticker: "ARKOW" },
    { name: "VHAQ-UN - Viveon Health Acquisition Corp.", ticker: "VHAQ-UN" },
    { name: "ARBGW - Aequi Acquisition Corp.", ticker: "ARBGW" },
    { name: "EUCRW - Eucrates Biomedical Acquisition Corp.", ticker: "EUCRW" },
    { name: "CLNNW - Clene Inc.", ticker: "CLNNW" },
    { name: "PIPP-WT - Pine Island Acquisition Corp.", ticker: "PIPP-WT" },
    { name: "TEKKW - Tekkorp Digital Acquisition Corp.", ticker: "TEKKW" },
    { name: "TMKRU - Tastemaker Acquisition Corp.", ticker: "TMKRU" },
    { name: "BREZR - Breeze Holdings Acquisition Corp.", ticker: "BREZR" },
    { name: "BREZW - Breeze Holdings Acquisition Corp.", ticker: "BREZW" },
    { name: "CFACW - CF Finance Acquisition Corp. III", ticker: "CFACW" },
    { name: "IVAN-UN - Ivanhoe Capital Acquisition Corp.", ticker: "IVAN-UN" },
    { name: "VCKAU - Vickers Vantage Corp. I", ticker: "VCKAU" },
    { name: "BWACW - Better World Acquisition Corp.", ticker: "BWACW" },
    { name: "RSI-WT - Rush Street Interactive, Inc.", ticker: "RSI-WT" },
    { name: "CLOVW - Social Capital Hedosophia Holdings Corp. III", ticker: "CLOVW" },
    { name: "RADIW - Radius Global Infrastructure, Inc.", ticker: "RADIW" },
    { name: "BNKD - BANK OF MONTREAL /CAN/", ticker: "BNKD" },
    { name: "BNKU - BANK OF MONTREAL /CAN/", ticker: "BNKU" },
    { name: "STRRP - DIGIRAD CORP", ticker: "STRRP" },
    { name: "UNCP - UNIT CORP", ticker: "UNCP" },
    { name: "NEXTW - NextDecade Corp.", ticker: "NEXTW" },
    { name: "ATH-PD - Athene Holding Ltd", ticker: "ATH-PD" },
    { name: "NVOOF - Novo Resources Corp.", ticker: "NVOOF" },
    { name: "PFXNL - PhenixFIN Corp", ticker: "PFXNL" },
    { name: "CPNG - Coupang, Inc.", ticker: "CPNG" },
    { name: "ATLCY - ATLAS COPCO AB", ticker: "ATLCY" },
    { name: "STLA - Stellantis N.V.", ticker: "STLA" },
    { name: "OAOFY - PJSC TATNEFT", ticker: "OAOFY" },
    { name: "FERG - Ferguson plc", ticker: "FERG" },
    { name: "XM - Qualtrics International Inc.", ticker: "XM" },
    { name: "CLVT - CLARIVATE Plc", ticker: "CLVT" },
    { name: "TSGTY - TSINGTAO BREWERY CO LTD /FI", ticker: "TSGTY" },
    { name: "SBYSF - Sibanye-Stillwater Limited/ADR", ticker: "SBYSF" },
    { name: "TPL - Texas Pacific Land Corp", ticker: "TPL" },
    { name: "TUYA - Tuya Inc.", ticker: "TUYA" },
    { name: "AXON - AXON ENTERPRISE, INC.", ticker: "AXON" },
    { name: "IBRX - ImmunityBio, Inc.", ticker: "IBRX" },
    { name: "WFG - WEST FRASER TIMBER CO., LTD", ticker: "WFG" },
    { name: "TIXT - TELUS International (Cda) Inc.", ticker: "TIXT" },
    { name: "CHPT - ChargePoint Holdings, Inc.", ticker: "CHPT" },
    { name: "FURCF - FAURECIA/ADR", ticker: "FURCF" },
    { name: "BMBL - Bumble Inc.", ticker: "BMBL" },
    { name: "APA - APA Corp", ticker: "APA" },
    { name: "SANA - Sana Biotechnology, Inc.", ticker: "SANA" },
    { name: "CSAN - Cosan S.A.", ticker: "CSAN" },
    { name: "LDI - loanDepot, Inc.", ticker: "LDI" },
    { name: "MITUY - Mitsui Chemicals Inc", ticker: "MITUY" },
    { name: "COUR - Coursera, Inc.", ticker: "COUR" },
    { name: "SHLS - Shoals Technologies Group, Inc.", ticker: "SHLS" },
    { name: "TCNNF - Trulieve Cannabis Corp.", ticker: "TCNNF" },
    { name: "ACVA - ACV Auctions Inc.", ticker: "ACVA" },
    { name: "TNL - Travel & Leisure Co.", ticker: "TNL" },
    { name: "OSCR - Oscar Health, Inc.", ticker: "OSCR" },
    { name: "FHTF - FHT Future Technology Ltd", ticker: "FHTF" },
    { name: "ZH - Zhihu Inc.", ticker: "ZH" },
    { name: "DSEY - Diversey Holdings, Ltd.", ticker: "DSEY" },
    { name: "VZIO - Vizio Holding Corp.", ticker: "VZIO" },
    { name: "DOCN - DigitalOcean Holdings, Inc.", ticker: "DOCN" },
    { name: "CRCT - Cricut, Inc.", ticker: "CRCT" },
    { name: "OLK - Olink Holding AB (publ)", ticker: "OLK" },
    { name: "OLO - Olo Inc.", ticker: "OLO" },
    { name: "ALHC - Alignment Healthcare, Inc.", ticker: "ALHC" },
    { name: "INNV - InnovAge Holding Corp.", ticker: "INNV" },
    { name: "HAYW - Hayward Holdings, Inc.", ticker: "HAYW" },
    { name: "TIL - Instil Bio, Inc.", ticker: "TIL" },
    { name: "DSP - Viant Technology Inc.", ticker: "DSP" },
    { name: "BFLY - Butterfly Network, Inc.", ticker: "BFLY" },
    { name: "ZIM - ZIM Integrated Shipping Services Ltd.", ticker: "ZIM" },
    { name: "CRLBF - Cresco Labs Inc.", ticker: "CRLBF" },
    { name: "THNPY - Technip Energies N.V.", ticker: "THNPY" },
    { name: "HIMS - Hims & Hers Health, Inc.", ticker: "HIMS" },
    { name: "AEVA - Aeva Technologies, Inc.", ticker: "AEVA" },
    { name: "MYTE - MYT Netherlands Parent B.V.", ticker: "MYTE" },
    { name: "DFH - Dream Finders Homes, Inc.", ticker: "DFH" },
    { name: "PAX - Patria Investments Ltd", ticker: "PAX" },
    { name: "NUVB - Nuvation Bio Inc.", ticker: "NUVB" },
    { name: "ETWO - E2open Parent Holdings, Inc.", ticker: "ETWO" },
    { name: "RAAS - Cloopen Group Holding Ltd", ticker: "RAAS" },
    { name: "OILY - Sino American Oil Co", ticker: "OILY" },
    { name: "TDUP - ThredUp Inc.", ticker: "TDUP" },
    { name: "SNCY - Sun Country Airlines Holdings, Inc.", ticker: "SNCY" },
    { name: "NAPA - Duckhorn Portfolio, Inc.", ticker: "NAPA" },
    { name: "IMCR - Immunocore Holdings plc", ticker: "IMCR" },
    { name: "APPH - AppHarvest, Inc.", ticker: "APPH" },
    { name: "DSGN - Design Therapeutics, Inc.", ticker: "DSGN" },
    { name: "SPNT - SiriusPoint Ltd", ticker: "SPNT" },
    { name: "SEMR - SEMrush Holdings, Inc.", ticker: "SEMR" },
    { name: "VIEW - View, Inc.", ticker: "VIEW" },
    { name: "VOR - Vor Biopharma Inc.", ticker: "VOR" },
    { name: "EWTX - Edgewise Therapeutics, Inc.", ticker: "EWTX" },
    { name: "SCR - Score Media & Gaming Inc.", ticker: "SCR" },
    { name: "OUST - Ouster, Inc.", ticker: "OUST" },
    { name: "JWSM - Jaws Mustang Acquisition Corp", ticker: "JWSM" },
    { name: "DCOM - Dime Community Bancshares, Inc. /NY/", ticker: "DCOM" },
    { name: "AAC - Ares Acquisition Corp", ticker: "AAC" },
    { name: "AYRWF - Ayr Wellness Inc.", ticker: "AYRWF" },
    { name: "VADP - VADO CORP.", ticker: "VADP" },
    { name: "BOLT - Bolt Biotherapeutics, Inc.", ticker: "BOLT" },
    { name: "PYR - PyroGenesis Canada Inc.", ticker: "PYR" },
    { name: "CNTB - Connect Biopharma Holdings Ltd", ticker: "CNTB" },
    { name: "CPUH - Compute Health Acquisition Corp.", ticker: "CPUH" },
    { name: "LCA - Landcadia Holdings IV, Inc.", ticker: "LCA" },
    { name: "APR - Apria, Inc.", ticker: "APR" },
    { name: "IKNA - Ikena Oncology, Inc.", ticker: "IKNA" },
    { name: "MMEDF - Mind Medicine (MindMed) Inc.", ticker: "MMEDF" },
    { name: "PHVS - Pharvaris N.V.", ticker: "PHVS" },
    { name: "CMGR - Clubhouse Media Group, Inc.", ticker: "CMGR" },
    { name: "LGORD - Largo Resources Ltd.", ticker: "LGORD" },
    { name: "BVS - Bioventus Inc.", ticker: "BVS" },
    { name: "DELKY - Delek Group, Ltd.", ticker: "DELKY" },
    { name: "HUTMF - HUT 8 MINING CORP.", ticker: "HUTMF" },
    { name: "RNGTF - Osisko Development Corp.", ticker: "RNGTF" },
    { name: "ASXC - ASENSUS SURGICAL, INC.", ticker: "ASXC" },
    { name: "FNCH - Finch Therapeutics Group, Inc.", ticker: "FNCH" },
    { name: "ADAG - Adagene Inc.", ticker: "ADAG" },
    { name: "RXDX - Prometheus Biosciences, Inc.", ticker: "RXDX" },
    { name: "KCAC - Kensington Capital Acquisition Corp. II", ticker: "KCAC" },
    { name: "ACHL - Achilles Therapeutics plc", ticker: "ACHL" },
    { name: "ZEPP - Zepp Health Corp", ticker: "ZEPP" },
    { name: "UNTC - UNIT CORP", ticker: "UNTC" },
    { name: "ACTC - ArcLight Clean Transition Corp.", ticker: "ACTC" },
    { name: "ADN - ADVENT TECHNOLOGIES HOLDINGS, INC.", ticker: "ADN" },
    { name: "SPAQ - Spartan Acquisition Corp. III", ticker: "SPAQ" },
    { name: "MIT - Mason Industrial Technology, Inc.", ticker: "MIT" },
    { name: "GMTX - Gemini Therapeutics, Inc. /DE", ticker: "GMTX" },
    { name: "PLBY - PLBY Group, Inc.", ticker: "PLBY" },
    { name: "VAQC - Vector Acquisition Corp II", ticker: "VAQC" },
    { name: "KVSC - Khosla Ventures Acquisition Co. III", ticker: "KVSC" },
    { name: "ANGN - Angion Biomedica Corp.", ticker: "ANGN" },
    { name: "GMII - Gores Metropoulos II, Inc.", ticker: "GMII" },
    { name: "TERN - Terns Pharmaceuticals, Inc.", ticker: "TERN" },
    { name: "DGNU - Dragoneer Growth Opportunities Corp. III", ticker: "DGNU" },
    { name: "HHLA - HH&L Acquisition Co.", ticker: "HHLA" },
    { name: "NSTB - Northern Star Investment Corp. II", ticker: "NSTB" },
    { name: "TLGA - TLG Acquisition One Corp.", ticker: "TLGA" },
    { name: "HYAC - Haymaker Acquisition Corp. III", ticker: "HYAC" },
    { name: "ACAM - Acamar Partners Acquisition Corp. II", ticker: "ACAM" },
    { name: "LHDX - Lucira Health, Inc.", ticker: "LHDX" },
    { name: "REPX - Riley Exploration Permian, Inc.", ticker: "REPX" },
    { name: "KVSA - Khosla Ventures Acquisition Co.", ticker: "KVSA" },
    { name: "YELL - Yellow Corp", ticker: "YELL" },
    { name: "SNSE - Sensei Biotherapeutics, Inc.", ticker: "SNSE" },
    { name: "FWAA - Fifth Wall Acquisition Corp. I", ticker: "FWAA" },
    { name: "NEXI - NexImmune, Inc.", ticker: "NEXI" },
    { name: "ATMR - Altimar Acquisition Corp. II", ticker: "ATMR" },
    { name: "BPIRY - Piraeus Bank S.A.", ticker: "BPIRY" },
    { name: "GSQD - G Squared Ascend I Inc.", ticker: "GSQD" },
    { name: "JCIC - Jack Creek Investment Corp.", ticker: "JCIC" },
    { name: "SVFC - SVF Investment Corp. 3", ticker: "SVFC" },
    { name: "KVSB - Khosla Ventures Acquisition Co. II", ticker: "KVSB" },
    { name: "JOAN - JOANN Inc.", ticker: "JOAN" },
    { name: "LFMD - LifeMD, Inc.", ticker: "LFMD" },
    { name: "ALTO - Alto Ingredients, Inc.", ticker: "ALTO" },
    { name: "TRIN - Trinity Capital Inc.", ticker: "TRIN" },
    { name: "SWBK - Switchback II Corp", ticker: "SWBK" },
    { name: "LVTX - LAVA Therapeutics NV", ticker: "LVTX" },
    { name: "CRGE - Charge Enterprises, Inc.", ticker: "CRGE" },
    { name: "LABP - Landos Biopharma, Inc.", ticker: "LABP" },
    { name: "GXGX - GX Acquisition Corp.", ticker: "GXGX" },
    { name: "ENFA - 890 5th Avenue Partners, Inc.", ticker: "ENFA" },
    { name: "IMCC - IM Cannabis Corp.", ticker: "IMCC" },
    { name: "TZPS - TZP Strategies Acquisition Corp.", ticker: "TZPS" },
    { name: "VIRX - Viracta Therapeutics, Inc.", ticker: "VIRX" },
    { name: "ADER - 26 Capital Acquisition Corp.", ticker: "ADER" },
    { name: "EAC - Edify Acquisition Corp.", ticker: "EAC" },
    { name: "TLIS - Talis Biomedical Corp", ticker: "TLIS" },
    { name: "CMMB - Chemomab Therapeutics Ltd.", ticker: "CMMB" },
    { name: "SVFB - SVF Investment Corp. 2", ticker: "SVFB" },
    { name: "PPTA - PERPETUA RESOURCES CORP.", ticker: "PPTA" },
    { name: "AFCG - AFC Gamma, Inc.", ticker: "AFCG" },
    { name: "BIOT - Biotech Acquisition Co", ticker: "BIOT" },
    { name: "LBPH - Longboard Pharmaceuticals, Inc.", ticker: "LBPH" },
    { name: "DBTX - Decibel Therapeutics, Inc.", ticker: "DBTX" },
    { name: "HYW - Hywin Holdings Ltd.", ticker: "HYW" },
    { name: "ACAC - Acies Acquisition Corp.", ticker: "ACAC" },
    { name: "HCAQ - HealthCor Catalio Acquisition Corp.", ticker: "HCAQ" },
    { name: "LEGO - Legato Merger Corp.", ticker: "LEGO" },
    { name: "FSII - FS Development Corp. II", ticker: "FSII" },
    { name: "AGFY - Agrify Corp", ticker: "AGFY" },
    { name: "SCM - Stellus Capital Investment Corp", ticker: "SCM" },
    { name: "AMCI - AMCI Acquisition Corp. II", ticker: "AMCI" },
    { name: "AMR - Alpha Metallurgical Resources, Inc.", ticker: "AMR" },
    { name: "NOTV - Inotiv, Inc.", ticker: "NOTV" },
    { name: "GCAC - Growth Capital Acquisition Corp.", ticker: "GCAC" },
    { name: "ARYD - ARYA Sciences Acquisition Corp IV", ticker: "ARYD" },
    { name: "CXEE - China Xuefeng Environmental Engineering Inc.", ticker: "CXEE" },
    { name: "TWOA - two", ticker: "TWOA" },
    { name: "PANA - Panacea Acquisition Corp. II", ticker: "PANA" },
    { name: "ABGI - ABG Acquisition Corp. I", ticker: "ABGI" },
    { name: "NVVE - Nuvve Holding Corp.", ticker: "NVVE" },
    { name: "GROY - Gold Royalty Corp.", ticker: "GROY" },
    { name: "OCAX - OCA Acquisition Corp.", ticker: "OCAX" },
    { name: "CAPA - HighCape Capital Acquisition Corp.", ticker: "CAPA" },
    { name: "MOVE - Movano Inc.", ticker: "MOVE" },
    { name: "BAOS - Baosheng Media Group Holdings Ltd", ticker: "BAOS" },
    { name: "GBNH - Greenbrook TMS Inc.", ticker: "GBNH" },
    { name: "VWTR - VIDLER WATER RESOURCES, INC.", ticker: "VWTR" },
    { name: "GANX - Gain Therapeutics, Inc.", ticker: "GANX" },
    { name: "ZUUS - ZEUUS, INC.", ticker: "ZUUS" },
    { name: "AUGG - AUGUSTA GOLD CORP.", ticker: "AUGG" },
    { name: "FNEC - First National Energy Corp.", ticker: "FNEC" },
    { name: "ROCR - Roth CH Acquisition III Co", ticker: "ROCR" },
    { name: "FURY - FURY GOLD MINES LTD", ticker: "FURY" },
    { name: "BPTS - Biophytis SA", ticker: "BPTS" },
    { name: "TUEM - TUESDAY MORNING CORP/DE", ticker: "TUEM" },
    { name: "MOTN - Motion Acquisition Corp.", ticker: "MOTN" },
    { name: "ADRA - Adara Acquisition Corp.", ticker: "ADRA" },
    { name: "ACR - ACRES Commercial Realty Corp.", ticker: "ACR" },
    { name: "MITC - MeaTech 3D Ltd.", ticker: "MITC" },
    { name: "LGVN - Longeveron Inc.", ticker: "LGVN" },
    { name: "NECB - NorthEast Community Bancorp, Inc./MD/", ticker: "NECB" },
    { name: "VRDN - Viridian Therapeutics, Inc.\\DE", ticker: "VRDN" },
    { name: "EVAX - Evaxion Biotech A/S", ticker: "EVAX" },
    { name: "ISUN - ISUN, INC.", ticker: "ISUN" },
    { name: "FTCO - Fortitude Gold Corp", ticker: "FTCO" },
    { name: "AEI - Alset EHome International Inc.", ticker: "AEI" },
    { name: "BSPE - Bespoke Capital Acquisition Corp", ticker: "BSPE" },
    { name: "SDH - Global Internet of People, Inc.", ticker: "SDH" },
    { name: "CFCX - Centric Financial Corp", ticker: "CFCX" },
    { name: "UNQL - UNIQUE LOGISTICS INTERNATIONAL INC", ticker: "UNQL" },
    { name: "BCAC - Brookline Capital Acquisition Corp.", ticker: "BCAC" },
    { name: "ARHH - Assure Holdings Corp.", ticker: "ARHH" },
    { name: "TDXP - Global Smart Capital Corp.", ticker: "TDXP" },
    { name: "SNBH - SENTIENT BRANDS HOLDINGS INC.", ticker: "SNBH" },
    { name: "LOWLF - Lowell Farms Inc.", ticker: "LOWLF" },
    { name: "CULL - Cullman Bancorp, Inc. /MD/", ticker: "CULL" },
    { name: "SKYE - Skye Bioscience, Inc.", ticker: "SKYE" },
    { name: "LISMF - LITHIUM SOUTH DEVELOPMENT Corp", ticker: "LISMF" },
    { name: "AUUD - AUDDIA INC.", ticker: "AUUD" },
    { name: "SPRCY - SciSparc Ltd./ADR", ticker: "SPRCY" },
    { name: "VLON - Vallon Pharmaceuticals, Inc.", ticker: "VLON" },
    { name: "EDXC - Endexx Corp", ticker: "EDXC" },
    { name: "HLTT - Healthtech Solutions, Inc./UT", ticker: "HLTT" },
    { name: "HLOC - Helo Corp.", ticker: "HLOC" },
    { name: "UGHB - ECARD INC.", ticker: "UGHB" },
    { name: "OTLC - Oncotelic Therapeutics, Inc.", ticker: "OTLC" },
    { name: "TGRP - TRON Group Inc.", ticker: "TGRP" },
    { name: "LMRMF - Lomiko Metals Inc.", ticker: "LMRMF" },
    { name: "HYEX - HEALTHY EXTRACTS INC.", ticker: "HYEX" },
    { name: "LBCMF - Libero Copper & Gold Corp", ticker: "LBCMF" },
    { name: "BVFL - BV Financial, Inc.", ticker: "BVFL" },
    { name: "PSYCF - Duncan Park Holdings Corp", ticker: "PSYCF" },
    { name: "CAWW - CCA INDUSTRIES INC", ticker: "CAWW" },
    { name: "TRXA - Trex Acquisition Corp.", ticker: "TRXA" },
    { name: "SODI - SOLITRON DEVICES INC", ticker: "SODI" },
    { name: "TPPM - TMPOS, INC", ticker: "TPPM" },
    { name: "BYLG - BYLOG GROUP CORP.", ticker: "BYLG" },
    { name: "QIAN - Qiansui International Group Co. Ltd.", ticker: "QIAN" },
    { name: "FDIT - FINDIT, INC.", ticker: "FDIT" },
    { name: "PUGE - PUGET TECHNOLOGIES, INC.", ticker: "PUGE" },
    { name: "ILHMF - International Lithium Corp", ticker: "ILHMF" },
    { name: "PRCX - Phoenix Rising Companies, Inc.", ticker: "PRCX" },
    { name: "SMPR - Standard Metals Processing, Inc.", ticker: "SMPR" },
    { name: "APQT - Appliqate Inc", ticker: "APQT" },
    { name: "AFPW - AlumiFuel Power Corp", ticker: "AFPW" },
    { name: "SSCR - SMSA CRANE ACQUISITION CORP.", ticker: "SSCR" },
    { name: "CIIG - CIIG Merger Corp. II", ticker: "CIIG" },
    { name: "TKXHF - TRACKX HOLDINGS INC", ticker: "TKXHF" },
    { name: "NMLSF - Nova Mentis Life Science Corp.", ticker: "NMLSF" },
    { name: "CYNXF - Cyon Exploration Ltd.", ticker: "CYNXF" },
    { name: "GEGP - GOLD ENTERTAINMENT GROUP INC", ticker: "GEGP" },
    { name: "AVLP - AVALANCHE INTERNATIONAL, CORP.", ticker: "AVLP" },
    { name: "ZHUD - VANGOLD MINING CORP.", ticker: "ZHUD" },
    { name: "CWNR - Crosswind Renewable Energy Corp", ticker: "CWNR" },
    { name: "MRJT - 3D MAKERJET, INC.", ticker: "MRJT" },
    { name: "LBTD - Lotus Biotech Development Corp.", ticker: "LBTD" },
    { name: "VSYM - VIEW SYSTEMS INC", ticker: "VSYM" },
    { name: "TTSI - TACTICAL SERVICES INC", ticker: "TTSI" },
    { name: "HSTA - Hestia Insight Inc.", ticker: "HSTA" },
    { name: "IMGL - Image International Group, Inc.", ticker: "IMGL" },
    { name: "ELRA - ELRAY RESOURCES, INC.", ticker: "ELRA" },
    { name: "HENC - Hero Technologies Inc.", ticker: "HENC" },
    { name: "WTCG - W Technologies, Inc.", ticker: "WTCG" },
    { name: "TSPG - TGI Solar Power Group Inc.", ticker: "TSPG" },
    { name: "RCMW - RCMW Group, Inc.", ticker: "RCMW" },
    { name: "QTGI - QUARK TECHNOLOGY GLOBAL INC.", ticker: "QTGI" },
    { name: "TMLL - NEXPLORE Corp", ticker: "TMLL" },
    { name: "WEBB - Web Blockchain Media, Inc.", ticker: "WEBB" },
    { name: "GHST - GHST World Inc.", ticker: "GHST" },
    { name: "ADGS - ADGS Advisory, Inc.", ticker: "ADGS" },
    { name: "DPSM - 3D PIONEER SYSTEMS, INC.", ticker: "DPSM" },
    { name: "CBKCQ - CHRISTOPHER & BANKS CORP", ticker: "CBKCQ" },
    { name: "VCBDQ - Vitalibis, Inc.", ticker: "VCBDQ" },
    { name: "CHAA - Catcha Investment Corp", ticker: "CHAA" },
    { name: "CANX - CannAwake Corp", ticker: "CANX" },
    { name: "LOGX - PeerLogix, Inc.", ticker: "LOGX" },
    { name: "LTSC - LIGHTSCAPE TECHNOLOGIES INC.", ticker: "LTSC" },
    { name: "MEDD - MEDICAL IMAGING CORP.", ticker: "MEDD" },
    { name: "ELED - ExeLED Holdings Inc.", ticker: "ELED" },
    { name: "NUVI - Emo Capital Corp.", ticker: "NUVI" },
    { name: "FDOC - FUEL DOCTOR HOLDINGS, INC.", ticker: "FDOC" },
    { name: "VDXI - WebSafety, Inc.", ticker: "VDXI" },
    { name: "RCHA - Rich Pharmaceuticals, Inc.", ticker: "RCHA" },
    { name: "FRHV - Fresh Harvest Products, Inc.", ticker: "FRHV" },
    { name: "MMMW - MASS MEGAWATTS WIND POWER INC", ticker: "MMMW" },
    { name: "SPLY - SocialPlay USA, Inc.", ticker: "SPLY" },
    { name: "NECA - NEW AMERICA ENERGY CORP.", ticker: "NECA" },
    { name: "PBAJ - PETRO USA, INC.", ticker: "PBAJ" },
    { name: "DTHR - DTHERA SCIENCES", ticker: "DTHR" },
    { name: "BMXC - Bemax, Inc.", ticker: "BMXC" },
    { name: "NXNN - NEXEON MEDSYSTEMS INC", ticker: "NXNN" },
    { name: "CSTC - Canning Street Corp", ticker: "CSTC" },
    { name: "RDAR - RAADR, INC.", ticker: "RDAR" },
    { name: "ECEZ - ECOSCIENCES, INC.", ticker: "ECEZ" },
    { name: "GYST - GRAYSTONE COMPANY, INC.", ticker: "GYST" },
    { name: "MOMT - MoneyOnMobile, Inc.", ticker: "MOMT" },
    { name: "AEPTD - American Energy Partners, Inc.", ticker: "AEPTD" },
    { name: "IGSC - IGS Capital Group Ltd", ticker: "IGSC" },
    { name: "COUV - CORPORATE UNIVERSE INC", ticker: "COUV" },
    { name: "MNIZ - Gen 2 Technologies Inc.", ticker: "MNIZ" },
    { name: "STSC - Start Scientific, Inc.", ticker: "STSC" },
    { name: "AHAD - ALPHACOM HOLDINGS INC", ticker: "AHAD" },
    { name: "WRMK - Watermark Lodging Trust, Inc.", ticker: "WRMK" },
    { name: "OPLF - OPTILEAF, INC.", ticker: "OPLF" },
    { name: "TMCI - TREACE MEDICAL CONCEPTS, INC.", ticker: "TMCI" },
    { name: "RPHM - Reneo Pharmaceuticals, Inc.", ticker: "RPHM" },
    { name: "ULCC - Frontier Group Holdings, Inc.", ticker: "ULCC" },
    { name: "DECI - DECIPHER BIOSCIENCES, INC.", ticker: "DECI" },
    { name: "COIN - Coinbase Global, Inc.", ticker: "COIN" },
    { name: "LMDX - LumiraDx Ltd", ticker: "LMDX" },
    { name: "IDAI - T Stamp Inc", ticker: "IDAI" },
    { name: "AKYA - Akoya Biosciences, Inc.", ticker: "AKYA" },
    { name: "INSD - Mikrocoze Inc.", ticker: "INSD" },
    { name: "CRKM - Crank Media Inc", ticker: "CRKM" },
    { name: "SCTH - Securetech Innovations, Inc.", ticker: "SCTH" },
    { name: "JENGQ - Just Energy Group Inc.", ticker: "JENGQ" },
    { name: "TRLC - TriLinc Global Impact Fund LLC", ticker: "TRLC" },
    { name: "CTBO - Cantabio Pharmaceuticals Inc.", ticker: "CTBO" },
    { name: "AOIX - American Oil & Gas Inc.", ticker: "AOIX" },
    { name: "ALKT - ALKAMI TECHNOLOGY, INC.", ticker: "ALKT" },
    { name: "NPCE - NeuroPace Inc", ticker: "NPCE" },
    { name: "CNIC - CION Investment Corp", ticker: "CNIC" },
    { name: "RXRX - RECURSION PHARMACEUTICALS, INC.", ticker: "RXRX" },
    { name: "GIGW - GigWorld Inc.", ticker: "GIGW" },
    { name: "COMP - Compass, Inc.", ticker: "COMP" },
    { name: "VYNT - CANCER GENETICS, INC", ticker: "VYNT" },
    { name: "LXX - Lexaria Bioscience Corp.", ticker: "LXX" },
    { name: "CERP - Cereplast Inc", ticker: "CERP" },
    { name: "FRST - Primis Financial Corp.", ticker: "FRST" },
    { name: "NSAL - Navios South American Logistics Inc.", ticker: "NSAL" },
    { name: "KLTR - KALTURA INC", ticker: "KLTR" },
    { name: "UNSS - UNIVERSAL SOLAR TECHNOLOGY, INC.", ticker: "UNSS" },
    { name: "NPFC - Newpoint Financial Corp", ticker: "NPFC" },
    { name: "SFLM - Sun Kissed Industries, Inc.", ticker: "SFLM" },
    { name: "MTWO - Troika Media Group, Inc.", ticker: "MTWO" },
    { name: "WGTG - WINGS & THINGS INC", ticker: "WGTG" },
    { name: "BTX - Brooklyn ImmunoTherapeutics, Inc.", ticker: "BTX" },
    { name: "SYQH - Evergreen International Corp.", ticker: "SYQH" },
    { name: "TSP - TuSimple Holdings Inc.", ticker: "TSP" },
    { name: "JXN - Jackson Financial Inc.", ticker: "JXN" },
    { name: "HHGC - HHG Capital Corp", ticker: "HHGC" },
    { name: "VOSO - Virtuoso Acquisition Corp.", ticker: "VOSO" },
    { name: "GBRG - Goldenbridge Acquisition Ltd", ticker: "GBRG" },
    { name: "AACP - Aeon Acquisition Corp", ticker: "AACP" },
    { name: "HCXX - Healthcare Merger Corp. II", ticker: "HCXX" },
    { name: "SCAQ - Stratim Cloud Acquisition Corp.", ticker: "SCAQ" },
    { name: "OGN - Organon & Co.", ticker: "OGN" },
    { name: "ATAC - ALTIMAR ACQUISITION CORP.", ticker: "ATAC" },
    { name: "KIII - Kismet Acquisition Three Corp.", ticker: "KIII" },
    { name: "SPKB - Silver Spike Acquisition Corp II", ticker: "SPKB" },
    { name: "KAII - Kismet Acquisition Two Corp.", ticker: "KAII" },
    { name: "OTII - Osprey Technology Acquisition Corp. II", ticker: "OTII" },
    { name: "TWLV - Twelve Seas Investment Co. II", ticker: "TWLV" },
    { name: "DV - DoubleVerify Holdings, Inc.", ticker: "DV" },
    { name: "SKYT - CMI Acquisition, LLC", ticker: "SKYT" },
    { name: "GTOO - Graf Acquisition Corp. II", ticker: "GTOO" },
    { name: "HRDG - Huarui International New Material Ltd", ticker: "HRDG" },
    { name: "NPAB - New Providence Acquisition Corp. II", ticker: "NPAB" },
    { name: "SWSS - Springwater Special Situations Corp.", ticker: "SWSS" },
    { name: "OACA - Ocelot Acquisition Corp I", ticker: "OACA" },
    { name: "CLAA - Colonnade Acquisition Corp. II", ticker: "CLAA" },
    { name: "SLAM - Slam Corp.", ticker: "SLAM" },
    { name: "DHCA - DHC Acquisition Corp.", ticker: "DHCA" },
    { name: "PTOC - Pine Technology Acquisition Corp.", ticker: "PTOC" },
    { name: "SNII - Supernova Partners Acquisition Co II, Ltd.", ticker: "SNII" },
    { name: "STRE - Supernova Partners Acquisition Co III, Ltd.", ticker: "STRE" },
    { name: "SCOB - ScION Tech Growth II", ticker: "SCOB" },
    { name: "NVSA - New Vista Acquisition Corp", ticker: "NVSA" },
    { name: "EJFA - EJF Acquisition Corp.", ticker: "EJFA" },
    { name: "MBAC - M3-Brigade Acquisition II Corp.", ticker: "MBAC" },
    { name: "XPDI - Power & Digital Infrastructure Acquisition Corp.", ticker: "XPDI" },
    { name: "FACT - Freedom Acquisition I Corp.", ticker: "FACT" },
    { name: "GAPA - G&P Acquisition Corp.", ticker: "GAPA" },
    { name: "PFDR - Pathfinder Acquisition Corp", ticker: "PFDR" },
    { name: "DISA - Disruptive Acquisition Corp I", ticker: "DISA" },
    { name: "GLBL - Cartesian Growth Corp", ticker: "GLBL" },
    { name: "BGSX - Build Acquisition Corp.", ticker: "BGSX" },
    { name: "MACQ - MCAP Acquisition Corp", ticker: "MACQ" },
    { name: "LVRA - Levere Holdings Corp.", ticker: "LVRA" },
    { name: "TRAQ - Trine II Acquisition Corp.", ticker: "TRAQ" },
    { name: "EBAC - European Biotech Acquisition Corp.", ticker: "EBAC" },
    { name: "VPCC - VPC Impact Acquisition Holdings III, Inc.", ticker: "VPCC" },
    { name: "ESM - ESM Acquisition Corp", ticker: "ESM" },
    { name: "CENQ - CENAQ Energy Corp.", ticker: "CENQ" },
    { name: "LOKM - Live Oak Mobility Acquisition Corp.", ticker: "LOKM" },
    { name: "ITAQ - Industrial Tech Acquisitions II, Inc.", ticker: "ITAQ" },
    { name: "QNZL - Quinzel Acquisition Co", ticker: "QNZL" },
    { name: "ROSS - Ross Acquisition Corp II", ticker: "ROSS" },
    { name: "ADF - Aldel Financial Inc.", ticker: "ADF" },
    { name: "LIII - Leo Holdings III Corp.", ticker: "LIII" },
    { name: "YTPG - TPG Pace Beneficial II Corp.", ticker: "YTPG" },
    { name: "ANZU - Anzu Special Acquisition Corp I", ticker: "ANZU" },
    { name: "TETC - Tech & Energy Transition Corp", ticker: "TETC" },
    { name: "TPGT - TPG Pace Tech Opportunities II Corp.", ticker: "TPGT" },
    { name: "TPGS - TPG Pace Solutions Corp.", ticker: "TPGS" },
    { name: "LCAA - L Catterton Asia Acquisition Corp", ticker: "LCAA" },
    { name: "ATSP - Archimedes Tech Spac Partners Co", ticker: "ATSP" },
    { name: "GAMC - Golden Arrow Merger Corp.", ticker: "GAMC" },
    { name: "CFFS - CF Acquisition Corp. VII", ticker: "CFFS" },
    { name: "CAIN - Cain Acquisition Corp", ticker: "CAIN" },
    { name: "CFFE - CF Acquisition Corp. VIII", ticker: "CFFE" },
    { name: "FTEV - FinTech Evolution Acquisition Group", ticker: "FTEV" },
    { name: "IPVA - InterPrivate II Acquisition Corp.", ticker: "IPVA" },
    { name: "IPVF - InterPrivate III Financial Partners Inc.", ticker: "IPVF" },
    { name: "IPVI - InterPrivate IV InfraTech Partners Inc.", ticker: "IPVI" },
    { name: "FZT - FAST Acquisition Corp. II", ticker: "FZT" },
    { name: "JBI - Janus Parent, Inc.", ticker: "JBI" },
    { name: "FTPA - FTAC Parnassus Acquisition Corp.", ticker: "FTPA" },
    { name: "DTOC - Digital Transformation Opportunities Corp.", ticker: "DTOC" },
    { name: "FRXB - Forest Road Acquisition Corp. II", ticker: "FRXB" },
    { name: "WALD - Waldencast Acquisition Corp.", ticker: "WALD" },
    { name: "ATHN - Athena Technology Acquisition Corp.", ticker: "ATHN" },
    { name: "PLMI - Plum Acquisition Corp. I", ticker: "PLMI" },
    { name: "TRCA - Twin Ridge Capital Acquisition Corp.", ticker: "TRCA" },
    { name: "ISOS - Isos Acquisition Corp.", ticker: "ISOS" },
    { name: "ASAI - Sendas Distributor S.A.", ticker: "ASAI" },
    { name: "EM - Smart Share Global Ltd", ticker: "EM" },
    { name: "FSRX - Finserv Acquisition Corp. II", ticker: "FSRX" },
    { name: "ALF - Alfi, Inc.", ticker: "ALF" },
    { name: "PSFE - Paysafe Ltd", ticker: "PSFE" },
    { name: "EVOJ - Evo Acquisition Corp", ticker: "EVOJ" },
    { name: "GPAT - GP-Act III Acquisition Corp.", ticker: "GPAT" },
    { name: "GENI - Galileo Newco Ltd", ticker: "GENI" },
    { name: "LEGA - Lead Edge Growth Opportunities, Ltd", ticker: "LEGA" },
    { name: "IGNY - Ignyte Acquisition Corp.", ticker: "IGNY" },
    { name: "SLAC - Social Leverage Acquisition Corp I", ticker: "SLAC" },
    { name: "LEV - Lion Electric Co", ticker: "LEV" },
    { name: "TMAC - Music Acquisition Corp", ticker: "TMAC" },
    { name: "THMA - Thimble Point Acquisition Corp.", ticker: "THMA" },
    { name: "TWNT - Tailwind Two Acquisition Corp.", ticker: "TWNT" },
    { name: "IACB - ION Acquisition Corp 2 Ltd.", ticker: "IACB" },
    { name: "MACA - Moringa Acquisition Corp", ticker: "MACA" },
    { name: "INTM - INTERMEDIA CLOUD COMMUNICATIONS, INC.", ticker: "INTM" },
    { name: "IBER - IBERE PHARMACEUTICALS", ticker: "IBER" },
    { name: "PICC - Pivotal Investment Corp III", ticker: "PICC" },
    { name: "NSTD - Northern Star Investment Corp. IV", ticker: "NSTD" },
    { name: "INVZ - Innoviz Technologies Ltd.", ticker: "INVZ" },
    { name: "NSTC - Northern Star Investment Corp. III", ticker: "NSTC" },
    { name: "AURC - Aurora Acquisition Corp.", ticker: "AURC" },
    { name: "GLBE - Global-E Online Ltd.", ticker: "GLBE" },
    { name: "ARRW - Arrowroot Acquisition Corp.", ticker: "ARRW" },
    { name: "NDAC - NightDragon Acquisition Corp.", ticker: "NDAC" },
    { name: "CENH - Centricus Acquisition Corp.", ticker: "CENH" },
    { name: "GIG - GigCapital4, Inc.", ticker: "GIG" },
    { name: "ICGA - ICG HYPERSONIC ACQUISITION CORP", ticker: "ICGA" },
    { name: "MBTC - Nocturne Acquisition Corp", ticker: "MBTC" },
    { name: "ACQR - Independence Holdings Corp.", ticker: "ACQR" },
    { name: "CMII - CM Life Sciences II Inc.", ticker: "CMII" },
    { name: "IINN - Inspira Technologies OXY B.H.N. Ltd", ticker: "IINN" },
    { name: "PMGM - Priveterra Acquisition Corp.", ticker: "PMGM" },
    { name: "OHPA - Orion Acquisition Corp.", ticker: "OHPA" },
    { name: "WPCB - Warburg Pincus Capital Corp I-B", ticker: "WPCB" },
    { name: "WPCA - Warburg Pincus Capital Corp I-A", ticker: "WPCA" },
    { name: "PUCK - Goal Acquisitions Corp.", ticker: "PUCK" },
    { name: "SPTK - SportsTek Acquisition Corp.", ticker: "SPTK" },
    { name: "ACAH - Atlantic Coastal Acquisition Corp.", ticker: "ACAH" },
    { name: "VECT - VectivBio Holding AG", ticker: "VECT" },
    { name: "AVAC - Avalon Acquisition Inc.", ticker: "AVAC" },
    { name: "MSAC - Medicus Sciences Acquisition Corp.", ticker: "MSAC" },
    { name: "LGAC - Lazard Growth Acquisition Corp. I", ticker: "LGAC" },
    { name: "ASPC - Alpha Capital Acquisition Co", ticker: "ASPC" },
    { name: "SBEA - SILVERBOX ENGAGED MERGER CORP I", ticker: "SBEA" },
    { name: "DMYQ - dMY Technology Group, Inc. IV", ticker: "DMYQ" },
    { name: "SZZL - Sizzle Acquisition Corp.", ticker: "SZZL" },
    { name: "ETA - Integrated Energy Transition Acquisition Corp.", ticker: "ETA" },
    { name: "ANAC - ARCTOS NORTHSTAR ACQUISITION CORP.", ticker: "ANAC" },
    { name: "MON - Monument Circle Acquisition Corp.", ticker: "MON" },
    { name: "NXU - Novus Capital Corp II", ticker: "NXU" },
    { name: "LICY - Li-Cycle Holdings Corp.", ticker: "LICY" },
    { name: "FTCI - FTC Solar, Inc.", ticker: "FTCI" },
    { name: "CCVI - Churchill Capital Corp VI", ticker: "CCVI" },
    { name: "CVII - Churchill Capital Corp VII", ticker: "CVII" },
    { name: "KARO - Karooooo Ltd.", ticker: "KARO" },
    { name: "RTPY - Reinvent Technology Partners Y", ticker: "RTPY" },
    { name: "AEAC - Authentic Equity Acquisition Corp.", ticker: "AEAC" },
    { name: "NGAB - Northern Genesis Acquisition Corp. II", ticker: "NGAB" },
    { name: "CPTK - Crown PropTech Acquisitions", ticker: "CPTK" },
    { name: "AGL - agilon health, inc.", ticker: "AGL" },
    { name: "BITE - Bite Acquisition Corp.", ticker: "BITE" },
    { name: "SRNG - Soaring Eagle Acquisition Corp.", ticker: "SRNG" },
    { name: "QFTA - Quantum FinTech Acquisition Corp", ticker: "QFTA" },
    { name: "ATVC - Tribe Capital Growth Corp I", ticker: "ATVC" },
    { name: "FLME - Flame Acquisition Corp.", ticker: "FLME" },
    { name: "SDHI - Siddhi Acquisition Corp.", ticker: "SDHI" },
    { name: "BDS - Building DreamStar Technology Inc.", ticker: "BDS" },
    { name: "EBET - Esports Technologies, Inc.", ticker: "EBET" },
    { name: "RNAZ - Transcode Therapeutics, Inc.", ticker: "RNAZ" },
    { name: "RGCB - Regencell Bioscience Holdings Ltd", ticker: "RGCB" },
    { name: "IPW - iPower Inc.", ticker: "IPW" },
    { name: "CFVI - CF Acquisition Corp. VI", ticker: "CFVI" },
    { name: "ENNV - ECP Environmental Growth Opportunities Corp.", ticker: "ENNV" },
    { name: "NRAC - Noble Rock Acquisition Corp", ticker: "NRAC" },
    { name: "NBST - Newbury Street Acquisition Corp", ticker: "NBST" },
    { name: "FTAA - FTAC Athena Acquisition Corp.", ticker: "FTAA" },
    { name: "TSIB - Tishman Speyer Innovation Corp. II", ticker: "TSIB" },
    { name: "HZNA - Horizon Acquisition Corp III", ticker: "HZNA" },
    { name: "DRS - Leonardo DRS, Inc.", ticker: "DRS" },
    { name: "RCLF - Rosecliff Acquisition Corp I", ticker: "RCLF" },
    { name: "KRNL - Kernel Group Holdings, Inc.", ticker: "KRNL" },
    { name: "PGRW - Progress Acquisition Corp.", ticker: "PGRW" },
    { name: "KRT - Karat Packaging Inc.", ticker: "KRT" },
    { name: "APP - Applovin Corp", ticker: "APP" },
    { name: "PBLT - PurposeBuilt Brands, Inc.", ticker: "PBLT" },
    { name: "AUGX - Augmedix, Inc.", ticker: "AUGX" },
    { name: "TONY - Tony Fun, Inc.", ticker: "TONY" },
    { name: "FLGC - Flora Growth Corp.", ticker: "FLGC" },
    { name: "CDTG - CDT Environmental Technology Investment Holdings Ltd", ticker: "CDTG" },
    { name: "SKFG - Stark Focus Group, Inc.", ticker: "SKFG" },
    { name: "NXMH - Next Meats Holdings, Inc.", ticker: "NXMH" },
    { name: "GWYGU - Gateway Garage Partners LLC", ticker: "GWYGU" },
    { name: "TGCB - Tego Cyber, Inc.", ticker: "TGCB" },
    { name: "ONS - ONS Acquisition Corp.", ticker: "ONS" },
    { name: "SNTG - Sentage Holdings Inc.", ticker: "SNTG" },
    { name: "OST - Ostin Technology Group Co., Ltd.", ticker: "OST" },
    { name: "CPOP - Pop Culture Group Co., Ltd", ticker: "CPOP" },
    { name: "ITQ - Itiquira Acquisition Corp.", ticker: "ITQ" },
    { name: "VENA - Venus Acquisition Corp", ticker: "VENA" },
    { name: "TWCG - Galliot Acquisition Corp.", ticker: "TWCG" },
    { name: "TWIC - Twist Investment Corp", ticker: "TWIC" },
    { name: "LHRT - Lionheart III CORP", ticker: "LHRT" },
    { name: "LHIV - Lionheart IV CORP", ticker: "LHIV" },
    { name: "BLFY - Blue Foundry Bancorp", ticker: "BLFY" },
    { name: "HCCR - HighCape Capital Acquisition Corp. II", ticker: "HCCR" },
    { name: "HUMC - Anthropos Capital Corp", ticker: "HUMC" },
    { name: "KVSD - Khosla Ventures Acquisition Co. IV", ticker: "KVSD" },
    { name: "CLBR - Colombier Acquisition Corp.", ticker: "CLBR" },
    { name: "TUGC - TradeUP Global Corp", ticker: "TUGC" },
    { name: "TPBA - TPB Acquisition Corp I", ticker: "TPBA" },
    { name: "HCAA - Hony Capital Acquisition Corp.", ticker: "HCAA" },
    { name: "TRTL - TortoiseEcofin Acquisition Corp. III", ticker: "TRTL" },
    { name: "GGPI - Gores Guggenheim, Inc.", ticker: "GGPI" },
    { name: "CEAS - CEA Space Partners I Corp.", ticker: "CEAS" },
    { name: "RMGF - RMG Acquisition Corp. VI", ticker: "RMGF" },
    { name: "RMGE - RMG Acquisition Corp. V", ticker: "RMGE" },
    { name: "RMGG - RMG Acquisition Corp. VII", ticker: "RMGG" },
    { name: "SKYA - SKYDECK ACQUISITION CORP.", ticker: "SKYA" },
    { name: "PEGR - Project Energy Reimagined Acquisition Corp.", ticker: "PEGR" },
    { name: "JACA - Jeneration Acquisition Corp", ticker: "JACA" },
    { name: "BRD - Beard Energy Transition Acquisition Corp.", ticker: "BRD" },
    { name: "TGAA - Target Global Acquisition I Corp.", ticker: "TGAA" },
    { name: "TEKC - Tekkorp Digital Acquisition Corp. II", ticker: "TEKC" },
    { name: "MITA - Coliseum Acquisition Corp.", ticker: "MITA" },
    { name: "RMGD - RMG Acquisition Corp. IV", ticker: "RMGD" },
    { name: "ACCV - Atlas Crest Investment Corp. V", ticker: "ACCV" },
    { name: "ACIV - Atlas Crest Investment Corp. IV", ticker: "ACIV" },
    { name: "FWAB - Fifth Wall Acquisition Corp. II", ticker: "FWAB" },
    { name: "ACCC - Atlas Crest Investment Corp. III", ticker: "ACCC" },
    { name: "BRIM - Brimstone Acquisition Holdings Corp.", ticker: "BRIM" },
    { name: "NTWO - N2 Acquisition Holdings Corp.", ticker: "NTWO" },
    { name: "DOIT - Do It Again Corp.", ticker: "DOIT" },
    { name: "LCW - Learn CW Investment Corp", ticker: "LCW" },
    { name: "SPGL - SPGL Acquisition Corp", ticker: "SPGL" },
    { name: "OUTR - Space Acquisition Corp. I", ticker: "OUTR" },
    { name: "NBAD - New Beginnings Acquisition Corp. III", ticker: "NBAD" },
    { name: "NBAB - New Beginnings Acquisition Corp. II", ticker: "NBAB" },
    { name: "ACRO - Acropolis Infrastructure Acquisition Corp.", ticker: "ACRO" },
    { name: "VIII - Virgin Group Acquisition Corp. III", ticker: "VIII" },
    { name: "DIII - DD3 Acquisition Corp. III", ticker: "DIII" },
    { name: "AACE - Alexandria Agtech/Climate Innovation Acquisition Corp.", ticker: "AACE" },
    { name: "MOOS - Moose Pond Acquisition Corp, NCV I", ticker: "MOOS" },
    { name: "SWBT - Switchback III Corp", ticker: "SWBT" },
    { name: "LOCC - Live Oak Crestview Climate Acquisition Corp.", ticker: "LOCC" },
    { name: "LITT - Logistics Innovation Technologies Corp.", ticker: "LITT" },
    { name: "CPAR - Catalyst Partners Acquisition Corp.", ticker: "CPAR" },
    { name: "OPOT - 1.12 Acquisition Corp", ticker: "OPOT" },
    { name: "DSPQ - Denham Sustainable Performance Acquisition Corp.", ticker: "DSPQ" },
    { name: "CHAB - Catcha Investment Corp 2.0", ticker: "CHAB" },
    { name: "VCXA - 10X Capital Venture Acquisition Corp. II", ticker: "VCXA" },
    { name: "VCXB - 10X Capital Venture Acquisition Corp. III", ticker: "VCXB" },
    { name: "DCRD - Decarbonization Plus Acquisition Corp IV", ticker: "DCRD" },
    { name: "CRUA - Crucible Acquisition Corp. II", ticker: "CRUA" },
    { name: "CRUB - Crucible Acquisition Corp. III", ticker: "CRUB" },
    { name: "ALCC - AltC Acquisition Corp.", ticker: "ALCC" },
    { name: "ODAC - Ocean Drive Acquisition Corp.", ticker: "ODAC" },
    { name: "VACI - VICTORY ACQUISITION CORP.", ticker: "VACI" },
    { name: "BRIG - Brigantine Acquisition Corp.", ticker: "BRIG" },
    { name: "DKDCA - Data Knights Acquisition Corp.", ticker: "DKDCA" },
    { name: "XLSA - Excelsa Acquisition Corp.", ticker: "XLSA" },
    { name: "TCBS - Texas Community Bancshares, Inc.", ticker: "TCBS" },
    { name: "UNOO - 1Sharpe Acquisition Corp.", ticker: "UNOO" },
    { name: "NCAC - Newcourt Acquisition Corp", ticker: "NCAC" },
    { name: "TWCM - Mistico Acquisition Corp.", ticker: "TWCM" },
    { name: "STLRA - Stellaris Growth Acquisition Corp.", ticker: "STLRA" },
    { name: "ABCO - Able Brands Co.", ticker: "ABCO" },
    { name: "WAVC - Waverley Capital Acquisition Corp. 1", ticker: "WAVC" },
    { name: "VBAQ - Venice Brands Acquisition Corp. I", ticker: "VBAQ" },
    { name: "PBBK - PB Bankshares, Inc.", ticker: "PBBK" },
    { name: "EIPA - EIP Acquisition Corp I", ticker: "EIPA" },
    { name: "RCDA - Red Cell DRM Acquisition Corp.", ticker: "RCDA" },
    { name: "RCPI - Reverence Acquisition Corp.", ticker: "RCPI" },
    { name: "CLST - Catalyst Bancorp, Inc.", ticker: "CLST" },
    { name: "MEAC - Mercury Ecommerce Acquisition Corp", ticker: "MEAC" },
    { name: "QPAA - Quiet Plus I Acquisition Corp.", ticker: "QPAA" },
    { name: "TEGA - Think Elevation Capital Growth Opportunities", ticker: "TEGA" },
    { name: "HIGB - H.I.G. Acquisition Corp. II", ticker: "HIGB" },
    { name: "TCBC - TC Bancshares, Inc.", ticker: "TCBC" },
    { name: "AVEA - Avanea Energy Acquisition Corp.", ticker: "AVEA" },
    { name: "CAVU - CAVU TECHNOLOGY ACQUISITION CORP.", ticker: "CAVU" },
    { name: "ISAP - Israel Amplify Program Corp.", ticker: "ISAP" },
    { name: "CNDA - Concord Acquisition Corp II", ticker: "CNDA" },
    { name: "CNDB - Concord Acquisition Corp III", ticker: "CNDB" },
    { name: "LFTA - Lazard Fintech Acquisition Corp. I", ticker: "LFTA" },
    { name: "LHCA - Lazard Healthcare Acquisition Corp. I", ticker: "LHCA" },
    { name: "LRIS - Laris Media Acquisition Corp", ticker: "LRIS" },
    { name: "RJAC - Jackson Acquisition Co", ticker: "RJAC" },
    { name: "GLEE - Gladstone Acquisition Corp", ticker: "GLEE" },
    { name: "NGC - Northern Genesis Acquisition Corp. III", ticker: "NGC" },
    { name: "KSI - Kadem Sustainable Impact Corp", ticker: "KSI" },
    { name: "BLNG - Belong Acquisition Corp.", ticker: "BLNG" },
    { name: "WNNR - Andretti Acquisition Corp.", ticker: "WNNR" },
    { name: "NGCA - NextGen Acquisition Corp. II", ticker: "NGCA" },
    { name: "KETA - Keter1 Acquisition Corp", ticker: "KETA" },
    { name: "SVII - Spring Valley Acquisition Corp. II", ticker: "SVII" },
    { name: "TTO - Tiga Acquisition Corp. II", ticker: "TTO" },
    { name: "REE - REE Automotive Ltd.", ticker: "REE" },
    { name: "AMAO - American Acquisition Opportunity Inc.", ticker: "AMAO" },
    { name: "WCAT - Jaws Wildcat Acquisition Corp", ticker: "WCAT" },
    { name: "FRSG - First Reserve Sustainable Growth Corp.", ticker: "FRSG" },
    { name: "HERA - FTAC Hera Acquisition Corp.", ticker: "HERA" },
    { name: "OTMO - Otonomo Technologies Ltd.", ticker: "OTMO" },
    { name: "BYTS - BYTE Acquisition Corp.", ticker: "BYTS" },
    { name: "FMIV - Forum Merger IV Corp", ticker: "FMIV" },
    { name: "HCVI - Hennessy Capital Investment Corp. VI", ticker: "HCVI" },
    { name: "ALPA - ALPHA HEALTHCARE ACQUISITION CORP III", ticker: "ALPA" },
    { name: "GGI - Guggenheim Special Purpose Acquisition Corp. I", ticker: "GGI" },
    { name: "ALTT - Altitude Acquisition Corp. III", ticker: "ALTT" },
    { name: "CALQ - Callodine Acquisition Corp", ticker: "CALQ" },
    { name: "ARK - 5G Edge Acquisition Corp.", ticker: "ARK" },
    { name: "OPA - Magnum Opus Acquisition Ltd", ticker: "OPA" },
    { name: "MPAC - Model Performance Acquisition Corp", ticker: "MPAC" },
    { name: "INDI - Thunder Bridge II Surviving Pubco, Inc.", ticker: "INDI" },
    { name: "APGC - Apollo Strategic Growth Capital III", ticker: "APGC" },
    { name: "FRF - Fortegra Group, LLC", ticker: "FRF" },
    { name: "VGII - Virgin Group Acquisition Corp. II", ticker: "VGII" },
    { name: "SWAG - Software Acquisition Group Inc. III", ticker: "SWAG" },
    { name: "PDOT - Peridot Acquisition Corp. II", ticker: "PDOT" },
    { name: "ALTE - Altitude Acquisition Corp. II", ticker: "ALTE" },
    { name: "CNAQ - CHARDAN NEXTECH ACQUISITION CORP.", ticker: "CNAQ" },
    { name: "JUGG - Jaws Juggernaut Acquisition Corp", ticker: "JUGG" },
    { name: "SLVR - SILVERspac Inc.", ticker: "SLVR" },
    { name: "BCIC - BCC Investment Corp.", ticker: "BCIC" },
    { name: "FRON - Frontier Acquisition Corp.", ticker: "FRON" },
    { name: "ACTD - ArcLight Clean Transition Corp. II", ticker: "ACTD" },
    { name: "TCPG - Transformational CPG Acquisition Corp.", ticker: "TCPG" },
    { name: "GFLD - Gefen Landa Acquisition Corp.", ticker: "GFLD" },
    { name: "AGGR - Agile Growth Corp.", ticker: "AGGR" },
    { name: "LDHA - LDH Growth Corp I", ticker: "LDHA" },
    { name: "THCP - Thunder Bridge Capital Partners IV, Inc.", ticker: "THCP" },
    { name: "NPAC - New Providence Acquisition Corp. III", ticker: "NPAC" },
    { name: "EXAC - Excolere Acquisition Corp.", ticker: "EXAC" },
    { name: "BRIV - B. Riley Principal 250 Merger Corp.", ticker: "BRIV" },
    { name: "TRNY - Trinity Acquisition Corp.", ticker: "TRNY" },
    { name: "RKTA - Rocket Internet Growth Opportunities Corp.", ticker: "RKTA" },
    { name: "FGNB - FG New America Acquisition II Corp", ticker: "FGNB" },
    { name: "ACBA - Ace Global Business Acquisition Ltd", ticker: "ACBA" },
    { name: "UPTD - TradeUP Acquisition Corp.", ticker: "UPTD" },
    { name: "MAQC - Maquia Capital Acquisition Corp", ticker: "MAQC" },
    { name: "IPAX - Inflection Point Acquisition Corp.", ticker: "IPAX" },
    { name: "GIA - GigCapital5, Inc.", ticker: "GIA" },
    { name: "GIF - GigCapital6, Inc.", ticker: "GIF" },
    { name: "CTII - Cerberus Telecom Acquisition Corp. II", ticker: "CTII" },
    { name: "TCG - TCG Growth Opportunities Corp.", ticker: "TCG" },
    { name: "CSIC - Cornerstone Investment Capital Holdings Co.", ticker: "CSIC" },
    { name: "CRZN - Corazon Capital V838 Monoceros Corp", ticker: "CRZN" },
    { name: "BCTA - B Capital Technology Opportunities Corp.", ticker: "BCTA" },
    { name: "ARTA - Artisan Acquisition Corp.", ticker: "ARTA" },
    { name: "DCRC - Decarbonization Plus Acquisition Corp III", ticker: "DCRC" },
    { name: "QWNB - Queen's Gambit Growth Capital II", ticker: "QWNB" },
    { name: "ATWO - Acies Acquisition Corp. II", ticker: "ATWO" },
    { name: "FLSH - VIDA FLaSH Acquisitions", ticker: "FLSH" },
    { name: "APAC - StoneBridge Acquisition Corp.", ticker: "APAC" },
    { name: "OACC - Oaktree Acquisition Corp. III", ticker: "OACC" },
    { name: "AMBP - Ardagh Metal Packaging S.A.", ticker: "AMBP" },
    { name: "IVCP - Swiftmerge Acquisition Corp.", ticker: "IVCP" },
    { name: "ALTP - Altamont Pharma Acquisition Corp.", ticker: "ALTP" },
    { name: "CBRG - Chain Bridge I", ticker: "CBRG" },
    { name: "RAII - Revolution Acceleration Acquisition Corp II", ticker: "RAII" },
    { name: "HCMA - HCM Acquisition Corp", ticker: "HCMA" },
    { name: "RONI - Rice Acquisition Corp. II", ticker: "RONI" },
    { name: "CMLT - CM Life Sciences III Inc.", ticker: "CMLT" },
    { name: "TBSA - TB SA Acquisition Corp", ticker: "TBSA" },
    { name: "AACO - Advancit Acquisition Corp. I", ticker: "AACO" },
    { name: "CLIC - Climate Real Impact Solutions III Acquisition Corp", ticker: "CLIC" },
    { name: "GFOR - Graf Acquisition Corp. IV", ticker: "GFOR" },
    { name: "TCVA - TCV Acquisition Corp.", ticker: "TCVA" },
    { name: "TWCB - Bilander Acquisition Corp.", ticker: "TWCB" },
    { name: "OSAA - OS Acquisition Corp.", ticker: "OSAA" },
    { name: "SACQ - Silverman Acquisition Corp I", ticker: "SACQ" },
    { name: "TIOA - Tio Tech A", ticker: "TIOA" },
    { name: "JAAC - Just Another Acquisition Corp.", ticker: "JAAC" },
    { name: "RGAC - Rocket Global Acquistion Corp.", ticker: "RGAC" },
    { name: "TTRE - Tiga Acquisition Corp. III", ticker: "TTRE" },
    { name: "CATL - Category Leader Partner Corp 1", ticker: "CATL" },
    { name: "BTVC - Tribe Capital Growth Corp II", ticker: "BTVC" },
    { name: "SEPG - SEP Growth Holdings Corp.", ticker: "SEPG" },
    { name: "MACS - Modiv Acquisition Corp.", ticker: "MACS" },
    { name: "GCSA - Gateway Strategic Acquisition Co.", ticker: "GCSA" },
    { name: "TCOA - Trajectory Alpha Acquisition Corp.", ticker: "TCOA" },
    { name: "MCTY - MOTOR CITY ACQUISITION CORP.", ticker: "MCTY" },
    { name: "VEMC - VELOCITY MERGER CORP.", ticker: "VEMC" },
    { name: "APCP - Aperture Acquisition Corp", ticker: "APCP" },
    { name: "SEDA - SDCL EDGE Acquisition Corp", ticker: "SEDA" },
    { name: "MSDA - MSD ACQUISITION CORP. / NEW", ticker: "MSDA" },
    { name: "WFC-PC - WELLS FARGO & COMPANY/MN", ticker: "WFC-PC" },
    { name: "CEOHF - CNOOC LTD", ticker: "CEOHF" },
    { name: "SRE-PB - SEMPRA ENERGY", ticker: "SRE-PB" },
    { name: "FERGY - Ferguson plc", ticker: "FERGY" },
    { name: "WSO-B - WATSCO INC", ticker: "WSO-B" },
    { name: "SLG-PI - SL GREEN REALTY CORP", ticker: "SLG-PI" },
    { name: "CFXA - Colfax CORP", ticker: "CFXA" },
    { name: "WBS-PF - WEBSTER FINANCIAL CORP", ticker: "WBS-PF" },
    { name: "SRC-PA - SPIRIT REALTY CAPITAL, INC.", ticker: "SRC-PA" },
    { name: "AFFS - Trinity Capital Partners Inc.", ticker: "AFFS" },
    { name: "SLMBP - SLM Corp", ticker: "SLMBP" },
    { name: "VLYPO - VALLEY NATIONAL BANCORP", ticker: "VLYPO" },
    { name: "VLYPP - VALLEY NATIONAL BANCORP", ticker: "VLYPP" },
    { name: "THNPF - Technip Energies N.V.", ticker: "THNPF" },
    { name: "FNGD - BANK OF MONTREAL /CAN/", ticker: "FNGD" },
    { name: "PYRNF - PyroGenesis Canada Inc.", ticker: "PYRNF" },
    { name: "AHH-PA - Armada Hoffler Properties, Inc.", ticker: "AHH-PA" },
    { name: "CONX - CONX Corp.", ticker: "CONX" },
    { name: "AGO-PB - ASSURED GUARANTY LTD", ticker: "AGO-PB" },
    { name: "AGO-PE - ASSURED GUARANTY LTD", ticker: "AGO-PE" },
    { name: "AGO-PF - ASSURED GUARANTY LTD", ticker: "AGO-PF" },
    { name: "STAR-PI - ISTAR INC.", ticker: "STAR-PI" },
    { name: "STAR-PD - ISTAR INC.", ticker: "STAR-PD" },
    { name: "STAR-PG - ISTAR INC.", ticker: "STAR-PG" },
    { name: "UBP-PH - URSTADT BIDDLE PROPERTIES INC", ticker: "UBP-PH" },
    { name: "BANC-PD - BANC OF CALIFORNIA, INC.", ticker: "BANC-PD" },
    { name: "BANC-PE - BANC OF CALIFORNIA, INC.", ticker: "BANC-PE" },
    { name: "VADPD - VADO CORP.", ticker: "VADPD" },
    { name: "TSCBP - TriState Capital Holdings, Inc.", ticker: "TSCBP" },
    { name: "TSCAP - TriState Capital Holdings, Inc.", ticker: "TSCAP" },
    { name: "GBOX - GreenBox POS", ticker: "GBOX" },
    { name: "HITIF - High Tide Inc.", ticker: "HITIF" },
    { name: "DX-PB - DYNEX CAPITAL INC", ticker: "DX-PB" },
    { name: "ANH-PB - ANWORTH MORTGAGE ASSET CORP", ticker: "ANH-PB" },
    { name: "LANDM - GLADSTONE LAND Corp", ticker: "LANDM" },
    { name: "ANH-PC - ANWORTH MORTGAGE ASSET CORP", ticker: "ANH-PC" },
    { name: "ANH-PA - ANWORTH MORTGAGE ASSET CORP", ticker: "ANH-PA" },
    { name: "MDRPD - PERPETUA RESOURCES CORP.", ticker: "MDRPD" },
    { name: "BRG-PD - Bluerock Residential Growth REIT, Inc.", ticker: "BRG-PD" },
    { name: "BRG-PC - Bluerock Residential Growth REIT, Inc.", ticker: "BRG-PC" },
    { name: "BRG-PA - Bluerock Residential Growth REIT, Inc.", ticker: "BRG-PA" },
    { name: "BRCPF - BrasilAgro - Brazilian Agricultural Real Estate Co", ticker: "BRCPF" },
    { name: "KMGH - Kemiao Garment Holding Group", ticker: "KMGH" },
    { name: "GCEHD - Global Clean Energy Holdings, Inc.", ticker: "GCEHD" },
    { name: "WPG-PH - WASHINGTON PRIME GROUP INC.", ticker: "WPG-PH" },
    { name: "WPG-PI - WASHINGTON PRIME GROUP INC.", ticker: "WPG-PI" },
    { name: "BFGCD - AUGUSTA GOLD CORP.", ticker: "BFGCD" },
    { name: "NUGX - NUGENEREX IMMUNO-ONCOLOGY, INC.", ticker: "NUGX" },
    { name: "NVOSD - Novo Integrated Sciences, Inc.", ticker: "NVOSD" },
    { name: "SOHOB - Sotherly Hotels Inc.", ticker: "SOHOB" },
    { name: "SOHON - Sotherly Hotels Inc.", ticker: "SOHON" },
    { name: "SOHOO - Sotherly Hotels Inc.", ticker: "SOHOO" },
    { name: "SINGD - SinglePoint Inc.", ticker: "SINGD" },
    { name: "INTBD - SENTIENT BRANDS HOLDINGS INC.", ticker: "INTBD" },
    { name: "GENN - Genesis Healthcare, Inc.", ticker: "GENN" },
    { name: "VKIND - VIKING ENERGY GROUP, INC.", ticker: "VKIND" },
    { name: "OCGSF - OUTCROP GOLD CORP", ticker: "OCGSF" },
    { name: "ASDND - Astro Aerospace Ltd.", ticker: "ASDND" },
    { name: "SAFOD - Save Foods Inc.", ticker: "SAFOD" },
    { name: "ACEZD - Qiansui International Group Co. Ltd.", ticker: "ACEZD" },
    { name: "LBSRD - LIBERTY STAR URANIUM & METALS CORP.", ticker: "LBSRD" },
    { name: "SMKC - Smoke Cartel, Inc.", ticker: "SMKC" },
    { name: "RELVD - RELIV INTERNATIONAL INC", ticker: "RELVD" },
    { name: "VRUSD - VERUS INTERNATIONAL, INC.", ticker: "VRUSD" },
    { name: "HPTYD - RCMW Group, Inc.", ticker: "HPTYD" },
    { name: "SAMLD - Samsara Luggage, Inc.", ticker: "SAMLD" },
    { name: "EXPL - Endurance Exploration Group, Inc.", ticker: "EXPL" },
    { name: "ALACR - Alberton Acquisition Corp", ticker: "ALACR" },
    { name: "ALACW - Alberton Acquisition Corp", ticker: "ALACW" },
    { name: "NHLDW - NewHold Investment Corp. II", ticker: "NHLDW" },
    { name: "FLCXD - flooidCX Corp.", ticker: "FLCXD" },
    { name: "GMVPD - GridIron BioNutrients, Inc.", ticker: "GMVPD" },
    { name: "ASCKD - AUSCRETE Corp", ticker: "ASCKD" },
    { name: "BLSP - BLUE SPHERE CORP.", ticker: "BLSP" },
    { name: "BDGYD - BRIDGEWAY NATIONAL CORP.", ticker: "BDGYD" },
    { name: "FRHVD - Fresh Harvest Products, Inc.", ticker: "FRHVD" },
    { name: "CERPQ - Cereplast Inc", ticker: "CERPQ" },
    { name: "FTGID - FINOTEC GROUP INC", ticker: "FTGID" },
    { name: "DX-PC - DYNEX CAPITAL INC", ticker: "DX-PC" },
    { name: "VIACP - ViacomCBS Inc.", ticker: "VIACP" },
    { name: "BANFP - BANCFIRST CORP /OK/", ticker: "BANFP" },
    { name: "AEFC - AEGON NV", ticker: "AEFC" },
    { name: "CHKEL - CHESAPEAKE ENERGY CORP", ticker: "CHKEL" },
    { name: "CHKEW - CHESAPEAKE ENERGY CORP", ticker: "CHKEW" },
    { name: "CHKEZ - CHESAPEAKE ENERGY CORP", ticker: "CHKEZ" },
    { name: "DCOMP - Dime Community Bancshares, Inc. /NY/", ticker: "DCOMP" },
    { name: "AESC - AES CORP", ticker: "AESC" },
    { name: "ASRVP - AMERISERV FINANCIAL INC /PA/", ticker: "ASRVP" },
    { name: "SJIV - SOUTH JERSEY INDUSTRIES INC", ticker: "SJIV" },
    { name: "SNV-PE - SYNOVUS FINANCIAL CORP", ticker: "SNV-PE" },
    { name: "WRB-PH - BERKLEY W R CORP", ticker: "WRB-PH" },
    { name: "USB-PR - US BANCORP \\DE\\", ticker: "USB-PR" },
    { name: "BAC-PP - BANK OF AMERICA CORP /DE/", ticker: "BAC-PP" },
    { name: "ISCB - INTERNATIONAL SPEEDWAY CORP", ticker: "ISCB" },
    { name: "USML - UBS AG", ticker: "USML" },
    { name: "QULL - UBS AG", ticker: "QULL" },
    { name: "MTUL - UBS AG", ticker: "MTUL" },
    { name: "IWFL - UBS AG", ticker: "IWFL" },
    { name: "IWML - UBS AG", ticker: "IWML" },
    { name: "IWDL - UBS AG", ticker: "IWDL" },
    { name: "GTMAF - GRUPO TMM SAB", ticker: "GTMAF" },
    { name: "FRC-PL - FIRST REPUBLIC BANK", ticker: "FRC-PL" },
    { name: "WAFDP - WASHINGTON FEDERAL INC", ticker: "WAFDP" },
    { name: "FNGU - BANK OF MONTREAL /CAN/", ticker: "FNGU" },
    { name: "PRE-PJ - PARTNERRE LTD", ticker: "PRE-PJ" },
    { name: "WINTW - WINDTREE THERAPEUTICS INC /DE/", ticker: "WINTW" },
    { name: "BAMH - BROOKFIELD ASSET MANAGEMENT INC.", ticker: "BAMH" },
    { name: "BAMI - BROOKFIELD ASSET MANAGEMENT INC.", ticker: "BAMI" },
    { name: "TCBIO - TEXAS CAPITAL BANCSHARES INC/TX", ticker: "TCBIO" },
    { name: "TDS-PU - TELEPHONE & DATA SYSTEMS INC /DE/", ticker: "TDS-PU" },
    { name: "UBP-PK - URSTADT BIDDLE PROPERTIES INC", ticker: "UBP-PK" },
    { name: "ECCW - Eagle Point Credit Co Inc.", ticker: "ECCW" },
    { name: "FTAI-PC - Fortress Transportation & Infrastructure Investors LLC", ticker: "FTAI-PC" },
    { name: "RC-PB - Ready Capital Corp", ticker: "RC-PB" },
    { name: "RC-PC - Ready Capital Corp", ticker: "RC-PC" },
    { name: "RC-PD - Ready Capital Corp", ticker: "RC-PD" },
    { name: "RCC - Ready Capital Corp", ticker: "RCC" },
    { name: "AMPGW - AmpliTech Group, Inc.", ticker: "AMPGW" },
    { name: "AUUDW - AUDDIA INC.", ticker: "AUUDW" },
    { name: "KRPI - ZEUUS, INC.", ticker: "KRPI" },
    { name: "REKRP - Rekor Systems, Inc.", ticker: "REKRP" },
    { name: "HYMCL - HYCROFT MINING HOLDING CORP", ticker: "HYMCL" },
    { name: "ISUNW - ISUN, INC.", ticker: "ISUNW" },
    { name: "MBINN - Merchants Bancorp", ticker: "MBINN" },
    { name: "BWSN - Babcock & Wilcox Enterprises, Inc.", ticker: "BWSN" },
    { name: "BCTXW - BriaCell Therapeutics Corp.", ticker: "BCTXW" },
    { name: "AJXA - Great Ajax Corp.", ticker: "AJXA" },
    { name: "BIP-PB - Brookfield Infrastructure Partners L.P.", ticker: "BIP-PB" },
    { name: "BNGOW - Bionano Genomics, Inc", ticker: "BNGOW" },
    { name: "CUENW - Cuentas Inc.", ticker: "CUENW" },
    { name: "GLP-PB - GLOBAL PARTNERS LP", ticker: "GLP-PB" },
    { name: "ACR-PC - ACRES Commercial Realty Corp.", ticker: "ACR-PC" },
    { name: "EQH-PC - Equitable Holdings, Inc.", ticker: "EQH-PC" },
    { name: "LEXXW - Lexaria Bioscience Corp.", ticker: "LEXXW" },
    { name: "XCWPX - ACAP Strategic Fund", ticker: "XCWPX" },
    { name: "CSAN-WI - Cosan S.A.", ticker: "CSAN-WI" },
    { name: "ETWO-WT - E2open Parent Holdings, Inc.", ticker: "ETWO-WT" },
    { name: "TCACW - Tuatara Capital Acquisition Corp", ticker: "TCACW" },
    { name: "BFLY-WT - Butterfly Network, Inc.", ticker: "BFLY-WT" },
    { name: "PSACW - Property Solutions Acquisition Corp.", ticker: "PSACW" },
    { name: "ITQRW - Itiquira Acquisition Corp.", ticker: "ITQRW" },
    { name: "VIEWW - View, Inc.", ticker: "VIEWW" },
    { name: "APPHW - AppHarvest, Inc.", ticker: "APPHW" },
    { name: "RELIW - Reliance Global Group, Inc.", ticker: "RELIW" },
    { name: "CCV-WT - Churchill Capital Corp V", ticker: "CCV-WT" },
    { name: "DWIN-WT - Delwinds Insurance Acquisition Corp.", ticker: "DWIN-WT" },
    { name: "ACKIW - ACKRELL SPAC Partners I Co.", ticker: "ACKIW" },
    { name: "HIMS-WT - Hims & Hers Health, Inc.", ticker: "HIMS-WT" },
    { name: "CHPT-WT - ChargePoint Holdings, Inc.", ticker: "CHPT-WT" },
    { name: "FFVWF - 4Front Ventures Corp.", ticker: "FFVWF" },
    { name: "UWMC-WT - UWM Holdings Corp", ticker: "UWMC-WT" },
    { name: "HSQAX - Hartford Schroders Opportunistic Income Fund", ticker: "HSQAX" },
    { name: "HSQBX - Hartford Schroders Opportunistic Income Fund", ticker: "HSQBX" },
    { name: "HSQIX - Hartford Schroders Opportunistic Income Fund", ticker: "HSQIX" },
    { name: "GXGXW - GX Acquisition Corp.", ticker: "GXGXW" },
    { name: "ADNWW - ADVENT TECHNOLOGIES HOLDINGS, INC.", ticker: "ADNWW" },
    { name: "CAP-WT - Capitol Investment Corp. V", ticker: "CAP-WT" },
    { name: "CLAA-UN - Colonnade Acquisition Corp. II", ticker: "CLAA-UN" },
    { name: "RMGCU - RMG Acquisition Corp. III", ticker: "RMGCU" },
    { name: "RMGCW - RMG Acquisition Corp. III", ticker: "RMGCW" },
    { name: "SLAMU - Slam Corp.", ticker: "SLAMU" },
    { name: "DHCAU - DHC Acquisition Corp.", ticker: "DHCAU" },
    { name: "NVSAU - New Vista Acquisition Corp", ticker: "NVSAU" },
    { name: "STRE-UN - Supernova Partners Acquisition Co III, Ltd.", ticker: "STRE-UN" },
    { name: "SCOBW - ScION Tech Growth II", ticker: "SCOBW" },
    { name: "SNII-UN - Supernova Partners Acquisition Co II, Ltd.", ticker: "SNII-UN" },
    { name: "TSPQ-UN - TCW Special Purpose Acquisition Corp.", ticker: "TSPQ-UN" },
    { name: "AUS-UN - Austerlitz Acquisition Corp I", ticker: "AUS-UN" },
    { name: "PTOCU - Pine Technology Acquisition Corp.", ticker: "PTOCU" },
    { name: "APGB-UN - Apollo Strategic Growth Capital II", ticker: "APGB-UN" },
    { name: "MACQU - MCAP Acquisition Corp", ticker: "MACQU" },
    { name: "ACII-UN - Atlas Crest Investment Corp. II", ticker: "ACII-UN" },
    { name: "ACII-WT - Atlas Crest Investment Corp. II", ticker: "ACII-WT" },
    { name: "SPAQ-UN - Spartan Acquisition Corp. III", ticker: "SPAQ-UN" },
    { name: "GLBLU - Cartesian Growth Corp", ticker: "GLBLU" },
    { name: "BGSX-UN - Build Acquisition Corp.", ticker: "BGSX-UN" },
    { name: "AAQC-UN - Accelerate Acquisition Corp.", ticker: "AAQC-UN" },
    { name: "DISAU - Disruptive Acquisition Corp I", ticker: "DISAU" },
    { name: "PFDRU - Pathfinder Acquisition Corp", ticker: "PFDRU" },
    { name: "MBAC-UN - M3-Brigade Acquisition II Corp.", ticker: "MBAC-UN" },
    { name: "SPGS-UN - Simon Property Group Acquisition Holdings, Inc.", ticker: "SPGS-UN" },
    { name: "GAPA-UN - G&P Acquisition Corp.", ticker: "GAPA-UN" },
    { name: "FACT-UN - Freedom Acquisition I Corp.", ticker: "FACT-UN" },
    { name: "XPDIU - Power & Digital Infrastructure Acquisition Corp.", ticker: "XPDIU" },
    { name: "XPDIW - Power & Digital Infrastructure Acquisition Corp.", ticker: "XPDIW" },
    { name: "ASZ-UN - Austerlitz Acquisition Corp II", ticker: "ASZ-UN" },
    { name: "EJFAU - EJF Acquisition Corp.", ticker: "EJFAU" },
    { name: "ROCRU - Roth CH Acquisition III Co", ticker: "ROCRU" },
    { name: "ISOS-UN - Isos Acquisition Corp.", ticker: "ISOS-UN" },
    { name: "TRCA-UN - Twin Ridge Capital Acquisition Corp.", ticker: "TRCA-UN" },
    { name: "ATHN-UN - Athena Technology Acquisition Corp.", ticker: "ATHN-UN" },
    { name: "FSNB-UN - Fusion Acquisition Corp. II", ticker: "FSNB-UN" },
    { name: "FRXB-UN - Forest Road Acquisition Corp. II", ticker: "FRXB-UN" },
    { name: "MACC-UN - Mission Advancement Corp.", ticker: "MACC-UN" },
    { name: "FTPAU - FTAC Parnassus Acquisition Corp.", ticker: "FTPAU" },
    { name: "DTOCU - Digital Transformation Opportunities Corp.", ticker: "DTOCU" },
    { name: "FZT-UN - FAST Acquisition Corp. II", ticker: "FZT-UN" },
    { name: "IPVF-UN - InterPrivate III Financial Partners Inc.", ticker: "IPVF-UN" },
    { name: "IPVA-UN - InterPrivate II Acquisition Corp.", ticker: "IPVA-UN" },
    { name: "FTEV-UN - FinTech Evolution Acquisition Group", ticker: "FTEV-UN" },
    { name: "CFFEU - CF Acquisition Corp. VIII", ticker: "CFFEU" },
    { name: "FACA-UN - Figure Acquisition Corp. I", ticker: "FACA-UN" },
    { name: "GAMCU - Golden Arrow Merger Corp.", ticker: "GAMCU" },
    { name: "ATSPU - Archimedes Tech Spac Partners Co", ticker: "ATSPU" },
    { name: "LCAAU - L Catterton Asia Acquisition Corp", ticker: "LCAAU" },
    { name: "TETCU - Tech & Energy Transition Corp", ticker: "TETCU" },
    { name: "LIII-UN - Leo Holdings III Corp.", ticker: "LIII-UN" },
    { name: "ROSS-UN - Ross Acquisition Corp II", ticker: "ROSS-UN" },
    { name: "LOKM-UN - Live Oak Mobility Acquisition Corp.", ticker: "LOKM-UN" },
    { name: "ESM-UN - ESM Acquisition Corp", ticker: "ESM-UN" },
    { name: "EBACU - European Biotech Acquisition Corp.", ticker: "EBACU" },
    { name: "KCAC-UN - Kensington Capital Acquisition Corp. II", ticker: "KCAC-UN" },
    { name: "LVRAU - Levere Holdings Corp.", ticker: "LVRAU" },
    { name: "DMYQ-UN - dMY Technology Group, Inc. IV", ticker: "DMYQ-UN" },
    { name: "SBEAU - SILVERBOX ENGAGED MERGER CORP I", ticker: "SBEAU" },
    { name: "ASPCU - Alpha Capital Acquisition Co", ticker: "ASPCU" },
    { name: "LGACU - Lazard Growth Acquisition Corp. I", ticker: "LGACU" },
    { name: "LGACW - Lazard Growth Acquisition Corp. I", ticker: "LGACW" },
    { name: "MSACW - Medicus Sciences Acquisition Corp.", ticker: "MSACW" },
    { name: "ACAHU - Atlantic Coastal Acquisition Corp.", ticker: "ACAHU" },
    { name: "OHPAU - Orion Acquisition Corp.", ticker: "OHPAU" },
    { name: "PUCKU - Goal Acquisitions Corp.", ticker: "PUCKU" },
    { name: "PUCKW - Goal Acquisitions Corp.", ticker: "PUCKW" },
    { name: "WPCA-UN - Warburg Pincus Capital Corp I-A", ticker: "WPCA-UN" },
    { name: "WPCB-UN - Warburg Pincus Capital Corp I-B", ticker: "WPCB-UN" },
    { name: "DCRNU - Decarbonization Plus Acquisition Corp II", ticker: "DCRNU" },
    { name: "DCRNW - Decarbonization Plus Acquisition Corp II", ticker: "DCRNW" },
    { name: "GMBTW - Queen's Gambit Growth Capital", ticker: "GMBTW" },
    { name: "GMBTU - Queen's Gambit Growth Capital", ticker: "GMBTU" },
    { name: "PMGMU - Priveterra Acquisition Corp.", ticker: "PMGMU" },
    { name: "CMIIU - CM Life Sciences II Inc.", ticker: "CMIIU" },
    { name: "GSQD-UN - G Squared Ascend I Inc.", ticker: "GSQD-UN" },
    { name: "GSQD-WT - G Squared Ascend I Inc.", ticker: "GSQD-WT" },
    { name: "SDACU - Sustainable Development Acquisition I Corp.", ticker: "SDACU" },
    { name: "SDACW - Sustainable Development Acquisition I Corp.", ticker: "SDACW" },
    { name: "ARKIU - ALKURI GLOBAL ACQUISITION CORP.", ticker: "ARKIU" },
    { name: "CENHU - Centricus Acquisition Corp.", ticker: "CENHU" },
    { name: "CENHW - Centricus Acquisition Corp.", ticker: "CENHW" },
    { name: "NDACU - NightDragon Acquisition Corp.", ticker: "NDACU" },
    { name: "NVVEW - Nuvve Holding Corp.", ticker: "NVVEW" },
    { name: "ARRWU - Arrowroot Acquisition Corp.", ticker: "ARRWU" },
    { name: "TWNI-UN - Tailwind International Acquisition Corp.", ticker: "TWNI-UN" },
    { name: "NSTC-UN - Northern Star Investment Corp. III", ticker: "NSTC-UN" },
    { name: "CLIM-UN - Climate Real Impact Solutions II Acquisition Corp", ticker: "CLIM-UN" },
    { name: "CLIM-WT - Climate Real Impact Solutions II Acquisition Corp", ticker: "CLIM-WT" },
    { name: "NSTD-UN - Northern Star Investment Corp. IV", ticker: "NSTD-UN" },
    { name: "PICC-UN - Pivotal Investment Corp III", ticker: "PICC-UN" },
    { name: "TMAC-UN - Music Acquisition Corp", ticker: "TMAC-UN" },
    { name: "TMAC-WT - Music Acquisition Corp", ticker: "TMAC-WT" },
    { name: "IBER-UN - IBERE PHARMACEUTICALS", ticker: "IBER-UN" },
    { name: "MACAU - Moringa Acquisition Corp", ticker: "MACAU" },
    { name: "IACB-UN - ION Acquisition Corp 2 Ltd.", ticker: "IACB-UN" },
    { name: "TWNT-UN - Tailwind Two Acquisition Corp.", ticker: "TWNT-UN" },
    { name: "THMAU - Thimble Point Acquisition Corp.", ticker: "THMAU" },
    { name: "AMPI-UN - Advanced Merger Partners, Inc.", ticker: "AMPI-UN" },
    { name: "SLAC-UN - Social Leverage Acquisition Corp I", ticker: "SLAC-UN" },
    { name: "IGNYW - Ignyte Acquisition Corp.", ticker: "IGNYW" },
    { name: "LEGAU - Lead Edge Growth Opportunities, Ltd", ticker: "LEGAU" },
    { name: "NSTB-UN - Northern Star Investment Corp. II", ticker: "NSTB-UN" },
    { name: "NSTB-WT - Northern Star Investment Corp. II", ticker: "NSTB-WT" },
    { name: "PSFE-WT - Paysafe Ltd", ticker: "PSFE-WT" },
    { name: "AGAC-UN - African Gold Acquisition Corp", ticker: "AGAC-UN" },
    { name: "AGAC-WT - African Gold Acquisition Corp", ticker: "AGAC-WT" },
    { name: "CSTA-UN - Constellation Acquisition Corp I", ticker: "CSTA-UN" },
    { name: "CSTA-WT - Constellation Acquisition Corp I", ticker: "CSTA-WT" },
    { name: "FSRXU - Finserv Acquisition Corp. II", ticker: "FSRXU" },
    { name: "EVOJW - Evo Acquisition Corp", ticker: "EVOJW" },
    { name: "BKCQF - Bespoke Capital Acquisition Corp", ticker: "BKCQF" },
    { name: "BSPOF - Bespoke Capital Acquisition Corp", ticker: "BSPOF" },
    { name: "PGRWU - Progress Acquisition Corp.", ticker: "PGRWU" },
    { name: "PGRWW - Progress Acquisition Corp.", ticker: "PGRWW" },
    { name: "BCYPW - Big Cypress Acquisition Corp.", ticker: "BCYPW" },
    { name: "RCLFU - Rosecliff Acquisition Corp I", ticker: "RCLFU" },
    { name: "RCLFW - Rosecliff Acquisition Corp I", ticker: "RCLFW" },
    { name: "TSIBW - Tishman Speyer Innovation Corp. II", ticker: "TSIBW" },
    { name: "TSIBU - Tishman Speyer Innovation Corp. II", ticker: "TSIBU" },
    { name: "EACPU - Edify Acquisition Corp.", ticker: "EACPU" },
    { name: "EACPW - Edify Acquisition Corp.", ticker: "EACPW" },
    { name: "KRNLU - Kernel Group Holdings, Inc.", ticker: "KRNLU" },
    { name: "KRNLW - Kernel Group Holdings, Inc.", ticker: "KRNLW" },
    { name: "FTAAU - FTAC Athena Acquisition Corp.", ticker: "FTAAU" },
    { name: "EUSGU - European Sustainable Growth Acquisition Corp.", ticker: "EUSGU" },
    { name: "EUSGW - European Sustainable Growth Acquisition Corp.", ticker: "EUSGW" },
    { name: "FOREU - Foresight Acquisition Corp.", ticker: "FOREU" },
    { name: "LMACU - Liberty Media Acquisition Corp", ticker: "LMACU" },
    { name: "LMACW - Liberty Media Acquisition Corp", ticker: "LMACW" },
    { name: "NRACU - Noble Rock Acquisition Corp", ticker: "NRACU" },
    { name: "NRACW - Noble Rock Acquisition Corp", ticker: "NRACW" },
    { name: "NBSTU - Newbury Street Acquisition Corp", ticker: "NBSTU" },
    { name: "DLCAU - Deep Lake Capital Acquisition Corp.", ticker: "DLCAU" },
    { name: "MCADR - Mountain Crest Acquisition Corp II", ticker: "MCADR" },
    { name: "ENNVU - ECP Environmental Growth Opportunities Corp.", ticker: "ENNVU" },
    { name: "ENNVW - ECP Environmental Growth Opportunities Corp.", ticker: "ENNVW" },
    { name: "CAHCU - CA Healthcare Acquisition Corp.", ticker: "CAHCU" },
    { name: "CAHCW - CA Healthcare Acquisition Corp.", ticker: "CAHCW" },
    { name: "LGV-UN - Longview Acquisition Corp. II", ticker: "LGV-UN" },
    { name: "NAACU - North Atlantic Acquisition Corp", ticker: "NAACU" },
    { name: "ADEX-UN - Adit EdTech Acquisition Corp.", ticker: "ADEX-UN" },
    { name: "ADEX-WT - Adit EdTech Acquisition Corp.", ticker: "ADEX-WT" },
    { name: "PCTTU - PureCycle Technologies, Inc.", ticker: "PCTTU" },
    { name: "PCTTW - PureCycle Technologies, Inc.", ticker: "PCTTW" },
    { name: "STPC-WT - Star Peak Corp II", ticker: "STPC-WT" },
    { name: "SWBK-UN - Switchback II Corp", ticker: "SWBK-UN" },
    { name: "SWBK-WT - Switchback II Corp", ticker: "SWBK-WT" },
    { name: "PACXW - Pioneer Merger Corp.", ticker: "PACXW" },
    { name: "FOXWW - FoxWayne Enterprises Acquisition Corp.", ticker: "FOXWW" },
    { name: "FLME-UN - Flame Acquisition Corp.", ticker: "FLME-UN" },
    { name: "ATVCU - Tribe Capital Growth Corp I", ticker: "ATVCU" },
    { name: "LMAOW - LMF Acquisition Opportunities Inc", ticker: "LMAOW" },
    { name: "QFTA-UN - Quantum FinTech Acquisition Corp", ticker: "QFTA-UN" },
    { name: "QFTA-WT - Quantum FinTech Acquisition Corp", ticker: "QFTA-WT" },
    { name: "SRNGU - Soaring Eagle Acquisition Corp.", ticker: "SRNGU" },
    { name: "BITE-UN - Bite Acquisition Corp.", ticker: "BITE-UN" },
    { name: "JWSM-WT - Jaws Mustang Acquisition Corp", ticker: "JWSM-WT" },
    { name: "JWSM-UN - Jaws Mustang Acquisition Corp", ticker: "JWSM-UN" },
    { name: "PAQCW - Provident Acquisition Corp.", ticker: "PAQCW" },
    { name: "RTPYU - Reinvent Technology Partners Y", ticker: "RTPYU" },
    { name: "CVII-UN - Churchill Capital Corp VII", ticker: "CVII-UN" },
    { name: "FVIV-UN - Fortress Value Acquisition Corp. IV", ticker: "FVIV-UN" },
    { name: "CCVI-UN - Churchill Capital Corp VI", ticker: "CCVI-UN" },
    { name: "CPTK-WT - Crown PropTech Acquisitions", ticker: "CPTK-WT" },
    { name: "CPTK-UN - Crown PropTech Acquisitions", ticker: "CPTK-UN" },
    { name: "NGAB-UN - Northern Genesis Acquisition Corp. II", ticker: "NGAB-UN" },
    { name: "NGAB-WT - Northern Genesis Acquisition Corp. II", ticker: "NGAB-WT" },
    { name: "OCA-WT - Omnichannel Acquisition Corp.", ticker: "OCA-WT" },
    { name: "MOTV-WT - Motive Capital Corp", ticker: "MOTV-WT" },
    { name: "TLGA-UN - TLG Acquisition One Corp.", ticker: "TLGA-UN" },
    { name: "TLGA-WT - TLG Acquisition One Corp.", ticker: "TLGA-WT" },
    { name: "TACA-WT - Trepont Acquisition Corp I", ticker: "TACA-WT" },
    { name: "CLAS-UN - Class Acceleration Corp.", ticker: "CLAS-UN" },
    { name: "CLAS-WT - Class Acceleration Corp.", ticker: "CLAS-WT" },
    { name: "FRX-WT - Forest Road Acquisition Corp.", ticker: "FRX-WT" },
    { name: "AEACU - Authentic Equity Acquisition Corp.", ticker: "AEACU" },
    { name: "AEACW - Authentic Equity Acquisition Corp.", ticker: "AEACW" },
    { name: "ROT-WT - Rotor Acquisition Corp.", ticker: "ROT-WT" },
    { name: "INKAW - KLUDEIN I ACQUISITION CORP", ticker: "INKAW" },
    { name: "MTACW - MedTech Acquisition Corp", ticker: "MTACW" },
    { name: "GXIIU - GX Acquisition Corp. II", ticker: "GXIIU" },
    { name: "ANAC-UN - ARCTOS NORTHSTAR ACQUISITION CORP.", ticker: "ANAC-UN" },
    { name: "AAC-UN - Ares Acquisition Corp", ticker: "AAC-UN" },
    { name: "AAC-WT - Ares Acquisition Corp", ticker: "AAC-WT" },
    { name: "FPAC-WT - Far Peak Acquisition Corp", ticker: "FPAC-WT" },
    { name: "SWETU - Athlon Acquisition Corp.", ticker: "SWETU" },
    { name: "SWETW - Athlon Acquisition Corp.", ticker: "SWETW" },
    { name: "ENFAW - 890 5th Avenue Partners, Inc.", ticker: "ENFAW" },
    { name: "ENFAU - 890 5th Avenue Partners, Inc.", ticker: "ENFAU" },
    { name: "HTPA-WT - Highland Transcend Partners I Corp.", ticker: "HTPA-WT" },
    { name: "SVOKW - Seven Oaks Acquisition Corp.", ticker: "SVOKW" },
    { name: "CPUH-UN - Compute Health Acquisition Corp.", ticker: "CPUH-UN" },
    { name: "CPUH-WT - Compute Health Acquisition Corp.", ticker: "CPUH-WT" },
    { name: "CBAH-WT - CBRE Acquisition Holdings, Inc.", ticker: "CBAH-WT" },
    { name: "NXU-UN - Novus Capital Corp II", ticker: "NXU-UN" },
    { name: "SVFAW - SVF Investment Corp.", ticker: "SVFAW" },
    { name: "NXU-WT - Novus Capital Corp II", ticker: "NXU-WT" },
    { name: "FLACW - Frazier Lifesciences Acquisition Corp", ticker: "FLACW" },
    { name: "FRTT - Fortitude Gold Corp", ticker: "FRTT" },
    { name: "MONCU - Monument Circle Acquisition Corp.", ticker: "MONCU" },
    { name: "DUNEW - Dune Acquisition Corp", ticker: "DUNEW" },
    { name: "BLUWW - Blue Water Acquisition Corp.", ticker: "BLUWW" },
    { name: "OUST-WT - Ouster, Inc.", ticker: "OUST-WT" },
    { name: "TBCPU - Thunder Bridge Capital Partners III Inc.", ticker: "TBCPU" },
    { name: "TBCPW - Thunder Bridge Capital Partners III Inc.", ticker: "TBCPW" },
    { name: "IVAN-WT - Ivanhoe Capital Acquisition Corp.", ticker: "IVAN-WT" },
    { name: "GHVIW - Gores Holdings VI, Inc.", ticker: "GHVIW" },
    { name: "XMETD - XXStream Entertainment, Inc.", ticker: "XMETD" },
    { name: "PV-UN - Primavera Capital Acquisition Corp.", ticker: "PV-UN" },
    { name: "PV-WT - Primavera Capital Acquisition Corp.", ticker: "PV-WT" },
    { name: "TWLVU - Twelve Seas Investment Co. II", ticker: "TWLVU" },
    { name: "GMIIU - Gores Metropoulos II, Inc.", ticker: "GMIIU" },
    { name: "GMIIW - Gores Metropoulos II, Inc.", ticker: "GMIIW" },
    { name: "GNPK-WT - Genesis Park Acquisition Corp.", ticker: "GNPK-WT" },
    { name: "OCAXU - OCA Acquisition Corp.", ticker: "OCAXU" },
    { name: "OCAXW - OCA Acquisition Corp.", ticker: "OCAXW" },
    { name: "WARR-UN - Warrior Technologies Acquisition Co", ticker: "WARR-UN" },
    { name: "LEGOW - Legato Merger Corp.", ticker: "LEGOW" },
    { name: "TVACW - Thayer Ventures Acquisition Corp", ticker: "TVACW" },
    { name: "PRPC-UN - CC Neuberger Principal Holdings III", ticker: "PRPC-UN" },
    { name: "PRPC-WT - CC Neuberger Principal Holdings III", ticker: "PRPC-WT" },
    { name: "PTICW - PROPTECH INVESTMENT CORP. II", ticker: "PTICW" },
    { name: "TMKRW - Tastemaker Acquisition Corp.", ticker: "TMKRW" },
    { name: "ADRA-UN - Adara Acquisition Corp.", ticker: "ADRA-UN" },
    { name: "ADRA-WT - Adara Acquisition Corp.", ticker: "ADRA-WT" },
    { name: "TZPSU - TZP Strategies Acquisition Corp.", ticker: "TZPSU" },
    { name: "FCAX-UN - Fortress Capital Acquisition Corp", ticker: "FCAX-UN" },
    { name: "FCAX-WT - Fortress Capital Acquisition Corp", ticker: "FCAX-WT" },
    { name: "CTAQW - Carney Technology Acquisition Corp. II", ticker: "CTAQW" },
    { name: "KWAC-WT - Kingswood Acquisition Corp.", ticker: "KWAC-WT" },
    { name: "MDH-UN - MDH Acquisition Corp.", ticker: "MDH-UN" },
    { name: "MDH-WT - MDH Acquisition Corp.", ticker: "MDH-WT" },
    { name: "KLAQW - KL Acquisition Corp", ticker: "KLAQW" },
    { name: "VOSOU - Virtuoso Acquisition Corp.", ticker: "VOSOU" },
    { name: "VOSOW - Virtuoso Acquisition Corp.", ticker: "VOSOW" },
    { name: "ADERW - 26 Capital Acquisition Corp.", ticker: "ADERW" },
    { name: "ALTUW - Altitude Acquisition Corp.", ticker: "ALTUW" },
    { name: "ENVIU - Environmental Impact Acquisition Corp", ticker: "ENVIU" },
    { name: "ENVIW - Environmental Impact Acquisition Corp", ticker: "ENVIW" },
    { name: "SPRQ-WT - Spartan Acquisition Corp. II", ticker: "SPRQ-WT" },
    { name: "VTAQW - Ventoux CCM Acquisition Corp.", ticker: "VTAQW" },
    { name: "LOKB-WT - Live Oak Acquisition Corp II", ticker: "LOKB-WT" },
    { name: "SCAQU - Stratim Cloud Acquisition Corp.", ticker: "SCAQU" },
    { name: "CAS-WT - Cascade Acquisition Corp", ticker: "CAS-WT" },
    { name: "JCICW - Jack Creek Investment Corp.", ticker: "JCICW" },
    { name: "LHC-WT - Leo Holdings Corp. II", ticker: "LHC-WT" },
    { name: "KAIRW - Kairos Acquisition Corp.", ticker: "KAIRW" },
    { name: "HHLA-UN - HH&L Acquisition Co.", ticker: "HHLA-UN" },
    { name: "HHLA-WT - HH&L Acquisition Co.", ticker: "HHLA-WT" },
    { name: "CND-WT - Concord Acquisition Corp", ticker: "CND-WT" },
    { name: "FVT-WT - Fortress Value Acquisition Corp. III", ticker: "FVT-WT" },
    { name: "RAACW - Revolution Acceleration Acquisition Corp", ticker: "RAACW" },
    { name: "ATAC-UN - ALTIMAR ACQUISITION CORP.", ticker: "ATAC-UN" },
    { name: "ATAC-WT - ALTIMAR ACQUISITION CORP.", ticker: "ATAC-WT" },
    { name: "GFX-WT - Golden Falcon Acquisition Corp.", ticker: "GFX-WT" },
    { name: "VHAQ-RI - Viveon Health Acquisition Corp.", ticker: "VHAQ-RI" },
    { name: "VHAQ-WT - Viveon Health Acquisition Corp.", ticker: "VHAQ-WT" },
    { name: "SNRHW - Senior Connect Acquisition Corp. I", ticker: "SNRHW" },
    { name: "IIAC-WT - Investindustrial Acquisition Corp.", ticker: "IIAC-WT" },
    { name: "PCPC-WT - Periphas Capital Partnering Corp", ticker: "PCPC-WT" },
    { name: "NOACW - Natural Order Acquisition Corp.", ticker: "NOACW" },
    { name: "CHFW-WT - Consonance-HFW Acquisition Corp.", ticker: "CHFW-WT" },
    { name: "ATA-WT - AMERICAS TECHNOLOGY ACQUISITION CORP.", ticker: "ATA-WT" },
    { name: "BIOTW - Biotech Acquisition Co", ticker: "BIOTW" },
    { name: "BIOTU - Biotech Acquisition Co", ticker: "BIOTU" },
    { name: "PRSRW - Prospector Capital Corp.", ticker: "PRSRW" },
    { name: "CRU-WT - Crucible Acquisition Corp", ticker: "CRU-WT" },
    { name: "SPFR-WT - JAWS Spitfire Acquisition Corp", ticker: "SPFR-WT" },
    { name: "CFIVW - CF ACQUISITION CORP. IV", ticker: "CFIVW" },
    { name: "MIT-UN - Mason Industrial Technology, Inc.", ticker: "MIT-UN" },
    { name: "MIT-WT - Mason Industrial Technology, Inc.", ticker: "MIT-WT" },
    { name: "VIIAW - 7GC & Co. Holdings Inc.", ticker: "VIIAW" },
    { name: "KAIIU - Kismet Acquisition Two Corp.", ticker: "KAIIU" },
    { name: "KIIIU - Kismet Acquisition Three Corp.", ticker: "KIIIU" },
    { name: "SPKBU - Silver Spike Acquisition Corp II", ticker: "SPKBU" },
    { name: "SLCRW - Silver Crest Acquisition Corp", ticker: "SLCRW" },
    { name: "RMGDU - RMG Acquisition Corp. IV", ticker: "RMGDU" },
    { name: "GGPIU - Gores Guggenheim, Inc.", ticker: "GGPIU" },
    { name: "AMCIW - AMCI Acquisition Corp. II", ticker: "AMCIW" },
    { name: "TBSAU - TB SA Acquisition Corp", ticker: "TBSAU" },
    { name: "LCAHU - Landcadia Holdings IV, Inc.", ticker: "LCAHU" },
    { name: "CRZNU - Corazon Capital V838 Monoceros Corp", ticker: "CRZNU" },
    { name: "ACBAU - Ace Global Business Acquisition Ltd", ticker: "ACBAU" },
    { name: "AGGRU - Agile Growth Corp.", ticker: "AGGRU" },
    { name: "SBII-UN - Sandbridge X2 Corp", ticker: "SBII-UN" },
    { name: "CNAQU - CHARDAN NEXTECH ACQUISITION CORP.", ticker: "CNAQU" },
    { name: "PDOT-UN - Peridot Acquisition Corp. II", ticker: "PDOT-UN" },
    { name: "VGII-UN - Virgin Group Acquisition Corp. II", ticker: "VGII-UN" },
    { name: "FRONU - Frontier Acquisition Corp.", ticker: "FRONU" },
    { name: "KAHC-UN - KKR Acquisition Holdings I Corp.", ticker: "KAHC-UN" },
    { name: "BYTSU - BYTE Acquisition Corp.", ticker: "BYTSU" },
    { name: "HERAU - FTAC Hera Acquisition Corp.", ticker: "HERAU" },
    { name: "AMAOU - American Acquisition Opportunity Inc.", ticker: "AMAOU" },
    { name: "KSICU - Kadem Sustainable Impact Corp", ticker: "KSICU" },
    { name: "NGCAU - NextGen Acquisition Corp. II", ticker: "NGCAU" },
    { name: "NGC-UN - Northern Genesis Acquisition Corp. III", ticker: "NGC-UN" },
    { name: "OPA-UN - Magnum Opus Acquisition Ltd", ticker: "OPA-UN" },
    { name: "SONY - SONY CORP", ticker: "SONY" },
    { name: "ATLKY - ATLAS COPCO AB", ticker: "ATLKY" },
    { name: "BIOGY - BioGaia AB/ADR", ticker: "BIOGY" },
    { name: "NMGRD - Nouveau Monde Mining Enterprises Inc.", ticker: "NMGRD" },
    { name: "CTOS - Custom Truck One Source, Inc.", ticker: "CTOS" },
    { name: "CSLI - Critical Solutions, Inc.", ticker: "CSLI" },
    { name: "OOGI - C2E ENERGY, INC.", ticker: "OOGI" },
    { name: "CORG - CORDIA CORP", ticker: "CORG" },
    { name: "LVPA - FINOTEC GROUP INC", ticker: "LVPA" },
    { name: "CENBF - CEN BIOTECH INC", ticker: "CENBF" },
    { name: "IMTH - Fresh Harvest Products, Inc.", ticker: "IMTH" },
    { name: "IMPL - IMPEL NEUROPHARMA INC", ticker: "IMPL" },
    { name: "CHSN - Chanson International Holding", ticker: "CHSN" },
    { name: "ANEB - Anebulo Pharmaceuticals, Inc.", ticker: "ANEB" },
    { name: "LYT - Lytus Technologies Holdings PTV. Ltd.", ticker: "LYT" },
    { name: "BAMR - Brookfield Asset Management Reinsurance Partners Ltd.", ticker: "BAMR" },
    { name: "SWIM - Latham Group, Inc.", ticker: "SWIM" },
    { name: "PWSC - POWERSCHOOL HOLDINGS, INC.", ticker: "PWSC" },
    { name: "AVAH - Aveanna Healthcare Holdings, Inc.", ticker: "AVAH" },
    { name: "OSI - Osiris Acquisition Corp.", ticker: "OSI" },
    { name: "SHMY - Synergy Empire Ltd", ticker: "SHMY" },
    { name: "EDR - Endeavor Group Holdings, Inc.", ticker: "EDR" },
    { name: "RAIN - Rain Therapeutics Inc.", ticker: "RAIN" },
    { name: "ASTS - AST SpaceMobile, Inc.", ticker: "ASTS" },
    { name: "DGON - Black Dragon Acquisition Corp. I", ticker: "DGON" },
    { name: "EGGF - EG Acquisition Corp.", ticker: "EGGF" },
    { name: "ILAC - Innovatus Life Sciences Acquisition Corp.", ticker: "ILAC" },
    { name: "BWMN - Bowman Consulting Group Ltd.", ticker: "BWMN" },
    { name: "AURV - Aurvandil Acquisition Corp.", ticker: "AURV" },
    { name: "LPC - Lamar Partnering Corp", ticker: "LPC" },
    { name: "VRAR - Glimpse Group, Inc.", ticker: "VRAR" },
    { name: "ZT - Zimmer Energy Transition Acquisition Corp.", ticker: "ZT" },
    { name: "TRIS - Tristar Acquisition I Corp.", ticker: "TRIS" },
    { name: "NMTCD - NEUROONE MEDICAL TECHNOLOGIES Corp", ticker: "NMTCD" },
    { name: "PHIG - PHI Group, Inc./DE", ticker: "PHIG" },
    { name: "SCHW-PJ - SCHWAB CHARLES CORP", ticker: "SCHW-PJ" },
    { name: "PHIGW - PHI Group, Inc./DE", ticker: "PHIGW" },
    { name: "CTOS-WT - Custom Truck One Source, Inc.", ticker: "CTOS-WT" },
    { name: "FOREW - Foresight Acquisition Corp.", ticker: "FOREW" },
    { name: "BITE-WT - Bite Acquisition Corp.", ticker: "BITE-WT" },
    { name: "FOA-WT - Finance of America Companies Inc.", ticker: "FOA-WT" },
    { name: "CVII-WT - Churchill Capital Corp VII", ticker: "CVII-WT" },
    { name: "CCVI-WT - Churchill Capital Corp VI", ticker: "CCVI-WT" },
    { name: "SLAC-WT - Social Leverage Acquisition Corp I", ticker: "SLAC-WT" },
    { name: "IACB-WT - ION Acquisition Corp 2 Ltd.", ticker: "IACB-WT" },
    { name: "MACAW - Moringa Acquisition Corp", ticker: "MACAW" },
    { name: "PICC-WT - Pivotal Investment Corp III", ticker: "PICC-WT" },
    { name: "INVZW - Innoviz Technologies Ltd.", ticker: "INVZW" },
    { name: "SPAQ-WT - Spartan Acquisition Corp. III", ticker: "SPAQ-WT" },
    { name: "CHAA-UN - Catcha Investment Corp", ticker: "CHAA-UN" },
    { name: "CHAA-WT - Catcha Investment Corp", ticker: "CHAA-WT" },
    { name: "APGB-WT - Apollo Strategic Growth Capital II", ticker: "APGB-WT" },
    { name: "HOMU - XXStream Entertainment, Inc.", ticker: "HOMU" },
    { name: "TIOAU - Tio Tech A", ticker: "TIOAU" },
    { name: "ZTU - Zimmer Energy Transition Acquisition Corp.", ticker: "ZTU" },
    { name: "ZTW - Zimmer Energy Transition Acquisition Corp.", ticker: "ZTW" },
    { name: "CMLTU - CM Life Sciences III Inc.", ticker: "CMLTU" },
    { name: "IFNNY - INFINEON TECHNOLOGIES AG", ticker: "IFNNY" },
    { name: "PATH - UiPath, Inc.", ticker: "PATH" },
    { name: "MRVL - Marvell Technology, Inc.", ticker: "MRVL" },
    { name: "KKOYY - Kesko OYJ", ticker: "KKOYY" },
    { name: "MIUFY - Mitsubishi UFJ Lease & Finance Co., Ltd.", ticker: "MIUFY" },
    { name: "LGO - Largo Resources Ltd.", ticker: "LGO" },
    { name: "FHAI - FOUNTAIN HEALTHY AGING, INC.", ticker: "FHAI" },
    { name: "BTCM - BIT Mining Ltd", ticker: "BTCM" },
    { name: "CTLP - CANTALOUPE, INC.", ticker: "CTLP" },
    { name: "TFAN - TradeFan, Inc.", ticker: "TFAN" },
    { name: "AUD - AUDACY, INC.", ticker: "AUD" },
    { name: "BMEA - Biomea Fusion, Inc.", ticker: "BMEA" },
    { name: "SHGFF - Skylight Health Group Inc.", ticker: "SHGFF" },
    { name: "MYMD - MyMD Pharmaceuticals, Inc.", ticker: "MYMD" },
    { name: "BSPI - Business Solutions Plus, Inc.", ticker: "BSPI" },
    { name: "IFBD - Infobird Co., Ltd", ticker: "IFBD" },
    { name: "TRKA - Troika Media Group, Inc.", ticker: "TRKA" },
    { name: "CGRN - Capstone Green Energy Corp", ticker: "CGRN" },
    { name: "SOMC - SOUTHERN MICHIGAN BANCORP INC", ticker: "SOMC" },
    { name: "PSHIF - PetroShale Inc.", ticker: "PSHIF" },
    { name: "GWSO - Global Warming Solutions, Inc.", ticker: "GWSO" },
    { name: "NLSP - NLS Pharmaceutics Ltd.", ticker: "NLSP" },
    { name: "ATAI - ATAI Life Sciences B.V.", ticker: "ATAI" },
    { name: "SVVC - Firsthand Technology Value Fund, Inc.", ticker: "SVVC" },
    { name: "IMHC - IMPERALIS HOLDING CORP.", ticker: "IMHC" },
    { name: "ENDMF - Crystal Lake Mining Corp", ticker: "ENDMF" },
    { name: "NUWE - Nuwellis, Inc.", ticker: "NUWE" },
    { name: "PCST - PURE CAPITAL SOLUTIONS, INC.", ticker: "PCST" },
    { name: "ARAT - Arax Holdings Corp", ticker: "ARAT" },
    { name: "FEMFF - First Energy Metals Ltd", ticker: "FEMFF" },
    { name: "FDMSF - FANDOM SPORTS MEDIA CORP.", ticker: "FDMSF" },
    { name: "APSI - AQUA POWER SYSTEMS INC.", ticker: "APSI" },
    { name: "TPII - Triad Pro Innovators, Inc.", ticker: "TPII" },
    { name: "PGLO - PAN GLOBAL, CORP.", ticker: "PGLO" },
    { name: "CRXM - Gene Biotherapeutics, Inc.", ticker: "CRXM" },
    { name: "BTFL - Bountiful Co", ticker: "BTFL" },
    { name: "APLD - Applied Digital Corporation", ticker: "APLD" },
    { name: "RKOS - Arkose Energy Corp.", ticker: "RKOS" },
    { name: "MASN - Clikia Corp.", ticker: "MASN" },
    { name: "ECDD - ECRID, INC", ticker: "ECDD" },
    { name: "CLNV - Byzen Digital, Inc.", ticker: "CLNV" },
    { name: "MYTG - Mu Yan Technology Group Co., Ltd", ticker: "MYTG" },
    { name: "ZIP - ZIPRECRUITER, INC.", ticker: "ZIP" },
    { name: "CMSL - CAMPOSOL HOLDING PLC", ticker: "CMSL" },
    { name: "HNST - Honest Company, Inc.", ticker: "HNST" },
    { name: "VNMT - Vemanti Group, Inc.", ticker: "VNMT" },
    { name: "PALI - PALISADE BIO, INC.", ticker: "PALI" },
    { name: "SGMT - Sagimet Biosciences Inc.", ticker: "SGMT" },
    { name: "SQSP - Squarespace, Inc.", ticker: "SQSP" },
    { name: "AFDG - Earn-A-Car Inc.", ticker: "AFDG" },
    { name: "GROUY - Grafton Group plc", ticker: "GROUY" },
    { name: "FSBC - FIVE STAR BANCORP", ticker: "FSBC" },
    { name: "MIGI - Mawson Infrastructure Group Inc.", ticker: "MIGI" },
    { name: "CITY - AVALON CORRECTIONAL SERVICES INC", ticker: "CITY" },
    { name: "WDH - Waterdrop Inc.", ticker: "WDH" },
    { name: "GLSPT - Global SPAC Partners Co,", ticker: "GLSPT" },
    { name: "RTVA - Artiva Biotherapeutics, Inc.", ticker: "RTVA" },
    { name: "HCG - hear.com N.V.", ticker: "HCG" },
    { name: "ISLE - Isleworth Healthcare Acquisition Corp.", ticker: "ISLE" },
    { name: "VISN - Gyroscope Therapeutics Holdings Ltd", ticker: "VISN" },
    { name: "ZENV - Zenvia Inc.", ticker: "ZENV" },
    { name: "PYCR - PAYCOR HCM, INC.", ticker: "PYCR" },
    { name: "NABL - N-able, Inc.", ticker: "NABL" },
    { name: "VALN - Valneva SE", ticker: "VALN" },
    { name: "VACC - Vaccitech plc", ticker: "VACC" },
    { name: "TALS - Talaris Therapeutics, Inc.", ticker: "TALS" },
    { name: "SLDX - JMD Properties, Inc.", ticker: "SLDX" },
    { name: "TASK - TaskUs, Inc.", ticker: "TASK" },
    { name: "OG - Onion Global Ltd", ticker: "OG" },
    { name: "VERA - Vera Therapeutics, Inc.", ticker: "VERA" },
    { name: "PRVA - Privia Health Group, Inc.", ticker: "PRVA" },
    { name: "BSEC - AXELEREX CORP.", ticker: "BSEC" },
    { name: "BITW - Bitwise 10 Crypto Index Fund", ticker: "BITW" },
    { name: "MOLN - MOLECULAR PARTNERS AG", ticker: "MOLN" },
    { name: "GRVI - GROVE, INC.", ticker: "GRVI" },
    { name: "HOWL - Werewolf Therapeutics, Inc.", ticker: "HOWL" },
    { name: "TCRX - TScan Therapeutics, Inc.", ticker: "TCRX" },
    { name: "RICO - Agrico Acquisition Corp.", ticker: "RICO" },
    { name: "OTLY - Oatly Group AB", ticker: "OTLY" },
    { name: "SMWB - SIMILARWEB LTD.", ticker: "SMWB" },
    { name: "GPCO - Golden Path Acquisition Corp", ticker: "GPCO" },
    { name: "KTTA - Pasithea Therapeutics Corp.", ticker: "KTTA" },
    { name: "PICS - PicS Ltd.", ticker: "PICS" },
    { name: "IMAQ - International Media Acquisition Corp.", ticker: "IMAQ" },
    { name: "OTEC - OceanTech Acquisitions I Corp.", ticker: "OTEC" },
    { name: "PCCT - Perception Capital Corp. II", ticker: "PCCT" },
    { name: "FREY - FREYR Battery", ticker: "FREY" },
    { name: "ALIT - Alight, Inc. /DE", ticker: "ALIT" },
    { name: "FWAC - Fifth Wall Acquisition Corp. III", ticker: "FWAC" },
    { name: "CNTA - Centessa Pharmaceuticals Ltd", ticker: "CNTA" },
    { name: "LAAA - Lakeshore Acquisition I Corp.", ticker: "LAAA" },
    { name: "PBRM - Parabellum Acquisition Corp.", ticker: "PBRM" },
    { name: "SWGC - Stillwater Growth Corp. I", ticker: "SWGC" },
    { name: "GIW - GigInternational1, Inc.", ticker: "GIW" },
    { name: "CLOE - Clover Leaf Capital Corp.", ticker: "CLOE" },
    { name: "SCIB - Science Strategic Acquisition Corp. Bravo", ticker: "SCIB" },
    { name: "SCIC - Science Strategic Acquisition Corp. Charlie", ticker: "SCIC" },
    { name: "ZETA - Zeta Global Holdings Corp.", ticker: "ZETA" },
    { name: "TACQ - Tetragon Acquisition Corp I", ticker: "TACQ" },
    { name: "GLTA - Galata Acquisition Corp.", ticker: "GLTA" },
    { name: "MCAE - Mountain Crest Acquisition Corp. III", ticker: "MCAE" },
    { name: "KORE - King Pubco, Inc.", ticker: "KORE" },
    { name: "VEEE - Twin Vee PowerCats, Co.", ticker: "VEEE" },
    { name: "STZ-B - CONSTELLATION BRANDS, INC.", ticker: "STZ-B" },
    { name: "BXP-PB - BOSTON PROPERTIES INC", ticker: "BXP-PB" },
    { name: "RF-PC - REGIONS FINANCIAL CORP", ticker: "RF-PC" },
    { name: "RF-PB - REGIONS FINANCIAL CORP", ticker: "RF-PB" },
    { name: "RF-PA - REGIONS FINANCIAL CORP", ticker: "RF-PA" },
    { name: "EPR-PG - EPR PROPERTIES", ticker: "EPR-PG" },
    { name: "MFA-PB - MFA FINANCIAL, INC.", ticker: "MFA-PB" },
    { name: "NS-PA - NuStar Energy L.P.", ticker: "NS-PA" },
    { name: "NS-PB - NuStar Energy L.P.", ticker: "NS-PB" },
    { name: "NS-PC - NuStar Energy L.P.", ticker: "NS-PC" },
    { name: "ENGMF - Enthusiast Gaming Holdings Inc. / Canada", ticker: "ENGMF" },
    { name: "HT-PD - HERSHA HOSPITALITY TRUST", ticker: "HT-PD" },
    { name: "HT-PE - HERSHA HOSPITALITY TRUST", ticker: "HT-PE" },
    { name: "HT-PC - HERSHA HOSPITALITY TRUST", ticker: "HT-PC" },
    { name: "MITT-PA - AG Mortgage Investment Trust, Inc.", ticker: "MITT-PA" },
    { name: "MITT-PB - AG Mortgage Investment Trust, Inc.", ticker: "MITT-PB" },
    { name: "CIO-PA - City Office REIT, Inc.", ticker: "CIO-PA" },
    { name: "CAI-PB - CAI International, Inc.", ticker: "CAI-PB" },
    { name: "GECCL - Great Elm Capital Corp.", ticker: "GECCL" },
    { name: "HCAPZ - Harvest Capital Credit Corp", ticker: "HCAPZ" },
    { name: "OMWSD - OMNIA WELLNESS INC.", ticker: "OMWSD" },
    { name: "AVLND - Avalon Advanced Materials Inc.", ticker: "AVLND" },
    { name: "FPFID - Rogue One, Inc.", ticker: "FPFID" },
    { name: "IALS - Business Solutions Plus, Inc.", ticker: "IALS" },
    { name: "JMDP - JMD Properties, Inc.", ticker: "JMDP" },
    { name: "BYZN - Byzen Digital, Inc.", ticker: "BYZN" },
    { name: "CCURD - CCUR Holdings, Inc.", ticker: "CCURD" },
    { name: "NEE-PK - NEXTERA ENERGY INC", ticker: "NEE-PK" },
    { name: "NEE-PN - NEXTERA ENERGY INC", ticker: "NEE-PN" },
    { name: "CTLPP - CANTALOUPE, INC.", ticker: "CTLPP" },
    { name: "EPR-PC - EPR PROPERTIES", ticker: "EPR-PC" },
    { name: "EPR-PE - EPR PROPERTIES", ticker: "EPR-PE" },
    { name: "MFA-PC - MFA FINANCIAL, INC.", ticker: "MFA-PC" },
    { name: "TRKAW - Troika Media Group, Inc.", ticker: "TRKAW" },
    { name: "NIMC - NISOURCE INC.", ticker: "NIMC" },
    { name: "GTYHW - GTY Technology Holdings Inc.", ticker: "GTYHW" },
    { name: "GECCM - Great Elm Capital Corp.", ticker: "GECCM" },
    { name: "GECCN - Great Elm Capital Corp.", ticker: "GECCN" },
    { name: "REKRW - Rekor Systems, Inc.", ticker: "REKRW" },
    { name: "KREF-PA - KKR Real Estate Finance Trust Inc.", ticker: "KREF-PA" },
    { name: "KKRS - KKR & Co. Inc.", ticker: "KKRS" },
    { name: "TGH-PA - TEXTAINER GROUP HOLDINGS LTD", ticker: "TGH-PA" },
    { name: "HTFB - Horizon Technology Finance Corp", ticker: "HTFB" },
    { name: "RILYT - B. Riley Financial, Inc.", ticker: "RILYT" },
    { name: "RSRL - Resource Real Estate Opportunity REIT, Inc.", ticker: "RSRL" },
    { name: "GCACW - Growth Capital Acquisition Corp.", ticker: "GCACW" },
    { name: "MITT-PC - AG Mortgage Investment Trust, Inc.", ticker: "MITT-PC" },
    { name: "RILYK - B. Riley Financial, Inc.", ticker: "RILYK" },
    { name: "VENAW - Venus Acquisition Corp", ticker: "VENAW" },
    { name: "NUVB-WT - Nuvation Bio Inc.", ticker: "NUVB-WT" },
    { name: "ASTSW - AST SpaceMobile, Inc.", ticker: "ASTSW" },
    { name: "NLSPW - NLS Pharmaceutics Ltd.", ticker: "NLSPW" },
    { name: "FLME-WT - Flame Acquisition Corp.", ticker: "FLME-WT" },
    { name: "SRNGW - Soaring Eagle Acquisition Corp.", ticker: "SRNGW" },
    { name: "MRACU - Marquee Raine Acquisition Corp.", ticker: "MRACU" },
    { name: "MRACW - Marquee Raine Acquisition Corp.", ticker: "MRACW" },
    { name: "CFVIW - CF Acquisition Corp. VI", ticker: "CFVIW" },
    { name: "ANAC-WT - ARCTOS NORTHSTAR ACQUISITION CORP.", ticker: "ANAC-WT" },
    { name: "ALFIW - Alfi, Inc.", ticker: "ALFIW" },
    { name: "GENI-WT - Genius Sports Ltd", ticker: "GENI-WT" },
    { name: "IBER-WT - IBERE PHARMACEUTICALS", ticker: "IBER-WT" },
    { name: "WPCA-WT - Warburg Pincus Capital Corp I-A", ticker: "WPCA-WT" },
    { name: "SPTKW - SportsTek Acquisition Corp.", ticker: "SPTKW" },
    { name: "ASPCW - Alpha Capital Acquisition Co", ticker: "ASPCW" },
    { name: "TWNI-WT - Tailwind International Acquisition Corp.", ticker: "TWNI-WT" },
    { name: "NSTC-WT - Northern Star Investment Corp. III", ticker: "NSTC-WT" },
    { name: "NSTD-WT - Northern Star Investment Corp. IV", ticker: "NSTD-WT" },
    { name: "SLAMW - Slam Corp.", ticker: "SLAMW" },
    { name: "AUS-WT - Austerlitz Acquisition Corp I", ticker: "AUS-WT" },
    { name: "TSPQ-WT - TCW Special Purpose Acquisition Corp.", ticker: "TSPQ-WT" },
    { name: "CMIIW - CM Life Sciences II Inc.", ticker: "CMIIW" },
    { name: "PMGMW - Priveterra Acquisition Corp.", ticker: "PMGMW" },
    { name: "MBTCU - Nocturne Acquisition Corp", ticker: "MBTCU" },
    { name: "DMYQ-WT - dMY Technology Group, Inc. IV", ticker: "DMYQ-WT" },
    { name: "SNII-WT - Supernova Partners Acquisition Co II, Ltd.", ticker: "SNII-WT" },
    { name: "NVSAW - New Vista Acquisition Corp", ticker: "NVSAW" },
    { name: "FACT-WT - Freedom Acquisition I Corp.", ticker: "FACT-WT" },
    { name: "FACA-WT - Figure Acquisition Corp. I", ticker: "FACA-WT" },
    { name: "IPVA-WT - InterPrivate II Acquisition Corp.", ticker: "IPVA-WT" },
    { name: "IPVF-WT - InterPrivate III Financial Partners Inc.", ticker: "IPVF-WT" },
    { name: "PFDRW - Pathfinder Acquisition Corp", ticker: "PFDRW" },
    { name: "MBAC-WT - M3-Brigade Acquisition II Corp.", ticker: "MBAC-WT" },
    { name: "SPGS-WT - Simon Property Group Acquisition Holdings, Inc.", ticker: "SPGS-WT" },
    { name: "ASZ-WT - Austerlitz Acquisition Corp II", ticker: "ASZ-WT" },
    { name: "WARR-WT - Warrior Technologies Acquisition Co", ticker: "WARR-WT" },
    { name: "GBRGR - Goldenbridge Acquisition Ltd", ticker: "GBRGR" },
    { name: "GBRGW - Goldenbridge Acquisition Ltd", ticker: "GBRGW" },
    { name: "ACACW - Acies Acquisition Corp.", ticker: "ACACW" },
    { name: "KAIIW - Kismet Acquisition Two Corp.", ticker: "KAIIW" },
    { name: "FSNB-WT - Fusion Acquisition Corp. II", ticker: "FSNB-WT" },
    { name: "MACC-WT - Mission Advancement Corp.", ticker: "MACC-WT" },
    { name: "LIII-WT - Leo Holdings III Corp.", ticker: "LIII-WT" },
    { name: "ISOS-WT - Isos Acquisition Corp.", ticker: "ISOS-WT" },
    { name: "TRCA-WT - Twin Ridge Capital Acquisition Corp.", ticker: "TRCA-WT" },
    { name: "LOKM-WT - Live Oak Mobility Acquisition Corp.", ticker: "LOKM-WT" },
    { name: "AGGRW - Agile Growth Corp.", ticker: "AGGRW" },
    { name: "TTE - TotalEnergies SE", ticker: "TTE" },
    { name: "IDEXY - Industria de Diseno Textil Inditex SA / ADR", ticker: "IDEXY" },
    { name: "BF-A - BROWN FORMAN CORP", ticker: "BF-A" },
    { name: "DNHBY - DnB NOR ASA", ticker: "DNHBY" },
    { name: "WEGZY - Weg SA", ticker: "WEGZY" },
    { name: "ANYYY - Aena S.A./ADR", ticker: "ANYYY" },
    { name: "GRUB - Just Eat Takeaway.com N.V.", ticker: "GRUB" },
    { name: "BZ - Kanzhun Ltd", ticker: "BZ" },
    { name: "SOFI - SoFi Technologies, Inc.", ticker: "SOFI" },
    { name: "SWMAY - SWEDISH MATCH CORP", ticker: "SWMAY" },
    { name: "PCOR - PROCORE TECHNOLOGIES, INC.", ticker: "PCOR" },
    { name: "JPXGY - Japan Exchange Group, Inc./ADR", ticker: "JPXGY" },
    { name: "LFST - LifeStance Health Group, Inc.", ticker: "LFST" },
    { name: "REMYY - Remy Cointreau/ADR", ticker: "REMYY" },
    { name: "MNDY - monday.com Ltd.", ticker: "MNDY" },
    { name: "FIGS - FIGS, Inc.", ticker: "FIGS" },
    { name: "CCOEY - Capcom Co., LTD/ADR", ticker: "CCOEY" },
    { name: "NEGG - Newegg Commerce, Inc.", ticker: "NEGG" },
    { name: "FYBR - Frontier Communications Parent, Inc.", ticker: "FYBR" },
    { name: "CANO - Cano Health, Inc.", ticker: "CANO" },
    { name: "ME - 23andMe Holding Co.", ticker: "ME" },
    { name: "TAIPY - Taisho Pharmaceutical Holdings Co Ltd./ADR", ticker: "TAIPY" },
    { name: "PAY - Paymentus Holdings, Inc.", ticker: "PAY" },
    { name: "LYEL - Lyell Immunopharma, Inc.", ticker: "LYEL" },
    { name: "DBRG - DigitalBridge Group, Inc.", ticker: "DBRG" },
    { name: "FLYW - Flywire Corp", ticker: "FLYW" },
    { name: "TMBBY - TMB Bank Public Co Limited/ADR", ticker: "TMBBY" },
    { name: "RERE - AiHuiShou International Co. Ltd.", ticker: "RERE" },
    { name: "MNTV - MOMENTIVE GLOBAL INC.", ticker: "MNTV" },
    { name: "VERV - Verve Therapeutics, Inc.", ticker: "VERV" },
    { name: "WKME - WalkMe Ltd.", ticker: "WKME" },
    { name: "UILCY - United Industrial Corp Ltd", ticker: "UILCY" },
    { name: "ZME - Zhangmen Education Inc.", ticker: "ZME" },
    { name: "ALBKY - ALPHA BANK AE /FI", ticker: "ALBKY" },
    { name: "OMIC - Singular Genomics Systems, Inc.", ticker: "OMIC" },
    { name: "INST - INSTRUCTURE HOLDINGS, INC.", ticker: "INST" },
    { name: "ERO - Ero Copper Corp.", ticker: "ERO" },
    { name: "AWWH - Ascend Wellness Holdings, Inc", ticker: "AWWH" },
    { name: "LTCH - Latch, Inc.", ticker: "LTCH" },
    { name: "IPSC - Century Therapeutics, Inc.", ticker: "IPSC" },
    { name: "TGSGY - TGS NOPEC Geophysical CO", ticker: "TGSGY" },
    { name: "MYTAY - Magyar Telekom Plc.", ticker: "MYTAY" },
    { name: "DAWN - Day One Biopharmaceuticals, Inc.", ticker: "DAWN" },
    { name: "CCHWF - Columbia Care Inc.", ticker: "CCHWF" },
    { name: "GIC - GLOBAL INDUSTRIAL Co", ticker: "GIC" },
    { name: "TRMR - Tremor International Ltd.", ticker: "TRMR" },
    { name: "DIBS - 1stdibs.com, Inc.", ticker: "DIBS" },
    { name: "WFRD - Weatherford International plc", ticker: "WFRD" },
    { name: "NAUT - Nautilus Biotechnology, Inc.", ticker: "NAUT" },
    { name: "KPLT - Katapult Holdings, Inc.", ticker: "KPLT" },
    { name: "ACHN - Achison Inc", ticker: "ACHN" },
    { name: "SKIL - Skillsoft Corp.", ticker: "SKIL" },
    { name: "BLDE - Blade Air Mobility, Inc.", ticker: "BLDE" },
    { name: "NEWP - NEW PACIFIC METALS CORP", ticker: "NEWP" },
    { name: "ALZN - Alzamend Neuro, Inc.", ticker: "ALZN" },
    { name: "AMAM - Ambrx Biopharma Inc.", ticker: "AMAM" },
    { name: "CYT - Cyteir Therapeutics, Inc.", ticker: "CYT" },
    { name: "VWE - Vintage Wine Estates, Inc.", ticker: "VWE" },
    { name: "HUT - HUT 8 MINING CORP.", ticker: "HUT" },
    { name: "DNAY - Codex DNA, Inc.", ticker: "DNAY" },
    { name: "ZEV - Lightning eMotors, Inc.", ticker: "ZEV" },
    { name: "ATY - AcuityAds Holdings Inc.", ticker: "ATY" },
    { name: "STEM - STEM, INC.", ticker: "STEM" },
    { name: "BITF - Bitfarms Ltd", ticker: "BITF" },
    { name: "MAPS - WM TECHNOLOGY, INC.", ticker: "MAPS" },
    { name: "NRXP - NRX Pharmaceuticals, Inc.", ticker: "NRXP" },
    { name: "ATER - Aterian, Inc.", ticker: "ATER" },
    { name: "AOMR - Angel Oak Mortgage, Inc.", ticker: "AOMR" },
    { name: "SBNC - SOUTHERN BANCSHARES NC INC", ticker: "SBNC" },
    { name: "TTSH - TILE SHOP HOLDINGS, INC.", ticker: "TTSH" },
    { name: "ELLKY - Ellaktor SA / ADR", ticker: "ELLKY" },
    { name: "BLUA - BlueRiver Acquisition Corp.", ticker: "BLUA" },
    { name: "DNZ - D & Z Media Acquisition Corp.", ticker: "DNZ" },
    { name: "HCCC - Healthcare Capital Corp/DE", ticker: "HCCC" },
    { name: "ABIT - GAMEPLAN INC", ticker: "ABIT" },
    { name: "QOEG - ADGS Advisory, Inc.", ticker: "QOEG" },
    { name: "DYNS - Dynamics Special Purpose Corp.", ticker: "DYNS" },
    { name: "GDNSF - Goodness Growth Holdings, Inc.", ticker: "GDNSF" },
    { name: "LWAC - Locust Walk Acquisition Corp.", ticker: "LWAC" },
    { name: "ELEK - China Xuefeng Environmental Engineering Inc.", ticker: "ELEK" },
    { name: "QIPT - Quipt Home Medical Corp.", ticker: "QIPT" },
    { name: "VQSLF - VIQ Solutions Inc.", ticker: "VQSLF" },
    { name: "GAME - Engine Media Holdings, Inc.", ticker: "GAME" },
    { name: "SLHG - Skylight Health Group Inc.", ticker: "SLHG" },
    { name: "FOSYF - Forsys Metals Corp", ticker: "FOSYF" },
    { name: "CPKF - CHESAPEAKE FINANCIAL SHARES INC", ticker: "CPKF" },
    { name: "ENMPY - Ensurge Micropower ASA/ADR", ticker: "ENMPY" },
    { name: "UTME - UTime Ltd", ticker: "UTME" },
    { name: "GSVRF - VANGOLD MINING CORP.", ticker: "GSVRF" },
    { name: "FHBI - BayFirst Financial Corp.", ticker: "FHBI" },
    { name: "BMXI - BROOKMOUNT EXPLORATIONS INC", ticker: "BMXI" },
    { name: "DBGI - Digital Brands Group, Inc.", ticker: "DBGI" },
    { name: "GXSFD - Goldsource Mines Inc.", ticker: "GXSFD" },
    { name: "AGGL - Agtech Global International Inc", ticker: "AGGL" },
    { name: "BMBIF - BRIGHT MINDS BIOSCIENCES INC.", ticker: "BMBIF" },
    { name: "BTB - Bit Brother Ltd", ticker: "BTB" },
    { name: "SILEF - Silver Elephant Mining Corp.", ticker: "SILEF" },
    { name: "CPSL - Catapult Solutions, Inc.", ticker: "CPSL" },
    { name: "LEXX - Lexaria Bioscience Corp.", ticker: "LEXX" },
    { name: "SNPX - Synaptogenix, Inc.", ticker: "SNPX" },
    { name: "RSLS - ReShape Lifesciences Inc.", ticker: "RSLS" },
    { name: "NUBC - NORTHUMBERLAND BANCORP", ticker: "NUBC" },
    { name: "OAKV - Oak View Bankshares, Inc.", ticker: "OAKV" },
    { name: "TPIA - Mycotopia Therapies, Inc.", ticker: "TPIA" },
    { name: "PMEDF - Predictmedix Inc.", ticker: "PMEDF" },
    { name: "HGYN - Cereplast Inc", ticker: "HGYN" },
    { name: "GROM - Grom Social Enterprises, Inc.", ticker: "GROM" },
    { name: "CGOLF - Contact Gold Corp.", ticker: "CGOLF" },
    { name: "IRNS - IRONSTONE GROUP INC", ticker: "IRNS" },
    { name: "NEWH - NewHydrogen, Inc.", ticker: "NEWH" },
    { name: "CCBC - Chino Commercial Bancorp", ticker: "CCBC" },
    { name: "GDMK - Global Diversified Marketing Group Inc.", ticker: "GDMK" },
    { name: "KGNR - KANGE CORP", ticker: "KGNR" },
    { name: "KOOL - Manycore Tech Inc.", ticker: "KOOL" },
    { name: "FOMC - FOMO CORP.", ticker: "FOMC" },
    { name: "ICCO - INTERCARE DX INC", ticker: "ICCO" },
    { name: "CRFTF - BC Craft Supply Co. Ltd.", ticker: "CRFTF" },
    { name: "BBBT - Black Bird Biotech, Inc.", ticker: "BBBT" },
    { name: "ROAG - Rogue One, Inc.", ticker: "ROAG" },
    { name: "MNVN - MONDIAL VENTURES, INC.", ticker: "MNVN" },
    { name: "CYCA - CYTTA CORP.", ticker: "CYCA" },
    { name: "NVGT - NOVAGANT CORP", ticker: "NVGT" },
    { name: "NUGL - NUGL, INC.", ticker: "NUGL" },
    { name: "WEGYF - WESTBRIDGE ENERGY CORP.", ticker: "WEGYF" },
    { name: "MTPP - MOUNTAIN TOP PROPERTIES, INC.", ticker: "MTPP" },
    { name: "FRTM - Fortium Holdings Corp.", ticker: "FRTM" },
    { name: "JMKJ - Nine Alliance Science & Technology Group", ticker: "JMKJ" },
    { name: "EMAX - Ecomax, Inc", ticker: "EMAX" },
    { name: "WWSG - WORLDWIDE STRATEGIES INC", ticker: "WWSG" },
    { name: "GBUX - GIVBUX, INC.", ticker: "GBUX" },
    { name: "GRHI - GOLD ROCK HOLDINGS, INC.", ticker: "GRHI" },
    { name: "MDWK - MDwerks, Inc.", ticker: "MDWK" },
    { name: "WTKN - WellTek Inc", ticker: "WTKN" },
    { name: "GZIC - GZ6G Technologies Corp.", ticker: "GZIC" },
    { name: "NSAV - Net Savings Link, Inc./DE", ticker: "NSAV" },
    { name: "CHNO - CLASSWORX INC", ticker: "CHNO" },
    { name: "HRAA - HEALTH REVENUE ASSURANCE HOLDINGS, INC.", ticker: "HRAA" },
    { name: "TRON - CORNER GROWTH ACQUISITION CORP. 2", ticker: "TRON" },
    { name: "CBDC - Apotheca Biosciences, Inc.", ticker: "CBDC" },
    { name: "CONC - CONECTISYS CORP", ticker: "CONC" },
    { name: "ODRS - Outdoor Specialty Products, Inc.", ticker: "ODRS" },
    { name: "HPITQ - Hospitality Investors Trust, Inc.", ticker: "HPITQ" },
    { name: "S - SentinelOne, Inc.", ticker: "S" },
    { name: "RMLS - ROMULUS CORP.", ticker: "RMLS" },
    { name: "ROIV - Roivant Sciences Ltd.", ticker: "ROIV" },
    { name: "KBSG - KBS Growth & Income REIT, Inc.", ticker: "KBSG" },
    { name: "LAW - CS Disco, Inc.", ticker: "LAW" },
    { name: "BHG - Bright Health Group Inc.", ticker: "BHG" },
    { name: "TPTA - Terra Property Trust, Inc.", ticker: "TPTA" },
    { name: "ABSI - AbSci Corp", ticker: "ABSI" },
    { name: "XMTR - Xometry, Inc.", ticker: "XMTR" },
    { name: "HTZZ - HERTZ GLOBAL HOLDINGS, INC", ticker: "HTZZ" },
    { name: "CXM - Sprinklr, Inc.", ticker: "CXM" },
    { name: "ABOS - Acumen Pharmaceuticals, Inc.", ticker: "ABOS" },
    { name: "DUOL - Duolingo, Inc.", ticker: "DUOL" },
    { name: "INTA - Intapp, Inc.", ticker: "INTA" },
    { name: "ISPC - iSpecimen Inc.", ticker: "ISPC" },
    { name: "SERA - SERA PROGNOSTICS, INC.", ticker: "SERA" },
    { name: "TPST - Millendo Therapeutics, Inc.", ticker: "TPST" },
    { name: "ONFA - One 4 Art Ltd", ticker: "ONFA" },
    { name: "SLI - STANDARD LITHIUM LTD.", ticker: "SLI" },
    { name: "ELTX - Elicio Therapeutics, Inc.", ticker: "ELTX" },
    { name: "DOCS - Doximity, Inc.", ticker: "DOCS" },
    { name: "MQ - Marqeta, Inc.", ticker: "MQ" },
    { name: "SGHT - Sight Sciences, Inc.", ticker: "SGHT" },
    { name: "GTOR - SPORTS VENUES OF FLORIDA, INC.", ticker: "GTOR" },
    { name: "GTTJ - GTJ REIT, INC.", ticker: "GTTJ" },
    { name: "GJS - STRATS(SM) Trust for Goldman Sachs Group Securities, Series 2006-2", ticker: "GJS" },
    { name: "GJT - STRATS(SM) Trust for Allstate Corp Securities, Series 2006-3", ticker: "GJT" },
    { name: "GJP - STRATS(SM) TRUST FOR DOMINION RESOURCES, INC. SECURITIES, SERIES 2005-6", ticker: "GJP" },
    { name: "GJO - STRATS SM TRUST FOR WAL-MART STORES, INC. SECURITIES, SERIES 2005-4", ticker: "GJO" },
    { name: "RPID - RAPID MICRO BIOSYSTEMS, INC.", ticker: "RPID" },
    { name: "FEMY - FEMASYS INC", ticker: "FEMY" },
    { name: "LHTV - Lightstone Value Plus Real Estate Investment Trust, Inc.", ticker: "LHTV" },
    { name: "JBK - LEHMAN ABS CORP GOLDMAN SACHS CAP 1 SEC BACKED SER 2004-6", ticker: "JBK" },
    { name: "LZ - LEGALZOOM.COM, INC.", ticker: "LZ" },
    { name: "GJH - STRATS SM TRUST FOR U S CELL CORP SEC SERIES 2004 6", ticker: "GJH" },
    { name: "KTN - STRUCTURED PRODUCTS CORP CRED ENHANCE CORTS TR FOR AON CAP A", ticker: "KTN" },
    { name: "KTH - STRUCTURED PRODUCTS CORP CORTS TR FOR PECO ENERGY CAP TR III", ticker: "KTH" },
    { name: "DALN - DallasNews Corp", ticker: "DALN" },
    { name: "ESYE - Easy Energy Inc", ticker: "ESYE" },
    { name: "MMAT - META MATERIALS INC.", ticker: "MMAT" },
    { name: "THCC - Healing Co Inc.", ticker: "THCC" },
    { name: "OB - Outbrain Inc.", ticker: "OB" },
    { name: "CVRX - CVRx, Inc.", ticker: "CVRX" },
    { name: "FA - FIRST ADVANTAGE CORP", ticker: "FA" },
    { name: "AIMD - Ainos, Inc.", ticker: "AIMD" },
    { name: "FNWD - Finward Bancorp", ticker: "FNWD" },
    { name: "CFLT - Confluent, Inc.", ticker: "CFLT" },
    { name: "LVOX - LiveVox Holdings, Inc.", ticker: "LVOX" },
    { name: "BRSP - BrightSpire Capital, Inc.", ticker: "BRSP" },
    { name: "PMTM - Prometheum, Inc.", ticker: "PMTM" },
    { name: "HVBT - HIVE Blockchain Technologies Ltd.", ticker: "HVBT" },
    { name: "LNKB - LINKBANCORP, Inc.", ticker: "LNKB" },
    { name: "ERAS - Erasca, Inc.", ticker: "ERAS" },
    { name: "DIDI - DiDi Global Inc.", ticker: "DIDI" },
    { name: "UNCY - Unicycive Therapeutics, Inc.", ticker: "UNCY" },
    { name: "PWP - Perella Weinberg Partners", ticker: "PWP" },
    { name: "GOTU - GSX Techedu Inc.", ticker: "GOTU" },
    { name: "ACXP - Acurx Pharmaceuticals, Inc.", ticker: "ACXP" },
    { name: "ACT - Enact Holdings, Inc.", ticker: "ACT" },
    { name: "OWL - BLUE OWL CAPITAL INC.", ticker: "OWL" },
    { name: "MYPS - PLAYSTUDIOS, Inc.", ticker: "MYPS" },
    { name: "GLUE - Monte Rosa Therapeutics, Inc.", ticker: "GLUE" },
    { name: "GSUN - Golden Sun Education Group Ltd", ticker: "GSUN" },
    { name: "EZFL - EzFill Holdings Inc", ticker: "EZFL" },
    { name: "BON - Bon Natural Life Ltd", ticker: "BON" },
    { name: "JANX - Janux Therapeutics, Inc.", ticker: "JANX" },
    { name: "SKIN - Beauty Health Co", ticker: "SKIN" },
    { name: "PTRA - Proterra Inc", ticker: "PTRA" },
    { name: "CMAX - CareMax, Inc.", ticker: "CMAX" },
    { name: "HUAK - Huake Holding Biology Co., LTD", ticker: "HUAK" },
    { name: "ASTR - Holicity Inc.", ticker: "ASTR" },
    { name: "GSBYP - Gatsby Digital, Inc.", ticker: "GSBYP" },
    { name: "GRPH - Graphite Bio, Inc.", ticker: "GRPH" },
    { name: "ATIP - ATI Physical Therapy, Inc.", ticker: "ATIP" },
    { name: "QSI - Quantum-Si Inc", ticker: "QSI" },
    { name: "TALK - Talkspace, Inc.", ticker: "TALK" },
    { name: "XPOF - Xponential Fitness, Inc.", ticker: "XPOF" },
    { name: "AMZL - ROX Financial LP", ticker: "AMZL" },
    { name: "ORGN - Origin Materials, Inc.", ticker: "ORGN" },
    { name: "HKD - AMTD Digital Inc.", ticker: "HKD" },
    { name: "GAEGF - Gage Growth Corp.", ticker: "GAEGF" },
    { name: "CEAI - Creations Inc", ticker: "CEAI" },
    { name: "AVTE - Aerovate Therapeutics, Inc.", ticker: "AVTE" },
    { name: "CURV - Torrid Holdings Inc.", ticker: "CURV" },
    { name: "VTEX - VTEX", ticker: "VTEX" },
    { name: "ELMS - Electric Last Mile Solutions, Inc.", ticker: "ELMS" },
    { name: "ELEV - Elevation Oncology, Inc.", ticker: "ELEV" },
    { name: "AZIC - Azar International Corp.", ticker: "AZIC" },
    { name: "SVFD - Save Foods Inc.", ticker: "SVFD" },
    { name: "FXLV - F45 Training Holdings Inc.", ticker: "FXLV" },
    { name: "SVNI - Seven Islands Inc", ticker: "SVNI" },
    { name: "FRLA - Fortune Rise Acquisition Corp", ticker: "FRLA" },
    { name: "HEPS - D-MARKET Electronic Services & Trading", ticker: "HEPS" },
    { name: "INTE - Integral Acquisition Corp 1", ticker: "INTE" },
    { name: "DNAB - Social Capital Suvretta Holdings Corp. II", ticker: "DNAB" },
    { name: "DNAD - Social Capital Suvretta Holdings Corp. IV", ticker: "DNAD" },
    { name: "TKNO - Alpha Teknova, Inc.", ticker: "TKNO" },
    { name: "WQGA - World Quantum Growth Acquisition Corp.", ticker: "WQGA" },
    { name: "LTVA - LTV Capital Partners I", ticker: "LTVA" },
    { name: "TENK - TenX Keane Acquisition", ticker: "TENK" },
    { name: "SPRK - Spark Education Ltd", ticker: "SPRK" },
    { name: "MF - Missfresh Ltd", ticker: "MF" },
    { name: "BSAQ - Black Spade Acquisition Co", ticker: "BSAQ" },
    { name: "SCAC - Serendipity Capital Acquisition Corp.", ticker: "SCAC" },
    { name: "GXO - GXO Logistics, Inc.", ticker: "GXO" },
    { name: "FEXD - Fintech Ecosystem Development Corp.", ticker: "FEXD" },
    { name: "SCAN - Perspectum Group Ltd", ticker: "SCAN" },
    { name: "CEDA - Cedarlake Acquisition Corp.", ticker: "CEDA" },
    { name: "DRAY - Macondray Capital Acquisition Corp. I", ticker: "DRAY" },
    { name: "IVCA - Investcorp Acquisition Corp.", ticker: "IVCA" },
    { name: "SPTA - Sparta Healthcare Acquisition Corp.", ticker: "SPTA" },
    { name: "GDEV - Nexters Inc.", ticker: "GDEV" },
    { name: "RYAN - RYAN SPECIALTY GROUP HOLDINGS, INC.", ticker: "RYAN" },
    { name: "GSQB - G Squared Ascend II, Inc.", ticker: "GSQB" },
    { name: "STLR - Stellaris Growth Acquisition Corp.", ticker: "STLR" },
    { name: "FOYO - ForU Worldwide Inc.", ticker: "FOYO" },
    { name: "DWAC - Digital World Acquisition Corp.", ticker: "DWAC" },
    { name: "STVN - Stevanato Group S.p.A.", ticker: "STVN" },
    { name: "FSTN - Freestone Acquisition Corp", ticker: "FSTN" },
    { name: "VIT - Vital Human Capital, Inc.", ticker: "VIT" },
    { name: "FMG - Firemark Global Capital, Inc.", ticker: "FMG" },
    { name: "AXH - Industrial Human Capital, Inc.", ticker: "AXH" },
    { name: "SAGA - Sagaliam Acquisition Corp", ticker: "SAGA" },
    { name: "CLAY - Chavant Capital Acquisition Corp.", ticker: "CLAY" },
    { name: "PONO - PONO Capital Corp", ticker: "PONO" },
    { name: "JATT - JATT Acquisition Corp", ticker: "JATT" },
    { name: "FICV - Frontier Investment Corp", ticker: "FICV" },
    { name: "BLND - Blend Labs, Inc.", ticker: "BLND" },
    { name: "LILM - Lilium B.V.", ticker: "LILM" },
    { name: "SEAT - Vivid Seats Inc.", ticker: "SEAT" },
    { name: "YOU - Clear Secure, Inc.", ticker: "YOU" },
    { name: "VSCO - Victoria's Secret & Co.", ticker: "VSCO" },
    { name: "CNM - Core & Main, Inc.", ticker: "CNM" },
    { name: "UKWI - UK Wisdom Ltd", ticker: "UKWI" },
    { name: "DNUT - Krispy Kreme, Inc.", ticker: "DNUT" },
    { name: "NYXH - Nyxoah SA", ticker: "NYXH" },
    { name: "GDST - Goldenstone Acquisition Ltd.", ticker: "GDST" },
    { name: "NOVV - Nova Vision Acquisition Corp", ticker: "NOVV" },
    { name: "TDMY - TdMY Technology Group, Inc.", ticker: "TDMY" },
    { name: "CCMC - CCM Acquisition Corp.", ticker: "CCMC" },
    { name: "CZOO - Capri Listco", ticker: "CZOO" },
    { name: "ARQQ - Arqit Quantum Inc.", ticker: "ARQQ" },
    { name: "MBD - M3-Brigade Acquisition IV Corp.", ticker: "MBD" },
    { name: "NLIT - Northern Lights Acquisition Corp.", ticker: "NLIT" },
    { name: "GHRS - GH Research PLC", ticker: "GHRS" },
    { name: "TSY - TechStackery, Inc.", ticker: "TSY" },
    { name: "IRRX - INTEGRATED RAIL & RESOURCES ACQUISITION CORP", ticker: "IRRX" },
    { name: "LCLA - L Catterton Latin America Acquisition Corp", ticker: "LCLA" },
    { name: "BSGA - Blue Safari Group Acquisition Corp", ticker: "BSGA" },
    { name: "EVCM - EverCommerce Inc.", ticker: "EVCM" },
    { name: "XPAX - XPAC Acquisition Corp.", ticker: "XPAX" },
    { name: "MCW - Mister Car Wash, Inc.", ticker: "MCW" },
    { name: "PFTA - PORTAGE FINTECH ACQUISITION CORP.", ticker: "PFTA" },
    { name: "ATAT - Atour Lifestyle Holdings Ltd", ticker: "ATAT" },
    { name: "MCAF - Mountain Crest Acquisition Corp. IV", ticker: "MCAF" },
    { name: "DGHI - Digihost Technology Inc.", ticker: "DGHI" },
    { name: "LKVA - Lakeview Acquisition Corp", ticker: "LKVA" },
    { name: "DRMA - Dermata Therapeutics, Inc.", ticker: "DRMA" },
    { name: "LDOC - LinkDoc Technology Ltd", ticker: "LDOC" },
    { name: "BRDG - Bridge Investment Group Holdings Inc.", ticker: "BRDG" },
    { name: "NETC - Nabors Energy Transition Corp.", ticker: "NETC" },
    { name: "RNER - Mount Rainier Acquisition Corp.", ticker: "RNER" },
    { name: "DDL - Dingdong (Cayman) Ltd", ticker: "DDL" },
    { name: "CLBT - Cellebrite DI Ltd.", ticker: "CLBT" },
    { name: "PAYO - Payoneer Global Inc.", ticker: "PAYO" },
    { name: "ASPX - Aspirational Consumer Lifestyle Corp. II", ticker: "ASPX" },
    { name: "MCG - Membership Collective Group Inc.", ticker: "MCG" },
    { name: "GREE - Greenidge Generation Holdings Inc.", ticker: "GREE" },
    { name: "BASE - Couchbase, Inc.", ticker: "BASE" },
    { name: "MLXA - Mericsson Acquisition Corp", ticker: "MLXA" },
    { name: "DLO - dLocal Ltd", ticker: "DLO" },
    { name: "WAVE - Eco Wave Power Global AB (publ)", ticker: "WAVE" },
    { name: "XIMA - Ximalaya Inc.", ticker: "XIMA" },
    { name: "LAX - 8i Acquisition 2 Corp.", ticker: "LAX" },
    { name: "RADD - CORNER GROWTH ACQUISITION CORP. 3", ticker: "RADD" },
    { name: "IAS - INTEGRAL AD SCIENCE HOLDING CORP.", ticker: "IAS" },
    { name: "POND - Angel Pond Holdings Corp", ticker: "POND" },
    { name: "DTM - DT Midstream, Inc.", ticker: "DTM" },
    { name: "CADL - Candel Therapeutics, Inc.", ticker: "CADL" },
    { name: "BLEU - bleuacacia ltd", ticker: "BLEU" },
    { name: "PSPC - Post Holdings Partnering Corp", ticker: "PSPC" },
    { name: "BTNC - Bridgetown 3 Holdings Ltd", ticker: "BTNC" },
    { name: "ASPG - Aspire Global Inc.", ticker: "ASPG" },
    { name: "EOCW - Elliott Opportunity II Corp.", ticker: "EOCW" },
    { name: "EOCO - Elliott Opportunity I Corp.", ticker: "EOCO" },
    { name: "CNTX - Context Therapeutics Inc.", ticker: "CNTX" },
    { name: "TBLA - Taboola.com Ltd.", ticker: "TBLA" },
    { name: "GAMB - Gambling.com Group Ltd", ticker: "GAMB" },
    { name: "SMIH - Summit Healthcare Acquisition Corp.", ticker: "SMIH" },
    { name: "IRME - IR-Med, Inc.", ticker: "IRME" },
    { name: "QNIU - Qiniu Ltd.", ticker: "QNIU" },
    { name: "VMEO - Vimeo, Inc.", ticker: "VMEO" },
    { name: "YMM - Full Truck Alliance Co. Ltd.", ticker: "YMM" },
    { name: "OCEA - Ocean Biomedical, Inc.", ticker: "OCEA" },
    { name: "SSR - Soulgate Inc.", ticker: "SSR" },
    { name: "MLNK - Project Angel Parent, LLC", ticker: "MLNK" },
    { name: "VEV - VICINITY MOTOR CORP", ticker: "VEV" },
    { name: "BODY - Forest Road Acquisition Corp.", ticker: "BODY" },
    { name: "RTPX - Reinvent Technology Partners X", ticker: "RTPX" },
    { name: "HCWB - HCW Biologics Inc.", ticker: "HCWB" },
    { name: "SSHI - Sandy Springs Holdings, Inc.", ticker: "SSHI" },
    { name: "DYCU - DYNACURE S.A.", ticker: "DYCU" },
    { name: "JTEC - JHD Technologies Ltd", ticker: "JTEC" },
    { name: "FACQ - Foresight Acquisition Corp. II", ticker: "FACQ" },
    { name: "ARBE - Arbe Robotics Ltd.", ticker: "ARBE" },
    { name: "IFIN - InFinT Acquisition Corp", ticker: "IFIN" },
    { name: "VLN - Valens Semiconductor Ltd.", ticker: "VLN" },
    { name: "TUFU - TradeUP 88 Corp.", ticker: "TUFU" },
    { name: "PROC - Procaps Group, S.A.", ticker: "PROC" },
    { name: "PPHPA - PHP Ventures Acquisition Corp.", ticker: "PPHPA" },
    { name: "GRPFF - GRUPO TELEVISA, S.A.B.", ticker: "GRPFF" },
    { name: "BABAF - Alibaba Group Holding Ltd", ticker: "BABAF" },
    { name: "TOYOF - TOYOTA MOTOR CORP/", ticker: "TOYOF" },
    { name: "NVSEF - NOVARTIS AG", ticker: "NVSEF" },
    { name: "NONOF - NOVO NORDISK A S", ticker: "NONOF" },
    { name: "BHPLF - BHP Group Ltd", ticker: "BHPLF" },
    { name: "BHPBF - BHP Group Plc", ticker: "BHPBF" },
    { name: "SAPGF - SAP SE", ticker: "SAPGF" },
    { name: "RYDBF - Royal Dutch Shell plc", ticker: "RYDBF" },
    { name: "AZNCF - ASTRAZENECA PLC", ticker: "AZNCF" },
    { name: "UNLYF - UNILEVER PLC", ticker: "UNLYF" },
    { name: "RYDAF - Royal Dutch Shell plc", ticker: "RYDAF" },
    { name: "PCCYF - PETROCHINA CO LTD", ticker: "PCCYF" },
    { name: "BUDFF - Anheuser-Busch InBev SA/NV", ticker: "BUDFF" },
    { name: "RTPPF - RIO TINTO PLC", ticker: "RTPPF" },
    { name: "SNYNF - Sanofi", ticker: "SNYNF" },
    { name: "CILJF - CHINA LIFE INSURANCE CO LTD", ticker: "CILJF" },
    { name: "SNEJF - Sony Group Corp", ticker: "SNEJF" },
    { name: "TTFNF - TotalEnergies SE", ticker: "TTFNF" },
    { name: "DGEAF - DIAGEO PLC", ticker: "DGEAF" },
    { name: "HBCYF - HSBC HOLDINGS PLC", ticker: "HBCYF" },
    { name: "IDEXF - Industria de Diseno Textil Inditex SA / ADR", ticker: "IDEXF" },
    { name: "NCRRP - NCR CORP", ticker: "NCRRP" },
    { name: "GLAXF - GLAXOSMITHKLINE PLC", ticker: "GLAXF" },
    { name: "BTAFF - British American Tobacco p.l.c.", ticker: "BTAFF" },
    { name: "BPAQF - BP PLC", ticker: "BPAQF" },
    { name: "EBBNF - ENBRIDGE INC", ticker: "EBBNF" },
    { name: "ENBBF - ENBRIDGE INC", ticker: "ENBBF" },
    { name: "SNPMF - CHINA PETROLEUM & CHEMICAL CORP", ticker: "SNPMF" },
    { name: "WEBNF - WESTPAC BANKING CORP", ticker: "WEBNF" },
    { name: "MBFJF - MITSUBISHI UFJ FINANCIAL GROUP INC", ticker: "MBFJF" },
    { name: "ATTLF - ATLAS COPCO AB", ticker: "ATTLF" },
    { name: "STOHF - EQUINOR ASA", ticker: "STOHF" },
    { name: "ATLKF - ATLAS COPCO AB", ticker: "ATLKF" },
    { name: "ABLZF - ABB LTD", ticker: "ABLZF" },
    { name: "BCDRF - Banco Santander, S.A.", ticker: "BCDRF" },
    { name: "PUK-P - PRUDENTIAL PLC", ticker: "PUK-P" },
    { name: "BAMGF - BROOKFIELD ASSET MANAGEMENT INC.", ticker: "BAMGF" },
    { name: "PLDGP - Prologis, Inc.", ticker: "PLDGP" },
    { name: "HNDAF - HONDA MOTOR CO LTD", ticker: "HNDAF" },
    { name: "PPWLM - PACIFICORP /OR/", ticker: "PPWLM" },
    { name: "AMOVF - AMERICA MOVIL SAB DE CV/", ticker: "AMOVF" },
    { name: "IFNNF - INFINEON TECHNOLOGIES AG", ticker: "IFNNF" },
    { name: "INGVF - ING GROEP NV", ticker: "INGVF" },
    { name: "AMXVF - AMERICA MOVIL SAB DE CV/", ticker: "AMXVF" },
    { name: "TKPHF - TAKEDA PHARMACEUTICAL CO LTD", ticker: "TKPHF" },
    { name: "RLXXF - RELX PLC", ticker: "RLXXF" },
    { name: "PUKPF - PRUDENTIAL PLC", ticker: "PUKPF" },
    { name: "PPWLO - PACIFICORP /OR/", ticker: "PPWLO" },
    { name: "VODPF - VODAFONE GROUP PUBLIC LTD CO", ticker: "VODPF" },
    { name: "SMFNF - SUMITOMO MITSUI FINANCIAL GROUP, INC.", ticker: "SMFNF" },
    { name: "NGGTF - NATIONAL GRID PLC", ticker: "NGGTF" },
    { name: "GPDNF - GROUPE DANONE", ticker: "GPDNF" },
    { name: "EIPAF - ENI SPA", ticker: "EIPAF" },
    { name: "LLDTF - Lloyds Banking Group plc", ticker: "LLDTF" },
    { name: "RYLPF - KONINKLIJKE PHILIPS NV", ticker: "RYLPF" },
    { name: "BBVXF - BANCO BILBAO VIZCAYA ARGENTARIA, S.A.", ticker: "BBVXF" },
    { name: "ERIXF - ERICSSON LM TELEPHONE CO", ticker: "ERIXF" },
    { name: "BCLYF - BARCLAYS PLC", ticker: "BCLYF" },
    { name: "MZHOF - MIZUHO FINANCIAL GROUP INC", ticker: "MZHOF" },
    { name: "RSMDF - RESMED INC", ticker: "RSMDF" },
    { name: "BF-B - BROWN FORMAN CORP", ticker: "BF-B" },
    { name: "DNBHF - DnB NOR ASA", ticker: "DNBHF" },
    { name: "AMSYF - ArcelorMittal", ticker: "AMSYF" },
    { name: "STMEF - STMicroelectronics N.V.", ticker: "STMEF" },
    { name: "NOKBF - NOKIA CORP", ticker: "NOKBF" },
    { name: "FNCTF - ORANGE", ticker: "FNCTF" },
    { name: "SLFYF - SUN LIFE FINANCIAL INC", ticker: "SLFYF" },
    { name: "GNMSF - GENMAB A/S", ticker: "GNMSF" },
    { name: "BTGOF - BT GROUP PLC", ticker: "BTGOF" },
    { name: "RCIAF - ROGERS COMMUNICATIONS INC", ticker: "RCIAF" },
    { name: "CUKPF - CARNIVAL PLC", ticker: "CUKPF" },
    { name: "ANNSF - Aena S.A./ADR", ticker: "ANNSF" },
    { name: "CSGKF - CREDIT SUISSE GROUP AG", ticker: "CSGKF" },
    { name: "FMCQF - Fresenius Medical Care AG & Co. KGaA", ticker: "FMCQF" },
    { name: "CAJFF - CANON INC", ticker: "CAJFF" },
    { name: "TEFOF - TELEFONICA S A", ticker: "TEFOF" },
    { name: "RSTRF - Restaurant Brands International Limited Partnership", ticker: "RSTRF" },
    { name: "RYAOF - RYANAIR HOLDINGS PLC", ticker: "RYAOF" },
    { name: "NCSYF - NICE Ltd.", ticker: "NCSYF" },
    { name: "RWNFF - RWE AG /FI", ticker: "RWNFF" },
    { name: "KEY-PK - KEYCORP /NEW/", ticker: "KEY-PK" },
    { name: "ORXCF - ORIX CORP", ticker: "ORXCF" },
    { name: "SNNUF - SMITH & NEPHEW PLC", ticker: "SNNUF" },
    { name: "NMK-PC - NATIONAL GRID PLC", ticker: "NMK-PC" },
    { name: "TSGTF - TSINGTAO BREWERY CO LTD /FI", ticker: "TSGTF" },
    { name: "NMK-PB - NATIONAL GRID PLC", ticker: "NMK-PB" },
    { name: "GIKLY - Grifols SA", ticker: "GIKLY" },
    { name: "KEY-PJ - KEYCORP /NEW/", ticker: "KEY-PJ" },
    { name: "KEY-PI - KEYCORP /NEW/", ticker: "KEY-PI" },
    { name: "AMCCF - Amcor plc", ticker: "AMCCF" },
    { name: "NPSCY - NIPPON STEEL CORP", ticker: "NPSCY" },
    { name: "WPPGF - WPP plc", ticker: "WPPGF" },
    { name: "GIFLF - Grifols SA", ticker: "GIFLF" },
    { name: "GIFOF - Grifols SA", ticker: "GIFOF" },
    { name: "NRSCF - NOMURA HOLDINGS INC", ticker: "NRSCF" },
    { name: "TKAYY - Just Eat Takeaway.com N.V.", ticker: "TKAYY" },
    { name: "JHIUF - James Hardie Industries plc", ticker: "JHIUF" },
    { name: "KKOYF - Kesko OYJ", ticker: "KKOYF" },
    { name: "JETKD - Just Eat Takeaway.com N.V.", ticker: "JETKD" },
    { name: "SWMAF - SWEDISH MATCH CORP", ticker: "SWMAF" },
    { name: "ALMMF - ALUMINUM CORP OF CHINA LTD", ticker: "ALMMF" },
    { name: "CHKIF - CHINA SOUTHERN AIRLINES CO LTD", ticker: "CHKIF" },
    { name: "TNRSF - TENARIS SA", ticker: "TNRSF" },
    { name: "CXMSF - CEMEX SAB DE CV", ticker: "CXMSF" },
    { name: "TCKRF - TECK RESOURCES LTD", ticker: "TCKRF" },
    { name: "OSCUF - Japan Exchange Group, Inc./ADR", ticker: "OSCUF" },
    { name: "FWONB - Liberty Media Corp", ticker: "FWONB" },
    { name: "TEVJF - TEVA PHARMACEUTICAL INDUSTRIES LTD", ticker: "TEVJF" },
    { name: "TIAJF - TIM S.p.A.", ticker: "TIAJF" },
    { name: "TIAOF - TIM S.p.A.", ticker: "TIAOF" },
    { name: "TIAIY - TIM S.p.A.", ticker: "TIAIY" },
    { name: "UHID - UNIVERSAL HEALTH SERVICES INC", ticker: "UHID" },
    { name: "TIIAY - TIM S.p.A.", ticker: "TIIAY" },
    { name: "COCSF - COCA COLA FEMSA SAB DE CV", ticker: "COCSF" },
    { name: "PSORF - PEARSON PLC", ticker: "PSORF" },
    { name: "CHEAF - CHINA EASTERN AIRLINES CORP LTD", ticker: "CHEAF" },
    { name: "REMYF - Remy Cointreau/ADR", ticker: "REMYF" },
    { name: "VNORP - VORNADO REALTY TRUST", ticker: "VNORP" },
    { name: "SASOF - SASOL LTD", ticker: "SASOF" },
    { name: "BGEPF - BUNGELTD", ticker: "BGEPF" },
    { name: "AEGOF - AEGON NV", ticker: "AEGOF" },
    { name: "WTRU - Essential Utilities, Inc.", ticker: "WTRU" },
    { name: "AULGF - ANGLOGOLD ASHANTI LTD", ticker: "AULGF" },
    { name: "GFIOF - GOLD FIELDS LTD", ticker: "GFIOF" },
    { name: "CCOEF - Capcom Co., LTD/ADR", ticker: "CCOEF" },
    { name: "ISDAF - ISRAEL DISCOUNT BANK LTD", ticker: "ISDAF" },
    { name: "PBCTP - People's United Financial, Inc.", ticker: "PBCTP" },
    { name: "JSM - NAVIENT CORP", ticker: "JSM" },
    { name: "JETKY - Just Eat Takeaway.com N.V.", ticker: "JETKY" },
    { name: "QBCRF - QUEBECOR MEDIA INC", ticker: "QBCRF" },
    { name: "GWPRF - GW PHARMACEUTICALS PLC", ticker: "GWPRF" },
    { name: "MITUF - Mitsui Chemicals Inc", ticker: "MITUF" },
    { name: "HUNGF - HUANENG POWER INTERNATIONAL INC", ticker: "HUNGF" },
    { name: "PHTCF - PLDT Inc.", ticker: "PHTCF" },
    { name: "GPAEF - Pacific Airport Group", ticker: "GPAEF" },
    { name: "BPOPO - POPULAR, INC.", ticker: "BPOPO" },
    { name: "FBPRP - FIRST BANCORP /PR/", ticker: "FBPRP" },
    { name: "FBPRL - FIRST BANCORP /PR/", ticker: "FBPRL" },
    { name: "NSARO - NSTAR ELECTRIC CO", ticker: "NSARO" },
    { name: "ABCZF - Abcam plc", ticker: "ABCZF" },
    { name: "ASRMF - SOUTHEAST AIRPORT GROUP", ticker: "ASRMF" },
    { name: "DFRYF - Dufry AG/ADR", ticker: "DFRYF" },
    { name: "GMMVD - G Medical Innovations Holdings Ltd.", ticker: "GMMVD" },
    { name: "ESGRP - Enstar Group LTD", ticker: "ESGRP" },
    { name: "GSABF - GROUP SIMEC SA DE CV", ticker: "GSABF" },
    { name: "MICCF - MILLICOM INTERNATIONAL CELLULAR SA", ticker: "MICCF" },
    { name: "GLPGF - GALAPAGOS NV", ticker: "GLPGF" },
    { name: "CIM-PC - CHIMERA INVESTMENT CORP", ticker: "CIM-PC" },
    { name: "CIM-PD - CHIMERA INVESTMENT CORP", ticker: "CIM-PD" },
    { name: "CIM-PB - CHIMERA INVESTMENT CORP", ticker: "CIM-PB" },
    { name: "CIM-PA - CHIMERA INVESTMENT CORP", ticker: "CIM-PA" },
    { name: "GROUF - Grafton Group plc", ticker: "GROUF" },
    { name: "RLJ-PA - RLJ Lodging Trust", ticker: "RLJ-PA" },
    { name: "SOCGP - SOUTHERN CALIFORNIA GAS CO", ticker: "SOCGP" },
    { name: "WELPP - WISCONSIN ELECTRIC POWER CO", ticker: "WELPP" },
    { name: "CLNY-PH - DigitalBridge Group, Inc.", ticker: "CLNY-PH" },
    { name: "CLNY-PJ - DigitalBridge Group, Inc.", ticker: "CLNY-PJ" },
    { name: "IHRTB - iHeartMedia, Inc.", ticker: "IHRTB" },
    { name: "CLNY-PI - DigitalBridge Group, Inc.", ticker: "CLNY-PI" },
    { name: "CLNY-PG - DigitalBridge Group, Inc.", ticker: "CLNY-PG" },
    { name: "HOVNP - HOVNANIAN ENTERPRISES INC", ticker: "HOVNP" },
    { name: "HGMCF - HARMONY GOLD MINING CO LTD", ticker: "HGMCF" },
    { name: "UILCF - United Industrial Corp Ltd", ticker: "UILCF" },
    { name: "AATP - Agape ATP Corp", ticker: "AATP" },
    { name: "BCUCF - Brunello Cucinelli S.p.A./ADR", ticker: "BCUCF" },
    { name: "MPSYF - MorphoSys AG", ticker: "MPSYF" },
    { name: "TNSSF - TRANSALTA CORP", ticker: "TNSSF" },
    { name: "MCFUF - MICRO FOCUS INTERNATIONAL PLC", ticker: "MCFUF" },
    { name: "GAERF - Central North Airport Group", ticker: "GAERF" },
    { name: "OSTBP - OVERSTOCK.COM, INC", ticker: "OSTBP" },
    { name: "SRG-PA - Seritage Growth Properties", ticker: "SRG-PA" },
    { name: "FBPRN - FIRST BANCORP /PR/", ticker: "FBPRN" },
    { name: "FBPRM - FIRST BANCORP /PR/", ticker: "FBPRM" },
    { name: "BPIRF - Piraeus Bank S.A.", ticker: "BPIRF" },
    { name: "TROLB - TOOTSIE ROLL INDUSTRIES INC", ticker: "TROLB" },
    { name: "GNGYF - GUANGSHEN RAILWAY CO LTD", ticker: "GNGYF" },
    { name: "ALBKF - ALPHA BANK AE /FI", ticker: "ALBKF" },
    { name: "CBB-PB - CINCINNATI BELL INC", ticker: "CBB-PB" },
    { name: "ERRPF - Ero Copper Corp.", ticker: "ERRPF" },
    { name: "NSS - NuStar Energy L.P.", ticker: "NSS" },
    { name: "IIJIF - INTERNET INITIATIVE JAPAN INC", ticker: "IIJIF" },
    { name: "SLCJF - SLC Agricola S.A.", ticker: "SLCJF" },
    { name: "TGSNF - TGS NOPEC Geophysical CO", ticker: "TGSNF" },
    { name: "BATRB - Liberty Media Corp", ticker: "BATRB" },
    { name: "MDPEB - MEREDITH CORP", ticker: "MDPEB" },
    { name: "INN-PE - Summit Hotel Properties, Inc.", ticker: "INN-PE" },
    { name: "PRTHU - Priority Technology Holdings, Inc.", ticker: "PRTHU" },
    { name: "INN-PD - Summit Hotel Properties, Inc.", ticker: "INN-PD" },
    { name: "RTNXF - Renalytix AI plc", ticker: "RTNXF" },
    { name: "HVBTF - HIVE Blockchain Technologies Ltd.", ticker: "HVBTF" },
    { name: "MEOBF - MESOBLAST LTD", ticker: "MEOBF" },
    { name: "IARE - InvenTrust Properties Corp.", ticker: "IARE" },
    { name: "CWGRP - COWEN INC.", ticker: "CWGRP" },
    { name: "NUPMF - NEW PACIFIC METALS CORP", ticker: "NUPMF" },
    { name: "CXRXF - ADVANZ PHARMA Corp.", ticker: "CXRXF" },
    { name: "DLKGF - Delek Group, Ltd.", ticker: "DLKGF" },
    { name: "SLNCF - Silence Therapeutics plc", ticker: "SLNCF" },
    { name: "HVT-A - HAVERTY FURNITURE COMPANIES INC", ticker: "HVT-A" },
    { name: "AAVVF - ADVANTAGE OIL & GAS LTD.", ticker: "AAVVF" },
    { name: "FIGM - FUTURE INTERNATIONAL GROUP CORP.", ticker: "FIGM" },
    { name: "CELJF - Cellcom Israel Ltd.", ticker: "CELJF" },
    { name: "CMO-PE - CAPSTEAD MORTGAGE CORP", ticker: "CMO-PE" },
    { name: "SBOEF - Schoeller-Bleckmann Oilfield Equipment AG/ADR", ticker: "SBOEF" },
    { name: "ACUIF - AcuityAds Holdings Inc.", ticker: "ACUIF" },
    { name: "BFARF - Bitfarms Ltd", ticker: "BFARF" },
    { name: "SAFLF - Safilo Group SpA/ADR", ticker: "SAFLF" },
    { name: "NBR-PA - NABORS INDUSTRIES LTD", ticker: "NBR-PA" },
    { name: "ATROB - ASTRONICS CORP", ticker: "ATROB" },
    { name: "CORR-PA - CorEnergy Infrastructure Trust, Inc.", ticker: "CORR-PA" },
    { name: "HOL - Holicity Inc.", ticker: "HOL" },
    { name: "HITID - High Tide Inc.", ticker: "HITID" },
    { name: "DGICB - DONEGAL GROUP INC", ticker: "DGICB" },
    { name: "CPSN - Capstone Systems Inc", ticker: "CPSN" },
    { name: "CAI-PA - CAI International, Inc.", ticker: "CAI-PA" },
    { name: "FPI-PB - Farmland Partners Inc.", ticker: "FPI-PB" },
    { name: "ELLKF - Ellaktor SA / ADR", ticker: "ELLKF" },
    { name: "CNTHP - CONNECTICUT LIGHT & POWER CO", ticker: "CNTHP" },
    { name: "CNLPL - CONNECTICUT LIGHT & POWER CO", ticker: "CNLPL" },
    { name: "ARTNB - ARTESIAN RESOURCES CORP", ticker: "ARTNB" },
    { name: "AMSIY - ArcelorMittal", ticker: "AMSIY" },
    { name: "AIXN - AiXin Life International, Inc.", ticker: "AIXN" },
    { name: "VRRMW - VERRA MOBILITY Corp", ticker: "VRRMW" },
    { name: "CNLHO - CONNECTICUT LIGHT & POWER CO", ticker: "CNLHO" },
    { name: "DSX-PB - DIANA SHIPPING INC.", ticker: "DSX-PB" },
    { name: "CNTHO - CONNECTICUT LIGHT & POWER CO", ticker: "CNTHO" },
    { name: "BYRND - Byrna Technologies Inc.", ticker: "BYRND" },
    { name: "CNTHN - CONNECTICUT LIGHT & POWER CO", ticker: "CNTHN" },
    { name: "DS-PD - Drive Shack Inc.", ticker: "DS-PD" },
    { name: "DS-PC - Drive Shack Inc.", ticker: "DS-PC" },
    { name: "DS-PB - Drive Shack Inc.", ticker: "DS-PB" },
    { name: "GNE-PA - Genie Energy Ltd.", ticker: "GNE-PA" },
    { name: "CNLTP - CONNECTICUT LIGHT & POWER CO", ticker: "CNLTP" },
    { name: "CNPWP - CONNECTICUT LIGHT & POWER CO", ticker: "CNPWP" },
    { name: "CHMI-PB - Cherry Hill Mortgage Investment Corp", ticker: "CHMI-PB" },
    { name: "CNLHP - CONNECTICUT LIGHT & POWER CO", ticker: "CNLHP" },
    { name: "CNPWM - CONNECTICUT LIGHT & POWER CO", ticker: "CNPWM" },
    { name: "CNLPM - CONNECTICUT LIGHT & POWER CO", ticker: "CNLPM" },
    { name: "CNLTN - CONNECTICUT LIGHT & POWER CO", ticker: "CNLTN" },
    { name: "RVRF - River Financial Corp", ticker: "RVRF" },
    { name: "CNLTL - CONNECTICUT LIGHT & POWER CO", ticker: "CNLTL" },
    { name: "UOLID - UONLIVE CORP", ticker: "UOLID" },
    { name: "CHMI-PA - Cherry Hill Mortgage Investment Corp", ticker: "CHMI-PA" },
    { name: "IPHYF - Innate Pharma SA", ticker: "IPHYF" },
    { name: "IDTYD - Ipsidy Inc.", ticker: "IDTYD" },
    { name: "VSOGF - Vista Oil & Gas, S.A.B. de C.V.", ticker: "VSOGF" },
    { name: "AAZZF - A2Z Smart Technologies Corp", ticker: "AAZZF" },
    { name: "QTRHF - Quarterhill Inc.", ticker: "QTRHF" },
    { name: "TIZAF - Tiziana Life Sciences plc", ticker: "TIZAF" },
    { name: "GEIND - Genesys Industries, Inc.", ticker: "GEIND" },
    { name: "URCCF - Uranium Royalty Corp.", ticker: "URCCF" },
    { name: "DTRCD - DAKOTA TERRITORY RESOURCE CORP", ticker: "DTRCD" },
    { name: "PTQQD - Quipt Home Medical Corp.", ticker: "PTQQD" },
    { name: "NSRCD - NextSource Materials Inc.", ticker: "NSRCD" },
    { name: "PLYM-PA - Plymouth Industrial REIT, Inc.", ticker: "PLYM-PA" },
    { name: "BGLC - BioNexus Gene Lab Corp", ticker: "BGLC" },
    { name: "BUSXF - VICINITY MOTOR CORP", ticker: "BUSXF" },
    { name: "PTQQF - Quipt Home Medical Corp.", ticker: "PTQQF" },
    { name: "IDBHF - Industrias Bachoco S.A.B. de C.V.", ticker: "IDBHF" },
    { name: "LAKFD - Healing Co Inc.", ticker: "LAKFD" },
    { name: "SOLCF - SOL Global Investments Corp.", ticker: "SOLCF" },
    { name: "OASMY - Oasmia Pharmaceutical AB", ticker: "OASMY" },
    { name: "BUSXD - VICINITY MOTOR CORP", ticker: "BUSXD" },
    { name: "CINV - Crucial Innovations, Corp.", ticker: "CINV" },
    { name: "GMGT - Gaming Technologies, Inc.", ticker: "GMGT" },
    { name: "SPE-PB - SPECIAL OPPORTUNITIES FUND, INC.", ticker: "SPE-PB" },
    { name: "NVGNF - KAZIA THERAPEUTICS LTD", ticker: "NVGNF" },
    { name: "WRRI - Wari, Inc.", ticker: "WRRI" },
    { name: "KHDHF - Scully Royalty Ltd.", ticker: "KHDHF" },
    { name: "XELAU - Exela Technologies, Inc.", ticker: "XELAU" },
    { name: "SLBG - Slinger Bag Inc.", ticker: "SLBG" },
    { name: "ENMPF - Ensurge Micropower ASA/ADR", ticker: "ENMPF" },
    { name: "WSKEF - Wisekey International Holding S.A.", ticker: "WSKEF" },
    { name: "PLFX - Pulse Evolution Corp", ticker: "PLFX" },
    { name: "HSSHF - Digihost Technology Inc.", ticker: "HSSHF" },
    { name: "ASSF - ASSISTED 4 LIVING, INC.", ticker: "ASSF" },
    { name: "VMNT - Vemanti Group, Inc.", ticker: "VMNT" },
    { name: "CNIGP - Corning Natural Gas Holding Corp", ticker: "CNIGP" },
    { name: "AJIA - Ajia Innogroup Holdings, Ltd.", ticker: "AJIA" },
    { name: "IMPHO - IMPAC MORTGAGE HOLDINGS INC", ticker: "IMPHO" },
    { name: "CNIGO - Corning Natural Gas Holding Corp", ticker: "CNIGO" },
    { name: "SCXLB - STARRETT L S CO", ticker: "SCXLB" },
    { name: "CHUCD - Charlie's Holdings, Inc.", ticker: "CHUCD" },
    { name: "REAXF - Real Brokerage Inc", ticker: "REAXF" },
    { name: "IMPHP - IMPAC MORTGAGE HOLDINGS INC", ticker: "IMPHP" },
    { name: "GRMMD - Grom Social Enterprises, Inc.", ticker: "GRMMD" },
    { name: "DRDGF - DRDGOLD LTD", ticker: "DRDGF" },
    { name: "TGSI - TGS International Ltd.", ticker: "TGSI" },
    { name: "FCELB - FUELCELL ENERGY INC", ticker: "FCELB" },
    { name: "PRNAF - ALTERITY THERAPEUTICS LTD", ticker: "PRNAF" },
    { name: "RMNIW - Rimini Street, Inc.", ticker: "RMNIW" },
    { name: "XELAW - Exela Technologies, Inc.", ticker: "XELAW" },
    { name: "MVXM - MOVEIX INC.", ticker: "MVXM" },
    { name: "SNPXD - Synaptogenix, Inc.", ticker: "SNPXD" },
    { name: "MBBC - Marathon Bancorp, Inc. /MD/", ticker: "MBBC" },
    { name: "PALT - PALTALK, INC.", ticker: "PALT" },
    { name: "FLDI - Folkup Development Inc.", ticker: "FLDI" },
    { name: "KFSYF - KINGSWAY FINANCIAL SERVICES INC", ticker: "KFSYF" },
    { name: "RCRTD - Recruiter.com Group, Inc.", ticker: "RCRTD" },
    { name: "CYCCP - Cyclacel Pharmaceuticals, Inc.", ticker: "CYCCP" },
    { name: "HBIE - Trinity Capital Partners Inc.", ticker: "HBIE" },
    { name: "ARCXF - ArcelorMittal", ticker: "ARCXF" },
    { name: "LTCO - LONG TERM CARE OPERATIONS 360, INC.", ticker: "LTCO" },
    { name: "ADMQ - ADM ENDEAVORS, INC.", ticker: "ADMQ" },
    { name: "TCPP - Trinity Capital Partners Inc.", ticker: "TCPP" },
    { name: "PNGZF - Paringa Resources Ltd", ticker: "PNGZF" },
    { name: "YTFD - Yacht Finders, Inc.", ticker: "YTFD" },
    { name: "JSBL - JS BEAUTY LAND NETWORK TECHNOLOGY INC", ticker: "JSBL" },
    { name: "CPMV - Mosaic ImmunoEngineering Inc.", ticker: "CPMV" },
    { name: "CAVG - CANNAPOWDER, INC.", ticker: "CAVG" },
    { name: "BBRW - BrewBilt Manufacturing Inc.", ticker: "BBRW" },
    { name: "LAZYW - Lazydays Holdings, Inc.", ticker: "LAZYW" },
    { name: "CNSC - CannAssist International Corp", ticker: "CNSC" },
    { name: "QSAM - QSAM Biosciences, Inc.", ticker: "QSAM" },
    { name: "DPSMD - 3D PIONEER SYSTEMS, INC.", ticker: "DPSMD" },
    { name: "REGRF - GRAPH BLOCKCHAIN INC", ticker: "REGRF" },
    { name: "FXBYD - FOXBY CORP.", ticker: "FXBYD" },
    { name: "GNTLF - GENETIC TECHNOLOGIES LTD", ticker: "GNTLF" },
    { name: "NCRE - New Century Resources Corp", ticker: "NCRE" },
    { name: "GRPX - GreenPlex Services, Inc.", ticker: "GRPX" },
    { name: "ECMTD - Ecomax, Inc", ticker: "ECMTD" },
    { name: "FTRS - Futuris Co", ticker: "FTRS" },
    { name: "BCRHF - Blue Capital Reinsurance Holdings Ltd.", ticker: "BCRHF" },
    { name: "OSTO - ORIGINAL SIXTEEN TO ONE MINE INC /CA/", ticker: "OSTO" },
    { name: "PRKI - Perk International Inc.", ticker: "PRKI" },
    { name: "SMPRD - Standard Metals Processing, Inc.", ticker: "SMPRD" },
    { name: "ESTRF - ESTRE AMBIENTAL, INC.", ticker: "ESTRF" },
    { name: "PFSF - PACIFIC SOFTWARE, INC.", ticker: "PFSF" },
    { name: "RELT - Reliant Holdings, Inc.", ticker: "RELT" },
    { name: "IMUND - Immune Therapeutics, Inc.", ticker: "IMUND" },
    { name: "RIGG - NEVTAH CAPITAL MANAGEMENT CORP", ticker: "RIGG" },
    { name: "VXIT - Poverty Dignified, Inc.", ticker: "VXIT" },
    { name: "GNKWF - GENCO SHIPPING & TRADING LTD", ticker: "GNKWF" },
    { name: "RGBPP - Regen BioPharma Inc", ticker: "RGBPP" },
    { name: "JKRO - JAKROO INC.", ticker: "JKRO" },
    { name: "BTLN - BRIGHTLANE CORP.", ticker: "BTLN" },
    { name: "OXBRW - OXBRIDGE RE HOLDINGS Ltd", ticker: "OXBRW" },
    { name: "QDMI - QDM International Inc.", ticker: "QDMI" },
    { name: "DCAC - Daniels Corporate Advisory Company, Inc.", ticker: "DCAC" },
    { name: "CNCC - CANNA Corp", ticker: "CNCC" },
    { name: "SNNAQ - Sienna Biopharmaceuticals, Inc.", ticker: "SNNAQ" },
    { name: "OSIN - OPTIMUM SOURCE INTERNATIONAL LTD", ticker: "OSIN" },
    { name: "OMHI - Portage Resources Inc.", ticker: "OMHI" },
    { name: "EOSSD - EOS INC.", ticker: "EOSSD" },
    { name: "LTSCD - LIGHTSCAPE TECHNOLOGIES INC.", ticker: "LTSCD" },
    { name: "PCHK - Willow Creek Enterprises Inc.", ticker: "PCHK" },
    { name: "CBTC - XTRA Bitcoin Inc.", ticker: "CBTC" },
    { name: "LENSF - Presbia PLC", ticker: "LENSF" },
    { name: "AGMGP - FEDERAL AGRICULTURAL MORTGAGE CORP", ticker: "AGMGP" },
    { name: "AGM-PG - FEDERAL AGRICULTURAL MORTGAGE CORP", ticker: "AGM-PG" },
    { name: "FIISO - FINANCIAL INSTITUTIONS INC", ticker: "FIISO" },
    { name: "IPWLK - AES CORP", ticker: "IPWLK" },
    { name: "IPWLN - AES CORP", ticker: "IPWLN" },
    { name: "IPWLP - AES CORP", ticker: "IPWLP" },
    { name: "ENBFF - ENBRIDGE INC", ticker: "ENBFF" },
    { name: "EBGEF - ENBRIDGE INC", ticker: "EBGEF" },
    { name: "EBPPF - ENBRIDGE INC", ticker: "EBPPF" },
    { name: "EBRGF - ENBRIDGE INC", ticker: "EBRGF" },
    { name: "EBRZF - ENBRIDGE INC", ticker: "EBRZF" },
    { name: "EBBGF - ENBRIDGE INC", ticker: "EBBGF" },
    { name: "LGNXZ - LIGAND PHARMACEUTICALS INC", ticker: "LGNXZ" },
    { name: "LGNYZ - LIGAND PHARMACEUTICALS INC", ticker: "LGNYZ" },
    { name: "LGNZZ - LIGAND PHARMACEUTICALS INC", ticker: "LGNZZ" },
    { name: "LGNDZ - LIGAND PHARMACEUTICALS INC", ticker: "LGNDZ" },
    { name: "UGIC - UGI CORP /PA/", ticker: "UGIC" },
    { name: "UGIIU - UGI CORP /PA/", ticker: "UGIIU" },
    { name: "APPDW - APPLIED DNA SCIENCES INC", ticker: "APPDW" },
    { name: "XOMAO - XOMA Corp", ticker: "XOMAO" },
    { name: "BPOPM - POPULAR, INC.", ticker: "BPOPM" },
    { name: "PAASF - PAN AMERICAN SILVER CORP", ticker: "PAASF" },
    { name: "UZF - UNITED STATES CELLULAR CORP", ticker: "UZF" },
    { name: "HHHED - 37 CAPITAL INC", ticker: "HHHED" },
    { name: "CMSEP - CMS ENERGY CORP", ticker: "CMSEP" },
    { name: "CMSEV - CMS ENERGY CORP", ticker: "CMSEV" },
    { name: "CNBKB - CENTURY BANCORP INC", ticker: "CNBKB" },
    { name: "MQMNW - McEwen Mining Inc.", ticker: "MQMNW" },
    { name: "COWTF - BARCLAYS BANK PLC", ticker: "COWTF" },
    { name: "BWVTF - BARCLAYS BANK PLC", ticker: "BWVTF" },
    { name: "AYTEF - BARCLAYS BANK PLC", ticker: "AYTEF" },
    { name: "BALTF - BARCLAYS BANK PLC", ticker: "BALTF" },
    { name: "HOVVB - HOVNANIAN ENTERPRISES INC", ticker: "HOVVB" },
    { name: "KYSRW - KEY ENERGY SERVICES INC", ticker: "KYSRW" },
    { name: "GL-PC - GLOBE LIFE INC.", ticker: "GL-PC" },
    { name: "GL-PD - GLOBE LIFE INC.", ticker: "GL-PD" },
    { name: "SBNCM - SOUTHERN BANCSHARES NC INC", ticker: "SBNCM" },
    { name: "SBNCN - SOUTHERN BANCSHARES NC INC", ticker: "SBNCN" },
    { name: "NWEAF - NATIONAL WESTMINSTER BANK PLC /ENG/", ticker: "NWEAF" },
    { name: "SGGFF - BARCLAYS BANK PLC", ticker: "SGGFF" },
    { name: "PGMFF - BARCLAYS BANK PLC", ticker: "PGMFF" },
    { name: "PGDDF - BARCLAYS BANK PLC", ticker: "PGDDF" },
    { name: "JJTFF - BARCLAYS BANK PLC", ticker: "JJTFF" },
    { name: "JJUFF - BARCLAYS BANK PLC", ticker: "JJUFF" },
    { name: "JJOFF - BARCLAYS BANK PLC", ticker: "JJOFF" },
    { name: "JJPFF - BARCLAYS BANK PLC", ticker: "JJPFF" },
    { name: "JJSSF - BARCLAYS BANK PLC", ticker: "JJSSF" },
    { name: "JJGTF - BARCLAYS BANK PLC", ticker: "JJGTF" },
    { name: "JJMTF - BARCLAYS BANK PLC", ticker: "JJMTF" },
    { name: "JJNTF - BARCLAYS BANK PLC", ticker: "JJNTF" },
    { name: "JJATF - BARCLAYS BANK PLC", ticker: "JJATF" },
    { name: "JJCTF - BARCLAYS BANK PLC", ticker: "JJCTF" },
    { name: "JJETF - BARCLAYS BANK PLC", ticker: "JJETF" },
    { name: "GRNTF - BARCLAYS BANK PLC", ticker: "GRNTF" },
    { name: "ICITF - BARCLAYS BANK PLC", ticker: "ICITF" },
    { name: "JEMTF - BARCLAYS BANK PLC", ticker: "JEMTF" },
    { name: "GAZZF - BARCLAYS BANK PLC", ticker: "GAZZF" },
    { name: "GBBEF - BARCLAYS BANK PLC", ticker: "GBBEF" },
    { name: "EROTF - BARCLAYS BANK PLC", ticker: "EROTF" },
    { name: "WELPM - WISCONSIN ELECTRIC POWER CO", ticker: "WELPM" },
    { name: "SENEM - Seneca Foods Corp", ticker: "SENEM" },
    { name: "PNMXO - PUBLIC SERVICE CO OF NEW MEXICO", ticker: "PNMXO" },
    { name: "SOJE - SOUTHERN CO", ticker: "SOJE" },
    { name: "SOCGM - SOUTHERN CALIFORNIA GAS CO", ticker: "SOCGM" },
    { name: "BKDKP - STANLEY BLACK & DECKER, INC.", ticker: "BKDKP" },
    { name: "TDGMW - TIDEWATER INC", ticker: "TDGMW" },
    { name: "HWM-P - Howmet Aerospace Inc.", ticker: "HWM-P" },
    { name: "BMYMP - BRISTOL MYERS SQUIBB CO", ticker: "BMYMP" },
    { name: "NSARP - NSTAR ELECTRIC CO", ticker: "NSARP" },
    { name: "HXOH - HEXION INC.", ticker: "HXOH" },
    { name: "FHN-PF - FIRST HORIZON CORP", ticker: "FHN-PF" },
    { name: "FHNNP - FIRST HORIZON CORP", ticker: "FHNNP" },
    { name: "DDT - DILLARD'S, INC.", ticker: "DDT" },
    { name: "OGSRW - OVERSEAS SHIPHOLDING GROUP INC", ticker: "OGSRW" },
    { name: "WFCNP - WELLS FARGO & COMPANY/MN", ticker: "WFCNP" },
    { name: "PKDCW - PARKER DRILLING CO /DE/", ticker: "PKDCW" },
    { name: "BACRP - BANK OF AMERICA CORP /DE/", ticker: "BACRP" },
    { name: "MNESP - MSA Safety Inc", ticker: "MNESP" },
    { name: "MSEXP - MIDDLESEX WATER CO", ticker: "MSEXP" },
    { name: "BOH-PA - BANK OF HAWAII CORP", ticker: "BOH-PA" },
    { name: "HBANM - HUNTINGTON BANCSHARES INC /MD/", ticker: "HBANM" },
    { name: "INPAP - INTERNATIONAL PAPER CO /NEW/", ticker: "INPAP" },
    { name: "OSATW - ORBSAT CORP", ticker: "OSATW" },
    { name: "FBPRO - FIRST BANCORP /PR/", ticker: "FBPRO" },
    { name: "CRLKP - SP Plus Corp", ticker: "CRLKP" },
    { name: "CCIXF - CANADIAN IMPERIAL BANK OF COMMERCE /CAN/", ticker: "CCIXF" },
    { name: "IDGGW - INTERPACE BIOSCIENCES, INC.", ticker: "IDGGW" },
    { name: "CSNBF - CREDIT SUISSE AG", ticker: "CSNBF" },
    { name: "PTIXW - Protagenic Therapeutics, Inc.\\new", ticker: "PTIXW" },
    { name: "POWWP - AMMO, INC.", ticker: "POWWP" },
    { name: "CRESF - CRESUD INC", ticker: "CRESF" },
    { name: "CRESW - CRESUD INC", ticker: "CRESW" },
    { name: "LTSA - LADENBURG THALMANN FINANCIAL SERVICES INC.", ticker: "LTSA" },
    { name: "DVAXW - DYNAVAX TECHNOLOGIES CORP", ticker: "DVAXW" },
    { name: "SREA - SEMPRA ENERGY", ticker: "SREA" },
    { name: "PRLEP - PILLARSTONE CAPITAL REIT", ticker: "PRLEP" },
    { name: "SJRWF - SHAW COMMUNICATIONS INC", ticker: "SJRWF" },
    { name: "TNTTF - TORONTO DOMINION BANK", ticker: "TNTTF" },
    { name: "TORDF - TORONTO DOMINION BANK", ticker: "TORDF" },
    { name: "DTB - DTE ENERGY CO", ticker: "DTB" },
    { name: "AATRL - AFFILIATED MANAGERS GROUP, INC.", ticker: "AATRL" },
    { name: "MGRB - AFFILIATED MANAGERS GROUP, INC.", ticker: "MGRB" },
    { name: "NMPWP - NATIONAL GRID PLC", ticker: "NMPWP" },
    { name: "NEWEN - NATIONAL GRID PLC", ticker: "NEWEN" },
    { name: "RYMTF - ROYAL BANK OF CANADA", ticker: "RYMTF" },
    { name: "MBNKP - MEDALLION FINANCIAL CORP", ticker: "MBNKP" },
    { name: "ACGLN - ARCH CAPITAL GROUP LTD.", ticker: "ACGLN" },
    { name: "BMKAF - BROOKFIELD ASSET MANAGEMENT INC.", ticker: "BMKAF" },
    { name: "BROXF - BROOKFIELD ASSET MANAGEMENT INC.", ticker: "BROXF" },
    { name: "BXDIF - BROOKFIELD ASSET MANAGEMENT INC.", ticker: "BXDIF" },
    { name: "BAMKF - BROOKFIELD ASSET MANAGEMENT INC.", ticker: "BAMKF" },
    { name: "BKAMF - BROOKFIELD ASSET MANAGEMENT INC.", ticker: "BKAMF" },
    { name: "BKFAF - BROOKFIELD ASSET MANAGEMENT INC.", ticker: "BKFAF" },
    { name: "BKFPF - BROOKFIELD ASSET MANAGEMENT INC.", ticker: "BKFPF" },
    { name: "TTNPW - TITAN PHARMACEUTICALS INC", ticker: "TTNPW" },
    { name: "COF-PL - CAPITAL ONE FINANCIAL CORP", ticker: "COF-PL" },
    { name: "FGPRB - FERRELLGAS PARTNERS L P", ticker: "FGPRB" },
    { name: "MNLCF - MANULIFE FINANCIAL CORP", ticker: "MNLCF" },
    { name: "MNLFF - MANULIFE FINANCIAL CORP", ticker: "MNLFF" },
    { name: "MNQFF - MANULIFE FINANCIAL CORP", ticker: "MNQFF" },
    { name: "MNUFF - MANULIFE FINANCIAL CORP", ticker: "MNUFF" },
    { name: "SUNFF - SUN LIFE FINANCIAL INC", ticker: "SUNFF" },
    { name: "SLFIF - SUN LIFE FINANCIAL INC", ticker: "SLFIF" },
    { name: "SLFSF - SUN LIFE FINANCIAL INC", ticker: "SLFSF" },
    { name: "SQFTP - Presidio Property Trust, Inc.", ticker: "SQFTP" },
    { name: "NWGIW - Elys Game Technology, Corp.", ticker: "NWGIW" },
    { name: "ONCWF - ONCOLYTICS BIOTECH INC", ticker: "ONCWF" },
    { name: "SRCU - SPIRE INC", ticker: "SRCU" },
    { name: "BASWW - BASIC ENERGY SERVICES, INC.", ticker: "BASWW" },
    { name: "ZIVOW - Zivo Bioscience, Inc.", ticker: "ZIVOW" },
    { name: "AQNNF - ALGONQUIN POWER & UTILITIES CORP.", ticker: "AQNNF" },
    { name: "AQNNV - ALGONQUIN POWER & UTILITIES CORP.", ticker: "AQNNV" },
    { name: "AQNU - ALGONQUIN POWER & UTILITIES CORP.", ticker: "AQNU" },
    { name: "COMSW - COMSovereign Holding Corp.", ticker: "COMSW" },
    { name: "GSCCP - GLADSTONE COMMERCIAL CORP", ticker: "GSCCP" },
    { name: "MTCN - ArcelorMittal", ticker: "MTCN" },
    { name: "ABR-PD - ARBOR REALTY TRUST INC", ticker: "ABR-PD" },
    { name: "ABRRP - ARBOR REALTY TRUST INC", ticker: "ABRRP" },
    { name: "OXSQZ - Oxford Square Capital Corp.", ticker: "OXSQZ" },
    { name: "OXSQG - Oxford Square Capital Corp.", ticker: "OXSQG" },
    { name: "NBRWF - NABORS INDUSTRIES LTD", ticker: "NBRWF" },
    { name: "CIMXP - CIMAREX ENERGY CO", ticker: "CIMXP" },
    { name: "LLOBF - Lloyds Banking Group plc", ticker: "LLOBF" },
    { name: "TSLTF - TRANSALTA CORP", ticker: "TSLTF" },
    { name: "QBCAF - QUEBECOR MEDIA INC", ticker: "QBCAF" },
    { name: "OSTKO - OVERSTOCK.COM, INC", ticker: "OSTKO" },
    { name: "GRZZP - Grizzly Energy, LLC", ticker: "GRZZP" },
    { name: "GRZZU - Grizzly Energy, LLC", ticker: "GRZZU" },
    { name: "OPXXW - Optex Systems Holdings Inc", ticker: "OPXXW" },
    { name: "SDRDW - SANDRIDGE ENERGY INC", ticker: "SDRDW" },
    { name: "SDRWW - SANDRIDGE ENERGY INC", ticker: "SDRWW" },
    { name: "HROWL - HARROW HEALTH, INC.", ticker: "HROWL" },
    { name: "EYESW - SECOND SIGHT MEDICAL PRODUCTS INC", ticker: "EYESW" },
    { name: "AMDDW - Sintx Technologies, Inc.", ticker: "AMDDW" },
    { name: "COTRP - STRUCTURED PRODUCTS CORP CRED ENHANCE CORTS TR FOR AON CAP A", ticker: "COTRP" },
    { name: "KTBA - STRUCTURED PRODUCTS CORP CRED ENHANCE CORTS TR FOR AON CAP A", ticker: "KTBA" },
    { name: "RF-PE - REGIONS FINANCIAL CORP", ticker: "RF-PE" },
    { name: "ET-PC - Energy Transfer LP", ticker: "ET-PC" },
    { name: "ET-PD - Energy Transfer LP", ticker: "ET-PD" },
    { name: "ET-PE - Energy Transfer LP", ticker: "ET-PE" },
    { name: "SHO-PH - Sunstone Hotel Investors, Inc.", ticker: "SHO-PH" },
    { name: "SNTHP - Sunstone Hotel Investors, Inc.", ticker: "SNTHP" },
    { name: "EGKPF - Eagle Bulk Shipping Inc.", ticker: "EGKPF" },
    { name: "ACRDP - ACRES Commercial Realty Corp.", ticker: "ACRDP" },
    { name: "ACR-PD - ACRES Commercial Realty Corp.", ticker: "ACR-PD" },
    { name: "SESCF - Seaspan CORP", ticker: "SESCF" },
    { name: "NSPRW - InspireMD, Inc.", ticker: "NSPRW" },
    { name: "NSPRZ - InspireMD, Inc.", ticker: "NSPRZ" },
    { name: "DTSTW - Data Storage Corp", ticker: "DTSTW" },
    { name: "AVYAW - Avaya Holdings Corp.", ticker: "AVYAW" },
    { name: "VRSZW - Verso Corp", ticker: "VRSZW" },
    { name: "FGBIP - First Guaranty Bancshares, Inc.", ticker: "FGBIP" },
    { name: "BINFF - Brookfield Infrastructure Partners L.P.", ticker: "BINFF" },
    { name: "BIPAF - Brookfield Infrastructure Partners L.P.", ticker: "BIPAF" },
    { name: "MIUFF - Mitsubishi UFJ Lease & Finance Co., Ltd.", ticker: "MIUFF" },
    { name: "FTRK - SAUER ENERGY, INC.", ticker: "FTRK" },
    { name: "SGIC - Strategic Realty Trust, Inc.", ticker: "SGIC" },
    { name: "GGNNW - GENOCEA BIOSCIENCES, INC.", ticker: "GGNNW" },
    { name: "XTNTW - Xtant Medical Holdings, Inc.", ticker: "XTNTW" },
    { name: "GMBLW - ESPORTS ENTERTAINMENT GROUP, INC.", ticker: "GMBLW" },
    { name: "ATLCP - Atlanticus Holdings Corp", ticker: "ATLCP" },
    { name: "RCRTW - Recruiter.com Group, Inc.", ticker: "RCRTW" },
    { name: "FCRX - First Eagle Alternative Capital BDC, Inc.", ticker: "FCRX" },
    { name: "PEB-PG - Pebblebrook Hotel Trust", ticker: "PEB-PG" },
    { name: "PEBHP - Pebblebrook Hotel Trust", ticker: "PEBHP" },
    { name: "NOVNW - Novan, Inc.", ticker: "NOVNW" },
    { name: "ATOWW - ATOSSA THERAPEUTICS, INC.", ticker: "ATOWW" },
    { name: "CUBB - Customers Bancorp, Inc.", ticker: "CUBB" },
    { name: "OASPW - Oasis Petroleum Inc.", ticker: "OASPW" },
    { name: "CLDTP - Chatham Lodging Trust", ticker: "CLDTP" },
    { name: "CLDTV - Chatham Lodging Trust", ticker: "CLDTV" },
    { name: "NXEOW - Nexeo Solutions, Inc.", ticker: "NXEOW" },
    { name: "WFTUF - Weatherford International plc", ticker: "WFTUF" },
    { name: "ECCC - Eagle Point Credit Co Inc.", ticker: "ECCC" },
    { name: "ECCPP - Eagle Point Credit Co Inc.", ticker: "ECCPP" },
    { name: "ATLEW - ARTELO BIOSCIENCES, INC.", ticker: "ATLEW" },
    { name: "INSEW - Inspired Entertainment, Inc.", ticker: "INSEW" },
    { name: "HSDTW - HELIUS MEDICAL TECHNOLOGIES, INC.", ticker: "HSDTW" },
    { name: "ARECW - American Resources Corp", ticker: "ARECW" },
    { name: "MONOF - MonotaRO Co., Ltd./ADR", ticker: "MONOF" },
    { name: "CTRVW - Hepion Pharmaceuticals, Inc.", ticker: "CTRVW" },
    { name: "NWDVW - Gannett Co., Inc.", ticker: "NWDVW" },
    { name: "OKSWF - Osisko Gold Royalties LTD", ticker: "OKSWF" },
    { name: "TRTXP - TPG RE Finance Trust, Inc.", ticker: "TRTXP" },
    { name: "TRTX-PC - TPG RE Finance Trust, Inc.", ticker: "TRTX-PC" },
    { name: "BW-PA - Babcock & Wilcox Enterprises, Inc.", ticker: "BW-PA" },
    { name: "BWCXP - Babcock & Wilcox Enterprises, Inc.", ticker: "BWCXP" },
    { name: "GECCO - Great Elm Capital Corp.", ticker: "GECCO" },
    { name: "ZHYBF - Zhong Yuan Bio-Technology Holdings Ltd", ticker: "ZHYBF" },
    { name: "APVTW - Aptevo Therapeutics Inc.", ticker: "APVTW" },
    { name: "GROMW - Grom Social Enterprises, Inc.", ticker: "GROMW" },
    { name: "HJLBW - Hancock Jaffe Laboratories, Inc.", ticker: "HJLBW" },
    { name: "FORFF - Fortis Inc.", ticker: "FORFF" },
    { name: "FTRSF - Fortis Inc.", ticker: "FTRSF" },
    { name: "DBGIW - Digital Brands Group, Inc.", ticker: "DBGIW" },
    { name: "FGLHF - FGL Holdings", ticker: "FGLHF" },
    { name: "SBEV-WT - SPLASH BEVERAGE GROUP, INC.", ticker: "SBEV-WT" },
    { name: "LFTPP - Lument Finance Trust, Inc.", ticker: "LFTPP" },
    { name: "LFT-PA - Lument Finance Trust, Inc.", ticker: "LFT-PA" },
    { name: "PBNAF - PEMBINA PIPELINE CORP", ticker: "PBNAF" },
    { name: "PMBPF - PEMBINA PIPELINE CORP", ticker: "PMBPF" },
    { name: "PMMBF - PEMBINA PIPELINE CORP", ticker: "PMMBF" },
    { name: "BEPH - Brookfield Renewable Partners L.P.", ticker: "BEPH" },
    { name: "BRENF - Brookfield Renewable Partners L.P.", ticker: "BRENF" },
    { name: "BROOF - Brookfield Renewable Partners L.P.", ticker: "BROOF" },
    { name: "PW-PA - Power REIT", ticker: "PW-PA" },
    { name: "COLE - Cole Office & Industrial REIT (CCIT II), Inc.", ticker: "COLE" },
    { name: "SSPCF - SiriusPoint Ltd", ticker: "SSPCF" },
    { name: "HLTC - Healthcare Trust, Inc.", ticker: "HLTC" },
    { name: "SYRSW - Syros Pharmaceuticals, Inc.", ticker: "SYRSW" },
    { name: "CNFRL - Conifer Holdings, Inc.", ticker: "CNFRL" },
    { name: "DPSIP - DecisionPoint Systems, Inc.", ticker: "DPSIP" },
    { name: "DMPWW - Kintara Therapeutics, Inc.", ticker: "DMPWW" },
    { name: "CHTH - CNL Healthcare Properties, Inc.", ticker: "CHTH" },
    { name: "AMPYW - Amplify Energy Holdings LLC", ticker: "AMPYW" },
    { name: "ADIWW - ADIAL PHARMACEUTICALS, INC.", ticker: "ADIWW" },
    { name: "RC-PE - Ready Capital Corp", ticker: "RC-PE" },
    { name: "CGABL - Carlyle Group Inc.", ticker: "CGABL" },
    { name: "SSEHW - SenesTech, Inc.", ticker: "SSEHW" },
    { name: "SCMCP - Sachem Capital Corp.", ticker: "SCMCP" },
    { name: "VSSYW - Versus Systems Inc.", ticker: "VSSYW" },
    { name: "CNTWW - Alpha Metallurgical Resources, Inc.", ticker: "CNTWW" },
    { name: "FLMNW - Falcon Minerals Corp", ticker: "FLMNW" },
    { name: "ESTWF - ESTRE AMBIENTAL, INC.", ticker: "ESTWF" },
    { name: "OCCIO - OFS Credit Company, Inc.", ticker: "OCCIO" },
    { name: "NRXPW - NRX Pharmaceuticals, Inc.", ticker: "NRXPW" },
    { name: "LVOXW - LiveVox Holdings, Inc.", ticker: "LVOXW" },
    { name: "CLVPF - CLARIVATE Plc", ticker: "CLVPF" },
    { name: "CLVT-PA - CLARIVATE Plc", ticker: "CLVT-PA" },
    { name: "GMVDW - G Medical Innovations Holdings Ltd.", ticker: "GMVDW" },
    { name: "ESSCW - East Stone Acquisition Corp", ticker: "ESSCW" },
    { name: "STEM-WT - STEM, INC.", ticker: "STEM-WT" },
    { name: "OSWWF - ONESPAWORLD HOLDINGS Ltd", ticker: "OSWWF" },
    { name: "CODQL - Coronado Global Resources Inc.", ticker: "CODQL" },
    { name: "UPH-WT - UpHealth, Inc.", ticker: "UPH-WT" },
    { name: "MMNWF - MedMen Enterprises, Inc.", ticker: "MMNWF" },
    { name: "SKIL-WT - Skillsoft Corp.", ticker: "SKIL-WT" },
    { name: "MAPSW - WM TECHNOLOGY, INC.", ticker: "MAPSW" },
    { name: "BLDEW - Blade Air Mobility, Inc.", ticker: "BLDEW" },
    { name: "PWPPW - Perella Weinberg Partners", ticker: "PWPPW" },
    { name: "DFNS-WT - LGL Systems Acquisition Corp.", ticker: "DFNS-WT" },
    { name: "GTXAP - Garrett Motion Inc.", ticker: "GTXAP" },
    { name: "PLLTL - Piedmont Lithium Inc.", ticker: "PLLTL" },
    { name: "HUTWF - HUT 8 MINING CORP.", ticker: "HUTWF" },
    { name: "KBNTW - Kubient, Inc.", ticker: "KBNTW" },
    { name: "SCVX-WT - SCVX Corp.", ticker: "SCVX-WT" },
    { name: "CCAC-WT - CITIC Capital Acquisition Corp.", ticker: "CCAC-WT" },
    { name: "ATCOL - Atlas Corp.", ticker: "ATCOL" },
    { name: "DFPHW - DFP HEALTHCARE ACQUISITIONS CORP.", ticker: "DFPHW" },
    { name: "CANO-WT - Cano Health, Inc.", ticker: "CANO-WT" },
    { name: "AEVA-WT - Aeva Technologies, Inc.", ticker: "AEVA-WT" },
    { name: "BIPH - Brookfield Infrastructure Corp", ticker: "BIPH" },
    { name: "BRLIW - Brilliant Acquisition Corp", ticker: "BRLIW" },
    { name: "ELMSW - Electric Last Mile Solutions, Inc.", ticker: "ELMSW" },
    { name: "HCDIP - Harbor Custom Development, Inc.", ticker: "HCDIP" },
    { name: "HCDIW - Harbor Custom Development, Inc.", ticker: "HCDIW" },
    { name: "KPLTW - Katapult Holdings, Inc.", ticker: "KPLTW" },
    { name: "BCACW - Brookline Capital Acquisition Corp.", ticker: "BCACW" },
    { name: "CMAXW - CareMax, Inc.", ticker: "CMAXW" },
    { name: "QSIAW - Quantum-Si Inc", ticker: "QSIAW" },
    { name: "ATIP-WT - ATI Physical Therapy, Inc.", ticker: "ATIP-WT" },
    { name: "MEUSW - 23andMe Holding Co.", ticker: "MEUSW" },
    { name: "ZEV-WT - Lightning eMotors, Inc.", ticker: "ZEV-WT" },
    { name: "ORGNW - Origin Materials, Inc.", ticker: "ORGNW" },
    { name: "TALKW - Talkspace, Inc.", ticker: "TALKW" },
    { name: "SST - Trebia Acquisition Corp.", ticker: "SST" },
    { name: "BARK-WT - Original Bark Co", ticker: "BARK-WT" },
    { name: "SCAQW - Stratim Cloud Acquisition Corp.", ticker: "SCAQW" },
    { name: "GLSPW - Global SPAC Partners Co,", ticker: "GLSPW" },
    { name: "KINZU - KINS Technology Group, Inc.", ticker: "KINZU" },
    { name: "KINZW - KINS Technology Group, Inc.", ticker: "KINZW" },
    { name: "VCKAW - Vickers Vantage Corp. I", ticker: "VCKAW" },
    { name: "TINV-UN - Tiga Acquisition Corp.", ticker: "TINV-UN" },
    { name: "TINV-WT - Tiga Acquisition Corp.", ticker: "TINV-WT" },
    { name: "RMGBW - RMG Acquisition Corp. II", ticker: "RMGBW" },
    { name: "HCCCU - Healthcare Capital Corp/DE", ticker: "HCCCU" },
    { name: "HCCCW - Healthcare Capital Corp/DE", ticker: "HCCCW" },
    { name: "MOTNW - Motion Acquisition Corp.", ticker: "MOTNW" },
    { name: "MYPSW - PLAYSTUDIOS, Inc.", ticker: "MYPSW" },
    { name: "OWL-WT - BLUE OWL CAPITAL INC.", ticker: "OWL-WT" },
    { name: "LTCHW - Latch, Inc.", ticker: "LTCHW" },
    { name: "NEBCW - Nebula Caravel Acquisition Corp.", ticker: "NEBCW" },
    { name: "SPKBW - Silver Spike Acquisition Corp II", ticker: "SPKBW" },
    { name: "PPGHW - Poema Global Holdings Corp.", ticker: "PPGHW" },
    { name: "FTAAW - FTAC Athena Acquisition Corp.", ticker: "FTAAW" },
    { name: "BSPOW - Vintage Wine Estates, Inc.", ticker: "BSPOW" },
    { name: "FSRXW - Finserv Acquisition Corp. II", ticker: "FSRXW" },
    { name: "GROY-WT - Gold Royalty Corp.", ticker: "GROY-WT" },
    { name: "THMAW - Thimble Point Acquisition Corp.", ticker: "THMAW" },
    { name: "AMPI-WT - Advanced Merger Partners, Inc.", ticker: "AMPI-WT" },
    { name: "LEV-WT - Lion Electric Co", ticker: "LEV-WT" },
    { name: "DHCAW - DHC Acquisition Corp.", ticker: "DHCAW" },
    { name: "MBTCR - Nocturne Acquisition Corp", ticker: "MBTCR" },
    { name: "CLAA-WT - Colonnade Acquisition Corp. II", ticker: "CLAA-WT" },
    { name: "BGSX-WT - Build Acquisition Corp.", ticker: "BGSX-WT" },
    { name: "MACQW - MCAP Acquisition Corp", ticker: "MACQW" },
    { name: "STRE-WT - Supernova Partners Acquisition Co III, Ltd.", ticker: "STRE-WT" },
    { name: "GIGGU - GigCapital4, Inc.", ticker: "GIGGU" },
    { name: "GIGGW - GigCapital4, Inc.", ticker: "GIGGW" },
    { name: "NDACW - NightDragon Acquisition Corp.", ticker: "NDACW" },
    { name: "ARRWW - Arrowroot Acquisition Corp.", ticker: "ARRWW" },
    { name: "OHPAW - Orion Acquisition Corp.", ticker: "OHPAW" },
    { name: "RESSD - Sandy Springs Holdings, Inc.", ticker: "RESSD" },
    { name: "HMCOW - HumanCo Acquisition Corp.", ticker: "HMCOW" },
    { name: "LWACU - Locust Walk Acquisition Corp.", ticker: "LWACU" },
    { name: "LWACW - Locust Walk Acquisition Corp.", ticker: "LWACW" },
    { name: "FVIV-WT - Fortress Value Acquisition Corp. IV", ticker: "FVIV-WT" },
    { name: "CFFVU - CF Acquisition Corp. V", ticker: "CFFVU" },
    { name: "CFFVW - CF Acquisition Corp. V", ticker: "CFFVW" },
    { name: "BODY-WT - Forest Road Acquisition Corp.", ticker: "BODY-WT" },
    { name: "EQHA-UN - EQ Health Acquisition Corp.", ticker: "EQHA-UN" },
    { name: "EQHA-WT - EQ Health Acquisition Corp.", ticker: "EQHA-WT" },
    { name: "ROT-UN - Rotor Acquisition Corp.", ticker: "ROT-UN" },
    { name: "COOLW - Corner Growth Acquisition Corp.", ticker: "COOLW" },
    { name: "COOLU - Corner Growth Acquisition Corp.", ticker: "COOLU" },
    { name: "LBPSW - 4D Pharma PLC", ticker: "LBPSW" },
    { name: "DHHCW - DiamondHead Holdings Corp.", ticker: "DHHCW" },
    { name: "OSI-UN - Osiris Acquisition Corp.", ticker: "OSI-UN" },
    { name: "LGV-WT - Longview Acquisition Corp. II", ticker: "LGV-WT" },
    { name: "ATVCW - Tribe Capital Growth Corp I", ticker: "ATVCW" },
    { name: "BLUA-UN - BlueRiver Acquisition Corp.", ticker: "BLUA-UN" },
    { name: "BLUA-WT - BlueRiver Acquisition Corp.", ticker: "BLUA-WT" },
    { name: "DNZ-UN - D & Z Media Acquisition Corp.", ticker: "DNZ-UN" },
    { name: "DNZ-WT - D & Z Media Acquisition Corp.", ticker: "DNZ-WT" },
    { name: "PNTM-UN - Pontem Corp", ticker: "PNTM-UN" },
    { name: "PNTM-WT - Pontem Corp", ticker: "PNTM-WT" },
    { name: "FZT-WT - FAST Acquisition Corp. II", ticker: "FZT-WT" },
    { name: "SHGFD - Skylight Health Group Inc.", ticker: "SHGFD" },
    { name: "FTPAW - FTAC Parnassus Acquisition Corp.", ticker: "FTPAW" },
    { name: "JBI-WT - Janus International Group, Inc.", ticker: "JBI-WT" },
    { name: "EJFAW - EJF Acquisition Corp.", ticker: "EJFAW" },
    { name: "CFFEW - CF Acquisition Corp. VIII", ticker: "CFFEW" },
    { name: "AAQC-WT - Accelerate Acquisition Corp.", ticker: "AAQC-WT" },
    { name: "SMIHU - Summit Healthcare Acquisition Corp.", ticker: "SMIHU" },
    { name: "GAPA-WT - G&P Acquisition Corp.", ticker: "GAPA-WT" },
    { name: "BRPMW - B. Riley Principal 150 Merger Corp.", ticker: "BRPMW" },
    { name: "ROCRW - Roth CH Acquisition III Co", ticker: "ROCRW" },
    { name: "TBLAW - Taboola.com Ltd.", ticker: "TBLAW" },
    { name: "ATSPT - Archimedes Tech Spac Partners Co", ticker: "ATSPT" },
    { name: "ADF-UN - Aldel Financial Inc.", ticker: "ADF-UN" },
    { name: "ADF-WT - Aldel Financial Inc.", ticker: "ADF-WT" },
    { name: "ATHN-WT - Athena Technology Acquisition Corp.", ticker: "ATHN-WT" },
    { name: "PLMIU - Plum Acquisition Corp. I", ticker: "PLMIU" },
    { name: "PLMIW - Plum Acquisition Corp. I", ticker: "PLMIW" },
    { name: "WALDW - Waldencast Acquisition Corp.", ticker: "WALDW" },
    { name: "ANZUU - Anzu Special Acquisition Corp I", ticker: "ANZUU" },
    { name: "ANZUW - Anzu Special Acquisition Corp I", ticker: "ANZUW" },
    { name: "GPCOU - Golden Path Acquisition Corp", ticker: "GPCOU" },
    { name: "EBACW - European Biotech Acquisition Corp.", ticker: "EBACW" },
    { name: "KCAC-WT - Kensington Capital Acquisition Corp. II", ticker: "KCAC-WT" },
    { name: "VPCC-UN - VPC Impact Acquisition Holdings III, Inc.", ticker: "VPCC-UN" },
    { name: "VLATW - Valor Latitude Acquisition Corp.", ticker: "VLATW" },
    { name: "FRSGU - First Reserve Sustainable Growth Corp.", ticker: "FRSGU" },
    { name: "KAHC-WT - KKR Acquisition Holdings I Corp.", ticker: "KAHC-WT" },
    { name: "EOCW-UN - Elliott Opportunity II Corp.", ticker: "EOCW-UN" },
    { name: "PSPC-UN - Post Holdings Partnering Corp", ticker: "PSPC-UN" },
    { name: "AMAOW - American Acquisition Opportunity Inc.", ticker: "AMAOW" },
    { name: "ESM-WT - ESM Acquisition Corp", ticker: "ESM-WT" },
    { name: "ROSS-WT - Ross Acquisition Corp II", ticker: "ROSS-WT" },
    { name: "RAMMU - Aries I Acquisition Corp.", ticker: "RAMMU" },
    { name: "VGII-WT - Virgin Group Acquisition Corp. II", ticker: "VGII-WT" },
    { name: "PDOT-WT - Peridot Acquisition Corp. II", ticker: "PDOT-WT" },
    { name: "INDIW - indie Semiconductor, Inc.", ticker: "INDIW" },
    { name: "MPACR - Model Performance Acquisition Corp", ticker: "MPACR" },
    { name: "MPACU - Model Performance Acquisition Corp", ticker: "MPACU" },
    { name: "BYTSW - BYTE Acquisition Corp.", ticker: "BYTSW" },
    { name: "POND-UN - Angel Pond Holdings Corp", ticker: "POND-UN" },
    { name: "JUGGU - Jaws Juggernaut Acquisition Corp", ticker: "JUGGU" },
    { name: "SBII-WT - Sandbridge X2 Corp", ticker: "SBII-WT" },
    { name: "FRONW - Frontier Acquisition Corp.", ticker: "FRONW" },
    { name: "ACTDW - ArcLight Clean Transition Corp. II", ticker: "ACTDW" },
    { name: "MCAER - Mountain Crest Acquisition Corp. III", ticker: "MCAER" },
    { name: "MCAFU - Mountain Crest Acquisition Corp. IV", ticker: "MCAFU" },
    { name: "ZTAQU - Zimmer Energy Transition Acquisition Corp.", ticker: "ZTAQU" },
    { name: "GSQB-UN - G Squared Ascend II, Inc.", ticker: "GSQB-UN" },
    { name: "GIWWU - GigInternational1, Inc.", ticker: "GIWWU" },
    { name: "DKDCU - Data Knights Acquisition Corp.", ticker: "DKDCU" },
    { name: "DKDCW - Data Knights Acquisition Corp.", ticker: "DKDCW" },
    { name: "CPARU - Catalyst Partners Acquisition Corp.", ticker: "CPARU" },
    { name: "TRONU - CORNER GROWTH ACQUISITION CORP. 2", ticker: "TRONU" },
    { name: "HITTF - High Tide Inc.", ticker: "HITTF" },
    { name: "TUGCU - TradeUP Global Corp", ticker: "TUGCU" },
    { name: "CLBR-UN - Colombier Acquisition Corp.", ticker: "CLBR-UN" },
    { name: "SKYAU - SKYDECK ACQUISITION CORP.", ticker: "SKYAU" },
    { name: "OTECU - OceanTech Acquisitions I Corp.", ticker: "OTECU" },
    { name: "CNBQF - Ayr Wellness Inc.", ticker: "CNBQF" },
    { name: "MITAU - Coliseum Acquisition Corp.", ticker: "MITAU" },
    { name: "ORIAU - Orion Biotech Opportunities Corp.", ticker: "ORIAU" },
    { name: "LITTU - Logistics Innovation Technologies Corp.", ticker: "LITTU" },
    { name: "LAAAU - Lakeshore Acquisition I Corp.", ticker: "LAAAU" },
    { name: "LCAHW - Landcadia Holdings IV, Inc.", ticker: "LCAHW" },
    { name: "ARTAU - Artisan Acquisition Corp.", ticker: "ARTAU" },
    { name: "MAQCU - Maquia Capital Acquisition Corp", ticker: "MAQCU" },
    { name: "MAQCW - Maquia Capital Acquisition Corp", ticker: "MAQCW" },
    { name: "ACBAW - Ace Global Business Acquisition Ltd", ticker: "ACBAW" },
    { name: "THCPU - Thunder Bridge Capital Partners IV, Inc.", ticker: "THCPU" },
    { name: "DCRCU - Decarbonization Plus Acquisition Corp III", ticker: "DCRCU" },
    { name: "RONI-UN - Rice Acquisition Corp. II", ticker: "RONI-UN" },
    { name: "GFOR-UN - Graf Acquisition Corp. IV", ticker: "GFOR-UN" },
    { name: "PAYOW - Payoneer Global Inc.", ticker: "PAYOW" },
    { name: "REAXD - Real Brokerage Inc", ticker: "REAXD" },
    { name: "ZSHGY - Zhongsheng Group Holdings Limited/ADR/", ticker: "ZSHGY" },
    { name: "EVGO - EVgo Inc", ticker: "EVGO" },
    { name: "BIOS - BioPlus Acquisition Corp.", ticker: "BIOS" },
    { name: "SHCR - Sharecare, Inc.", ticker: "SHCR" },
    { name: "CTKB - Cytek Biosciences, Inc.", ticker: "CTKB" },
    { name: "ENVX - Enovix Corp", ticker: "ENVX" },
    { name: "UP - Wheels Up Experience Inc.", ticker: "UP" },
    { name: "MKFG - Markforged Holding Corp", ticker: "MKFG" },
    { name: "AAWH - Ascend Wellness Holdings, Inc", ticker: "AAWH" },
    { name: "HLLY - Holley Inc.", ticker: "HLLY" },
    { name: "SOPH - SOPHiA GENETICS SA", ticker: "SOPH" },
    { name: "OWLT - Owlet, Inc.", ticker: "OWLT" },
    { name: "CRBU - Caribou Biosciences, Inc.", ticker: "CRBU" },
    { name: "SUNL - Sunlight Financial Holdings Inc.", ticker: "SUNL" },
    { name: "MKTW - MARKETWISE, INC.", ticker: "MKTW" },
    { name: "CPAA - Conyers Park III Acquisition Corp.", ticker: "CPAA" },
    { name: "CIC - Capitol Investment Corp. VII", ticker: "CIC" },
    { name: "NSRXF - Nomad Royalty Co Ltd.", ticker: "NSRXF" },
    { name: "BGRY - Berkshire Grey, Inc.", ticker: "BGRY" },
    { name: "AUID - Ipsidy Inc.", ticker: "AUID" },
    { name: "WBBA - Business Solutions Plus, Inc.", ticker: "WBBA" },
    { name: "ENSC - Ensysce Biosciences, Inc.", ticker: "ENSC" },
    { name: "RGC - Regencell Bioscience Holdings Ltd", ticker: "RGC" },
    { name: "BCOW - 1895 Bancorp of Wisconsin, Inc. /MD/", ticker: "BCOW" },
    { name: "LRFC - Logan Ridge Finance Corp.", ticker: "LRFC" },
    { name: "UNRV - Unrivaled Brands, Inc.", ticker: "UNRV" },
    { name: "PGEZF - Group Ten Metals Inc", ticker: "PGEZF" },
    { name: "AATC - AUTOSCOPE TECHNOLOGIES CORP", ticker: "AATC" },
    { name: "SZLSF - STAGEZERO LIFE SCIENCES LTD.", ticker: "SZLSF" },
    { name: "RNWR - 808 RENEWABLE ENERGY CORP", ticker: "RNWR" },
    { name: "BLMS - BLOOMIOS, INC.", ticker: "BLMS" },
    { name: "COEP - Coeptis Therapeutics Inc.", ticker: "COEP" },
    { name: "CBPI - China Botanic Pharmaceutical", ticker: "CBPI" },
    { name: "RAKR - Rainmaker Worldwide Inc.", ticker: "RAKR" },
    { name: "HRBK - HARBOR BANKSHARES CORP", ticker: "HRBK" },
    { name: "UITA - Utilicraft Aerospace Industries, Inc.", ticker: "UITA" },
    { name: "AQUI - Aquarius I Acquisition Corp.", ticker: "AQUI" },
    { name: "SFIO - Smokefree Innotec, Inc.", ticker: "SFIO" },
    { name: "ISO - IsoPlexis Corp", ticker: "ISO" },
    { name: "CYTO - Auris Medical Holding Ltd.", ticker: "CYTO" },
    { name: "GBTT - Gabbit Corp.", ticker: "GBTT" },
    { name: "AUTH - Authentic Brands Group Inc.", ticker: "AUTH" },
    { name: "CLABD - CORE ONE LABS INC.", ticker: "CLABD" },
    { name: "NALU - Nalu Medical, Inc.", ticker: "NALU" },
    { name: "RNXT - RenovoRx, Inc.", ticker: "RNXT" },
    { name: "SIXWF - SIXTH WAVE INNOVATIONS INC.", ticker: "SIXWF" },
    { name: "DNBBY - DnB NOR ASA", ticker: "DNBBY" },
    { name: "GSTC - AngioSoma, Inc.", ticker: "GSTC" },
    { name: "CGTX - COGNITION THERAPEUTICS INC", ticker: "CGTX" },
    { name: "PECO - Phillips Edison & Company, Inc.", ticker: "PECO" },
    { name: "NXTP - NextPlay Technologies Inc.", ticker: "NXTP" },
    { name: "BRBL - Simlatus Corp", ticker: "BRBL" },
    { name: "GTTN - GTT Communications, Inc.", ticker: "GTTN" },
    { name: "COTRP - STRUCTURED PRODUCTS CORTS TRUST FOR JC PENNEY DEBENTURES", ticker: "COTRP" },
    { name: "MXCT - MAXCYTE, INC.", ticker: "MXCT" },
    { name: "HLM_P - HILLMAN COMPANIES INC", ticker: "HLM_P" },
    { name: "RXST - RxSight, Inc.", ticker: "RXST" },
    { name: "EUBG - ENTREPRENEUR UNIVERSE BRIGHT GROUP", ticker: "EUBG" },
    { name: "SSBK - Southern States Bancshares, Inc.", ticker: "SSBK" },
    { name: "SNAX - STRYVE FOODS, INC.", ticker: "SNAX" },
    { name: "HYZN - Hyzon Motors Inc.", ticker: "HYZN" },
    { name: "CCBS - Castle Creek Biosciences, Inc.", ticker: "CCBS" },
    { name: "MVST - Microvast Holdings, Inc.", ticker: "MVST" },
    { name: "ELYM - Eliem Therapeutics, Inc.", ticker: "ELYM" },
    { name: "AVPT - AvePoint, Inc.", ticker: "AVPT" },
    { name: "CELU - Celularity Inc", ticker: "CELU" },
    { name: "OBT - Orange County Bancorp, Inc. /DE/", ticker: "OBT" },
    { name: "CCLV - COCOLUV INC.", ticker: "CCLV" },
    { name: "RLYB - Rallybio Corp", ticker: "RLYB" },
    { name: "HLMN - Hillman Solutions Corp.", ticker: "HLMN" },
    { name: "MTTR - Gores Holdings VI, Inc.", ticker: "MTTR" },
    { name: "OPFI - OppFi Inc.", ticker: "OPFI" },
    { name: "SMFR - Sema4 Holdings Corp.", ticker: "SMFR" },
    { name: "SMTK - SmartKem, Inc.", ticker: "SMTK" },
    { name: "SOPA - SOCIETY PASS INCORPORATED.", ticker: "SOPA" },
    { name: "LCID - Lucid Group, Inc.", ticker: "LCID" },
    { name: "STRG - STARGUIDE GROUP, INC.", ticker: "STRG" },
    { name: "FFIE - FARADAY FUTURE INTELLIGENT ELECTRIC INC.", ticker: "FFIE" },
    { name: "EVLV - Evolv Technologies Holdings, Inc.", ticker: "EVLV" },
    { name: "JIA - Daojia Ltd", ticker: "JIA" },
    { name: "HOOD - Robinhood Markets, Inc.", ticker: "HOOD" },
    { name: "MSTH - Mystic Holdings Inc./NV", ticker: "MSTH" },
    { name: "IMRX - Immuneering Corp", ticker: "IMRX" },
    { name: "ICVX - Icosavax, Inc.", ticker: "ICVX" },
    { name: "DPRO - Draganfly Inc.", ticker: "DPRO" },
    { name: "CLAQ - cleantech Acquisition Corp.", ticker: "CLAQ" },
    { name: "GLASF - Mercer Park Brand Acquisition Corp.", ticker: "GLASF" },
    { name: "GTAC - Global Technology Acquisition Corp. I", ticker: "GTAC" },
    { name: "NFYS - Enphys Acquisition Corp.", ticker: "NFYS" },
    { name: "ACMSY - AccuStem Sciences Ltd", ticker: "ACMSY" },
    { name: "OMGA - Omega Therapeutics, Inc.", ticker: "OMGA" },
    { name: "ACDI - Ascendant Digital Acquisition Corp. III", ticker: "ACDI" },
    { name: "TFM - Fresh Market Holdings, Inc.", ticker: "TFM" },
    { name: "THRN - Thorne Healthtech, Inc.", ticker: "THRN" },
    { name: "CICX - Capitol Investment Corp. VI", ticker: "CICX" },
    { name: "MRAI - Marpai, Inc.", ticker: "MRAI" },
    { name: "AACI - Armada Acquisition Corp. I", ticker: "AACI" },
    { name: "KDC - Knowlton Development Corp Inc", ticker: "KDC" },
    { name: "MLST - Millstreet Capital Acquisition Corp.", ticker: "MLST" },
    { name: "SSIC - Silver Spike Investment Corp.", ticker: "SSIC" },
    { name: "APXB - Apex Technology Acquisition Corp. II", ticker: "APXB" },
    { name: "CYBN - CYBIN INC.", ticker: "CYBN" },
    { name: "ADGI - Adagio Therapeutics, Inc.", ticker: "ADGI" },
    { name: "KEYR - KeyStar Corp.", ticker: "KEYR" },
    { name: "WEJO - Wejo Group Ltd", ticker: "WEJO" },
    { name: "ARGU - Argus Capital Corp.", ticker: "ARGU" },
    { name: "KCGI - Kensington Capital Acquisition Corp. V", ticker: "KCGI" },
    { name: "FTRP - Field Trip Health Ltd.", ticker: "FTRP" },
    { name: "NN - Spartacus Acquisition Shelf Corp.", ticker: "NN" },
    { name: "CCTS - Cactus Acquisition Corp. 1 Ltd", ticker: "CCTS" },
    { name: "NFTT - Neo Technology Acquisition Corp", ticker: "NFTT" },
    { name: "ATLA - Atlas Growth Acquisition Ltd", ticker: "ATLA" },
    { name: "ACAQ - Athena Consumer Acquisition Corp.", ticker: "ACAQ" },
    { name: "SSU - SIGNA Sports United B.V.", ticker: "SSU" },
    { name: "PMAC - Pomona Acquisition Ltd", ticker: "PMAC" },
    { name: "BBLN - Babylon Holdings Ltd", ticker: "BBLN" },
    { name: "WBX - Wallbox B.V.", ticker: "WBX" },
    { name: "VIEDA - Aetherium Acquisition Corp", ticker: "VIEDA" },
    { name: "EVTL - Vertical Aerospace Ltd.", ticker: "EVTL" },
    { name: "GVAC - Golden Ventures Acquisition Corp", ticker: "GVAC" },
    { name: "JMAC - Jade Mountain Acquisition Corp.", ticker: "JMAC" },
    { name: "BBCO - BETTER BEING CO., LLC", ticker: "BBCO" },
    { name: "ROCG - Roth CH Acquisition IV Co.", ticker: "ROCG" },
    { name: "RICH - RichSpace Acquisition Corp.", ticker: "RICH" },
    { name: "EWCZ - European Wax Center, Inc.", ticker: "EWCZ" },
    { name: "WEBR - Weber Inc.", ticker: "WEBR" },
    { name: "BTRY - Clarios International Inc.", ticker: "BTRY" },
    { name: "BFRI - Biofrontera Inc.", ticker: "BFRI" },
    { name: "ROTK - Rotech Healthcare Holdings Inc.", ticker: "ROTK" },
    { name: "TNYA - Tenaya Therapeutics, Inc.", ticker: "TNYA" },
    { name: "HCRX - Healthcare Royalty, Inc.", ticker: "HCRX" },
    { name: "CDRE - Cadre Holdings, Inc.", ticker: "CDRE" },
    { name: "ASTL - Algoma Steel Group Inc.", ticker: "ASTL" },
    { name: "WCGC - WCG Clinical, Inc.", ticker: "WCGC" },
    { name: "DOLE - Dole plc", ticker: "DOLE" },
    { name: "COOK - TGPX Holdings I LLC", ticker: "COOK" },
    { name: "RANI - Rani Therapeutics Holdings, Inc.", ticker: "RANI" },
    { name: "INCR - Intercure Ltd.", ticker: "INCR" },
    { name: "FINW - Finwise Bancorp", ticker: "FINW" },
    { name: "SNPO - Snap One Holdings Corp.", ticker: "SNPO" },
    { name: "TEAD - Teads S.A.", ticker: "TEAD" },
    { name: "NUVL - Nuvalent, Inc.", ticker: "NUVL" },
    { name: "OXAC - Oxbridge Acquisition Corp.", ticker: "OXAC" },
    { name: "PHCC - Preston Hollow Community Capital, Inc.", ticker: "PHCC" },
    { name: "EVSD - Everside Health Group, Inc.", ticker: "EVSD" },
    { name: "FDSP - Founder SPAC", ticker: "FDSP" },
    { name: "APOA - Apollo Acquisition Corp", ticker: "APOA" },
    { name: "DALS - DA32 Life Science Tech Acquisition Corp.", ticker: "DALS" },
    { name: "SCMA - Seaport Calibre Materials Acquisition Corp.", ticker: "SCMA" },
    { name: "AQUB - Aquarius II Acquisition Corp.", ticker: "AQUB" },
    { name: "MTAL - Metals Acquisition Corp", ticker: "MTAL" },
    { name: "PRDT - Peridot Acquisition Corp. III", ticker: "PRDT" },
    { name: "SCEM - Sachem Acquisition Corp.", ticker: "SCEM" },
    { name: "RSKD - Riskified Ltd.", ticker: "RSKD" },
    { name: "VAQA - Vector Acquisition Corp III", ticker: "VAQA" },
    { name: "BNNR - Banner Acquisition Corp.", ticker: "BNNR" },
    { name: "REVE - Alpine Acquisition Corp.", ticker: "REVE" },
    { name: "ZVIA - Zevia PBC", ticker: "ZVIA" },
    { name: "BWC - Blue Whale Acquisition Corp I", ticker: "BWC" },
    { name: "APCC - Activate Permanent Capital Corp.", ticker: "APCC" },
    { name: "ASPA - Abri SPAC I, Inc.", ticker: "ASPA" },
    { name: "ZHSHF - Zhongsheng Group Holdings Limited/ADR/", ticker: "ZHSHF" },
    { name: "BLPGD - Blue Line Protection Group, Inc.", ticker: "BLPGD" },
    { name: "STLHF - STANDARD LITHIUM LTD.", ticker: "STLHF" },
    { name: "NSRXD - Nomad Royalty Co Ltd.", ticker: "NSRXD" },
    { name: "MRCQF - Mercer Park Brand Acquisition Corp.", ticker: "MRCQF" },
    { name: "KAVLD - Kaival Brands Innovations Group, Inc.", ticker: "KAVLD" },
    { name: "FTRPF - Field Trip Health Ltd.", ticker: "FTRPF" },
    { name: "DFLYF - Draganfly Inc.", ticker: "DFLYF" },
    { name: "REDIF - RedHill Biopharma Ltd.", ticker: "REDIF" },
    { name: "OCBI - Orange County Bancorp, Inc. /DE/", ticker: "OCBI" },
    { name: "MMEXD - MMEX Resources Corp", ticker: "MMEXD" },
    { name: "ATDSD - Data443 Risk Mitigation, Inc.", ticker: "ATDSD" },
    { name: "SSOKD - Sunstock, Inc.", ticker: "SSOKD" },
    { name: "STLYD - HG Holdings, Inc.", ticker: "STLYD" },
    { name: "EXLA - Helmer Directional Drilling Corp.", ticker: "EXLA" },
    { name: "ENNPF - ENBRIDGE INC", ticker: "ENNPF" },
    { name: "CDZAP - CADIZ INC", ticker: "CDZAP" },
    { name: "STFLP - STIFEL FINANCIAL CORP", ticker: "STFLP" },
    { name: "STFLV - STIFEL FINANCIAL CORP", ticker: "STFLV" },
    { name: "NSRWF - Nomad Royalty Co Ltd.", ticker: "NSRWF" },
    { name: "CMS-PC - CMS ENERGY CORP", ticker: "CMS-PC" },
    { name: "VAL-WT - Valaris Ltd", ticker: "VAL-WT" },
    { name: "TDW-WT - TIDEWATER INC", ticker: "TDW-WT" },
    { name: "TDW-WTA - TIDEWATER INC", ticker: "TDW-WTA" },
    { name: "TDW-WTB - TIDEWATER INC", ticker: "TDW-WTB" },
    { name: "WFPDP - WELLS FARGO & COMPANY/MN", ticker: "WFPDP" },
    { name: "CTO-PA - CTO Realty Growth, Inc.", ticker: "CTO-PA" },
    { name: "CTOPP - CTO Realty Growth, Inc.", ticker: "CTOPP" },
    { name: "TDBKF - TORONTO DOMINION BANK", ticker: "TDBKF" },
    { name: "MGRD - AFFILIATED MANAGERS GROUP, INC.", ticker: "MGRD" },
    { name: "RNR-PG - RENAISSANCERE HOLDINGS LTD", ticker: "RNR-PG" },
    { name: "RNRRP - RENAISSANCERE HOLDINGS LTD", ticker: "RNRRP" },
    { name: "SNCRL - SYNCHRONOSS TECHNOLOGIES INC", ticker: "SNCRL" },
    { name: "FRC-PM - FIRST REPUBLIC BANK", ticker: "FRC-PM" },
    { name: "FRBSV - FIRST REPUBLIC BANK", ticker: "FRBSV" },
    { name: "PMCBD - PharmaCyte Biotech, Inc.", ticker: "PMCBD" },
    { name: "NYMFP - NEW YORK MORTGAGE TRUST INC", ticker: "NYMFP" },
    { name: "NYMTL - NEW YORK MORTGAGE TRUST INC", ticker: "NYMTL" },
    { name: "SHO-PI - Sunstone Hotel Investors, Inc.", ticker: "SHO-PI" },
    { name: "SNSHP - Sunstone Hotel Investors, Inc.", ticker: "SNSHP" },
    { name: "PSECP - PROSPECT CAPITAL CORP", ticker: "PSECP" },
    { name: "PSEC-PA - PROSPECT CAPITAL CORP", ticker: "PSEC-PA" },
    { name: "MAXC - MAXCYTE, INC.", ticker: "MAXC" },
    { name: "PEBBP - Pebblebrook Hotel Trust", ticker: "PEBBP" },
    { name: "PHECD - Phillips Edison & Company, Inc.", ticker: "PHECD" },
    { name: "CLDT-PA - Chatham Lodging Trust", ticker: "CLDT-PA" },
    { name: "MDLM - MEDLEY MANAGEMENT INC.", ticker: "MDLM" },
    { name: "MDLYQ - MEDLEY MANAGEMENT INC.", ticker: "MDLYQ" },
    { name: "HTZZW - HERTZ GLOBAL HOLDINGS, INC", ticker: "HTZZW" },
    { name: "MDLQQ - Medley LLC", ticker: "MDLQQ" },
    { name: "MDLXQ - Medley LLC", ticker: "MDLXQ" },
    { name: "SRSPF - SiriusPoint Ltd", ticker: "SRSPF" },
    { name: "SPNT-PB - SiriusPoint Ltd", ticker: "SPNT-PB" },
    { name: "SACH-PA - Sachem Capital Corp.", ticker: "SACH-PA" },
    { name: "FORZ - Forza Innovations Inc", ticker: "FORZ" },
    { name: "METCL - Ramaco Resources, Inc.", ticker: "METCL" },
    { name: "SNAXW - STRYVE FOODS, INC.", ticker: "SNAXW" },
    { name: "HYZNW - Hyzon Motors Inc.", ticker: "HYZNW" },
    { name: "TAISF - Taisho Pharmaceutical Holdings Co Ltd./ADR", ticker: "TAISF" },
    { name: "AVPTW - AvePoint, Inc.", ticker: "AVPTW" },
    { name: "MVSTW - Microvast Holdings, Inc.", ticker: "MVSTW" },
    { name: "CELUW - Celularity Inc", ticker: "CELUW" },
    { name: "EVLVW - Evolv Technologies Holdings, Inc.", ticker: "EVLVW" },
    { name: "FFIEW - FARADAY FUTURE INTELLIGENT ELECTRIC INC.", ticker: "FFIEW" },
    { name: "SHCRW - Sharecare, Inc.", ticker: "SHCRW" },
    { name: "MKFG-WT - Markforged Holding Corp", ticker: "MKFG-WT" },
    { name: "AUVIP - Applied UV, Inc.", ticker: "AUVIP" },
    { name: "AUVPP - Applied UV, Inc.", ticker: "AUVPP" },
    { name: "EVGOW - EVgo Inc", ticker: "EVGOW" },
    { name: "OWLT-WT - Owlet, Inc.", ticker: "OWLT-WT" },
    { name: "OPFI-WT - OppFi Inc.", ticker: "OPFI-WT" },
    { name: "SMFRW - Sema4 Holdings Corp.", ticker: "SMFRW" },
    { name: "MTTRW - Gores Holdings VI, Inc.", ticker: "MTTRW" },
    { name: "UP-WT - Wheels Up Experience Inc.", ticker: "UP-WT" },
    { name: "HLLY-WT - Holley Inc.", ticker: "HLLY-WT" },
    { name: "BGRYW - Berkshire Grey, Inc.", ticker: "BGRYW" },
    { name: "OSI-WT - Osiris Acquisition Corp.", ticker: "OSI-WT" },
    { name: "IINNW - Inspira Technologies OXY B.H.N. Ltd", ticker: "IINNW" },
    { name: "AGRIW - AGRIFORCE GROWING SYSTEMS LTD.", ticker: "AGRIW" },
    { name: "CORS-UN - Corsair Partnering Corp", ticker: "CORS-UN" },
    { name: "POND-WT - Angel Pond Holdings Corp", ticker: "POND-WT" },
    { name: "REEAW - REE Automotive Ltd.", ticker: "REEAW" },
    { name: "RICOU - Agrico Acquisition Corp.", ticker: "RICOU" },
    { name: "CPARW - Catalyst Partners Acquisition Corp.", ticker: "CPARW" },
    { name: "MRCWF - Mercer Park Brand Acquisition Corp.", ticker: "MRCWF" },
    { name: "GHBWF - Mercer Park Brand Acquisition Corp.", ticker: "GHBWF" },
    { name: "LAAAW - Lakeshore Acquisition I Corp.", ticker: "LAAAW" },
    { name: "ACRO-UN - Acropolis Infrastructure Acquisition Corp.", ticker: "ACRO-UN" },
    { name: "TRTL-UN - TortoiseEcofin Acquisition Corp. III", ticker: "TRTL-UN" },
    { name: "CLOEU - Clover Leaf Capital Corp.", ticker: "CLOEU" },
    { name: "FREY-WT - FREYR Battery", ticker: "FREY-WT" },
    { name: "UPTDU - TradeUP Acquisition Corp.", ticker: "UPTDU" },
    { name: "ALIT-WT - Alight, Inc. /DE", ticker: "ALIT-WT" },
    { name: "PSPC-WT - Post Holdings Partnering Corp", ticker: "PSPC-WT" },
    { name: "CLBR-WT - Colombier Acquisition Corp.", ticker: "CLBR-WT" },
    { name: "OTECW - OceanTech Acquisitions I Corp.", ticker: "OTECW" },
    { name: "APACU - StoneBridge Acquisition Corp.", ticker: "APACU" },
    { name: "GFOR-WT - Graf Acquisition Corp. IV", ticker: "GFOR-WT" },
    { name: "TWCBU - Bilander Acquisition Corp.", ticker: "TWCBU" },
    { name: "PFTAU - PORTAGE FINTECH ACQUISITION CORP.", ticker: "PFTAU" },
    { name: "DRAYU - Macondray Capital Acquisition Corp. I", ticker: "DRAYU" },
    { name: "GLTA-UN - Galata Acquisition Corp.", ticker: "GLTA-UN" },
    { name: "FICVU - Frontier Investment Corp", ticker: "FICVU" },
    { name: "JATT-UN - JATT Acquisition Corp", ticker: "JATT-UN" },
    { name: "CLAYU - Chavant Capital Acquisition Corp.", ticker: "CLAYU" },
    { name: "EXPGY - Experian Group LTD", ticker: "EXPGY" },
    { name: "SAUHY - Straumann Holding AG / ADR", ticker: "SAUHY" },
    { name: "PTAIY - PT Astra International Tbk / ADR", ticker: "PTAIY" },
    { name: "LNVGY - LENOVO GROUP LTD", ticker: "LNVGY" },
    { name: "PBCRY - PT Bank Central Asia Tbk / ADR", ticker: "PBCRY" },
    { name: "PTBRY - PT Bank Negara Indonesia (Persero) Tbk/ADR", ticker: "PTBRY" },
    { name: "ACCYY - ACCOR", ticker: "ACCYY" },
    { name: "GLPEY - Galp Energia, SGPS, S.A.", ticker: "GLPEY" },
    { name: "PEGRY - Pennon Group Plc / ADR", ticker: "PEGRY" },
    { name: "ALIT - Alight, Inc. / Delaware", ticker: "ALIT" },
    { name: "CADE - BancorpSouth Bank", ticker: "CADE" },
    { name: "PTXKY - PT XL Axiata Tbk/ADR", ticker: "PTXKY" },
    { name: "ACHR - Archer Aviation Inc.", ticker: "ACHR" },
    { name: "SDIG - Stronghold Digital Mining, Inc.", ticker: "SDIG" },
    { name: "BKGFY - Berkeley Group Holdings plc", ticker: "BKGFY" },
    { name: "AKA - A.K.A. BRANDS HOLDING CORP.", ticker: "AKA" },
    { name: "TRSSF - TerrAscend Corp.", ticker: "TRSSF" },
    { name: "CLVLY - Clinuvel Pharmaceuticals Ltd", ticker: "CLVLY" },
    { name: "ASZP - JV GROUP, INC.", ticker: "ASZP" },
    { name: "AIP - Arteris, Inc.", ticker: "AIP" },
    { name: "AIRS - Airsculpt Technologies, Inc.", ticker: "AIRS" },
    { name: "AADI - Aadi Bioscience, Inc.", ticker: "AADI" },
    { name: "HMBL - Tesoro Distributors, Inc.", ticker: "HMBL" },
    { name: "AGIL - AgileThought, Inc.", ticker: "AGIL" },
    { name: "CTRA - Coterra Energy Inc.", ticker: "CTRA" },
    { name: "CVT - Dragoneer Growth Opportunities Corp. II", ticker: "CVT" },
    { name: "NHIC - NewHold Investment Corp. II", ticker: "NHIC" },
    { name: "AERC - AeroClean Technologies, Inc.", ticker: "AERC" },
    { name: "CWBHF - Charlotte's Web Holdings, Inc.", ticker: "CWBHF" },
    { name: "GRAMF - TPCO Holding Corp.", ticker: "GRAMF" },
    { name: "LSAC - DMB Acquisition Corp.", ticker: "LSAC" },
    { name: "LFAC - LF Capital Acquisition Corp. II", ticker: "LFAC" },
    { name: "XERS - Xeris Biopharma Holdings, Inc.", ticker: "XERS" },
    { name: "AEHA - Aesther Healthcare Acquisition Corp.", ticker: "AEHA" },
    { name: "AHI - Advanced Human Imaging Ltd", ticker: "AHI" },
    { name: "TGGI - TRANS GLOBAL GROUP, INC.", ticker: "TGGI" },
    { name: "MOXC - Moxian (BVI) Inc", ticker: "MOXC" },
    { name: "SEV - Sono Group N.V.", ticker: "SEV" },
    { name: "IVDA - Iveda Solutions, Inc.", ticker: "IVDA" },
    { name: "JETMF - Global Crossing Airlines Group Inc.", ticker: "JETMF" },
    { name: "ORPB - OREGON PACIFIC BANCORP", ticker: "ORPB" },
    { name: "ALTB - Balincan International Inc.", ticker: "ALTB" },
    { name: "VEGYF - VIRGINIA ENERGY RESOURCES INC", ticker: "VEGYF" },
    { name: "BOPO - Biopower Operations Corp", ticker: "BOPO" },
    { name: "PSYBF - PSYBIO THERAPEUTICS FINANCING INC.", ticker: "PSYBF" },
    { name: "CSKL - CATSKILL HUDSON BANCORP INC", ticker: "CSKL" },
    { name: "CJJD - China Jo-Jo Drugstores Holdings, Inc.", ticker: "CJJD" },
    { name: "FERN - Fernhill Corp", ticker: "FERN" },
    { name: "AIAD - AiAdvertising, Inc.", ticker: "AIAD" },
    { name: "RXMD - Progressive Care Inc.", ticker: "RXMD" },
    { name: "PJXRF - PJX Resources Inc.", ticker: "PJXRF" },
    { name: "BCCEF - BacTech Environmental Corp", ticker: "BCCEF" },
    { name: "CFIC - Cornerstone Financial Corp", ticker: "CFIC" },
    { name: "ARCK - Arbor Rapha Capital Bioholdings Corp. I", ticker: "ARCK" },
    { name: "LUXFF - Luxxfolio Holdings Inc.", ticker: "LUXFF" },
    { name: "ARMC - Un Monde International Ltd.", ticker: "ARMC" },
    { name: "COWI - CoroWare, Inc,", ticker: "COWI" },
    { name: "AMRR - American Metals Recovery & Recycling Inc.", ticker: "AMRR" },
    { name: "EARI - ENTERTAINMENT ARTS RESEARCH, INC.", ticker: "EARI" },
    { name: "BMCS - BMCS SUMCOIN INDEX FUND, INC.", ticker: "BMCS" },
    { name: "AGNPD - Algernon Pharmaceuticals Inc.", ticker: "AGNPD" },
    { name: "GSAC - GELSTAT CORP", ticker: "GSAC" },
    { name: "CYDX - CYduct Diagnostics, Inc.", ticker: "CYDX" },
    { name: "PCNT - Point of Care Nano-Technology, Inc.", ticker: "PCNT" },
    { name: "GOFF - GOFF, CORP", ticker: "GOFF" },
    { name: "KATX - KAT EXPLORATION, INC.", ticker: "KATX" },
    { name: "MLMN - Millennium Prime, Inc.", ticker: "MLMN" },
    { name: "PRPS - Propellus, Inc.", ticker: "PRPS" },
    { name: "CMDRF - COMMANDER RESOURCES LTD", ticker: "CMDRF" },
    { name: "STUPF - Straightup Resources Inc", ticker: "STUPF" },
    { name: "GSBX - Golden State Bancorp", ticker: "GSBX" },
    { name: "OXBC - Oxford Bank Corp", ticker: "OXBC" },
    { name: "BONZ - Bonanza Goldfields Corp.", ticker: "BONZ" },
    { name: "TLGN - Ever Harvest International Group Inc.", ticker: "TLGN" },
    { name: "SANP - SANTO MINING CORP.", ticker: "SANP" },
    { name: "ELIO - Elio Motors, Inc.", ticker: "ELIO" },
    { name: "SVSN - STEREO VISION ENTERTAINMENT INC", ticker: "SVSN" },
    { name: "KENS - KENILWORTH SYSTEMS CORP", ticker: "KENS" },
    { name: "MSPC - METROSPACES, INC.", ticker: "MSPC" },
    { name: "IWAL - iWallet Corp", ticker: "IWAL" },
    { name: "SGLA - Sino Green Land Corp.", ticker: "SGLA" },
    { name: "QLIS - Qualis Innovations, Inc.", ticker: "QLIS" },
    { name: "NHLE - Nhale, Inc.", ticker: "NHLE" },
    { name: "GEVI - General Enterprise Ventures, Inc.", ticker: "GEVI" },
    { name: "VIZC - VIZCONNECT, INC.", ticker: "VIZC" },
    { name: "XTRM - EXTREME BIODIESEL, INC.", ticker: "XTRM" },
    { name: "PURT - Purthanol Resources Ltd", ticker: "PURT" },
    { name: "AWON - A1 Group, Inc.", ticker: "AWON" },
    { name: "KWIK - KwikClick, Inc.", ticker: "KWIK" },
    { name: "EMDF - E Med Future, Inc.", ticker: "EMDF" },
    { name: "ENMI - DH ENCHANTMENT, INC.", ticker: "ENMI" },
    { name: "REOS - ReoStar Energy CORP", ticker: "REOS" },
    { name: "WLYW - Wally World Media, Inc", ticker: "WLYW" },
    { name: "WGEI - WINDGEN ENERGY, INC.", ticker: "WGEI" },
    { name: "EFIR - EGPI FIRECREEK, INC.", ticker: "EFIR" },
    { name: "XCPL - XCPCNL Business Services Corp", ticker: "XCPL" },
    { name: "SDVI - SIGNATURE DEVICES INC", ticker: "SDVI" },
    { name: "NICH - NITCHES INC", ticker: "NICH" },
    { name: "BSSP - BASELINE PRODUCTIONS, INC.", ticker: "BSSP" },
    { name: "XRXH - Entertainment Holdings, Inc./OK", ticker: "XRXH" },
    { name: "ATYG - Atlas Technology Group, Inc.", ticker: "ATYG" },
    { name: "NNRX - NUTRANOMICS, INC.", ticker: "NNRX" },
    { name: "AHFD - Active Health Foods, Inc.", ticker: "AHFD" },
    { name: "BEES - JJY Holding Group", ticker: "BEES" },
    { name: "MNGG - Mining Global, Inc.", ticker: "MNGG" },
    { name: "XPRO - EXPRO GROUP HOLDINGS N.V.", ticker: "XPRO" },
    { name: "EVTV - Envirotech Vehicles, Inc.", ticker: "EVTV" },
    { name: "FBRT - Franklin BSP Realty Trust, Inc.", ticker: "FBRT" },
    { name: "INTS - INTENSITY THERAPEUTICS, INC.", ticker: "INTS" },
    { name: "USER - UserTesting, Inc.", ticker: "USER" },
    { name: "OCEL - Organicell Regenerative Medicine, Inc.", ticker: "OCEL" },
    { name: "FSPR - Four Springs Capital Trust", ticker: "FSPR" },
    { name: "TNT - Tenet Fintech Group Inc.", ticker: "TNT" },
    { name: "PLSH - PANACEA LIFE SCIENCES HOLDINGS, INC.", ticker: "PLSH" },
    { name: "CGSI - CGS INTERNATIONAL, INC.", ticker: "CGSI" },
    { name: "BIOF - BLUE BIOFUELS, INC.", ticker: "BIOF" },
    { name: "LLL - JX Luxventure Ltd", ticker: "LLL" },
    { name: "BPYPM - Brookfield Property Partners L.P.", ticker: "BPYPM" },
    { name: "AVTX - Avalo Therapeutics, Inc.", ticker: "AVTX" },
    { name: "CION - CION Investment Corp", ticker: "CION" },
    { name: "FNA - Paragon 28, Inc.", ticker: "FNA" },
    { name: "CRYM - Cryomass Technologies, Inc.", ticker: "CRYM" },
    { name: "FRSH - Freshworks Inc.", ticker: "FRSH" },
    { name: "SMBA - Samba TV, Inc.", ticker: "SMBA" },
    { name: "EZRG - EZRaider Co.", ticker: "EZRG" },
    { name: "ETOR - eToro Group Ltd.", ticker: "ETOR" },
    { name: "AURA - Aura Biosciences, Inc.", ticker: "AURA" },
    { name: "MULN - MULLEN AUTOMOTIVE INC.", ticker: "MULN" },
    { name: "LVO - LiveOne, Inc.", ticker: "LVO" },
    { name: "POGO - Intuity Medical, Inc.", ticker: "POGO" },
    { name: "COCO - Vita Coco Company, Inc.", ticker: "COCO" },
    { name: "EXFY - Expensify, Inc.", ticker: "EXFY" },
    { name: "WRBY - Warby Parker Inc.", ticker: "WRBY" },
    { name: "KPRX - KIORA PHARMACEUTICALS INC", ticker: "KPRX" },
    { name: "APGT - Appgate, Inc.", ticker: "APGT" },
    { name: "NXDT - NEXPOINT DIVERSIFIED REAL ESTATE TRUST", ticker: "NXDT" },
    { name: "RMESF - RED METAL RESOURCES, LTD.", ticker: "RMESF" },
    { name: "FHLD - Freedom Holdings, Inc.", ticker: "FHLD" },
    { name: "FTMRQ - Fortem Resources Inc.", ticker: "FTMRQ" },
    { name: "LSFP - LFTD PARTNERS INC.", ticker: "LSFP" },
    { name: "BLYFF - BOART LONGYEAR LTD", ticker: "BLYFF" },
    { name: "SONX - Sonendo, Inc.", ticker: "SONX" },
    { name: "EVO - Evotec SE", ticker: "EVO" },
    { name: "TROO - Troops, Inc. /Cayman Islands/", ticker: "TROO" },
    { name: "MLCT - MALACHITE INNOVATIONS, INC.", ticker: "MLCT" },
    { name: "ZWS - Zurn Water Solutions Corp", ticker: "ZWS" },
    { name: "RBSH - Rebus Holdings, Inc.", ticker: "RBSH" },
    { name: "HSMD - Healthcare Solutions Management Group, Inc.", ticker: "HSMD" },
    { name: "ATXS - Astria Therapeutics, Inc.", ticker: "ATXS" },
    { name: "FKST - Flowerkist Skin Care & Cosmetics, Inc.", ticker: "FKST" },
    { name: "UTRS - MINERVA SURGICAL INC", ticker: "UTRS" },
    { name: "NNMX - NANOMIX Corp", ticker: "NNMX" },
    { name: "RENT - Rent the Runway, Inc.", ticker: "RENT" },
    { name: "UPOW - UAN Power Corp", ticker: "UPOW" },
    { name: "KUSA - Kashin, Inc.", ticker: "KUSA" },
    { name: "BLZE - Backblaze, Inc.", ticker: "BLZE" },
    { name: "NVNO - enVVeno Medical Corp", ticker: "NVNO" },
    { name: "GLGX - Gerson Lehrman Group, Inc.", ticker: "GLGX" },
    { name: "CMTG - Claros Mortgage Trust, Inc.", ticker: "CMTG" },
    { name: "RWAY - Runway Growth Finance Corp.", ticker: "RWAY" },
    { name: "GTLB - Gitlab Inc.", ticker: "GTLB" },
    { name: "BIRD - Allbirds, Inc.", ticker: "BIRD" },
    { name: "CHMX - NEXT-ChemX Corporation.", ticker: "CHMX" },
    { name: "MDVA - MODIV INC.", ticker: "MDVA" },
    { name: "STER - Sterling Check Corp.", ticker: "STER" },
    { name: "DICE - DICE Therapeutics, Inc.", ticker: "DICE" },
    { name: "DATS - DatChat, Inc.", ticker: "DATS" },
    { name: "SQBGQ - Sequential Brands Group, Inc.", ticker: "SQBGQ" },
    { name: "BAFN - BayFirst Financial Corp.", ticker: "BAFN" },
    { name: "TOST - Toast, Inc.", ticker: "TOST" },
    { name: "IOT - Samsara Inc.", ticker: "IOT" },
    { name: "MPWF - MPOWER Financing, Public Benefit Corp", ticker: "MPWF" },
    { name: "QNRX - Quoin Pharmaceuticals, Ltd.", ticker: "QNRX" },
    { name: "LTRY - Lottery.com Inc.", ticker: "LTRY" },
    { name: "BRZE - Braze, Inc.", ticker: "BRZE" },
    { name: "JUNS - JUPITER NEUROSCIENCES, INC.", ticker: "JUNS" },
    { name: "NU - Nu Holdings Ltd.", ticker: "NU" },
    { name: "KCRD - MWF GLOBAL INC.", ticker: "KCRD" },
    { name: "DIAH - DIAMOND HOLDINGS, INC.", ticker: "DIAH" },
    { name: "VXI - 5.11 ABR CORP.", ticker: "VXI" },
    { name: "TRDA - Entrada Therapeutics, Inc.", ticker: "TRDA" },
    { name: "VBNK - VersaBank", ticker: "VBNK" },
    { name: "ICR-PA - InPoint Commercial Real Estate Income, Inc.", ticker: "ICR-PA" },
    { name: "ZHEC - ZHRH Corp", ticker: "ZHEC" },
    { name: "PRCT - PROCEPT BioRobotics Corp", ticker: "PRCT" },
    { name: "DFGC - Dengfeng Group Ltd", ticker: "DFGC" },
    { name: "TCN - Tricon Residential Inc.", ticker: "TCN" },
    { name: "LTES - Leet Technology Inc.", ticker: "LTES" },
    { name: "VIA - Via Renewables, Inc.", ticker: "VIA" },
    { name: "SQL - SeqLL, Inc.", ticker: "SQL" },
    { name: "UDMY - Udemy, Inc.", ticker: "UDMY" },
    { name: "FWBI - First Wave BioPharma, Inc.", ticker: "FWBI" },
    { name: "AGDX - Agendia N.V.", ticker: "AGDX" },
    { name: "GRTA - Griffin Realty Trust, Inc.", ticker: "GRTA" },
    { name: "WEAV - Weave Communications, Inc.", ticker: "WEAV" },
    { name: "SPRCF - SciSparc Ltd.", ticker: "SPRCF" },
    { name: "PHCI - Panamera Holdings Corp", ticker: "PHCI" },
    { name: "HLTH - Cue Health Inc.", ticker: "HLTH" },
    { name: "AEON - AEON Biopharma, Inc.", ticker: "AEON" },
    { name: "NRDS - NERDWALLET, INC.", ticker: "NRDS" },
    { name: "ARMV - Arma Services Inc", ticker: "ARMV" },
    { name: "SKE - Skeena Resources Ltd", ticker: "SKE" },
    { name: "MNAO - MINARO CORP", ticker: "MNAO" },
    { name: "DOMA - Doma Holdings, Inc.", ticker: "DOMA" },
    { name: "HCP - HashiCorp, Inc.", ticker: "HCP" },
    { name: "HIVE - HIVE Blockchain Technologies Ltd.", ticker: "HIVE" },
    { name: "CRDL - Cardiol Therapeutics Inc.", ticker: "CRDL" },
    { name: "GFS - GLOBALFOUNDRIES Inc.", ticker: "GFS" },
    { name: "ECVT - Ecovyst Inc.", ticker: "ECVT" },
    { name: "BJDX - Bluejay Diagnostics, Inc.", ticker: "BJDX" },
    { name: "THRX - Theseus Pharmaceuticals, Inc.", ticker: "THRX" },
    { name: "EAAS - Redaptive, Inc.", ticker: "EAAS" },
    { name: "BXSL - Blackstone Secured Lending Fund", ticker: "BXSL" },
    { name: "GRAZ - Graze, Inc.", ticker: "GRAZ" },
    { name: "XRTX - XORTX Therapeutics Inc.", ticker: "XRTX" },
    { name: "NBLD - Nestbuilder.com Corp.", ticker: "NBLD" },
    { name: "TLNT - iCIMS Holding LLC", ticker: "TLNT" },
    { name: "SANG - Sangoma Technologies Corp", ticker: "SANG" },
    { name: "INKI - INKY INC.", ticker: "INKI" },
    { name: "BKSY - BlackSky Technology Inc.", ticker: "BKSY" },
    { name: "EVVL - Evil Empire Designs, Inc.", ticker: "EVVL" },
    { name: "NOWG - Nowigence Inc.", ticker: "NOWG" },
    { name: "CJAX - CoJax Oil & Gas Corp", ticker: "CJAX" },
    { name: "DPM - Desert Peak Minerals Inc.", ticker: "DPM" },
    { name: "LVLU - Lulu's Fashion Lounge Holdings, Inc.", ticker: "LVLU" },
    { name: "MNTS - Momentus Inc.", ticker: "MNTS" },
    { name: "IRNT - IronNet, Inc.", ticker: "IRNT" },
    { name: "VQS - VIQ Solutions Inc.", ticker: "VQS" },
    { name: "NVEI - Nuvei Corp", ticker: "NVEI" },
    { name: "LITM - Snow Lake Resources Ltd.", ticker: "LITM" },
    { name: "LUCD - Lucid Diagnostics Inc.", ticker: "LUCD" },
    { name: "TOI - Oncology Institute, Inc.", ticker: "TOI" },
    { name: "IONM - Assure Holdings Corp.", ticker: "IONM" },
    { name: "TMC - TMC the metals Co Inc.", ticker: "TMC" },
    { name: "HXN - Hexion Holdings Corp", ticker: "HXN" },
    { name: "CYXT - Cyxtera Technologies, Inc.", ticker: "CYXT" },
    { name: "TDCX - TDCX Inc.", ticker: "TDCX" },
    { name: "GFAI - Guardforce AI Co., Ltd", ticker: "GFAI" },
    { name: "CLRS - Claire's Holdings LLC", ticker: "CLRS" },
    { name: "FWRG - First Watch Restaurant Group, Inc.", ticker: "FWRG" },
    { name: "JSPR - Jasper Therapeutics, Inc.", ticker: "JSPR" },
    { name: "TIVC - Tivic Health Systems, Inc.", ticker: "TIVC" },
    { name: "HLBZ - Helbiz, Inc.", ticker: "HLBZ" },
    { name: "BWV - Blue Water Vaccines Inc.", ticker: "BWV" },
    { name: "RELY - Remitly Global, Inc.", ticker: "RELY" },
    { name: "PYXS - Pyxis Oncology, Inc.", ticker: "PYXS" },
    { name: "TCBX - Third Coast Bancshares, Inc.", ticker: "TCBX" },
    { name: "WBEV - Winc, Inc.", ticker: "WBEV" },
    { name: "SHPW - Shapeways Holdings, Inc.", ticker: "SHPW" },
    { name: "PNYG - Pony Group Inc.", ticker: "PNYG" },
    { name: "FHP - Freehold Properties, Inc.", ticker: "FHP" },
    { name: "ZD - ZIFF DAVIS, INC.", ticker: "ZD" },
    { name: "CRDV - Community Redevelopment Inc.", ticker: "CRDV" },
    { name: "BASXQ - BASIC ENERGY SERVICES, INC.", ticker: "BASXQ" },
    { name: "SLVYY - SOLVAY S A /ADR/", ticker: "SLVYY" },
    { name: "SCWO - 374Water Inc.", ticker: "SCWO" },
    { name: "AZTA - Azenta, Inc.", ticker: "AZTA" },
    { name: "VATE - INNOVATE Corp.", ticker: "VATE" },
    { name: "SNDA - SONIDA SENIOR LIVING, INC.", ticker: "SNDA" },
    { name: "SBET - SharpLink Gaming Ltd.", ticker: "SBET" },
    { name: "BNOX - BIONOMICS LIMITED/FI", ticker: "BNOX" },
    { name: "HWTR - HFactor, Inc.", ticker: "HWTR" },
    { name: "CRKR - Creek Road Miners, Inc.", ticker: "CRKR" },
    { name: "YBCN - Yong Bai Chao New Retail Corp", ticker: "YBCN" },
    { name: "SISI - SHINECO, INC.", ticker: "SISI" },
    { name: "LCGMF - LION COPPER & GOLD CORP.", ticker: "LCGMF" },
    { name: "ESPI - ESP Resources, Inc.", ticker: "ESPI" },
    { name: "STAB - Statera Biopharma, Inc.", ticker: "STAB" },
    { name: "IVT - InvenTrust Properties Corp.", ticker: "IVT" },
    { name: "SNT - SENSTAR TECHNOLOGIES LTD.", ticker: "SNT" },
    { name: "ETD - ETHAN ALLEN INTERIORS INC", ticker: "ETD" },
    { name: "WOLF - WOLFSPEED, INC.", ticker: "WOLF" },
    { name: "CLRD - Clearday, Inc.", ticker: "CLRD" },
    { name: "STGW - Stagwell Inc", ticker: "STGW" },
    { name: "PRNDY - PERNOD RICARD S A /FI", ticker: "PRNDY" },
    { name: "CECL - CECIL BANCORP INC", ticker: "CECL" },
    { name: "VRE - MACK CALI REALTY CORP", ticker: "VRE" },
    { name: "ISIGN - iSign Solutions Inc.", ticker: "ISIGN" },
    { name: "BBWI - Bath & Body Works, Inc.", ticker: "BBWI" },
    { name: "TLGTQ - Teligent, Inc.", ticker: "TLGTQ" },
    { name: "RRX - REGAL REXNORD CORP", ticker: "RRX" },
    { name: "SLNH - Soluna Holdings, Inc", ticker: "SLNH" },
    { name: "MLKN - MILLERKNOLL, INC.", ticker: "MLKN" },
    { name: "FOGO - Fogo Hospitality, Inc.", ticker: "FOGO" },
    { name: "JWAC - Jupiter Wellness Acquisition Corp.", ticker: "JWAC" },
    { name: "TF - Transfix Holdings, Inc.", ticker: "TF" },
    { name: "AIB - AIB Acquisition Corp", ticker: "AIB" },
    { name: "LGTO - LEGATO MERGER CORP. II", ticker: "LGTO" },
    { name: "BFAC - Battery Future Acquisition Corp.", ticker: "BFAC" },
    { name: "DRCT - Direct Digital Holdings, Inc.", ticker: "DRCT" },
    { name: "PSGI - Perfect Solutions Group, Inc.", ticker: "PSGI" },
    { name: "PRM - Perimeter Solutions, SA", ticker: "PRM" },
    { name: "VINE - Fresh Vine Wine, Inc.", ticker: "VINE" },
    { name: "ATEK - Athena Technology Acquisition Corp. II", ticker: "ATEK" },
    { name: "ECOA - Energy Cloud I Acquisition Corp", ticker: "ECOA" },
    { name: "ROC - ROC Energy Acquisition Corp.", ticker: "ROC" },
    { name: "ALOR - ALSP Orchid Acquisition Corp I", ticker: "ALOR" },
    { name: "VSAC - VISION SENSING ACQUISITION CORP.", ticker: "VSAC" },
    { name: "CLIN - Clean Earth Acquisitions Corp.", ticker: "CLIN" },
    { name: "PSNY - Polestar Automotive Holding UK Ltd", ticker: "PSNY" },
    { name: "SESU - SensaSure Technologies, Inc.", ticker: "SESU" },
    { name: "MTVC - Motive Capital Corp II", ticker: "MTVC" },
    { name: "XYGJ - Fortune Joy International Acquisition Corp", ticker: "XYGJ" },
    { name: "SGHC - Super Group (SGHC) Ltd", ticker: "SGHC" },
    { name: "ICGC - Igniting Consumer Growth Acquisition Co Ltd", ticker: "ICGC" },
    { name: "RGG - Rue Gilt Groupe, Inc.", ticker: "RGG" },
    { name: "VGFC - Very Good Food Co Inc.", ticker: "VGFC" },
    { name: "IREN - Iris Energy Ltd", ticker: "IREN" },
    { name: "DOUG - Douglas Elliman Inc.", ticker: "DOUG" },
    { name: "CFSB - CFSB Bancorp, Inc. /MA/", ticker: "CFSB" },
    { name: "CVCBY - CVC Brasil Operadora e Agencia de Viagens S.A./ADR", ticker: "CVCBY" },
    { name: "UTAA - UTA Acquisition Corp", ticker: "UTAA" },
    { name: "WEL - Integrated Wellness Acquisition Corp", ticker: "WEL" },
    { name: "EOC - EO Charging", ticker: "EOC" },
    { name: "ZGN - Ermenegildo Zegna Holditalia S.p.A.", ticker: "ZGN" },
    { name: "ADSE - Ads-Tec Energy Public Ltd Co", ticker: "ADSE" },
    { name: "MYSN - Myson, Inc.", ticker: "MYSN" },
    { name: "LGVC - LAMF Global Ventures Corp. I", ticker: "LGVC" },
    { name: "ENCP - Energem Corp", ticker: "ENCP" },
    { name: "SIDU - Sidus Space Inc.", ticker: "SIDU" },
    { name: "TLGY - TLGY Acquisition Corp", ticker: "TLGY" },
    { name: "PEV - PHOENIX MOTOR INC.", ticker: "PEV" },
    { name: "TMTC - TMT Acquisition Corp.", ticker: "TMTC" },
    { name: "LIBY - Liberty Resources Acquisition Corp.", ticker: "LIBY" },
    { name: "VTSCY - Vitesco Technologies Group AG /ADR", ticker: "VTSCY" },
    { name: "SHAP - Spree Acquisition Corp. 1 Ltd", ticker: "SHAP" },
    { name: "PFHC - ProFrac Holding Corp.", ticker: "PFHC" },
    { name: "NUBI - Nubia Brand International Corp.", ticker: "NUBI" },
    { name: "NSTS - NSTS Bancorp, Inc.", ticker: "NSTS" },
    { name: "AOGO - Arogo Capital Acquisition Corp.", ticker: "AOGO" },
    { name: "ARIZ - Arisz Acquisition Corp.", ticker: "ARIZ" },
    { name: "VMGA - VMG Consumer Acquisition Corp.", ticker: "VMGA" },
    { name: "GFGD - Growth for Good Acquisition Corp", ticker: "GFGD" },
    { name: "THCH - TH International Ltd", ticker: "THCH" },
    { name: "ARHS - Arhaus, Inc.", ticker: "ARHS" },
    { name: "CSLM - Consilium Acquisition Corp I, Ltd.", ticker: "CSLM" },
    { name: "NVCT - Nuvectis Pharma, Inc.", ticker: "NVCT" },
    { name: "SWVL - Pivotal Holdings Corp", ticker: "SWVL" },
    { name: "AEIB - AEI CapForce II Investment Corp", ticker: "AEIB" },
    { name: "CRCL - CIrcle Acquisition Public Ltd Co", ticker: "CRCL" },
    { name: "IHS - IHS Holding Ltd", ticker: "IHS" },
    { name: "OLV - Olive Ventures Holdings, Inc.", ticker: "OLV" },
    { name: "PRE - Prenetics Global Ltd", ticker: "PRE" },
    { name: "IMPP - Imperial Petroleum Inc./Marshall Islands", ticker: "IMPP" },
    { name: "PEPL - PepperLime Health Acquisition Corp", ticker: "PEPL" },
    { name: "PGRU - PropertyGuru Group Ltd", ticker: "PGRU" },
    { name: "BCSA - Blockchain Coinvestors Acquisition Corp. I", ticker: "BCSA" },
    { name: "RIVN - Rivian Automotive, Inc. / DE", ticker: "RIVN" },
    { name: "RCAC - Revelstone Capital Acquisition Corp.", ticker: "RCAC" },
    { name: "MYNZ - Mainz Biomed B.V.", ticker: "MYNZ" },
    { name: "SATL - Satellogic Inc.", ticker: "SATL" },
    { name: "ALLG - Athena Pubco B.V.", ticker: "ALLG" },
    { name: "FRBN - Forbion European Acquisition Corp.", ticker: "FRBN" },
    { name: "MLAN - Milan Laser Inc.", ticker: "MLAN" },
    { name: "HOUR - Hour Loop, Inc", ticker: "HOUR" },
    { name: "VCSA - Vacasa, Inc.", ticker: "VCSA" },
    { name: "USAX - USA Acquisition Corp.", ticker: "USAX" },
    { name: "RHDM - Rhodium Enterprises, Inc.", ticker: "RHDM" },
    { name: "NRSN - NeuroSense Therapeutics Ltd.", ticker: "NRSN" },
    { name: "DRTS - Alpha Tau Medical Ltd.", ticker: "DRTS" },
    { name: "PTLO - Portillo's Inc.", ticker: "PTLO" },
    { name: "BRKH - BurTech Acquisition Corp.", ticker: "BRKH" },
    { name: "HPAC - Henley Park Acquisition Corp.", ticker: "HPAC" },
    { name: "ACLHF - ACME Lithium Inc.", ticker: "ACLHF" },
    { name: "DSAQ - Direct Selling Acquisition Corp.", ticker: "DSAQ" },
    { name: "LYLT - Loyalty Ventures Inc.", ticker: "LYLT" },
    { name: "BBUC - Brookfield Business Corp", ticker: "BBUC" },
    { name: "RGF - Real Good Food Company, Inc.", ticker: "RGF" },
    { name: "DTC - Solo Brands, Inc.", ticker: "DTC" },
    { name: "OHAA - Opy Acquisition Corp. I", ticker: "OHAA" },
    { name: "ENTF - Enterprise 4.0 Technology Acquisition Corp", ticker: "ENTF" },
    { name: "ANGH - Anghami Inc", ticker: "ANGH" },
    { name: "BULL - Bullish", ticker: "BULL" },
    { name: "STRN - Stran & Company, Inc.", ticker: "STRN" },
    { name: "MDXH - MDxHealth SA", ticker: "MDXH" },
    { name: "TCBP - TC BioPharm (Holdings) Ltd", ticker: "TCBP" },
    { name: "MTEK - Maris Tech Ltd.", ticker: "MTEK" },
    { name: "CDLA - Candela Medical, Inc.", ticker: "CDLA" },
    { name: "NWAC - Namaste World Acquisition Corp", ticker: "NWAC" },
    { name: "KLC - KC Holdco, LLC", ticker: "KLC" },
    { name: "BBLR - Bubblr Inc.", ticker: "BBLR" },
    { name: "IMMX - Immix Biopharma, Inc.", ticker: "IMMX" },
    { name: "IXHL - Incannex Healthcare Ltd", ticker: "IXHL" },
    { name: "SUNF - Sunfire Acquisition Corp Ltd", ticker: "SUNF" },
    { name: "ONL - Orion Office REIT Inc.", ticker: "ONL" },
    { name: "TYTP - TypTap Insurance Group, Inc.", ticker: "TYTP" },
    { name: "CYN - Cyngn Inc.", ticker: "CYN" },
    { name: "REAI - Renewable Energy Acquisition Corp. /DE/", ticker: "REAI" },
    { name: "SMAP - Sportsmap Tech Acquisition Corp.", ticker: "SMAP" },
    { name: "BIDI - Inter Platform, Inc.", ticker: "BIDI" },
    { name: "PPHP - PHP Ventures Acquisition Corp.", ticker: "PPHP" },
    { name: "THAC - Thrive Acquisition Corp", ticker: "THAC" },
    { name: "MNTN - Everest Consolidator Acquisition Corp", ticker: "MNTN" },
    { name: "ARIS - Aris Water Solutions, Inc.", ticker: "ARIS" },
    { name: "TGVC - TG Venture Acquisition Corp.", ticker: "TGVC" },
    { name: "FGI - FGI Industries Ltd.", ticker: "FGI" },
    { name: "SOVO - Sovos Brands, Inc.", ticker: "SOVO" },
    { name: "DHAC - DIGITAL HEALTH ACQUISITION CORP.", ticker: "DHAC" },
    { name: "EDNC - Endurance Acquisition Corp.", ticker: "EDNC" },
    { name: "IOBT - IO Biotech, Inc.", ticker: "IOBT" },
    { name: "ESAC - ESGEN Acquisition Corp", ticker: "ESAC" },
    { name: "ADRT - Ault Disruptive Technologies Corp", ticker: "ADRT" },
    { name: "EXAI - Exscientia plc", ticker: "EXAI" },
    { name: "PORT - Southport Acquisition Corp", ticker: "PORT" },
    { name: "CMCA - Capitalworks Emerging Markets Acquisition Corp", ticker: "CMCA" },
    { name: "KYCH - Keyarch Acquisition Corp", ticker: "KYCH" },
    { name: "CRGY - Crescent Energy Co", ticker: "CRGY" },
    { name: "WTMA - Welsbach Technology Metals Acquisition Corp.", ticker: "WTMA" },
    { name: "CWAN - Clearwater Analytics Holdings, Inc.", ticker: "CWAN" },
    { name: "HORI - Emerging Markets Horizon Corp.", ticker: "HORI" },
    { name: "DTRT - DTRT Health Acquisition Corp.", ticker: "DTRT" },
    { name: "GGAA - Genesis Growth Tech Acquisition Corp.", ticker: "GGAA" },
    { name: "LATG - LatAmGrowth SPAC", ticker: "LATG" },
    { name: "CEG - Constellation Energy Corp", ticker: "CEG" },
    { name: "WAVS - Western Acquisition Ventures Corp.", ticker: "WAVS" },
    { name: "APXI - APx Acquisition Corp. I", ticker: "APXI" },
    { name: "IGTA - Inception Growth Acquisition Ltd", ticker: "IGTA" },
    { name: "BRAG - Bragg Gaming Group Inc.", ticker: "BRAG" },
    { name: "REFI - Chicago Atlantic Real Estate Finance, Inc.", ticker: "REFI" },
    { name: "SIGQ - Sieger Healthcare Acquisition Corp", ticker: "SIGQ" },
    { name: "GET - Getnet Adquirencia E Servicos Para Meios De Pagamento S.A.", ticker: "GET" },
    { name: "CNGL - Canna-Global Acquisition Corp", ticker: "CNGL" },
    { name: "BMAQ - Blockchain Moon Acquisition Corp.", ticker: "BMAQ" },
    { name: "GMFI - Aetherium Acquisition Corp", ticker: "GMFI" },
    { name: "TWKS - Thoughtworks Holding, Inc.", ticker: "TWKS" },
    { name: "BROS - Dutch Bros Inc.", ticker: "BROS" },
    { name: "CCSI - Consensus Cloud Solutions, Inc.", ticker: "CCSI" },
    { name: "AMPL - Amplitude, Inc.", ticker: "AMPL" },
    { name: "BRLT - Brilliant Earth Group, Inc.", ticker: "BRLT" },
    { name: "CDRO - Codere Online Luxembourg, S.A.", ticker: "CDRO" },
    { name: "HAC - Hash Space Acquisition Corp", ticker: "HAC" },
    { name: "OLIT - OmniLit Acquisition Corp.", ticker: "OLIT" },
    { name: "KETR - Keter Group SA", ticker: "KETR" },
    { name: "DERM - Journey Medical Corp", ticker: "DERM" },
    { name: "KD - Kyndryl Holdings, Inc.", ticker: "KD" },
    { name: "SGII - Seaport Global Acquisition II Corp.", ticker: "SGII" },
    { name: "ROSE - Rose Hill Acquisition Corp", ticker: "ROSE" },
    { name: "RCFA - RCF Acquisition Corp.", ticker: "RCFA" },
    { name: "MAAQ - Mana Capital Acquisition Corp.", ticker: "MAAQ" },
    { name: "MEKA - MELI Kaszek Pioneer Corp", ticker: "MEKA" },
    { name: "PBAX - PHOENIX BIOTECH ACQUISITION CORP.", ticker: "PBAX" },
    { name: "OP - OceanPal Inc.", ticker: "OP" },
    { name: "BACA - Berenson Acquisition Corp. I", ticker: "BACA" },
    { name: "VHNA - Vahanna Tech Edge Acquisition I Corp.", ticker: "VHNA" },
    { name: "LTH - Life Time Group Holdings, Inc.", ticker: "LTH" },
    { name: "OLPX - OLAPLEX HOLDINGS, INC.", ticker: "OLPX" },
    { name: "ASCA - ASPAC I Acquisition Corp.", ticker: "ASCA" },
    { name: "INFA - Informatica Inc.", ticker: "INFA" },
    { name: "ENFN - Enfusion, Inc.", ticker: "ENFN" },
    { name: "FLNC - Fluence Energy, Inc.", ticker: "FLNC" },
    { name: "CINT - CI&T Inc", ticker: "CINT" },
    { name: "CHO - Chobani Inc.", ticker: "CHO" },
    { name: "ROAR - Impact Shares Climate Risk Reinsurance Corp", ticker: "ROAR" },
    { name: "TDSPZ - Amity LPX Fund I, LP", ticker: "TDSPZ" },
    { name: "PACL - Pomelo Acquisition Corporation Limited", ticker: "PACL" },
    { name: "TSIV - Twelve Seas Investment Co IV TMT", ticker: "TSIV" },
    { name: "TYDE - Cryptyde, Inc.", ticker: "TYDE" },
    { name: "ZAAG - ZA Group, Inc.", ticker: "ZAAG" },
    { name: "ACAB - Atlantic Coastal Acquisition Corp. II", ticker: "ACAB" },
    { name: "PPYA - Papaya Growth Opportunity Corp. I", ticker: "PPYA" },
    { name: "HMAC - Hainan Manaslu Acquisition Corp.", ticker: "HMAC" },
    { name: "PXCLY - Phoenix Copper Limited/ADR", ticker: "PXCLY" },
    { name: "DEFT - Defi Technologies, Inc.", ticker: "DEFT" },
    { name: "GLLI - GLOBALINK INVESTMENT INC.", ticker: "GLLI" },
    { name: "ROCL - Roth CH Acquisition V Co.", ticker: "ROCL" },
    { name: "DEFY - Agora Digital Holdings, Inc.", ticker: "DEFY" },
    { name: "GGR - Gogoro Inc.", ticker: "GGR" },
    { name: "BCHPY - Brainchip Holdings Limited/ADR", ticker: "BCHPY" },
    { name: "MIMO - Airspan Networks Holdings Inc.", ticker: "MIMO" },
    { name: "DCGO - DocGo Inc.", ticker: "DCGO" },
    { name: "RDW - Redwire Corp", ticker: "RDW" },
    { name: "JOBY - Joby Aviation, Inc.", ticker: "JOBY" },
    { name: "CIFR - Cipher Mining Inc.", ticker: "CIFR" },
    { name: "RKLB - Rocket Lab USA, Inc.", ticker: "RKLB" },
    { name: "GWH - ESS Tech, Inc.", ticker: "GWH" },
    { name: "NRDY - Nerdy Inc.", ticker: "NRDY" },
    { name: "XOS - Xos, Inc.", ticker: "XOS" },
    { name: "EXOD - Exodus Movement, Inc.", ticker: "EXOD" },
    { name: "NVTS - Navitas Semiconductor Corp", ticker: "NVTS" },
    { name: "BKKT - Bakkt Holdings, Inc.", ticker: "BKKT" },
    { name: "RBOT - Vicarious Surgical Inc.", ticker: "RBOT" },
    { name: "WE - WeWork Inc.", ticker: "WE" },
    { name: "ML - MONEYLION INC.", ticker: "ML" },
    { name: "FCCI - FAST CASUAL CONCEPTS, INC.", ticker: "FCCI" },
    { name: "EDBL - Edible Garden AG Inc", ticker: "EDBL" },
    { name: "MIR - Mirion Technologies, Inc.", ticker: "MIR" },
    { name: "SNCE - Science 37 Holdings, Inc.", ticker: "SNCE" },
    { name: "TNGX - Tango Therapeutics, Inc.", ticker: "TNGX" },
    { name: "LIDR - AEye, Inc.", ticker: "LIDR" },
    { name: "HUMA - Humacyte, Inc.", ticker: "HUMA" },
    { name: "JAQC - Jupiter Acquisition Corp", ticker: "JAQC" },
    { name: "AUST - Austin Gold Corp.", ticker: "AUST" },
    { name: "CCCS - CCC Intelligent Solutions Holdings Inc.", ticker: "CCCS" },
    { name: "CRXT - Clarus Therapeutics Holdings, Inc.", ticker: "CRXT" },
    { name: "BAUFF - Blue Star Gold Corp", ticker: "BAUFF" },
    { name: "SPIR - Spire Global, Inc.", ticker: "SPIR" },
    { name: "SABS - SAB Biotherapeutics, Inc.", ticker: "SABS" },
    { name: "BTTX - Better Therapeutics, Inc.", ticker: "BTTX" },
    { name: "PIII - P3 Health Partners Inc.", ticker: "PIII" },
    { name: "LIAN - LianBio", ticker: "LIAN" },
    { name: "ENJY - ENJOY TECHNOLOGY, INC./DE", ticker: "ENJY" },
    { name: "BHIL - Benson Hill, Inc.", ticker: "BHIL" },
    { name: "DNA - Ginkgo Bioworks Holdings, Inc.", ticker: "DNA" },
    { name: "MMIC - Memic Innovative Surgery Ltd.", ticker: "MMIC" },
    { name: "SRAD - Sportradar Group AG", ticker: "SRAD" },
    { name: "PEAR - Pear Therapeutics, Inc.", ticker: "PEAR" },
    { name: "KPNT - Kepuni Holdings Inc.", ticker: "KPNT" },
    { name: "ROVR - ROVER GROUP, INC.", ticker: "ROVR" },
    { name: "STRC - Sarcos Technology & Robotics Corp", ticker: "STRC" },
    { name: "VIGL - Vigil Neuroscience, Inc.", ticker: "VIGL" },
    { name: "OPAD - Offerpad Solutions Inc.", ticker: "OPAD" },
    { name: "IONQ - IonQ, Inc.", ticker: "IONQ" },
    { name: "SMSA - Samsara Vision, Inc", ticker: "SMSA" },
    { name: "VLD - Velo3D, Inc.", ticker: "VLD" },
    { name: "SRZN - Surrozen, Inc./DE", ticker: "SRZN" },
    { name: "RSVR - Reservoir Media, Inc.", ticker: "RSVR" },
    { name: "BOXD - Boxed, Inc.", ticker: "BOXD" },
    { name: "AMPS - Altus Power, Inc.", ticker: "AMPS" },
    { name: "EMBK - Embark Technology, Inc.", ticker: "EMBK" },
    { name: "HIPO - Hippo Holdings Inc.", ticker: "HIPO" },
    { name: "AUR - Aurora Innovation, Inc.", ticker: "AUR" },
    { name: "DRUG - BRIGHT MINDS BIOSCIENCES INC.", ticker: "DRUG" },
    { name: "BZFD - BuzzFeed, Inc.", ticker: "BZFD" },
    { name: "VLCN - Volcon, Inc.", ticker: "VLCN" },
    { name: "FLAG - First Light Acquisition Group, Inc.", ticker: "FLAG" },
    { name: "ENER - ACCRETION ACQUISITION CORP.", ticker: "ENER" },
    { name: "GRAB - Grab Holdings Ltd", ticker: "GRAB" },
    { name: "FTE - FAST Merger Corp.", ticker: "FTE" },
    { name: "PRLH - Pearl Holdings Acquisition Corp", ticker: "PRLH" },
    { name: "CXAC - C5 Acquisition Corp", ticker: "CXAC" },
    { name: "SLVM - Sylvamo Corp", ticker: "SLVM" },
    { name: "LVAC - LAVA Medtech Acquisition Corp.", ticker: "LVAC" },
    { name: "XPDB - Power & Digital Infrastructure Acquisition II Corp.", ticker: "XPDB" },
    { name: "IZM - ICZOOM Group Inc.", ticker: "IZM" },
    { name: "NLCP - NewLake Capital Partners, Inc.", ticker: "NLCP" },
    { name: "VUSO - Virtuoso Acquisition Corp. 2", ticker: "VUSO" },
    { name: "MEGI - MainStay CBRE Global Infrastructure Megatrends Fund", ticker: "MEGI" },
    { name: "WRAC - Williams Rowland Acquisition Corp.", ticker: "WRAC" },
    { name: "OXUS - Oxus Acquisition Corp.", ticker: "OXUS" },
    { name: "WWAC - Worldwide Webb Acquisition Corp.", ticker: "WWAC" },
    { name: "PACI - PROOF Acquisition Corp I", ticker: "PACI" },
    { name: "GIAC - Gesher I Acquisition Corp.", ticker: "GIAC" },
    { name: "MPRA - Mercato Partners Acquisition Corp", ticker: "MPRA" },
    { name: "SCUA - Sculptor Acquisition Corp I", ticker: "SCUA" },
    { name: "IOAC - Innovative International Acquisition Corp.", ticker: "IOAC" },
    { name: "WINV - WinVest Acquisition Corp.", ticker: "WINV" },
    { name: "FIAC - Focus Impact Acquisition Corp.", ticker: "FIAC" },
    { name: "ARAC - Artemis Acquisition Corp./DE", ticker: "ARAC" },
    { name: "ADAL - Anthemis Digital Acquisitions I Corp", ticker: "ADAL" },
    { name: "DCRE - Decarbonization Plus Acquisition Corp V", ticker: "DCRE" },
    { name: "EFHT - EF HUTTON ACQUISITION CORP.", ticker: "EFHT" },
    { name: "BRDS - Bird Global, Inc.", ticker: "BRDS" },
    { name: "EVE - EVe Mobility Acquisition Corp", ticker: "EVE" },
    { name: "LGST - Semper Paratus Acquisition Corp", ticker: "LGST" },
    { name: "RRAC - Rigel Resource Acquisition Corp.", ticker: "RRAC" },
    { name: "NUVO - Nuvo Group Ltd.", ticker: "NUVO" },
    { name: "PIK - KIDPIK CORP.", ticker: "PIK" },
    { name: "PGSS - Pegasus Digital Mobility Acquisition Corp.", ticker: "PGSS" },
    { name: "YSWY - Yesway, Inc.", ticker: "YSWY" },
    { name: "TJH - Thomas James Homes, Inc.", ticker: "TJH" },
    { name: "USCT - TKB Critical Technologies 1", ticker: "USCT" },
    { name: "ALLR - Allarity Therapeutics, Inc.", ticker: "ALLR" },
    { name: "MTRY - Monterey Bio Acquisition Corp", ticker: "MTRY" },
    { name: "TSVT - 2seventy bio, Inc.", ticker: "TSVT" },
    { name: "HILS - Hillstream BioPharma Inc.", ticker: "HILS" },
    { name: "DH - Definitive Healthcare Corp.", ticker: "DH" },
    { name: "FOUN - Founder SPAC", ticker: "FOUN" },
    { name: "CING - Cingulate Inc.", ticker: "CING" },
    { name: "INAQ - Insight Acquisition Corp. /DE", ticker: "INAQ" },
    { name: "DCFC - Tritium DCFC Ltd", ticker: "DCFC" },
    { name: "HHLLU - Hardwoods Holdings, LLC", ticker: "HHLLU" },
    { name: "WODA - WODA Corp", ticker: "WODA" },
    { name: "VDNT - VERDANT EARTH TECHNOLOGIES LTD", ticker: "VDNT" },
    { name: "APCA - AP Acquisition Corp", ticker: "APCA" },
    { name: "TGR - Kimbell Tiger Acquisition Corp", ticker: "TGR" },
    { name: "ESMT - EngageSmart, Inc.", ticker: "ESMT" },
    { name: "TYRA - Tyra Biosciences, Inc.", ticker: "TYRA" },
    { name: "HPLT - Home Plate Acquisition Corp", ticker: "HPLT" },
    { name: "INDP - Indaptus Therapeutics, Inc.", ticker: "INDP" },
    { name: "DMAQ - Deep Medicine Acquisition Corp.", ticker: "DMAQ" },
    { name: "FNVT - Finnovate Acquisition Corp.", ticker: "FNVT" },
    { name: "FWD - FWD Group Holdings Ltd", ticker: "FWD" },
    { name: "IVCB - Investcorp Europe Acquisition Corp I", ticker: "IVCB" },
    { name: "JGGC - Jaguar Global Growth Corp I", ticker: "JGGC" },
    { name: "BPAC - Bullpen Parlay Acquisition Co", ticker: "BPAC" },
    { name: "MBSC - M3-Brigade Acquisition III Corp.", ticker: "MBSC" },
    { name: "GEEX - Games & Esports Experience Acquisition Corp.", ticker: "GEEX" },
    { name: "BOCN - Blue Ocean Acquisition Corp", ticker: "BOCN" },
    { name: "MCAA - Mountain & Co. I Acquisition Corp.", ticker: "MCAA" },
    { name: "DRFS - Dr. Foods, Inc.", ticker: "DRFS" },
    { name: "DPCS - DP Cap Acquisition Corp I", ticker: "DPCS" },
    { name: "AVDX - AvidXchange Holdings, Inc.", ticker: "AVDX" },
    { name: "DMYS - dMY Technology Group, Inc. VI", ticker: "DMYS" },
    { name: "ICNC - Iconic Sports Acquisition Corp.", ticker: "ICNC" },
    { name: "GVCI - Green Visor Financial Technology Acquisition Corp I", ticker: "GVCI" },
    { name: "STET - ST Energy Transition I Ltd.", ticker: "STET" },
    { name: "ONON - On Holding AG", ticker: "ONON" },
    { name: "MCAG - Mountain Crest Acquisition Corp. V", ticker: "MCAG" },
    { name: "HRT - HireRight Holdings Corp", ticker: "HRT" },
    { name: "MEOA - Minority Equality Opportunities Acquisition Inc.", ticker: "MEOA" },
    { name: "CITE - Cartica Acquisition Corp", ticker: "CITE" },
    { name: "PHYT - Pyrophyte Acquisition Corp.", ticker: "PHYT" },
    { name: "RNW - ReNew Energy Global plc", ticker: "RNW" },
    { name: "HAIA - Healthcare AI Acquisition Corp.", ticker: "HAIA" },
    { name: "PRBM - Parabellum Acquisition Corp.", ticker: "PRBM" },
    { name: "TOP - Zhong Yang Financial Group Ltd", ticker: "TOP" },
    { name: "SGML - Sigma Lithium Corp", ticker: "SGML" },
    { name: "THMB - Thimble Point Acquisition Corp. II", ticker: "THMB" },
    { name: "CCAI - Cascadia Acquisition Corp.", ticker: "CCAI" },
    { name: "FHLT - Future Health ESG Corp.", ticker: "FHLT" },
    { name: "VTYX - Ventyx Biosciences, Inc.", ticker: "VTYX" },
    { name: "CREC - Crescera Capital Acquisition Corp.", ticker: "CREC" },
    { name: "EGAC - Europa Growth Acquisition Co", ticker: "EGAC" },
    { name: "BHAC - Crixus BH3 Acquisition Co", ticker: "BHAC" },
    { name: "VAXX - Vaxxinity, Inc.", ticker: "VAXX" },
    { name: "CDAQ - Compass Digital Acquisition Corp.", ticker: "CDAQ" },
    { name: "HMA - Heartland Media Acquisition Corp.", ticker: "HMA" },
    { name: "IFIT - iFit Health & Fitness Inc", ticker: "IFIT" },
    { name: "MLAI - McLaren Technology Acquisition Corp.", ticker: "MLAI" },
    { name: "AEAE - AltEnergy Acquisition Corp", ticker: "AEAE" },
    { name: "IXAQ - IX Acquisition Corp.", ticker: "IXAQ" },
    { name: "GAQ - Generation Asia I Acquisition Ltd", ticker: "GAQ" },
    { name: "BYN - Banyan Acquisition Corp", ticker: "BYN" },
    { name: "BFYW - Better For You Wellness, Inc.", ticker: "BFYW" },
    { name: "XFIN - ExcelFin Acquisition Corp.", ticker: "XFIN" },
    { name: "FSHP - Flag Ship Acquisition Corp", ticker: "FSHP" },
    { name: "MYNA - Mynaric AG", ticker: "MYNA" },
    { name: "ONYX - Onyx Acquisition Co. I", ticker: "ONYX" },
    { name: "APN - Apeiron Capital Investment Corp.", ticker: "APN" },
    { name: "BWTR - Blue Water Acquisition Corp. II", ticker: "BWTR" },
    { name: "GIPL - Global Innovative Platforms Inc.", ticker: "GIPL" },
    { name: "SLGC - SomaLogic, Inc.", ticker: "SLGC" },
    { name: "PL - dMY Technology Group, Inc. IV", ticker: "PL" },
    { name: "SMRT - SmartRent, Inc.", ticker: "SMRT" },
    { name: "GNTA - Genenta Science S.p.A.", ticker: "GNTA" },
    { name: "HCTI - Healthcare Triangle, Inc.", ticker: "HCTI" },
    { name: "GATE - Marblegate Acquisition Corp.", ticker: "GATE" },
    { name: "ARTE - Artemis Strategic Investment Corp", ticker: "ARTE" },
    { name: "NFGC - New Found Gold Corp.", ticker: "NFGC" },
    { name: "INKT - MiNK Therapeutics, Inc.", ticker: "INKT" },
    { name: "XLO - Xilio Therapeutics, Inc.", ticker: "XLO" },
    { name: "HWKZ - Hawks Acquisition Corp", ticker: "HWKZ" },
    { name: "FLXE - FlexEnergy Green Solutions, Inc.", ticker: "FLXE" },
    { name: "HGTY - Hagerty, Inc.", ticker: "HGTY" },
    { name: "LOCL - Local Bounti Corporation/DE", ticker: "LOCL" },
    { name: "TSAT - Telesat Corp", ticker: "TSAT" },
    { name: "BNIX - Bannix Acquisition Corp.", ticker: "BNIX" },
    { name: "KIND - Nextdoor Holdings, Inc.", ticker: "KIND" },
    { name: "LION - Lionheart III Corp", ticker: "LION" },
    { name: "AVHI - Achari Ventures Holdings Corp. I", ticker: "AVHI" },
    { name: "SLDP - Decarbonization Plus Acquisition Corp III", ticker: "SLDP" },
    { name: "TRCC - TRACCOM INC.", ticker: "TRCC" },
    { name: "RDTX - Roman DBDR Tech Acquisition Corp. II", ticker: "RDTX" },
    { name: "PX - P10, Inc.", ticker: "PX" },
    { name: "ARBK - Argo Blockchain Plc", ticker: "ARBK" },
    { name: "SMI - SEMICONDUCTOR MANUFACTURING INTERNATIONAL CORP", ticker: "SMI" },
    { name: "EXPGF - Experian Group LTD", ticker: "EXPGF" },
    { name: "SAUHF - Straumann Holding AG / ADR", ticker: "SAUHF" },
    { name: "PTAIF - PT Astra International Tbk / ADR", ticker: "PTAIF" },
    { name: "PBCRF - PT Bank Central Asia Tbk / ADR", ticker: "PBCRF" },
    { name: "LNVGF - LENOVO GROUP LTD", ticker: "LNVGF" },
    { name: "SVYSF - SOLVAY S A /ADR/", ticker: "SVYSF" },
    { name: "ACRFF - ACCOR", ticker: "ACRFF" },
    { name: "GLPEF - Galp Energia, SGPS, S.A.", ticker: "GLPEF" },
    { name: "PEGRF - Pennon Group Plc / ADR", ticker: "PEGRF" },
    { name: "SAMOF - Sangoma Technologies Corp", ticker: "SAMOF" },
    { name: "VRNOF - Verano Holdings Corp.", ticker: "VRNOF" },
    { name: "CLVLF - Clinuvel Pharmaceuticals Ltd", ticker: "CLVLF" },
    { name: "PKKFF - Tenet Fintech Group Inc.", ticker: "PKKFF" },
    { name: "BRCHF - Brainchip Holdings Limited/ADR", ticker: "BRCHF" },
    { name: "DEFTF - Defi Technologies, Inc.", ticker: "DEFTF" },
    { name: "ARBKF - Argo Blockchain Plc", ticker: "ARBKF" },
    { name: "PXCLF - Phoenix Copper Limited/ADR", ticker: "PXCLF" },
    { name: "CLYYF - Celyad Oncology SA", ticker: "CLYYF" },
    { name: "LNDZF - Salona Global Medical Device Corp", ticker: "LNDZF" },
    { name: "PDNLB - PRESIDENTIAL REALTY CORP/DE/", ticker: "PDNLB" },
    { name: "GVSI - Good Vibrations Shoes, Inc.", ticker: "GVSI" },
    { name: "HMLA - HIMALAYA TECHNOLOGIES, INC", ticker: "HMLA" },
    { name: "IPWLG - AES CORP", ticker: "IPWLG" },
    { name: "MS-PO - MORGAN STANLEY", ticker: "MS-PO" },
    { name: "FOSLL - Fossil Group, Inc.", ticker: "FOSLL" },
    { name: "ADC-PA - AGREE REALTY CORP", ticker: "ADC-PA" },
    { name: "COF-PN - CAPITAL ONE FINANCIAL CORP", ticker: "COF-PN" },
    { name: "BERZ - BANK OF MONTREAL /CAN/", ticker: "BERZ" },
    { name: "BULZ - BANK OF MONTREAL /CAN/", ticker: "BULZ" },
    { name: "OILD - BANK OF MONTREAL /CAN/", ticker: "OILD" },
    { name: "OILU - BANK OF MONTREAL /CAN/", ticker: "OILU" },
    { name: "VNO-PO - VORNADO REALTY TRUST", ticker: "VNO-PO" },
    { name: "WFC-PD - WELLS FARGO & COMPANY/MN", ticker: "WFC-PD" },
    { name: "BAC-PQ - BANK OF AMERICA CORP /DE/", ticker: "BAC-PQ" },
    { name: "SLNHP - Soluna Holdings, Inc", ticker: "SLNHP" },
    { name: "TELZ - TELLURIAN INC. /DE/", ticker: "TELZ" },
    { name: "CNOBP - ConnectOne Bancorp, Inc.", ticker: "CNOBP" },
    { name: "SF-PD - STIFEL FINANCIAL CORP", ticker: "SF-PD" },
    { name: "COMSP - COMSovereign Holding Corp.", ticker: "COMSP" },
    { name: "CELZD - CREATIVE MEDICAL TECHNOLOGY HOLDINGS, INC.", ticker: "CELZD" },
    { name: "ABR-PE - ARBOR REALTY TRUST INC", ticker: "ABR-PE" },
    { name: "ABR-PF - ARBOR REALTY TRUST INC", ticker: "ABR-PF" },
    { name: "WAL-PA - WESTERN ALLIANCE BANCORPORATION", ticker: "WAL-PA" },
    { name: "FRCDL - FIRST REPUBLIC BANK", ticker: "FRCDL" },
    { name: "FRC-PN - FIRST REPUBLIC BANK", ticker: "FRC-PN" },
    { name: "OIBZQ - OI S.A. - In Judicial Reorganization", ticker: "OIBZQ" },
    { name: "HNNAZ - HENNESSY ADVISORS INC", ticker: "HNNAZ" },
    { name: "SI-PA - Silvergate Capital Corp", ticker: "SI-PA" },
    { name: "GTTNQ - GTT Communications, Inc.", ticker: "GTTNQ" },
    { name: "SGLDF - KIDOZ INC.", ticker: "SGLDF" },
    { name: "ROLLP - RBC Bearings INC", ticker: "ROLLP" },
    { name: "BWBBP - Bridgewater Bancshares Inc", ticker: "BWBBP" },
    { name: "CADE-PA - BancorpSouth Bank", ticker: "CADE-PA" },
    { name: "NYMTZ - NEW YORK MORTGAGE TRUST INC", ticker: "NYMTZ" },
    { name: "NYMGV - NEW YORK MORTGAGE TRUST INC", ticker: "NYMGV" },
    { name: "EFSCP - ENTERPRISE FINANCIAL SERVICES CORP", ticker: "EFSCP" },
    { name: "NJMCD - Idaho Strategic Resources, Inc.", ticker: "NJMCD" },
    { name: "GDPCW - GOODRICH PETROLEUM CORP", ticker: "GDPCW" },
    { name: "LFMDP - LifeMD, Inc.", ticker: "LFMDP" },
    { name: "DTG - DTE ENERGY CO", ticker: "DTG" },
    { name: "IRS-WT - IRSA INVESTMENTS & REPRESENTATIONS INC", ticker: "IRS-WT" },
    { name: "TDS-PV - TELEPHONE & DATA SYSTEMS INC /DE/", ticker: "TDS-PV" },
    { name: "MODDD - Modular Medical, Inc.", ticker: "MODDD" },
    { name: "MOBQW - Mobiquity Technologies, Inc.", ticker: "MOBQW" },
    { name: "WKSPW - Worksport Ltd", ticker: "WKSPW" },
    { name: "IFED - UBS AG", ticker: "IFED" },
    { name: "ESUS - UBS AG", ticker: "ESUS" },
    { name: "FEDL - UBS AG", ticker: "FEDL" },
    { name: "GMBLP - ESPORTS ENTERTAINMENT GROUP, INC.", ticker: "GMBLP" },
    { name: "NBLRF - Noble Corp", ticker: "NBLRF" },
    { name: "NBLTF - Noble Corp", ticker: "NBLTF" },
    { name: "NBLWF - Noble Corp", ticker: "NBLWF" },
    { name: "PEB-PH - Pebblebrook Hotel Trust", ticker: "PEB-PH" },
    { name: "PMT-PC - PennyMac Mortgage Investment Trust", ticker: "PMT-PC" },
    { name: "ATLCL - Atlanticus Holdings Corp", ticker: "ATLCL" },
    { name: "BBLGW - Bone Biologics Corp", ticker: "BBLGW" },
    { name: "MMTLP - META MATERIALS INC.", ticker: "MMTLP" },
    { name: "TRYMF - TREASURY METALS INC", ticker: "TRYMF" },
    { name: "SURGW - SurgePays, Inc.", ticker: "SURGW" },
    { name: "PHBRD - PhoneBrasil International Inc", ticker: "PHBRD" },
    { name: "TGH-PB - TEXTAINER GROUP HOLDINGS LTD", ticker: "TGH-PB" },
    { name: "FTLFD - FITLIFE BRANDS, INC.", ticker: "FTLFD" },
    { name: "NXDT-PA - NEXPOINT DIVERSIFIED REAL ESTATE TRUST", ticker: "NXDT-PA" },
    { name: "CNFND - CFN Enterprises Inc.", ticker: "CNFND" },
    { name: "HPP-PC - Hudson Pacific Properties, Inc.", ticker: "HPP-PC" },
    { name: "OFSSH - OFS Capital Corp", ticker: "OFSSH" },
    { name: "PFXNZ - PhenixFIN Corp", ticker: "PFXNZ" },
    { name: "BDVC - Business Development Corp of America", ticker: "BDVC" },
    { name: "INN-PF - Summit Hotel Properties, Inc.", ticker: "INN-PF" },
    { name: "QUGB - Quinton Group, Inc.", ticker: "QUGB" },
    { name: "PETVW - PetVivo Holdings, Inc.", ticker: "PETVW" },
    { name: "WHLRL - Wheeler Real Estate Investment Trust, Inc.", ticker: "WHLRL" },
    { name: "NRZ-PD - New Residential Investment Corp.", ticker: "NRZ-PD" },
    { name: "OZKAP - Bank OZK", ticker: "OZKAP" },
    { name: "FBRT-PE - Franklin BSP Realty Trust, Inc.", ticker: "FBRT-PE" },
    { name: "HTIBP - Healthcare Trust, Inc.", ticker: "HTIBP" },
    { name: "SQLLW - SeqLL, Inc.", ticker: "SQLLW" },
    { name: "VIASP - Via Renewables, Inc.", ticker: "VIASP" },
    { name: "EPCCP - Eagle Point Credit Co Inc.", ticker: "EPCCP" },
    { name: "ROIVW - Roivant Sciences Ltd.", ticker: "ROIVW" },
    { name: "CAHO - Caro Holdings Inc.", ticker: "CAHO" },
    { name: "NTRBW - NutriBand Inc.", ticker: "NTRBW" },
    { name: "DBRG-PH - DigitalBridge Group, Inc.", ticker: "DBRG-PH" },
    { name: "DBRG-PI - DigitalBridge Group, Inc.", ticker: "DBRG-PI" },
    { name: "DBRG-PJ - DigitalBridge Group, Inc.", ticker: "DBRG-PJ" },
    { name: "LTRYW - Lottery.com Inc.", ticker: "LTRYW" },
    { name: "BHFPL - Brighthouse Financial, Inc.", ticker: "BHFPL" },
    { name: "LMDXW - LumiraDx Ltd", ticker: "LMDXW" },
    { name: "BHFAM - Brighthouse Financial, Inc.", ticker: "BHFAM" },
    { name: "DATSW - DatChat, Inc.", ticker: "DATSW" },
    { name: "WBSR - Webstar Technology Group Inc.", ticker: "WBSR" },
    { name: "TRTN-PE - Triton International Ltd", ticker: "TRTN-PE" },
    { name: "NVNOW - enVVeno Medical Corp", ticker: "NVNOW" },
    { name: "SEDOD - SEEDO CORP.", ticker: "SEDOD" },
    { name: "GIPRW - GENERATION INCOME PROPERTIES, INC.", ticker: "GIPRW" },
    { name: "HTZWW - HERTZ GLOBAL HOLDINGS, INC", ticker: "HTZWW" },
    { name: "BTBDW - BT Brands, Inc.", ticker: "BTBDW" },
    { name: "DOMA-WT - Doma Holdings, Inc.", ticker: "DOMA-WT" },
    { name: "OCCIN - OFS Credit Company, Inc.", ticker: "OCCIN" },
    { name: "FATBB - Fat Brands, Inc", ticker: "FATBB" },
    { name: "GPMTP - Granite Point Mortgage Trust Inc.", ticker: "GPMTP" },
    { name: "GPMT-PA - Granite Point Mortgage Trust Inc.", ticker: "GPMT-PA" },
    { name: "CHRB - Charah Solutions, Inc.", ticker: "CHRB" },
    { name: "TMCWW - TMC the metals Co Inc.", ticker: "TMCWW" },
    { name: "KNGW - Kenongwo Group US, Inc.", ticker: "KNGW" },
    { name: "TOIIW - Oncology Institute, Inc.", ticker: "TOIIW" },
    { name: "GFAIW - Guardforce AI Co., Ltd", ticker: "GFAIW" },
    { name: "RCOR-WT - Renovacor, Inc.", ticker: "RCOR-WT" },
    { name: "AGILW - AgileThought, Inc.", ticker: "AGILW" },
    { name: "HLBZW - Helbiz, Inc.", ticker: "HLBZW" },
    { name: "JSPRW - Jasper Therapeutics, Inc.", ticker: "JSPRW" },
    { name: "HCDIZ - Harbor Custom Development, Inc.", ticker: "HCDIZ" },
    { name: "SHPW-WT - Shapeways Holdings, Inc.", ticker: "SHPW-WT" },
    { name: "IRNT-WT - IronNet, Inc.", ticker: "IRNT-WT" },
    { name: "BEATW - HeartBeam, Inc.", ticker: "BEATW" },
    { name: "MNTSW - Momentus Inc.", ticker: "MNTSW" },
    { name: "BKSY-WT - BlackSky Technology Inc.", ticker: "BKSY-WT" },
    { name: "SAMOD - Sangoma Technologies Corp", ticker: "SAMOD" },
    { name: "EICA - Eagle Point Income Co Inc.", ticker: "EICA" },
    { name: "TCNWF - Trulieve Cannabis Corp.", ticker: "TCNWF" },
    { name: "SABSW - SAB Biotherapeutics, Inc.", ticker: "SABSW" },
    { name: "PIIIW - P3 Health Partners Inc.", ticker: "PIIIW" },
    { name: "NBSTW - Newbury Street Acquisition Corp", ticker: "NBSTW" },
    { name: "DNA-WT - Ginkgo Bioworks Holdings, Inc.", ticker: "DNA-WT" },
    { name: "BHIL-WT - Benson Hill, Inc.", ticker: "BHIL-WT" },
    { name: "ENJYW - ENJOY TECHNOLOGY, INC./DE", ticker: "ENJYW" },
    { name: "TWNT-WT - Tailwind Two Acquisition Corp.", ticker: "TWNT-WT" },
    { name: "CTV-WT - Innovid Corp.", ticker: "CTV-WT" },
    { name: "PEARW - Pear Therapeutics, Inc.", ticker: "PEARW" },
    { name: "AURCW - Aurora Acquisition Corp.", ticker: "AURCW" },
    { name: "SBEAW - SILVERBOX ENGAGED MERGER CORP I", ticker: "SBEAW" },
    { name: "AVACU - Avalon Acquisition Inc.", ticker: "AVACU" },
    { name: "AVACW - Avalon Acquisition Inc.", ticker: "AVACW" },
    { name: "WPCB-WT - Warburg Pincus Capital Corp I-B", ticker: "WPCB-WT" },
    { name: "ACAHW - Atlantic Coastal Acquisition Corp.", ticker: "ACAHW" },
    { name: "BZFDW - BuzzFeed, Inc.", ticker: "BZFDW" },
    { name: "SZZLU - Sizzle Acquisition Corp.", ticker: "SZZLU" },
    { name: "LICY-WT - Li-Cycle Holdings Corp.", ticker: "LICY-WT" },
    { name: "AMPS-WT - Altus Power, Inc.", ticker: "AMPS-WT" },
    { name: "BOXD-WT - Boxed, Inc.", ticker: "BOXD-WT" },
    { name: "EFTRW - eFFECTOR Therapeutics, Inc.", ticker: "EFTRW" },
    { name: "AUROW - Aurora Innovation, Inc.", ticker: "AUROW" },
    { name: "HIPO-WT - Hippo Holdings Inc.", ticker: "HIPO-WT" },
    { name: "RSVRW - Reservoir Media, Inc.", ticker: "RSVRW" },
    { name: "ACHR-WT - Archer Aviation Inc.", ticker: "ACHR-WT" },
    { name: "SRZNW - Surrozen, Inc./DE", ticker: "SRZNW" },
    { name: "VLD-WT - Velo3D, Inc.", ticker: "VLD-WT" },
    { name: "IONQ-WT - IonQ, Inc.", ticker: "IONQ-WT" },
    { name: "OPAD-WT - Offerpad Solutions Inc.", ticker: "OPAD-WT" },
    { name: "GXIIW - GX Acquisition Corp. II", ticker: "GXIIW" },
    { name: "STRCW - Sarcos Technology & Robotics Corp", ticker: "STRCW" },
    { name: "WE-WT - WeWork Inc.", ticker: "WE-WT" },
    { name: "RBOT-WT - Vicarious Surgical Inc.", ticker: "RBOT-WT" },
    { name: "MIR-WT - Mirion Technologies, Inc.", ticker: "MIR-WT" },
    { name: "ALIT-WT - Alight, Inc. / Delaware", ticker: "ALIT-WT" },
    { name: "ML-WT - MONEYLION INC.", ticker: "ML-WT" },
    { name: "HUMAW - Humacyte, Inc.", ticker: "HUMAW" },
    { name: "LIDRW - AEye, Inc.", ticker: "LIDRW" },
    { name: "CRXTW - Clarus Therapeutics Holdings, Inc.", ticker: "CRXTW" },
    { name: "CCCS-WT - CCC Intelligent Solutions Holdings Inc.", ticker: "CCCS-WT" },
    { name: "SPIR-WT - Spire Global, Inc.", ticker: "SPIR-WT" },
    { name: "MIMO-WT - Airspan Networks Holdings Inc.", ticker: "MIMO-WT" },
    { name: "LFG-WT - Archaea Energy Inc.", ticker: "LFG-WT" },
    { name: "HHGCR - HHG Capital Corp", ticker: "HHGCR" },
    { name: "HHGCU - HHG Capital Corp", ticker: "HHGCU" },
    { name: "HHGCW - HHG Capital Corp", ticker: "HHGCW" },
    { name: "DCGOW - DocGo Inc.", ticker: "DCGOW" },
    { name: "SEAH-WT - Sports Entertainment Acquisition Corp.", ticker: "SEAH-WT" },
    { name: "BKKT-WT - Bakkt Holdings, Inc.", ticker: "BKKT-WT" },
    { name: "VLTA-WT - Volta Inc.", ticker: "VLTA-WT" },
    { name: "HYACW - Haymaker Acquisition Corp. III", ticker: "HYACW" },
    { name: "TWLVW - Twelve Seas Investment Co. II", ticker: "TWLVW" },
    { name: "XOSWW - Xos, Inc.", ticker: "XOSWW" },
    { name: "NRDY-WT - Nerdy Inc.", ticker: "NRDY-WT" },
    { name: "GWH-WT - ESS Tech, Inc.", ticker: "GWH-WT" },
    { name: "CIFRW - Cipher Mining Inc.", ticker: "CIFRW" },
    { name: "JOBY-WT - Joby Aviation, Inc.", ticker: "JOBY-WT" },
    { name: "RDW-WT - Redwire Corp", ticker: "RDW-WT" },
    { name: "HGTY-WT - Hagerty, Inc.", ticker: "HGTY-WT" },
    { name: "FRXB-WT - Forest Road Acquisition Corp. II", ticker: "FRXB-WT" },
    { name: "FTEV-WT - FinTech Evolution Acquisition Group", ticker: "FTEV-WT" },
    { name: "ARTEU - Artemis Strategic Investment Corp", ticker: "ARTEU" },
    { name: "DTOCW - Digital Transformation Opportunities Corp.", ticker: "DTOCW" },
    { name: "IPVIW - InterPrivate IV InfraTech Partners Inc.", ticker: "IPVIW" },
    { name: "SLHGP - Skylight Health Group Inc.", ticker: "SLHGP" },
    { name: "VPCBW - VPC Impact Acquisition Holdings II", ticker: "VPCBW" },
    { name: "ATSPW - Archimedes Tech Spac Partners Co", ticker: "ATSPW" },
    { name: "LOCL-WT - Local Bounti Corporation/DE", ticker: "LOCL-WT" },
    { name: "TETCW - Tech & Energy Transition Corp", ticker: "TETCW" },
    { name: "CPAAW - Conyers Park III Acquisition Corp.", ticker: "CPAAW" },
    { name: "GAMCW - Golden Arrow Merger Corp.", ticker: "GAMCW" },
    { name: "CENQU - CENAQ Energy Corp.", ticker: "CENQU" },
    { name: "CENQW - CENAQ Energy Corp.", ticker: "CENQW" },
    { name: "VPCC-WT - VPC Impact Acquisition Holdings III, Inc.", ticker: "VPCC-WT" },
    { name: "TRAQ-UN - Trine II Acquisition Corp.", ticker: "TRAQ-UN" },
    { name: "HWKZ-UN - Hawks Acquisition Corp", ticker: "HWKZ-UN" },
    { name: "HWKZ-WT - Hawks Acquisition Corp", ticker: "HWKZ-WT" },
    { name: "GPCOR - Golden Path Acquisition Corp", ticker: "GPCOR" },
    { name: "GPCOW - Golden Path Acquisition Corp", ticker: "GPCOW" },
    { name: "KTTAW - Pasithea Therapeutics Corp.", ticker: "KTTAW" },
    { name: "CIIGU - CIIG Capital Partners II, Inc.", ticker: "CIIGU" },
    { name: "CIIGW - CIIG Capital Partners II, Inc.", ticker: "CIIGW" },
    { name: "LVRAW - Levere Holdings Corp.", ticker: "LVRAW" },
    { name: "ACQRW - Independence Holdings Corp.", ticker: "ACQRW" },
    { name: "HUGS-UN - USHG Acquisition Corp.", ticker: "HUGS-UN" },
    { name: "HUGS-WT - USHG Acquisition Corp.", ticker: "HUGS-WT" },
    { name: "BBAI-WT - BigBear.ai Holdings, Inc.", ticker: "BBAI-WT" },
    { name: "PL-WT - dMY Technology Group, Inc. IV", ticker: "PL-WT" },
    { name: "SLGCW - SomaLogic, Inc.", ticker: "SLGCW" },
    { name: "NPABU - New Providence Acquisition Corp. II", ticker: "NPABU" },
    { name: "SWSSU - Springwater Special Situations Corp.", ticker: "SWSSU" },
    { name: "SWSSW - Springwater Special Situations Corp.", ticker: "SWSSW" },
    { name: "BOAS-UN - BOA Acquisition Corp.", ticker: "BOAS-UN" },
    { name: "BOAS-WT - BOA Acquisition Corp.", ticker: "BOAS-WT" },
    { name: "GATEU - Marblegate Acquisition Corp.", ticker: "GATEU" },
    { name: "GATEW - Marblegate Acquisition Corp.", ticker: "GATEW" },
    { name: "GLBLW - Cartesian Growth Corp", ticker: "GLBLW" },
    { name: "PTOCW - Pine Technology Acquisition Corp.", ticker: "PTOCW" },
    { name: "TMW - Pine Technology Acquisition Corp.", ticker: "TMW" },
    { name: "SMIHW - Summit Healthcare Acquisition Corp.", ticker: "SMIHW" },
    { name: "JUN-UN - Juniper II Corp.", ticker: "JUN-UN" },
    { name: "DISAW - Disruptive Acquisition Corp I", ticker: "DISAW" },
    { name: "FLYA-UN - SOAR Technology Acquisition Corp.", ticker: "FLYA-UN" },
    { name: "FLYA-WT - SOAR Technology Acquisition Corp.", ticker: "FLYA-WT" },
    { name: "AACIU - Armada Acquisition Corp. I", ticker: "AACIU" },
    { name: "AACIW - Armada Acquisition Corp. I", ticker: "AACIW" },
    { name: "SLDPW - Decarbonization Plus Acquisition Corp III", ticker: "SLDPW" },
    { name: "ARTAW - Artisan Acquisition Corp.", ticker: "ARTAW" },
    { name: "DCRCW - Decarbonization Plus Acquisition Corp III", ticker: "DCRCW" },
    { name: "AVHIU - Achari Ventures Holdings Corp. I", ticker: "AVHIU" },
    { name: "AVHIW - Achari Ventures Holdings Corp. I", ticker: "AVHIW" },
    { name: "GIA-UN - GigCapital5, Inc.", ticker: "GIA-UN" },
    { name: "GIA-WT - GigCapital5, Inc.", ticker: "GIA-WT" },
    { name: "IPAXU - Inflection Point Acquisition Corp.", ticker: "IPAXU" },
    { name: "IPAXW - Inflection Point Acquisition Corp.", ticker: "IPAXW" },
    { name: "UPTDW - TradeUP Acquisition Corp.", ticker: "UPTDW" },
    { name: "ZINGU - FTAC ZEUS ACQUISITION CORP.", ticker: "ZINGU" },
    { name: "BRIVW - B. Riley Principal 250 Merger Corp.", ticker: "BRIVW" },
    { name: "PCCTU - Perception Capital Corp. II", ticker: "PCCTU" },
    { name: "TBSAW - TB SA Acquisition Corp", ticker: "TBSAW" },
    { name: "THCPW - Thunder Bridge Capital Partners IV, Inc.", ticker: "THCPW" },
    { name: "AMBP-WT - Ardagh Metal Packaging S.A.", ticker: "AMBP-WT" },
    { name: "APACW - StoneBridge Acquisition Corp.", ticker: "APACW" },
    { name: "GREEL - Greenidge Generation Holdings Inc.", ticker: "GREEL" },
    { name: "RONI-WT - Rice Acquisition Corp. II", ticker: "RONI-WT" },
    { name: "TWCBW - Bilander Acquisition Corp.", ticker: "TWCBW" },
    { name: "APTMU - Alpha Partners Technology Merger Corp.", ticker: "APTMU" },
    { name: "APTMW - Alpha Partners Technology Merger Corp.", ticker: "APTMW" },
    { name: "IMAQU - International Media Acquisition Corp.", ticker: "IMAQU" },
    { name: "IMAQW - International Media Acquisition Corp.", ticker: "IMAQW" },
    { name: "TIOAW - Tio Tech A", ticker: "TIOAW" },
    { name: "IMAQR - International Media Acquisition Corp.", ticker: "IMAQR" },
    { name: "AHPAW - Avista Public Acquisition Corp. II", ticker: "AHPAW" },
    { name: "LIONU - Lionheart III Corp", ticker: "LIONU" },
    { name: "LIONW - Lionheart III Corp", ticker: "LIONW" },
    { name: "BNIXW - Bannix Acquisition Corp.", ticker: "BNIXW" },
    { name: "ARBKL - Argo Blockchain Plc", ticker: "ARBKL" },
    { name: "SWAGW - Software Acquisition Group Inc. III", ticker: "SWAGW" },
    { name: "RICOW - Agrico Acquisition Corp.", ticker: "RICOW" },
    { name: "MPACW - Model Performance Acquisition Corp", ticker: "MPACW" },
    { name: "CORS-WT - Corsair Partnering Corp", ticker: "CORS-WT" },
    { name: "SLVRW - SILVERspac Inc.", ticker: "SLVRW" },
    { name: "JUGGW - Jaws Juggernaut Acquisition Corp", ticker: "JUGGW" },
    { name: "OTMOW - Otonomo Technologies Ltd.", ticker: "OTMOW" },
    { name: "BLNGW - Belong Acquisition Corp.", ticker: "BLNGW" },
    { name: "BLEUU - bleuacacia ltd", ticker: "BLEUU" },
    { name: "NGCAW - NextGen Acquisition Corp. II", ticker: "NGCAW" },
    { name: "EOCW-WT - Elliott Opportunity II Corp.", ticker: "EOCW-WT" },
    { name: "CMLTW - CM Life Sciences III Inc.", ticker: "CMLTW" },
    { name: "FRSGW - First Reserve Sustainable Growth Corp.", ticker: "FRSGW" },
    { name: "HCVIW - Hennessy Capital Investment Corp. VI", ticker: "HCVIW" },
    { name: "ALPAW - ALPHA HEALTHCARE ACQUISITION CORP III", ticker: "ALPAW" },
    { name: "FMIVW - Forum Merger IV Corp", ticker: "FMIVW" },
    { name: "HERAW - FTAC Hera Acquisition Corp.", ticker: "HERAW" },
    { name: "GLEEU - Gladstone Acquisition Corp", ticker: "GLEEU" },
    { name: "NGC-WT - Northern Genesis Acquisition Corp. III", ticker: "NGC-WT" },
    { name: "GLEEW - Gladstone Acquisition Corp", ticker: "GLEEW" },
    { name: "SAMAU - Schultze Special Purpose Acquisition Corp. II", ticker: "SAMAU" },
    { name: "SAMAW - Schultze Special Purpose Acquisition Corp. II", ticker: "SAMAW" },
    { name: "OPA-WT - Magnum Opus Acquisition Ltd", ticker: "OPA-WT" },
    { name: "LITTW - Logistics Innovation Technologies Corp.", ticker: "LITTW" },
    { name: "LOCC-UN - Live Oak Crestview Climate Acquisition Corp.", ticker: "LOCC-UN" },
    { name: "DCRDU - Decarbonization Plus Acquisition Corp IV", ticker: "DCRDU" },
    { name: "DCRDW - Decarbonization Plus Acquisition Corp IV", ticker: "DCRDW" },
    { name: "VCXAU - 10X Capital Venture Acquisition Corp. II", ticker: "VCXAU" },
    { name: "VCXAW - 10X Capital Venture Acquisition Corp. II", ticker: "VCXAW" },
    { name: "HAIAU - Healthcare AI Acquisition Corp.", ticker: "HAIAU" },
    { name: "GTACU - Global Technology Acquisition Corp. I", ticker: "GTACU" },
    { name: "GIWWW - GigInternational1, Inc.", ticker: "GIWWW" },
    { name: "PHYT-UN - Pyrophyte Acquisition Corp.", ticker: "PHYT-UN" },
    { name: "RNWWW - ReNew Energy Global plc", ticker: "RNWWW" },
    { name: "GDEVW - Nexters Inc.", ticker: "GDEVW" },
    { name: "LOCC-WT - Live Oak Crestview Climate Acquisition Corp.", ticker: "LOCC-WT" },
    { name: "PRBM-UN - Parabellum Acquisition Corp.", ticker: "PRBM-UN" },
    { name: "PRBM-WT - Parabellum Acquisition Corp.", ticker: "PRBM-WT" },
    { name: "BMAC-UN - Black Mountain Acquisition Corp.", ticker: "BMAC-UN" },
    { name: "BMAC-WT - Black Mountain Acquisition Corp.", ticker: "BMAC-WT" },
    { name: "CNTQU - Chardan NexTech Acquisition 2 Corp.", ticker: "CNTQU" },
    { name: "CNTQW - Chardan NexTech Acquisition 2 Corp.", ticker: "CNTQW" },
    { name: "ACRO-WT - Acropolis Infrastructure Acquisition Corp.", ticker: "ACRO-WT" },
    { name: "MITAW - Coliseum Acquisition Corp.", ticker: "MITAW" },
    { name: "LCW-WT - Learn CW Investment Corp", ticker: "LCW-WT" },
    { name: "CCAIU - Cascadia Acquisition Corp.", ticker: "CCAIU" },
    { name: "CCAIW - Cascadia Acquisition Corp.", ticker: "CCAIW" },
    { name: "TCOA-UN - Trajectory Alpha Acquisition Corp.", ticker: "TCOA-UN" },
    { name: "SEDA-UN - SDCL EDGE Acquisition Corp", ticker: "SEDA-UN" },
    { name: "TRTL-WT - TortoiseEcofin Acquisition Corp. III", ticker: "TRTL-WT" },
    { name: "TUGCW - TradeUP Global Corp", ticker: "TUGCW" },
    { name: "MSDAW - MSD ACQUISITION CORP. / NEW", ticker: "MSDAW" },
    { name: "TRONW - CORNER GROWTH ACQUISITION CORP. 2", ticker: "TRONW" },
    { name: "ORIAW - Orion Biotech Opportunities Corp.", ticker: "ORIAW" },
    { name: "PEGRU - Project Energy Reimagined Acquisition Corp.", ticker: "PEGRU" },
    { name: "SKYAW - SKYDECK ACQUISITION CORP.", ticker: "SKYAW" },
    { name: "TPBAU - TPB Acquisition Corp I", ticker: "TPBAU" },
    { name: "TPBAW - TPB Acquisition Corp I", ticker: "TPBAW" },
    { name: "GGPIW - Gores Guggenheim, Inc.", ticker: "GGPIW" },
    { name: "BRD-UN - Beard Energy Transition Acquisition Corp.", ticker: "BRD-UN" },
    { name: "TGAAU - Target Global Acquisition I Corp.", ticker: "TGAAU" },
    { name: "DWACU - Digital World Acquisition Corp.", ticker: "DWACU" },
    { name: "DWACW - Digital World Acquisition Corp.", ticker: "DWACW" },
    { name: "NCACU - Newcourt Acquisition Corp", ticker: "NCACU" },
    { name: "NCACW - Newcourt Acquisition Corp", ticker: "NCACW" },
    { name: "ZTAQW - Zimmer Energy Transition Acquisition Corp.", ticker: "ZTAQW" },
    { name: "GSQB-WT - G Squared Ascend II, Inc.", ticker: "GSQB-WT" },
    { name: "APN-UN - Apeiron Capital Investment Corp.", ticker: "APN-UN" },
    { name: "CLOER - Clover Leaf Capital Corp.", ticker: "CLOER" },
    { name: "HTAQ-UN - Hunt Companies Acquisition Corp. I", ticker: "HTAQ-UN" },
    { name: "MEACU - Mercury Ecommerce Acquisition Corp", ticker: "MEACU" },
    { name: "MEACW - Mercury Ecommerce Acquisition Corp", ticker: "MEACW" },
    { name: "CLAQW - cleantech Acquisition Corp.", ticker: "CLAQW" },
    { name: "ONYXU - Onyx Acquisition Co. I", ticker: "ONYXU" },
    { name: "ONYXW - Onyx Acquisition Co. I", ticker: "ONYXW" },
    { name: "INTEU - Integral Acquisition Corp 1", ticker: "INTEU" },
    { name: "IQMDU - Intelligent Medicine Acquisition Corp.", ticker: "IQMDU" },
    { name: "GLTA-WT - Galata Acquisition Corp.", ticker: "GLTA-WT" },
    { name: "TRIS-UN - Tristar Acquisition I Corp.", ticker: "TRIS-UN" },
    { name: "TRIS-WT - Tristar Acquisition I Corp.", ticker: "TRIS-WT" },
    { name: "XFINU - ExcelFin Acquisition Corp.", ticker: "XFINU" },
    { name: "RJAC-UN - Jackson Acquisition Co", ticker: "RJAC-UN" },
    { name: "FEXDU - Fintech Ecosystem Development Corp.", ticker: "FEXDU" },
    { name: "BNNRU - Banner Acquisition Corp.", ticker: "BNNRU" },
    { name: "RKLY-WT - Rockley Photonics Holdings Ltd", ticker: "RKLY-WT" },
    { name: "IXAQU - IX Acquisition Corp.", ticker: "IXAQU" },
    { name: "IXAQW - IX Acquisition Corp.", ticker: "IXAQW" },
    { name: "CNDB-UN - Concord Acquisition Corp III", ticker: "CNDB-UN" },
    { name: "AEAEU - AltEnergy Acquisition Corp", ticker: "AEAEU" },
    { name: "AEAEW - AltEnergy Acquisition Corp", ticker: "AEAEW" },
    { name: "CNDA-WT - Concord Acquisition Corp II", ticker: "CNDA-WT" },
    { name: "MLAIU - McLaren Technology Acquisition Corp.", ticker: "MLAIU" },
    { name: "NFYS-UN - Enphys Acquisition Corp.", ticker: "NFYS-UN" },
    { name: "NFYS-WT - Enphys Acquisition Corp.", ticker: "NFYS-WT" },
    { name: "WQGA-UN - World Quantum Growth Acquisition Corp.", ticker: "WQGA-UN" },
    { name: "SVNAU - 7 Acquisition Corp", ticker: "SVNAU" },
    { name: "WQGA-WT - World Quantum Growth Acquisition Corp.", ticker: "WQGA-WT" },
    { name: "CDAQU - Compass Digital Acquisition Corp.", ticker: "CDAQU" },
    { name: "CDAQW - Compass Digital Acquisition Corp.", ticker: "CDAQW" },
    { name: "BHACU - Crixus BH3 Acquisition Co", ticker: "BHACU" },
    { name: "BHACW - Crixus BH3 Acquisition Co", ticker: "BHACW" },
    { name: "CRECU - Crescera Capital Acquisition Corp.", ticker: "CRECU" },
    { name: "FHLTU - Future Health ESG Corp.", ticker: "FHLTU" },
    { name: "FHLTW - Future Health ESG Corp.", ticker: "FHLTW" },
    { name: "CZOO-WT - Cazoo Group Ltd", ticker: "CZOO-WT" },
    { name: "BFRIW - Biofrontera Inc.", ticker: "BFRIW" },
    { name: "MEOAW - Minority Equality Opportunities Acquisition Inc.", ticker: "MEOAW" },
    { name: "MCAGR - Mountain Crest Acquisition Corp. V", ticker: "MCAGR" },
    { name: "MCAGU - Mountain Crest Acquisition Corp. V", ticker: "MCAGU" },
    { name: "STET-UN - ST Energy Transition I Ltd.", ticker: "STET-UN" },
    { name: "GVCIU - Green Visor Financial Technology Acquisition Corp I", ticker: "GVCIU" },
    { name: "ICNC-UN - Iconic Sports Acquisition Corp.", ticker: "ICNC-UN" },
    { name: "DMYS-UN - dMY Technology Group, Inc. VI", ticker: "DMYS-UN" },
    { name: "DMYS-WT - dMY Technology Group, Inc. VI", ticker: "DMYS-WT" },
    { name: "DPCSU - DP Cap Acquisition Corp I", ticker: "DPCSU" },
    { name: "NOVVU - Nova Vision Acquisition Corp", ticker: "NOVVU" },
    { name: "NOVVW - Nova Vision Acquisition Corp", ticker: "NOVVW" },
    { name: "MCAAU - Mountain & Co. I Acquisition Corp.", ticker: "MCAAU" },
    { name: "BOCNU - Blue Ocean Acquisition Corp", ticker: "BOCNU" },
    { name: "MBSC-UN - M3-Brigade Acquisition III Corp.", ticker: "MBSC-UN" },
    { name: "BIOSU - BioPlus Acquisition Corp.", ticker: "BIOSU" },
    { name: "BPACU - Bullpen Parlay Acquisition Co", ticker: "BPACU" },
    { name: "APMIW - AxonPrime Infrastructure Acquisition Corp", ticker: "APMIW" },
    { name: "FNVTU - Finnovate Acquisition Corp.", ticker: "FNVTU" },
    { name: "FNVTW - Finnovate Acquisition Corp.", ticker: "FNVTW" },
    { name: "DMAQR - Deep Medicine Acquisition Corp.", ticker: "DMAQR" },
    { name: "SCMAU - Seaport Calibre Materials Acquisition Corp.", ticker: "SCMAU" },
    { name: "PPHPU - PHP Ventures Acquisition Corp.", ticker: "PPHPU" },
    { name: "PPHPW - PHP Ventures Acquisition Corp.", ticker: "PPHPW" },
    { name: "HPLTU - Home Plate Acquisition Corp", ticker: "HPLTU" },
    { name: "HPLTW - Home Plate Acquisition Corp", ticker: "HPLTW" },
    { name: "VLN-WT - Valens Semiconductor Ltd.", ticker: "VLN-WT" },
    { name: "IFIN-UN - InFinT Acquisition Corp", ticker: "IFIN-UN" },
    { name: "INAQ-WT - Insight Acquisition Corp. /DE", ticker: "INAQ-WT" },
    { name: "NFNT-UN - Infinite Acquisition Corp.", ticker: "NFNT-UN" },
    { name: "CINGW - Cingulate Inc.", ticker: "CINGW" },
    { name: "FOUNW - Founder SPAC", ticker: "FOUNW" },
    { name: "ARBEW - Arbe Robotics Ltd.", ticker: "ARBEW" },
    { name: "ASTLW - Algoma Steel Group Inc.", ticker: "ASTLW" },
    { name: "USCTU - TKB Critical Technologies 1", ticker: "USCTU" },
    { name: "TOACU - Talon 1 Acquisition Corp", ticker: "TOACU" },
    { name: "VLNCD - Valens Company, Inc.", ticker: "VLNCD" },
    { name: "ARQQW - Arqit Quantum Inc.", ticker: "ARQQW" },
    { name: "OXACW - Oxbridge Acquisition Corp.", ticker: "OXACW" },
    { name: "PGSS-UN - Pegasus Digital Mobility Acquisition Corp.", ticker: "PGSS-UN" },
    { name: "RRAC-UN - Rigel Resource Acquisition Corp.", ticker: "RRAC-UN" },
    { name: "LGSTU - Semper Paratus Acquisition Corp", ticker: "LGSTU" },
    { name: "BRDS-WT - Bird Global, Inc.", ticker: "BRDS-WT" },
    { name: "DRMAW - Dermata Therapeutics, Inc.", ticker: "DRMAW" },
    { name: "MCAFR - Mountain Crest Acquisition Corp. IV", ticker: "MCAFR" },
    { name: "ADALU - Anthemis Digital Acquisitions I Corp", ticker: "ADALU" },
    { name: "FIACU - Focus Impact Acquisition Corp.", ticker: "FIACU" },
    { name: "RNERU - Mount Rainier Acquisition Corp.", ticker: "RNERU" },
    { name: "WINVU - WinVest Acquisition Corp.", ticker: "WINVU" },
    { name: "WINVW - WinVest Acquisition Corp.", ticker: "WINVW" },
    { name: "NETC-UN - Nabors Energy Transition Corp.", ticker: "NETC-UN" },
    { name: "IOACU - Innovative International Acquisition Corp.", ticker: "IOACU" },
    { name: "SCUA-UN - Sculptor Acquisition Corp I", ticker: "SCUA-UN" },
    { name: "REVEU - Alpine Acquisition Corp.", ticker: "REVEU" },
    { name: "REVEW - Alpine Acquisition Corp.", ticker: "REVEW" },
    { name: "PFTAW - PORTAGE FINTECH ACQUISITION CORP.", ticker: "PFTAW" },
    { name: "MPRAU - Mercato Partners Acquisition Corp", ticker: "MPRAU" },
    { name: "BSGAR - Blue Safari Group Acquisition Corp", ticker: "BSGAR" },
    { name: "GIACU - Gesher I Acquisition Corp.", ticker: "GIACU" },
    { name: "GIACW - Gesher I Acquisition Corp.", ticker: "GIACW" },
    { name: "XPAXU - XPAC Acquisition Corp.", ticker: "XPAXU" },
    { name: "XPAXW - XPAC Acquisition Corp.", ticker: "XPAXW" },
    { name: "PACI-UN - PROOF Acquisition Corp I", ticker: "PACI-UN" },
    { name: "WWACU - Worldwide Webb Acquisition Corp.", ticker: "WWACU" },
    { name: "MTAL-UN - Metals Acquisition Corp", ticker: "MTAL-UN" },
    { name: "MTAL-WT - Metals Acquisition Corp", ticker: "MTAL-WT" },
    { name: "OXUSU - Oxus Acquisition Corp.", ticker: "OXUSU" },
    { name: "DRAYW - Macondray Capital Acquisition Corp. I", ticker: "DRAYW" },
    { name: "OXUSW - Oxus Acquisition Corp.", ticker: "OXUSW" },
    { name: "NHICU - NewHold Investment Corp. II", ticker: "NHICU" },
    { name: "NLITW - Northern Lights Acquisition Corp.", ticker: "NLITW" },
    { name: "BWCAU - Blue Whale Acquisition Corp I", ticker: "BWCAU" },
    { name: "ASPAW - Abri SPAC I, Inc.", ticker: "ASPAW" },
    { name: "CLBTW - Cellebrite DI Ltd.", ticker: "CLBTW" },
    { name: "IRRX-UN - INTEGRATED RAIL & RESOURCES ACQUISITION CORP", ticker: "IRRX-UN" },
    { name: "XPDBU - Power & Digital Infrastructure Acquisition II Corp.", ticker: "XPDBU" },
    { name: "CLAYW - Chavant Capital Acquisition Corp.", ticker: "CLAYW" },
    { name: "KORE-WT - KORE Group Holdings, Inc.", ticker: "KORE-WT" },
    { name: "ROCGW - Roth CH Acquisition IV Co.", ticker: "ROCGW" },
    { name: "LILMW - Lilium N.V.", ticker: "LILMW" },
    { name: "ARCKU - Arbor Rapha Capital Bioholdings Corp. I", ticker: "ARCKU" },
    { name: "PCXCU - Parsec Capital Acquisitions Corp.", ticker: "PCXCU" },
    { name: "FICVW - Frontier Investment Corp", ticker: "FICVW" },
    { name: "GRABW - Grab Holdings Ltd", ticker: "GRABW" },
    { name: "ENERR - ACCRETION ACQUISITION CORP.", ticker: "ENERR" },
    { name: "ENERW - ACCRETION ACQUISITION CORP.", ticker: "ENERW" },
    { name: "PONOU - Pono Capital Corp", ticker: "PONOU" },
    { name: "PONOW - Pono Capital Corp", ticker: "PONOW" },
    { name: "JATT-WT - JATT Acquisition Corp", ticker: "JATT-WT" },
    { name: "GGRW - Gogoro Inc.", ticker: "GGRW" },
    { name: "GLLIU - GLOBALINK INVESTMENT INC.", ticker: "GLLIU" },
    { name: "VHNAU - Vahanna Tech Edge Acquisition I Corp.", ticker: "VHNAU" },
    { name: "BACA-UN - Berenson Acquisition Corp. I", ticker: "BACA-UN" },
    { name: "BACA-WT - Berenson Acquisition Corp. I", ticker: "BACA-WT" },
    { name: "SGIIW - Seaport Global Acquisition II Corp.", ticker: "SGIIW" },
    { name: "ACAQ-UN - Athena Consumer Acquisition Corp.", ticker: "ACAQ-UN" },
    { name: "ACAQ-WT - Athena Consumer Acquisition Corp.", ticker: "ACAQ-WT" },
    { name: "PBAXU - PHOENIX BIOTECH ACQUISITION CORP.", ticker: "PBAXU" },
    { name: "PBAXW - PHOENIX BIOTECH ACQUISITION CORP.", ticker: "PBAXW" },
    { name: "RCFA-UN - RCF Acquisition Corp.", ticker: "RCFA-UN" },
    { name: "ROSEU - Rose Hill Acquisition Corp", ticker: "ROSEU" },
    { name: "ROSEW - Rose Hill Acquisition Corp", ticker: "ROSEW" },
    { name: "AEHAU - Aesther Healthcare Acquisition Corp.", ticker: "AEHAU" },
    { name: "AEHAW - Aesther Healthcare Acquisition Corp.", ticker: "AEHAW" },
    { name: "OLITU - OmniLit Acquisition Corp.", ticker: "OLITU" },
    { name: "WBX-WT - Wallbox N.V.", ticker: "WBX-WT" },
    { name: "CDROW - Codere Online Luxembourg, S.A.", ticker: "CDROW" },
    { name: "BMAQR - Blockchain Moon Acquisition Corp.", ticker: "BMAQR" },
    { name: "BMAQU - Blockchain Moon Acquisition Corp.", ticker: "BMAQU" },
    { name: "BMAQW - Blockchain Moon Acquisition Corp.", ticker: "BMAQW" },
    { name: "CNGLU - Canna-Global Acquisition Corp", ticker: "CNGLU" },
    { name: "IGTAU - Inception Growth Acquisition Ltd", ticker: "IGTAU" },
    { name: "APXIU - APx Acquisition Corp. I", ticker: "APXIU" },
    { name: "GGAAU - Genesis Growth Tech Acquisition Corp.", ticker: "GGAAU" },
    { name: "NNAVW - NEXTNAV INC.", ticker: "NNAVW" },
    { name: "DTRTW - DTRT Health Acquisition Corp.", ticker: "DTRTW" },
    { name: "BBLN-WT - Babylon Holdings Ltd", ticker: "BBLN-WT" },
    { name: "CCTSU - Cactus Acquisition Corp. 1 Ltd", ticker: "CCTSU" },
    { name: "AFTR-UN - AfterNext HealthTech Acquisition Corp.", ticker: "AFTR-UN" },
    { name: "AFTR-WT - AfterNext HealthTech Acquisition Corp.", ticker: "AFTR-WT" },
    { name: "KCGI-UN - Kensington Capital Acquisition Corp. V", ticker: "KCGI-UN" },
    { name: "KCGI-WT - Kensington Capital Acquisition Corp. V", ticker: "KCGI-WT" },
    { name: "CMCAU - Capitalworks Emerging Markets Acquisition Corp", ticker: "CMCAU" },
    { name: "PORT-UN - Southport Acquisition Corp", ticker: "PORT-UN" },
    { name: "ARGUU - Argus Capital Corp.", ticker: "ARGUU" },
    { name: "ARGUW - Argus Capital Corp.", ticker: "ARGUW" },
    { name: "ESACU - ESGEN Acquisition Corp", ticker: "ESACU" },
    { name: "HORIU - Emerging Markets Horizon Corp.", ticker: "HORIU" },
    { name: "EDNCU - Endurance Acquisition Corp.", ticker: "EDNCU" },
    { name: "EDNCW - Endurance Acquisition Corp.", ticker: "EDNCW" },
    { name: "DHACU - DIGITAL HEALTH ACQUISITION CORP.", ticker: "DHACU" },
    { name: "TGVCU - TG Venture Acquisition Corp.", ticker: "TGVCU" },
    { name: "TGVCW - TG Venture Acquisition Corp.", ticker: "TGVCW" },
    { name: "MNTN-UN - Everest Consolidator Acquisition Corp", ticker: "MNTN-UN" },
    { name: "THACU - Thrive Acquisition Corp", ticker: "THACU" },
    { name: "PPHPR - PHP Ventures Acquisition Corp.", ticker: "PPHPR" },
    { name: "THACW - Thrive Acquisition Corp", ticker: "THACW" },
    { name: "PROCW - Procaps Group, S.A.", ticker: "PROCW" },
    { name: "WEJOW - Wejo Group Ltd", ticker: "WEJOW" },
    { name: "SMAPU - Sportsmap Tech Acquisition Corp.", ticker: "SMAPU" },
    { name: "SMAPW - Sportsmap Tech Acquisition Corp.", ticker: "SMAPW" },
    { name: "PRTM - Prime Time Holdings, Inc.", ticker: "PRTM" },
    { name: "PEPLW - PepperLime Health Acquisition Corp", ticker: "PEPLW" },
    { name: "STRNW - Stran & Company, Inc.", ticker: "STRNW" },
    { name: "ENTFW - Enterprise 4.0 Technology Acquisition Corp", ticker: "ENTFW" },
    { name: "DSAQ-WT - Direct Selling Acquisition Corp.", ticker: "DSAQ-WT" },
    { name: "NRSNW - NeuroSense Therapeutics Ltd.", ticker: "NRSNW" },
    { name: "JMACU - Maxpro Capital Acquisition Corp.", ticker: "JMACU" },
    { name: "JMACW - Maxpro Capital Acquisition Corp.", ticker: "JMACW" },
    { name: "BCSAU - Blockchain Coinvestors Acquisition Corp. I", ticker: "BCSAU" },
    { name: "PEPLU - PepperLime Health Acquisition Corp", ticker: "PEPLU" },
    { name: "IMPPP - Imperial Petroleum Inc./Marshall Islands", ticker: "IMPPP" },
    { name: "WEL-UN - Integrated Wellness Acquisition Corp", ticker: "WEL-UN" },
    { name: "GRMWF - TPCO Holding Corp.", ticker: "GRMWF" },
    { name: "ARIZR - Arisz Acquisition Corp.", ticker: "ARIZR" },
    { name: "ARIZU - Arisz Acquisition Corp.", ticker: "ARIZU" },
    { name: "ARIZW - Arisz Acquisition Corp.", ticker: "ARIZW" },
    { name: "LIBYU - Liberty Resources Acquisition Corp.", ticker: "LIBYU" },
    { name: "TLGYU - TLGY Acquisition Corp", ticker: "TLGYU" },
    { name: "ENCPU - Energem Corp", ticker: "ENCPU" },
    { name: "LGVCU - LAMF Global Ventures Corp. I", ticker: "LGVCU" },
    { name: "BNOW - Boon Industries, Inc.", ticker: "BNOW" },
    { name: "UTAAU - UTA Acquisition Corp", ticker: "UTAAU" },
    { name: "ROCLU - Roth CH Acquisition V Co.", ticker: "ROCLU" },
    { name: "MTVC-UN - Motive Capital Corp II", ticker: "MTVC-UN" },
    { name: "SUAC-UN - ShoulderUP Technology Acquisition Corp.", ticker: "SUAC-UN" },
    { name: "VSACU - VISION SENSING ACQUISITION CORP.", ticker: "VSACU" },
    { name: "ALORU - ALSP Orchid Acquisition Corp I", ticker: "ALORU" },
    { name: "ROCAU - ROC Energy Acquisition Corp.", ticker: "ROCAU" },
    { name: "ATEK-UN - Athena Technology Acquisition Corp. II", ticker: "ATEK-UN" },
    { name: "ASEPF - ALPINE SUMMIT ENERGY PARTNERS, INC.", ticker: "ASEPF" },
    { name: "VTSCF - Vitesco Technologies Group AG /ADR", ticker: "VTSCF" },
    { name: "ENLAY - ENEL SOCIETA PER AZIONI", ticker: "ENLAY" },
    { name: "APO - Apollo Global Management, Inc.", ticker: "APO" },
    { name: "DSCSY - Disco Corporation/ADR", ticker: "DSCSY" },
    { name: "NCNO - nCino, Inc.", ticker: "NCNO" },
    { name: "VORB - Virgin Orbit Holdings, Inc.", ticker: "VORB" },
    { name: "BOWL - Bowlero Corp.", ticker: "BOWL" },
    { name: "WULF - TERAWULF INC.", ticker: "WULF" },
    { name: "HLGN - Heliogen, Inc.", ticker: "HLGN" },
    { name: "PRDS - PARDES BIOSCIENCES, INC.", ticker: "PRDS" },
    { name: "PLNHF - Planet 13 Holdings Inc.", ticker: "PLNHF" },
    { name: "ADTH - AdTheorent Holding Company, Inc.", ticker: "ADTH" },
    { name: "FATH - Fathom Digital Manufacturing Corp", ticker: "FATH" },
    { name: "RLFTY - Relief Therapeutics Holding SA", ticker: "RLFTY" },
    { name: "CCRD - CoreCard Corp", ticker: "CCRD" },
    { name: "USCB - USCB FINANCIAL HOLDINGS, INC.", ticker: "USCB" },
    { name: "HYPR - Hyperfine, Inc.", ticker: "HYPR" },
    { name: "KCAC - Kensington Capital Acquisition Corp. IV", ticker: "KCAC" },
    { name: "PDLB - Ponce Financial Group, Inc.", ticker: "PDLB" },
    { name: "BASI - Basis Global Technologies, Inc.", ticker: "BASI" },
    { name: "CLPE - CLEAR PEAK ENERGY, INC", ticker: "CLPE" },
    { name: "AHG - Xiaobai Maimai Inc.", ticker: "AHG" },
    { name: "SQFL - SQL Technologies Corp.", ticker: "SQFL" },
    { name: "CMPO - CompoSecure, Inc.", ticker: "CMPO" },
    { name: "JDVB - JD BANCSHARES INC", ticker: "JDVB" },
    { name: "BRAC - Broad Capital Acquisition Corp", ticker: "BRAC" },
    { name: "NILE - BitNile Holdings, Inc.", ticker: "NILE" },
    { name: "MPIR - Empire Diversified Energy Inc", ticker: "MPIR" },
    { name: "EWGFF - Eat Well Investment Group Inc.", ticker: "EWGFF" },
    { name: "WAVD - WAVEDANCER, INC.", ticker: "WAVD" },
    { name: "PRSO - Peraso Inc.", ticker: "PRSO" },
    { name: "OHCS - Optimus Healthcare Services, Inc.", ticker: "OHCS" },
    { name: "GEBRF - Greenbriar Capital Corp.", ticker: "GEBRF" },
    { name: "SMREF - San Marco Resources Inc.", ticker: "SMREF" },
    { name: "PNXLF - Argentina Lithium & Energy Corp.", ticker: "PNXLF" },
    { name: "GFGSF - GFG Resources Inc.", ticker: "GFGSF" },
    { name: "RENO - RENOVARE ENVIRONMENTAL, INC.", ticker: "RENO" },
    { name: "NXGL - NEXGEL, INC.", ticker: "NXGL" },
    { name: "SPRC - SciSparc Ltd.", ticker: "SPRC" },
    { name: "FMNJ - Franklin Mining, Inc.", ticker: "FMNJ" },
    { name: "NSPDF - NATURALLY SPLENDID ENTERPRISES LTD.", ticker: "NSPDF" },
    { name: "MNRLF - MINERAL MOUNTAIN RESOURCES LTD.", ticker: "MNRLF" },
    { name: "HADV - HEALTH ADVANCE INC.", ticker: "HADV" },
    { name: "TRMNF - NEW WAVE HOLDINGS CORP.", ticker: "TRMNF" },
    { name: "WSRC - WESTERN SIERRA RESOURCE Corp", ticker: "WSRC" },
    { name: "VMCS - InnovaQor, Inc.", ticker: "VMCS" },
    { name: "NLAB - NUONCOLOGY LABS INC", ticker: "NLAB" },
    { name: "TAMG - Transnational Group, Inc.", ticker: "TAMG" },
    { name: "XCRT - Xcelerate, Inc.", ticker: "XCRT" },
    { name: "KNOS - KRONOS ADVANCED TECHNOLOGIES INC", ticker: "KNOS" },
    { name: "EAPH - EASTON PHARMACEUTICALS INC.", ticker: "EAPH" },
    { name: "MSTO - Masterbeat Corp", ticker: "MSTO" },
    { name: "KEGS - 1812 Brewing Company, Inc.", ticker: "KEGS" },
    { name: "AMLX - Amylyx Pharmaceuticals, Inc.", ticker: "AMLX" },
    { name: "GENQ - Genesis Unicorn Capital Corp.", ticker: "GENQ" },
    { name: "RACY - Relativity Acquisition Corp", ticker: "RACY" },
    { name: "ELSN - Eleison Pharmaceuticals Inc", ticker: "ELSN" },
    { name: "FVT.U - Fortress Value Acquisition Corp. III", ticker: "FVT.U" },
    { name: "ALR - AlerisLife Inc.", ticker: "ALR" },
    { name: "AKAN - AKANDA CORP.", ticker: "AKAN" },
    { name: "DPAC - Deep Space Acquisition Corp. I", ticker: "DPAC" },
    { name: "SGLY - Singularity Future Technology Ltd.", ticker: "SGLY" },
    { name: "QHI - QINHONG INTERNATIONAL GROUP", ticker: "QHI" },
    { name: "SVV - S-Evergreen Holding LLC", ticker: "SVV" },
    { name: "BRCC - BRC Inc.", ticker: "BRCC" },
    { name: "GLAA - GLA II Meteora Acquisition Corp.", ticker: "GLAA" },
    { name: "LBBB - Lakeshore Acquisition II Corp.", ticker: "LBBB" },
    { name: "CORZ - Core Scientific, Inc./tx", ticker: "CORZ" },
    { name: "LUCY - Innovative Eyewear Inc", ticker: "LUCY" },
    { name: "CENN - CENNTRO ELECTRIC GROUP Ltd", ticker: "CENN" },
    { name: "RVR - REV Renewables, Inc.", ticker: "RVR" },
    { name: "AXAC - AXIOS Sustainable Growth Acquisition Corp", ticker: "AXAC" },
    { name: "MFRM - Mattress Firm Group Inc.", ticker: "MFRM" },
    { name: "USSC - Constitution Acquisition Corp.", ticker: "USSC" },
    { name: "TKLF - Yoshitsu Co., Ltd", ticker: "TKLF" },
    { name: "DAVE - Dave Inc./DE", ticker: "DAVE" },
    { name: "DUET - DUET Acquisition Corp.", ticker: "DUET" },
    { name: "SKYH - Sky Harbour Group Corp", ticker: "SKYH" },
    { name: "EDGS - Edge Data Solutions, Inc.", ticker: "EDGS" },
    { name: "KSCP - Knightscope, Inc.", ticker: "KSCP" },
    { name: "PGRM - Panagram Capital, LLC", ticker: "PGRM" },
    { name: "LDSP - Sports & Health Tech Acquisition Corp", ticker: "LDSP" },
    { name: "ALOHA - Cariloha, Inc.", ticker: "ALOHA" },
    { name: "RFAC - RF Acquisition Corp.", ticker: "RFAC" },
    { name: "BRNI - Beroni Group Ltd", ticker: "BRNI" },
    { name: "NXPL - NextPlat Corp", ticker: "NXPL" },
    { name: "TPG - TPG Inc.", ticker: "TPG" },
    { name: "GHIX - Gores Holdings IX, Inc.", ticker: "GHIX" },
    { name: "KACL - Kairous Acquisition Corp. Ltd", ticker: "KACL" },
    { name: "RAYA - Erayak Power Solution Group Inc.", ticker: "RAYA" },
    { name: "TURO - Turo Inc.", ticker: "TURO" },
    { name: "TCRT - Alaunos Therapeutics, Inc.", ticker: "TCRT" },
    { name: "KNSW - KnightSwan Acquisition Corp", ticker: "KNSW" },
    { name: "SCRM - Screaming Eagle Acquisition Corp.", ticker: "SCRM" },
    { name: "PMBY - PostD Merchant Banque", ticker: "PMBY" },
    { name: "VZLA - Vizsla Silver Corp.", ticker: "VZLA" },
    { name: "BTRU - tru Shrimp Companies, Inc.", ticker: "BTRU" },
    { name: "RVLP - RVL Pharmaceuticals plc", ticker: "RVLP" },
    { name: "LEDG - Ledger Acquisition Co", ticker: "LEDG" },
    { name: "ZIMV - ZimVie Inc.", ticker: "ZIMV" },
    { name: "ATAK - Aurora Technology Acquisition Corp.", ticker: "ATAK" },
    { name: "CEAD - CEA Industries Inc.", ticker: "CEAD" },
    { name: "HTCR - HeartCore Enterprises, Inc.", ticker: "HTCR" },
    { name: "LBGJ - Li Bang International Corp Inc.", ticker: "LBGJ" },
    { name: "MSVA - Mindset Growth Opportunities I Corp.", ticker: "MSVA" },
    { name: "NVAC - NorthView Acquisition Corp", ticker: "NVAC" },
    { name: "CCV.U - Churchill Capital Corp V", ticker: "CCV.U" },
    { name: "VMCA - Valuence Merger Corp. I", ticker: "VMCA" },
    { name: "ACAX - Alset Capital Acquisition Corp.", ticker: "ACAX" },
    { name: "YOSH - Yoshiharu Global Co.", ticker: "YOSH" },
    { name: "FRZA - Forza X1, Inc.", ticker: "FRZA" },
    { name: "HZAG - Hanze Asia Growth A", ticker: "HZAG" },
    { name: "CPAQ - Counter Press Acquisition Corp", ticker: "CPAQ" },
    { name: "RAMX - Aries II Acquisition Corp", ticker: "RAMX" },
    { name: "BLCO - Bausch & Lomb Corp", ticker: "BLCO" },
    { name: "DSTY - Dynasty Financial Partners Inc.", ticker: "DSTY" },
    { name: "TDRK - TIDEROCK COMPANIES, INC.", ticker: "TDRK" },
    { name: "HWNI - HIGH WIRE NETWORKS, INC.", ticker: "HWNI" },
    { name: "YBZN - Yi Po International Holdings Ltd", ticker: "YBZN" },
    { name: "MURF - Murphy Canyon Acquisition Corp.", ticker: "MURF" },
    { name: "ACON - Aclarion, Inc.", ticker: "ACON" },
    { name: "SATT - SATIVUS TECH CORP.", ticker: "SATT" },
    { name: "SGHL - Signal Hill Acquisition Corp.", ticker: "SGHL" },
    { name: "GDVW - Grandview Capital Acquisition Corp.", ticker: "GDVW" },
    { name: "ACRU - AmeriCrew Inc.", ticker: "ACRU" },
    { name: "XFCI - XTREME FIGHTING CHAMPIONSHIPS, INC.", ticker: "XFCI" },
    { name: "XESP - Electronic Servitor Publication Network Inc.", ticker: "XESP" },
    { name: "IPOF.U - Social Capital Hedosophia Holdings Corp. VI", ticker: "IPOF.U" },
    { name: "TRIRF - Triterras, Inc.", ticker: "TRIRF" },
    { name: "DGC - Delphi Growth Capital Corp.", ticker: "DGC" },
    { name: "IACI - Intrepid Acquisition Corp I", ticker: "IACI" },
    { name: "MANS - Bright Lights Parent Corp.", ticker: "MANS" },
    { name: "HGIA - HENGGUANG HOLDING CO, Ltd", ticker: "HGIA" },
    { name: "HLP - Hongli Group Inc.", ticker: "HLP" },
    { name: "UBXG - U-BX Technology Ltd.", ticker: "UBXG" },
    { name: "EMLD - FTAC Emerald Acquisition Corp.", ticker: "EMLD" },
    { name: "ALVO - Alvotech Lux Holdings S.A.S.", ticker: "ALVO" },
    { name: "JJOC - JJ Opportunity Corp.", ticker: "JJOC" },
    { name: "NVX - NOVONIX Ltd", ticker: "NVX" },
    { name: "HS - HomeSmart Holdings, Inc.", ticker: "HS" },
    { name: "FDHA - First Digital Health Acquisition Corp.", ticker: "FDHA" },
    { name: "ALSA - Alpha Star Acquisition Corp", ticker: "ALSA" },
    { name: "GRRR - Gorilla Technology Group Inc.", ticker: "GRRR" },
    { name: "PWUP - PowerUp Acquisition Corp.", ticker: "PWUP" },
    { name: "GRNA - Environmental Impact Acquisition Corp", ticker: "GRNA" },
    { name: "NXL - Nexalin Technology, Inc.", ticker: "NXL" },
    { name: "TRDE - TRADESTATION GROUP INC", ticker: "TRDE" },
    { name: "JW - Justworks, Inc.", ticker: "JW" },
    { name: "AFTX - Affinia Therapeutics Inc.", ticker: "AFTX" },
    { name: "CRGH - Carriage House Event Center, Inc.", ticker: "CRGH" },
    { name: "RTGN - RetinalGenix Technologies Inc.", ticker: "RTGN" },
    { name: "LSDI - Lucy Scientific Discovery, Inc.", ticker: "LSDI" },
    { name: "GLXY - Galaxy Digital Inc.", ticker: "GLXY" },
    { name: "OPHV - Opti-Harvest, Inc.", ticker: "OPHV" },
    { name: "PCPC.U - Periphas Capital Partnering Corp", ticker: "PCPC.U" },
    { name: "GLS - GELESIS HOLDINGS, INC.", ticker: "GLS" },
    { name: "IPOD.U - Social Capital Hedosophia Holdings Corp. IV", ticker: "IPOD.U" },
    { name: "CRDO - Credo Technology Group Holding Ltd", ticker: "CRDO" },
    { name: "FTII - Future Tech II Acquisition Corp.", ticker: "FTII" },
    { name: "GTEN - Gores Holdings X, Inc.", ticker: "GTEN" },
    { name: "DESR - DESRI Inc.", ticker: "DESR" },
    { name: "PNAC - Prime Number Acquisition I Corp.", ticker: "PNAC" },
    { name: "LCFY - Locafy Ltd", ticker: "LCFY" },
    { name: "SHEL - Shell plc", ticker: "SHEL" },
    { name: "AFRI - Globis NV Merger Corp.", ticker: "AFRI" },
    { name: "RENE - Cartesian Growth Corp II", ticker: "RENE" },
    { name: "TSIO - Thornburg Strategic Income Opportunities Trust", ticker: "TSIO" },
    { name: "AORT - ARTIVION, INC.", ticker: "AORT" },
    { name: "BBOP - BeBop Channel Corp", ticker: "BBOP" },
    { name: "REVB - REVELATION BIOSCIENCES, INC.", ticker: "REVB" },
    { name: "RDXX - Roman DBDR Tech Acquisition Corp. III", ticker: "RDXX" },
    { name: "SOND - Sonder Holdings, Inc.", ticker: "SOND" },
    { name: "ACLX - Arcellx, Inc.", ticker: "ACLX" },
    { name: "SPCM - Sound Point Acquisition Corp I, Ltd", ticker: "SPCM" },
    { name: "SBP - Specialty Building Products, Inc.", ticker: "SBP" },
    { name: "PDPG - Performance Drink Group, Inc.", ticker: "PDPG" },
    { name: "AZ - A2Z Smart Technologies Corp", ticker: "AZ" },
    { name: "SOSH - SOS Hydration Inc.", ticker: "SOSH" },
    { name: "WTW - WILLIS TOWERS WATSON PLC", ticker: "WTW" },
    { name: "EXRO - EXRO TECHNOLOGIES INC.", ticker: "EXRO" },
    { name: "YCQH - YCQH Agricultural Technology Co. Ltd", ticker: "YCQH" },
    { name: "BWAQ - Blue World Acquisition Corp", ticker: "BWAQ" },
    { name: "TETE - Technology & Telecommunication Acquisition Corp", ticker: "TETE" },
    { name: "MOGL - Mobile Global Esports, Inc.", ticker: "MOGL" },
    { name: "GETY - VECTOR HOLDING, LLC", ticker: "GETY" },
    { name: "ESOCF - ENEL SOCIETA PER AZIONI", ticker: "ESOCF" },
    { name: "DISPF - Disco Corporation/ADR", ticker: "DISPF" },
    { name: "BKGFF - Berkeley Group Holdings plc", ticker: "BKGFF" },
    { name: "EVOTF - Evotec SE", ticker: "EVOTF" },
    { name: "NVNXF - NOVONIX Ltd", ticker: "NVNXF" },
    { name: "RLFTF - Relief Therapeutics Holding SA", ticker: "RLFTF" },
    { name: "FFLWF - Fire & Flower Holdings Corp.", ticker: "FFLWF" },
    { name: "EXROF - EXRO TECHNOLOGIES INC.", ticker: "EXROF" },
    { name: "SRNW - Stratos Renewables Corp", ticker: "SRNW" },
    { name: "ZYRXD - Winvest Group Ltd", ticker: "ZYRXD" },
    { name: "NBCO - Neon Bloom, Inc.", ticker: "NBCO" },
    { name: "BFDE - Bedford Holdings Corp", ticker: "BFDE" },
    { name: "YSAC-UN - Sky Harbour Group Corp", ticker: "YSAC-UN" },
    { name: "SKYH-WT - Sky Harbour Group Corp", ticker: "SKYH-WT" },
    { name: "PHYT-WT - Pyrophyte Acquisition Corp.", ticker: "PHYT-WT" },
    { name: "PORT-WT - Southport Acquisition Corp", ticker: "PORT-WT" },
    { name: "NFNT-WT - Infinite Acquisition Corp.", ticker: "NFNT-WT" },
    { name: "CRECW - Crescera Capital Acquisition Corp.", ticker: "CRECW" },
    { name: "CXAC-UN - C5 Acquisition Corp", ticker: "CXAC-UN" },
    { name: "PRLHU - Pearl Holdings Acquisition Corp", ticker: "PRLHU" },
    { name: "DUETU - DUET Acquisition Corp.", ticker: "DUETU" },
    { name: "FRBNU - Forbion European Acquisition Corp.", ticker: "FRBNU" },
    { name: "FRBNW - Forbion European Acquisition Corp.", ticker: "FRBNW" },
    { name: "ASTID - Ascent Solar Technologies, Inc.", ticker: "ASTID" },
    { name: "JRJCY - China Finance Online Co. LTD", ticker: "JRJCY" },
    { name: "JWACR - Jupiter Wellness Acquisition Corp.", ticker: "JWACR" },
    { name: "VSACW - VISION SENSING ACQUISITION CORP.", ticker: "VSACW" },
    { name: "MBSC-WT - M3-Brigade Acquisition III Corp.", ticker: "MBSC-WT" },
    { name: "APCA-UN - AP Acquisition Corp", ticker: "APCA-UN" },
    { name: "BRACU - Broad Capital Acquisition Corp", ticker: "BRACU" },
    { name: "BRKHW - BurTech Acquisition Corp.", ticker: "BRKHW" },
    { name: "BRKHU - BurTech Acquisition Corp.", ticker: "BRKHU" },
    { name: "AIBBU - AIB Acquisition Corp", ticker: "AIBBU" },
    { name: "VMGAW - VMG Consumer Acquisition Corp.", ticker: "VMGAW" },
    { name: "SZZLW - Sizzle Acquisition Corp.", ticker: "SZZLW" },
    { name: "DAVEW - Dave Inc./DE", ticker: "DAVEW" },
    { name: "HCMAU - HCM Acquisition Corp", ticker: "HCMAU" },
    { name: "CNDA-UN - Concord Acquisition Corp II", ticker: "CNDA-UN" },
    { name: "SHCAU - Spindletop Health Acquisition Corp.", ticker: "SHCAU" },
    { name: "PACI-WT - PROOF Acquisition Corp I", ticker: "PACI-WT" },
    { name: "EFC-PB - Ellington Financial Inc.", ticker: "EFC-PB" },
    { name: "GRBK-PA - Green Brick Partners, Inc.", ticker: "GRBK-PA" },
    { name: "SILED - Silver Elephant Mining Corp.", ticker: "SILED" },
    { name: "WBS-PG - WEBSTER FINANCIAL CORP", ticker: "WBS-PG" },
    { name: "VHNAW - Vahanna Tech Edge Acquisition I Corp.", ticker: "VHNAW" },
    { name: "SSU-WT - SIGNA Sports United N.V.", ticker: "SSU-WT" },
    { name: "CFFSU - CF Acquisition Corp. VII", ticker: "CFFSU" },
    { name: "IOACW - Innovative International Acquisition Corp.", ticker: "IOACW" },
    { name: "NXPLW - NextPlat Corp", ticker: "NXPLW" },
    { name: "GHIXU - Gores Holdings IX, Inc.", ticker: "GHIXU" },
    { name: "UTAAW - UTA Acquisition Corp", ticker: "UTAAW" },
    { name: "BCSAW - Blockchain Coinvestors Acquisition Corp. I", ticker: "BCSAW" },
    { name: "ALPAU - ALPHA HEALTHCARE ACQUISITION CORP III", ticker: "ALPAU" },
    { name: "TCOA-WT - Trajectory Alpha Acquisition Corp.", ticker: "TCOA-WT" },
    { name: "INTEW - Integral Acquisition Corp 1", ticker: "INTEW" },
    { name: "HMA-UN - Heartland Media Acquisition Corp.", ticker: "HMA-UN" },
    { name: "XPDBW - Power & Digital Infrastructure Acquisition II Corp.", ticker: "XPDBW" },
    { name: "APMIU - AxonPrime Infrastructure Acquisition Corp", ticker: "APMIU" },
    { name: "MPRAW - Mercato Partners Acquisition Corp", ticker: "MPRAW" },
    { name: "KACLW - Kairous Acquisition Corp. Ltd", ticker: "KACLW" },
    { name: "KACLR - Kairous Acquisition Corp. Ltd", ticker: "KACLR" },
    { name: "KACLU - Kairous Acquisition Corp. Ltd", ticker: "KACLU" },
    { name: "STET-WT - ST Energy Transition I Ltd.", ticker: "STET-WT" },
    { name: "SCMAW - Seaport Calibre Materials Acquisition Corp.", ticker: "SCMAW" },
    { name: "ADRT-UN - Ault Disruptive Technologies Corp", ticker: "ADRT-UN" },
    { name: "IGTAW - Inception Growth Acquisition Ltd", ticker: "IGTAW" },
    { name: "IGTAR - Inception Growth Acquisition Ltd", ticker: "IGTAR" },
    { name: "MCAAW - Mountain & Co. I Acquisition Corp.", ticker: "MCAAW" },
    { name: "BOCNW - Blue Ocean Acquisition Corp", ticker: "BOCNW" },
    { name: "ICNC-WT - Iconic Sports Acquisition Corp.", ticker: "ICNC-WT" },
    { name: "PGSS-WT - Pegasus Digital Mobility Acquisition Corp.", ticker: "PGSS-WT" },
    { name: "FCNCO - FIRST CITIZENS BANCSHARES INC /DE/", ticker: "FCNCO" },
    { name: "NXGLW - NEXGEL, INC.", ticker: "NXGLW" },
    { name: "ODTC - Odonate Therapeutics, Inc.", ticker: "ODTC" },
    { name: "SCCD - Sachem Capital Corp.", ticker: "SCCD" },
    { name: "NVNBW - enVVeno Medical Corp", ticker: "NVNBW" },
    { name: "CORZW - Core Scientific, Inc./tx", ticker: "CORZW" },
    { name: "WNNR-UN - Andretti Acquisition Corp.", ticker: "WNNR-UN" },
    { name: "GOGN-WT - GoGreen Investments Corp", ticker: "GOGN-WT" },
    { name: "GOGN-UN - GoGreen Investments Corp", ticker: "GOGN-UN" },
    { name: "MLAIW - McLaren Technology Acquisition Corp.", ticker: "MLAIW" },
    { name: "GTACW - Global Technology Acquisition Corp. I", ticker: "GTACW" },
    { name: "CITEU - Cartica Acquisition Corp", ticker: "CITEU" },
    { name: "CNGLW - Canna-Global Acquisition Corp", ticker: "CNGLW" },
    { name: "ROCAR - ROC Energy Acquisition Corp.", ticker: "ROCAR" },
    { name: "OLITW - OmniLit Acquisition Corp.", ticker: "OLITW" },
    { name: "IVCBU - Investcorp Europe Acquisition Corp I", ticker: "IVCBU" },
    { name: "TOACW - Talon 1 Acquisition Corp", ticker: "TOACW" },
    { name: "BPACW - Bullpen Parlay Acquisition Co", ticker: "BPACW" },
    { name: "SQFTW - Presidio Property Trust, Inc.", ticker: "SQFTW" },
    { name: "APN-WT - Apeiron Capital Investment Corp.", ticker: "APN-WT" },
    { name: "HTAQ-WT - Hunt Companies Acquisition Corp. I", ticker: "HTAQ-WT" },
    { name: "GEEXW - Games & Esports Experience Acquisition Corp.", ticker: "GEEXW" },
    { name: "MNTN-WT - Everest Consolidator Acquisition Corp", ticker: "MNTN-WT" },
    { name: "MAAQW - Mana Capital Acquisition Corp.", ticker: "MAAQW" },
    { name: "NOVVR - Nova Vision Acquisition Corp", ticker: "NOVVR" },
    { name: "SGHC-WT - Super Group (SGHC) Ltd", ticker: "SGHC-WT" },
    { name: "SATLW - Satellogic Inc.", ticker: "SATLW" },
    { name: "LGTOW - LEGATO MERGER CORP. II", ticker: "LGTOW" },
    { name: "ACAXU - Alset Capital Acquisition Corp.", ticker: "ACAXU" },
    { name: "TRAQ-WT - Trine II Acquisition Corp.", ticker: "TRAQ-WT" },
    { name: "NETC-WT - Nabors Energy Transition Corp.", ticker: "NETC-WT" },
    { name: "GAQ-UN - Generation Asia I Acquisition Ltd", ticker: "GAQ-UN" },
    { name: "ACDI-UN - Ascendant Digital Acquisition Corp. III", ticker: "ACDI-UN" },
    { name: "ACDI-WT - Ascendant Digital Acquisition Corp. III", ticker: "ACDI-WT" },
    { name: "RCFA-WT - RCF Acquisition Corp.", ticker: "RCFA-WT" },
    { name: "AOGOU - Arogo Capital Acquisition Corp.", ticker: "AOGOU" },
    { name: "EVE-UN - EVe Mobility Acquisition Corp", ticker: "EVE-UN" },
    { name: "VWEWW - Vintage Wine Estates, Inc.", ticker: "VWEWW" },
    { name: "BOWL-WT - Bowlero Corp.", ticker: "BOWL-WT" },
    { name: "AAM-PB - Apollo Asset Management, Inc.", ticker: "AAM-PB" },
    { name: "AAM-PA - Apollo Asset Management, Inc.", ticker: "AAM-PA" },
    { name: "BWNB - Babcock & Wilcox Enterprises, Inc.", ticker: "BWNB" },
    { name: "MTBCO - CareCloud, Inc.", ticker: "MTBCO" },
    { name: "ECC-PD - Eagle Point Credit Co Inc.", ticker: "ECC-PD" },
    { name: "ECCV - Eagle Point Credit Co Inc.", ticker: "ECCV" },
    { name: "SCRMU - Screaming Eagle Acquisition Corp.", ticker: "SCRMU" },
    { name: "CSLMU - Consilium Acquisition Corp I, Ltd.", ticker: "CSLMU" },
    { name: "KNSW-UN - KnightSwan Acquisition Corp", ticker: "KNSW-UN" },
    { name: "FRLAU - Fortune Rise Acquisition Corp", ticker: "FRLAU" },
    { name: "FRLAW - Fortune Rise Acquisition Corp", ticker: "FRLAW" },
    { name: "FATH-WT - Fathom Digital Manufacturing Corp", ticker: "FATH-WT" },
    { name: "IRRX-WT - INTEGRATED RAIL & RESOURCES ACQUISITION CORP", ticker: "IRRX-WT" },
    { name: "INAQ-UN - Insight Acquisition Corp. /DE", ticker: "INAQ-UN" },
    { name: "GVCIW - Green Visor Financial Technology Acquisition Corp I", ticker: "GVCIW" },
    { name: "NVACW - NorthView Acquisition Corp", ticker: "NVACW" },
    { name: "NVACR - NorthView Acquisition Corp", ticker: "NVACR" },
    { name: "WEL-WT - Integrated Wellness Acquisition Corp", ticker: "WEL-WT" },
    { name: "CMCAW - Capitalworks Emerging Markets Acquisition Corp", ticker: "CMCAW" },
    { name: "MTVC-WT - Motive Capital Corp II", ticker: "MTVC-WT" },
    { name: "TGAAW - Target Global Acquisition I Corp.", ticker: "TGAAW" },
    { name: "PEGRW - Project Energy Reimagined Acquisition Corp.", ticker: "PEGRW" },
    { name: "PCCTW - Perception Capital Corp. II", ticker: "PCCTW" },
    { name: "BLEUR - bleuacacia ltd", ticker: "BLEUR" },
    { name: "BLEUW - bleuacacia ltd", ticker: "BLEUW" },
    { name: "LEGAW - Lead Edge Growth Opportunities, Ltd", ticker: "LEGAW" },
    { name: "NPABW - New Providence Acquisition Corp. II", ticker: "NPABW" },
    { name: "IQMDW - Intelligent Medicine Acquisition Corp.", ticker: "IQMDW" },
    { name: "WWACW - Worldwide Webb Acquisition Corp.", ticker: "WWACW" },
    { name: "FIACW - Focus Impact Acquisition Corp.", ticker: "FIACW" },
    { name: "IFIN-WT - InFinT Acquisition Corp", ticker: "IFIN-WT" },
    { name: "ARCKW - Arbor Rapha Capital Bioholdings Corp. I", ticker: "ARCKW" },
    { name: "ZINGW - FTAC ZEUS ACQUISITION CORP.", ticker: "ZINGW" },
    { name: "GMFIU - Aetherium Acquisition Corp", ticker: "GMFIU" },
    { name: "DSAQ-UN - Direct Selling Acquisition Corp.", ticker: "DSAQ-UN" },
    { name: "MURFU - Murphy Canyon Acquisition Corp.", ticker: "MURFU" },
    { name: "ALORW - ALSP Orchid Acquisition Corp I", ticker: "ALORW" },
    { name: "BIPI - Brookfield Infrastructure Partners L.P.", ticker: "BIPI" },
    { name: "TRIRW - Triterras, Inc.", ticker: "TRIRW" },
    { name: "BAC-PS - BANK OF AMERICA CORP /DE/", ticker: "BAC-PS" },
    { name: "BACXL - BANK OF AMERICA CORP /DE/", ticker: "BACXL" },
    { name: "AHRNU - Ahren Acquisition Corp.", ticker: "AHRNU" },
    { name: "KYCHU - Keyarch Acquisition Corp", ticker: "KYCHU" },
    { name: "GFGDW - Growth for Good Acquisition Corp", ticker: "GFGDW" },
    { name: "GFGDR - Growth for Good Acquisition Corp", ticker: "GFGDR" },
    { name: "ZGN-WT - Ermenegildo Zegna N.V.", ticker: "ZGN-WT" },
    { name: "SHAP-UN - Spree Acquisition Corp. 1 Ltd", ticker: "SHAP-UN" },
    { name: "BYN-UN - Banyan Acquisition Corp", ticker: "BYN-UN" },
    { name: "WRPT - WARPSPEED TAXI INC.", ticker: "WRPT" },
    { name: "SSSSL - SURO CAPITAL CORP.", ticker: "SSSSL" },
    { name: "BEPI - Brookfield Renewable Partners L.P.", ticker: "BEPI" },
    { name: "ADALW - Anthemis Digital Acquisitions I Corp", ticker: "ADALW" },
    { name: "WINVR - WinVest Acquisition Corp.", ticker: "WINVR" },
    { name: "BIOSW - BioPlus Acquisition Corp.", ticker: "BIOSW" },
    { name: "RRAC-WT - Rigel Resource Acquisition Corp.", ticker: "RRAC-WT" },
    { name: "IVCPU - Swiftmerge Acquisition Corp.", ticker: "IVCPU" },
    { name: "SEDA-WT - SDCL EDGE Acquisition Corp", ticker: "SEDA-WT" },
    { name: "LAXXW - 8i Acquisition 2 Corp.", ticker: "LAXXW" },
    { name: "VCXB-UN - 10X Capital Venture Acquisition Corp. III", ticker: "VCXB-UN" },
    { name: "PPYAU - Papaya Growth Opportunity Corp. I", ticker: "PPYAU" },
    { name: "EMLDU - FTAC Emerald Acquisition Corp.", ticker: "EMLDU" },
    { name: "ROCLW - Roth CH Acquisition V Co.", ticker: "ROCLW" },
    { name: "ADSEW - Ads-Tec Energy Public Ltd Co", ticker: "ADSEW" },
    { name: "LGVCW - LAMF Global Ventures Corp. I", ticker: "LGVCW" },
    { name: "GRNAW - Environmental Impact Acquisition Corp", ticker: "GRNAW" },
    { name: "URCWF - Uranium Royalty Corp.", ticker: "URCWF" },
    { name: "PCXCW - Parsec Capital Acquisitions Corp.", ticker: "PCXCW" },
    { name: "USCTW - TKB Critical Technologies 1", ticker: "USCTW" },
    { name: "LATGU - LatAmGrowth SPAC", ticker: "LATGU" },
    { name: "CCTSW - Cactus Acquisition Corp. 1 Ltd", ticker: "CCTSW" },
    { name: "ALSAW - Alpha Star Acquisition Corp", ticker: "ALSAW" },
    { name: "ALSAU - Alpha Star Acquisition Corp", ticker: "ALSAU" },
    { name: "ALSAR - Alpha Star Acquisition Corp", ticker: "ALSAR" },
    { name: "WAVSU - Western Acquisition Ventures Corp.", ticker: "WAVSU" },
    { name: "SAGAU - Sagaliam Acquisition Corp", ticker: "SAGAU" },
    { name: "SUNFU - Sunfire Acquisition Corp Ltd", ticker: "SUNFU" },
    { name: "ACABU - Atlantic Coastal Acquisition Corp. II", ticker: "ACABU" },
    { name: "MTEKW - Maris Tech Ltd.", ticker: "MTEKW" },
    { name: "SLVRU - SILVERspac Inc.", ticker: "SLVRU" },
    { name: "LCAAW - L Catterton Asia Acquisition Corp", ticker: "LCAAW" },
    { name: "SST-WT - System1, Inc.", ticker: "SST-WT" },
    { name: "TETEU - Technology & Telecommunication Acquisition Corp", ticker: "TETEU" },
    { name: "TLGYW - TLGY Acquisition Corp", ticker: "TLGYW" },
    { name: "BWAQU - Blue World Acquisition Corp", ticker: "BWAQU" },
    { name: "APXIW - APx Acquisition Corp. I", ticker: "APXIW" },
    { name: "GGAAW - Genesis Growth Tech Acquisition Corp.", ticker: "GGAAW" },
    { name: "WTMAU - Welsbach Technology Metals Acquisition Corp.", ticker: "WTMAU" },
    { name: "WTMAR - Welsbach Technology Metals Acquisition Corp.", ticker: "WTMAR" },
    { name: "ESACW - ESGEN Acquisition Corp", ticker: "ESACW" },
    { name: "HCVIU - Hennessy Capital Investment Corp. VI", ticker: "HCVIU" },
    { name: "CNDB-WT - Concord Acquisition Corp III", ticker: "CNDB-WT" },
    { name: "RJAC-WT - Jackson Acquisition Co", ticker: "RJAC-WT" },
    { name: "JUN-WT - Juniper II Corp.", ticker: "JUN-WT" },
    { name: "GLS-WT - GELESIS HOLDINGS, INC.", ticker: "GLS-WT" },
    { name: "ATEK-WT - Athena Technology Acquisition Corp. II", ticker: "ATEK-WT" },
    { name: "GLLIR - GLOBALINK INVESTMENT INC.", ticker: "GLLIR" },
    { name: "GLLIW - GLOBALINK INVESTMENT INC.", ticker: "GLLIW" },
    { name: "XFINW - ExcelFin Acquisition Corp.", ticker: "XFINW" },
    { name: "BRD-WT - Beard Energy Transition Acquisition Corp.", ticker: "BRD-WT" },
    { name: "ENCPW - Energem Corp", ticker: "ENCPW" },
    { name: "BFAC-UN - Battery Future Acquisition Corp.", ticker: "BFAC-UN" },
    { name: "DHACW - DIGITAL HEALTH ACQUISITION CORP.", ticker: "DHACW" },
    { name: "LGSTW - Semper Paratus Acquisition Corp", ticker: "LGSTW" },
    { name: "ADTHW - AdTheorent Holding Company, Inc.", ticker: "ADTHW" },
    { name: "LIBYW - Liberty Resources Acquisition Corp.", ticker: "LIBYW" },
    { name: "RCACU - Revelstone Capital Acquisition Corp.", ticker: "RCACU" },
    { name: "FGIWW - FGI Industries Ltd.", ticker: "FGIWW" },
    { name: "BNIXR - Bannix Acquisition Corp.", ticker: "BNIXR" },
    { name: "FEXDR - Fintech Ecosystem Development Corp.", ticker: "FEXDR" },
    { name: "FEXDW - Fintech Ecosystem Development Corp.", ticker: "FEXDW" },
    { name: "ARRHW - ARCH RESOURCES, INC.", ticker: "ARRHW" },
    { name: "REVBW - REVELATION BIOSCIENCES, INC.", ticker: "REVBW" },
    { name: "CMPOW - CompoSecure, Inc.", ticker: "CMPOW" },
    { name: "LVACW - LAVA Medtech Acquisition Corp.", ticker: "LVACW" },
    { name: "SCUA-WT - Sculptor Acquisition Corp I", ticker: "SCUA-WT" },
    { name: "HLGN-WT - Heliogen, Inc.", ticker: "HLGN-WT" },
    { name: "DCFCW - Tritium DCFC Ltd", ticker: "DCFCW" },
    { name: "LSPRU - Larkspur Health Acquisition Corp.", ticker: "LSPRU" },
    { name: "RNERW - Mount Rainier Acquisition Corp.", ticker: "RNERW" },
    { name: "DPCSW - DP Cap Acquisition Corp I", ticker: "DPCSW" },
    { name: "SUAC-WT - ShoulderUP Technology Acquisition Corp.", ticker: "SUAC-WT" },
    { name: "EVTL-WT - Vertical Aerospace Ltd.", ticker: "EVTL-WT" },
    { name: "WNLV - Winvest Group Ltd", ticker: "WNLV" },
    { name: "SONDW - Sonder Holdings, Inc.", ticker: "SONDW" },
    { name: "HAIAW - Healthcare AI Acquisition Corp.", ticker: "HAIAW" },
    { name: "VORBW - Virgin Orbit Holdings, Inc.", ticker: "VORBW" },
    { name: "CBRGW - Chain Bridge I", ticker: "CBRGW" },
    { name: "APCXW - AppTech Payments Corp.", ticker: "APCXW" },
    { name: "YUKA - Yuka Group Inc", ticker: "YUKA" },
    { name: "MKGP - Maverick Energy Group, Ltd.", ticker: "MKGP" },
    { name: "LFLY - Leafly Holdings, Inc. /DE", ticker: "LFLY" },
    { name: "ENDI - ENDI Corp.", ticker: "ENDI" },
    { name: "SVOB - SEVEN OAKS ACQUISITION CORP. II", ticker: "SVOB" },
    { name: "SES - Ivanhoe Capital Acquisition Corp.", ticker: "SES" },
    { name: "IVCBW - Investcorp Europe Acquisition Corp I", ticker: "IVCBW" },
    { name: "BFAC-WT - Battery Future Acquisition Corp.", ticker: "BFAC-WT" },
    { name: "TGR-UN - Kimbell Tiger Acquisition Corp", ticker: "TGR-UN" },
    { name: "AHRNW - Ahren Acquisition Corp.", ticker: "AHRNW" },
    { name: "ANGHW - Anghami Inc", ticker: "ANGHW" },
    { name: "SES-WT - Ivanhoe Capital Acquisition Corp.", ticker: "SES-WT" },
    { name: "PRLHW - Pearl Holdings Acquisition Corp", ticker: "PRLHW" },
    { name: "EVE-WT - EVe Mobility Acquisition Corp", ticker: "EVE-WT" },
    { name: "MAPPF - PROSTAR HOLDINGS INC. /BC", ticker: "MAPPF" },
    { name: "KGEIF - Kolibri Global Energy Inc.", ticker: "KGEIF" },
    { name: "FBPI - FIRST BANCORP OF INDIANA INC", ticker: "FBPI" },
    { name: "TMNA - TINGO, INC.", ticker: "TMNA" },
    { name: "SLTA - Solta Medical Corp", ticker: "SLTA" },
    { name: "ENAC - Endeavor Acquisition Corp.", ticker: "ENAC" },
    { name: "FSRD - Fast Radius, Inc.", ticker: "FSRD" },
    { name: "SKYX - SQL Technologies Corp.", ticker: "SKYX" },
    { name: "BYNO - byNordic Acquisition Corp", ticker: "BYNO" },
    { name: "HNRA - HNR Acquisition Corp.", ticker: "HNRA" },
    { name: "ALEF - Aleph Group, Inc", ticker: "ALEF" },
    { name: "AREN - Arena Group Holdings, Inc.", ticker: "AREN" },
    { name: "EVGR - Evergreen Corp", ticker: "EVGR" },
    { name: "STIX - Alpha Capital Holdco Co", ticker: "STIX" },
    { name: "QNGY - CITIC Capital Acquisition Corp.", ticker: "QNGY" },
    { name: "SHAP-WT - Spree Acquisition Corp. 1 Ltd", ticker: "SHAP-WT" },
    { name: "ADRT-WT - Ault Disruptive Technologies Corp", ticker: "ADRT-WT" },
    { name: "IPWLO - AES CORP", ticker: "IPWLO" },
    { name: "LFLYW - Leafly Holdings, Inc. /DE", ticker: "LFLYW" },
    { name: "USBOV - US BANCORP \\DE\\", ticker: "USBOV" },
    { name: "APCA-WT - AP Acquisition Corp", ticker: "APCA-WT" },
    { name: "EMLDW - FTAC Emerald Acquisition Corp.", ticker: "EMLDW" },
    { name: "FSRDW - Fast Radius, Inc.", ticker: "FSRDW" },
    { name: "LIVBU - LIV Capital Acquisition Corp. II", ticker: "LIVBU" },
    { name: "QNGY-WT - CITIC Capital Acquisition Corp.", ticker: "QNGY-WT" },
    { name: "EVGRU - Evergreen Corp", ticker: "EVGRU" },
    { name: "AREBW - AMERICAN REBEL HOLDINGS INC", ticker: "AREBW" },
    { name: "ATAKU - Aurora Technology Acquisition Corp.", ticker: "ATAKU" },
    { name: "CEADD - CEA Industries Inc.", ticker: "CEADD" },
    { name: "PGFF - Pioneer Green Farms, Inc.", ticker: "PGFF" },
    { name: "RCACW - Revelstone Capital Acquisition Corp.", ticker: "RCACW" },
    { name: "BRCC-WT - BRC Inc.", ticker: "BRCC-WT" },
    { name: "SAGAR - Sagaliam Acquisition Corp", ticker: "SAGAR" },
    { name: "TDCB - THIRD CENTURY BANCORP", ticker: "TDCB" },
    { name: "WOWI - METRO ONE TELECOMMUNICATIONS INC", ticker: "WOWI" },
    { name: "WYTC - WYTEC INTERNATIONAL INC", ticker: "WYTC" },
    { name: "CPTN - Cepton, Inc.", ticker: "CPTN" },
    { name: "EMBC - Embecta Corp.", ticker: "EMBC" },
    { name: "MDV - MODIV INC.", ticker: "MDV" },
    { name: "ISPO - Thayer Ventures Acquisition Corp", ticker: "ISPO" },
    { name: "FEAM - 5E Advanced Materials, Inc.", ticker: "FEAM" },
    { name: "HNRA-UN - HNR Acquisition Corp.", ticker: "HNRA-UN" },
    { name: "CFFSW - CF Acquisition Corp. VII", ticker: "CFFSW" },
    { name: "DRCTW - Direct Digital Holdings, Inc.", ticker: "DRCTW" },
    { name: "RACYU - Relativity Acquisition Corp", ticker: "RACYU" },
    { name: "CPTNW - Cepton, Inc.", ticker: "CPTNW" },
    { name: "LSPRW - Larkspur Health Acquisition Corp.", ticker: "LSPRW" },
    { name: "TCBPW - TC BioPharm (Holdings) plc", ticker: "TCBPW" },
    { name: "AOGOW - Arogo Capital Acquisition Corp.", ticker: "AOGOW" },
    { name: "JGGCU - Jaguar Global Growth Corp I", ticker: "JGGCU" },
    { name: "CEADW - CEA Industries Inc.", ticker: "CEADW" },
    { name: "MDV-PA - MODIV INC.", ticker: "MDV-PA" },
    { name: "NFEI - NEW FRONTIER ENERGY INC", ticker: "NFEI" },
    { name: "KRFG - KING RESOURCES INC", ticker: "KRFG" },
    { name: "ECEC - BCAC Holdings, Inc.", ticker: "ECEC" },
    { name: "NRGV - Energy Vault Holdings, Inc.", ticker: "NRGV" },
    { name: "NRGV-WT - Energy Vault Holdings, Inc.", ticker: "NRGV-WT" },
    { name: "USBOL - US BANCORP \\DE\\", ticker: "USBOL" },
    { name: "XPNGF - XPENG INC.", ticker: "XPNGF" },
    { name: "ISPOW - Thayer Ventures Acquisition Corp", ticker: "ISPOW" },
    { name: "CANBD - Can B Corp", ticker: "CANBD" },
    { name: "IVCPW - Swiftmerge Acquisition Corp.", ticker: "IVCPW" },
    { name: "BWVI - BLUE WATER VENTURES INTERNATIONAL INC", ticker: "BWVI" },
    { name: "QTEK - QualTek Services Inc.", ticker: "QTEK" },
    { name: "SMFL - SMART FOR LIFE, INC.", ticker: "SMFL" },
    { name: "RAF - Resources Acquisition Corp.", ticker: "RAF" },
    { name: "TCGI - Cannaisseur Group Inc.", ticker: "TCGI" },
    { name: "PARA - Paramount Global", ticker: "PARA" },
    { name: "BTOG - China Xiangtai Food Co., Ltd.", ticker: "BTOG" },
    { name: "STRY - Starry Group Holdings, Inc.", ticker: "STRY" },
    { name: "SSSC - Silver Sustainable Solutions Corp.", ticker: "SSSC" },
    { name: "MHUA - Meihua International Medical Technologies Co., Ltd.", ticker: "MHUA" },
    { name: "BLKS - BLACKSTONE PRODUCTS, INC.", ticker: "BLKS" },
    { name: "RBRXF - RHINO BIOTECH Ltd", ticker: "RBRXF" },
    { name: "GZTGF - Gazit-Globe Ltd", ticker: "GZTGF" },
    { name: "PSIQ - Profile Solutions, Inc.", ticker: "PSIQ" },
    { name: "ASCAU - ASPAC I Acquisition Corp.", ticker: "ASCAU" },
    { name: "AXAC-UN - AXIOS Sustainable Growth Acquisition Corp", ticker: "AXAC-UN" },
    { name: "MCLDW - mCloud Technologies Corp.", ticker: "MCLDW" },
    { name: "PWUPU - PowerUp Acquisition Corp.", ticker: "PWUPU" },
    { name: "WBHC - WILSON BANK HOLDING CO", ticker: "WBHC" },
    { name: "SBFMW - Sunshine Biopharma, Inc", ticker: "SBFMW" },
    { name: "PARAA - Paramount Global", ticker: "PARAA" },
    { name: "PARAP - Paramount Global", ticker: "PARAP" },
    { name: "USB-PS - US BANCORP \\DE\\", ticker: "USB-PS" },
    { name: "ONBPP - OLD NATIONAL BANCORP /IN/", ticker: "ONBPP" },
    { name: "ONBPO - OLD NATIONAL BANCORP /IN/", ticker: "ONBPO" },
    { name: "QTEKW - QualTek Services Inc.", ticker: "QTEKW" },
    { name: "FTIIU - Future Tech II Acquisition Corp.", ticker: "FTIIU" },
    { name: "GENQU - Genesis Unicorn Capital Corp.", ticker: "GENQU" },
    { name: "PLHWF - Planet 13 Holdings Inc.", ticker: "PLHWF" },
    { name: "JFBR - Jeffs' Brands Ltd", ticker: "JFBR" },
    { name: "BOC - BOSTON OMAHA Corp", ticker: "BOC" },
    { name: "WLDS - Wearable Devices Ltd.", ticker: "WLDS" },
    { name: "FIGI - Freedom Internet Group Inc.", ticker: "FIGI" },
    { name: "GMFIW - Aetherium Acquisition Corp", ticker: "GMFIW" },
    { name: "DROP - Fuse Science, Inc.", ticker: "DROP" },
    { name: "CMCZ - Curtis Mathes Corp", ticker: "CMCZ" },
    { name: "ESAB - ESAB Corp", ticker: "ESAB" },
    { name: "TAP.A - MOLSON COORS BEVERAGE CO", ticker: "TAP.A" },
    { name: "UERI - Okada Manila International, Inc.", ticker: "UERI" },
    { name: "BMR - Beamr Imaging Ltd.", ticker: "BMR" },
    { name: "GSRM - GSR II Meteora Acquisition Corp.", ticker: "GSRM" },
    { name: "GOSC - Giant Oak Acquisition Corp", ticker: "GOSC" },
    { name: "BRACR - Broad Capital Acquisition Corp", ticker: "BRACR" },
    { name: "AIBBR - AIB Acquisition Corp", ticker: "AIBBR" },
    { name: "OFST - Carbon Streaming Corp", ticker: "OFST" },
    { name: "OFSTF - Carbon Streaming Corp", ticker: "OFSTF" },
    { name: "PNCKD - Galleon Gold Corp.", ticker: "PNCKD" },
    { name: "CLINU - Clean Earth Acquisitions Corp.", ticker: "CLINU" },
    { name: "MYSND - Myson, Inc.", ticker: "MYSND" },
    { name: "HYIV - Haymaker Acquisition Corp. IV", ticker: "HYIV" },
    { name: "FGMC - FG Merger Corp.", ticker: "FGMC" },
    { name: "THER - THERALINK TECHNOLOGIES, INC.", ticker: "THER" },
    { name: "CITEW - Cartica Acquisition Corp", ticker: "CITEW" },
    { name: "FGMCU - FG Merger Corp.", ticker: "FGMCU" },
    { name: "GSRMU - GSR II Meteora Acquisition Corp.", ticker: "GSRMU" },
    { name: "KSSH - Kingfish Holding Corp", ticker: "KSSH" },
    { name: "AMLH - AMERICAN LEISURE HOLDINGS, INC.", ticker: "AMLH" },
    { name: "MKAR - Makara Strategic Acquisition Corp.", ticker: "MKAR" },
    { name: "ZENYF - Zentek Ltd.", ticker: "ZENYF" },
    { name: "BFFTF - Biofrontera AG", ticker: "BFFTF" },
    { name: "SCRMW - Screaming Eagle Acquisition Corp.", ticker: "SCRMW" },
    { name: "EQCDX - Equalize Community Development Fund", ticker: "EQCDX" },
    { name: "POETD - POET TECHNOLOGIES INC.", ticker: "POETD" },
    { name: "CXAC-WT - C5 Acquisition Corp", ticker: "CXAC-WT" },
    { name: "VMCAU - Valuence Merger Corp. I", ticker: "VMCAU" },
    { name: "MSRTD - Greenwave Technology Solutions, Inc.", ticker: "MSRTD" },
    { name: "VBOCW - Viscogliosi Brothers Acquisition Corp", ticker: "VBOCW" },
    { name: "LVCA - Victoria Lake, Inc.", ticker: "LVCA" },
    { name: "RGTI - Rigetti Computing, Inc.", ticker: "RGTI" },
    { name: "SPTY - SPECIFICITY, INC.", ticker: "SPTY" },
    { name: "DECA - Denali Capital Acquisition Corp.", ticker: "DECA" },
    { name: "LGMK - LogicMark, Inc.", ticker: "LGMK" },
    { name: "CHJI - CHINA CHANGJIANG MINING & NEW ENERGY COMPANY, LTD.", ticker: "CHJI" },
    { name: "NNMXD - NANOMIX Corp", ticker: "NNMXD" },
    { name: "RGTIW - Rigetti Computing, Inc.", ticker: "RGTIW" },
    { name: "ACUT - Accustem Sciences Inc.", ticker: "ACUT" },
    { name: "WTII - Water Technologies International,Inc.", ticker: "WTII" },
    { name: "BMNR - BITMINE IMMERSION TECHNOLOGIES, INC.", ticker: "BMNR" },
    { name: "DGC - JR Resources Corp.", ticker: "DGC" },
    { name: "ATGFF - AltaGas Ltd.", ticker: "ATGFF" },
    { name: "ALTGF - AltaGas Ltd.", ticker: "ALTGF" },
    { name: "KCAC-UN - Kensington Capital Acquisition Corp. IV", ticker: "KCAC-UN" },
    { name: "KYCHR - Keyarch Acquisition Corp", ticker: "KYCHR" },
    { name: "KYCHW - Keyarch Acquisition Corp", ticker: "KYCHW" },
    { name: "AFHIQ - Atlas Financial Holdings, Inc.", ticker: "AFHIQ" },
    { name: "EP - EMPIRE PETROLEUM CORP", ticker: "EP" },
    { name: "BFAGY - Biofrontera AG", ticker: "BFAGY" },
    { name: "PPYAW - Papaya Growth Opportunity Corp. I", ticker: "PPYAW" },
    { name: "VCXB-WT - 10X Capital Venture Acquisition Corp. III", ticker: "VCXB-WT" },
    { name: "ITAQW - Industrial Tech Acquisitions II, Inc.", ticker: "ITAQW" },
    { name: "JMSB - John Marshall Bancorp, Inc.", ticker: "JMSB" },
    { name: "BPRN - Princeton Bancorp, Inc.", ticker: "BPRN" },
    { name: "VEDU - Visionary Education Technology Holdings Group Inc.", ticker: "VEDU" },
    { name: "GRFX - Graphex Group Ltd", ticker: "GRFX" },
    { name: "LNNGY - Li Ning Co. Ltd.", ticker: "LNNGY" },
    { name: "ANTX - AN2 Therapeutics, Inc.", ticker: "ANTX" },
    { name: "OKYO - OKYO Pharma Ltd", ticker: "OKYO" },
    { name: "GRFXY - Graphex Group Ltd", ticker: "GRFXY" },
    { name: "CSLMW - Consilium Acquisition Corp I, Ltd.", ticker: "CSLMW" },
    { name: "CSLMR - Consilium Acquisition Corp I, Ltd.", ticker: "CSLMR" },
    { name: "AFHBQ - Atlas Financial Holdings, Inc.", ticker: "AFHBQ" },
    { name: "DRTSW - Alpha Tau Medical Ltd.", ticker: "DRTSW" },
    { name: "ACABW - Atlantic Coastal Acquisition Corp. II", ticker: "ACABW" },
    { name: "GAXYD - GALAXY NEXT GENERATION, INC.", ticker: "GAXYD" },
    { name: "WNNR-WT - Andretti Acquisition Corp.", ticker: "WNNR-WT" },
    { name: "IDR - Idaho Strategic Resources, Inc.", ticker: "IDR" },
    { name: "CMRA - Comera Life Sciences Holdings, Inc.", ticker: "CMRA" },
    { name: "BGTK - BIGtoken, Inc.", ticker: "BGTK" },
    { name: "MGLD - CONCIERGE TECHNOLOGIES INC", ticker: "MGLD" },
    { name: "POET - POET TECHNOLOGIES INC.", ticker: "POET" },
    { name: "BHM - Bluerock Homes Trust, Inc.", ticker: "BHM" },
    { name: "SPRJ - AVRA INC.", ticker: "SPRJ" },
    { name: "PLAO - Patria Latin American Opportunity Acquisition Corp.", ticker: "PLAO" },
    { name: "LNNGF - Li Ning Co. Ltd.", ticker: "LNNGF" },
    { name: "NCMGY - NEWCREST MINING LTD /FI", ticker: "NCMGY" },
    { name: "NCMGF - NEWCREST MINING LTD /FI", ticker: "NCMGF" },
    { name: "EQTNP - Equitrans Midstream Corp", ticker: "EQTNP" },
    { name: "LBBBU - Lakeshore Acquisition II Corp.", ticker: "LBBBU" },
    { name: "SCVXW - SCVX Corp.", ticker: "SCVXW" },
    { name: "SCCE - Sachem Capital Corp.", ticker: "SCCE" },
    { name: "PLAOU - Patria Latin American Opportunity Acquisition Corp.", ticker: "PLAOU" },
    { name: "QSAMD - QSAM Biosciences, Inc.", ticker: "QSAMD" },
    { name: "OTSDS - Otis Gallery LLC", ticker: "OTSDS" },
    { name: "ADOOY - Adaro Energy PT/ADR/", ticker: "ADOOY" },
    { name: "SASDY - SAS AB / ADR", ticker: "SASDY" },
    { name: "QWTR - Quest Water Global, Inc.", ticker: "QWTR" },
    { name: "SMPNY - Sompo Japan Nipponkoa Holdings, Inc./ADR", ticker: "SMPNY" },
    { name: "ECBK - ECB Bancorp, Inc. /MD/", ticker: "ECBK" },
    { name: "RWOD - Redwoods Acquisition Corp.", ticker: "RWOD" },
    { name: "LIVBW - LIV Capital Acquisition Corp. II", ticker: "LIVBW" },
    { name: "ASNBD - EKIMAS Corp", ticker: "ASNBD" },
    { name: "GHIXW - Gores Holdings IX, Inc.", ticker: "GHIXW" },
    { name: "EVTVD - Envirotech Vehicles, Inc.", ticker: "EVTVD" },
    { name: "BYN-WT - Banyan Acquisition Corp", ticker: "BYN-WT" },
    { name: "NUBIU - Nubia Brand International Corp.", ticker: "NUBIU" },
    { name: "TRBMF - TORQ RESOURCES INC.", ticker: "TRBMF" },
    { name: "AURI - AURI INC", ticker: "AURI" },
    { name: "UNA - LUNA INNOVATIONS INC", ticker: "UNA" },
    { name: "DINO - HF Sinclair Corp", ticker: "DINO" },
    { name: "LIFD - LFTD PARTNERS INC.", ticker: "LIFD" },
    { name: "AGXPF - ORO X MINING CORP.", ticker: "AGXPF" },
    { name: "QBTS - D-Wave Quantum Inc.", ticker: "QBTS" },
    { name: "ATA.U - AMERICAS TECHNOLOGY ACQUISITION CORP.", ticker: "ATA.U" },
    { name: "GCTK - Integrity Applications, Inc.", ticker: "GCTK" },
    { name: "CLRC - ClimateRock", ticker: "CLRC" },
    { name: "NHOLF - Sompo Japan Nipponkoa Holdings, Inc./ADR", ticker: "NHOLF" },
    { name: "TKAYF - Just Eat Takeaway.com N.V.", ticker: "TKAYF" },
    { name: "PADEF - Adaro Energy PT/ADR/", ticker: "PADEF" },
    { name: "DUETW - DUET Acquisition Corp.", ticker: "DUETW" },
    { name: "EXMWW - Emmaus Life Sciences, Inc.", ticker: "EXMWW" },
    { name: "KMPB - KEMPER Corp", ticker: "KMPB" },
    { name: "OTSCS - Otis Collection LLC", ticker: "OTSCS" },
    { name: "GAQ-WT - Generation Asia I Acquisition Ltd", ticker: "GAQ-WT" },
    { name: "ENMPD - Ensurge Micropower ASA/ADR", ticker: "ENMPD" },
    { name: "OGSTS - Otis Gallery LLC", ticker: "OGSTS" },
    { name: "HCMAW - HCM Acquisition Corp", ticker: "HCMAW" },
    { name: "APYPD - APPYEA, INC", ticker: "APYPD" },
    { name: "KNSW-WT - KnightSwan Acquisition Corp", ticker: "KNSW-WT" },
    { name: "HMA-WT - Heartland Media Acquisition Corp.", ticker: "HMA-WT" },
    { name: "BLBLF - Bilibili Inc.", ticker: "BLBLF" },
    { name: "GMBLZ - ESPORTS ENTERTAINMENT GROUP, INC.", ticker: "GMBLZ" },
    { name: "JTKWY - Just Eat Takeaway.com N.V.", ticker: "JTKWY" },
    { name: "TETEW - Technology & Telecommunication Acquisition Corp", ticker: "TETEW" },
    { name: "BWAQW - Blue World Acquisition Corp", ticker: "BWAQW" },
    { name: "BWAQR - Blue World Acquisition Corp", ticker: "BWAQR" },
    { name: "LTGHY - Life Healthcare Group Holdings Limited/ADR", ticker: "LTGHY" },
    { name: "ISRL - Israel Acquisitions Corp", ticker: "ISRL" },
    { name: "GNSG - Naples Soap Company, Inc.", ticker: "GNSG" },
    { name: "HMNTY - Hemnet Group AB/ADR", ticker: "HMNTY" },
    { name: "SPFX - STANDARD PREMIUM FINANCE HOLDINGS, INC.", ticker: "SPFX" },
    { name: "VRAX - Virax Biolabs Group Ltd", ticker: "VRAX" },
    { name: "AFAR - Aura Fat Projects Acquisition Corp", ticker: "AFAR" },
    { name: "VSSA - VIKASA SPAC Series I Acquisition Corp.", ticker: "VSSA" },
    { name: "ENMMD - Ensurge Micropower ASA/ADR", ticker: "ENMMD" },
    { name: "STSS - Sharps Technology Inc.", ticker: "STSS" },
    { name: "ZTEK - Zentek Ltd.", ticker: "ZTEK" },
    { name: "LTGHF - Life Healthcare Group Holdings Limited/ADR", ticker: "LTGHF" },
    { name: "ASCAW - ASPAC I Acquisition Corp.", ticker: "ASCAW" },
    { name: "ASCAR - ASPAC I Acquisition Corp.", ticker: "ASCAR" },
    { name: "LATGW - LatAmGrowth SPAC", ticker: "LATGW" },
    { name: "GDSTU - Goldenstone Acquisition Ltd.", ticker: "GDSTU" },
    { name: "ALLG-WT - Allego N.V.", ticker: "ALLG-WT" },
    { name: "HRAAD - HEALTH REVENUE ASSURANCE HOLDINGS, INC.", ticker: "HRAAD" },
    { name: "EGMCD - EMGOLD MINING CORP", ticker: "EGMCD" },
    { name: "CUBT - Curative Biotechnology Inc", ticker: "CUBT" },
    { name: "FBCD - FBC Holding, Inc.", ticker: "FBCD" },
    { name: "GGE - CHINA HGS REAL ESTATE INC.", ticker: "GGE" },
    { name: "TSGN - NAAC Holdco, Inc.", ticker: "TSGN" },
    { name: "YMAT - J-Star Holding Co., Ltd.", ticker: "YMAT" },
    { name: "FRGE - Forge Global Holdings, Inc.", ticker: "FRGE" },
    { name: "ENRFF - Enerflex Ltd.", ticker: "ENRFF" },
    { name: "TRIQD - TRAQIQ, INC.", ticker: "TRIQD" },
    { name: "UCIX - Umbra Companies, Inc.", ticker: "UCIX" },
    { name: "BEESD - JJY Holding Group", ticker: "BEESD" },
    { name: "TZUP - THUMZUP MEDIA Corp", ticker: "TZUP" },
    { name: "FRGE-WT - Forge Global Holdings, Inc.", ticker: "FRGE-WT" },
    { name: "XELAP - Exela Technologies, Inc.", ticker: "XELAP" },
    { name: "ENBGF - ENBRIDGE INC", ticker: "ENBGF" },
    { name: "OGPKS - Otis Gallery LLC", ticker: "OGPKS" },
    { name: "ARMM - ARMM INC.", ticker: "ARMM" },
    { name: "ATAKR - Aurora Technology Acquisition Corp.", ticker: "ATAKR" },
    { name: "ATAKW - Aurora Technology Acquisition Corp.", ticker: "ATAKW" },
    { name: "GWAV - Greenwave Technology Solutions, Inc.", ticker: "GWAV" },
    { name: "MTMT - Mega Matrix Corp.", ticker: "MTMT" },
    { name: "HPCO - Hempacco Co., Inc.", ticker: "HPCO" },
    { name: "TRPCF - Trip.com Group Ltd", ticker: "TRPCF" },
    { name: "RFACU - RF Acquisition Corp.", ticker: "RFACU" },
    { name: "ACAXR - Alset Capital Acquisition Corp.", ticker: "ACAXR" },
    { name: "ACAXW - Alset Capital Acquisition Corp.", ticker: "ACAXW" },
    { name: "AXAC-WT - AXIOS Sustainable Growth Acquisition Corp", ticker: "AXAC-WT" },
    { name: "AXAC-RI - AXIOS Sustainable Growth Acquisition Corp", ticker: "AXAC-RI" },
    { name: "PEGY - Pineapple Holdings, Inc.", ticker: "PEGY" },
    { name: "PERF - Perfect Corp.", ticker: "PERF" },
    { name: "AIMA - Aimfinity Investment Corp. I", ticker: "AIMA" },
    { name: "RVSN - Rail Vision Ltd.", ticker: "RVSN" },
    { name: "LCFYW - Locafy Ltd", ticker: "LCFYW" },
    { name: "OGDMS - Otis Gallery LLC", ticker: "OGDMS" },
    { name: "OGDLS - Otis Gallery LLC", ticker: "OGDLS" },
    { name: "MSSMY - Misumi Group Inc./ADR", ticker: "MSSMY" },
    { name: "CRBG - SAFG Retirement Services, Inc.", ticker: "CRBG" },
    { name: "DC - Dakota Gold Corp.", ticker: "DC" },
    { name: "BGXX - Bright Green Corp", ticker: "BGXX" },
    { name: "IPX - IPERIONX Ltd", ticker: "IPX" },
    { name: "WXT - Wuxin Technology Holdings, Inc.", ticker: "WXT" },
    { name: "LLAP - Terran Orbital Corp", ticker: "LLAP" },
    { name: "GXXY - Agtech Global International Inc", ticker: "GXXY" },
    { name: "ASCB - SPAC II Acquisition Corp.", ticker: "ASCB" },
    { name: "JCSE - JE Cleantech Holdings Ltd", ticker: "JCSE" },
    { name: "STRW - Strawberry Fields REIT, Inc.", ticker: "STRW" },
    { name: "ELEP - Elephant Oil Corp.", ticker: "ELEP" },
    { name: "MSUXF - Misumi Group Inc./ADR", ticker: "MSUXF" },
    { name: "OGMBS - Otis Gallery LLC", ticker: "OGMBS" },
    { name: "STRY-WT - Starry Group Holdings, Inc.", ticker: "STRY-WT" },
    { name: "UVIX - VS Trust", ticker: "UVIX" },
    { name: "RWODU - Redwoods Acquisition Corp.", ticker: "RWODU" },
    { name: "TGR-WT - Kimbell Tiger Acquisition Corp", ticker: "TGR-WT" },
    { name: "LLAP-WT - Terran Orbital Corp", ticker: "LLAP-WT" },
    { name: "MURFW - Murphy Canyon Acquisition Corp.", ticker: "MURFW" },
    { name: "SGHLW - Signal Hill Acquisition Corp.", ticker: "SGHLW" },
    { name: "RVSNW - Rail Vision Ltd.", ticker: "RVSNW" },
    { name: "LNDOS - Landa App LLC", ticker: "LNDOS" },
    { name: "RTSLD - Rapid Therapeutic Science Laboratories, Inc.", ticker: "RTSLD" },
    { name: "ORPHY - Orphazyme A/S", ticker: "ORPHY" },
    { name: "TESLU - 286 Lenox Partners LLC", ticker: "TESLU" },
    { name: "PCRFY - PANASONIC Corp", ticker: "PCRFY" },
    { name: "HLDCY - HENDERSON LAND DEVELOPMENT COMPANY LTD /FI", ticker: "HLDCY" },
    { name: "IVBT - GridIron BioNutrients, Inc.", ticker: "IVBT" },
    { name: "ELGP - Elate Group, Inc.", ticker: "ELGP" },
    { name: "MSSA - Metal Sky Star Acquisition Corp", ticker: "MSSA" },
    { name: "AAGR - African Agriculture, Inc.", ticker: "AAGR" },
    { name: "PMEC - Primech Holdings Ltd", ticker: "PMEC" },
    { name: "CHEA - Chenghe Acquisition Co.", ticker: "CHEA" },
    { name: "GNS - Genius Group Ltd", ticker: "GNS" },
    { name: "NUTX - Nutex Health, Inc.", ticker: "NUTX" },
    { name: "BOUYY - Bouygues SA", ticker: "BOUYY" },
    { name: "XPON - Expion360 Inc.", ticker: "XPON" },
    { name: "BFH - BREAD FINANCIAL HOLDINGS, INC.", ticker: "BFH" },
    { name: "WLY - JOHN WILEY & SONS, INC.", ticker: "WLY" },
    { name: "PCRFF - PANASONIC Corp", ticker: "PCRFF" },
    { name: "MSSAU - Metal Sky Star Acquisition Corp", ticker: "MSSAU" },
    { name: "MTB-PH - M&T BANK CORP", ticker: "MTB-PH" },
    { name: "RACYW - Relativity Acquisition Corp", ticker: "RACYW" },
    { name: "EVGRW - Evergreen Corp", ticker: "EVGRW" },
    { name: "JGGCR - Jaguar Global Growth Corp I", ticker: "JGGCR" },
    { name: "JGGCW - Jaguar Global Growth Corp I", ticker: "JGGCW" },
    { name: "GMBTU - Swvl Holdings Corp", ticker: "GMBTU" },
    { name: "SWVLW - Swvl Holdings Corp", ticker: "SWVLW" },
    { name: "FRMEP - FIRST MERCHANTS CORP", ticker: "FRMEP" },
    { name: "WLYB - JOHN WILEY & SONS, INC.", ticker: "WLYB" },
    { name: "IVDAW - Iveda Solutions, Inc.", ticker: "IVDAW" },
    { name: "BASWQ - BASIC ENERGY SERVICES, INC.", ticker: "BASWQ" },
    { name: "CPAQW - Counter Press Acquisition Corp", ticker: "CPAQW" },
    { name: "GWSND - Gulf West Security Network, Inc.", ticker: "GWSND" },
    { name: "CBCA - Crown Baus Capital Corp.", ticker: "CBCA" },
    { name: "ACMB - AGRO CAPITAL MANAGEMENT CORP.", ticker: "ACMB" },
    { name: "SNWR - Sanwire Corp", ticker: "SNWR" },
    { name: "HLVX - HilleVax, Inc.", ticker: "HLVX" },
    { name: "RVIC - Retail Value Inc.", ticker: "RVIC" },
    { name: "LAB - STANDARD BIOTOOLS INC.", ticker: "LAB" },
    { name: "MLTX - MoonLake Immunotherapeutics", ticker: "MLTX" },
    { name: "ENOV - Enovis CORP", ticker: "ENOV" },
    { name: "BLTE - BELITE BIO, INC", ticker: "BLTE" },
    { name: "HLDVF - HENDERSON LAND DEVELOPMENT COMPANY LTD /FI", ticker: "HLDVF" },
    { name: "BOUYF - Bouygues SA", ticker: "BOUYF" },
    { name: "ETHOD - Ethos Gold Corp.", ticker: "ETHOD" },
    { name: "SEAL-PA - Seapeak LLC", ticker: "SEAL-PA" },
    { name: "SEAL-PB - Seapeak LLC", ticker: "SEAL-PB" },
    { name: "BYNOW - byNordic Acquisition Corp", ticker: "BYNOW" },
    { name: "DECAU - Denali Capital Acquisition Corp.", ticker: "DECAU" },
    { name: "OGDBS - Otis Gallery LLC", ticker: "OGDBS" },
    { name: "GGROW - Gogoro Inc.", ticker: "GGROW" },
    { name: "GENQW - Genesis Unicorn Capital Corp.", ticker: "GENQW" },
    { name: "AOIXD - NFiniTi inc.", ticker: "AOIXD" },
    { name: "HNRA-WT - HNR Acquisition Corp.", ticker: "HNRA-WT" },
    { name: "RSTN - RDE, Inc.", ticker: "RSTN" },
    { name: "CIPI - TRICCAR INC.", ticker: "CIPI" },
    { name: "DSRO - Descrypto Holdings, Inc.", ticker: "DSRO" },
    { name: "PGY - Pagaya Technologies Ltd.", ticker: "PGY" },
    { name: "ONFO - Onfolio Holdings, Inc", ticker: "ONFO" },
    { name: "LAIXY - LAIX Inc.", ticker: "LAIXY" },
    { name: "WBD - Warner Bros. Discovery, Inc.", ticker: "WBD" },
    { name: "EVGDF - ELEVATION GOLD MINING Corp", ticker: "EVGDF" },
    { name: "ZLME - Zhanling International Ltd", ticker: "ZLME" },
    { name: "SGE - Strong Global Entertainment, Inc", ticker: "SGE" },
    { name: "INRX - Intrinsic Medicine, Inc.", ticker: "INRX" },
    { name: "WAVSW - Western Acquisition Ventures Corp.", ticker: "WAVSW" },
    { name: "OTSRS - Otis Gallery LLC", ticker: "OTSRS" },
    { name: "PWUPW - PowerUp Acquisition Corp.", ticker: "PWUPW" },
    { name: "FTIIW - FutureTech II Acquisition Corp.", ticker: "FTIIW" },
    { name: "VXELD - HWGC Holdings Ltd", ticker: "VXELD" },
    { name: "WOPEY - WOODSIDE PETROLEUM LTD", ticker: "WOPEY" },
    { name: "VHLD - VECTOR 21 HOLDINGS, INC.", ticker: "VHLD" },
    { name: "MAIA - MAIA Biotechnology, Inc.", ticker: "MAIA" },
    { name: "AGSS - AMERIGUARD SECURITY SERVICES, INC.", ticker: "AGSS" },
    { name: "STEK - Stemtech Corp", ticker: "STEK" },
    { name: "FLFV - Feutune Light Acquisition Corp", ticker: "FLFV" },
    { name: "WOPEF - WOODSIDE PETROLEUM LTD", ticker: "WOPEF" },
    { name: "NTVMF - ELEVATION GOLD MINING Corp", ticker: "NTVMF" },
    { name: "TRLEF - Trillion Energy International Inc.", ticker: "TRLEF" },
    { name: "AFARU - Aura Fat Projects Acquisition Corp", ticker: "AFARU" },
    { name: "WDS - WOODSIDE PETROLEUM LTD", ticker: "WDS" },
    { name: "DZGH - JJY Holding Group", ticker: "DZGH" },
    { name: "LBBBW - Lakeshore Acquisition II Corp.", ticker: "LBBBW" },
    { name: "LBBBR - Lakeshore Acquisition II Corp.", ticker: "LBBBR" },
    { name: "GDSTR - Goldenstone Acquisition Ltd.", ticker: "GDSTR" },
    { name: "GDSTW - Goldenstone Acquisition Ltd.", ticker: "GDSTW" },
    { name: "STSSW - Sharps Technology Inc.", ticker: "STSSW" },
    { name: "UBEOY - Ube Industries Ltd", ticker: "UBEOY" },
    { name: "STWY - Steinway Musical Instruments Holdings, Inc.", ticker: "STWY" },
    { name: "ELBM - Electra Battery Materials Corp", ticker: "ELBM" },
    { name: "IHCPF - Inchcape plc/ADR", ticker: "IHCPF" },
    { name: "SYMB - Symbolic Logic, Inc.", ticker: "SYMB" },
    { name: "ASNS - ACTELIS NETWORKS INC", ticker: "ASNS" },
    { name: "NOAV - NanoVibronix, Inc.", ticker: "NOAV" },
    { name: "BGAC - Biotech Group Acquisition Corp", ticker: "BGAC" },
    { name: "PEPG - PepGen Inc.", ticker: "PEPG" },
    { name: "OXEA - Oxeia Biopharmaceuticals, Inc.", ticker: "OXEA" },
    { name: "ASPP - Abri SPAC 2, Inc.", ticker: "ASPP" },
    { name: "CLINW - Clean Earth Acquisitions Corp.", ticker: "CLINW" },
    { name: "CLINR - Clean Earth Acquisitions Corp.", ticker: "CLINR" },
    { name: "OTCBS - Otis Collection LLC", ticker: "OTCBS" },
    { name: "OTGLS - Otis Gallery LLC", ticker: "OTGLS" },
    { name: "OTSUS - Otis Gallery LLC", ticker: "OTSUS" },
    { name: "GSRMW - GSR II Meteora Acquisition Corp.", ticker: "GSRMW" },
    { name: "GSRMR - GSR II Meteora Acquisition Corp.", ticker: "GSRMR" },
    { name: "TLLTF - TILT Holdings Inc.", ticker: "TLLTF" },
    { name: "SILS - SILVER SCOTT MINES INC", ticker: "SILS" },
    { name: "YOTA - Yotta Acquisition Corp", ticker: "YOTA" },
    { name: "KAL - Kalera Public Ltd Co", ticker: "KAL" },
    { name: "GBBK - Global Blockchain Acquisition Corp.", ticker: "GBBK" },
    { name: "BNRG - Brenmiller Energy Ltd.", ticker: "BNRG" },
    { name: "LRHC - La Rosa Holdings Corp.", ticker: "LRHC" },
    { name: "ASFH - ASIAFIN HOLDINGS CORP.", ticker: "ASFH" },
    { name: "SAUHD - Straumann Holding AG / ADR", ticker: "SAUHD" },
    { name: "UBEOF - Ube Industries Ltd", ticker: "UBEOF" },
    { name: "RFACW - RF Acquisition Corp.", ticker: "RFACW" },
    { name: "RFACR - RF Acquisition Corp.", ticker: "RFACR" },
    { name: "YOTAU - Yotta Acquisition Corp", ticker: "YOTAU" },
    { name: "FGMCW - FG Merger Corp.", ticker: "FGMCW" },
    { name: "VMCAW - Valuence Merger Corp. I", ticker: "VMCAW" },
    { name: "SPCMW - Sound Point Acquisition Corp I, Ltd", ticker: "SPCMW" },
    { name: "SHUAW - SHUAA Partners Acquisition Corp I", ticker: "SHUAW" },
    { name: "OGGCS - Otis Collection LLC", ticker: "OGGCS" },
    { name: "OTMES - Otis Collection LLC", ticker: "OTMES" },
    { name: "ACONW - Aclarion, Inc.", ticker: "ACONW" },
    { name: "DODRW - DIAMOND OFFSHORE DRILLING, INC.", ticker: "DODRW" },
    { name: "LIFX - Life360, Inc.", ticker: "LIFX" },
    { name: "MCAC - Monterey Capital Acquisition Corp", ticker: "MCAC" },
    { name: "NLSC - Kreido Biofuels, Inc.", ticker: "NLSC" },
    { name: "HOTI - Hemoglobin Oxygen Therapeutics LLC", ticker: "HOTI" },
    { name: "TNON - Tenon Medical, Inc.", ticker: "TNON" },
    { name: "SOUN - SoundHound AI, Inc.", ticker: "SOUN" },
    { name: "ZTOP - Zi Toprun Acquisition Corp.", ticker: "ZTOP" },
    { name: "AKO.A - ANDINA BOTTLING CO INC", ticker: "AKO.A" },
    { name: "FGLD - Franklin Templeton Holdings Trust", ticker: "FGLD" },
    { name: "BIAF - bioAffinity Technologies, Inc.", ticker: "BIAF" },
    { name: "WEST - Westrock Coffee Holdings, LLC", ticker: "WEST" },
    { name: "SMST - SmartStop Self Storage REIT, Inc.", ticker: "SMST" },
    { name: "UNTCW - UNIT CORP", ticker: "UNTCW" },
    { name: "FTAIO - Fortress Transportation & Infrastructure Investors LLC", ticker: "FTAIO" },
    { name: "FTAIN - Fortress Transportation & Infrastructure Investors LLC", ticker: "FTAIN" },
    { name: "FTAIP - Fortress Transportation & Infrastructure Investors LLC", ticker: "FTAIP" },
    { name: "AIMAU - Aimfinity Investment Corp. I", ticker: "AIMAU" },
    { name: "ONMD - Data Knights Acquisition Corp.", ticker: "ONMD" },
    { name: "TWOHD - Two Hands Corp", ticker: "TWOHD" },
    { name: "MMDWF - Mind Medicine (MindMed) Inc.", ticker: "MMDWF" },
    { name: "KCA-UN - Kensington Capital Acquisition Corp. IV", ticker: "KCA-UN" },
    { name: "LNDKS - Landa App LLC", ticker: "LNDKS" },
    { name: "LNDFS - Landa App LLC", ticker: "LNDFS" },
    { name: "JRONY - Jeronimo Martins SGPS SA", ticker: "JRONY" },
    { name: "GWGHQ - GWG Holdings, Inc.", ticker: "GWGHQ" },
    { name: "RIT - RODIN INCOME TRUST, INC.", ticker: "RIT" },
    { name: "MHHC - MHHC Enterprises Inc.", ticker: "MHHC" },
    { name: "LNW - Light & Wonder, Inc.", ticker: "LNW" },
    { name: "BBRWD - BrewBilt Manufacturing Inc.", ticker: "BBRWD" },
    { name: "CHEAU - Chenghe Acquisition Co.", ticker: "CHEAU" },
    { name: "RWODW - Redwoods Acquisition Corp.", ticker: "RWODW" },
    { name: "INVUP - Investview, Inc.", ticker: "INVUP" },
    { name: "CLRCU - ClimateRock", ticker: "CLRCU" },
    { name: "SOBRD - SOBR Safe, Inc.", ticker: "SOBRD" },
    { name: "SOUNW - Archimedes Tech Spac Partners Co", ticker: "SOUNW" },
    { name: "AZPN - Aspen Technology, Inc.", ticker: "AZPN" },
    { name: "QDEL - QuidelOrtho Corp", ticker: "QDEL" },
    { name: "EENEY - Electrocomponents plc / ADR", ticker: "EENEY" },
    { name: "DKNG - DraftKings Inc.", ticker: "DKNG" },
    { name: "DFIHY - DAIRY FARM INTERNATIONAL HOLDINGS LTD /FI", ticker: "DFIHY" },
    { name: "NFTN - NFiniTi inc.", ticker: "NFTN" },
    { name: "NIC - NICOLET BANKSHARES INC", ticker: "NIC" },
    { name: "GBTG - Global Business Travel Group, Inc.", ticker: "GBTG" },
    { name: "SMR - NUSCALE POWER Corp", ticker: "SMR" },
    { name: "LSAK - NET 1 UEPS TECHNOLOGIES INC", ticker: "LSAK" },
    { name: "CFNB - CALIFORNIA FIRST LEASING Corp", ticker: "CFNB" },
    { name: "BIOR - BIORA THERAPEUTICS, INC.", ticker: "BIOR" },
    { name: "HNVR - Hanover Bancorp, Inc. /NY", ticker: "HNVR" },
    { name: "SAI - SAI.TECH Global Corp", ticker: "SAI" },
    { name: "NHWK - NightHawk Biosciences, Inc.", ticker: "NHWK" },
    { name: "AIU - Meta Data Ltd", ticker: "AIU" },
    { name: "TETAA - Teton Advisors, Inc.", ticker: "TETAA" },
    { name: "MSPR - MSP Recovery, Inc.", ticker: "MSPR" },
    { name: "GEHI - RYB Education, Inc.", ticker: "GEHI" },
    { name: "CATG - Capstone Technologies Group Inc.", ticker: "CATG" },
    { name: "NEWYY - Puxin Ltd", ticker: "NEWYY" },
    { name: "HWGC - HWGC Holdings Ltd", ticker: "HWGC" },
    { name: "MICS - SINGING MACHINE CO INC", ticker: "MICS" },
    { name: "RYTTF - Royalty North Partners Ltd.", ticker: "RYTTF" },
    { name: "IOGPQ - ION GEOPHYSICAL CORP", ticker: "IOGPQ" },
    { name: "TEVNF - Tevano Systems Holdings Inc.", ticker: "TEVNF" },
    { name: "CTKYY - CooTek(Cayman)Inc.", ticker: "CTKYY" },
    { name: "HALB - Halberd Corp", ticker: "HALB" },
    { name: "ECGI - ECGI Holdings, Inc.", ticker: "ECGI" },
    { name: "SNHO - SHONGHOYA INTERNATIONAL GROUP INC.", ticker: "SNHO" },
    { name: "PCMC - PUBLIC CO MANAGEMENT CORP", ticker: "PCMC" },
    { name: "BLFE - BioLIfe Sciences Inc", ticker: "BLFE" },
    { name: "MSOF - MULTI SOFT II, INC", ticker: "MSOF" },
    { name: "SVRE - SaverOne 2014 Ltd.", ticker: "SVRE" },
    { name: "SKGR - SK Growth Opportunities Corp", ticker: "SKGR" },
    { name: "HYPB - Hypebeast Ltd", ticker: "HYPB" },
    { name: "DXYZ - Destiny Tech100 Inc.", ticker: "DXYZ" },
    { name: "MDL - Medallion Resources Ltd", ticker: "MDL" },
    { name: "AFIIQ - Armstrong Flooring, Inc.", ticker: "AFIIQ" },
    { name: "EVEX - Eve Holding, Inc.", ticker: "EVEX" },
    { name: "IONR - ioneer Ltd", ticker: "IONR" },
    { name: "INTR - Inter & Co, Inc.", ticker: "INTR" },
    { name: "MOBV - Mobiv Acquisition Corp", ticker: "MOBV" },
    { name: "GLNK - Grayscale Chainlink Trust (LINK)", ticker: "GLNK" },
    { name: "BLAC - Bellevue Life Sciences Acquisition Corp.", ticker: "BLAC" },
    { name: "GXLM - Grayscale Stellar Lumens Trust (XLM)", ticker: "GXLM" },
    { name: "QSP - Restaurant Brands International Limited Partnership", ticker: "QSP" },
    { name: "ARIR - ARES INDUSTRIAL REAL ESTATE INCOME TRUST Inc.", ticker: "ARIR" },
    { name: "GRNT - Granite Ridge Resources, Inc.", ticker: "GRNT" },
    { name: "JEWL - Adamas One Corp.", ticker: "JEWL" },
    { name: "DSGR - Distribution Solutions Group, Inc.", ticker: "DSGR" },
    { name: "CVUA - CPI AEROSTRUCTURES INC", ticker: "CVUA" },
    { name: "RAPH - Raphael Pharmaceutical Inc.", ticker: "RAPH" },
    { name: "MVCO - WATERSIDE CAPITAL CORP", ticker: "MVCO" },
    { name: "BOUW - Boustead Wavefront Inc.", ticker: "BOUW" },
    { name: "KGEID - Kolibri Global Energy Inc.", ticker: "KGEID" },
    { name: "BALL - BALL Corp", ticker: "BALL" },
    { name: "FP - First Person Ltd.", ticker: "FP" },
    { name: "MEGL - Magic Empire Global Ltd", ticker: "MEGL" },
    { name: "ARAG - Arago Acquisition Corp.", ticker: "ARAG" },
    { name: "HLN - Haleon plc", ticker: "HLN" },
    { name: "CDMNF - Canadian Manganese Co Inc.", ticker: "CDMNF" },
    { name: "FILG - Grayscale Filecoin Trust (FIL)", ticker: "FILG" },
    { name: "IAUX - i-80 Gold Corp.", ticker: "IAUX" },
    { name: "SHPH - Shuttle Pharmaceuticals Holdings, Inc.", ticker: "SHPH" },
    { name: "WEIDY - Weidai Ltd.", ticker: "WEIDY" },
    { name: "HUDA - Hudson Acquisition I Corp.", ticker: "HUDA" },
    { name: "GBAT - Grayscale Basic Attention Token Trust (BAT)", ticker: "GBAT" },
    { name: "CEAC - CE Energy Acquisition Corp.", ticker: "CEAC" },
    { name: "IE - Ivanhoe Electric Inc.", ticker: "IE" },
    { name: "HZEN - Grayscale Horizen Trust (ZEN)", ticker: "HZEN" },
    { name: "BTMD - biote Corp.", ticker: "BTMD" },
    { name: "CBLO - C2 Blockchain,Inc.", ticker: "CBLO" },
    { name: "NASO - Naples Soap Company, Inc.", ticker: "NASO" },
    { name: "FIP - FTAI Infrastructure LLC", ticker: "FIP" },
    { name: "MPTI - M-tron Industries, Inc.", ticker: "MPTI" },
    { name: "EMCG - Embrace Change Acquisition Corp.", ticker: "EMCG" },
    { name: "BCAN - BYND CANNASOFT ENTERPRISES INC.", ticker: "BCAN" },
    { name: "EZAGOO - Ezagoo Ltd", ticker: "EZAGOO" },
    { name: "EHAB - Enhabit, Inc.", ticker: "EHAB" },
    { name: "SASI - SIGMA LABS, INC.", ticker: "SASI" },
    { name: "AWYS - Awaysis Capital, Inc.", ticker: "AWYS" },
    { name: "CNXA - Connexa Sports Technologies Inc.", ticker: "CNXA" },
    { name: "PRZO - ParaZero Technologies Ltd.", ticker: "PRZO" },
    { name: "LICN - Lichen China Ltd", ticker: "LICN" },
    { name: "BEEP - Mobile Infrastructure Trust", ticker: "BEEP" },
    { name: "AQU - Aquaron Acquisition Corp.", ticker: "AQU" },
    { name: "ZCSH - Grayscale Zcash Trust (ZEC)", ticker: "ZCSH" },
    { name: "ESH - ESH Acquisition Corp.", ticker: "ESH" },
    { name: "HSCS - Heart Test Laboratories, Inc.", ticker: "HSCS" },
    { name: "NYX - NYIAX, INC.", ticker: "NYX" },
    { name: "FRGT - Hudson Capital Inc.", ticker: "FRGT" },
    { name: "NEAT - Noble Education Acquisition Corp.", ticker: "NEAT" },
    { name: "MARX - Mars Acquisition Corp.", ticker: "MARX" },
    { name: "JRONF - Jeronimo Martins SGPS SA", ticker: "JRONF" },
    { name: "EENEF - Electrocomponents plc / ADR", ticker: "EENEF" },
    { name: "ATLLF - ATLAS COPCO AB", ticker: "ATLLF" },
    { name: "DFILF - DAIRY FARM INTERNATIONAL HOLDINGS LTD /FI", ticker: "DFILF" },
    { name: "PXPC - Phoenix Plus Corp.", ticker: "PXPC" },
    { name: "AWCA - Awaysis Capital, Inc.", ticker: "AWCA" },
    { name: "CNBXD - CNBX Pharmaceuticals Inc.", ticker: "CNBXD" },
    { name: "MLLOF - Medallion Resources Ltd", ticker: "MLLOF" },
    { name: "NLABD - NUONCOLOGY LABS INC", ticker: "NLABD" },
    { name: "CELPQ - Cypress Environmental Partners, L.P.", ticker: "CELPQ" },
    { name: "AMIHD - AMERICAN INTERNATIONAL HOLDINGS CORP.", ticker: "AMIHD" },
    { name: "SVREW - SaverOne 2014 Ltd.", ticker: "SVREW" },
    { name: "MCLE - Medicale Corp.", ticker: "MCLE" },
    { name: "RNGTD - Osisko Development Corp.", ticker: "RNGTD" },
    { name: "MSPRW - MSP Recovery, Inc.", ticker: "MSPRW" },
    { name: "MSPRZ - MSP Recovery, Inc.", ticker: "MSPRZ" },
    { name: "MMDCF - Mind Medicine (MindMed) Inc.", ticker: "MMDCF" },
    { name: "MMCWF - Mind Medicine (MindMed) Inc.", ticker: "MMCWF" },
    { name: "SCDL - UBS AG", ticker: "SCDL" },
    { name: "PLAOW - Patria Latin American Opportunity Acquisition Corp.", ticker: "PLAOW" },
    { name: "SGLAD - Sino Green Land Corp.", ticker: "SGLAD" },
    { name: "SFUNY - Fang Holdings Ltd", ticker: "SFUNY" },
    { name: "EVEX-WT - Eve Holding, Inc.", ticker: "EVEX-WT" },
    { name: "MCACU - Monterey Capital Acquisition Corp", ticker: "MCACU" },
    { name: "PRMFF - Perimeter Solutions, SA", ticker: "PRMFF" },
    { name: "AFARW - Aura Fat Projects Acquisition Corp", ticker: "AFARW" },
    { name: "CMRAW - Comera Life Sciences Holdings, Inc.", ticker: "CMRAW" },
    { name: "ASCBU - SPAC II Acquisition Corp.", ticker: "ASCBU" },
    { name: "ASCBW - SPAC II Acquisition Corp.", ticker: "ASCBW" },
    { name: "ASCBR - SPAC II Acquisition Corp.", ticker: "ASCBR" },
    { name: "PNACU - Prime Number Acquisition I Corp.", ticker: "PNACU" },
    { name: "FLRAP - FLUOR CORP", ticker: "FLRAP" },
    { name: "MSSAR - Metal Sky Star Acquisition Corp", ticker: "MSSAR" },
    { name: "MSSAW - Metal Sky Star Acquisition Corp", ticker: "MSSAW" },
    { name: "NUBIW - Nubia Brand International Corp.", ticker: "NUBIW" },
    { name: "FNGS - BANK OF MONTREAL /CAN/", ticker: "FNGS" },
    { name: "FNGO - BANK OF MONTREAL /CAN/", ticker: "FNGO" },
    { name: "LNDHS - Landa App LLC", ticker: "LNDHS" },
    { name: "FLESD - Auto Parts 4Less Group, Inc.", ticker: "FLESD" },
    { name: "ATLRF - ATLAS COPCO AB", ticker: "ATLRF" },
    { name: "PRENW - Prenetics Global Ltd", ticker: "PRENW" },
    { name: "SMR-WT - NUSCALE POWER Corp", ticker: "SMR-WT" },
    { name: "RENEU - Cartesian Growth Corp II", ticker: "RENEU" },
    { name: "GBTG-WT - Global Business Travel Group, Inc.", ticker: "GBTG-WT" },
    { name: "RWODR - Redwoods Acquisition Corp.", ticker: "RWODR" },
    { name: "KCAC-WT - Kensington Capital Acquisition Corp. IV", ticker: "KCAC-WT" },
    { name: "TIGOR - MILLICOM INTERNATIONAL CELLULAR SA", ticker: "TIGOR" },
    { name: "SAITW - SAI.TECH Global Corp", ticker: "SAITW" },
    { name: "SAT - SARATOGA INVESTMENT CORP.", ticker: "SAT" },
    { name: "SCCF - Sachem Capital Corp.", ticker: "SCCF" },
    { name: "BTMDW - biote Corp.", ticker: "BTMDW" },
    { name: "GIREX - Apollo Diversified Real Estate Fund", ticker: "GIREX" },
    { name: "EDBLW - Edible Garden AG Inc", ticker: "EDBLW" },
    { name: "CLRCR - ClimateRock", ticker: "CLRCR" },
    { name: "CLRCW - ClimateRock", ticker: "CLRCW" },
    { name: "RJF-PB - RAYMOND JAMES FINANCIAL INC", ticker: "RJF-PB" },
    { name: "RJF-PA - RAYMOND JAMES FINANCIAL INC", ticker: "RJF-PA" },
    { name: "DECAW - Denali Capital Acquisition Corp.", ticker: "DECAW" },
    { name: "IVCAU - Investcorp India Acquisition Corp", ticker: "IVCAU" },
    { name: "EMWP - Eros STX Global Corp", ticker: "EMWP" },
    { name: "META - Meta Platforms, Inc.", ticker: "META" },
    { name: "STR - Sitio Royalties Corp.", ticker: "STR" },
    { name: "HOUS - REALOGY HOLDINGS CORP.", ticker: "HOUS" },
    { name: "SYM - SVF Investment Corp. 3", ticker: "SYM" },
    { name: "RTO - RENTOKIL INITIAL PLC /FI", ticker: "RTO" },
    { name: "USEA - United Maritime Corp", ticker: "USEA" },
    { name: "RKLIF - RENTOKIL INITIAL PLC /FI", ticker: "RKLIF" },
    { name: "RTOKY - RENTOKIL INITIAL PLC /FI", ticker: "RTOKY" },
    { name: "IGEX - Indo Global Exchange(s) Pte, Ltd.", ticker: "IGEX" },
    { name: "ADXSD - Advaxis, Inc.", ticker: "ADXSD" },
    { name: "SAPMD - SAIPEM S P A /FI", ticker: "SAPMD" },
    { name: "TIHE - NUONCOLOGY LABS INC", ticker: "TIHE" },
    { name: "STRDW - Sitio Royalties Corp.", ticker: "STRDW" },
    { name: "NILE-PD - BitNile Holdings, Inc.", ticker: "NILE-PD" },
    { name: "CPPTL - Copper Property CTL Pass Through Trust", ticker: "CPPTL" },
    { name: "PACWP - PACWEST BANCORP", ticker: "PACWP" },
    { name: "CSLLY - CSL LTD", ticker: "CSLLY" },
    { name: "ATEYY - ADVANTEST CORP", ticker: "ATEYY" },
    { name: "MTLHY - Mitsubishi Chemical Holdings Corp", ticker: "MTLHY" },
    { name: "ACAC - Acri Capital Acquisition Corp", ticker: "ACAC" },
    { name: "CMHF - Community Heritage Financial, Inc.", ticker: "CMHF" },
    { name: "LXXGF - LexaGene Holdings Inc.", ticker: "LXXGF" },
    { name: "RSHN - RushNet, Inc.", ticker: "RSHN" },
    { name: "OILCF - Permex Petroleum Corp", ticker: "OILCF" },
    { name: "GRLF - GREEN LEAF INNOVATIONS INC", ticker: "GRLF" },
    { name: "CADMF - Chemesis International Inc.", ticker: "CADMF" },
    { name: "SSOF - Sixty Six Oilfield Services, Inc.", ticker: "SSOF" },
    { name: "WKLN - MainStreetChamber Holdings, Inc.", ticker: "WKLN" },
    { name: "WRNT - WARRANTEE INC.", ticker: "WRNT" },
    { name: "GOLQ - GoLogiq, Inc.", ticker: "GOLQ" },
    { name: "MNKPF - Mallinckrodt plc", ticker: "MNKPF" },
    { name: "BETR - BetterLife Pharma Inc.", ticker: "BETR" },
    { name: "OMED - OptMed, Inc.", ticker: "OMED" },
    { name: "ELMSQ - Electric Last Mile Solutions, Inc.", ticker: "ELMSQ" },
    { name: "ICG - Intchains Group Ltd", ticker: "ICG" },
    { name: "GROV - Grove Collaborative Holdings, Inc.", ticker: "GROV" },
    { name: "WNFT - GOFF, CORP", ticker: "WNFT" },
    { name: "ACRG - Standard Metals Processing, Inc.", ticker: "ACRG" },
    { name: "BRSH - Bruush Oral Care Inc.", ticker: "BRSH" },
    { name: "WLGS - WANG & LEE GROUP, Inc.", ticker: "WLGS" },
    { name: "SBIG - SpringBig Holdings, Inc.", ticker: "SBIG" },
    { name: "GEMZ - Gemxx Corp.", ticker: "GEMZ" },
    { name: "HLCO - Healing Co Inc.", ticker: "HLCO" },
    { name: "NAAS - NaaS Technology Inc.", ticker: "NAAS" },
    { name: "TBMCU - Trailblazer Merger Corp I", ticker: "TBMCU" },
    { name: "OSA - LAAA Merger Corp.", ticker: "OSA" },
    { name: "ALEH - ALE Group Holding Ltd", ticker: "ALEH" },
    { name: "EGIO - Edgio, Inc.", ticker: "EGIO" },
    { name: "GNLX - GENELUX CORP", ticker: "GNLX" },
    { name: "SOV - Santander Holdings USA, Inc.", ticker: "SOV" },
    { name: "TEVND - Tevano Systems Holdings Inc.", ticker: "TEVND" },
    { name: "NA - Nano Labs Ltd", ticker: "NA" },
    { name: "ZSANQ - Zosano Pharma Corp", ticker: "ZSANQ" },
    { name: "PMN - ProMIS Neurosciences Inc.", ticker: "PMN" },
    { name: "MOB - Mobilicom Ltd", ticker: "MOB" },
    { name: "DSPK - Dorchester Capital Acquisition Corp.", ticker: "DSPK" },
    { name: "SNTI - Senti Biosciences, Inc.", ticker: "SNTI" },
    { name: "BZWR - Business Warrior Corp", ticker: "BZWR" },
    { name: "MDLVY - Medlive Technology Co., Ltd./ADR", ticker: "MDLVY" },
    { name: "ELV - Elevance Health, Inc.", ticker: "ELV" },
    { name: "SIMPQ - Simply, Inc.", ticker: "SIMPQ" },
    { name: "CHRD - Oasis Petroleum Inc.", ticker: "CHRD" },
    { name: "SFCO - Southern Financial Corp", ticker: "SFCO" },
    { name: "CMXHF - CSL LTD", ticker: "CMXHF" },
    { name: "ADTTF - ADVANTEST CORP", ticker: "ADTTF" },
    { name: "MTLHF - Mitsubishi Chemical Holdings Corp", ticker: "MTLHF" },
    { name: "GWIN - GLORYWIN ENTERTAINMENT GROUP, INC.", ticker: "GWIN" },
    { name: "VOXCF - Vox Royalty Corp.", ticker: "VOXCF" },
    { name: "TAOFF - IPERIONX Ltd", ticker: "TAOFF" },
    { name: "ARFXF - ProMIS Neurosciences Inc.", ticker: "ARFXF" },
    { name: "ALVOW - Alvotech", ticker: "ALVOW" },
    { name: "GROV-WT - Grove Collaborative Holdings, Inc.", ticker: "GROV-WT" },
    { name: "HTFC - Horizon Technology Finance Corp", ticker: "HTFC" },
    { name: "KALWW - Kalera Public Ltd Co", ticker: "KALWW" },
    { name: "WECTD - Motos America, Inc.", ticker: "WECTD" },
    { name: "SBIGW - SpringBig Holdings, Inc.", ticker: "SBIGW" },
    { name: "RSLPS - RSE Archive, LLC", ticker: "RSLPS" },
    { name: "RSSKS - RSE Archive, LLC", ticker: "RSSKS" },
    { name: "LNDPS - Landa App LLC", ticker: "LNDPS" },
    { name: "LDSUS - Landa App LLC", ticker: "LDSUS" },
    { name: "CADMD - Chemesis International Inc.", ticker: "CADMD" },
    { name: "TMGID - Marquie Group, Inc.", ticker: "TMGID" },
    { name: "JRVSD - iMine Corp", ticker: "JRVSD" },
    { name: "PSNYW - Polestar Automotive Holding UK PLC", ticker: "PSNYW" },
    { name: "FLYD - BANK OF MONTREAL /CAN/", ticker: "FLYD" },
    { name: "FLYU - BANK OF MONTREAL /CAN/", ticker: "FLYU" },
    { name: "SKGRU - SK Growth Opportunities Corp", ticker: "SKGRU" },
    { name: "TETAR - Teton Advisors, Inc.", ticker: "TETAR" },
    { name: "YOTAR - Yotta Acquisition Corp", ticker: "YOTAR" },
    { name: "YOTAW - Yotta Acquisition Corp", ticker: "YOTAW" },
    { name: "SEATW - Vivid Seats Inc.", ticker: "SEATW" },
    { name: "DTIID - DEFENSE TECHNOLOGIES INTERNATIONAL CORP.", ticker: "DTIID" },
    { name: "ARFXD - ProMIS Neurosciences Inc.", ticker: "ARFXD" },
    { name: "HSCSW - Heart Test Laboratories, Inc.", ticker: "HSCSW" },
    { name: "ENIAY - ENEL AMERICAS S.A.", ticker: "ENIAY" },
    { name: "AFRIW - Forafric Global PLC", ticker: "AFRIW" },
    { name: "GBBKR - Global Blockchain Acquisition Corp.", ticker: "GBBKR" },
    { name: "GBBKW - Global Blockchain Acquisition Corp.", ticker: "GBBKW" },
    { name: "SAPFD - SAIPEM S P A /FI", ticker: "SAPFD" },
    { name: "AIMAW - Aimfinity Investment Corp. I", ticker: "AIMAW" },
    { name: "AIMBU - Aimfinity Investment Corp. I", ticker: "AIMBU" },
    { name: "OGLFS - Otis Gallery LLC", ticker: "OGLFS" },
    { name: "OGSKS - Otis Gallery LLC", ticker: "OGSKS" },
    { name: "OTSGS - Otis Gallery LLC", ticker: "OTSGS" },
    { name: "STR-WT - Sitio Royalties Corp.", ticker: "STR-WT" },
    { name: "PCNTD - Point of Care Nano-Technology, Inc.", ticker: "PCNTD" },
    { name: "TYDEV - Cryptyde, Inc.", ticker: "TYDEV" },
    { name: "FRFRD - Fritzy Tech Inc.", ticker: "FRFRD" },
    { name: "MGDDD - MICHELIN COMPAGNIE GENERALE DES ETABLISSEMENTS MICHELIN /FI", ticker: "MGDDD" },
    { name: "GEGGL - Great Elm Group, Inc.", ticker: "GEGGL" },
    { name: "DIDIY - DiDi Global Inc.", ticker: "DIDIY" },
    { name: "ELMWQ - Electric Last Mile Solutions, Inc.", ticker: "ELMWQ" },
    { name: "HCYTD - H-CYTE, INC.", ticker: "HCYTD" },
    { name: "PGYWW - Pagaya Technologies Ltd.", ticker: "PGYWW" },
    { name: "FLFVU - Feutune Light Acquisition Corp", ticker: "FLFVU" },
    { name: "MCACR - Monterey Capital Acquisition Corp", ticker: "MCACR" },
    { name: "BRWC - Birdie Win Corp", ticker: "BRWC" },
    { name: "XSIIX - VOYA CREDIT INCOME FUND", ticker: "XSIIX" },
    { name: "ESPID - ESP Resources, Inc.", ticker: "ESPID" },
    { name: "IVCAW - Investcorp India Acquisition Corp", ticker: "IVCAW" },
    { name: "ACACU - Acri Capital Acquisition Corp", ticker: "ACACU" },
    { name: "VVX - V2X, Inc.", ticker: "VVX" },
    { name: "RITM - Rithm Capital Corp.", ticker: "RITM" },
    { name: "FAZE - FaZe Holdings Inc.", ticker: "FAZE" },
    { name: "ZFOX - ZeroFox Holdings, Inc.", ticker: "ZFOX" },
    { name: "MATV - Mativ Holdings, Inc.", ticker: "MATV" },
    { name: "MOND - Mondee Holdings, Inc.", ticker: "MOND" },
    { name: "PROK - PROKIDNEY CORP.", ticker: "PROK" },
    { name: "JUSHF - Jushi Holdings Inc.", ticker: "JUSHF" },
    { name: "IRAA - Iris Acquisition Corp", ticker: "IRAA" },
    { name: "OPAL - OPAL Fuels Inc.", ticker: "OPAL" },
    { name: "POL - 1847 Goedeker Inc.", ticker: "POL" },
    { name: "MGAM - Mobile Global Esports, Inc.", ticker: "MGAM" },
    { name: "OIG - Orbital Energy Group, Inc.", ticker: "OIG" },
    { name: "QNCX - Cortexyme, Inc.", ticker: "QNCX" },
    { name: "QYOUF - QYOU Media Inc.", ticker: "QYOUF" },
    { name: "STKH - Steakholder Foods Ltd.", ticker: "STKH" },
    { name: "FRPRF - 4D Pharma PLC", ticker: "FRPRF" },
    { name: "PLUR - Pluri Inc.", ticker: "PLUR" },
    { name: "ZRFY - Zerify, Inc.", ticker: "ZRFY" },
    { name: "SDCH - SideChannel, Inc.", ticker: "SDCH" },
    { name: "ENJYQ - ENJOY TECHNOLOGY, INC./DE", ticker: "ENJYQ" },
    { name: "VPER - VIPER NETWORKS INC", ticker: "VPER" },
    { name: "NUGN - NuGene International, Inc.", ticker: "NUGN" },
    { name: "NSTM - NovelStem International Corp", ticker: "NSTM" },
    { name: "BTTC - Bitech Technologies Corp", ticker: "BTTC" },
    { name: "AFTC - ALTERNATIVE FUEL TECHNOLOGIES, INC.", ticker: "AFTC" },
    { name: "RLLY - AMERICAS TECHNOLOGY ACQUISITION HOLDINGS INC.", ticker: "RLLY" },
    { name: "LEAS - Strategic Asset Leasing, Inc.", ticker: "LEAS" },
    { name: "FWFW - FLYWHEEL ADVANCED TECHNOLOGY, INC.", ticker: "FWFW" },
    { name: "WNBD - Winning Brands Corp", ticker: "WNBD" },
    { name: "OWVI - One World Ventures Inc", ticker: "OWVI" },
    { name: "LFEV - Life Electric Vehicles Holdings, Inc.", ticker: "LFEV" },
    { name: "TGL - TREASURE GLOBAL INC", ticker: "TGL" },
    { name: "ALWN - Allwyn Entertainment AG", ticker: "ALWN" },
    { name: "WPA - Whale Point Acquisition Corp.", ticker: "WPA" },
    { name: "JZ - Jianzhi Education Technology Group Co Ltd", ticker: "JZ" },
    { name: "MDLS - MDNA Life Sciences, Inc.", ticker: "MDLS" },
    { name: "QIND - WIKISOFT CORP.", ticker: "QIND" },
    { name: "CETS - Cetus Capital Acquisition Corp.", ticker: "CETS" },
    { name: "SUPB - SUPERBAC PubCo Holdings Inc.", ticker: "SUPB" },
    { name: "VACX - Vistas Acquisition Co II Inc.", ticker: "VACX" },
    { name: "HESP - Hesperos, Inc", ticker: "HESP" },
    { name: "SPGC - Sacks Parente Golf, Inc.", ticker: "SPGC" },
    { name: "NAMS - NewAmsterdam Pharma Co B.V.", ticker: "NAMS" },
    { name: "NOTE - FiscalNote Holdings, Inc.", ticker: "NOTE" },
    { name: "AQPW - Golden Ally Lifetech Group, Inc.", ticker: "AQPW" },
    { name: "CJOY - Cine Top Culture Holdings Ltd.", ticker: "CJOY" },
    { name: "MTAM - Motos America, Inc.", ticker: "MTAM" },
    { name: "GRTR - Global Robotic Drone Acquisition Corp.", ticker: "GRTR" },
    { name: "KARX - Karbon-X Corp.", ticker: "KARX" },
    { name: "MBC - MIDDLEFIELD BANC CORP", ticker: "MBC" },
    { name: "PTWO - Pono Capital Two, Inc.", ticker: "PTWO" },
    { name: "SMXT - SolarMax Technology, Inc.", ticker: "SMXT" },
    { name: "SED - Sedibelo Resources Ltd", ticker: "SED" },
    { name: "GLST - Global Star Acquisition Inc.", ticker: "GLST" },
    { name: "AZTGY - AZTECH GLOBAL LTD./ADR", ticker: "AZTGY" },
    { name: "LANV - Lanvin Group Holdings Ltd", ticker: "LANV" },
    { name: "YGF - YanGuFang International Group Co., Ltd", ticker: "YGF" },
    { name: "TWEN - T20 HOLDINGS PTE. LTD.", ticker: "TWEN" },
    { name: "NWTN - NWTN, Inc.", ticker: "NWTN" },
    { name: "GCT - GigaCloud Technology Inc", ticker: "GCT" },
    { name: "RYNL - Reynaldo's Mexican Food Company, Inc.", ticker: "RYNL" },
    { name: "VWFB - VWF Bancorp, Inc.", ticker: "VWFB" },
    { name: "RPGL - Republic Power Group Ltd", ticker: "RPGL" },
    { name: "PROQ - PROTONIQ Acquisition Corp", ticker: "PROQ" },
    { name: "LIPO - LIPELLA PHARMACEUTICALS INC", ticker: "LIPO" },
    { name: "WDTK - WEDOTALK INC.", ticker: "WDTK" },
    { name: "GLAXD - GSK PLC", ticker: "GLAXD" },
    { name: "ATLPF - ATLAS COPCO AB", ticker: "ATLPF" },
    { name: "PBNNF - PT Bank Negara Indonesia (Persero) Tbk/ADR", ticker: "PBNNF" },
    { name: "IVEVF - Inventiva S.A.", ticker: "IVEVF" },
    { name: "FIPWV - FTAI Infrastructure Inc.", ticker: "FIPWV" },
    { name: "MOYFF - Mynaric AG", ticker: "MOYFF" },
    { name: "GUER - Guerrilla RF, Inc.", ticker: "GUER" },
    { name: "CBPID - China Botanic Pharmaceutical", ticker: "CBPID" },
    { name: "ARRKF - ARRAS MINERALS CORP.", ticker: "ARRKF" },
    { name: "QEGYD - QUANTUM ENERGY INC.", ticker: "QEGYD" },
    { name: "CCTCD - Clean Coal Technologies Inc.", ticker: "CCTCD" },
    { name: "MOJOD - EQUATOR Beverage Co", ticker: "MOJOD" },
    { name: "WOLVD - Wolverine Resources Corp.", ticker: "WOLVD" },
    { name: "ARGQD - ARGENTUM 47, INC.", ticker: "ARGQD" },
    { name: "PGLOD - FLYWHEEL ADVANCED TECHNOLOGY, INC.", ticker: "PGLOD" },
    { name: "SGOO - Snoogoo Corp.", ticker: "SGOO" },
    { name: "ELRED - Yinfu Gold Corp.", ticker: "ELRED" },
    { name: "GRRRW - Gorilla Technology Group Inc.", ticker: "GRRRW" },
    { name: "HLNCF - Haleon plc", ticker: "HLNCF" },
    { name: "POL-WT - 1847 Goedeker Inc.", ticker: "POL-WT" },
    { name: "HNPIY - HUANENG POWER INTERNATIONAL INC", ticker: "HNPIY" },
    { name: "MS-PP - MORGAN STANLEY", ticker: "MS-PP" },
    { name: "MSSXL - MORGAN STANLEY", ticker: "MSSXL" },
    { name: "KPHCW - KIORA PHARMACEUTICALS INC", ticker: "KPHCW" },
    { name: "KPHMW - KIORA PHARMACEUTICALS INC", ticker: "KPHMW" },
    { name: "SEDRF - Seadrill Ltd", ticker: "SEDRF" },
    { name: "FTAIV - Fortress Transportation & Infrastructure Investors LLC", ticker: "FTAIV" },
    { name: "FSUN - FIRSTSUN CAPITAL BANCORP", ticker: "FSUN" },
    { name: "STIXW - Semantix, Inc.", ticker: "STIXW" },
    { name: "GETY-WT - Getty Images Holdings, Inc.", ticker: "GETY-WT" },
    { name: "ENJWQ - ENJOY TECHNOLOGY, INC./DE", ticker: "ENJWQ" },
    { name: "MOBVU - Mobiv Acquisition Corp", ticker: "MOBVU" },
    { name: "NEOVW - NeoVolta Inc.", ticker: "NEOVW" },
    { name: "RITM-PA - Rithm Capital Corp.", ticker: "RITM-PA" },
    { name: "RITM-PC - Rithm Capital Corp.", ticker: "RITM-PC" },
    { name: "RITM-PB - Rithm Capital Corp.", ticker: "RITM-PB" },
    { name: "RITM-PD - Rithm Capital Corp.", ticker: "RITM-PD" },
    { name: "IRAAW - Iris Acquisition Corp", ticker: "IRAAW" },
    { name: "RENEW - Cartesian Growth Corp II", ticker: "RENEW" },
    { name: "ACACW - Acri Capital Acquisition Corp", ticker: "ACACW" },
    { name: "FAZEW - FaZe Holdings Inc.", ticker: "FAZEW" },
    { name: "RWAYL - Runway Growth Finance Corp.", ticker: "RWAYL" },
    { name: "FIGP - Forge Group, Inc.", ticker: "FIGP" },
    { name: "FLFVW - Feutune Light Acquisition Corp", ticker: "FLFVW" },
    { name: "FLFVR - Feutune Light Acquisition Corp", ticker: "FLFVR" },
    { name: "BRSHW - Bruush Oral Care Inc.", ticker: "BRSHW" },
    { name: "QBTS-WT - D-Wave Quantum Inc.", ticker: "QBTS-WT" },
    { name: "ZFOXW - ZeroFox Holdings, Inc.", ticker: "ZFOXW" },
    { name: "NOTE-WT - FiscalNote Holdings, Inc.", ticker: "NOTE-WT" },
    { name: "TRINL - Trinity Capital Inc.", ticker: "TRINL" },
    { name: "REAQS - RSE Archive, LLC", ticker: "REAQS" },
    { name: "RSBOS - RSE Archive, LLC", ticker: "RSBOS" },
    { name: "RSLES - RSE Archive, LLC", ticker: "RSLES" },
    { name: "RSSCS - RSE Archive, LLC", ticker: "RSSCS" },
    { name: "ARSND - Yuenglings Ice Cream Corp", ticker: "ARSND" },
    { name: "PNACR - Prime Number Acquisition I Corp.", ticker: "PNACR" },
    { name: "PNACW - Prime Number Acquisition I Corp.", ticker: "PNACW" },
    { name: "NCPLW - Netcapital Inc.", ticker: "NCPLW" },
    { name: "PTWOU - Pono Capital Two, Inc.", ticker: "PTWOU" },
    { name: "ASXFY - ASX Ltd.", ticker: "ASXFY" },
    { name: "BDNNY - Boliden AB", ticker: "BDNNY" },
    { name: "JSCPY - JSR Corp.", ticker: "JSCPY" },
    { name: "PTCAY - PT Chandra Asri Petrochemical Tbk/ADR", ticker: "PTCAY" },
    { name: "FG - F&G Annuities & Life, Inc.", ticker: "FG" },
    { name: "TDAC - Translational Development Acquisition Corp.", ticker: "TDAC" },
    { name: "BKTPF - CRUZ BATTERY METALS CORP.", ticker: "BKTPF" },
    { name: "TETOF - Tectonic Metals Inc.", ticker: "TETOF" },
    { name: "ABNAF - Aben Resources Ltd.", ticker: "ABNAF" },
    { name: "EESH - EESTech, Inc.", ticker: "EESH" },
    { name: "UVSS - UNIVERSAL SYSTEMS INC", ticker: "UVSS" },
    { name: "NDVNQ - nDivision Inc.", ticker: "NDVNQ" },
    { name: "CHNC - CHINA INFRASTRUCTURE CONSTRUCTION Corp", ticker: "CHNC" },
    { name: "LPHM - Lee Pharmaceuticals, Inc.", ticker: "LPHM" },
    { name: "SPBV - Glink Arts Global Group, Inc.", ticker: "SPBV" },
    { name: "GSPT - Golden Star Enterprises Ltd.", ticker: "GSPT" },
    { name: "VYBE - Limitless X Holdings Inc.", ticker: "VYBE" },
    { name: "EEGI - Eline Entertainment Group, Inc.", ticker: "EEGI" },
    { name: "MMV - Model Performance Mini Corp.", ticker: "MMV" },
    { name: "GPLDF - GREAT PANTHER MINING Ltd", ticker: "GPLDF" },
    { name: "NBEVQ - NewAge, Inc.", ticker: "NBEVQ" },
    { name: "HLLK - HALLMARK VENTURE GROUP, INC.", ticker: "HLLK" },
    { name: "SFWJ - Software Effective Solutions, Corp.", ticker: "SFWJ" },
    { name: "SLNA - SELINA HOSPITALITY PLC", ticker: "SLNA" },
    { name: "PSE - Prime Skyline Ltd", ticker: "PSE" },
    { name: "TPET - Trio Petroleum Corp.", ticker: "TPET" },
    { name: "EAWC - Ecco Auto World Corp", ticker: "EAWC" },
    { name: "PR - Permian Resources Corp", ticker: "PR" },
    { name: "LQLY - Azar International Corp.", ticker: "LQLY" },
    { name: "LRE - LEAD REAL ESTATE CO., LTD", ticker: "LRE" },
    { name: "KITT - Nauticus Robotics, Inc.", ticker: "KITT" },
    { name: "REUN - Reunion Neuroscience Inc.", ticker: "REUN" },
    { name: "QREE - QUANTUM ENERGY INC.", ticker: "QREE" },
    { name: "THRD - Third Harmonic Bio, Inc.", ticker: "THRD" },
    { name: "CTM - Castellum, Inc.", ticker: "CTM" },
    { name: "IVVD - Invivyd, Inc.", ticker: "IVVD" },
    { name: "ENDPQ - Endo International plc", ticker: "ENDPQ" },
    { name: "RUM - Rumble Inc.", ticker: "RUM" },
    { name: "SMX - Empatan Public Ltd Co", ticker: "SMX" },
    { name: "HUBC - Hub Cyber Security (Israel) Ltd.", ticker: "HUBC" },
    { name: "EU - Encore Energy Corp.", ticker: "EU" },
    { name: "BAER - Wildfire New PubCo, Inc.", ticker: "BAER" },
    { name: "FTHWF - Field Trip Health & Wellness Ltd.", ticker: "FTHWF" },
    { name: "ASPI - ASP Isotopes Inc.", ticker: "ASPI" },
    { name: "AMPX - Amprius Technologies, Inc.", ticker: "AMPX" },
    { name: "RSMXF - Regency Silver Corp.", ticker: "RSMXF" },
    { name: "MODG - Topgolf Callaway Brands Corp.", ticker: "MODG" },
    { name: "FRTX - Fresh Tracks Therapeutics, Inc.", ticker: "FRTX" },
    { name: "LSTA - LISATA THERAPEUTICS, INC.", ticker: "LSTA" },
    { name: "NYAX - Nayax Ltd.", ticker: "NYAX" },
    { name: "MNX - MN8 Energy, Inc.", ticker: "MNX" },
    { name: "SATX - SatixFy Communications Ltd.", ticker: "SATX" },
    { name: "RBNK - RiverBank Holding Co", ticker: "RBNK" },
    { name: "PET - Wag! Group Co.", ticker: "PET" },
    { name: "FOXO - FOXO TECHNOLOGIES INC.", ticker: "FOXO" },
    { name: "TFPM - Triple Flag Precious Metals Corp.", ticker: "TFPM" },
    { name: "EPOW - Sunrise New Energy Co., Ltd.", ticker: "EPOW" },
    { name: "MWRK - METAWORKS PLATFORMS, INC.", ticker: "MWRK" },
    { name: "PDRO - Pedro's List, Inc.", ticker: "PDRO" },
    { name: "LNZNY - Lenzing AG/ADR", ticker: "LNZNY" },
    { name: "ASST - Asset Entities Inc.", ticker: "ASST" },
    { name: "MBGYY - DAIMLER AG", ticker: "MBGYY" },
    { name: "EMTX - EMULATE THERAPEUTICS, INC.", ticker: "EMTX" },
    { name: "GLE - Global Engine Group Holding Ltd", ticker: "GLE" },
    { name: "BANL - CBL International Ltd", ticker: "BANL" },
    { name: "SNAL - Snail, Inc.", ticker: "SNAL" },
    { name: "PARG - Power Americas Resource Group Ltd.", ticker: "PARG" },
    { name: "REBN - Reborn Coffee, Inc.", ticker: "REBN" },
    { name: "RBT - Rubicon Technologies, Inc.", ticker: "RBT" },
    { name: "EVTS - EV TRANSPORTATION SERVICES, INC.", ticker: "EVTS" },
    { name: "CRXTQ - Clarus Therapeutics Holdings, Inc.", ticker: "CRXTQ" },
    { name: "UPXI - UPEXI, INC.", ticker: "UPXI" },
    { name: "BRCNF - Burcon NutraScience Corp", ticker: "BRCNF" },
    { name: "ACNT - ASCENT INDUSTRIES CO.", ticker: "ACNT" },
    { name: "AKLI - Akili, Inc.", ticker: "AKLI" },
    { name: "EMWPF - Eros STX Global Corp", ticker: "EMWPF" },
    { name: "PSLY - PSLY.COM, Inc.", ticker: "PSLY" },
    { name: "HLST - Holisto Ltd.", ticker: "HLST" },
    { name: "SKUR - Sekur Private Data Ltd.", ticker: "SKUR" },
    { name: "VANI - Vivani Medical, Inc.", ticker: "VANI" },
    { name: "KWE - KWESST Micro Systems Inc.", ticker: "KWE" },
    { name: "FLCT - Felicitex Therapeutics Inc.", ticker: "FLCT" },
    { name: "BCGF - BCGF Acquisition Corp.", ticker: "BCGF" },
    { name: "FORL - Four Leaf Acquisition Corp", ticker: "FORL" },
    { name: "YCRM - Yuenglings Ice Cream Corp", ticker: "YCRM" },
    { name: "MKDTY - Molecular Data Inc.", ticker: "MKDTY" },
    { name: "DSWR - OS Support, Inc.", ticker: "DSWR" },
    { name: "NOVI - Novibet Plc", ticker: "NOVI" },
    { name: "AGII - AgiiPlus Inc.", ticker: "AGII" },
    { name: "FTFI - FIRST BERLIN BANCORP INC", ticker: "FTFI" },
    { name: "NOGN - Nogin, Inc.", ticker: "NOGN" },
    { name: "MFIC - MidCap Financial Investment Corp", ticker: "MFIC" },
    { name: "DMYY - dMY Squared Technology Group, Inc.", ticker: "DMYY" },
    { name: "GELS - Gelteq Ltd", ticker: "GELS" },
    { name: "IBG - Innovation Beverage Group Ltd", ticker: "IBG" },
    { name: "EFHT - EF Hutton Acquisition Corp I", ticker: "EFHT" },
    { name: "SJA - SolarJuice Co., Ltd.", ticker: "SJA" },
    { name: "STBX - Starbox Group Holdings Ltd.", ticker: "STBX" },
    { name: "BACK - IMAC Holdings, Inc.", ticker: "BACK" },
    { name: "PTPIF - PT Chandra Asri Petrochemical Tbk/ADR", ticker: "PTPIF" },
    { name: "ASXFF - ASX Ltd.", ticker: "ASXFF" },
    { name: "BOLIF - Boliden AB", ticker: "BOLIF" },
    { name: "JSCPF - JSR Corp.", ticker: "JSCPF" },
    { name: "LNZNF - Lenzing AG/ADR", ticker: "LNZNF" },
    { name: "SWGHF - SAWAI GROUP HOLDINGS Co., Ltd.", ticker: "SWGHF" },
    { name: "TRFPF - Triple Flag Precious Metals Corp.", ticker: "TRFPF" },
    { name: "ENCUF - Encore Energy Corp.", ticker: "ENCUF" },
    { name: "WONDF - WonderFi Technologies Inc.", ticker: "WONDF" },
    { name: "MILOF - Mobilicom Ltd", ticker: "MILOF" },
    { name: "KWEMF - KWESST Micro Systems Inc.", ticker: "KWEMF" },
    { name: "VBIXD - Viewbix Inc.", ticker: "VBIXD" },
    { name: "BRSYF - Brainsway Ltd.", ticker: "BRSYF" },
    { name: "ONOV - Castellum, Inc.", ticker: "ONOV" },
    { name: "APE - AMC ENTERTAINMENT HOLDINGS, INC.", ticker: "APE" },
    { name: "WSCRD - Premium Nickel Resources Ltd.", ticker: "WSCRD" },
    { name: "RBSPD - NatWest Group plc", ticker: "RBSPD" },
    { name: "KITTW - Nauticus Robotics, Inc.", ticker: "KITTW" },
    { name: "EMCGU - Embrace Change Acquisition Corp.", ticker: "EMCGU" },
    { name: "JPUHF - JPMorgan Chase Bank, N.A.", ticker: "JPUHF" },
    { name: "JIREF - JPMorgan Chase Bank, N.A.", ticker: "JIREF" },
    { name: "NEEXU - NEXTERA ENERGY INC", ticker: "NEEXU" },
    { name: "AMPX-WT - Amprius Technologies, Inc.", ticker: "AMPX-WT" },
    { name: "SNPTY - CHINA PETROLEUM & CHEMICAL CORP", ticker: "SNPTY" },
    { name: "ENCUD - Encore Energy Corp.", ticker: "ENCUD" },
    { name: "SCCG - Sachem Capital Corp.", ticker: "SCCG" },
    { name: "SILOD - Silo Pharma, Inc.", ticker: "SILOD" },
    { name: "HMACW - Hainan Manaslu Acquisition Corp.", ticker: "HMACW" },
    { name: "HMACR - Hainan Manaslu Acquisition Corp.", ticker: "HMACR" },
    { name: "HMACU - Hainan Manaslu Acquisition Corp.", ticker: "HMACU" },
    { name: "PETWW - Wag! Group Co.", ticker: "PETWW" },
    { name: "KWACW - Kingswood Acquisition Corp.", ticker: "KWACW" },
    { name: "AGCGV - AGNC Investment Corp.", ticker: "AGCGV" },
    { name: "AGNCL - AGNC Investment Corp.", ticker: "AGNCL" },
    { name: "KEY-PL - KEYCORP /NEW/", ticker: "KEY-PL" },
    { name: "RBT-WT - Rubicon Technologies, Inc.", ticker: "RBT-WT" },
    { name: "SKGRW - SK Growth Opportunities Corp", ticker: "SKGRW" },
    { name: "TAKYX - Carlyle Tactical Private Credit Fund", ticker: "TAKYX" },
    { name: "TAKIX - Carlyle Tactical Private Credit Fund", ticker: "TAKIX" },
    { name: "TAKNX - Carlyle Tactical Private Credit Fund", ticker: "TAKNX" },
    { name: "CRXWQ - Clarus Therapeutics Holdings, Inc.", ticker: "CRXWQ" },
    { name: "MSBIP - Midland States Bancorp, Inc.", ticker: "MSBIP" },
    { name: "QSMGD - Pedro's List, Inc.", ticker: "QSMGD" },
    { name: "FOXO-WT - FOXO TECHNOLOGIES INC.", ticker: "FOXO-WT" },
    { name: "AIMDW - Ainos, Inc.", ticker: "AIMDW" },
    { name: "SPKY - ConvexityShares Trust", ticker: "SPKY" },
    { name: "SLHGF - Skylight Health Group Inc.", ticker: "SLHGF" },
    { name: "SLHPF - Skylight Health Group Inc.", ticker: "SLHPF" },
    { name: "HMDCF - HUTCHMED (China) Ltd", ticker: "HMDCF" },
    { name: "MBGAF - DAIMLER AG", ticker: "MBGAF" },
    { name: "WESTW - Westrock Coffee Co", ticker: "WESTW" },
    { name: "ONFOW - Onfolio Holdings, Inc", ticker: "ONFOW" },
    { name: "F-PD - FORD MOTOR CO", ticker: "F-PD" },
    { name: "SHIIY - SINOPEC SHANGHAI PETROCHEMICAL CO LTD", ticker: "SHIIY" },
    { name: "VANIW - Vivani Medical, Inc.", ticker: "VANIW" },
    { name: "BIAFW - bioAffinity Technologies, Inc.", ticker: "BIAFW" },
    { name: "CSSEL - Chicken Soup for the Soul Entertainment, Inc.", ticker: "CSSEL" },
    { name: "IRAAU - Iris Acquisition Corp", ticker: "IRAAU" },
    { name: "DC-WT - Dakota Gold Corp.", ticker: "DC-WT" },
    { name: "NNUPD - NOCOPI TECHNOLOGIES INC/MD/", ticker: "NNUPD" },
    { name: "HOLOW - Golden Path Acquisition Corp", ticker: "HOLOW" },
    { name: "WLDSW - Wearable Devices Ltd.", ticker: "WLDSW" },
    { name: "RRVCS - RSE Archive, LLC", ticker: "RRVCS" },
    { name: "ARHKS - RSE Archive, LLC", ticker: "ARHKS" },
    { name: "SASBQ - SAS AB / ADR", ticker: "SASBQ" },
    { name: "PTRCY - PETROCHINA CO LTD", ticker: "PTRCY" },
    { name: "MOBBW - Mobilicom Ltd", ticker: "MOBBW" },
    { name: "EFHTU - EF Hutton Acquisition Corp I", ticker: "EFHTU" },
    { name: "JFBRW - Jeffs' Brands Ltd", ticker: "JFBRW" },
    { name: "FBDS - Fuss Brands Corp.", ticker: "FBDS" },
    { name: "LUCYW - Innovative Eyewear Inc", ticker: "LUCYW" },
    { name: "NXLIW - Nexalin Technology, Inc.", ticker: "NXLIW" },
    { name: "QPRCD - QUEST PATENT RESEARCH CORP", ticker: "QPRCD" },
    { name: "GRFXF - Graphex Group Ltd", ticker: "GRFXF" },
    { name: "GTBT - ESP Resources, Inc.", ticker: "GTBT" },
    { name: "NOGNW - Nogin, Inc.", ticker: "NOGNW" },
    { name: "LFCHY - CHINA LIFE INSURANCE CO LTD", ticker: "LFCHY" },
    { name: "OMRNY - OMRON CORP /FI", ticker: "OMRNY" },
    { name: "ECGR - Bellatora, Inc.", ticker: "ECGR" },
    { name: "CXXMF - CMX GOLD & SILVER CORP.", ticker: "CXXMF" },
    { name: "IMNN - Celsion CORP", ticker: "IMNN" },
    { name: "AMV - Atlis Motor Vehicles Inc", ticker: "AMV" },
    { name: "MELT - Melt Pharmaceuticals, Inc.", ticker: "MELT" },
    { name: "PRST - Ventoux CCM Acquisition Corp.", ticker: "PRST" },
    { name: "EFXT - Enerflex Ltd.", ticker: "EFXT" },
    { name: "GLSTU - Global Star Acquisition Inc.", ticker: "GLSTU" },
    { name: "LPTVD - Loop Media, Inc.", ticker: "LPTVD" },
    { name: "XPER-WI - Xperi Inc.", ticker: "XPER-WI" },
    { name: "NSPDD - NATURALLY SPLENDID ENTERPRISES LTD.", ticker: "NSPDD" },
    { name: "IPODW - Social Capital Hedosophia Holdings Corp. IV", ticker: "IPODW" },
    { name: "CLSHD - CLS Holdings USA, Inc.", ticker: "CLSHD" },
    { name: "NYAXF - Nayax Ltd.", ticker: "NYAXF" },
    { name: "RSAGS - RSE Archive, LLC", ticker: "RSAGS" },
    { name: "GTXOD - Metalert, Inc.", ticker: "GTXOD" },
    { name: "PRSTW - Ventoux CCM Acquisition Corp.", ticker: "PRSTW" },
    { name: "XYLB - XY Labs, Inc.", ticker: "XYLB" },
    { name: "IPOFW - Social Capital Hedosophia Holdings Corp. VI", ticker: "IPOFW" },
    { name: "NE - Noble Corp plc", ticker: "NE" },
    { name: "BCNN - Balincan USA, Inc", ticker: "BCNN" },
    { name: "MSCLF - Satellos Bioscience Inc.", ticker: "MSCLF" },
    { name: "ENGA - Engage Mobility, Inc.", ticker: "ENGA" },
    { name: "PRRY - Planet Resource Recovery, Inc.", ticker: "PRRY" },
    { name: "MBLY - Mobileye Global Inc.", ticker: "MBLY" },
    { name: "ARBB - ARB IOT Group Ltd", ticker: "ARBB" },
    { name: "EPMI - EPIEN MEDICAL, INC.", ticker: "EPMI" },
    { name: "ALPS - ALPINE SUMMIT ENERGY PARTNERS, INC.", ticker: "ALPS" },
    { name: "LASE - Laser Photonics Corp", ticker: "LASE" },
    { name: "MOHOY - ECMOHO Ltd", ticker: "MOHOY" },
    { name: "QOMO - Qomolangma Acquisition Corp.", ticker: "QOMO" },
    { name: "PRME - Prime Medicine, Inc.", ticker: "PRME" },
    { name: "RXO - RXO, LLC", ticker: "RXO" },
    { name: "CACO - Caravelle International Group", ticker: "CACO" },
    { name: "FLJ - FLJ Group Ltd", ticker: "FLJ" },
    { name: "LVWR - LiveWire Group, Inc.", ticker: "LVWR" },
    { name: "STEL - CBTX, Inc.", ticker: "STEL" },
    { name: "SHFS - SHF Holdings, Inc.", ticker: "SHFS" },
    { name: "FRPRQ - 4D Pharma PLC", ticker: "FRPRQ" },
    { name: "CVKD - Cadrenal Therapeutics, Inc.", ticker: "CVKD" },
    { name: "BOMO - Cruzani, Inc.", ticker: "BOMO" },
    { name: "CMND - Clearmind Medicine Inc.", ticker: "CMND" },
    { name: "BMDPD - BANCA MONTE DEI PASCHI DI SIENA SPA", ticker: "BMDPD" },
    { name: "CETI - Cyber Enviro-Tech, Inc.", ticker: "CETI" },
    { name: "RBC - RBC Bearings INC", ticker: "RBC" },
    { name: "NFTX - Ultimax Digital, Inc.", ticker: "NFTX" },
    { name: "LVRO - Lavoro Ltd", ticker: "LVRO" },
    { name: "MKC-V - MCCORMICK & CO INC", ticker: "MKC-V" },
    { name: "OMRNF - OMRON CORP /FI", ticker: "OMRNF" },
    { name: "CMNDF - Clearmind Medicine Inc.", ticker: "CMNDF" },
    { name: "RBCP - RBC Bearings INC", ticker: "RBCP" },
    { name: "LNDUS - Landa App LLC", ticker: "LNDUS" },
    { name: "EMCGW - Embrace Change Acquisition Corp.", ticker: "EMCGW" },
    { name: "EMCGR - Embrace Change Acquisition Corp.", ticker: "EMCGR" },
    { name: "CRUBW - Crucible Acquisition Corp", ticker: "CRUBW" },
    { name: "LVWR-WT - LiveWire Group, Inc.", ticker: "LVWR-WT" },
    { name: "CRLWF - Cresco Labs Inc.", ticker: "CRLWF" },
    { name: "VISMD - VISIUM TECHNOLOGIES, INC.", ticker: "VISMD" },
    { name: "DMYY-UN - dMY Squared Technology Group, Inc.", ticker: "DMYY-UN" },
    { name: "SHFSW - SHF Holdings, Inc.", ticker: "SHFSW" },
    { name: "MBINM - Merchants Bancorp", ticker: "MBINM" },
    { name: "RSSPS - RSE Archive, LLC", ticker: "RSSPS" },
    { name: "RARPS - RSE Archive, LLC", ticker: "RARPS" },
    { name: "CMNDD - Clearmind Medicine Inc.", ticker: "CMNDD" },
    { name: "TPGYF - TPG Pace Beneficial Finance Corp.", ticker: "TPGYF" },
    { name: "MCACW - Monterey Capital Acquisition Corp", ticker: "MCACW" },
    { name: "MOBVW - Mobiv Acquisition Corp", ticker: "MOBVW" },
    { name: "QOMOU - Qomolangma Acquisition Corp.", ticker: "QOMOU" },
    { name: "DRFSD - Dr. Foods, Inc.", ticker: "DRFSD" },
    { name: "QBAKD - QUALSTAR CORP", ticker: "QBAKD" },
    { name: "BRBLD - BrewBilt Brewing Co", ticker: "BRBLD" },
    { name: "GWLL - GOLDENWELL BIOTECH, INC.", ticker: "GWLL" },
    { name: "PTWOW - Pono Capital Two, Inc.", ticker: "PTWOW" },
    { name: "XPER - Xperi Inc.", ticker: "XPER" },
    { name: "ADEA - Xperi Holding Corp", ticker: "ADEA" },
    { name: "BHVN - Biohaven Ltd.", ticker: "BHVN" },
    { name: "ATLX - Brazil Minerals, Inc.", ticker: "ATLX" },
    { name: "LADX - CYTRX CORP", ticker: "LADX" },
    { name: "IMDS - IMAGING DIAGNOSTIC SYSTEMS INC /FL/", ticker: "IMDS" },
    { name: "GAHCD - Global Arena Holding, Inc.", ticker: "GAHCD" },
    { name: "ASZCF - Austerlitz Acquisition Corp II", ticker: "ASZCF" },
    { name: "AUSCF - Austerlitz Acquisition Corp I", ticker: "AUSCF" },
    { name: "AQUNU - Aquaron Acquisition Corp.", ticker: "AQUNU" },
    { name: "NBLWF - Noble Corp plc", ticker: "NBLWF" },
    { name: "AUCUF - Inflection Resources Ltd.", ticker: "AUCUF" },
    { name: "ALPX - Alopexx, Inc.", ticker: "ALPX" },
    { name: "DFLI - Dragonfly Energy Holdings Corp.", ticker: "DFLI" },
    { name: "ADOB - Adorbs Inc.", ticker: "ADOB" },
    { name: "FTEL - Fitell Corp", ticker: "FTEL" },
    { name: "YAMHY - Yamaha Motor Co., Ltd.", ticker: "YAMHY" },
    { name: "SAG - SAG Holdings Ltd", ticker: "SAG" },
    { name: "DWAY - Driveitaway Holdings, Inc.", ticker: "DWAY" },
    { name: "ATRXD - Adhera Therapeutics, Inc.", ticker: "ATRXD" },
    { name: "GAMI - GAMCO INVESTORS, INC. ET AL", ticker: "GAMI" },
    { name: "HIGAW - H.I.G. Acquisition Corp.", ticker: "HIGAW" },
    { name: "NEE-PR - NEXTERA ENERGY INC", ticker: "NEE-PR" },
    { name: "BHM-WI - Bluerock Homes Trust, Inc.", ticker: "BHM-WI" },
    { name: "PHOTD - GROWLIFE, INC.", ticker: "PHOTD" },
    { name: "RZC - REINSURANCE GROUP OF AMERICA INC", ticker: "RZC" },
    { name: "DFLIW - Dragonfly Energy Holdings Corp.", ticker: "DFLIW" },
    { name: "ZYME - Zymeworks Delaware Inc.", ticker: "ZYME" },
    { name: "RWGI - Rodedawg International Industries, Inc.", ticker: "RWGI" },
    { name: "MSFC - MAO SHI JADE JEWELRY INTERNATIONAL INVESTMENT LTD.", ticker: "MSFC" },
    { name: "VSOLF - THREE SIXTY SOLAR LTD.", ticker: "VSOLF" },
    { name: "ECX - ECARX Holdings Inc.", ticker: "ECX" },
    { name: "SODR - SONDORS Inc.", ticker: "SODR" },
    { name: "GEHC - GE Healthcare Holding LLC", ticker: "GEHC" },
    { name: "YAMHF - Yamaha Motor Co., Ltd.", ticker: "YAMHF" },
    { name: "MOSTQ - MobileSmith, Inc.", ticker: "MOSTQ" },
    { name: "LNDJS - Landa App LLC", ticker: "LNDJS" },
    { name: "SVIIU - Spring Valley Acquisition Corp. II", ticker: "SVIIU" },
    { name: "RIRCS - RSE Archive, LLC", ticker: "RIRCS" },
    { name: "LNDMS - Landa App 2 LLC", ticker: "LNDMS" },
    { name: "ILUS - Ilustrato Pictures International Inc.", ticker: "ILUS" },
    { name: "MLRT - Metalert, Inc.", ticker: "MLRT" },
    { name: "HVCW - HARRISON VICKERS & WATERMAN INC", ticker: "HVCW" },
    { name: "NFTG - NFT Gaming Co Inc.", ticker: "NFTG" },
    { name: "MDLB - Medlab Clinical Ltd.", ticker: "MDLB" },
    { name: "TOVX - Theriva Biologics, Inc.", ticker: "TOVX" },
    { name: "GSD - Global System Dynamics, Inc.", ticker: "GSD" },
    { name: "WTRV - White River Energy Corp.", ticker: "WTRV" },
    { name: "ELME - Elme Communities", ticker: "ELME" },
    { name: "ACRV - Acrivon Therapeutics, Inc.", ticker: "ACRV" },
    { name: "ERNA - Brooklyn ImmunoTherapeutics, Inc.", ticker: "ERNA" },
    { name: "JNRV - Janover Inc.", ticker: "JNRV" },
    { name: "MLEC - Moolec Science SA", ticker: "MLEC" },
    { name: "KDSKF - Royal DSM N.V.", ticker: "KDSKF" },
    { name: "BMEXF - Banco Santander Mexico S.A., Institucion de Banca Multiple, Grupo Financiero Santander Mexico", ticker: "BMEXF" },
    { name: "PIPPW - Pine Island Acquisition Corp.", ticker: "PIPPW" },
    { name: "FVIVW - Fortress Value Acquisition Corp. IV", ticker: "FVIVW" },
    { name: "FVTAW - Fortress Value Acquisition Corp. III", ticker: "FVTAW" },
    { name: "TENKU - TenX Keane Acquisition", ticker: "TENKU" },
    { name: "GFASD - Gafisa S.A.", ticker: "GFASD" },
    { name: "GSDWW - Global System Dynamics, Inc.", ticker: "GSDWW" },
    { name: "GSDWU - Global System Dynamics, Inc.", ticker: "GSDWU" },
    { name: "PPLPF - PEMBINA PIPELINE CORP", ticker: "PPLPF" },
    { name: "HUDAU - Hudson Acquisition I Corp.", ticker: "HUDAU" },
    { name: "KWACU - Kingswood Acquisition Corp.", ticker: "KWACU" },
    { name: "BABY - PishPosh, Inc.", ticker: "BABY" },
    { name: "CDCN - Grizzly New Pubco, Inc.", ticker: "CDCN" },
    { name: "SMUUY - SIAM COMMERCIAL BANK PUBLIC CO LTD /FI", ticker: "SMUUY" },
    { name: "REVRQ - REVLON INC /DE/", ticker: "REVRQ" },
    { name: "BFAI - BullFrog AI Holdings, Inc.", ticker: "BFAI" },
    { name: "RVYL - RYVYL Inc.", ticker: "RVYL" },
    { name: "IMCID - INFINITE GROUP INC", ticker: "IMCID" },
    { name: "RNEW - Viveon Health Acquisition Corp.", ticker: "RNEW" },
    { name: "GSQDW - G Squared Ascend I Inc.", ticker: "GSQDW" },
    { name: "HTAQW - Hunt Companies Acquisition Corp. I", ticker: "HTAQW" },
    { name: "MIMO-WTB - Airspan Networks Holdings Inc.", ticker: "MIMO-WTB" },
    { name: "AQUNR - Aquaron Acquisition Corp.", ticker: "AQUNR" },
    { name: "RSSOS - RSE Archive, LLC", ticker: "RSSOS" },
    { name: "OSTIY - Osterreichische Post AG ADR", ticker: "OSTIY" },
    { name: "COEP - Bull Horn Holdings Corp.", ticker: "COEP" },
    { name: "CGEI - CGE ENERGY, INC.", ticker: "CGEI" },
    { name: "ALFIQ - Alfi, Inc.", ticker: "ALFIQ" },
    { name: "CLMB - Wayside Technology Group, Inc.", ticker: "CLMB" },
    { name: "LIAI - LEMENG HOLDINGS LTD", ticker: "LIAI" },
    { name: "NAVA - NAVA HEALTH MD, LLC", ticker: "NAVA" },
    { name: "CDIO - Cardio Diagnostics Holdings, Inc.", ticker: "CDIO" },
    { name: "SRFM - SURF AIR MOBILITY INC.", ticker: "SRFM" },
    { name: "INBS - INTELLIGENT BIO SOLUTIONS INC.", ticker: "INBS" },
    { name: "PWM - Prestige Wealth Inc.", ticker: "PWM" },
    { name: "DCCA - Decca Investment Ltd", ticker: "DCCA" },
    { name: "ICU - SeaStar Medical Holding Corp", ticker: "ICU" },
    { name: "MRDB - Mangomill plc", ticker: "MRDB" },
    { name: "XWEL - XWELL, Inc.", ticker: "XWEL" },
    { name: "BAIDF - Baidu, Inc.", ticker: "BAIDF" },
    { name: "EVTK - EVENTIKO INC.", ticker: "EVTK" },
    { name: "CANQF - CanaQuest Medical Corp.", ticker: "CANQF" },
    { name: "BMRK - GPL Holdings, Inc.", ticker: "BMRK" },
    { name: "GPLL - GPL Holdings, Inc.", ticker: "GPLL" },
    { name: "HBISD - Home Bistro, Inc. /NV/", ticker: "HBISD" },
    { name: "PERF-WT - Perfect Corp.", ticker: "PERF-WT" },
    { name: "NBLTF - Noble Corp plc", ticker: "NBLTF" },
    { name: "NBLRF - Noble Corp plc", ticker: "NBLRF" },
    { name: "MACCW - Mission Advancement Corp.", ticker: "MACCW" },
    { name: "GRNT-WT - Granite Ridge Resources, Inc.", ticker: "GRNT-WT" },
    { name: "ACIIW - Atlas Crest Investment Corp. II", ticker: "ACIIW" },
    { name: "SLNAW - SELINA HOSPITALITY PLC", ticker: "SLNAW" },
    { name: "HWKZW - Hawks Acquisition Corp", ticker: "HWKZW" },
    { name: "ICUCW - SeaStar Medical Holding Corp", ticker: "ICUCW" },
    { name: "RHBTS - RSE Archive, LLC", ticker: "RHBTS" },
    { name: "RSCPS - RSE Archive, LLC", ticker: "RSCPS" },
    { name: "BCPPF - BCE INC", ticker: "BCPPF" },
    { name: "ALFWQ - Alfi, Inc.", ticker: "ALFWQ" },
    { name: "COEPW - Bull Horn Holdings Corp.", ticker: "COEPW" },
    { name: "CYAPD - Cyber Apps World", ticker: "CYAPD" },
    { name: "PMVCW - PMV Consumer Acquisition Corp.", ticker: "PMVCW" },
    { name: "KWEMD - KWESST Micro Systems Inc.", ticker: "KWEMD" },
    { name: "RXO-WI - RXO, Inc.", ticker: "RXO-WI" },
    { name: "SVIIW - Spring Valley Acquisition Corp. II", ticker: "SVIIW" },
    { name: "SVIIR - Spring Valley Acquisition Corp. II", ticker: "SVIIR" },
    { name: "GNBTQ - GENEREX BIOTECHNOLOGY CORP", ticker: "GNBTQ" },
    { name: "CDIOW - Cardio Diagnostics Holdings, Inc.", ticker: "CDIOW" },
    { name: "RFLFY - Raffles Education Corp Ltd", ticker: "RFLFY" },
    { name: "LUXH - LUXURBAN HOTELS INC.", ticker: "LUXH" },
    { name: "PHASQ - PhaseBio Pharmaceuticals Inc", ticker: "PHASQ" },
    { name: "OABI - OmniAb, Inc.", ticker: "OABI" },
    { name: "ADD - Color Star Technology Co., Ltd.", ticker: "ADD" },
    { name: "IRON - Iron Horse Acquisitions Corp.", ticker: "IRON" },
    { name: "VCIG - VCI Global Ltd", ticker: "VCIG" },
    { name: "ACDC - ProFrac Holding Corp.", ticker: "ACDC" },
    { name: "JR - JINRONG HOLDINGS LTD.", ticker: "JR" },
    { name: "PKBO - Peak Bio, Inc.", ticker: "PKBO" },
    { name: "VTS - Vitesse Energy, Inc.", ticker: "VTS" },
    { name: "WT - WisdomTree Investments, Inc.", ticker: "WT" },
    { name: "RFLFF - Raffles Education Corp Ltd", ticker: "RFLFF" },
    { name: "RLFTD - Relief Therapeutics Holding SA", ticker: "RLFTD" },
    { name: "PRBMW - Parabellum Acquisition Corp.", ticker: "PRBMW" },
    { name: "OABIW - OmniAb, Inc.", ticker: "OABIW" },
    { name: "QFTAW - Quantum FinTech Acquisition Corp", ticker: "QFTAW" },
    { name: "BKGMD - BankGuam Holding Co", ticker: "BKGMD" },
    { name: "ACDCW - ProFrac Holding Corp.", ticker: "ACDCW" },
    { name: "PEYED - PRECISION OPTICS CORPORATION, INC.", ticker: "PEYED" },
    { name: "SAJ - SARATOGA INVESTMENT CORP.", ticker: "SAJ" },
    { name: "GAPAW - G&P Acquisition Corp.", ticker: "GAPAW" },
    { name: "PPLAF - PEMBINA PIPELINE CORP", ticker: "PPLAF" },
    { name: "PKBOW - Peak Bio, Inc.", ticker: "PKBOW" },
    { name: "FEMFD - First Energy Metals Ltd", ticker: "FEMFD" },
    { name: "OILCD - Permex Petroleum Corp", ticker: "OILCD" },
    { name: "PUTKY - PT United Tractors Tbk / ADR", ticker: "PUTKY" },
    { name: "PSBQ - PSB HOLDINGS INC /WI/", ticker: "PSBQ" },
    { name: "GEN - Gen Digital Inc.", ticker: "GEN" },
    { name: "CECO - CECO ENVIRONMENTAL CORP", ticker: "CECO" },
    { name: "GDHG - GOLDEN HEAVEN GROUP HOLDINGS LTD.", ticker: "GDHG" },
    { name: "FSCO - FS Credit Opportunities Corp.", ticker: "FSCO" },
    { name: "GNNDY - GN STORE NORD A/S", ticker: "GNNDY" },
    { name: "SHGI - Sparx Holdings Group, Inc.", ticker: "SHGI" },
    { name: "OCS - Oculis Holding AG", ticker: "OCS" },
    { name: "TLGPY - Telstra Group Ltd", ticker: "TLGPY" },
    { name: "KPEA - Kun Peng International Ltd.", ticker: "KPEA" },
    { name: "BREA - Brera Holdings PLC", ticker: "BREA" },
    { name: "LTMAY - LATAM AIRLINES GROUP S.A.", ticker: "LTMAY" },
    { name: "PLTN - Plutonian Acquisition Corp.", ticker: "PLTN" },
    { name: "ALRTF - ALR Technologies SG Ltd.", ticker: "ALRTF" },
    { name: "EBZT - Everything Blockchain, Inc.", ticker: "EBZT" },
    { name: "SPRY - Silverback Therapeutics, Inc.", ticker: "SPRY" },
    { name: "ATMV - AlphaVest Acquisition Corp.", ticker: "ATMV" },
    { name: "PUTKF - PT United Tractors Tbk / ADR", ticker: "PUTKF" },
    { name: "LDEGS - Landa App LLC", ticker: "LDEGS" },
    { name: "LNDIS - Landa App LLC", ticker: "LNDIS" },
    { name: "TLGAW - TLG Acquisition One Corp.", ticker: "TLGAW" },
    { name: "CLIMW - Climate Real Impact Solutions II Acquisition Corp", ticker: "CLIMW" },
    { name: "CHAAW - Catcha Investment Corp", ticker: "CHAAW" },
    { name: "VIHDD - VISION HYDROGEN Corp", ticker: "VIHDD" },
    { name: "MITGW - Mason Industrial Technology, Inc.", ticker: "MITGW" },
    { name: "CRRCF - Cohn Robbins Holdings Corp.", ticker: "CRRCF" },
    { name: "GRP.U - GRANITE REAL ESTATE INVESTMENT TRUST", ticker: "GRP.U" },
    { name: "MDBH - MDB Capital Holdings, LLC", ticker: "MDBH" },
    { name: "SPRU - XL Fleet Corp.", ticker: "SPRU" },
    { name: "EVOH - EvoAir Holdings Inc.", ticker: "EVOH" },
    { name: "ALKD - Alkaid Acquisition Corp.", ticker: "ALKD" },
    { name: "BNTY - Bounty Minerals, Inc.", ticker: "BNTY" },
    { name: "INUMF - Infinitum Copper Corp.", ticker: "INUMF" },
    { name: "ZVOI - Zovio Inc", ticker: "ZVOI" },
    { name: "ALBT - Avalon GloboCare Corp.", ticker: "ALBT" },
    { name: "OAKC - Oakworth Capital, Inc.", ticker: "OAKC" },
    { name: "OILS - Permex Petroleum Corp", ticker: "OILS" },
    { name: "SCLX - Vickers Vantage Corp. I", ticker: "SCLX" },
    { name: "PTHR - Pono Capital Three, Inc.", ticker: "PTHR" },
    { name: "GGNDF - GN STORE NORD A/S", ticker: "GGNDF" },
    { name: "SCLXW - Vickers Vantage Corp. I", ticker: "SCLXW" },
    { name: "ARHJS - RSE Archive, LLC", ticker: "ARHJS" },
    { name: "FSNBW - Fusion Acquisition Corp. II", ticker: "FSNBW" },
    { name: "SPGSW - Simon Property Group Acquisition Holdings, Inc.", ticker: "SPGSW" },
    { name: "QNGYW - Quanergy Systems, Inc.", ticker: "QNGYW" },
    { name: "PLTNU - Plutonian Acquisition Corp.", ticker: "PLTNU" },
    { name: "UHALB - AMERCO /NV/", ticker: "UHALB" },
    { name: "LDEDS - Landa App LLC", ticker: "LDEDS" },
    { name: "AMPED - Ampio Pharmaceuticals, Inc.", ticker: "AMPED" },
    { name: "CRHWF - Cohn Robbins Holdings Corp.", ticker: "CRHWF" },
    { name: "BDORY - BANCO DO BRASIL S.A.", ticker: "BDORY" },
    { name: "MEJHY - MEIJI Holdings Co Ltd/ADR", ticker: "MEJHY" },
    { name: "VIAAY - VIENNA INTERNATIONAL AIRPORT", ticker: "VIAAY" },
    { name: "POCI - PRECISION OPTICS CORPORATION, INC.", ticker: "POCI" },
    { name: "MBC - MasterBrand, Inc.", ticker: "MBC" },
    { name: "SKWD - Skyward Specialty Insurance Group, Inc.", ticker: "SKWD" },
    { name: "FENCF - FENNEC PHARMACEUTICALS INC.", ticker: "FENCF" },
    { name: "LFCR - LIFECORE BIOMEDICAL, INC. DE", ticker: "LFCR" },
    { name: "NPLS - NP Life Sciences Health Industry Group Inc.", ticker: "NPLS" },
    { name: "MEJHF - MEIJI Holdings Co Ltd/ADR", ticker: "MEJHF" },
    { name: "NWTNW - NWTN, Inc.", ticker: "NWTNW" },
    { name: "GRNFD - GRN Holding Corp", ticker: "GRNFD" },
    { name: "REGRD - GRAPH BLOCKCHAIN INC", ticker: "REGRD" },
    { name: "NSTTW - Northern Star Investment Corp. III", ticker: "NSTTW" },
    { name: "TRNFQ - Taronis Fuels, Inc.", ticker: "TRNFQ" },
    { name: "MDHA - MDH Acquisition Corp.", ticker: "MDHA" },
    { name: "MDHAW - MDH Acquisition Corp.", ticker: "MDHAW" },
    { name: "AAQCW - Accelerate Acquisition Corp.", ticker: "AAQCW" },
    { name: "TSPQW - TCW Special Purpose Acquisition Corp.", ticker: "TSPQW" },
    { name: "GLSTW - Global Star Acquisition Inc.", ticker: "GLSTW" },
    { name: "GLSTR - Global Star Acquisition Inc.", ticker: "GLSTR" },
    { name: "CRHUF - Cohn Robbins Holdings Corp.", ticker: "CRHUF" },
    { name: "LHCIW - Leo Holdings Corp. II", ticker: "LHCIW" },
    { name: "LNDDS - Landa App LLC", ticker: "LNDDS" },
    { name: "HTPAW - Highland Transcend Partners I Corp.", ticker: "HTPAW" },
    { name: "FFHPF - FAIRFAX FINANCIAL HOLDINGS LTD/ CAN", ticker: "FFHPF" },
    { name: "RRVAS - RSE Archive, LLC", ticker: "RRVAS" },
    { name: "RSMSS - RSE Archive, LLC", ticker: "RSMSS" },
    { name: "REABS - RSE Archive, LLC", ticker: "REABS" },
    { name: "AHVBS - RSE Archive, LLC", ticker: "AHVBS" },
    { name: "RCVGS - RSE Archive, LLC", ticker: "RCVGS" },
    { name: "GAPAU - G&P Acquisition Corp.", ticker: "GAPAU" },
    { name: "AXHIW - Industrial Human Capital, Inc.", ticker: "AXHIW" },
    { name: "AXH-UN - Industrial Human Capital, Inc.", ticker: "AXH-UN" },
    { name: "AXH-WT - Industrial Human Capital, Inc.", ticker: "AXH-WT" },
    { name: "ALMU - Aeluma, Inc.", ticker: "ALMU" },
    { name: "ARPC - AREM PACIFIC Corp", ticker: "ARPC" },
    { name: "GDTC - CytoMed Therapeutics Pte. Ltd.", ticker: "GDTC" },
    { name: "GRND - Grindr Inc", ticker: "GRND" },
    { name: "NTPIF - NAM TAI PROPERTY INC.", ticker: "NTPIF" },
    { name: "MALG - MICROALLIANCE GROUP INC.", ticker: "MALG" },
    { name: "MGIH - Millennium Group International Holdings Ltd", ticker: "MGIH" },
    { name: "BKV - BKV Corp", ticker: "BKV" },
    { name: "TORO - TORO CORP.", ticker: "TORO" },
    { name: "FSRDQ - Fast Radius, Inc.", ticker: "FSRDQ" },
    { name: "EUDA - 8i Acquisition 2 Corp.", ticker: "EUDA" },
    { name: "SYT - SYLA Technologies Co., Ltd.", ticker: "SYT" },
    { name: "ASAP - Waitr Holdings Inc.", ticker: "ASAP" },
    { name: "TXO - MorningStar Partners, L.P.", ticker: "TXO" },
    { name: "COYA - Coya Therapeutics, Inc.", ticker: "COYA" },
    { name: "MGOL - MGO Global Inc.", ticker: "MGOL" },
    { name: "MOG.A - MOOG INC.", ticker: "MOG.A" },
    { name: "FZRO - FLASHZERO CORP.", ticker: "FZRO" },
    { name: "AXHI - Industrial Human Capital, Inc.", ticker: "AXHI" },
    { name: "HTPAF - Highland Transcend Partners I Corp.", ticker: "HTPAF" },
    { name: "GRND-WT - Tiga Acquisition Corp.", ticker: "GRND-WT" },
    { name: "EUDAW - 8i Acquisition 2 Corp.", ticker: "EUDAW" },
    { name: "FSRWQ - Fast Radius, Inc.", ticker: "FSRWQ" },
    { name: "LNCDL - LINCOLN NATIONAL CORP", ticker: "LNCDL" },
    { name: "RARHS - RSE Archive, LLC", ticker: "RARHS" },
    { name: "ARHDS - RSE Archive, LLC", ticker: "ARHDS" },
    { name: "CPTKW - Crown PropTech Acquisitions", ticker: "CPTKW" },
    { name: "RSLVS - RSE Collection, LLC", ticker: "RSLVS" },
    { name: "BSEM - BIOSTEM TECHNOLOGIES", ticker: "BSEM" },
    { name: "SRLZF - SALAZAR RESOURCES LTD", ticker: "SRLZF" },
    { name: "TMPO - Tempo Automation Holdings, Inc.", ticker: "TMPO" },
    { name: "APLM - Apollomics Inc.", ticker: "APLM" },
    { name: "CDXQ - Nhale, Inc.", ticker: "CDXQ" },
    { name: "GMM - Global Mofy Metaverse Ltd", ticker: "GMM" },
    { name: "SFR - PROPTECH INVESTMENT CORP. II", ticker: "SFR" },
    { name: "PYT - PPLUS Trust Series GSC-2", ticker: "PYT" },
    { name: "SAVU - BioLife4D Corp", ticker: "SAVU" },
    { name: "KLNG - Deep Down, Inc.", ticker: "KLNG" },
    { name: "MTTCF - Steakholder Foods Ltd.", ticker: "MTTCF" },
    { name: "NAMSW - NewAmsterdam Pharma Co N.V.", ticker: "NAMSW" },
    { name: "LNDBS - Landa App LLC", ticker: "LNDBS" },
    { name: "ENBRF - ENBRIDGE INC", ticker: "ENBRF" },
    { name: "EQHAW - EQ Health Acquisition Corp.", ticker: "EQHAW" },
    { name: "FG-WI - F&G Annuities & Life, Inc.", ticker: "FG-WI" },
    { name: "HUGSW - USHG Acquisition Corp.", ticker: "HUGSW" },
    { name: "BKDT - Brookdale Senior Living Inc.", ticker: "BKDT" },
    { name: "EPWR-UN - Empowerment & Inclusion Capital I Corp.", ticker: "EPWR-UN" },
    { name: "EPWR-WT - Empowerment & Inclusion Capital I Corp.", ticker: "EPWR-WT" },
    { name: "DMYY-WT - dMY Squared Technology Group, Inc.", ticker: "DMYY-WT" },
    { name: "QOMOW - Qomolangma Acquisition Corp.", ticker: "QOMOW" },
    { name: "RCVHS - RSE Archive, LLC", ticker: "RCVHS" },
    { name: "ATAQF - Altimar Acquisition Corp. III", ticker: "ATAQF" },
    { name: "DSAQW - Direct Selling Acquisition Corp.", ticker: "DSAQW" },
    { name: "SHWDY - Showa Denko K.K./ADR", ticker: "SHWDY" },
    { name: "NISUY - NIPPON SUISAN KAISHA LTD /ADR/", ticker: "NISUY" },
    { name: "GESI - General European Strategic Investments, Inc.", ticker: "GESI" },
    { name: "HSPO - Horizon Space Acquisition I Corp.", ticker: "HSPO" },
    { name: "EQOSQ - EQONEX Ltd", ticker: "EQOSQ" },
    { name: "TFIN - Triumph Financial, Inc.", ticker: "TFIN" },
    { name: "RLFT - Relief Therapeutics Holding SA", ticker: "RLFT" },
    { name: "ULVR - UNILEVER PLC", ticker: "ULVR" },
    { name: "AGAE - Allied Gaming & Entertainment Inc.", ticker: "AGAE" },
    { name: "PAPL - Pineapple Financial Inc.", ticker: "PAPL" },
    { name: "JXJT - JX Luxventure Ltd", ticker: "JXJT" },
    { name: "ALCY - Alchemy Investments Acquisition Corp 1", ticker: "ALCY" },
    { name: "FBIN - Fortune Brands Home & Security, Inc.", ticker: "FBIN" },
    { name: "IPB - MERRILL LYNCH DEPOSITOR INC INDEXPLUS TRUST SERIES 2003-1", ticker: "IPB" },
    { name: "GJR - STRATS(SM) Trust for Procter & Gamble Securities, Series 2006-1", ticker: "GJR" },
    { name: "SCTL - Societal CDMO, Inc.", ticker: "SCTL" },
    { name: "LEN-B - LENNAR CORP /NEW/", ticker: "LEN-B" },
    { name: "SHWDF - Showa Denko K.K./ADR", ticker: "SHWDF" },
    { name: "AIRTP - AIR T INC", ticker: "AIRTP" },
    { name: "AVHHL - AVITA Medical, Inc.", ticker: "AVHHL" },
    { name: "RSCKS - RSE Collection, LLC", ticker: "RSCKS" },
    { name: "BN-WI - BROOKFIELD ASSET MANAGEMENT INC.", ticker: "BN-WI" },
    { name: "BAM-WI - Brookfield Asset Management Ltd.", ticker: "BAM-WI" },
    { name: "BIOE - Bio Essence Corp", ticker: "BIOE" },
    { name: "SFRWW - Appreciate Holdings, Inc.", ticker: "SFRWW" },
    { name: "EQOSF - EQONEX Ltd", ticker: "EQOSF" },
    { name: "CDZIP - CADIZ INC", ticker: "CDZIP" },
    { name: "RSEXS - RSE Archive, LLC", ticker: "RSEXS" },
    { name: "TWNIF - Tailwind International Acquisition Corp.", ticker: "TWNIF" },
    { name: "LNC-PD - LINCOLN NATIONAL CORP", ticker: "LNC-PD" },
    { name: "SATX-WTA - SatixFy Communications Ltd.", ticker: "SATX-WTA" },
    { name: "TFINP - Triumph Financial, Inc.", ticker: "TFINP" },
    { name: "QOMOR - Qomolangma Acquisition Corp.", ticker: "QOMOR" },
    { name: "WPCAF - Warburg Pincus Capital Corp I-A", ticker: "WPCAF" },
    { name: "FCCND - SPECTRAL CAPITAL Corp", ticker: "FCCND" },
    { name: "REDW - REDWOOD FINANCIAL INC /MN/", ticker: "REDW" },
    { name: "DCSX - Direct Communication Solutions, Inc.", ticker: "DCSX" },
    { name: "AHRO - Global Fiber Technologies, Inc.", ticker: "AHRO" },
    { name: "ATMC - ALPHATIME ACQUISITION CORP", ticker: "ATMC" },
    { name: "VENG - VISION ENERGY Corp", ticker: "VENG" },
    { name: "OLKR - OpenLocker Holdings, Inc.", ticker: "OLKR" },
    { name: "VFS - Vinfast Trading & Investment Pte. Ltd.", ticker: "VFS" },
    { name: "OMH - Ohmyhome Ltd", ticker: "OMH" },
    { name: "WAVC-UN - Waverley Capital Acquisition Corp. 1", ticker: "WAVC-UN" },
    { name: "WAVC-WT - Waverley Capital Acquisition Corp. 1", ticker: "WAVC-WT" },
    { name: "FHSEY - First High-School Education Group Co., Ltd.", ticker: "FHSEY" },
    { name: "RKTA-WT - Rocket Internet Growth Opportunities Corp.", ticker: "RKTA-WT" },
    { name: "RKTA-UN - Rocket Internet Growth Opportunities Corp.", ticker: "RKTA-UN" },
    { name: "EFHTR - EF Hutton Acquisition Corp I", ticker: "EFHTR" },
    { name: "SUNL-WT - Sunlight Financial Holdings Inc.", ticker: "SUNL-WT" },
    { name: "AGAEW - Allied Gaming & Entertainment Inc.", ticker: "AGAEW" },
    { name: "BSAQ-WT - Black Spade Acquisition Co", ticker: "BSAQ-WT" },
    { name: "BSAQ-UN - Black Spade Acquisition Co", ticker: "BSAQ-UN" },
    { name: "NIOIF - NIO Inc.", ticker: "NIOIF" },
    { name: "VIVVS - RSE Archive, LLC", ticker: "VIVVS" },
    { name: "RSVNS - RSE Archive, LLC", ticker: "RSVNS" },
    { name: "REAFS - RSE Archive, LLC", ticker: "REAFS" },
    { name: "RSLLS - RSE Archive, LLC", ticker: "RSLLS" },
    { name: "WPCBF - Warburg Pincus Capital Corp I-B", ticker: "WPCBF" },
    { name: "OSAAW - ProSomnus, Inc.", ticker: "OSAAW" },
    { name: "VST-WTA - Vistra Corp.", ticker: "VST-WTA" },
    { name: "TENKR - TenX Keane Acquisition", ticker: "TENKR" },
    { name: "RWAYZ - Runway Growth Finance Corp.", ticker: "RWAYZ" },
    { name: "CVE-WT - CENOVUS ENERGY INC.", ticker: "CVE-WT" },
    { name: "WRAC-WT - Williams Rowland Acquisition Corp.", ticker: "WRAC-WT" },
    { name: "WRAC-UN - Williams Rowland Acquisition Corp.", ticker: "WRAC-UN" },
    { name: "CNDAW - Concord Acquisition Corp", ticker: "CNDAW" },
    { name: "EGGF-UN - EG Acquisition Corp.", ticker: "EGGF-UN" },
    { name: "EGGF-WT - EG Acquisition Corp.", ticker: "EGGF-WT" },
    { name: "KWESW - KWESST Micro Systems Inc.", ticker: "KWESW" },
    { name: "OEZVY - OSTERREICHISCHE ELEKTRIZITATSWIRTSCHAFTS /FI", ticker: "OEZVY" },
    { name: "CRGO - Freightos Ltd", ticker: "CRGO" },
    { name: "NISM - Newsight Imaging Ltd.", ticker: "NISM" },
    { name: "MLGO - Venus Acquisition Corp", ticker: "MLGO" },
    { name: "SCRP - SCRIPPS SAFE, INC.", ticker: "SCRP" },
    { name: "GETR - InterPrivate II Acquisition Corp.", ticker: "GETR" },
    { name: "KUBR - UONLIVE CORP", ticker: "KUBR" },
    { name: "ZVSA - ZyVersa Therapeutics, Inc.", ticker: "ZVSA" },
    { name: "BENF - Beneficient Co Group, L.P.", ticker: "BENF" },
    { name: "BN - BROOKFIELD Corp /ON/", ticker: "BN" },
    { name: "BFRG - BullFrog AI Holdings, Inc.", ticker: "BFRG" },
    { name: "BNH - BROOKFIELD Corp /ON/", ticker: "BNH" },
    { name: "BNJ - BROOKFIELD Corp /ON/", ticker: "BNJ" },
    { name: "FLAG-WT - First Light Acquisition Group, Inc.", ticker: "FLAG-WT" },
    { name: "FLAG-UN - First Light Acquisition Group, Inc.", ticker: "FLAG-UN" },
    { name: "VYSTD - Vystar Corp", ticker: "VYSTD" },
    { name: "MITID - Mitesco, Inc.", ticker: "MITID" },
    { name: "MBC-WI - MasterBrand, Inc.", ticker: "MBC-WI" },
    { name: "GETR-WT - InterPrivate II Acquisition Corp.", ticker: "GETR-WT" },
    { name: "QNGYQ - Quanergy Systems, Inc.", ticker: "QNGYQ" },
    { name: "NREG - Springs Rejuvenation, Inc.", ticker: "NREG" },
    { name: "WBEVQ - Winc, Inc.", ticker: "WBEVQ" },
    { name: "DEFG - Grayscale Decentralized Finance (DeFi) Fund LLC", ticker: "DEFG" },
    { name: "FNHCQ - FedNat Holding Co", ticker: "FNHCQ" },
    { name: "BNRE - Brookfield Asset Management Reinsurance Partners Ltd.", ticker: "BNRE" },
    { name: "MATH - Metalpha Technology Holding Ltd", ticker: "MATH" },
    { name: "OEZVF - OSTERREICHISCHE ELEKTRIZITATSWIRTSCHAFTS /FI", ticker: "OEZVF" },
    { name: "VHAQ-RT - Viveon Health Acquisition Corp.", ticker: "VHAQ-RT" },
    { name: "VENAF - Venus Acquisition Corp", ticker: "VENAF" },
    { name: "QNGWQ - Quanergy Systems, Inc.", ticker: "QNGWQ" },
    { name: "OTSPS - Otis Gallery LLC", ticker: "OTSPS" },
    { name: "ATHLL - Athene Holding Ltd", ticker: "ATHLL" },
    { name: "EFHTW - EF Hutton Acquisition Corp I", ticker: "EFHTW" },
    { name: "RSABS - RSE Archive, LLC", ticker: "RSABS" },
    { name: "SWAG - Stran & Company, Inc.", ticker: "SWAG" },
    { name: "AMBI - Ambipar Emergency Response", ticker: "AMBI" },
    { name: "MSLPQ - MusclePharm Corp", ticker: "MSLPQ" },
    { name: "KA - YUMANITY THERAPEUTICS, INC.", ticker: "KA" },
    { name: "ETAO - ETAO International Co., Ltd.", ticker: "ETAO" },
    { name: "GDLT - Greifenberg Digital Ltd", ticker: "GDLT" },
    { name: "PRET - PENNSYLVANIA REAL ESTATE INVESTMENT TRUST", ticker: "PRET" },
    { name: "GEHCV - GE Healthcare Holding LLC", ticker: "GEHCV" },
    { name: "ATH-PE - Athene Holding Ltd", ticker: "ATH-PE" },
    { name: "STRYW - Starry Group Holdings, Inc.", ticker: "STRYW" },
    { name: "LANV-WT - Lanvin Group Holdings Ltd", ticker: "LANV-WT" },
    { name: "SAY - SARATOGA INVESTMENT CORP.", ticker: "SAY" },
    { name: "KAHCU - KKR Acquisition Holdings I Corp.", ticker: "KAHCU" },
    { name: "LNDSS - Landa App LLC", ticker: "LNDSS" },
    { name: "GE-WI - GENERAL ELECTRIC CO", ticker: "GE-WI" },
    { name: "SWAGW - Stran & Company, Inc.", ticker: "SWAGW" },
    { name: "ZYRX - GLOBAL EARNINGS CAPITAL LTD.", ticker: "ZYRX" },
    { name: "MSNVF - MISSION READY SOLUTIONS INC", ticker: "MSNVF" },
    { name: "GEGI - Genesis Electronics Group, Inc.", ticker: "GEGI" },
    { name: "DOMH - Dominari Holdings Inc.", ticker: "DOMH" },
    { name: "UCAR - U Power Ltd", ticker: "UCAR" },
    { name: "AMLI - American Lithium Corp.", ticker: "AMLI" },
    { name: "CRML - Critical Metals Corp.", ticker: "CRML" },
    { name: "BCG - Binah Capital Group, Inc.", ticker: "BCG" },
    { name: "HBER - HUBEIER GROUP LTD.", ticker: "HBER" },
    { name: "CLVSQ - Clovis Oncology, Inc.", ticker: "CLVSQ" },
    { name: "XI - Xiao-I Corp", ticker: "XI" },
    { name: "MI - NFT Ltd", ticker: "MI" },
    { name: "QSG - QuantaSing Group Ltd", ticker: "QSG" },
    { name: "EVKG - Ever-Glory International Group, Inc.", ticker: "EVKG" },
    { name: "ZKGCF - ZKGC New Energy Ltd", ticker: "ZKGCF" },
    { name: "FGH - FG Group Holdings Inc.", ticker: "FGH" },
    { name: "LIACF - American Lithium Corp.", ticker: "LIACF" },
    { name: "MIKP - Mike the Pike Productions, Inc.", ticker: "MIKP" },
    { name: "UHAL-B - U-Haul Holding Co /NV/", ticker: "UHAL-B" },
    { name: "GTLS-PB - CHART INDUSTRIES INC", ticker: "GTLS-PB" },
    { name: "GTLCL - CHART INDUSTRIES INC", ticker: "GTLCL" },
    { name: "HSPOU - Horizon Space Acquisition I Corp.", ticker: "HSPOU" },
    { name: "MIMO-WTA - Airspan Networks Holdings Inc.", ticker: "MIMO-WTA" },
    { name: "ATLXD - Atlas Lithium Corp", ticker: "ATLXD" },
    { name: "FACAW - Figure Acquisition Corp. I", ticker: "FACAW" },
    { name: "RDARD - RAADR, INC.", ticker: "RDARD" },
    { name: "GNCAQ - GENOCEA BIOSCIENCES, INC.", ticker: "GNCAQ" },
    { name: "BEIGF - BeiGene, Ltd.", ticker: "BEIGF" },
    { name: "HROWM - HARROW HEALTH, INC.", ticker: "HROWM" },
    { name: "PRETN - PENNSYLVANIA REAL ESTATE INVESTMENT TRUST", ticker: "PRETN" },
    { name: "PRETM - PENNSYLVANIA REAL ESTATE INVESTMENT TRUST", ticker: "PRETM" },
    { name: "PRETL - PENNSYLVANIA REAL ESTATE INVESTMENT TRUST", ticker: "PRETL" },
    { name: "MRDB-WT - MariaDB plc", ticker: "MRDB-WT" },
    { name: "TGIDW - TRIUMPH GROUP INC", ticker: "TGIDW" },
    { name: "ATMVU - AlphaVest Acquisition Corp.", ticker: "ATMVU" },
    { name: "VYBED - Limitless X Holdings Inc.", ticker: "VYBED" },
    { name: "AHLAS - RSE Archive, LLC", ticker: "AHLAS" },
    { name: "ECXWW - ECARX Holdings Inc.", ticker: "ECXWW" },
    { name: "HUDAR - Hudson Acquisition I Corp.", ticker: "HUDAR" },
    { name: "FWPAY - Forward Pharma A/S", ticker: "FWPAY" },
    { name: "ZJYL - Jin Medical International Ltd.", ticker: "ZJYL" },
    { name: "SGD - Safe & Green Development Corp", ticker: "SGD" },
    { name: "QGLD - Quality Gold Holdings, Inc.", ticker: "QGLD" },
    { name: "PODC - Courtside Group, Inc.", ticker: "PODC" },
    { name: "MERQ - Merqueo Holdings", ticker: "MERQ" },
    { name: "SLACW - Social Leverage Acquisition Corp I", ticker: "SLACW" },
    { name: "SLACU - Social Leverage Acquisition Corp I", ticker: "SLACU" },
    { name: "BGSXW - Build Acquisition Corp.", ticker: "BGSXW" },
    { name: "RACJS - RSE Archive, LLC", ticker: "RACJS" },
    { name: "CSSI - COSTAS INC", ticker: "CSSI" },
    { name: "RTC - Fuwei Films (Holdings), Co. Ltd.", ticker: "RTC" },
    { name: "QTNTF - Quotient Ltd", ticker: "QTNTF" },
    { name: "ALTI - Alvarium Tiedemann Holdings, Inc.", ticker: "ALTI" },
    { name: "LIFW - MSP Recovery, Inc.", ticker: "LIFW" },
    { name: "ECLP - Eclipse Bancorp, Inc.", ticker: "ECLP" },
    { name: "CORZQ - Core Scientific, Inc./tx", ticker: "CORZQ" },
    { name: "AULT - Ault Alliance, Inc.", ticker: "AULT" },
    { name: "REII - RENEWABLE INNOVATIONS, INC.", ticker: "REII" },
    { name: "KVUE - Kenvue Inc.", ticker: "KVUE" },
    { name: "BZFL - BOZHI FANGLUE INTERNATIONAL INVESTMENT GROUP CO LTD", ticker: "BZFL" },
    { name: "TBIO - Telesis Bio Inc.", ticker: "TBIO" },
    { name: "STR - Sitio Royalties Corp.", ticker: "STR" },
    { name: "GLXG - Galaxy Payroll Group Ltd", ticker: "GLXG" },
    { name: "ELWS - Earlyworks Co., Ltd.", ticker: "ELWS" },
    { name: "OGBLY - Onion Global Ltd", ticker: "OGBLY" },
    { name: "IMSV - IMMRSIV Inc.", ticker: "IMSV" },
    { name: "RYET - Ruanyun Edal Technology Inc.", ticker: "RYET" },
    { name: "CVTO - Covalto Ltd.", ticker: "CVTO" },
    { name: "ESGL - ESGL Holdings Ltd", ticker: "ESGL" },
    { name: "IRON - Disc Medicine, Inc.", ticker: "IRON" },
    { name: "RKTAW - Rocket Internet Growth Opportunities Corp.", ticker: "RKTAW" },
    { name: "CZOOF - Cazoo Group Ltd", ticker: "CZOOF" },
    { name: "CZOWF - Cazoo Group Ltd", ticker: "CZOWF" },
    { name: "AULT-PD - Ault Alliance, Inc.", ticker: "AULT-PD" },
    { name: "MCLDP - mCloud Technologies Corp.", ticker: "MCLDP" },
    { name: "LIFWZ - MSP Recovery, Inc.", ticker: "LIFWZ" },
    { name: "LIFWW - MSP Recovery, Inc.", ticker: "LIFWW" },
    { name: "CRZWQ - Core Scientific, Inc./tx", ticker: "CRZWQ" },
    { name: "FPACW - Far Peak Acquisition Corp", ticker: "FPACW" },
    { name: "MLECW - Moolec Science SA", ticker: "MLECW" },
    { name: "ALTIW - Alvarium Tiedemann Holdings, Inc.", ticker: "ALTIW" },
    { name: "RSLCS - RSE Archive, LLC", ticker: "RSLCS" },
    { name: "ARHQS - RSE Archive, LLC", ticker: "ARHQS" },
    { name: "AGACW - African Gold Acquisition Corp", ticker: "AGACW" },
    { name: "RXMDD - Progressive Care Inc.", ticker: "RXMDD" },
    { name: "STR-WT - Sitio Royalties Corp.", ticker: "STR-WT" },
    { name: "ATMCU - ALPHATIME ACQUISITION CORP", ticker: "ATMCU" },
    { name: "DSHK - Drive Shack Inc.", ticker: "DSHK" },
    { name: "DSHKO - Drive Shack Inc.", ticker: "DSHKO" },
    { name: "DSHKN - Drive Shack Inc.", ticker: "DSHKN" },
    { name: "DSHKP - Drive Shack Inc.", ticker: "DSHKP" },
    { name: "HMLPF - Hoegh LNG Partners LP", ticker: "HMLPF" },
    { name: "CCFLU - CCF Holdings LLC", ticker: "CCFLU" },
    { name: "ITMSF - INTERMAP TECHNOLOGIES CORP", ticker: "ITMSF" },
    { name: "EGYF - ENERGY FINDERS INC", ticker: "EGYF" },
    { name: "WGS - GeneDx Holdings Corp.", ticker: "WGS" },
    { name: "VTLE - Vital Energy, Inc.", ticker: "VTLE" },
    { name: "ANZGY - ANZ GROUP HOLDINGS LIMITED/ADR", ticker: "ANZGY" },
    { name: "CCLD - CareCloud, Inc.", ticker: "CCLD" },
    { name: "FTEVW - FinTech Evolution Acquisition Group", ticker: "FTEVW" },
    { name: "MMVWW - MultiMetaVerse Holdings Ltd", ticker: "MMVWW" },
    { name: "GLSHW - GELESIS HOLDINGS, INC.", ticker: "GLSHW" },
    { name: "BRMKW - Broadmark Realty Capital Inc.", ticker: "BRMKW" },
    { name: "RNMNS - RSE Archive, LLC", ticker: "RNMNS" },
    { name: "RSADS - RSE Archive, LLC", ticker: "RSADS" },
    { name: "MKUL - Molekule Group, Inc.", ticker: "MKUL" },
    { name: "PMCOF - Prospector Metals Corp.", ticker: "PMCOF" },
    { name: "GDC - GD Culture Group Ltd", ticker: "GDC" },
    { name: "NXT - Nextracker Inc.", ticker: "NXT" },
    { name: "GPCR - Structure Therapeutics Inc.", ticker: "GPCR" },
    { name: "NRXS - Neuraxis, INC", ticker: "NRXS" },
    { name: "QTNTQ - Quotient Ltd", ticker: "QTNTQ" },
    { name: "CHRO - Chromocell Therapeutics Corp", ticker: "CHRO" },
    { name: "MNGO - MANGOCEUTICALS, INC.", ticker: "MNGO" },
    { name: "FDAN - FD TECHNOLOGY INC.", ticker: "FDAN" },
    { name: "RVGO - RVELOCITY, INC.", ticker: "RVGO" },
    { name: "CKDXF - Opthea Ltd", ticker: "CKDXF" },
    { name: "IHLXF - Incannex Healthcare Ltd", ticker: "IHLXF" },
    { name: "ISRLU - Israel Acquisitions Corp", ticker: "ISRLU" },
    { name: "AMRLF - American Lithium Corp.", ticker: "AMRLF" },
    { name: "INAQW - Insight Acquisition Corp. /DE", ticker: "INAQW" },
    { name: "GDCCW - GD Culture Group Ltd", ticker: "GDCCW" },
    { name: "OTGBS - Otis Gallery LLC", ticker: "OTGBS" },
    { name: "WGSWW - GeneDx Holdings Corp.", ticker: "WGSWW" },
    { name: "RWTRP - REDWOOD TRUST INC", ticker: "RWTRP" },
    { name: "VTS-WI - Vitesse Energy, Inc.", ticker: "VTS-WI" },
    { name: "PLTNR - Plutonian Acquisition Corp.", ticker: "PLTNR" },
    { name: "PLTNW - Plutonian Acquisition Corp.", ticker: "PLTNW" },
    { name: "RJACW - Jackson Acquisition Co", ticker: "RJACW" },
    { name: "CCLDO - CareCloud, Inc.", ticker: "CCLDO" },
    { name: "CCLDP - CareCloud, Inc.", ticker: "CCLDP" },
    { name: "BSPKD - Bespoke Extracts, Inc.", ticker: "BSPKD" },
    { name: "FSEA - First Seacoast Bancorp, Inc.", ticker: "FSEA" },
    { name: "SDA - SunCar Technology Group Inc.", ticker: "SDA" },
    { name: "TRNR - Interactive Strength, Inc.", ticker: "TRNR" },
    { name: "SQRX - Squarex Pharmaceutical Corp", ticker: "SQRX" },
    { name: "MLYS - Mineralys Therapeutics, Inc.", ticker: "MLYS" },
    { name: "PRTYQ - Party City Holdco Inc.", ticker: "PRTYQ" },
    { name: "AMNI - AMERICAN NOBLE GAS, INC.", ticker: "AMNI" },
    { name: "AVCTQ - American Virtual Cloud Technologies, Inc.", ticker: "AVCTQ" },
    { name: "HSAI - Hesai Group", ticker: "HSAI" },
    { name: "PNRLF - Premium Nickel Resources Ltd.", ticker: "PNRLF" },
    { name: "ATMCR - ALPHATIME ACQUISITION CORP", ticker: "ATMCR" },
    { name: "ATMCW - ALPHATIME ACQUISITION CORP", ticker: "ATMCW" },
    { name: "PSBYP - PS BUSINESS PARKS, INC./MD", ticker: "PSBYP" },
    { name: "AUB-PA - Atlantic Union Bankshares Corp", ticker: "AUB-PA" },
    { name: "PSBZP - PS BUSINESS PARKS, INC./MD", ticker: "PSBZP" },
    { name: "PSBXP - PS BUSINESS PARKS, INC./MD", ticker: "PSBXP" },
    { name: "FDBLD - Friendable, Inc.", ticker: "FDBLD" },
    { name: "CBDW - 1606 CORP.", ticker: "CBDW" },
    { name: "REAMS - RSE Archive, LLC", ticker: "REAMS" },
    { name: "LDDD - Longduoduo Co Ltd", ticker: "LDDD" },
    { name: "ARTHD - Arch Therapeutics, Inc.", ticker: "ARTHD" },
    { name: "LNDRS - Landa App LLC", ticker: "LNDRS" },
    { name: "SGTM - Sustainable Green Team, Ltd.", ticker: "SGTM" },
    { name: "ENLT - Enlight Renewable Energy Ltd.", ticker: "ENLT" },
    { name: "TCJH - Top KingWin Ltd", ticker: "TCJH" },
    { name: "VGFCQ - Very Good Food Co Inc.", ticker: "VGFCQ" },
    { name: "TCDAQ - Tricida, Inc.", ticker: "TCDAQ" },
    { name: "MIMOW - Airspan Networks Holdings Inc.", ticker: "MIMOW" },
    { name: "AVCWQ - American Virtual Cloud Technologies, Inc.", ticker: "AVCWQ" },
    { name: "RWT-PA - REDWOOD TRUST INC", ticker: "RWT-PA" },
    { name: "CIXXF - CI Financial Corp.", ticker: "CIXXF" },
    { name: "RPET - New Ruipeng Pet Group Inc.", ticker: "RPET" },
    { name: "JETR - Star Jets International Inc.", ticker: "JETR" },
    { name: "ALAR - Safe-T Group Ltd.", ticker: "ALAR" },
    { name: "THNK - T1V, Inc.", ticker: "THNK" },
    { name: "AVTA - BLUCORA, INC.", ticker: "AVTA" },
    { name: "CETYD - Clean Energy Technologies, Inc.", ticker: "CETYD" },
    { name: "BAERW - Wildfire New PubCo, Inc.", ticker: "BAERW" },
    { name: "ATMVR - AlphaVest Acquisition Corp.", ticker: "ATMVR" },
    { name: "QSJC - TANCHENG GROUP CO., LTD.", ticker: "QSJC" },
    { name: "CRGOW - Freightos Ltd", ticker: "CRGOW" },
    { name: "HSPOW - Horizon Space Acquisition I Corp.", ticker: "HSPOW" },
    { name: "HSPOR - Horizon Space Acquisition I Corp.", ticker: "HSPOR" },
    { name: "BFRGW - BullFrog AI Holdings, Inc.", ticker: "BFRGW" },
    { name: "UGEIF - UGE International Ltd.", ticker: "UGEIF" },
    { name: "NFTU - Ultimax Digital, Inc.", ticker: "NFTU" },
    { name: "SFWL - SHENGFENG DEVELOPMENT Ltd", ticker: "SFWL" },
    { name: "HRYU - Hanryu Holdings, Inc.", ticker: "HRYU" },
    { name: "OBIO - Orchestra BioMed Holdings, Inc.", ticker: "OBIO" },
    { name: "SEPA - SEP Acquisition Corp.", ticker: "SEPA" },
    { name: "SEPAU - SEP Acquisition Corp.", ticker: "SEPAU" },
    { name: "SEPAW - SEP Acquisition Corp.", ticker: "SEPAW" },
    { name: "FBGL - FBS Global Ltd", ticker: "FBGL" },
    { name: "SXTP - 60 DEGREES PHARMACEUTICALS, INC.", ticker: "SXTP" },
    { name: "BURU - Nuburu, Inc.", ticker: "BURU" },
    { name: "AESI - Atlas Energy Solutions Inc.", ticker: "AESI" },
    { name: "WOEN - WOLF ENERGY SERVICES INC.", ticker: "WOEN" },
    { name: "APNC - Apeiron Capital Investment Corp.", ticker: "APNC" },
    { name: "CETU - Cetus Capital Acquisition Corp.", ticker: "CETU" },
    { name: "ISPR - Ispire Technology Inc.", ticker: "ISPR" },
    { name: "IVCRQ - INVACARE CORP", ticker: "IVCRQ" },
    { name: "VOCO - Vocodia Holdings Corp", ticker: "VOCO" },
    { name: "RKLYQ - Rockley Photonics Holdings Ltd", ticker: "RKLYQ" },
    { name: "RKLWQ - Rockley Photonics Holdings Ltd", ticker: "RKLWQ" },
    { name: "APNCW - Apeiron Capital Investment Corp.", ticker: "APNCW" },
    { name: "CETUU - Cetus Capital Acquisition Corp.", ticker: "CETUU" },
    { name: "AHLES - RSE Archive, LLC", ticker: "AHLES" },
    { name: "BURU-WT - Nuburu, Inc.", ticker: "BURU-WT" },
    { name: "ZNHYY - CHINA SOUTHERN AIRLINES CO LTD", ticker: "ZNHYY" },
    { name: "AWIN - AERWINS Technologies Inc.", ticker: "AWIN" },
    { name: "MPU - Mega Matrix Corp.", ticker: "MPU" },
    { name: "CWD - CaliberCos Inc.", ticker: "CWD" },
    { name: "BRSFD - BRAIN SCIENTIFIC INC.", ticker: "BRSFD" },
    { name: "LEV-WTA - Lion Electric Co", ticker: "LEV-WTA" },
    { name: "CEAYY - CHINA EASTERN AIRLINES CORP LTD", ticker: "CEAYY" },
    { name: "ATAQ-UN - Altimar Acquisition Corp. III", ticker: "ATAQ-UN" },
    { name: "EFCRP - Ellington Financial Inc.", ticker: "EFCRP" },
    { name: "AWINW - AERWINS Technologies Inc.", ticker: "AWINW" },
    { name: "RARWS - RSE Archive, LLC", ticker: "RARWS" },
    { name: "RSMES - RSE Archive, LLC", ticker: "RSMES" },
    { name: "RSSTS - RSE Archive, LLC", ticker: "RSSTS" },
    { name: "EAXR - Ealixir, Inc.", ticker: "EAXR" },
    { name: "HCNWF - Hypercharge Networks Corp.", ticker: "HCNWF" },
    { name: "USGO - U.S. GoldMining Inc.", ticker: "USGO" },
    { name: "LUNR - Intuitive Machines, Inc.", ticker: "LUNR" },
    { name: "TUEMQ - TUESDAY MORNING CORP/DE", ticker: "TUEMQ" },
    { name: "INQR - InnovaQor, Inc.", ticker: "INQR" },
    { name: "ZBJ - ZBJ FINANCE GROUP LTD", ticker: "ZBJ" },
    { name: "MWG - Multi Ways Holdings Ltd", ticker: "MWG" },
    { name: "LAES - SEALSQ Corp", ticker: "LAES" },
    { name: "WETO - Webus International Ltd.", ticker: "WETO" },
    { name: "FLXG - Flexi Group Holdings Ltd", ticker: "FLXG" },
    { name: "MVLA - Movella Holdings Inc.", ticker: "MVLA" },
    { name: "DRFY - Droneify Holdings Ltd", ticker: "DRFY" },
    { name: "DIST - Distoken Acquisition Corp", ticker: "DIST" },
    { name: "RADX - Radiopharm Theranostics Ltd", ticker: "RADX" },
    { name: "YS - YishengBio Co., Ltd", ticker: "YS" },
    { name: "HXHX - Haoxin Holdings Ltd", ticker: "HXHX" },
    { name: "YZH - YUEZHONGHUI INTERNATIONAL HOLDINGS GROUP LTD", ticker: "YZH" },
    { name: "LEWY - LEEWAY SERVICES, INC.", ticker: "LEWY" },
    { name: "SBXC - SilverBox Corp III", ticker: "SBXC" },
    { name: "LNZA - LanzaTech Global, Inc.", ticker: "LNZA" },
    { name: "EPWK - EPWK Holdings Ltd.", ticker: "EPWK" },
    { name: "ENLTF - Enlight Renewable Energy Ltd.", ticker: "ENLTF" },
    { name: "MARXU - Mars Acquisition Corp.", ticker: "MARXU" },
    { name: "BLACU - Bellevue Life Sciences Acquisition Corp.", ticker: "BLACU" },
    { name: "MBIC - Mobile Infrastructure Corp", ticker: "MBIC" },
    { name: "PRBMU - Parabellum Acquisition Corp.", ticker: "PRBMU" },
    { name: "OUST-WTA - Ouster, Inc.", ticker: "OUST-WTA" },
    { name: "MVLAW - Movella Holdings Inc.", ticker: "MVLAW" },
    { name: "HWKED - Hawkeye Systems, Inc.", ticker: "HWKED" },
    { name: "GRI - Vallon Pharmaceuticals, Inc.", ticker: "GRI" },
    { name: "LUNRW - Intuitive Machines, Inc.", ticker: "LUNRW" },
    { name: "PTHRU - Pono Capital Three, Inc.", ticker: "PTHRU" },
    { name: "EFC-PC - Ellington Financial Inc.", ticker: "EFC-PC" },
    { name: "LNZAW - LanzaTech Global, Inc.", ticker: "LNZAW" },
    { name: "ANZGF - ANZ GROUP HOLDINGS LIMITED/ADR", ticker: "ANZGF" },
    { name: "AHTR - American Healthcare REIT, Inc.", ticker: "AHTR" },
    { name: "ADRAW - ALLIANCE ENTERTAINMENT HOLDING CORP", ticker: "ADRAW" },
    { name: "DCSXD - Direct Communication Solutions, Inc.", ticker: "DCSXD" },
    { name: "INFT - Infinity Bancorp", ticker: "INFT" },
    { name: "OAKUO - Oak Woods Acquisition Corp", ticker: "OAKUO" },
    { name: "HARD - Harden Technologies Inc.", ticker: "HARD" },
    { name: "NVDED - NEVADA EXPLORATION INC", ticker: "NVDED" },
    { name: "RUSA - IWAC HOLDINGS INC.", ticker: "RUSA" },
    { name: "OCEA - Ocean Biomedical, Inc.", ticker: "OCEA" },
    { name: "FBYD - Falcon's Beyond Global, Inc.", ticker: "FBYD" },
    { name: "CLCO - Cool Co Ltd.", ticker: "CLCO" },
    { name: "HGRN - Healthy Green Group Holding Ltd", ticker: "HGRN" },
    { name: "STRYQ - Starry Group Holdings, Inc.", ticker: "STRYQ" },
    { name: "AVYAQ - Avaya Holdings Corp.", ticker: "AVYAQ" },
    { name: "CATX - Perspective Therapeutics, Inc.", ticker: "CATX" },
    { name: "JYD - Jayud Global Logistics Ltd", ticker: "JYD" },
    { name: "MGRX - MANGOCEUTICALS, INC.", ticker: "MGRX" },
    { name: "ETZ - Earntz Healthcare Products, Inc.", ticker: "ETZ" },
    { name: "IAMR - Medical Industries of the Americas", ticker: "IAMR" },
    { name: "VGAS - Verde Clean Fuels, Inc.", ticker: "VGAS" },
    { name: "CASK - Heritage Distilling Group, Inc.", ticker: "CASK" },
    { name: "MBGH - American Metals Recovery & Recycling Inc.", ticker: "MBGH" },
    { name: "RSLBS - RSE Archive, LLC", ticker: "RSLBS" },
    { name: "OCEAW - Ocean Biomedical, Inc.", ticker: "OCEAW" },
    { name: "BXXYD - Boxxy Inc.", ticker: "BXXYD" },
    { name: "PKPHD - PEAK PHARMACEUTICALS, INC.", ticker: "PKPHD" },
    { name: "SLNDW - Southland Holdings, Inc.", ticker: "SLNDW" },
    { name: "WTID - BANK OF MONTREAL /CAN/", ticker: "WTID" },
    { name: "WTIU - BANK OF MONTREAL /CAN/", ticker: "WTIU" },
    { name: "PTNRY - PARTNER COMMUNICATIONS CO LTD", ticker: "PTNRY" },
    { name: "VGASW - Verde Clean Fuels, Inc.", ticker: "VGASW" },
    { name: "SNMN - SNM Global Holdings", ticker: "SNMN" },
    { name: "GTRL - Get Real USA, Inc.", ticker: "GTRL" },
    { name: "QDRO - Quadro Acquisition One Corp.", ticker: "QDRO" },
    { name: "LXXGQ - LexaGene Holdings Inc.", ticker: "LXXGQ" },
    { name: "ELVN - Enliven Therapeutics, Inc.", ticker: "ELVN" },
    { name: "ZVRA - ZEVRA THERAPEUTICS, INC.", ticker: "ZVRA" },
    { name: "NTV - Neotv Group Ltd", ticker: "NTV" },
    { name: "NNAG - 99 Acquisition Group Inc.", ticker: "NNAG" },
    { name: "KPN - Kepuni Holdings Inc.", ticker: "KPN" },
    { name: "AGLY - Shengshi Elevator International Holding Group Inc.", ticker: "AGLY" },
    { name: "ATMU - Atmus Filtration Technologies Inc.", ticker: "ATMU" },
    { name: "UPBD - UPBOUND GROUP, INC.", ticker: "UPBD" },
    { name: "SRNEQ - Sorrento Therapeutics, Inc.", ticker: "SRNEQ" },
    { name: "HYREQ - HyreCar Inc.", ticker: "HYREQ" },
    { name: "BSME - MED EIBY Holding Co., Ltd", ticker: "BSME" },
    { name: "AIXI - Xiao-I Corp", ticker: "AIXI" },
    { name: "TIO - MICT, Inc.", ticker: "TIO" },
    { name: "TETAB - Teton Advisors, Inc.", ticker: "TETAB" },
    { name: "CRCE - Circle Energy, Inc./NV", ticker: "CRCE" },
    { name: "RCKTW - ROCKET PHARMACEUTICALS, INC.", ticker: "RCKTW" },
    { name: "ABNAD - Aben Resources Ltd.", ticker: "ABNAD" },
    { name: "DULL - BANK OF MONTREAL /CAN/", ticker: "DULL" },
    { name: "SHNY - BANK OF MONTREAL /CAN/", ticker: "SHNY" },
    { name: "TPCSD - TECHPRECISION CORP", ticker: "TPCSD" },
    { name: "RSLXS - RSE Archive, LLC", ticker: "RSLXS" },
    { name: "QDROU - Quadro Acquisition One Corp.", ticker: "QDROU" },
    { name: "QDROW - Quadro Acquisition One Corp.", ticker: "QDROW" },
    { name: "STYWQ - Starry Group Holdings, Inc.", ticker: "STYWQ" },
    { name: "KOZAY - Koza Altin Isletmeleri A.S./ADR", ticker: "KOZAY" },
    { name: "BHRB - Burke & Herbert Financial Services Corp.", ticker: "BHRB" },
    { name: "PSIG - PSI Group Holdings Ltd.", ticker: "PSIG" },
    { name: "LGCL - Lucas GC Ltd", ticker: "LGCL" },
    { name: "NSTD.U - Northern Star Investment Corp. IV", ticker: "NSTD.U" },
    { name: "ODDB - Odd Burger Corp", ticker: "ODDB" },
    { name: "ASII - Accredited Solutions, Inc.", ticker: "ASII" },
    { name: "ODDAF - Odd Burger Corp", ticker: "ODDAF" },
    { name: "LVROW - Lavoro Ltd", ticker: "LVROW" },
    { name: "TOROV - TORO CORP.", ticker: "TOROV" },
    { name: "SLND-WT - Southland Holdings, Inc.", ticker: "SLND-WT" },
    { name: "ARBH - ASSISTED 4 LIVING, INC.", ticker: "ARBH" },
    { name: "HUBCW - Hub Cyber Security Ltd.", ticker: "HUBCW" },
    { name: "SBXC-UN - SilverBox Corp III", ticker: "SBXC-UN" },
    { name: "PICCU - Pivotal Investment Corp III", ticker: "PICCU" },
    { name: "ISRLW - Israel Acquisitions Corp", ticker: "ISRLW" },
    { name: "GSHRF - GOLDSHORE RESOURCES INC.", ticker: "GSHRF" },
    { name: "LHDXQ - Lucira Health, Inc.", ticker: "LHDXQ" },
    { name: "DAZS - DA AI ZHI SHUI INTERNATIONAL HOLDING GROUP LTD", ticker: "DAZS" },
    { name: "QTM - CH AUTO Inc.", ticker: "QTM" },
    { name: "OCSAW - Oculis Holding AG", ticker: "OCSAW" },
    { name: "ASBA - ASSOCIATED BANC-CORP", ticker: "ASBA" },
    { name: "HUBCZ - Hub Cyber Security Ltd.", ticker: "HUBCZ" },
    { name: "CTRMV - Castor Maritime Inc.", ticker: "CTRMV" },
    { name: "TMDIF - TITAN MEDICAL INC", ticker: "TMDIF" },
    { name: "CARM - Carisma Therapeutics Inc.", ticker: "CARM" },
    { name: "HSHP - Himalaya Shipping Ltd.", ticker: "HSHP" },
    { name: "ZKH - ZKH Group Ltd", ticker: "ZKH" },
    { name: "CAJPY - CANON INC", ticker: "CAJPY" },
    { name: "SHLT - SHL TELEMEDICINE LTD", ticker: "SHLT" },
    { name: "SMDCF - SHL TELEMEDICINE LTD", ticker: "SMDCF" },
    { name: "GMSQF - GameSquare Esports Inc", ticker: "GMSQF" },
    { name: "XTXXF - Adastra Holdings Ltd.", ticker: "XTXXF" },
    { name: "HBNJL - HUNTINGTON BANCSHARES INC /MD/", ticker: "HBNJL" },
    { name: "HBANL - HUNTINGTON BANCSHARES INC /MD/", ticker: "HBANL" },
    { name: "AMBI-WT - Ambipar Emergency Response", ticker: "AMBI-WT" },
    { name: "FCRX - Crescent Capital BDC, Inc.", ticker: "FCRX" },
    { name: "RRSAS - RSE Archive, LLC", ticker: "RRSAS" },
    { name: "RGBAD - Regen BioPharma Inc", ticker: "RGBAD" },
    { name: "RGBPD - Regen BioPharma Inc", ticker: "RGBPD" },
    { name: "SMXWW - SMX (Security Matters) Public Ltd Co", ticker: "SMXWW" },
    { name: "INPXV - INPIXON", ticker: "INPXV" },
    { name: "CIVIW - CIVITAS RESOURCES, INC.", ticker: "CIVIW" },
    { name: "CIVII - CIVITAS RESOURCES, INC.", ticker: "CIVII" },
    { name: "CYRNQ - CYREN Ltd.", ticker: "CYRNQ" },
    { name: "LOBO - LOBO EV TECHNOLOGIES LTD", ticker: "LOBO" },
    { name: "CXAI - KINS Technology Group, Inc.", ticker: "CXAI" },
    { name: "MDRI - Midori Group Inc.", ticker: "MDRI" },
    { name: "TRSG - Tungray Technologies Inc", ticker: "TRSG" },
    { name: "AUMB - AUM Biosciences Ltd", ticker: "AUMB" },
    { name: "DTCK - DAVIS COMMODITIES Ltd", ticker: "DTCK" },
    { name: "KNF - Knife River Holding Co", ticker: "KNF" },
    { name: "UMAV - UAV Corp", ticker: "UMAV" },
    { name: "OLSI - Origin, Inc.", ticker: "OLSI" },
    { name: "PAVS - Paranovus Entertainment Technology Ltd.", ticker: "PAVS" },
    { name: "SRBK - SR Bancorp, Inc.", ticker: "SRBK" },
    { name: "LEC - LAFAYETTE ENERGY CORP.", ticker: "LEC" },
    { name: "EGOX - Next.e.GO B.V.", ticker: "EGOX" },
    { name: "CJET - Chijet Motor Company, Inc.", ticker: "CJET" },
    { name: "PTCHF - PureTech Health plc", ticker: "PTCHF" },
    { name: "GSCCF - ioneer Ltd", ticker: "GSCCF" },
    { name: "RRHHS - RSE Archive, LLC", ticker: "RRHHS" },
    { name: "JXNFL - Jackson Financial Inc.", ticker: "JXNFL" },
    { name: "PLM-RW - POLYMET MINING CORP", ticker: "PLM-RW" },
    { name: "FAVTV - FTAI Aviation Ltd.", ticker: "FAVTV" },
    { name: "LMND-WT - Lemonade, Inc.", ticker: "LMND-WT" },
    { name: "MARXR - Mars Acquisition Corp.", ticker: "MARXR" },
    { name: "BACAW - Berenson Acquisition Corp. I", ticker: "BACAW" },
    { name: "BMXCD - Bemax, Inc.", ticker: "BMXCD" },
    { name: "AITR - AI Transportation Acquisition Corp", ticker: "AITR" },
    { name: "UMAC - Unusual Machines, Inc.", ticker: "UMAC" },
    { name: "CKHL - Chi Ko Holdings Ltd", ticker: "CKHL" },
    { name: "SHCO - Soho House & Co Inc.", ticker: "SHCO" },
    { name: "AENT - ALLIANCE ENTERTAINMENT HOLDING CORP", ticker: "AENT" },
    { name: "ABLV - Able View Global Inc.", ticker: "ABLV" },
    { name: "NB - NIOCORP DEVELOPMENTS LTD", ticker: "NB" },
    { name: "PLPL - Plandai Biotechnology, Inc.", ticker: "PLPL" },
    { name: "CXAIW - CXApp Inc.", ticker: "CXAIW" },
    { name: "PLM-RI - POLYMET MINING CORP", ticker: "PLM-RI" },
    { name: "FTAIM - FTAI Aviation Ltd.", ticker: "FTAIM" },
    { name: "SSRGF - SSR MINING INC.", ticker: "SSRGF" },
    { name: "BLACR - Bellevue Life Sciences Acquisition Corp.", ticker: "BLACR" },
    { name: "BLACW - Bellevue Life Sciences Acquisition Corp.", ticker: "BLACW" },
    { name: "YSBPW - YS Biopharma Co., Ltd.", ticker: "YSBPW" },
    { name: "ATAOD - ALTAIR INTERNATIONAL CORP.", ticker: "ATAOD" },
    { name: "RSMMS - RSE Archive, LLC", ticker: "RSMMS" },
    { name: "FORLU - Four Leaf Acquisition Corp", ticker: "FORLU" },
    { name: "CASI - CASI Pharmaceuticals, Inc.", ticker: "CASI" },
    { name: "KNGRF - Kingsmen Resources Ltd.", ticker: "KNGRF" },
    { name: "HNOI - HNO International, Inc.", ticker: "HNOI" },
    { name: "VEST - Vestiage, Inc.", ticker: "VEST" },
    { name: "MOCI - Energy Holdings, Inc.", ticker: "MOCI" },
    { name: "CALC - CalciMedica, Inc. /DE/", ticker: "CALC" },
    { name: "ZAPP - Zapp Electric Vehicles Group Ltd", ticker: "ZAPP" },
    { name: "BNMV - BitNile Metaverse, Inc.", ticker: "BNMV" },
    { name: "ZURA - Zura Bio Ltd", ticker: "ZURA" },
    { name: "CRGT - Cortigent, Inc.", ticker: "CRGT" },
    { name: "NRHI - Natural Resource Holdings, Inc.", ticker: "NRHI" },
    { name: "STHO - Star Holdings", ticker: "STHO" },
    { name: "OBSVF - ObsEva SA", ticker: "OBSVF" },
    { name: "LYLTQ - Loyalty Ventures Inc.", ticker: "LYLTQ" },
    { name: "NIOBW - NIOCORP DEVELOPMENTS LTD", ticker: "NIOBW" },
    { name: "JXN-PA - Jackson Financial Inc.", ticker: "JXN-PA" },
    { name: "ZURAW - Zura Bio Ltd", ticker: "ZURAW" },
    { name: "BOXDW - Boxed, Inc.", ticker: "BOXDW" },
    { name: "SJIIU - SOUTH JERSEY INDUSTRIES INC", ticker: "SJIIU" },
    { name: "SSRT - Streetex Corp.", ticker: "SSRT" },
    { name: "RSELS - RSE Archive, LLC", ticker: "RSELS" },
    { name: "GDLG - Glidelogic Corp.", ticker: "GDLG" },
    { name: "USEE - USEE ELECTRONIC COMMERCE LTD", ticker: "USEE" },
    { name: "NIR - Near Intelligence, Inc.", ticker: "NIR" },
    { name: "PHCFF - Puhui Wealth Investment Management Co., Ltd.", ticker: "PHCFF" },
    { name: "TBMC - Trailblazer Merger Corp I", ticker: "TBMC" },
    { name: "CCTG - CCSC Technology International Holdings Ltd", ticker: "CCTG" },
    { name: "OAKU - Oak Woods Acquisition Corp", ticker: "OAKU" },
    { name: "DSWR - Deseo Swimwear Inc.", ticker: "DSWR" },
    { name: "NTCL - NetClass Technology Inc", ticker: "NTCL" },
    { name: "SZL - Sezzle Inc.", ticker: "SZL" },
    { name: "BDRX - Biodexa Pharmaceuticals Plc", ticker: "BDRX" },
    { name: "SIVBQ - SVB FINANCIAL GROUP", ticker: "SIVBQ" },
    { name: "MYZQF - Advanced Health Intelligence Ltd", ticker: "MYZQF" },
    { name: "OAKUU - Oak Woods Acquisition Corp", ticker: "OAKUU" },
    { name: "CETUW - Cetus Capital Acquisition Corp.", ticker: "CETUW" },
    { name: "CETUR - Cetus Capital Acquisition Corp.", ticker: "CETUR" },
    { name: "CR-WI - Crane Co", ticker: "CR-WI" },
    { name: "AENTW - ALLIANCE ENTERTAINMENT HOLDING CORP", ticker: "AENTW" },
    { name: "CXT-WI - Crane Holdings, Co.", ticker: "CXT-WI" },
    { name: "STHOV - Star Holdings", ticker: "STHOV" },
    { name: "KNGRD - Kingsmen Resources Ltd.", ticker: "KNGRD" },
    { name: "WUCT - UBS AG", ticker: "WUCT" },
    { name: "TMTCU - TMT Acquisition Corp.", ticker: "TMTCU" },
    { name: "NIRWW - Near Intelligence, Inc.", ticker: "NIRWW" },
    { name: "NAIFX - Nomura Alternative Income Fund", ticker: "NAIFX" },
    { name: "SIVPQ - SVB FINANCIAL GROUP", ticker: "SIVPQ" },
    { name: "KGS - Kodiak Gas Services, Inc.", ticker: "KGS" },
    { name: "GFCX - GoodFaith Technology Inc.", ticker: "GFCX" },
    { name: "VOCL - Creatd, Inc.", ticker: "VOCL" },
    { name: "AACT - Ares Acquisition Corp II", ticker: "AACT" },
    { name: "MCOM - micromobility.com Inc.", ticker: "MCOM" },
    { name: "SUNH - Xuhang Holdings Ltd", ticker: "SUNH" },
    { name: "MTEN - Mingteng International Corp Inc.", ticker: "MTEN" },
    { name: "EGSE - Evergreen Sustainable Enterprises, Inc.", ticker: "EGSE" },
    { name: "OSTX - OS Therapies Inc", ticker: "OSTX" },
    { name: "MEXGD - Mexican Gold Mining Corp.", ticker: "MEXGD" },
    { name: "SEQP - Santana Equestrian Private Financial, LLC", ticker: "SEQP" },
    { name: "MIESY - Mitsui E&S Holdings Co., Ltd./ADR", ticker: "MIESY" },
    { name: "HUHU - HUHUTECH International Group Inc.", ticker: "HUHU" },
    { name: "LBIO - Denali SPAC Holdco, Inc.", ticker: "LBIO" },
    { name: "UHG - DiamondHead Holdings Corp.", ticker: "UHG" },
    { name: "SAFE - ISTAR INC.", ticker: "SAFE" },
    { name: "MCOMW - micromobility.com Inc.", ticker: "MCOMW" },
    { name: "DISTW - Distoken Acquisition Corp", ticker: "DISTW" },
    { name: "DISTR - Distoken Acquisition Corp", ticker: "DISTR" },
    { name: "HSPPF - Himalaya Shipping Ltd.", ticker: "HSPPF" },
    { name: "APLMW - Apollomics Inc.", ticker: "APLMW" },
    { name: "UHGWW - DiamondHead Holdings Corp.", ticker: "UHGWW" },
    { name: "QBAND - Telco Cuba, Inc.", ticker: "QBAND" },
    { name: "RPKYS - RSE Archive, LLC", ticker: "RPKYS" },
    { name: "CR - Crane Co", ticker: "CR" },
    { name: "TWNFF - Tailwind International Acquisition Corp.", ticker: "TWNFF" },
    { name: "SPPL - SIMPPLE LTD.", ticker: "SPPL" },
    { name: "EDGM - Edgemode, Inc.", ticker: "EDGM" },
    { name: "CXT - Crane NXT, Co.", ticker: "CXT" },
    { name: "BOXDQ - Boxed, Inc.", ticker: "BOXDQ" },
    { name: "CDAKQ - Codiak BioSciences, Inc.", ticker: "CDAKQ" },
    { name: "OCTO - Eightco Holdings Inc.", ticker: "OCTO" },
    { name: "MIESF - Mitsui E&S Holdings Co., Ltd./ADR", ticker: "MIESF" },
    { name: "PTHRW - Pono Capital Three, Inc.", ticker: "PTHRW" },
    { name: "HAZH - HAZ Holdings Inc", ticker: "HAZH" },
    { name: "BOXWQ - Boxed, Inc.", ticker: "BOXWQ" },
    { name: "LSEB - LSEB Creative Corp.", ticker: "LSEB" },
    { name: "LAAOF - Li Auto Inc.", ticker: "LAAOF" },
    { name: "ITOR - Intorio, Corp.", ticker: "ITOR" },
    { name: "ITTOY - ITOCHU Techno-Solutions Corporation/ADR", ticker: "ITTOY" },
    { name: "NGKSY - NGK Spark Plug Co., Ltd.", ticker: "NGKSY" },
    { name: "BCAL - Southern California Bancorp \\ CA", ticker: "BCAL" },
    { name: "SLRN - ACELYRIN, Inc.", ticker: "SLRN" },
    { name: "GLSH - GELESIS HOLDINGS, INC.", ticker: "GLSH" },
    { name: "PLXPQ - PLx Pharma Inc.", ticker: "PLXPQ" },
    { name: "CTNT - CHEETAH NET SUPPLY CHAIN SERVICE INC.", ticker: "CTNT" },
    { name: "CISS - C3is Inc.", ticker: "CISS" },
    { name: "PKST - Peakstone Realty Trust", ticker: "PKST" },
    { name: "FIHL - Fidelis Insurance Holdings Ltd", ticker: "FIHL" },
    { name: "MNGA - MNG Havayollari ve Tasimacilik A.S.", ticker: "MNGA" },
    { name: "IPXX - Inflection Point Acquisition Corp. II", ticker: "IPXX" },
    { name: "IVP - INSPIRE VETERINARY PARTNERS, INC.", ticker: "IVP" },
    { name: "ELK - Elk Valley Resources Ltd.", ticker: "ELK" },
    { name: "BGC - BGC Group, Inc.", ticker: "BGC" },
    { name: "KALRQ - Kalera Public Ltd Co", ticker: "KALRQ" },
    { name: "VORBQ - Virgin Orbit Holdings, Inc.", ticker: "VORBQ" },
    { name: "GIAF - GigCapital5, Inc.", ticker: "GIAF" },
    { name: "DTEAF - DAVIDsTEA Inc.", ticker: "DTEAF" },
    { name: "ILLM - AcuityAds Holdings Inc.", ticker: "ILLM" },
    { name: "ARHFS - RSE Archive, LLC", ticker: "ARHFS" },
    { name: "SSTC - SensaSure Technologies, Inc.", ticker: "SSTC" },
    { name: "AMXOF - AMERICA MOVIL SAB DE CV/", ticker: "AMXOF" },
    { name: "GIAFU - GigCapital5, Inc.", ticker: "GIAFU" },
    { name: "PEARQ - Pear Therapeutics, Inc.", ticker: "PEARQ" },
    { name: "LZM - Lifezone Metals Ltd", ticker: "LZM" },
    { name: "LCIN - LANNETT CO INC", ticker: "LCIN" },
    { name: "YIBO - Planet Image International Ltd", ticker: "YIBO" },
    { name: "AFTCD - ConneXionONE Corp.", ticker: "AFTCD" },
    { name: "WTKWY - WOLTERS KLUWER N V /FI", ticker: "WTKWY" },
    { name: "MSGE - Madison Square Garden Entertainment Corp.", ticker: "MSGE" },
    { name: "SPHR - Sphere Entertainment Co.", ticker: "SPHR" },
    { name: "GTAGF - GOLDEN TAG RESOURCES LTD.", ticker: "GTAGF" },
    { name: "LBWR - Labwire Inc", ticker: "LBWR" },
    { name: "NO - CATALYST PHARMACEUTICALS, INC.", ticker: "NO" },
    { name: "BOF - BranchOut Food Inc.", ticker: "BOF" },
    { name: "XJET - XJet Ltd.", ticker: "XJET" },
    { name: "JPO - JP Outfitters, Inc.", ticker: "JPO" },
    { name: "GSOL - Grayscale Solana Trust (SOL)", ticker: "GSOL" },
    { name: "MYCB - My City Builders, Inc.", ticker: "MYCB" },
    { name: "IMPM - IMPAC MORTGAGE HOLDINGS INC", ticker: "IMPM" },
    { name: "LUDG - LUDWIG ENTERPRISES, INC.", ticker: "LUDG" },
    { name: "NWGL - Nature Wood Group Ltd", ticker: "NWGL" },
    { name: "CLB - Core Laboratories Inc. /DE/", ticker: "CLB" },
    { name: "BLTH - AMERICAN BATTERY MATERIALS, INC.", ticker: "BLTH" },
    { name: "SLNX - Solanbridge Group, Inc.", ticker: "SLNX" },
    { name: "BBBYQ - BED BATH & BEYOND INC", ticker: "BBBYQ" },
    { name: "GODN - Golden Star Acquisition Corp", ticker: "GODN" },
    { name: "ITCL - BANCO ITAU CHILE", ticker: "ITCL" },
    { name: "SMBMY - SembCorp Marine Ltd.", ticker: "SMBMY" },
    { name: "BTQQF - Sonora Gold & Silver Corp.", ticker: "BTQQF" },
    { name: "MJID - Majestic Ideal Holdings Ltd", ticker: "MJID" },
    { name: "SWIN - Solowin Holdings, Ltd.", ticker: "SWIN" },
    { name: "SLDC - Telco Cuba, Inc.", ticker: "SLDC" },
    { name: "FRCB - FIRST REPUBLIC BANK", ticker: "FRCB" },
    { name: "WOK - WORK Medical Technology Group LTD", ticker: "WOK" },
    { name: "EHGO - EShallGo Inc.", ticker: "EHGO" },
    { name: "AERS - Aerius International Inc.", ticker: "AERS" },
    { name: "GMZP - GEMZ Corp", ticker: "GMZP" },
    { name: "AMGS - Prospect Energy Holdings Corp.", ticker: "AMGS" },
    { name: "WBUY - WEBUY GLOBAL LTD", ticker: "WBUY" },
    { name: "LCINQ - LANNETT CO INC", ticker: "LCINQ" },
    { name: "SHZNY - Shenzhen Expressway Co. / ADR", ticker: "SHZNY" },
    { name: "IMVIQ - IMV Inc.", ticker: "IMVIQ" },
    { name: "SICP - Silvergate Capital Corp", ticker: "SICP" },
    { name: "YQAI - YOUNEEQAI TECHNICAL SERVICES, INC.", ticker: "YQAI" },
    { name: "SSHT - SSHT S&T Group Ltd.", ticker: "SSHT" },
    { name: "CNNN - ConneXionONE Corp.", ticker: "CNNN" },
    { name: "CBIA - Blue Heaven Coffee, Inc.", ticker: "CBIA" },
    { name: "AZTR - Azitra Inc", ticker: "AZTR" },
    { name: "ATCH - Calculator New Pubco, Inc.", ticker: "ATCH" },
    { name: "ALUR - ALLURION TECHNOLOGIES HOLDINGS, INC.", ticker: "ALUR" },
    { name: "RVTY - REVVITY, INC.", ticker: "RVTY" },
    { name: "SSII - SS Innovations International, Inc.", ticker: "SSII" },
    { name: "SYRA - Syra Health Corp", ticker: "SYRA" },
    { name: "VNTRQ - Venator Materials PLC", ticker: "VNTRQ" },
    { name: "TKO - New Whale Inc.", ticker: "TKO" },
    { name: "MGRM - MONOGRAM ORTHOPAEDICS INC", ticker: "MGRM" },
    { name: "STA - HWEL Holdings Corp.", ticker: "STA" },
    { name: "ULY - Urgent.ly Inc.", ticker: "ULY" },
    { name: "FPAQ - FPA ENERGY ACQUISITION CORP.", ticker: "FPAQ" },
    { name: "SDS - Signing Day Sports, Inc.", ticker: "SDS" },
    { name: "FTRE - Fortrea Holdings Inc.", ticker: "FTRE" },
    { name: "AUDA - AUDACY, INC.", ticker: "AUDA" },
    { name: "WDSP - World Scan Project, Inc.", ticker: "WDSP" },
    { name: "JBSAY - JBS S.A.", ticker: "JBSAY" },
    { name: "INVVY - INDIVIOR PLC", ticker: "INVVY" },
    { name: "OBK - Origin Bancorp, Inc.", ticker: "OBK" },
    { name: "RAASY - Cloopen Group Holding Ltd", ticker: "RAASY" },
    { name: "VSMR - VERIFY SMART CORP.", ticker: "VSMR" },
    { name: "FGDL - Franklin Templeton Holdings Trust", ticker: "FGDL" },
    { name: "DVGR - Digital Virgo Group S.A.", ticker: "DVGR" },
    { name: "ADVB - Advanced Biomed Inc.", ticker: "ADVB" },
    { name: "ABBNY - ABB LTD", ticker: "ABBNY" },
    { name: "PHIN - PHINIA INC.", ticker: "PHIN" },
    { name: "CAVA - CAVA GROUP, INC.", ticker: "CAVA" },
    { name: "CSTF - CuraScientific Corp.", ticker: "CSTF" },
    { name: "TYGO - Roth CH Acquisition IV Co.", ticker: "TYGO" },
    { name: "NHIQ - NantHealth, Inc.", ticker: "NHIQ" },
    { name: "CNVS - Cineverse Corp.", ticker: "CNVS" },
    { name: "VSTE - Vast Solar Pty Ltd", ticker: "VSTE" },
    { name: "FRES - Fresh2 Group Ltd", ticker: "FRES" },
    { name: "BOWN - Bowen Acquisition Corp", ticker: "BOWN" },
    { name: "MSS - Maison Solutions Inc.", ticker: "MSS" },
    { name: "ATS - ATS Corp /ATS", ticker: "ATS" },
    { name: "ATNXQ - Athenex, Inc.", ticker: "ATNXQ" },
    { name: "SRM - SRM Entertainment, Inc.", ticker: "SRM" },
    { name: "AFJK - Aimei Health Technology Co., Ltd.", ticker: "AFJK" },
    { name: "BBUZ - Engage Mobility, Inc.", ticker: "BBUZ" },
    { name: "INDV - INDIVIOR PLC", ticker: "INDV" },
    { name: "INTJ - Intelligent Group Ltd", ticker: "INTJ" },
    { name: "GENK - GEN Restaurant Group, Inc.", ticker: "GENK" },
    { name: "MNKA - Manuka, Inc.", ticker: "MNKA" },
    { name: "SBGI - Sinclair, Inc.", ticker: "SBGI" },
    { name: "MRRTY - MARFRIG GLOBAL FOODS S.A.", ticker: "MRRTY" },
    { name: "ELTX - Elicio Therapeutics, Inc.", ticker: "ELTX" },
    { name: "SLBK - Skyline Bankshares, Inc.", ticker: "SLBK" },
    { name: "CBUS - Cibus, Inc.", ticker: "CBUS" },
    { name: "NSGP - Clean Coal Technologies Inc.", ticker: "NSGP" },
    { name: "GRCYF - Greencity Acquisition Corp", ticker: "GRCYF" },
    { name: "GOVB - Gouverneur Bancorp, Inc./MD/", ticker: "GOVB" },
    { name: "AIRO - AIRO Group, Inc.", ticker: "AIRO" },
    { name: "DBDQQ - DIEBOLD NIXDORF, Inc", ticker: "DBDQQ" },
    { name: "MRNJ - Metatron Apps, Inc.", ticker: "MRNJ" },
    { name: "QTEKQ - QualTek Services Inc.", ticker: "QTEKQ" },
    { name: "SMCE - SMC Entertainment, Inc.", ticker: "SMCE" },
    { name: "TRFE - Trustfeed Corp.", ticker: "TRFE" },
    { name: "RINO - JOIN Entertainment Holdings, Inc.", ticker: "RINO" },
    { name: "MTWO - INKY INC.", ticker: "MTWO" },
    { name: "VTMX - Vesta Real Estate Corporation, S.A.B. de C.V.", ticker: "VTMX" },
    { name: "PXDT - PIXIE DUST TECHNOLOGIES, INC.", ticker: "PXDT" },
    { name: "FI - FISERV INC", ticker: "FI" },
    { name: "NPWR - NET Power Inc.", ticker: "NPWR" },
    { name: "SMDRF - SIERRA MADRE GOLD & SILVER LTD.", ticker: "SMDRF" },
    { name: "GCGJ - Charmt, Inc.", ticker: "GCGJ" },
    { name: "ROMA - Roma Green Finance Ltd", ticker: "ROMA" },
    { name: "DDCIU - Diffuse Digital 30, LP", ticker: "DDCIU" },
    { name: "WEJOQ - Wejo Group Ltd", ticker: "WEJOQ" },
    { name: "MDRN - Modern Mining Technology Corp.", ticker: "MDRN" },
    { name: "NBBK - NB Bancorp, Inc.", ticker: "NBBK" },
    { name: "CORBF - Global Cord Blood Corp", ticker: "CORBF" },
    { name: "BELR - Bell Rose Capital, Inc.", ticker: "BELR" },
    { name: "HLRTD - Hillcrest Energy Technologies Ltd.", ticker: "HLRTD" },
    { name: "CRNCD - CAIRN ENERGY PLC", ticker: "CRNCD" },
    { name: "WKC - WORLD FUEL SERVICES CORP", ticker: "WKC" },
    { name: "MTAL - Metals Acquisition Ltd", ticker: "MTAL" },
    { name: "YERBF - YERBAE BRANDS CORP.", ticker: "YERBF" },
    { name: "RSCI - Redwood Scientific Technologies, Inc.", ticker: "RSCI" },
    { name: "SPEV - UNITED STATES BASKETBALL LEAGUE INC", ticker: "SPEV" },
    { name: "CYXTQ - Cyxtera Technologies, Inc.", ticker: "CYXTQ" },
    { name: "UNAMQ - UNICO AMERICAN CORP", ticker: "UNAMQ" },
    { name: "PTEIQ - POLARITYTE, INC.", ticker: "PTEIQ" },
    { name: "HTGMQ - HTG MOLECULAR DIAGNOSTICS, INC", ticker: "HTGMQ" },
    { name: "PMED - Predictmedix Inc.", ticker: "PMED" },
    { name: "MXRX - MED-X, INC.", ticker: "MXRX" },
    { name: "CPBI - Central Plains Bancshares, Inc.", ticker: "CPBI" },
    { name: "ABXX - Abaxx Technologies Inc.", ticker: "ABXX" },
    { name: "TSBX - Turnstone Biologics Corp.", ticker: "TSBX" },
    { name: "NVNI - Nvni Group Ltd", ticker: "NVNI" },
    { name: "MSCH - MainStreetChamber Holdings, Inc.", ticker: "MSCH" },
    { name: "ESHA - ESH Acquisition Corp.", ticker: "ESHA" },
    { name: "SVMH - SRIVARU Holding Ltd", ticker: "SVMH" },
    { name: "BUJA - Bukit Jalil Global Acquisition 1 Ltd.", ticker: "BUJA" },
    { name: "LQR - LQR House Inc.", ticker: "LQR" },
    { name: "NXU - Nxu, Inc.", ticker: "NXU" },
    { name: "MTBL - Renren Inc.", ticker: "MTBL" },
    { name: "NETD - Nabors Energy Transition Corp. II", ticker: "NETD" },
    { name: "JDRR - F3 Platform Biologics INC", ticker: "JDRR" },
    { name: "DTI - ROC Energy Acquisition Corp.", ticker: "DTI" },
    { name: "NTDTY - NTT Data Corp", ticker: "NTDTY" },
    { name: "TKHVY - Turk Hava Yollari A.O.", ticker: "TKHVY" },
    { name: "IOCJY - IOCHPE-MAXION SA /FI", ticker: "IOCJY" },
    { name: "CCFN - CCFNB BANCORP INC", ticker: "CCFN" },
    { name: "TOON - Kartoon Studios, Inc.", ticker: "TOON" },
    { name: "ONCSQ - ONCOSEC MEDICAL Inc", ticker: "ONCSQ" },
    { name: "JPEX - JPX Global Inc.", ticker: "JPEX" },
    { name: "ODD - Oddity Tech Ltd", ticker: "ODD" },
    { name: "ELVA - Electrovaya Inc.", ticker: "ELVA" },
    { name: "UNFL - Unifoil Holdings, Inc.", ticker: "UNFL" },
    { name: "EG - EVEREST RE GROUP LTD", ticker: "EG" },
    { name: "APGE - Apogee Therapeutics, Inc.", ticker: "APGE" },
    { name: "HYAC - Haymaker Acquisition Corp. 4", ticker: "HYAC" },
    { name: "EBYH - Strainsforpains, Inc.", ticker: "EBYH" },
    { name: "ONEI - OneMeta Inc.", ticker: "ONEI" },
    { name: "SN - SharkNinja, Inc.", ticker: "SN" },
    { name: "BBLNF - Babylon Holdings Ltd", ticker: "BBLNF" },
    { name: "SQZB - SQZ Biotechnologies Co", ticker: "SQZB" },
    { name: "RISE - Rise Oil & Gas, Inc.", ticker: "RISE" },
    { name: "MIRA - MIRA PHARMACEUTICALS, INC.", ticker: "MIRA" },
    { name: "BGC - BGC Partners, Inc.", ticker: "BGC" },
    { name: "RMSG - Real Messenger Corp", ticker: "RMSG" },
    { name: "BTM - Bitcoin Depot Inc.", ticker: "BTM" },
    { name: "BNSOF - BONSO ELECTRONICS INTERNATIONAL INC", ticker: "BNSOF" },
    { name: "PHXM - PHAXIAM Therapeutics S.A.", ticker: "PHXM" },
    { name: "ABL - East Resources Acquisition Co", ticker: "ABL" },
    { name: "WIN - Garden Stage Ltd", ticker: "WIN" },
    { name: "SUBL - BioLingus (Cayman) Ltd", ticker: "SUBL" },
    { name: "SRGAQ - SURGALIGN HOLDINGS, INC.", ticker: "SRGAQ" },
    { name: "WDHI - Worldwide Diversified Holdings, Inc", ticker: "WDHI" },
    { name: "EXTO - Almacenes Exito S.A.", ticker: "EXTO" },
    { name: "RLND - RoyaLand Co Ltd.", ticker: "RLND" },
    { name: "NYMXF - NYMOX PHARMACEUTICAL CORP", ticker: "NYMXF" },
    { name: "LGM - SIXGOMEOW LTD", ticker: "LGM" },
    { name: "RIDEQ - Lordstown Motors Corp.", ticker: "RIDEQ" },
    { name: "JNVR - Janover Inc.", ticker: "JNVR" },
    { name: "TSNDF - TerrAscend Corp.", ticker: "TSNDF" },
    { name: "OBDC - Owl Rock Capital Corp", ticker: "OBDC" },
    { name: "SEZL - Sezzle Inc.", ticker: "SEZL" },
    { name: "SMKUY - Siam Makro Public Co Limited/ADR", ticker: "SMKUY" },
    { name: "MCF - Rocky Mountain Chocolate Factory, Inc.", ticker: "MCF" },
    { name: "CREEF - Crescera Capital Acquisition Corp.", ticker: "CREEF" },
    { name: "MRT - Marti Technologies, Inc.", ticker: "MRT" },
    { name: "TRLM - TRULEUM, INC.", ticker: "TRLM" },
    { name: "AZREF - Azure Power Global Ltd", ticker: "AZREF" },
    { name: "CYADY - Celyad Oncology SA", ticker: "CYADY" },
    { name: "TTCFQ - Tattooed Chef, Inc.", ticker: "TTCFQ" },
    { name: "STUPD - Straightup Resources Inc", ticker: "STUPD" },
    { name: "IMBIQ - iMedia Brands, Inc.", ticker: "IMBIQ" },
    { name: "IVRN - Innoveren Scientific, Inc.", ticker: "IVRN" },
    { name: "SPKL - Spark I Acquisition Corp", ticker: "SPKL" },
    { name: "MTMV - Motomova Inc", ticker: "MTMV" },
    { name: "GPAK - Gamer Pakistan Inc", ticker: "GPAK" },
    { name: "GOAI - Eva Live Inc", ticker: "GOAI" },
    { name: "GLFC - Gold Flora Corp.", ticker: "GLFC" },
    { name: "XMTI - X Metaverse Inc.", ticker: "XMTI" },
    { name: "CAPT - Captivision Inc.", ticker: "CAPT" },
    { name: "JBS - JBS B.V.", ticker: "JBS" },
    { name: "CTCX - ALPHA HEALTHCARE ACQUISITION CORP III", ticker: "CTCX" },
    { name: "NCL - Northann Corp.", ticker: "NCL" },
    { name: "AZI - Autozi Internet Technology (Global) Ltd.", ticker: "AZI" },
    { name: "TURB - Turbo Energy, S.A.", ticker: "TURB" },
    { name: "BATRA - Atlanta Braves Holdings, Inc.", ticker: "BATRA" },
    { name: "CSLR - Complete Solaria, Inc.", ticker: "CSLR" },
    { name: "ABXXF - Abaxx Technologies Inc.", ticker: "ABXXF" },
    { name: "HRGN - Harvard Apparatus Regenerative Technology, Inc.", ticker: "HRGN" },
    { name: "SEVCQ - Sono Group N.V.", ticker: "SEVCQ" },
    { name: "PSQH - PSQ Holdings, Inc.", ticker: "PSQH" },
    { name: "CGTH - Creative Global Technology Holdings Ltd", ticker: "CGTH" },
    { name: "FLYF - Flewber Global Inc.", ticker: "FLYF" },
    { name: "ATGL - Alpha Technology Group Ltd", ticker: "ATGL" },
    { name: "HMR - Heidmar Marine Inc.", ticker: "HMR" },
    { name: "AVAI - TREND INNOVATIONS HOLDING INC.", ticker: "AVAI" },
    { name: "ALPSQ - ALPINE SUMMIT ENERGY PARTNERS, INC.", ticker: "ALPSQ" },
    { name: "BATRK - Atlanta Braves Holdings, Inc.", ticker: "BATRK" },
    { name: "AEON - AEON Biopharma, Inc.", ticker: "AEON" },
    { name: "RTAS - REDtone Asia Inc", ticker: "RTAS" },
    { name: "KLG - WK Kellogg Co", ticker: "KLG" },
    { name: "UFND - Unifund Financial Technologies, Inc.", ticker: "UFND" },
    { name: "KVAC - Keen Vision Acquisition Corp.", ticker: "KVAC" },
    { name: "ATTOF - Atento S.A.", ticker: "ATTOF" },
    { name: "EBCOY - EBARA CORP /ADR/", ticker: "EBCOY" },
    { name: "PNXP - PINEAPPLE EXPRESS CANNABIS Co", ticker: "PNXP" },
    { name: "MHUBF - MineHub Technologies Inc.", ticker: "MHUBF" },
    { name: "WLMSQ - Williams Industrial Services Group Inc.", ticker: "WLMSQ" },
    { name: "SDOT - Sadot Group Inc.", ticker: "SDOT" },
    { name: "PFAB - PreTam Holdings Inc.", ticker: "PFAB" },
    { name: "INHD - INNO HOLDINGS INC.", ticker: "INHD" },
    { name: "CCG - Cheche Group Inc.", ticker: "CCG" },
    { name: "APPHQ - AppHarvest, Inc.", ticker: "APPHQ" },
    { name: "LVER - Lever Global Corp", ticker: "LVER" },
    { name: "NMTRQ - 9 METERS BIOPHARMA, INC.", ticker: "NMTRQ" },
    { name: "CCIF - Carlyle Credit Income Fund", ticker: "CCIF" },
    { name: "NBRVF - Nabriva Therapeutics plc", ticker: "NBRVF" },
    { name: "ANL - Adlai Nortye Ltd.", ticker: "ANL" },
    { name: "CDEX - CardieX Ltd", ticker: "CDEX" },
    { name: "MSBB - Mercer Bancorp, Inc.", ticker: "MSBB" },
    { name: "HAND - Hand in Hand Metaverse Marriage Technology Co., Ltd", ticker: "HAND" },
    { name: "NCNC - Prime Number Holding Ltd", ticker: "NCNC" },
    { name: "MAMA - MamaMancini's Holdings, Inc.", ticker: "MAMA" },
    { name: "DRPO - Draganfly Inc.", ticker: "DRPO" },
    { name: "CGRD - GRD Biotechnology Acquisition Ltd", ticker: "CGRD" },
    { name: "ZLS - Zalatoris II Acquisition Corp", ticker: "ZLS" },
    { name: "VTRO - Vitro Biopharma, Inc.", ticker: "VTRO" },
    { name: "NBND - NetBrands Corp.", ticker: "NBND" },
    { name: "NOVNQ - Novan, Inc.", ticker: "NOVNQ" },
    { name: "QTTOY - Qutoutiao Inc.", ticker: "QTTOY" },
    { name: "ILLR - Triller Corp.", ticker: "ILLR" },
    { name: "VRAYQ - ViewRay, Inc.", ticker: "VRAYQ" },
    { name: "VITT - Vittoria Ltd", ticker: "VITT" },
    { name: "CDSG - China Dongsheng International, Inc.", ticker: "CDSG" },
    { name: "GYGC - Guyana Gold Corp", ticker: "GYGC" },
    { name: "LDWY - LENDWAY, INC.", ticker: "LDWY" },
    { name: "AETHF - Aether Global Innovations Corp.", ticker: "AETHF" },
    { name: "NATL - NCR Atleos, LLC", ticker: "NATL" },
    { name: "RENB - RENOVARO BIOSCIENCES INC.", ticker: "RENB" },
    { name: "EEW - ClimateRock Holdings Ltd", ticker: "EEW" },
    { name: "VLTO - Veralto Corp", ticker: "VLTO" },
    { name: "JZL - JIZHILONG HOLDING GROUP LTD", ticker: "JZL" },
    { name: "RR - RICHTECH ROBOTICS INC.", ticker: "RR" },
    { name: "BATXF - Straightup Resources Inc", ticker: "BATXF" },
    { name: "PTOS - P2 Solar, Inc.", ticker: "PTOS" },
    { name: "AIRE - reAlpha Tech Corp.", ticker: "AIRE" },
    { name: "ENGN - enGene Holdings Inc.", ticker: "ENGN" },
    { name: "ZDYM - ZHIDING YUEMEI TECHNOLOGY CO., LTD", ticker: "ZDYM" },
    { name: "AVRW - Avenir Wellness Solutions, Inc.", ticker: "AVRW" },
    { name: "OMG - Broad Capital Acquisition Pty Ltd", ticker: "OMG" },
    { name: "HNGKY - HONGKONG LAND HOLDINGS LTD /FI", ticker: "HNGKY" },
    { name: "GRAM - Gold Flora Corp.", ticker: "GRAM" },
    { name: "SSCC - Spirits Capital Corp", ticker: "SSCC" },
    { name: "MACE - MACE SECURITY INTERNATIONAL INC", ticker: "MACE" },
    { name: "TLIF - TOCCA LIFE HOLDINGS, INC.", ticker: "TLIF" },
    { name: "GFR - Greenfire Resources Ltd.", ticker: "GFR" },
    { name: "ACIC - AMERICAN COASTAL INSURANCE Corp", ticker: "ACIC" },
    { name: "APHP - American Picture House Corp", ticker: "APHP" },
    { name: "CBIH - Cannabis Bioscience International Holdings, Inc.", ticker: "CBIH" },
    { name: "HHH - Howard Hughes Holdings Inc.", ticker: "HHH" },
    { name: "PTRAQ - Proterra Inc", ticker: "PTRAQ" },
    { name: "JTAI - Jet.AI Inc.", ticker: "JTAI" },
    { name: "COPR - Idaho Copper Corp", ticker: "COPR" },
    { name: "VSME - VS MEDIA Holdings Ltd", ticker: "VSME" },
    { name: "YELLQ - Yellow Corp", ticker: "YELLQ" },
    { name: "ZXTY - ZHONGXING HOLDING GROUP LTD", ticker: "ZXTY" },
    { name: "TLSI - TriSalus Life Sciences, Inc.", ticker: "TLSI" },
    { name: "CRVO - CervoMed Inc.", ticker: "CRVO" },
    { name: "GRPS - Trans American Aquaculture, Inc", ticker: "GRPS" },
    { name: "JYB - Jyong Biotech Ltd.", ticker: "JYB" },
    { name: "VTAK - Ra Medical Systems, Inc.", ticker: "VTAK" },
    { name: "FINR - Fintech Scion Ltd", ticker: "FINR" },
    { name: "AMRSQ - AMYRIS, INC.", ticker: "AMRSQ" },
    { name: "AFLYY - AIR FRANCE-KLM /FI", ticker: "AFLYY" },
    { name: "BETR - Better Home & Finance Holding Co", ticker: "BETR" },
    { name: "RDUS - SCHNITZER STEEL INDUSTRIES, INC.", ticker: "RDUS" },
    { name: "CART - Maplebear Inc.", ticker: "CART" },
    { name: "PMGM - Priveterra Acquisition Corp. II", ticker: "PMGM" },
    { name: "ICCT - FG Merger Corp.", ticker: "ICCT" },
    { name: "SPQS - SportsQuest, Inc.", ticker: "SPQS" },
    { name: "GMVDF - G Medical Innovations Holdings Ltd.", ticker: "GMVDF" },
    { name: "MNKTQ - Mallinckrodt plc", ticker: "MNKTQ" },
    { name: "OIGBQ - Orbital Infrastructure Group, Inc.", ticker: "OIGBQ" },
    { name: "RGTPQ - POLARITYTE, INC.", ticker: "RGTPQ" },
    { name: "YVRLF - Liquid Media Group Ltd.", ticker: "YVRLF" },
    { name: "NMRA - Neumora Therapeutics, Inc.", ticker: "NMRA" },
    { name: "MVNC - Marvion Inc.", ticker: "MVNC" },
    { name: "KVYO - Klaviyo, Inc.", ticker: "KVYO" },
    { name: "HAO - Haoxi Health Technology Ltd", ticker: "HAO" },
    { name: "NCEW - New Century Logistics (BVI) Ltd", ticker: "NCEW" },
    { name: "GDD - Healthy Green Group Holding Ltd", ticker: "GDD" },
    { name: "RYZB - RayzeBio, Inc.", ticker: "RYZB" },
    { name: "HXSZ - HONGXU SHANGZENG GLOBAL HOLDING LTD", ticker: "HXSZ" },
    { name: "QETA - Quetta Acquisition Corp", ticker: "QETA" },
    { name: "GVH - Globavend Holdings Ltd", ticker: "GVH" },
    { name: "BDMD - Baird Medical Investment Holdings Ltd", ticker: "BDMD" },
    { name: "COR - Cencora, Inc.", ticker: "COR" },
    { name: "BEEP - Mobile Infrastructure Corp", ticker: "BEEP" },
    { name: "VNG - VNG Ltd", ticker: "VNG" },
    { name: "ARM - Arm Holdings Ltd", ticker: "ARM" },
    { name: "ALNT - ALLIENT INC", ticker: "ALNT" },
    { name: "AGACF - African Gold Acquisition Corp", ticker: "AGACF" },
    { name: "MISN - Mission Control Acquisition Corp.", ticker: "MISN" },
    { name: "TYGJ - AMERICAN TUOYUAN INTERNATIONAL SECURITIES GROUP INC", ticker: "TYGJ" },
    { name: "KSD - Capstone Dental Pubco, Inc.", ticker: "KSD" },
    { name: "PDSRX - Principal Real Asset Fund", ticker: "PDSRX" },
    { name: "WTO - UTime Ltd", ticker: "WTO" },
    { name: "LGCB - Linkage Global Inc", ticker: "LGCB" },
    { name: "NXGB - NxGen Brands, Inc.", ticker: "NXGB" },
    { name: "MMCP - Myson, Inc.", ticker: "MMCP" },
    { name: "RYDE - Ryde Group Ltd", ticker: "RYDE" },
    { name: "LCCTF - L'Occitane International S.A./ADR/", ticker: "LCCTF" },
    { name: "SLTN - SILVERTON ENERGY, INC.", ticker: "SLTN" },
    { name: "VSTS - Vestis Corp", ticker: "VSTS" },
    { name: "SCNI - Scinai Immunotherapeutics Ltd.", ticker: "SCNI" },
    { name: "DMK - Adamis Pharmaceuticals Corp", ticker: "DMK" },
    { name: "ARMN - Aris Mining Corp", ticker: "ARMN" },
    { name: "ELUT - ELUTIA INC.", ticker: "ELUT" },
    { name: "SDHC - Smith Douglas Homes Corp.", ticker: "SDHC" },
    { name: "LOVLY - Spark Networks SE", ticker: "LOVLY" },
    { name: "CREV - Carbon Revolution Public Ltd Co", ticker: "CREV" },
    { name: "HKHGF - HONGKONG LAND HOLDINGS LTD /FI", ticker: "HKHGF" },
    { name: "APO-PA - Apollo Global Management, Inc.", ticker: "APO-PA" },
    { name: "BATRB - Atlanta Braves Holdings, Inc.", ticker: "BATRB" },
    { name: "SMBMF - SembCorp Marine Ltd.", ticker: "SMBMF" },
    { name: "TPRFF - Aris Mining Corp", ticker: "TPRFF" },
    { name: "BNOEF - BIONOMICS LIMITED/FI", ticker: "BNOEF" },
    { name: "LEAS - Redwoods Acquisition Corp.", ticker: "LEAS" },
    { name: "XFOWW - X4 Pharmaceuticals, Inc", ticker: "XFOWW" },
    { name: "XFORW - X4 Pharmaceuticals, Inc", ticker: "XFORW" },
    { name: "FMSTW - Foremost Lithium Resource & Technology Ltd.", ticker: "FMSTW" },
    { name: "FORLW - Four Leaf Acquisition Corp", ticker: "FORLW" },
    { name: "EBCOF - EBARA CORP /ADR/", ticker: "EBCOF" },
    { name: "ICRL - InPoint Commercial Real Estate Income, Inc.", ticker: "ICRL" },
    { name: "ICRP - InPoint Commercial Real Estate Income, Inc.", ticker: "ICRP" },
    { name: "JUHDF - JANUS HENDERSON GROUP PLC", ticker: "JUHDF" },
    { name: "ALCYW - Alchemy Investments Acquisition Corp 1", ticker: "ALCYW" },
    { name: "ALCYU - Alchemy Investments Acquisition Corp 1", ticker: "ALCYU" },
    { name: "EICB - Eagle Point Income Co Inc.", ticker: "EICB" },
    { name: "GLADZ - GLADSTONE CAPITAL CORP", ticker: "GLADZ" },
    { name: "NNAGU - 99 Acquisition Group Inc.", ticker: "NNAGU" },
    { name: "IPSID - Innovative Payment Solutions, Inc.", ticker: "IPSID" },
    { name: "VNLTF - VEON Ltd.", ticker: "VNLTF" },
    { name: "TDBCP - TORONTO DOMINION BANK", ticker: "TDBCP" },
    { name: "RYBPF - ROYAL BANK OF CANADA", ticker: "RYBPF" },
    { name: "AHRT - American Healthcare REIT, Inc.", ticker: "AHRT" },
    { name: "SMKUF - Siam Makro Public Co Limited/ADR", ticker: "SMKUF" },
    { name: "SENEL - Seneca Foods Corp", ticker: "SENEL" },
    { name: "FEAV - 5E Advanced Materials, Inc.", ticker: "FEAV" },
    { name: "AACT-WT - Ares Acquisition Corp II", ticker: "AACT-WT" },
    { name: "AACT-UN - Ares Acquisition Corp II", ticker: "AACT-UN" },
    { name: "SSST - SmartStop Self Storage REIT, Inc.", ticker: "SSST" },
    { name: "GECCZ - Great Elm Capital Corp.", ticker: "GECCZ" },
    { name: "LKRY - Linktory Inc.", ticker: "LKRY" },
    { name: "NETTF - NetEase, Inc.", ticker: "NETTF" },
    { name: "DOMAW - Doma Holdings, Inc.", ticker: "DOMAW" },
    { name: "INAQU - Insight Acquisition Corp. /DE", ticker: "INAQU" },
    { name: "UHGI - Ultimate Holdings Group, Inc.", ticker: "UHGI" },
    { name: "TPRXF - Aris Mining Corp", ticker: "TPRXF" },
    { name: "CLGDF - Aris Mining Corp", ticker: "CLGDF" },
    { name: "PFTY - Parallel Flight Technologies, Inc.", ticker: "PFTY" },
    { name: "HHEGF - Huahui Education Group Ltd", ticker: "HHEGF" },
    { name: "ALUR-WT - ALLURION TECHNOLOGIES, INC.", ticker: "ALUR-WT" },
    { name: "WRACW - Williams Rowland Acquisition Corp.", ticker: "WRACW" },
    { name: "ESHAR - ESH Acquisition Corp.", ticker: "ESHAR" },
    { name: "BENFW - Beneficient", ticker: "BENFW" },
    { name: "KCLHF - Kingsoft Cloud Holdings Ltd", ticker: "KCLHF" },
    { name: "CTCXW - Carmell Corp", ticker: "CTCXW" },
    { name: "UTAWF - UTA Acquisition Corp", ticker: "UTAWF" },
    { name: "PTNRF - PARTNER COMMUNICATIONS CO LTD", ticker: "PTNRF" },
    { name: "AEON-WT - AEON Biopharma, Inc.", ticker: "AEON-WT" },
    { name: "SBXC-WT - SilverBox Corp III", ticker: "SBXC-WT" },
    { name: "SAZ - SARATOGA INVESTMENT CORP.", ticker: "SAZ" },
    { name: "CBRGF - Chain Bridge I", ticker: "CBRGF" },
    { name: "CSSEZ - Chicken Soup for the Soul Entertainment, Inc.", ticker: "CSSEZ" },
    { name: "BLIDF - Boliden AB", ticker: "BLIDF" },
    { name: "HYAC-UN - Haymaker Acquisition Corp. 4", ticker: "HYAC-UN" },
    { name: "CWLXF - C21 Investments Inc.", ticker: "CWLXF" },
    { name: "PVOZ - Park View OZ REIT Inc", ticker: "PVOZ" },
    { name: "GMVWF - G Medical Innovations Holdings Ltd.", ticker: "GMVWF" },
    { name: "IPXXW - Inflection Point Acquisition Corp. II", ticker: "IPXXW" },
    { name: "IPXXU - Inflection Point Acquisition Corp. II", ticker: "IPXXU" },
    { name: "WSUPW - Wheels Up Experience Inc.", ticker: "WSUPW" },
    { name: "TARSD - Alianza Minerals Ltd.", ticker: "TARSD" },
    { name: "JETBF - Global Crossing Airlines Group Inc.", ticker: "JETBF" },
    { name: "CNFRZ - Conifer Holdings, Inc.", ticker: "CNFRZ" },
    { name: "NETDW - Nabors Energy Transition Corp. II", ticker: "NETDW" },
    { name: "NETDU - Nabors Energy Transition Corp. II", ticker: "NETDU" },
    { name: "SDAWW - SunCar Technology Group Inc.", ticker: "SDAWW" },
    { name: "BGLAF - BioGaia AB/ADR", ticker: "BGLAF" },
    { name: "ITTOF - ITOCHU Techno-Solutions Corporation/ADR", ticker: "ITTOF" },
    { name: "TMTCR - TMT Acquisition Corp.", ticker: "TMTCR" },
    { name: "BTMWW - Bitcoin Depot Inc.", ticker: "BTMWW" },
    { name: "DMXCF - District Metals Corp.", ticker: "DMXCF" },
    { name: "MACT - MachTen, Inc.", ticker: "MACT" },
    { name: "METCB - Ramaco Resources, Inc.", ticker: "METCB" },
    { name: "SSPFF - SiriusPoint Ltd", ticker: "SSPFF" },
    { name: "NUWEW - Nuwellis, Inc.", ticker: "NUWEW" },
    { name: "WNRS - WINNERS, INC.", ticker: "WNRS" },
    { name: "GLEI - Galaxy Enterprises Inc. /WY/", ticker: "GLEI" },
    { name: "AFRAD - AIR FRANCE-KLM /FI", ticker: "AFRAD" },
    { name: "RONN - Lee Pharmaceuticals, Inc.", ticker: "RONN" },
    { name: "KVACU - Keen Vision Acquisition Corp.", ticker: "KVACU" },
    { name: "MSTLW - MORGAN STANLEY", ticker: "MSTLW" },
    { name: "SHZNF - Shenzhen Expressway Co. / ADR", ticker: "SHZNF" },
    { name: "GRFGF - GRUPO FINANCIERO GALICIA SA", ticker: "GRFGF" },
    { name: "HMELF - Hold Me Ltd", ticker: "HMELF" },
    { name: "ELIQ-WT - Electriq Power Holdings, Inc.", ticker: "ELIQ-WT" },
    { name: "PPENF - Pampa Energy Inc.", ticker: "PPENF" },
    { name: "IDBAY - IDEX Biometrics ASA", ticker: "IDBAY" },
    { name: "ERYFF - PHAXIAM Therapeutics S.A.", ticker: "ERYFF" },
    { name: "NPPXF - NIPPON TELEGRAPH & TELEPHONE CORP", ticker: "NPPXF" },
    { name: "MEDE - Medies", ticker: "MEDE" },
    { name: "ALIV - AUTOLIV INC", ticker: "ALIV" },
    { name: "NE-WTA - Noble Corp plc", ticker: "NE-WTA" },
    { name: "NE-WT - Noble Corp plc", ticker: "NE-WT" },
    { name: "SXTPW - 60 DEGREES PHARMACEUTICALS, INC.", ticker: "SXTPW" },
    { name: "NXPT - NexPoint Capital, Inc.", ticker: "NXPT" },
    { name: "GIGGF - Giga Metals Corp", ticker: "GIGGF" },
    { name: "RHEPB - REGIONAL HEALTH PROPERTIES, INC", ticker: "RHEPB" },
    { name: "AGATF - DEUTSCHE BANK AKTIENGESELLSCHAFT", ticker: "AGATF" },
    { name: "DEENF - DEUTSCHE BANK AKTIENGESELLSCHAFT", ticker: "DEENF" },
    { name: "ADZCF - DEUTSCHE BANK AKTIENGESELLSCHAFT", ticker: "ADZCF" },
    { name: "OLOXF - DEUTSCHE BANK AKTIENGESELLSCHAFT", ticker: "OLOXF" },
    { name: "TMEF - Tipmefast, Inc.", ticker: "TMEF" },
    { name: "ADRTW - Ault Disruptive Technologies Corp", ticker: "ADRTW" },
    { name: "USGOW - U.S. GoldMining Inc.", ticker: "USGOW" },
    { name: "UHGI - LUBOA GROUP, INC.", ticker: "UHGI" },
    { name: "AMJT - AMJ Global Technology", ticker: "AMJT" },
    { name: "MTAL-WT - Metals Acquisition Ltd", ticker: "MTAL-WT" },
    { name: "BUJAW - Bukit Jalil Global Acquisition 1 Ltd.", ticker: "BUJAW" },
    { name: "BUJAU - Bukit Jalil Global Acquisition 1 Ltd.", ticker: "BUJAU" },
    { name: "BUJAR - Bukit Jalil Global Acquisition 1 Ltd.", ticker: "BUJAR" },
    { name: "PSQH-WT - PSQ Holdings, Inc.", ticker: "PSQH-WT" },
    { name: "RSGPY - Electrocomponents plc / ADR", ticker: "RSGPY" },
    { name: "JTAIW - Jet.AI Inc.", ticker: "JTAIW" },
    { name: "JTAIZ - Jet.AI Inc.", ticker: "JTAIZ" },
    { name: "WEWOW - WeWork Inc.", ticker: "WEWOW" },
    { name: "TDDWW - TIDEWATER INC", ticker: "TDDWW" },
    { name: "CHNEY - CHINA EASTERN AIRLINES CORP LTD", ticker: "CHNEY" },
    { name: "GRAMW - Gold Flora Corp.", ticker: "GRAMW" },
    { name: "GIAFW - GigCapital5, Inc.", ticker: "GIAFW" },
    { name: "BRFFF - BRF S.A.", ticker: "BRFFF" },
    { name: "POLSW - Polished.com Inc.", ticker: "POLSW" },
    { name: "TRSO - TRANSUITE.ORG INC.", ticker: "TRSO" },
    { name: "SYSXD - Sysorex, Inc.", ticker: "SYSXD" },
    { name: "BRQL - brooqLy, Inc.", ticker: "BRQL" },
    { name: "VFSWW - VinFast Auto Ltd.", ticker: "VFSWW" },
    { name: "BETRW - Better Home & Finance Holding Co", ticker: "BETRW" },
    { name: "AVOID - Advanced Voice Recognition Systems, Inc", ticker: "AVOID" },
    { name: "COBA - Chilean Cobalt Corp.", ticker: "COBA" },
    { name: "MOVAA - MOVADO GROUP INC", ticker: "MOVAA" },
    { name: "CSWCZ - CAPITAL SOUTHWEST CORP", ticker: "CSWCZ" },
    { name: "ABLVW - Able View Global Inc.", ticker: "ABLVW" },
    { name: "APPWQ - AppHarvest, Inc.", ticker: "APPWQ" },
    { name: "DMSIW - Digital Media Solutions, Inc.", ticker: "DMSIW" },
    { name: "PHGEW - BiomX Inc.", ticker: "PHGEW" },
    { name: "TRPEF - TC ENERGY CORP", ticker: "TRPEF" },
    { name: "QLUNF - Qilun Group Inc.", ticker: "QLUNF" },
    { name: "TRPPF - TC ENERGY CORP", ticker: "TRPPF" },
    { name: "SYBE - SYBLEU Inc", ticker: "SYBE" },
    { name: "WOLTF - WOLTERS KLUWER N V /FI", ticker: "WOLTF" },
    { name: "HYBTD - Heyu Biological Technology Corp", ticker: "HYBTD" },
    { name: "TEOF - TEO FOODS INC", ticker: "TEOF" },
    { name: "TSMWF - TAIWAN SEMICONDUCTOR MANUFACTURING CO LTD", ticker: "TSMWF" },
    { name: "LOWLD - Lowell Farms Inc.", ticker: "LOWLD" },
    { name: "BRFPF - BROOKFIELD Corp /ON/", ticker: "BRFPF" },
    { name: "OWLTW - Owlet, Inc.", ticker: "OWLTW" },
    { name: "ZAPPW - Zapp Electric Vehicles Group Ltd", ticker: "ZAPPW" },
    { name: "ZAILF - Zai Lab Ltd", ticker: "ZAILF" },
    { name: "AERGP - APPLIED ENERGETICS, INC.", ticker: "AERGP" },
    { name: "FXFHF - FAIRFAX FINANCIAL HOLDINGS LTD/ CAN", ticker: "FXFHF" },
    { name: "CTRVP - Hepion Pharmaceuticals, Inc.", ticker: "CTRVP" },
    { name: "GODNU - Golden Star Acquisition Corp", ticker: "GODNU" },
    { name: "GODNR - Golden Star Acquisition Corp", ticker: "GODNR" },
    { name: "AZRS - Azzurro Solutions Corp.", ticker: "AZRS" },
    { name: "AGXRW - AGILE THERAPEUTICS INC", ticker: "AGXRW" },
    { name: "JETU - BANK OF MONTREAL /CAN/", ticker: "JETU" },
    { name: "JETD - BANK OF MONTREAL /CAN/", ticker: "JETD" },
    { name: "CARD - BANK OF MONTREAL /CAN/", ticker: "CARD" },
    { name: "CARU - BANK OF MONTREAL /CAN/", ticker: "CARU" },
    { name: "DTLAP - Brookfield DTLA Fund Office Trust Investor Inc.", ticker: "DTLAP" },
    { name: "CNVEF - CENOVUS ENERGY INC.", ticker: "CNVEF" },
    { name: "CVEPF - CENOVUS ENERGY INC.", ticker: "CVEPF" },
    { name: "LLYVK - Liberty Media Corp", ticker: "LLYVK" },
    { name: "LLYVA - Liberty Media Corp", ticker: "LLYVA" },
    { name: "LLYVB - Liberty Media Corp", ticker: "LLYVB" },
    { name: "HCIIP - HCI Group, Inc.", ticker: "HCIIP" },
    { name: "SNLFF - SUN LIFE FINANCIAL INC", ticker: "SNLFF" },
    { name: "GRDV - Golden Royal Development Inc.", ticker: "GRDV" },
    { name: "NCNCW - noco-noco Inc.", ticker: "NCNCW" },
    { name: "OFSWF - Carbon Streaming Corp", ticker: "OFSWF" },
    { name: "PMIN - PLASMA INNOVATIVE INC.", ticker: "PMIN" },
    { name: "WEJWQ - Wejo Group Ltd", ticker: "WEJWQ" },
    { name: "ALL-PJ - ALLSTATE CORP", ticker: "ALL-PJ" },
    { name: "EBFI - Eco Bright Future, Inc.", ticker: "EBFI" },
    { name: "CYRB - Cyber App Solutions Corp.", ticker: "CYRB" },
    { name: "FOXOW - FOXO TECHNOLOGIES INC.", ticker: "FOXOW" },
    { name: "REGCP - REGENCY CENTERS CORP", ticker: "REGCP" },
    { name: "REGCO - REGENCY CENTERS CORP", ticker: "REGCO" },
    { name: "ESGLW - ESGL Holdings Ltd", ticker: "ESGLW" },
    { name: "OKMN - OKMIN RESOURCES, INC.", ticker: "OKMN" },
    { name: "ATGPF - AltaGas Ltd.", ticker: "ATGPF" },
    { name: "ATGAF - AltaGas Ltd.", ticker: "ATGAF" },
    { name: "RMHI - Retrieve Medical Holdings, Inc.", ticker: "RMHI" },
    { name: "RGPX - REGENEREX PHARMA, INC.", ticker: "RGPX" },
    { name: "ATIPW - ATI Physical Therapy, Inc.", ticker: "ATIPW" },
    { name: "HSCT - HOOPS SCOUTING USA", ticker: "HSCT" },
    { name: "ENBHF - ENBRIDGE INC", ticker: "ENBHF" },
    { name: "LTSV - Lightstone Value Plus REIT IV, Inc.", ticker: "LTSV" },
    { name: "NPWR-WT - NET Power Inc.", ticker: "NPWR-WT" },
    { name: "STNDF - Santander UK plc", ticker: "STNDF" },
    { name: "MHLGS - 370 Markets LLC", ticker: "MHLGS" },
    { name: "MTRC - Metaterra Corp.", ticker: "MTRC" },
    { name: "BSQKZ - Block, Inc.", ticker: "BSQKZ" },
    { name: "LZM-WT - Lifezone Metals Ltd", ticker: "LZM-WT" },
    { name: "TLSIW - TriSalus Life Sciences, Inc.", ticker: "TLSIW" },
    { name: "CRWWF - Crescera Capital Acquisition Corp.", ticker: "CRWWF" },
    { name: "FIISP - FINANCIAL INSTITUTIONS INC", ticker: "FIISP" },
    { name: "WLSS - Welsis Corp.", ticker: "WLSS" },
    { name: "SNTUF - Santander UK plc", ticker: "SNTUF" },
    { name: "MKHVS - 370 Markets LLC", ticker: "MKHVS" },
    { name: "BOWNR - Bowen Acquisition Corp", ticker: "BOWNR" },
    { name: "MSVYS - 370 Markets LLC", ticker: "MSVYS" },
    { name: "JAKP - JAKKS PACIFIC INC", ticker: "JAKP" },
    { name: "MRT-WT - Marti Technologies, Inc.", ticker: "MRT-WT" },
    { name: "RDGH - Ridgedale Holdings Inc.", ticker: "RDGH" },
    { name: "GROVW - Grove Collaborative Holdings, Inc.", ticker: "GROVW" },
    { name: "BSTT - Blackstone Real Estate Income Trust, Inc.", ticker: "BSTT" },
    { name: "OAKUR - Oak Woods Acquisition Corp", ticker: "OAKUR" },
    { name: "HCBR - Healthcare Business Resources, Inc.", ticker: "HCBR" },
    { name: "GERNW - GERON CORP", ticker: "GERNW" },
    { name: "ABLLW - Abacus Life, Inc.", ticker: "ABLLW" },
    { name: "HGTPW - Hagerty, Inc.", ticker: "HGTPW" },
    { name: "PLSAY - Polestar Automotive Holding UK PLC", ticker: "PLSAY" },
    { name: "TNONW - Tenon Medical, Inc.", ticker: "TNONW" },
    { name: "MIMWW - Airspan Networks Holdings Inc.", ticker: "MIMWW" },
    { name: "NGKSF - NGK Spark Plug Co., Ltd.", ticker: "NGKSF" },
    { name: "PSPX - Pacific Sports Exchange Inc.", ticker: "PSPX" },
    { name: "ANKM - Ankam Inc.", ticker: "ANKM" },
    { name: "ZLSWW - Zalatoris II Acquisition Corp", ticker: "ZLSWW" },
    { name: "BOWNU - Bowen Acquisition Corp", ticker: "BOWNU" },
    { name: "CSLRW - Complete Solaria, Inc.", ticker: "CSLRW" },
    { name: "APOS - Apollo Global Management, Inc.", ticker: "APOS" },
    { name: "NWOEF - New Oriental Education & Technology Group Inc.", ticker: "NWOEF" },
    { name: "WHFCL - WhiteHorse Finance, Inc.", ticker: "WHFCL" },
    { name: "ZLSWU - Zalatoris II Acquisition Corp", ticker: "ZLSWU" },
    { name: "NTTDF - NTT Data Corp", ticker: "NTTDF" },
    { name: "MDNC - Medinotec Inc.", ticker: "MDNC" },
    { name: "GFSAY - Gafisa S.A.", ticker: "GFSAY" },
    { name: "AHPIQ - ALLIED HEALTHCARE PRODUCTS INC", ticker: "AHPIQ" },
    { name: "EOCWF - Elliott Opportunity II Corp.", ticker: "EOCWF" },
    { name: "RTEZ - REST EZ Inc.", ticker: "RTEZ" },
    { name: "OAKUW - Oak Woods Acquisition Corp", ticker: "OAKUW" },
    { name: "STSR - Strategic Student & Senior Housing Trust, Inc.", ticker: "STSR" },
    { name: "TBMCR - Trailblazer Merger Corp I", ticker: "TBMCR" },
    { name: "RLEA - Rubber Leaf Inc", ticker: "RLEA" },
    { name: "CREUF - Crescera Capital Acquisition Corp.", ticker: "CREUF" },
    { name: "PMGMU - Priveterra Acquisition Corp. II", ticker: "PMGMU" },
    { name: "PMGMW - Priveterra Acquisition Corp. II", ticker: "PMGMW" },
    { name: "BETS - Bit Brother Ltd", ticker: "BETS" },
    { name: "YAAS - Youxin Technology Ltd", ticker: "YAAS" },
    { name: "DNTH - Magenta Therapeutics, Inc.", ticker: "DNTH" },
    { name: "SLE - Super League Gaming, Inc.", ticker: "SLE" },
    { name: "JPL - JEPLAN Holdings, Inc.", ticker: "JPL" },
    { name: "ZBAO - Zhibao Technology Inc.", ticker: "ZBAO" },
    { name: "ACFND - ACORN ENERGY, INC.", ticker: "ACFND" },
    { name: "GNVR - Genvor Inc", ticker: "GNVR" },
    { name: "GNL-PE - Global Net Lease, Inc.", ticker: "GNL-PE" },
    { name: "GNL-PD - Global Net Lease, Inc.", ticker: "GNL-PD" },
    { name: "SKYED - Skye Bioscience, Inc.", ticker: "SKYED" },
    { name: "ODTCD - Odonate Therapeutics, Inc.", ticker: "ODTCD" },
    { name: "MDAI - Rosecliff Acquisition Corp I", ticker: "MDAI" },
    { name: "MDAIW - Rosecliff Acquisition Corp I", ticker: "MDAIW" },
    { name: "NSTCU - Northern Star Investment Corp. III", ticker: "NSTCU" },
    { name: "ILLMF - illumin Holdings Inc.", ticker: "ILLMF" },
    { name: "MNY - MoneyHero Ltd", ticker: "MNY" },
    { name: "CLDI - First Light Acquisition Group, Inc.", ticker: "CLDI" },
    { name: "ATPC - Agape ATP Corp", ticker: "ATPC" },
    { name: "FEBO - Fenbo Holdings Ltd", ticker: "FEBO" },
    { name: "BIRK - Birkenstock Holding Ltd", ticker: "BIRK" },
    { name: "CLDI-WT - First Light Acquisition Group, Inc.", ticker: "CLDI-WT" },
    { name: "PLNH - Planet 13 Holdings Inc.", ticker: "PLNH" },
    { name: "SHOT - Safety Shot, Inc.", ticker: "SHOT" },
    { name: "DRTTF - DIRTT ENVIRONMENTAL SOLUTIONS LTD", ticker: "DRTTF" },
    { name: "WEJOF - Wejo Group Ltd", ticker: "WEJOF" },
    { name: "CDP - CORPORATE OFFICE PROPERTIES TRUST", ticker: "CDP" },
    { name: "ZEVY - Lightning eMotors, Inc.", ticker: "ZEVY" },
    { name: "ACSB - ACESIS HOLDINGS CORP.", ticker: "ACSB" },
    { name: "COOT - Australian Oilseeds Holdings Ltd", ticker: "COOT" },
    { name: "DROR - Dror Ortho-Design, Inc.", ticker: "DROR" },
    { name: "WETHD - Wetouch Technology Inc.", ticker: "WETHD" },
    { name: "SHOTW - Safety Shot, Inc.", ticker: "SHOTW" },
    { name: "KVACW - Keen Vision Acquisition Corp.", ticker: "KVACW" },
    { name: "PAAPU - PLAINS ALL AMERICAN PIPELINE LP", ticker: "PAAPU" },
    { name: "SGDVV - Safe & Green Development Corp", ticker: "SGDVV" },
    { name: "PRIAF - Prime Impact Acquisition I", ticker: "PRIAF" },
    { name: "HYAC-WT - Haymaker Acquisition Corp. 4", ticker: "HYAC-WT" },
    { name: "SIXWD - SIXTH WAVE INNOVATIONS INC.", ticker: "SIXWD" },
    { name: "NSTDW - Northern Star Investment Corp. IV", ticker: "NSTDW" },
    { name: "NSTDU - Northern Star Investment Corp. IV", ticker: "NSTDU" },
    { name: "RDZN - Roadzen Inc.", ticker: "RDZN" },
    { name: "RDZNW - Roadzen Inc.", ticker: "RDZNW" },
    { name: "AONCW - American Oncology Network, Inc.", ticker: "AONCW" },
    { name: "AONC - American Oncology Network, Inc.", ticker: "AONC" },
    { name: "SGBXV - SAFE & GREEN HOLDINGS CORP.", ticker: "SGBXV" },
    { name: "ABMLD - AMERICAN BATTERY TECHNOLOGY Co", ticker: "ABMLD" },
    { name: "NXNVW - NEXTNAV INC.", ticker: "NXNVW" },
    { name: "CCGWW - Cheche Group Inc.", ticker: "CCGWW" },
    { name: "ABAT - AMERICAN BATTERY TECHNOLOGY Co", ticker: "ABAT" },
    { name: "KDLY - Kindly MD, Inc.", ticker: "KDLY" },
    { name: "EBWK - ENIGMA-BULWARK, LTD", ticker: "EBWK" },
    { name: "EMSF - INTEGRATED VENTURES, INC.", ticker: "EMSF" },
    { name: "MNR - MACH NATURAL RESOURCES LP", ticker: "MNR" },
    { name: "HSAC - Hainan Sirius Acquisition Corp.", ticker: "HSAC" },
    { name: "GLAC - Global Lights Acquisition Corp", ticker: "GLAC" },
    { name: "LOCC.U - Live Oak Crestview Climate Acquisition Corp.", ticker: "LOCC.U" },
    { name: "CDT - CONDUIT PHARMACEUTICALS INC.", ticker: "CDT" },
    { name: "NLOP - Net Lease Office Properties", ticker: "NLOP" },
    { name: "YHGJ - YUNHONG GREEN CTI LTD.", ticker: "YHGJ" },
    { name: "CDTTW - CONDUIT PHARMACEUTICALS INC.", ticker: "CDTTW" },
    { name: "TFLM - Tofla Megaline Inc.", ticker: "TFLM" },
    { name: "SMTKD - SmartKem, Inc.", ticker: "SMTKD" },
    { name: "CTTRF - Controladora Vuela Compania de Aviacion, S.A.B. de C.V.", ticker: "CTTRF" },
    { name: "WEJWF - Wejo Group Ltd", ticker: "WEJWF" },
    { name: "TRLED - Trillion Energy International Inc.", ticker: "TRLED" },
    { name: "ZEVYW - Lightning eMotors, Inc.", ticker: "ZEVYW" },
    { name: "RTOND - Right On Brands, Inc.", ticker: "RTOND" },
    { name: "VDMCY - Vodacom Group Ltd / ADR", ticker: "VDMCY" },
    { name: "AU - AngloGold Ashanti PLC", ticker: "AU" },
    { name: "THAR - Tharimmune, Inc.", ticker: "THAR" },
    { name: "AAQL - Antiaging Quantum Living Inc.", ticker: "AAQL" },
    { name: "VODAF - Vodacom Group Ltd / ADR", ticker: "VODAF" },
    { name: "DMSL - Digital Media Solutions, Inc.", ticker: "DMSL" },
    { name: "DLOG - DELTA CORP. HOLDINGS Ltd", ticker: "DLOG" },
    { name: "BMAC.U - Black Mountain Acquisition Corp.", ticker: "BMAC.U" },
    { name: "CBSTF - Cannabist Co Holdings Inc.", ticker: "CBSTF" },
    { name: "KHIW - Brilliance Group", ticker: "KHIW" },
    { name: "MDLX - MODULEX MODULAR BUILDINGS PLC", ticker: "MDLX" },
    { name: "BTOC - Armlogi Holding Corp.", ticker: "BTOC" },
    { name: "VSTS-WI - Vestis Corp", ticker: "VSTS-WI" },
    { name: "KLG-WI - WK Kellogg Co", ticker: "KLG-WI" },
    { name: "ARMK-WI - Aramark", ticker: "ARMK-WI" },
    { name: "DHR-WI - DANAHER CORP /DE/", ticker: "DHR-WI" },
    { name: "PMTU - PennyMac Mortgage Investment Trust", ticker: "PMTU" },
    { name: "NSA-PB - National Storage Affiliates Trust", ticker: "NSA-PB" },
    { name: "VLTO-WI - Veralto Corp", ticker: "VLTO-WI" },
    { name: "K-WI - KELLOGG CO", ticker: "K-WI" },
    { name: "NWE - NorthWestern Energy Group, Inc.", ticker: "NWE" },
    { name: "AESI - Atlas Energy Solutions Inc.", ticker: "AESI" },
    { name: "MCLDF - mCloud Technologies Corp.", ticker: "MCLDF" },
    { name: "PCSV - PCS Edventures!, Inc.", ticker: "PCSV" },
    { name: "COCH - Envoy Medical, Inc.", ticker: "COCH" },
    { name: "KGEI - Kolibri Global Energy Inc.", ticker: "KGEI" },
    { name: "SDCCQ - SmileDirectClub, Inc.", ticker: "SDCCQ" },
    { name: "BTCT - BTC Digital Ltd.", ticker: "BTCT" },
    { name: "ESLA - Estrella Immunopharma, Inc.", ticker: "ESLA" },
    { name: "NUVO - Holdco Nuvo Group D.G Ltd.", ticker: "NUVO" },
    { name: "CGBS - Crown LNG Holdings Ltd", ticker: "CGBS" },
    { name: "TKE - OUI Global", ticker: "TKE" },
    { name: "KAPA - Kairos Pharma, LTD.", ticker: "KAPA" },
    { name: "ELAB - Elevai Labs Inc.", ticker: "ELAB" },
    { name: "VAPA - Valens Pay Global Ltd", ticker: "VAPA" },
    { name: "ABVX - Abivax S.A.", ticker: "ABVX" },
    { name: "NKGN - Graf Acquisition Corp. IV", ticker: "NKGN" },
    { name: "LXEO - Lexeo Therapeutics, Inc.", ticker: "LXEO" },
    { name: "AFRAF - AIR FRANCE-KLM /FI", ticker: "AFRAF" },
    { name: "ICCRW - iCoreConnect Inc.", ticker: "ICCRW" },
    { name: "SUNLW - Sunlight Financial Holdings Inc.", ticker: "SUNLW" },
    { name: "NVNIW - Nvni Group Ltd", ticker: "NVNIW" },
    { name: "LDDDD - Longduoduo Co Ltd", ticker: "LDDDD" },
    { name: "COCHW - Envoy Medical, Inc.", ticker: "COCHW" },
    { name: "MCLPF - mCloud Technologies Corp.", ticker: "MCLPF" },
    { name: "MCLWF - mCloud Technologies Corp.", ticker: "MCLWF" },
    { name: "SWKHL - SWK Holdings Corp", ticker: "SWKHL" },
    { name: "LAC-WI - 1397468 B.C. Ltd.", ticker: "LAC-WI" },
    { name: "LAAC-WI - LITHIUM AMERICAS CORP.", ticker: "LAAC-WI" },
    { name: "NKGNW - Graf Acquisition Corp. IV", ticker: "NKGNW" },
    { name: "ESLAW - Estrella Immunopharma, Inc.", ticker: "ESLAW" },
    { name: "FATHW - Fathom Digital Manufacturing Corp", ticker: "FATHW" },
    { name: "LAAC - LITHIUM AMERICAS CORP.", ticker: "LAAC" },
    { name: "BRDSW - Bird Global, Inc.", ticker: "BRDSW" },
    { name: "AENPP - MacKenzie Realty Capital, Inc.", ticker: "AENPP" },
    { name: "MKZR - MacKenzie Realty Capital, Inc.", ticker: "MKZR" },
    { name: "WOWID - METRO ONE TELECOMMUNICATIONS INC", ticker: "WOWID" },
    { name: "BTCTW - BTC Digital Ltd.", ticker: "BTCTW" },
    { name: "LAC - LITHIUM AMERICAS CORP.", ticker: "LAC" },
    { name: "TDTH - Trident Digital Tech Holdings Ltd.", ticker: "TDTH" },
    { name: "GRDN - Guardian Pharmacy Services, Inc.", ticker: "GRDN" },
    { name: "BNI - BURLINGTON NORTHERN SANTA FE, LLC", ticker: "BNI" },
    { name: "CGRNQ - Capstone Green Energy Corp", ticker: "CGRNQ" },
    { name: "VQSSF - VIQ Solutions Inc.", ticker: "VQSSF" },
    { name: "WS - Worthington Steel, Inc.", ticker: "WS" },
    { name: "ROTR - PHI Group, Inc./DE", ticker: "ROTR" },
    { name: "SPKLU - Spark I Acquisition Corp", ticker: "SPKLU" },
    { name: "QETAU - Quetta Acquisition Corp", ticker: "QETAU" },
    { name: "FBYDW - Falcon's Beyond Global, Inc.", ticker: "FBYDW" },
    { name: "FBYDP - Falcon's Beyond Global, Inc.", ticker: "FBYDP" },
    { name: "AMAM - Ambrx Biopharma, Inc.", ticker: "AMAM" },
    { name: "CLBR - COLOMBIER ACQUISITION CORP. II", ticker: "CLBR" },
    { name: "GV - Visionary Education Technology Holdings Group Inc.", ticker: "GV" },
    { name: "MURA - Mural Oncology plc", ticker: "MURA" },
    { name: "PMNT - Perfect Moment Ltd.", ticker: "PMNT" },
    { name: "QMMM - QMMM Holdings Ltd", ticker: "QMMM" },
    { name: "PTHL - Pheton Holdings Ltd", ticker: "PTHL" },
    { name: "UGCC - Universal Gaming Corp", ticker: "UGCC" },
    { name: "SHIM - Shimmick Corp", ticker: "SHIM" },
    { name: "DOCO - Docola, Inc.", ticker: "DOCO" },
    { name: "NNAGW - 99 Acquisition Group Inc.", ticker: "NNAGW" },
    { name: "NNAGR - 99 Acquisition Group Inc.", ticker: "NNAGR" },
    { name: "CRNZD - CAIRN ENERGY PLC", ticker: "CRNZD" },
    { name: "PPLOF - PEMBINA PIPELINE CORP", ticker: "PPLOF" },
    { name: "RYLBF - ROYAL BANK OF CANADA", ticker: "RYLBF" },
    { name: "MNYWW - MoneyHero Ltd", ticker: "MNYWW" },
    { name: "ENBNF - ENBRIDGE INC", ticker: "ENBNF" },
    { name: "ENBOF - ENBRIDGE INC", ticker: "ENBOF" },
    { name: "VYX-WI - NCR CORP", ticker: "VYX-WI" },
    { name: "NATL-WI - NCR Atleos, LLC", ticker: "NATL-WI" },
    { name: "NECAD - NEW AMERICA ENERGY CORP.", ticker: "NECAD" },
    { name: "RPDL - Rapid Line Inc.", ticker: "RPDL" },
    { name: "CUYTY - Colruyt SA", ticker: "CUYTY" },
    { name: "IHICY - IHI Corporation/ADR", ticker: "IHICY" },
    { name: "RADCQ - RITE AID CORP", ticker: "RADCQ" },
    { name: "CBMJ - CONSERVATIVE BROADCAST MEDIA & PUBLISHING, INC.", ticker: "CBMJ" },
    { name: "CAMG - CAM GROUP, INC.", ticker: "CAMG" },
    { name: "IRNTQ - IronNet, Inc.", ticker: "IRNTQ" },
    { name: "WAY - Waystar Holding Corp.", ticker: "WAY" },
    { name: "LOT - Lotus Technology Inc.", ticker: "LOT" },
    { name: "VYX - NCR CORP", ticker: "VYX" },
    { name: "ABVE - Above Food Ingredients Inc.", ticker: "ABVE" },
    { name: "NTBL - Notable Labs, Ltd.", ticker: "NTBL" },
    { name: "VNTRF - Venator Materials PLC", ticker: "VNTRF" },
    { name: "ORIS - ORIENTAL RISE HOLDINGS Ltd", ticker: "ORIS" },
    { name: "PFSB - PFS Bancorp, Inc.", ticker: "PFSB" },
    { name: "HG - Hamilton Insurance Group, Ltd.", ticker: "HG" },
    { name: "GEAR - Revelyst, Inc.", ticker: "GEAR" },
    { name: "MVRK - Maverick Lifestyle Inc.", ticker: "MVRK" },
    { name: "IHICF - IHI Corporation/ADR", ticker: "IHICF" },
    { name: "ICNP - iCoreConnect Inc.", ticker: "ICNP" },
    { name: "RAJAF - Cordyceps Sunshine Biotech Holdings Co., Ltd.", ticker: "RAJAF" },
    { name: "SSUNF - SIGNA Sports United N.V.", ticker: "SSUNF" },
    { name: "SSUTF - SIGNA Sports United N.V.", ticker: "SSUTF" },
    { name: "ATLFF - ATLAS COPCO AB", ticker: "ATLFF" },
    { name: "CUYTF - Colruyt SA", ticker: "CUYTF" },
    { name: "BOMOD - bowmo, Inc.", ticker: "BOMOD" },
    { name: "SPEC - Spectaire Holdings Inc.", ticker: "SPEC" },
    { name: "PHYT.U - Pyrophyte Acquisition Corp.", ticker: "PHYT.U" },
    { name: "INAI - Invea Therapeutics, Inc", ticker: "INAI" },
    { name: "WEBVF - Web3 Ventures Inc.", ticker: "WEBVF" },
    { name: "EVMO - EV Mobility, Inc.", ticker: "EVMO" },
    { name: "IROH - Iron Horse Acquisitions Corp.", ticker: "IROH" },
    { name: "CRGX - CARGO Therapeutics, Inc.", ticker: "CRGX" },
    { name: "CDLR - Cadeler A/S", ticker: "CDLR" },
    { name: "LFKG - Lianfeng Holding Acquisition", ticker: "LFKG" },
    { name: "BTAX - Biostax Corp.", ticker: "BTAX" },
    { name: "TRML - Tourmaline Bio, Inc.", ticker: "TRML" },
    { name: "JL - J-Long Group Ltd", ticker: "JL" },
    { name: "RMIC - Reticulate Micro, Inc.", ticker: "RMIC" },
    { name: "LOCLW - Local Bounti Corporation/DE", ticker: "LOCLW" },
    { name: "RBTCW - Rubicon Technologies, Inc.", ticker: "RBTCW" },
    { name: "SPECW - Spectaire Holdings Inc.", ticker: "SPECW" },
    { name: "TRPRF - TC ENERGY CORP", ticker: "TRPRF" },
    { name: "CRKRD - Prairie Operating Co.", ticker: "CRKRD" },
    { name: "SGMDD - Sugarmade, Inc.", ticker: "SGMDD" },
    { name: "RGRXD - REGENERX BIOPHARMACEUTICALS INC", ticker: "RGRXD" },
    { name: "BG - Bunge Global SA", ticker: "BG" },
    { name: "ALTM - Arcadium Lithium plc", ticker: "ALTM" },
    { name: "BNIGF - Beroni Group Ltd", ticker: "BNIGF" },
    { name: "SKYI - Sky Century Investment, Inc.", ticker: "SKYI" },
    { name: "NCI - Neo-Concept International Group Holdings Ltd", ticker: "NCI" },
    { name: "SUNLQ - Sunlight Financial Holdings Inc.", ticker: "SUNLQ" },
    { name: "EGLXF - Enthusiast Gaming Holdings Inc. / Canada", ticker: "EGLXF" },
    { name: "GYRE - GYRE THERAPEUTICS, INC.", ticker: "GYRE" },
    { name: "TLIH - Ten-League International Holdings Ltd", ticker: "TLIH" },
    { name: "FONG - Aibafang Group CO., Ltd.", ticker: "FONG" },
    { name: "BLMZ - BloomZ Inc.", ticker: "BLMZ" },
    { name: "ANSC - Agriculture & Natural Solutions Acquisition Corp", ticker: "ANSC" },
    { name: "BFX - NAUTILUS, INC.", ticker: "BFX" },
    { name: "SYNX - Silynxcom Ltd.", ticker: "SYNX" },
    { name: "BYU - BAIYU Holdings, Inc.", ticker: "BYU" },
    { name: "BRNS - Barinthus Biotherapeutics plc.", ticker: "BRNS" },
    { name: "SQVI - Sequoia Vaccines, Inc.", ticker: "SQVI" },
    { name: "SVRSF - GOLDEN TAG RESOURCES LTD.", ticker: "SVRSF" },
    { name: "THBD - NEW AMERICA ENERGY CORP.", ticker: "THBD" },
    { name: "ROI - RiskOn International, Inc.", ticker: "ROI" },
    { name: "RMCO - Royalty Management Holding Corp", ticker: "RMCO" },
    { name: "CAUD - Collective Audience, Inc.", ticker: "CAUD" },
    { name: "HCWC - HEALTHY CHOICE WELLNESS CORP.", ticker: "HCWC" },
    { name: "KRRO - Korro Bio, Inc.", ticker: "KRRO" },
    { name: "RAY - Raytech Holding Ltd", ticker: "RAY" },
    { name: "BYON - BEYOND, INC.", ticker: "BYON" },
    { name: "TRAK - PARK CITY GROUP INC", ticker: "TRAK" },
    { name: "GLSHQ - GELESIS HOLDINGS, INC.", ticker: "GLSHQ" },
    { name: "BIYA - Baiya International Group Inc.", ticker: "BIYA" },
    { name: "ONMDW - Data Knights Acquisition Corp.", ticker: "ONMDW" },
    { name: "SKILW - Skillsoft Corp.", ticker: "SKILW" },
    { name: "WEBT - WEB3 Corp", ticker: "WEBT" },
    { name: "AERTW - Worldwide Webb Acquisition Corp.", ticker: "AERTW" },
    { name: "PRRYD - Planet Resource Recovery, Inc.", ticker: "PRRYD" },
    { name: "CREVW - Carbon Revolution Public Ltd Co", ticker: "CREVW" },
    { name: "SULWQ - Sunlight Financial Holdings Inc.", ticker: "SULWQ" },
    { name: "ET-PI - Energy Transfer LP", ticker: "ET-PI" },
    { name: "OPTXW - OmniLit Acquisition Corp.", ticker: "OPTXW" },
    { name: "MURAV - Mural Oncology plc", ticker: "MURAV" },
    { name: "ENGNW - enGene Holdings Inc.", ticker: "ENGNW" },
    { name: "LUXHP - LUXURBAN HOTELS INC.", ticker: "LUXHP" },
    { name: "CRSLF - carsales.com Limited/ADR", ticker: "CRSLF" },
    { name: "RMCOW - Royalty Management Holding Corp", ticker: "RMCOW" },
    { name: "ALKSV - Alkermes plc.", ticker: "ALKSV" },
    { name: "AMDI - Amphitrite Digital Inc", ticker: "AMDI" },
    { name: "FBLG - FibroBiologics Inc.", ticker: "FBLG" },
    { name: "WEWKQ - WeWork Inc.", ticker: "WEWKQ" },
    { name: "OPTX - SYNTEC OPTICS HOLDINGS, INC.", ticker: "OPTX" },
    { name: "AERT - Worldwide Webb Acquisition Corp.", ticker: "AERT" },
    { name: "AITRU - AI Transportation Acquisition Corp", ticker: "AITRU" },
    { name: "ANSCU - Agriculture & Natural Solutions Acquisition Corp", ticker: "ANSCU" },
    { name: "UFABQ - Unique Fabricating, Inc.", ticker: "UFABQ" },
    { name: "WMBT - Sichuan Wanma Benteng Technology Co., LTD", ticker: "WMBT" },
    { name: "QMIX - QMIS TBS Capital Group Corp.", ticker: "QMIX" },
    { name: "RCFA.U - RCF Acquisition Corp.", ticker: "RCFA.U" },
    { name: "RNAC - Cartesian Therapeutics, Inc.", ticker: "RNAC" },
    { name: "HWEP - HW Electro Co., Ltd.", ticker: "HWEP" },
    { name: "SGN - Signing Day Sports, Inc.", ticker: "SGN" },
    { name: "DDC - DDC Enterprise Ltd", ticker: "DDC" },
    { name: "JFY - JIUFUYUAN BIOTECHNOLOGY CO., LTD", ticker: "JFY" },
    { name: "IRRXU - INTEGRATED RAIL & RESOURCES ACQUISITION CORP", ticker: "IRRXU" },
    { name: "ZK - ZEEKR Intelligent Technology Holding Ltd", ticker: "ZK" },
    { name: "PROP - Prairie Operating Co.", ticker: "PROP" },
    { name: "WXM - WF International Ltd.", ticker: "WXM" },
    { name: "CHR - Cheer Holding, Inc.", ticker: "CHR" },
    { name: "TFG - Fortegra Group, Inc", ticker: "TFG" },
    { name: "LDTC - LeddarTech Holdings Inc.", ticker: "LDTC" },
    { name: "LIMN - Iris Parent Holding Corp.", ticker: "LIMN" },
    { name: "ZENA - ZenaTech, Inc.", ticker: "ZENA" },
    { name: "GLSWQ - GELESIS HOLDINGS, INC.", ticker: "GLSWQ" },
    { name: "EEXAP - Emerald Holding, Inc.", ticker: "EEXAP" },
    { name: "HLGNW - Heliogen, Inc.", ticker: "HLGNW" },
    { name: "BODYW - Beachbody Company, Inc.", ticker: "BODYW" },
    { name: "ENBMF - ENBRIDGE INC", ticker: "ENBMF" },
    { name: "ODVWZ - Osisko Development Corp.", ticker: "ODVWZ" },
    { name: "GSLR - GeoSolar Technologies, Inc.", ticker: "GSLR" },
    { name: "BNIGD - Beroni Group Ltd", ticker: "BNIGD" },
    { name: "TANAF - Tian'an Technology Group Ltd", ticker: "TANAF" },
    { name: "MBUMY - Mabuchi Motor Co., Ltd./ADR", ticker: "MBUMY" },
    { name: "HIRU - HIRU Corp", ticker: "HIRU" },
    { name: "GSIW - Garden Stage Ltd", ticker: "GSIW" },
    { name: "CRMO - Carmot Therapeutics Inc.", ticker: "CRMO" },
    { name: "SFHG - SAMFINE CREATION HOLDINGS GROUP Ltd", ticker: "SFHG" },
    { name: "TELO - Telomir Pharmaceuticals, Inc.", ticker: "TELO" },
    { name: "CPGR - CorpAcq Group Plc", ticker: "CPGR" },
    { name: "CAST - FreeCast, Inc.", ticker: "CAST" },
    { name: "BAYA - Bayview Acquisition Corp", ticker: "BAYA" },
    { name: "KMCM - Key Mining Corp.", ticker: "KMCM" },
    { name: "ULS - UL Solutions Inc.", ticker: "ULS" },
    { name: "SEQL - SeqLL, Inc.", ticker: "SEQL" },
    { name: "ALGG - ALTA GLOBAL GROUP LTD", ticker: "ALGG" },
    { name: "MFLTY - Missfresh Ltd", ticker: "MFLTY" },
    { name: "PYRGF - PyroGenesis Canada Inc.", ticker: "PYRGF" },
    { name: "FHFH - 1427702 B.C. Ltd", ticker: "FHFH" },
    { name: "YYGH - YY Group Holding Ltd.", ticker: "YYGH" },
    { name: "ABTS - Abits Group Inc", ticker: "ABTS" },
    { name: "GLACU - Global Lights Acquisition Corp", ticker: "GLACU" },
    { name: "MFLTF - Missfresh Ltd", ticker: "MFLTF" },
    { name: "BKFOF - BROOKFIELD Corp /ON/", ticker: "BKFOF" },
    { name: "CANOW - Cano Health, Inc.", ticker: "CANOW" },
    { name: "CLBR-UN - COLOMBIER ACQUISITION CORP. II", ticker: "CLBR-UN" },
    { name: "WEWOQ - WeWork Inc.", ticker: "WEWOQ" },
    { name: "MBUMF - Mabuchi Motor Co., Ltd./ADR", ticker: "MBUMF" },
    { name: "RTEZD - REST EZ Inc.", ticker: "RTEZD" },
    { name: "RVMDW - Revolution Medicines, Inc.", ticker: "RVMDW" },
    { name: "GLTK - GlobalTech Corp", ticker: "GLTK" },
    { name: "BNRE-A - Brookfield Reinsurance Ltd.", ticker: "BNRE-A" },
    { name: "OPADW - Offerpad Solutions Inc.", ticker: "OPADW" },
    { name: "CAPTW - Captivision Inc.", ticker: "CAPTW" },
    { name: "OPSC - OpSec Holdings", ticker: "OPSC" },
    { name: "HCIL - Hongchang International Co., Ltd", ticker: "HCIL" },
    { name: "COC - COR3&Co. (Holdings) Ltd", ticker: "COC" },
    { name: "SUGP - SU Group Holdings Ltd", ticker: "SUGP" },
    { name: "TWG - Top Wealth Group Holding Ltd", ticker: "TWG" },
    { name: "HYHL - Houyi Digital Internet Industry Technology Co., Ltd.", ticker: "HYHL" },
    { name: "TRLI - TriLinc Global Impact Fund LLC", ticker: "TRLI" },
    { name: "JMTM - James Maritime Holdings Inc.", ticker: "JMTM" },
    { name: "NMFCZ - New Mountain Finance Corp", ticker: "NMFCZ" },
    { name: "BRCFF - BROOKFIELD Corp /ON/", ticker: "BRCFF" },
    { name: "SPKLW - Spark I Acquisition Corp", ticker: "SPKLW" },
    { name: "TRIC - TriLinc Global Impact Fund LLC", ticker: "TRIC" },
    { name: "WS-WI - Worthington Steel, Inc.", ticker: "WS-WI" },
    { name: "GDHLF - GDS Holdings Ltd", ticker: "GDHLF" },
    { name: "BRIPF - Brookfield Infrastructure Partners L.P.", ticker: "BRIPF" },
    { name: "CGBDL - Carlyle Secured Lending, Inc.", ticker: "CGBDL" },
    { name: "SYRE - Spyre Therapeutics, Inc.", ticker: "SYRE" },
    { name: "STXYF - SatixFy Communications Ltd.", ticker: "STXYF" },
    { name: "BCEIF - BCE INC", ticker: "BCEIF" },
    { name: "ABLLL - Abacus Life, Inc.", ticker: "ABLLL" },
    { name: "RECX - Planet Resource Recovery, Inc.", ticker: "RECX" },
    { name: "DECPF - Diversified Energy Co PLC", ticker: "DECPF" },
    { name: "ITCLY - BANCO ITAU CHILE", ticker: "ITCLY" },
    { name: "LOVLQ - Spark Networks SE", ticker: "LOVLQ" },
    { name: "TMBRQ - Timber Pharmaceuticals, Inc.", ticker: "TMBRQ" },
    { name: "MNTN.U - Everest Consolidator Acquisition Corp", ticker: "MNTN.U" },
    { name: "HHGJ - Concord Health Ltd", ticker: "HHGJ" },
    { name: "XBP - XBP Europe Holdings, Inc.", ticker: "XBP" },
    { name: "QETAR - Quetta Acquisition Corp", ticker: "QETAR" },
    { name: "SCE-PM - SOUTHERN CALIFORNIA EDISON Co", ticker: "SCE-PM" },
    { name: "BANC-PF - BANC OF CALIFORNIA, INC.", ticker: "BANC-PF" },
    { name: "XBPEW - XBP Europe Holdings, Inc.", ticker: "XBPEW" },
    { name: "WOR-WI - WORTHINGTON INDUSTRIES INC", ticker: "WOR-WI" },
    { name: "HUT - Hut 8 Corp.", ticker: "HUT" },
    { name: "SELX - Semilux International Ltd.", ticker: "SELX" },
    { name: "CFRXQ - CONTRAFECT Corp", ticker: "CFRXQ" },
    { name: "AAGR - 10X Capital Venture Acquisition Corp. II", ticker: "AAGR" },
    { name: "MNRLD - MINERAL MOUNTAIN RESOURCES LTD.", ticker: "MNRLD" },
    { name: "BABL - Buildablock Corp.", ticker: "BABL" },
    { name: "AAGRW - 10X Capital Venture Acquisition Corp. II", ticker: "AAGRW" },
    { name: "AFJKU - Aimei Health Technology Co., Ltd.", ticker: "AFJKU" },
    { name: "ICDX - Incordex Corp.", ticker: "ICDX" },
    { name: "TCNCF - TC ENERGY CORP", ticker: "TCNCF" },
    { name: "BKFDF - BROOKFIELD Corp /ON/", ticker: "BKFDF" },
    { name: "XXXX - BANK OF MONTREAL /CAN/", ticker: "XXXX" },
    { name: "GLACR - Global Lights Acquisition Corp", ticker: "GLACR" },
    { name: "SOAR-WT - PROOF Acquisition Corp I", ticker: "SOAR-WT" },
    { name: "OCELD - Organicell Regenerative Medicine, Inc.", ticker: "OCELD" },
    { name: "UPHLW - UpHealth, Inc.", ticker: "UPHLW" },
    { name: "OMVKY - OMV AKTIENGESELLSCHAFT /FI", ticker: "OMVKY" },
    { name: "OUTKY - OUTOKUMPU OY /FI", ticker: "OUTKY" },
    { name: "LNKS - Linkers Industries Ltd", ticker: "LNKS" },
    { name: "TMPOQ - Tempo Automation Holdings, Inc.", ticker: "TMPOQ" },
    { name: "BNZI - 7GC & Co. Holdings Inc.", ticker: "BNZI" },
    { name: "EIL - E I L Holdings Ltd", ticker: "EIL" },
    { name: "BFAC.U - Battery Future Acquisition Corp.", ticker: "BFAC.U" },
    { name: "RNGE - RANGE IMPACT, INC.", ticker: "RNGE" },
    { name: "IBLU - BLUE ROOM ACQUISITION CORP.", ticker: "IBLU" },
    { name: "ECDA - EF Hutton Acquisition Corp I", ticker: "ECDA" },
    { name: "FBTC - Fidelity Wise Origin Bitcoin Fund", ticker: "FBTC" },
    { name: "MTRS - Metros Development Co., Ltd.", ticker: "MTRS" },
    { name: "LLP - Logistic Properties of the Americas", ticker: "LLP" },
    { name: "TKBD - TechyBird Acquisition Corp.", ticker: "TKBD" },
    { name: "WDQY - WANGDIQIYUAN INTERNATIONAL HOLDINGS LTD", ticker: "WDQY" },
    { name: "MAAI - MID AMERICA APARTMENT COMMUNITIES INC.", ticker: "MAAI" },
    { name: "LEGT - Legato Merger Corp. III", ticker: "LEGT" },
    { name: "OMVJF - OMV AKTIENGESELLSCHAFT /FI", ticker: "OMVJF" },
    { name: "CORRL - CorEnergy Infrastructure Trust, Inc.", ticker: "CORRL" },
    { name: "SVMHW - SRIVARU Holding Ltd", ticker: "SVMHW" },
    { name: "BAYAU - Bayview Acquisition Corp", ticker: "BAYAU" },
    { name: "ECDAW - EF Hutton Acquisition Corp I", ticker: "ECDAW" },
    { name: "FGN - F&G Annuities & Life, Inc.", ticker: "FGN" },
    { name: "BLTHD - AMERICAN BATTERY MATERIALS, INC.", ticker: "BLTHD" },
    { name: "OUTFF - OUTOKUMPU OY /FI", ticker: "OUTFF" },
    { name: "CDLR-WI - Cadeler A/S", ticker: "CDLR-WI" },
    { name: "BNZIW - 7GC & Co. Holdings Inc.", ticker: "BNZIW" },
    { name: "KORGW - KORE Group Holdings, Inc.", ticker: "KORGW" },
    { name: "OKENF - Okeanis Eco Tankers Corp.", ticker: "OKENF" },
    { name: "DECPD - Diversified Energy Co PLC", ticker: "DECPD" },
    { name: "AFTWS - Ark7 Properties Plus LLC", ticker: "AFTWS" },
    { name: "EFC-PE - Ellington Financial Inc.", ticker: "EFC-PE" },
    { name: "EFC-PD - Ellington Financial Inc.", ticker: "EFC-PD" },
    { name: "DSX-WT - DIANA SHIPPING INC.", ticker: "DSX-WT" },
    { name: "ZRSP - ZEROSPO", ticker: "ZRSP" },
    { name: "NGNE - Neoleukin Therapeutics, Inc.", ticker: "NGNE" },
    { name: "GUTS - Fractyl Health, Inc.", ticker: "GUTS" },
    { name: "CARCY - China Resources Cement Holdings Limited/ADR/", ticker: "CARCY" },
    { name: "PAANF - Pan American Energy Corp. (Canada)", ticker: "PAANF" },
    { name: "HRLR - High Roller Technologies, Inc.", ticker: "HRLR" },
    { name: "MAMO - Massimo Group", ticker: "MAMO" },
    { name: "NTHI - NEONC TECHNOLOGIES HOLDINGS, INC.", ticker: "NTHI" },
    { name: "MOBX - Chavant Capital Acquisition Corp.", ticker: "MOBX" },
    { name: "AISP - BYTE Acquisition Corp.", ticker: "AISP" },
    { name: "MSAI - Infrared Cameras Holdings, Inc.", ticker: "MSAI" },
    { name: "HGAS - Global Gas Corp", ticker: "HGAS" },
    { name: "BRDSQ - Bird Global, Inc.", ticker: "BRDSQ" },
    { name: "HCDIQ - Harbor Custom Development, Inc.", ticker: "HCDIQ" },
    { name: "BURUW - Nuburu, Inc.", ticker: "BURUW" },
    { name: "MINR - Minerva Gold Inc.", ticker: "MINR" },
    { name: "HGASW - Global Gas Corp", ticker: "HGASW" },
    { name: "AISPW - BYTE Acquisition Corp.", ticker: "AISPW" },
    { name: "KMFG - KEEMO Fashion Group Ltd", ticker: "KMFG" },
    { name: "ELIQW - Electriq Power Holdings, Inc.", ticker: "ELIQW" },
    { name: "ONCO - Onconetix, Inc.", ticker: "ONCO" },
    { name: "MSAIW - Infrared Cameras Holdings, Inc.", ticker: "MSAIW" },
    { name: "MFICL - MidCap Financial Investment Corp", ticker: "MFICL" },
    { name: "MOBXW - Chavant Capital Acquisition Corp.", ticker: "MOBXW" },
    { name: "WTRVW - White River Energy Corp.", ticker: "WTRVW" },
    { name: "LDTCW - LeddarTech Holdings Inc.", ticker: "LDTCW" },
    { name: "CJRCF - China Resources Cement Holdings Limited/ADR/", ticker: "CJRCF" },
    { name: "GNTLD - GENETIC TECHNOLOGIES LTD", ticker: "GNTLD" },
    { name: "VSTEW - Vast Renewables Ltd", ticker: "VSTEW" },
    { name: "IDKOY - IDEMITSU KOSAN CO., LTD", ticker: "IDKOY" },
    { name: "NUKK - Brilliant Acquisition Corp", ticker: "NUKK" },
    { name: "ALCE - Alternus Clean Energy, Inc.", ticker: "ALCE" },
    { name: "NOGNQ - Nogin, Inc.", ticker: "NOGNQ" },
    { name: "FUFU - Bitfufu Inc.", ticker: "FUFU" },
    { name: "LZMH - LZ Technology Holdings Ltd", ticker: "LZMH" },
    { name: "GIT - Going International Holding Co Ltd", ticker: "GIT" },
    { name: "EEET - 3 E Network Technology Group Ltd", ticker: "EEET" },
    { name: "ZCARW - Innovative International Acquisition Corp.", ticker: "ZCARW" },
    { name: "ZCAR - Innovative International Acquisition Corp.", ticker: "ZCAR" },
    { name: "HCDZQ - Harbor Custom Development, Inc.", ticker: "HCDZQ" },
    { name: "HCDPQ - Harbor Custom Development, Inc.", ticker: "HCDPQ" },
    { name: "HCDWQ - Harbor Custom Development, Inc.", ticker: "HCDWQ" },
    { name: "GLCP - GLOBAL LEADERS CORP", ticker: "GLCP" },
    { name: "TCEYF - TC ENERGY CORP", ticker: "TCEYF" },
    { name: "BAYAR - Bayview Acquisition Corp", ticker: "BAYAR" },
    { name: "IROHU - Iron Horse Acquisitions Corp.", ticker: "IROHU" },
    { name: "GSTK - Growth Stalk Holdings Corp", ticker: "GSTK" },
    { name: "GETRW - Getaround, Inc", ticker: "GETRW" },
    { name: "NOGWQ - Nogin, Inc.", ticker: "NOGWQ" },
    { name: "SRKKS - Public Shrek Royalties LLC", ticker: "SRKKS" },
    { name: "BRDWQ - Bird Global, Inc.", ticker: "BRDWQ" },
    { name: "NUKKW - Brilliant Acquisition Corp", ticker: "NUKKW" },
    { name: "BHILW - Benson Hill, Inc.", ticker: "BHILW" },
    { name: "IDKOF - IDEMITSU KOSAN CO., LTD", ticker: "IDKOF" },
    { name: "DESLF - DIRTT ENVIRONMENTAL SOLUTIONS LTD", ticker: "DESLF" },
    { name: "LBPWQ - 4D Pharma PLC", ticker: "LBPWQ" },
    { name: "PGDE - PGD ECO SOLUTIONS", ticker: "PGDE" },
    { name: "GRIF - GRIID Infrastructure Inc.", ticker: "GRIF" },
    { name: "FREY - FREYR Battery, Inc. /DE/", ticker: "FREY" },
    { name: "PNST - Pinstripes Holdings, Inc.", ticker: "PNST" },
    { name: "EBIXQ - EBIX INC", ticker: "EBIXQ" },
    { name: "NMREF - Namibia Critical Metals Inc.", ticker: "NMREF" },
    { name: "ATHXQ - ATHERSYS, INC / NEW", ticker: "ATHXQ" },
    { name: "HGENQ - HUMANIGEN, INC", ticker: "HGENQ" },
    { name: "NEXN - Nexxen International Ltd.", ticker: "NEXN" },
    { name: "HWH - Alset Capital Acquisition Corp.", ticker: "HWH" },
    { name: "FER - Ferrovial SE", ticker: "FER" },
    { name: "AVBP - ArriVent Biopharma, Inc.", ticker: "AVBP" },
    { name: "TCTM - Tarena International, Inc.", ticker: "TCTM" },
    { name: "PBTC - Pando Asset Spot Bitcoin Trust", ticker: "PBTC" },
    { name: "JDZG - JIADE Ltd", ticker: "JDZG" },
    { name: "KSPI - Joint Stock Co Kaspi.kz", ticker: "KSPI" },
    { name: "TLPH - TALPHERA, INC.", ticker: "TLPH" },
    { name: "MGX - Metagenomi Technologies, LLC", ticker: "MGX" },
    { name: "LLLL - Love & Health Ltd", ticker: "LLLL" },
    { name: "CGON - CG Oncology, Inc.", ticker: "CGON" },
    { name: "ONDR - Sushi Ginza Onodera, Inc.", ticker: "ONDR" },
    { name: "EZBC - Franklin Templeton Digital Holdings Trust", ticker: "EZBC" },
    { name: "ZYBT - Zhengye Biotechnology Holding Ltd", ticker: "ZYBT" },
    { name: "DEFI - Tidal Commodities Trust I", ticker: "DEFI" },
    { name: "BRRR - Valkyrie Bitcoin Fund", ticker: "BRRR" },
    { name: "AS - Amer Sports, Inc.", ticker: "AS" },
    { name: "INVX - Innovex Downhole Solutions, Inc.", ticker: "INVX" },
    { name: "NMKCP - NATIONAL GRID PLC", ticker: "NMKCP" },
    { name: "FREY-WT - FREYR Battery, Inc. /DE/", ticker: "FREY-WT" },
    { name: "PNST-WT - Pinstripes Holdings, Inc.", ticker: "PNST-WT" },
    { name: "FLYX-WT - FLYEXCLUSIVE INC.", ticker: "FLYX-WT" },
    { name: "MYMXD - MYMETICS CORP", ticker: "MYMXD" },
    { name: "HYEXD - HEALTHY EXTRACTS INC.", ticker: "HYEXD" },
    { name: "SAVAW - CASSAVA SCIENCES INC", ticker: "SAVAW" },
    { name: "KIM-PN - KIMCO REALTY CORP", ticker: "KIM-PN" },
    { name: "SNLIF - SUN LIFE FINANCIAL INC", ticker: "SNLIF" },
    { name: "ELPC - ENERGY CO OF PARANA", ticker: "ELPC" },
    { name: "TACPF - TRANSALTA CORP", ticker: "TACPF" },
    { name: "ANSCW - Agriculture & Natural Solutions Acquisition Corp", ticker: "ANSCW" },
    { name: "AITRR - AI Transportation Acquisition Corp", ticker: "AITRR" },
    { name: "BXSY - DIVIDEND & INCOME FUND", ticker: "BXSY" },
    { name: "CLBR-WT - COLOMBIER ACQUISITION CORP. II", ticker: "CLBR-WT" },
    { name: "PSBD - Palmer Square Capital BDC Inc.", ticker: "PSBD" },
    { name: "LMDXF - LumiraDx Ltd", ticker: "LMDXF" },
    { name: "HOVR - New Horizon Aircraft Ltd.", ticker: "HOVR" },
    { name: "LILIF - Argentina Lithium & Energy Corp.", ticker: "LILIF" },
    { name: "OGGIF - Web3 Ventures Inc.", ticker: "OGGIF" },
    { name: "LEBGF - Legible Inc.", ticker: "LEBGF" },
    { name: "AUDAQ - AUDACY, INC.", ticker: "AUDAQ" },
    { name: "RCIT - REELCAUSE INC", ticker: "RCIT" },
    { name: "KYTX - Kyverna Therapeutics, Inc.", ticker: "KYTX" },
    { name: "TBBB - BBB FOODS INC", ticker: "TBBB" },
    { name: "BLMH - BLUM HOLDINGS, INC.", ticker: "BLMH" },
    { name: "TESI - Titan Environmental Solutions Inc.", ticker: "TESI" },
    { name: "JVSA - JVSPAC Acquisition Corp.", ticker: "JVSA" },
    { name: "JTGEY - Citibank,N.A./ADR", ticker: "JTGEY" },
    { name: "ANRO - Alto Neuroscience, Inc.", ticker: "ANRO" },
    { name: "RECT - Rectitude Holdings Ltd.", ticker: "RECT" },
    { name: "EPRX - EUPRAXIA PHARMACEUTICALS INC.", ticker: "EPRX" },
    { name: "BTSG - BrightSpring Health Services, Inc.", ticker: "BTSG" },
    { name: "GXAI - GAXOS.AI INC.", ticker: "GXAI" },
    { name: "PRETQ - PENNSYLVANIA REAL ESTATE INVESTMENT TRUST", ticker: "PRETQ" },
    { name: "GORV - Lazydays Holdings, Inc.", ticker: "GORV" },
    { name: "CSTAF - Constellation Acquisition Corp I", ticker: "CSTAF" },
    { name: "FLUT - Flutter Entertainment plc", ticker: "FLUT" },
    { name: "MSDL - Morgan Stanley Direct Lending Fund", ticker: "MSDL" },
    { name: "EPDU - ENTERPRISE PRODUCTS PARTNERS L.P.", ticker: "EPDU" },
    { name: "MFAN - MFA FINANCIAL, INC.", ticker: "MFAN" },
    { name: "MCKPF - Mallinckrodt plc", ticker: "MCKPF" },
    { name: "VNTRD - Venator Materials PLC", ticker: "VNTRD" },
    { name: "AFJKR - Aimei Health Technology Co., Ltd.", ticker: "AFJKR" },
    { name: "LMDWF - LumiraDx Ltd", ticker: "LMDWF" },
    { name: "O-P - REALTY INCOME CORP", ticker: "O-P" },
    { name: "YMHAD - Yamaha Motor Co., Ltd.", ticker: "YMHAD" },
    { name: "PARGD - Power Americas Resource Group Ltd.", ticker: "PARGD" },
    { name: "TTTPF - Nexxen International Ltd.", ticker: "TTTPF" },
    { name: "CSTWF - Constellation Acquisition Corp I", ticker: "CSTWF" },
    { name: "CSTUF - Constellation Acquisition Corp I", ticker: "CSTUF" },
    { name: "PRTNQ - PENNSYLVANIA REAL ESTATE INVESTMENT TRUST", ticker: "PRTNQ" },
    { name: "PRTMQ - PENNSYLVANIA REAL ESTATE INVESTMENT TRUST", ticker: "PRTMQ" },
    { name: "PRTLQ - PENNSYLVANIA REAL ESTATE INVESTMENT TRUST", ticker: "PRTLQ" },
    { name: "IMHCW - IMPERALIS HOLDING CORP.", ticker: "IMHCW" },
    { name: "HOVRW - New Horizon Aircraft Ltd.", ticker: "HOVRW" },
    { name: "RVIVD - Reviv3 Procare Co", ticker: "RVIVD" },
    { name: "JVSAU - JVSPAC Acquisition Corp.", ticker: "JVSAU" },
    { name: "UNRVD - BLUM HOLDINGS, INC.", ticker: "UNRVD" },
    { name: "JHY - JUHEYING INTELLIGENT TECHNOLOGY LTD", ticker: "JHY" },
    { name: "CAPV - CABO VERDE CAPITAL INC.", ticker: "CAPV" },
    { name: "NCDL - Nuveen Churchill Direct Lending Corp.", ticker: "NCDL" },
    { name: "NEUE - Bright Health Group Inc.", ticker: "NEUE" },
    { name: "PBM - PSYENCE BIOMEDICAL LTD.", ticker: "PBM" },
    { name: "AMIX - Autonomix Medical, Inc.", ticker: "AMIX" },
    { name: "OBDE - Blue Owl Capital Corp III", ticker: "OBDE" },
    { name: "GRDI - GRIID Infrastructure Inc.", ticker: "GRDI" },
    { name: "IOTR - iOThree Ltd", ticker: "IOTR" },
    { name: "SOGP - Sound Group Inc.", ticker: "SOGP" },
    { name: "CORZZ - Core Scientific, Inc./tx", ticker: "CORZZ" },
    { name: "GRDIW - GRIID Infrastructure Inc.", ticker: "GRDIW" },
    { name: "ECCF - Eagle Point Credit Co Inc.", ticker: "ECCF" },
    { name: "GSDI - Global System Dynamics, Inc.", ticker: "GSDI" },
    { name: "NKPH - NIKA PHARMACEUTICALS, INC", ticker: "NKPH" },
    { name: "VOCLD - Creatd, Inc.", ticker: "VOCLD" },
    { name: "RKPPS - Ark7 Properties Plus LLC", ticker: "RKPPS" },
    { name: "BTSGU - BrightSpring Health Services, Inc.", ticker: "BTSGU" },
    { name: "SIRCD - SOLAR INTEGRATED ROOFING CORP.", ticker: "SIRCD" },
    { name: "BAZNF - Baozun Inc.", ticker: "BAZNF" },
    { name: "PBMWW - PSYENCE BIOMEDICAL LTD.", ticker: "PBMWW" },
    { name: "ACPS - AC Partners, Inc.", ticker: "ACPS" },
    { name: "APRI - APRINOIA Therapeutics Inc.", ticker: "APRI" },
    { name: "JIE - Semidux (Cayman) Holding Ltd", ticker: "JIE" },
    { name: "SKK - SKK Holdings Ltd", ticker: "SKK" },
    { name: "TRUG - Deep Medicine Acquisition Corp.", ticker: "TRUG" },
    { name: "IVHI - Invech Holdings, Inc.", ticker: "IVHI" },
    { name: "NVIQ - Noventiq Holding Co", ticker: "NVIQ" },
    { name: "CHLW - Chun Hui Le Wan International Holding Group Ltd", ticker: "CHLW" },
    { name: "PLUT - Plutus Financial Group Ltd", ticker: "PLUT" },
    { name: "XTKG - Powerbridge Technologies Co., Ltd.", ticker: "XTKG" },
    { name: "GOLLQ - Gol Intelligent Airlines Inc.", ticker: "GOLLQ" },
    { name: "LUMA - DeerHorse One Zero Eight Group Holding Ltd", ticker: "LUMA" },
    { name: "ARVLF - Arrival", ticker: "ARVLF" },
    { name: "LFWD - ReWalk Robotics Ltd.", ticker: "LFWD" },
    { name: "ARQ - Advanced Emissions Solutions, Inc.", ticker: "ARQ" },
    { name: "DAY - Dayforce, Inc.", ticker: "DAY" },
    { name: "PDYPF - Flutter Entertainment plc", ticker: "PDYPF" },
    { name: "MSYND - MS YOUNG ADVENTURE ENTERPRISE, INC.", ticker: "MSYND" },
    { name: "AMJB - JPMORGAN CHASE & CO", ticker: "AMJB" },
    { name: "RWTN - REDWOOD TRUST INC", ticker: "RWTN" },
    { name: "ATLCZ - Atlanticus Holdings Corp", ticker: "ATLCZ" },
    { name: "AHR - American Healthcare REIT, Inc.", ticker: "AHR" },
    { name: "NOVS - Novusterra Inc", ticker: "NOVS" },
    { name: "STI - Solidion Technology Inc.", ticker: "STI" },
    { name: "TNBI - Tanke Biosciences Corp", ticker: "TNBI" },
    { name: "GOGR - Go Green Global Technologies Corp.", ticker: "GOGR" },
    { name: "CBBB - Blue Chip Technologies Corp.", ticker: "CBBB" },
    { name: "PRGY - IGTA Merger Sub Ltd", ticker: "PRGY" },
    { name: "QQJ - QQJ Inc.", ticker: "QQJ" },
    { name: "VEG - Veg House Holdings Inc.", ticker: "VEG" },
    { name: "SCPX - Scorpius Holdings, Inc.", ticker: "SCPX" },
    { name: "XCH - XCHG Ltd", ticker: "XCH" },
    { name: "CANOQ - Cano Health, Inc.", ticker: "CANOQ" },
    { name: "GRYP - Akerna Corp.", ticker: "GRYP" },
    { name: "DMKPQ - DMK PHARMACEUTICALS Corp", ticker: "DMKPQ" },
    { name: "PSUS - Pershing Square USA, Ltd.", ticker: "PSUS" },
    { name: "FLYE - Fly-E Group, Inc.", ticker: "FLYE" },
    { name: "BRLS - Oxus Acquisition Corp.", ticker: "BRLS" },
    { name: "BKHA - Black Hawk Acquisition Corp", ticker: "BKHA" },
    { name: "NMHI - LBBB Merger Corp.", ticker: "NMHI" },
    { name: "WSCOD - Global AI, Inc.", ticker: "WSCOD" },
    { name: "LEGT-UN - Legato Merger Corp. III", ticker: "LEGT-UN" },
    { name: "STMHD - Stem Holdings, Inc.", ticker: "STMHD" },
    { name: "SIGYD - Sigyn Therapeutics, Inc.", ticker: "SIGYD" },
    { name: "IRNWQ - IronNet, Inc.", ticker: "IRNWQ" },
    { name: "DHAIW - Aurora Technology Acquisition Corp.", ticker: "DHAIW" },
    { name: "DHAI - Aurora Technology Acquisition Corp.", ticker: "DHAI" },
    { name: "BRLSW - Oxus Acquisition Corp.", ticker: "BRLSW" },
    { name: "CVIIW - Churchill Capital Corp VII", ticker: "CVIIW" },
    { name: "CVIIU - Churchill Capital Corp VII", ticker: "CVIIU" },
    { name: "MITN - AG Mortgage Investment Trust, Inc.", ticker: "MITN" },
    { name: "HLXB - Helix Acquisition Corp. II", ticker: "HLXB" },
    { name: "LION - SEAC II Corp.", ticker: "LION" },
    { name: "JBDI - JBDI Holdings Ltd", ticker: "JBDI" },
    { name: "FLAI - Flewber Global Inc.", ticker: "FLAI" },
    { name: "IZTC - Invizyne Technologies Inc", ticker: "IZTC" },
    { name: "HPAI - Helport AI Ltd", ticker: "HPAI" },
    { name: "SMRED - SUN SUMMIT MINERALS CORP.", ticker: "SMRED" },
    { name: "NVIVQ - INVIVO THERAPEUTICS HOLDINGS CORP.", ticker: "NVIVQ" },
    { name: "BDCC - Power Americas Resource Group Ltd.", ticker: "BDCC" },
    { name: "MDVLQ - MedAvail Holdings, Inc.", ticker: "MDVLQ" },
    { name: "SFES - SAFEGUARD SCIENTIFICS INC", ticker: "SFES" },
    { name: "PLMJ - Plum Acquisition Corp. III", ticker: "PLMJ" },
    { name: "ODYS - Odysight.ai Inc.", ticker: "ODYS" },
    { name: "AAPI - Apple iSports Group, Inc.", ticker: "AAPI" },
    { name: "AXIL - Reviv3 Procare Co", ticker: "AXIL" },
    { name: "ALYAF - Alithya Group inc", ticker: "ALYAF" },
    { name: "WCT - Wellchange Holdings Co Ltd", ticker: "WCT" },
    { name: "GCDT - Green Circle Decarbonize Technology Ltd", ticker: "GCDT" },
    { name: "TKMO - Balincan USA, Inc", ticker: "TKMO" },
    { name: "AEYGQ - ADDVANTAGE TECHNOLOGIES GROUP INC", ticker: "AEYGQ" },
    { name: "PRKS - United Parks & Resorts Inc.", ticker: "PRKS" },
    { name: "NTCOY - Natura &Co Holding S.A.", ticker: "NTCOY" },
    { name: "PLMJW - Plum Acquisition Corp. III", ticker: "PLMJW" },
    { name: "PLMJU - Plum Acquisition Corp. III", ticker: "PLMJU" },
    { name: "ACLEW - Alternus Clean Energy, Inc.", ticker: "ACLEW" },
    { name: "FRBP - Franklin BSP Capital Corp", ticker: "FRBP" },
    { name: "BMOLF - BANK OF MONTREAL /CAN/", ticker: "BMOLF" },
    { name: "CANWQ - Cano Health, Inc.", ticker: "CANWQ" },
    { name: "TSPH - TuSimple Holdings Inc.", ticker: "TSPH" },
    { name: "SVMBD - Jingbo Technology, Inc.", ticker: "SVMBD" },
    { name: "NMPGY - Navios Maritime Holdings Inc.", ticker: "NMPGY" },
    { name: "NMPRY - Navios Maritime Holdings Inc.", ticker: "NMPRY" },
    { name: "YMHAY - Yamaha Motor Co., Ltd.", ticker: "YMHAY" },
    { name: "IDXAD - IDEX Biometrics ASA", ticker: "IDXAD" },
    { name: "TVGN - Tevogen Bio Holdings Inc.", ticker: "TVGN" },
    { name: "SOC - Sable Offshore Corp.", ticker: "SOC" },
    { name: "CERO - CERO THERAPEUTICS HOLDINGS, INC.", ticker: "CERO" },
    { name: "SBET - SharpLink Gaming, Inc.", ticker: "SBET" },
    { name: "SYFPV - Synchrony Financial", ticker: "SYFPV" },
    { name: "NSTGQ - NanoString Technologies Inc", ticker: "NSTGQ" },
    { name: "SUNWQ - Sunworks, Inc.", ticker: "SUNWQ" },
    { name: "PSII - Powermers Smart Industries, Inc.", ticker: "PSII" },
    { name: "GEV - GE Vernova LLC", ticker: "GEV" },
    { name: "TSLVF - TIER ONE SILVER INC.", ticker: "TSLVF" },
    { name: "LCCTY - L'Occitane International S.A./ADR/", ticker: "LCCTY" },
    { name: "NVTAQ - Invitae Corp", ticker: "NVTAQ" },
    { name: "TRUV - True Velocity, Inc./DE", ticker: "TRUV" },
    { name: "CEROW - CERO THERAPEUTICS HOLDINGS, INC.", ticker: "CEROW" },
    { name: "IROHW - Iron Horse Acquisitions Corp.", ticker: "IROHW" },
    { name: "IROHR - Iron Horse Acquisitions Corp.", ticker: "IROHR" },
    { name: "MLLOD - Medallion Resources Ltd", ticker: "MLLOD" },
    { name: "ATCHW - AtlasClear Holdings, Inc.", ticker: "ATCHW" },
    { name: "TVGNW - Tevogen Bio Holdings Inc.", ticker: "TVGNW" },
    { name: "SOC-WT - Sable Offshore Corp.", ticker: "SOC-WT" },
    { name: "CVMT - Sila Realty Trust, Inc.", ticker: "CVMT" },
    { name: "SNPWD - Sun Pacific Holding Corp.", ticker: "SNPWD" },
    { name: "SOFE - SOAFEE, Inc.", ticker: "SOFE" },
    { name: "EPRXF - EUPRAXIA PHARMACEUTICALS INC.", ticker: "EPRXF" },
    { name: "LOTWW - Lotus Technology Inc.", ticker: "LOTWW" },
    { name: "VHAI-WTA - Vocodia Holdings Corp", ticker: "VHAI-WTA" },
    { name: "VHAI-WTB - Vocodia Holdings Corp", ticker: "VHAI-WTB" },
    { name: "ITRE - IntriEnergy, Inc.", ticker: "ITRE" },
    { name: "FOMCD - FOMO WORLDWIDE, INC.", ticker: "FOMCD" },
    { name: "ESGH - ESG Inc.", ticker: "ESGH" },
    { name: "LATGF - Chenghe Acquisition I Co.", ticker: "LATGF" },
    { name: "CORZR - Core Scientific, Inc./tx", ticker: "CORZR" },
    { name: "SYFPL - Synchrony Financial", ticker: "SYFPL" },
    { name: "JTCHY - Jianpu Technology Inc.", ticker: "JTCHY" },
    { name: "SIENQ - Sientra, Inc.", ticker: "SIENQ" },
    { name: "SUNS - Sunrise Realty Trust, Inc.", ticker: "SUNS" },
    { name: "RDDT - Reddit, Inc.", ticker: "RDDT" },
    { name: "JUNE - Junee Ltd", ticker: "JUNE" },
    { name: "ORKT - ORANGEKLOUD TECHNOLOGY INC.", ticker: "ORKT" },
    { name: "VHAI - Vocodia Holdings Corp", ticker: "VHAI" },
    { name: "ASTH - Astrana Health, Inc.", ticker: "ASTH" },
    { name: "MNDR - Mobile-health Network Solutions", ticker: "MNDR" },
    { name: "CORRQ - CorEnergy Infrastructure Trust, Inc.", ticker: "CORRQ" },
    { name: "DYCQ - DT Cloud Acquisition Corp", ticker: "DYCQ" },
    { name: "MTUS - TimkenSteel Corp", ticker: "MTUS" },
    { name: "ZOOZ - ZOOZ Power Ltd.", ticker: "ZOOZ" },
    { name: "GBNHF - Greenbrook TMS Inc.", ticker: "GBNHF" },
    { name: "DYCQU - DT Cloud Acquisition Corp", ticker: "DYCQU" },
    { name: "MRNO - Murano Global Investments Ltd", ticker: "MRNO" },
    { name: "ROII - RiskOn International, Inc.", ticker: "ROII" },
    { name: "BODI - Beachbody Company, Inc.", ticker: "BODI" },
    { name: "QTZM - Quantumzyme Corp.", ticker: "QTZM" },
    { name: "CRMLW - Critical Metals Corp.", ticker: "CRMLW" },
    { name: "FUFUW - Bitfufu Inc.", ticker: "FUFUW" },
    { name: "SYF-PB - Synchrony Financial", ticker: "SYF-PB" },
    { name: "DOC - HEALTHPEAK PROPERTIES, INC.", ticker: "DOC" },
    { name: "TBRG - COMPUTER PROGRAMS & SYSTEMS INC", ticker: "TBRG" },
    { name: "GLAI - Global AI, Inc.", ticker: "GLAI" },
    { name: "POLC - Polished.com Inc.", ticker: "POLC" },
    { name: "BXRXQ - Baudax Bio, Inc.", ticker: "BXRXQ" },
    { name: "GLVT - MS YOUNG ADVENTURE ENTERPRISE, INC.", ticker: "GLVT" },
    { name: "RAN - RanMarine Technology B.V.", ticker: "RAN" },
    { name: "TIOG - Tingo Group, Inc.", ticker: "TIOG" },
    { name: "MHUBD - MineHub Technologies Inc.", ticker: "MHUBD" },
    { name: "CORLQ - CorEnergy Infrastructure Trust, Inc.", ticker: "CORLQ" },
    { name: "BAKR - Baker Global Asset Management Inc.", ticker: "BAKR" },
    { name: "ARLTF - Arcadium Lithium plc", ticker: "ARLTF" },
    { name: "AYWWF - Ayr Wellness Inc.", ticker: "AYWWF" },
    { name: "EDPFY - EDP ENERGIAS DE PORTUGAL SA", ticker: "EDPFY" },
    { name: "WLMIY - Wilmar International Ltd", ticker: "WLMIY" },
    { name: "JCYGY - Jardine Cycle & Carriage Ltd.", ticker: "JCYGY" },
    { name: "BOLD - Boundless Bio, Inc.", ticker: "BOLD" },
    { name: "QTI - QT IMAGING HOLDINGS, INC.", ticker: "QTI" },
    { name: "NEPTF - Neptune Wellness Solutions Inc.", ticker: "NEPTF" },
    { name: "UBYH - UBUYHOLDINGS INC", ticker: "UBYH" },
    { name: "ENGS - Energys Group Ltd", ticker: "ENGS" },
    { name: "FBLA - FB Bancorp, Inc. /MD/", ticker: "FBLA" },
    { name: "CRGEQ - Charge Enterprises, Inc.", ticker: "CRGEQ" },
    { name: "BFXXQ - BOWFLEX INC.", ticker: "BFXXQ" },
    { name: "CGTL - Creative Global Technology Holdings Ltd", ticker: "CGTL" },
    { name: "LUD - Luda Technology Group Ltd", ticker: "LUD" },
    { name: "WYHG - Wing Yip Food Holdings Group Ltd", ticker: "WYHG" },
    { name: "PGHL - Primega Group Holdings Ltd", ticker: "PGHL" },
    { name: "SKUB - Skubbs Holdings Ltd", ticker: "SKUB" },
    { name: "ZEOX - Zeo ScientifiX, Inc.", ticker: "ZEOX" },
    { name: "BETSF - Bit Brother Ltd", ticker: "BETSF" },
    { name: "WLMIF - Wilmar International Ltd", ticker: "WLMIF" },
    { name: "JCYCF - Jardine Cycle & Carriage Ltd.", ticker: "JCYCF" },
    { name: "TPGXL - TPG Inc.", ticker: "TPGXL" },
    { name: "ELCPF - EDP ENERGIAS DE PORTUGAL SA", ticker: "ELCPF" },
    { name: "PTOP - Peer To Peer Network", ticker: "PTOP" },
    { name: "AIJTY - Jianpu Technology Inc.", ticker: "AIJTY" },
    { name: "TOYO - TOYO Co., Ltd", ticker: "TOYO" },
    { name: "FDSB - Fifth District Bancorp, Inc.", ticker: "FDSB" },
    { name: "CUPR - Cuprina Holdings (Cayman) LTD", ticker: "CUPR" },
    { name: "ALAB - Astera Labs, Inc.", ticker: "ALAB" },
    { name: "POLCQ - Polished.com Inc.", ticker: "POLCQ" },
    { name: "SBOT - Serve Robotics Inc. /DE/", ticker: "SBOT" },
    { name: "PMCOD - Prospector Metals Corp.", ticker: "PMCOD" },
    { name: "VATE-RI - INNOVATE Corp.", ticker: "VATE-RI" },
    { name: "ATMU-WI - Atmus Filtration Technologies Inc.", ticker: "ATMU-WI" },
    { name: "ALBCL - ALBEMARLE CORP", ticker: "ALBCL" },
    { name: "JVSAR - JVSPAC Acquisition Corp.", ticker: "JVSAR" },
    { name: "NMHIW - Nature's Miracle Holding Inc.", ticker: "NMHIW" },
    { name: "NTRP - SIGMA ADDITIVE SOLUTIONS, INC.", ticker: "NTRP" },
    { name: "SOLV - Solventum Corp", ticker: "SOLV" },
    { name: "LRTX - Lirum Therapeutics, Inc.", ticker: "LRTX" },
    { name: "SUUN - SolarBank Corp", ticker: "SUUN" },
    { name: "XTIA - INPIXON", ticker: "XTIA" },
    { name: "RFAI - RF Acquisition Corp II", ticker: "RFAI" },
    { name: "ALB-PA - ALBEMARLE CORP", ticker: "ALB-PA" },
    { name: "SUUNF - SolarBank Corp", ticker: "SUUNF" },
    { name: "CPGRA - CorpAcq Group Plc", ticker: "CPGRA" },
    { name: "SUKE - Suke Ltd", ticker: "SUKE" },
    { name: "PACS - PACS Group, Inc.", ticker: "PACS" },
    { name: "BTC - Grayscale Bitcoin Mini Trust (BTC)", ticker: "BTC" },
    { name: "DSY - Big Tree Cloud Holdings Ltd", ticker: "DSY" },
    { name: "ZEO - ESGEN Acquisition Corp", ticker: "ZEO" },
    { name: "NRDE - Lordstown Motors Corp.", ticker: "NRDE" },
    { name: "HPH - Highest Performances Holdings Inc.", ticker: "HPH" },
    { name: "MMA - ALTA GLOBAL GROUP LTD", ticker: "MMA" },
    { name: "LPA - Logistic Properties of the Americas", ticker: "LPA" },
    { name: "AIRJ - Power & Digital Infrastructure Acquisition II Corp.", ticker: "AIRJ" },
    { name: "AIRJW - Power & Digital Infrastructure Acquisition II Corp.", ticker: "AIRJW" },
    { name: "CMI-WD - CUMMINS INC", ticker: "CMI-WD" },
    { name: "GTI - Energem Corp", ticker: "GTI" },
    { name: "ATHS - Athene Holding Ltd.", ticker: "ATHS" },
    { name: "ZEOWW - ESGEN Acquisition Corp", ticker: "ZEOWW" },
    { name: "BNAI - DHC Acquisition Corp.", ticker: "BNAI" },
    { name: "BNAIW - DHC Acquisition Corp.", ticker: "BNAIW" },
    { name: "FUJIY - FUJI PHOTO FILM CO LTD /FI", ticker: "FUJIY" },
    { name: "YKLTY - Yakult Honsha Co., LTD/ADR", ticker: "YKLTY" },
    { name: "SNT - Senstar Technologies Corp", ticker: "SNT" },
    { name: "NITO - Save Foods, Inc.", ticker: "NITO" },
    { name: "GSPI - Green Star Products, Inc.", ticker: "GSPI" },
    { name: "LENZ - Graphite Bio, Inc.", ticker: "LENZ" },
    { name: "IGOT - FOMO WORLDWIDE, INC.", ticker: "IGOT" },
    { name: "CPAY - FLEETCOR TECHNOLOGIES INC", ticker: "CPAY" },
    { name: "BIPH - Brookfield Infrastructure Partners L.P.", ticker: "BIPH" },
    { name: "MKDW - MKDWELL Tech Inc.", ticker: "MKDW" },
    { name: "CTNM - Contineum Therapeutics, Inc.", ticker: "CTNM" },
    { name: "LBRJ - Libera Gaming Operations, Inc", ticker: "LBRJ" },
    { name: "NNE - Nano Nuclear Energy Inc.", ticker: "NNE" },
    { name: "MCTR - CTRL GROUP Ltd", ticker: "MCTR" },
    { name: "PITA - Heramba Electric plc", ticker: "PITA" },
    { name: "FUJIF - FUJI PHOTO FILM CO LTD /FI", ticker: "FUJIF" },
    { name: "CRDE - Cardinal Ethanol LLC", ticker: "CRDE" },
    { name: "CYTT - Cyteir Therapeutics, Inc.", ticker: "CYTT" },
    { name: "POLWQ - Polished.com Inc.", ticker: "POLWQ" },
    { name: "PMVCD - PMV Consumer Acquisition Corp.", ticker: "PMVCD" },
    { name: "IRRXW - INTEGRATED RAIL & RESOURCES ACQUISITION CORP", ticker: "IRRXW" },
    { name: "QTIWW - QT IMAGING HOLDINGS, INC.", ticker: "QTIWW" },
    { name: "YKLTF - Yakult Honsha Co., LTD/ADR", ticker: "YKLTF" },
    { name: "MRNOW - Murano Global Investments Ltd", ticker: "MRNOW" },
    { name: "BKHAU - Black Hawk Acquisition Corp", ticker: "BKHAU" },
    { name: "COOTW - Australian Oilseeds Holdings Ltd", ticker: "COOTW" },
    { name: "ITXXF - Itaconix Plc", ticker: "ITXXF" },
    { name: "LNTO - LELANTOS HOLDINGS INC.", ticker: "LNTO" },
    { name: "IBTA - Ibotta, Inc.", ticker: "IBTA" },
    { name: "SW - Smurfit WestRock Ltd", ticker: "SW" },
    { name: "CCIX - Churchill Capital Corp IX/Cayman", ticker: "CCIX" },
    { name: "CTRI - Centuri Holdings, Inc.", ticker: "CTRI" },
    { name: "LXTM - Lei Xin Holdings Co., Ltd.", ticker: "LXTM" },
    { name: "DJT - Trump Media & Technology Group Corp.", ticker: "DJT" },
    { name: "FSRN - Fisker Inc./DE", ticker: "FSRN" },
    { name: "CUROQ - CURO Group Holdings Corp.", ticker: "CUROQ" },
    { name: "QTTB - Homology Medicines, Inc.", ticker: "QTTB" },
    { name: "IBAC - IB Acquisition Corp.", ticker: "IBAC" },
    { name: "MMM-WI - 3M CO", ticker: "MMM-WI" },
    { name: "NEMCL - NEWMONT Corp /DE/", ticker: "NEMCL" },
    { name: "CTOSW - Custom Truck One Source, Inc.", ticker: "CTOSW" },
    { name: "DJTWW - Trump Media & Technology Group Corp.", ticker: "DJTWW" },
    { name: "LIANY - LianBio", ticker: "LIANY" },
    { name: "SOLV-WI - Solventum Corp", ticker: "SOLV-WI" },
    { name: "PORTW - Southport Acquisition Corp", ticker: "PORTW" },
    { name: "PORTU - Southport Acquisition Corp", ticker: "PORTU" },
    { name: "FTPSF - Fortis Inc.", ticker: "FTPSF" },
    { name: "IBACU - IB Acquisition Corp.", ticker: "IBACU" },
    { name: "YGFGF - YanGuFang International Group Co., Ltd", ticker: "YGFGF" },
    { name: "KIQSF - KELSO TECHNOLOGIES INC", ticker: "KIQSF" },
    { name: "MRX - Marex Group plc", ticker: "MRX" },
    { name: "GCTS - Concord Acquisition Corp III", ticker: "GCTS" },
    { name: "SER - AgeX Therapeutics, Inc.", ticker: "SER" },
    { name: "JCY - JINGCAOYUAN HOLDINGS INC", ticker: "JCY" },
    { name: "FAURY - FORVIA SE/ADR", ticker: "FAURY" },
    { name: "HAHA - Harden Technologies Inc.", ticker: "HAHA" },
    { name: "BNEV - BRILLIANT N.E.V. CORP.", ticker: "BNEV" },
    { name: "MGRE - AFFILIATED MANAGERS GROUP, INC.", ticker: "MGRE" },
    { name: "GCTS-WT - Concord Acquisition Corp III", ticker: "GCTS-WT" },
    { name: "GEV-WI - GE Vernova LLC", ticker: "GEV-WI" },
    { name: "BEPJ - Brookfield Renewable Partners L.P.", ticker: "BEPJ" },
    { name: "LEGT-WT - Legato Merger Corp. III", ticker: "LEGT-WT" },
    { name: "BCGWW - Binah Capital Group, Inc.", ticker: "BCGWW" },
    { name: "CWBC - CENTRAL VALLEY COMMUNITY BANCORP", ticker: "CWBC" },
    { name: "ZPTA - Zapata Computing Holdings Inc.", ticker: "ZPTA" },
    { name: "LSH - Lakeside Holding Ltd", ticker: "LSH" },
    { name: "OCP - Huge Amount Group Ltd", ticker: "OCP" },
    { name: "RITR - Reitar Logtech Holdings Ltd", ticker: "RITR" },
    { name: "RBRK - Rubrik, Inc.", ticker: "RBRK" },
    { name: "XXC - XINXU COPPER INDUSTRY TECHNOLOGY Ltd", ticker: "XXC" },
    { name: "MIMOQ - Airspan Networks Holdings Inc.", ticker: "MIMOQ" },
    { name: "HAFN - Hafnia Ltd", ticker: "HAFN" },
    { name: "JOANQ - JOANN Inc.", ticker: "JOANQ" },
    { name: "NXTT - WETRADE GROUP INC.", ticker: "NXTT" },
    { name: "ZPTAW - Zapata Computing Holdings Inc.", ticker: "ZPTAW" },
    { name: "FAAS - DIGIASIA CORP.", ticker: "FAAS" },
    { name: "ZTOEF - ZTO Express (Cayman) Inc.", ticker: "ZTOEF" },
    { name: "TRINZ - Trinity Capital Inc.", ticker: "TRINZ" },
    { name: "TCMEF - Tencent Music Entertainment Group", ticker: "TCMEF" },
    { name: "HAFNF - Hafnia Ltd", ticker: "HAFNF" },
    { name: "GFRWF - Greenfire Resources Ltd.", ticker: "GFRWF" },
    { name: "NIVF - NewGenIvf Group Ltd", ticker: "NIVF" },
    { name: "VIEWQ - View, Inc.", ticker: "VIEWQ" },
    { name: "BWLP - BW LPG Ltd", ticker: "BWLP" },
    { name: "LOAR - Loar Holdings, LLC", ticker: "LOAR" },
    { name: "SPHL - SPRINGVIEW HOLDINGS LTD", ticker: "SPHL" },
    { name: "CASSQ - Casa Systems Inc", ticker: "CASSQ" },
    { name: "ASAPQ - Waitr Holdings Inc.", ticker: "ASAPQ" },
    { name: "MTBLY - Moatable, Inc.", ticker: "MTBLY" },
    { name: "GMHS - Gamehaus Holdings Inc.", ticker: "GMHS" },
    { name: "FFFZ - Fuxing China Group Ltd", ticker: "FFFZ" },
    { name: "VIK - Viking Holdings Ltd", ticker: "VIK" },
    { name: "MFI - mF International Ltd", ticker: "MFI" },
    { name: "AAUAF - ALMADEN MINERALS LTD", ticker: "AAUAF" },
    { name: "GMDAQ - Gamida Cell Ltd.", ticker: "GMDAQ" },
    { name: "TRAW - Traws Pharma, Inc.", ticker: "TRAW" },
    { name: "PDYN - Palladyne AI Corp.", ticker: "PDYN" },
    { name: "HNCUF - Royalty North Partners Ltd.", ticker: "HNCUF" },
    { name: "NIVFW - NewGenIvf Group Ltd", ticker: "NIVFW" },
    { name: "PDYNW - Palladyne AI Corp.", ticker: "PDYNW" },
    { name: "WBBAD - WB Burgers Asia, Inc.", ticker: "WBBAD" },
    { name: "VJTTY - voxeljet AG", ticker: "VJTTY" },
    { name: "MIMWQ - Airspan Networks Holdings Inc.", ticker: "MIMWQ" },
    { name: "EAGPP - Eagle Point Income Co Inc.", ticker: "EAGPP" },
    { name: "VIWWQ - View, Inc.", ticker: "VIWWQ" },
    { name: "QDMID - QDM International Inc.", ticker: "QDMID" },
    { name: "FERVF - Ferrovial SE", ticker: "FERVF" },
    { name: "ZOOZW - ZOOZ Power Ltd.", ticker: "ZOOZW" },
    { name: "FAASW - DIGIASIA CORP.", ticker: "FAASW" },
    { name: "MRPT - MACREPORT NET INC", ticker: "MRPT" },
    { name: "ZONE - CleanCore Solutions, Inc.", ticker: "ZONE" },
    { name: "DYCQR - DT Cloud Acquisition Corp", ticker: "DYCQR" },
    { name: "EICC - Eagle Point Income Co Inc.", ticker: "EICC" },
    { name: "ACORQ - Acorda Therapeutics, Inc.", ticker: "ACORQ" },
    { name: "SVCO - Silvaco Group, Inc.", ticker: "SVCO" },
    { name: "GACW - GACW Inc", ticker: "GACW" },
    { name: "FALSE - STARTENGINE CROWDFUNDING, INC.", ticker: "FALSE" },
    { name: "MISN - Mission Space Acquisition Corp.", ticker: "MISN" },
    { name: "BOW - Bowhead Specialty Holdings Inc.", ticker: "BOW" },
    { name: "GAUZ - Gauzy Ltd.", ticker: "GAUZ" },
    { name: "PLRZ - Polyrizon Ltd.", ticker: "PLRZ" },
    { name: "PAL - Proficient Auto Logistics, Inc", ticker: "PAL" },
    { name: "SLSR - Solaris Resources Inc.", ticker: "SLSR" },
    { name: "NVAM - Nova Minerals Ltd", ticker: "NVAM" },
    { name: "PTNYD - ParcelPal Logistics Inc.", ticker: "PTNYD" },
    { name: "LEJUY - Leju Holdings Ltd", ticker: "LEJUY" },
    { name: "AILE - Arrowroot Acquisition Corp.", ticker: "AILE" },
    { name: "AILEW - Arrowroot Acquisition Corp.", ticker: "AILEW" },
    { name: "EIGRQ - Eiger BioPharmaceuticals, Inc.", ticker: "EIGRQ" },
    { name: "GAQWF - Generation Asia I Acquisition Ltd", ticker: "GAQWF" },
    { name: "GAQUF - Generation Asia I Acquisition Ltd", ticker: "GAQUF" },
    { name: "JMKJD - Coretag Holdings, Inc.", ticker: "JMKJD" },
    { name: "PRLEQ - PILLARSTONE CAPITAL REIT", ticker: "PRLEQ" },
    { name: "SLSSF - Solaris Resources Inc.", ticker: "SLSSF" },
    { name: "KNDI - Kandi Technologies Group, Inc.", ticker: "KNDI" },
    { name: "SERV - Serve Robotics Inc. /DE/", ticker: "SERV" },
    { name: "XYLO - XYLO TECHNOLOGIES LTD", ticker: "XYLO" },
    { name: "OSAP - ProSomnus, Inc.", ticker: "OSAP" },
    { name: "ADIA - Adia Nutrition, Inc.", ticker: "ADIA" },
    { name: "GGEI - Green Giant Inc.", ticker: "GGEI" },
    { name: "YYAI - Connexa Sports Technologies Inc.", ticker: "YYAI" },
    { name: "SOBO - South Bow Corp", ticker: "SOBO" },
    { name: "GGL - Games Global Ltd", ticker: "GGL" },
    { name: "JLJT - JIALIANG HOLDINGS LTD", ticker: "JLJT" },
    { name: "ADGM - Aja Holdco, Inc.", ticker: "ADGM" },
    { name: "DCFCQ - Tritium DCFC Ltd", ticker: "DCFCQ" },
    { name: "EXPRQ - EXPRESS, INC.", ticker: "EXPRQ" },
    { name: "RMGCF - RMG Acquisition Corp. III", ticker: "RMGCF" },
    { name: "SYNSY - Syensqo SA/ADR", ticker: "SYNSY" },
    { name: "INUMD - Infinitum Copper Corp.", ticker: "INUMD" },
    { name: "NISUF - NIPPON SUISAN KAISHA LTD /ADR/", ticker: "NISUF" },
    { name: "XCFT - xCraft Enterprises, Inc.", ticker: "XCFT" },
    { name: "IFN-RT - INDIA FUND, INC.", ticker: "IFN-RT" },
    { name: "GECCI - Great Elm Capital Corp.", ticker: "GECCI" },
    { name: "CBDBY - BRAZILIAN DISTRIBUTION CO COMPANHIA BRASILEIRA DE DISTR CBD", ticker: "CBDBY" },
    { name: "OSAPW - ProSomnus, Inc.", ticker: "OSAPW" },
    { name: "DRJT - DERUN GROUP INC", ticker: "DRJT" },
    { name: "CBDLD - CBD Life Sciences Inc.", ticker: "CBDLD" },
    { name: "STWWF - Semantix, Inc.", ticker: "STWWF" },
    { name: "STIXF - Semantix, Inc.", ticker: "STIXF" },
    { name: "MFAO - MFA FINANCIAL, INC.", ticker: "MFAO" },
    { name: "ETH - Grayscale Ethereum Mini Trust (ETH)", ticker: "ETH" },
    { name: "USCTF - Roth CH Acquisition Co.", ticker: "USCTF" },
    { name: "ECRO - ECC Capital CORP", ticker: "ECRO" },
    { name: "SEVCF - Sono Group N.V.", ticker: "SEVCF" },
    { name: "VISTA - Vista Energy, S.A.B. de C.V.", ticker: "VISTA" },
    { name: "SECOY - Secoo Holding Ltd", ticker: "SECOY" },
    { name: "BPTSY - Biophytis SA", ticker: "BPTSY" },
    { name: "HDL - SUPER HI INTERNATIONAL HOLDING LTD.", ticker: "HDL" },
    { name: "TCENF - TC ENERGY CORP", ticker: "TCENF" },
    { name: "USTWF - Roth CH Acquisition Co.", ticker: "USTWF" },
    { name: "USTUF - Roth CH Acquisition Co.", ticker: "USTUF" },
    { name: "DCFWQ - Tritium DCFC Ltd", ticker: "DCFWQ" },
    { name: "FRTSF - Fortis Inc.", ticker: "FRTSF" },
    { name: "ALMP - Almco Plumbing Inc", ticker: "ALMP" },
    { name: "RMGWF - RMG Acquisition Corp. III", ticker: "RMGWF" },
    { name: "OTAC - OceanTech Acquisitions I Corp.", ticker: "OTAC" },
    { name: "FDOCD - Charging Robotics Inc.", ticker: "FDOCD" },
    { name: "SSOK. - Sunstock, Inc.", ticker: "SSOK." },
    { name: "HWEC - HW Electro Co., Ltd.", ticker: "HWEC" },
    { name: "BWLLF - BW LPG Ltd", ticker: "BWLLF" },
    { name: "VIAOY - VIA optronics AG", ticker: "VIAOY" },
    { name: "IBACR - IB Acquisition Corp.", ticker: "IBACR" },
    { name: "SHMD - SCHMID Group N.V.", ticker: "SHMD" },
    { name: "ACOGF - Alpha Cognition Inc.", ticker: "ACOGF" },
    { name: "EGOXF - Next.e.GO N.V.", ticker: "EGOXF" },
    { name: "SILA - Sila Realty Trust, Inc.", ticker: "SILA" },
    { name: "DTSQ - DT Cloud Star Acquisition Corp", ticker: "DTSQ" },
    { name: "SHMDW - SCHMID Group N.V.", ticker: "SHMDW" },
    { name: "CCIXU - Churchill Capital Corp IX/Cayman", ticker: "CCIXU" },
    { name: "NUVOW - Holdco Nuvo Group D.G Ltd.", ticker: "NUVOW" },
    { name: "CNXX - CONX Corp.", ticker: "CNXX" },
    { name: "APGTQ - Appgate, Inc.", ticker: "APGTQ" },
    { name: "MGON - MEGOLA INC", ticker: "MGON" },
    { name: "ELIQQ - Electriq Power Holdings, Inc.", ticker: "ELIQQ" },
    { name: "CNCK - Coincheck Group B.V.", ticker: "CNCK" },
    { name: "TBN - Tamboran Resources Corp", ticker: "TBN" },
    { name: "NIKA - NIKA PHARMACEUTICALS, INC", ticker: "NIKA" },
    { name: "COTI - CORETAG, INC.", ticker: "COTI" },
    { name: "QSAMW - TELIX QSAM INC.", ticker: "QSAMW" },
    { name: "GPATU - GP-Act III Acquisition Corp.", ticker: "GPATU" },
    { name: "OKLO - Oklo Inc.", ticker: "OKLO" },
    { name: "FUVV - Arcimoto Inc", ticker: "FUVV" },
    { name: "LOGC - ContextLogic Inc.", ticker: "LOGC" },
    { name: "FOMI - FORMATION MINERALS, INC.", ticker: "FOMI" },
    { name: "SLXN - Biomotion Sciences", ticker: "SLXN" },
    { name: "GAXYQ - GALAXY NEXT GENERATION, INC.", ticker: "GAXYQ" },
    { name: "YHNA - YHN Acquisition I Ltd", ticker: "YHNA" },
    { name: "LHSW - Lianhe Sowell International Group Ltd", ticker: "LHSW" },
    { name: "ELIWQ - Electriq Power Holdings, Inc.", ticker: "ELIWQ" },
    { name: "DSAQU - Direct Selling Acquisition Corp.", ticker: "DSAQU" },
    { name: "CNXXW - CONX Corp.", ticker: "CNXXW" },
    { name: "FRSPF - First Phosphate Corp.", ticker: "FRSPF" },
    { name: "ANG-PB - American National Group Inc.", ticker: "ANG-PB" },
    { name: "ANG-PA - American National Group Inc.", ticker: "ANG-PA" },
    { name: "CVMCD - Sila Realty Trust, Inc.", ticker: "CVMCD" },
    { name: "CVMTD - Sila Realty Trust, Inc.", ticker: "CVMTD" },
    { name: "LMMY - L A M Y", ticker: "LMMY" },
    { name: "OSPWQ - ProSomnus, Inc.", ticker: "OSPWQ" },
    { name: "OSAPQ - ProSomnus, Inc.", ticker: "OSAPQ" },
    { name: "ACCUF - AIB Acquisition Corp", ticker: "ACCUF" },
    { name: "AIBAF - AIB Acquisition Corp", ticker: "AIBAF" },
    { name: "AACRF - AIB Acquisition Corp", ticker: "AACRF" },
    { name: "MTDJL - M&T BANK CORP", ticker: "MTDJL" },
    { name: "MVNCD - Marvion Inc.", ticker: "MVNCD" },
    { name: "BKHAR - Black Hawk Acquisition Corp", ticker: "BKHAR" },
    { name: "ETAOF - ETAO International Co., Ltd.", ticker: "ETAOF" },
    { name: "SMBMD - SembCorp Marine Ltd.", ticker: "SMBMD" },
    { name: "BRPSF - BROOKFIELD Corp /ON/", ticker: "BRPSF" },
    { name: "MAA - Mid-America Apartments, L.P.", ticker: "MAA" },
    { name: "CNH - CNH Industrial N.V.", ticker: "CNH" },
    { name: "UUGRY - United Utilities Group plc", ticker: "UUGRY" },
    { name: "VRN - Crescent Point Energy Corp.", ticker: "VRN" },
    { name: "BAFYY - Balfour Beatty plc/ADR", ticker: "BAFYY" },
    { name: "BWIN - Baldwin Insurance Group, Inc.", ticker: "BWIN" },
    { name: "KBDC - Kayne Anderson BDC, Inc.", ticker: "KBDC" },
    { name: "ONE - TRTL Holding Corp.", ticker: "ONE" },
    { name: "ICON - Icon Energy Corp", ticker: "ICON" },
    { name: "PAIYY - Aesthetic Medical International Holdings Group Ltd", ticker: "PAIYY" },
    { name: "ENTO - First Wave BioPharma, Inc.", ticker: "ENTO" },
    { name: "TOGI - TurnOnGreen, Inc.", ticker: "TOGI" },
    { name: "TEM - Tempus AI, Inc.", ticker: "TEM" },
    { name: "INLF - INLIF Ltd", ticker: "INLF" },
    { name: "PCSC - Perceptive Capital Solutions Corp", ticker: "PCSC" },
    { name: "RAPP - Rapport Therapeutics, Inc.", ticker: "RAPP" },
    { name: "TLX - Telix Pharmaceuticals Ltd", ticker: "TLX" },
    { name: "CUNO - Specialty Copper Listco Plc", ticker: "CUNO" },
    { name: "GALE - Galleinphi Inc.", ticker: "GALE" },
    { name: "AERO - Grupo Aeromexico, S.A.B. de C.V.", ticker: "AERO" },
    { name: "NVL - Novelis Inc.", ticker: "NVL" },
    { name: "CASK - Heritage Distilling Holding Company, Inc.", ticker: "CASK" },
    { name: "CHEB - Chenghe Acquisition II Co.", ticker: "CHEB" },
    { name: "RSHL - Rise Smart Group Holdings Ltd", ticker: "RSHL" },
    { name: "KTA - KINGTITAN TECHNOLOGY Ltd", ticker: "KTA" },
    { name: "MMNFQ - MedMen Enterprises, Inc.", ticker: "MMNFQ" },
    { name: "CLVV - Clever Leaves Holdings Inc.", ticker: "CLVV" },
    { name: "MTB-PJ - M&T BANK CORP", ticker: "MTB-PJ" },
    { name: "SCEXP - SOUTHERN CALIFORNIA EDISON Co", ticker: "SCEXP" },
    { name: "MITP - AG Mortgage Investment Trust, Inc.", ticker: "MITP" },
    { name: "RFAIU - RF Acquisition Corp II", ticker: "RFAIU" },
    { name: "SMBYD - SembCorp Marine Ltd.", ticker: "SMBYD" },
    { name: "SPHIF - SUPER HI INTERNATIONAL HOLDING LTD.", ticker: "SPHIF" },
    { name: "CFGPV - CITIZENS FINANCIAL GROUP INC/RI", ticker: "CFGPV" },
    { name: "BAFBF - Balfour Beatty plc/ADR", ticker: "BAFBF" },
    { name: "UUGWF - United Utilities Group plc", ticker: "UUGWF"}
]

export default latestStocks;
